/* eslint-disable */
import { NgIf, CommonModule, NgForOf, NgStyle, NgTemplateOutlet, NgClass, NgSwitch, NgSwitchCase } from "@angular/common";
import * as i0 from "@angular/core";
import { InjectionToken, ɵɵngDeclareFactory, forwardRef, ɵɵFactoryTarget, ɵɵngDeclareInjectable, ɵɵngDeclareClassMetadata, Injectable, Optional, Inject, SkipSelf, Directive, ChangeDetectorRef, ElementRef, NgZone, Injector, ViewContainerRef, Self, Input, Output, EventEmitter, ɵɵngDeclareDirective, ɵɵngDeclareComponent, ChangeDetectionStrategy, ViewEncapsulation, Component, ContentChild, ɵɵngDeclareNgModule, ɵɵngDeclareInjector, NgModule, ViewChild, ViewChildren, ComponentFactoryResolver, ContentChildren, ApplicationRef } from "@angular/core";
import { NgControl, DefaultValueAccessor, NgControlStatus, NgModel, MaxLengthValidator, MinLengthValidator, PatternValidator, RequiredValidator, FormsModule } from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";
const _c0 = ["*"];
const _c1 = ["*", [["", "mbsc-icon", ""]], [["", "mbsc-start-icon", ""]], [["", "mbsc-end-icon", ""]]];
const _c2 = ["*", "[mbsc-icon]", "[mbsc-start-icon]", "[mbsc-end-icon]"];
function MbscButton_mbsc_icon_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mbsc-icon", 1);
    i0.ɵɵprojection(1, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0._iconClass);
    i0.ɵɵproperty("name", ctx_r0.s.icon)("svg", ctx_r0.s.iconSvg)("theme", ctx_r0.s.theme);
  }
}
function MbscButton_mbsc_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mbsc-icon", 1);
    i0.ɵɵprojection(1, 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0._startIconClass);
    i0.ɵɵproperty("name", ctx_r0.s.startIcon)("svg", ctx_r0.s.startIconSvg)("theme", ctx_r0.s.theme);
  }
}
function MbscButton_mbsc_icon_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mbsc-icon", 1);
    i0.ɵɵprojection(1, 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0._endIconClass);
    i0.ɵɵproperty("name", ctx_r0.s.endIcon)("svg", ctx_r0.s.endIconSvg)("theme", ctx_r0.s.theme);
  }
}
function MbscCalendarPrev_mbsc_button_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mbsc-button", 1);
    i0.ɵɵlistener("click", function MbscCalendarPrev_mbsc_button_0_Template_mbsc_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.inst.prevPage());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ariaLabel", ctx_r1.inst.s.prevPageText)("disabled", ctx_r1.inst._isPrevDisabled())("iconSvg", ctx_r1.inst._prevIcon)("theme", ctx_r1.inst.s.theme)("themeVariant", ctx_r1.inst.s.themeVariant);
  }
}
function MbscCalendarNext_mbsc_button_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mbsc-button", 1);
    i0.ɵɵlistener("click", function MbscCalendarNext_mbsc_button_0_Template_mbsc_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.inst.nextPage());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ariaLabel", ctx_r1.inst.s.nextPageText)("disabled", ctx_r1.inst._isNextDisabled())("iconSvg", ctx_r1.inst._nextIcon)("theme", ctx_r1.inst.s.theme)("themeVariant", ctx_r1.inst.s.themeVariant);
  }
}
function MbscCalendarToday_mbsc_button_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mbsc-button", 1);
    i0.ɵɵlistener("click", function MbscCalendarToday_mbsc_button_0_Template_mbsc_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.inst._onTodayClick($event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("theme", ctx_r1.inst.s.theme)("themeVariant", ctx_r1.inst.s.themeVariant);
    i0.ɵɵattribute("aria-label", ctx_r1.inst.s.todayText);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.inst.s.todayText, " ");
  }
}
function MbscCalendarNav_ng_container_0_mbsc_button_1_ng_container_2_ng_container_1_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-calendar-title mbsc-calendar-year" + ctx_r1.inst._theme);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r3.yearTitle, " ");
  }
}
function MbscCalendarNav_ng_container_0_mbsc_button_1_ng_container_2_ng_container_1_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-calendar-title mbsc-calendar-year" + ctx_r1.inst._theme);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r3.yearTitle, " ");
  }
}
function MbscCalendarNav_ng_container_0_mbsc_button_1_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscCalendarNav_ng_container_0_mbsc_button_1_ng_container_2_ng_container_1_span_1_Template, 2, 3, "span", 4);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, MbscCalendarNav_ng_container_0_mbsc_button_1_ng_container_2_ng_container_1_span_4_Template, 2, 3, "span", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.inst._yearFirst);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-calendar-title mbsc-calendar-month" + ctx_r1.inst._theme);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r3.monthTitle, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.inst._yearFirst);
  }
}
function MbscCalendarNav_ng_container_0_mbsc_button_1_ng_container_2_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-calendar-title" + ctx_r1.inst._theme);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r3.title, " ");
  }
}
function MbscCalendarNav_ng_container_0_mbsc_button_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscCalendarNav_ng_container_0_mbsc_button_1_ng_container_2_ng_container_1_Template, 5, 5, "ng-container", 1)(2, MbscCalendarNav_ng_container_0_mbsc_button_1_ng_container_2_span_2_Template, 2, 3, "span", 4);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !item_r3.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r3.title);
  }
}
function MbscCalendarNav_ng_container_0_mbsc_button_1_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap("mbsc-calendar-title" + ctx_r1.inst._theme);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.inst._viewTitle, " ");
  }
}
function MbscCalendarNav_ng_container_0_mbsc_button_1_mbsc_icon_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mbsc-icon", 6);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("svg", ctx_r1.inst._view === ctx_r1.inst.PAGE_VIEW ? ctx_r1.inst.s.downIcon : ctx_r1.inst.s.upIcon)("theme", ctx_r1.inst.s.theme)("themeVariant", ctx_r1.inst.s.themeVariant);
  }
}
function MbscCalendarNav_ng_container_0_mbsc_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mbsc-button", 3, 0);
    i0.ɵɵlistener("click", function MbscCalendarNav_ng_container_0_mbsc_button_1_Template_mbsc_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.inst._onPickerBtnClick($event));
    });
    i0.ɵɵtemplate(2, MbscCalendarNav_ng_container_0_mbsc_button_1_ng_container_2_Template, 3, 2, "ng-container", 1)(3, MbscCalendarNav_ng_container_0_mbsc_button_1_span_3_Template, 2, 3, "span", 4)(4, MbscCalendarNav_ng_container_0_mbsc_button_1_mbsc_icon_4_Template, 1, 3, "mbsc-icon", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-calendar-button" + (ctx_r1.inst._pageNr > 1 ? " mbsc-flex-1-1" : ""));
    i0.ɵɵproperty("theme", ctx_r1.inst.s.theme)("themeVariant", ctx_r1.inst.s.themeVariant);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.inst._hasPicker || ctx_r1.inst._view === ctx_r1.inst.PAGE_VIEW);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.inst._hasPicker && ctx_r1.inst._view !== ctx_r1.inst.PAGE_VIEW);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.inst.s.downIcon && ctx_r1.inst._pageNr === 1);
  }
}
function MbscCalendarNav_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscCalendarNav_ng_container_0_mbsc_button_1_Template, 5, 7, "mbsc-button", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.inst._title);
  }
}
const _c3 = ["input"];
const _c4 = ["lbl"];
const _c5 = [[["", "mbsc-label", ""]]];
const _c6 = ["[mbsc-label]"];
function MbscInput_input_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "input", 10);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1._dummyElmClass);
    i0.ɵɵproperty("disabled", ctx_r1._disabled)("placeholder", ctx_r1.s.placeholder)("readonly", true)("value", ctx_r1.state.files || "");
  }
}
function MbscInput_span_8_ng_container_1_span_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mbsc-icon", 12);
    i0.ɵɵlistener("click", function MbscInput_span_8_ng_container_1_span_1_Template_mbsc_icon_click_3_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const i_r4 = i0.ɵɵnextContext().index;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1._onTagClear($event, i_r4));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const v_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-textfield-tag" + ctx_r1._theme + ctx_r1._rtl);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-textfield-tag-text" + ctx_r1._theme);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(v_r5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("svg", ctx_r1.s.clearIcon)("theme", ctx_r1.s.theme);
  }
}
function MbscInput_span_8_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscInput_span_8_ng_container_1_span_1_Template, 4, 7, "span", 6);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const v_r5 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", v_r5);
  }
}
function MbscInput_span_8_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-textfield-tags-placeholder" + ctx_r1._theme);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.s.placeholder);
  }
}
function MbscInput_span_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, MbscInput_span_8_ng_container_1_Template, 2, 1, "ng-container", 11)(2, MbscInput_span_8_span_2_Template, 2, 3, "span", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-textfield-tags" + ctx_r1._nativeElmClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1._tagsArray);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1._tagsArray.length);
  }
}
function MbscInput_mbsc_icon_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mbsc-icon", 13);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1._selectIconClass);
    i0.ɵɵproperty("svg", ctx_r1.s.dropdownIcon)("theme", ctx_r1.s.theme);
  }
}
function MbscInput_mbsc_icon_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mbsc-icon", 14);
    i0.ɵɵlistener("click", function MbscInput_mbsc_icon_10_Template_mbsc_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._onIconClick());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1._startIconClass);
    i0.ɵɵproperty("name", ctx_r1.s.startIcon)("svg", ctx_r1.s.startIconSvg)("theme", ctx_r1.s.theme);
  }
}
function MbscInput_mbsc_icon_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mbsc-icon", 14);
    i0.ɵɵlistener("click", function MbscInput_mbsc_icon_11_Template_mbsc_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._onIconClick());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1._endIconClass);
    i0.ɵɵproperty("name", ctx_r1.s.endIcon)("svg", ctx_r1.s.endIconSvg)("theme", ctx_r1.s.theme);
  }
}
function MbscInput_mbsc_icon_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mbsc-icon", 14);
    i0.ɵɵlistener("click", function MbscInput_mbsc_icon_12_Template_mbsc_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._onClick());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1._passIconClass);
    i0.ɵɵproperty("name", ctx_r1._hidePass ? ctx_r1.s.showIcon : ctx_r1.s.hideIcon)("svg", ctx_r1._hidePass ? ctx_r1.s.showIconSvg : ctx_r1.s.hideIconSvg)("theme", ctx_r1.s.theme);
  }
}
function MbscInput_span_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1._errorClass);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.s.errorMessage);
  }
}
function MbscInput_fieldset_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "fieldset", 15)(1, "legend");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1._fieldSetClass);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r1._legendClass);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.s.label && ctx_r1.s.labelStyle !== "inline" ? ctx_r1.s.label : "&nbsp;");
  }
}
function MbscInput_span_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1._rippleClass);
  }
}
const _c7 = [[["", "mbsc-label", ""]], "*"];
const _c8 = ["[mbsc-label]", "*"];
function MbscDropdown_mbsc_icon_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mbsc-icon", 7);
    i0.ɵɵlistener("click", function MbscDropdown_mbsc_icon_8_Template_mbsc_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3._onIconClick());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r3._startIconClass);
    i0.ɵɵproperty("name", ctx_r3.s.startIcon)("svg", ctx_r3.s.startIconSvg)("theme", ctx_r3.s.theme);
  }
}
function MbscDropdown_mbsc_icon_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mbsc-icon", 7);
    i0.ɵɵlistener("click", function MbscDropdown_mbsc_icon_9_Template_mbsc_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3._onIconClick());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r3._endIconClass);
    i0.ɵɵproperty("name", ctx_r3.s.endIcon)("svg", ctx_r3.s.endIconSvg)("theme", ctx_r3.s.theme);
  }
}
function MbscDropdown_span_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r3._errorClass);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r3.s.errorMessage);
  }
}
function MbscDropdown_fieldset_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "fieldset", 8)(1, "legend");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r3._fieldSetClass);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r3._legendClass);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r3.s.label && ctx_r3.s.labelStyle !== "inline" ? ctx_r3.s.label : "&nbsp;");
  }
}
function MbscDropdown_span_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span");
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r3._rippleClass);
  }
}
function MbscTextarea_mbsc_icon_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mbsc-icon", 6);
    i0.ɵɵlistener("click", function MbscTextarea_mbsc_icon_6_Template_mbsc_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2._onIconClick());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r2._startIconClass);
    i0.ɵɵproperty("name", ctx_r2.s.startIcon)("svg", ctx_r2.s.startIconSvg)("theme", ctx_r2.s.theme);
  }
}
function MbscTextarea_mbsc_icon_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mbsc-icon", 6);
    i0.ɵɵlistener("click", function MbscTextarea_mbsc_icon_7_Template_mbsc_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2._onIconClick());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r2._endIconClass);
    i0.ɵɵproperty("name", ctx_r2.s.endIcon)("svg", ctx_r2.s.endIconSvg)("theme", ctx_r2.s.theme);
  }
}
function MbscTextarea_span_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r2._errorClass);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.s.errorMessage);
  }
}
function MbscTextarea_fieldset_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "fieldset", 7)(1, "legend");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r2._fieldSetClass);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r2._legendClass);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.s.label && ctx_r2.s.labelStyle !== "inline" ? ctx_r2.s.label : "&nbsp;");
  }
}
function MbscTextarea_span_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r2._rippleClass);
  }
}
const _c9 = ["active"];
const _c10 = ["content"];
const _c11 = ["limit"];
const _c12 = ["wrapper"];
const _c13 = ["popup"];
function MbscPopup_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵprojection(1);
    i0.ɵɵelementContainerEnd();
  }
}
function MbscPopup_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscPopup_ng_template_0_ng_container_0_Template, 2, 0, "ng-container", 6);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r0._isVisible || !ctx_r0._isModal);
  }
}
function MbscPopup_ng_container_2_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵlistener("click", function MbscPopup_ng_container_2_div_3_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0._onOverlayClick());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-popup-overlay mbsc-popup-overlay-" + ctx_r0.s.display + ctx_r0._theme + (ctx_r0._isClosing ? " mbsc-popup-overlay-out" : "") + (ctx_r0._isOpening && ctx_r0.state.isReady ? " mbsc-popup-overlay-in" : ""));
  }
}
function MbscPopup_ng_container_2_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "div", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-popup-arrow-wrapper mbsc-popup-arrow-wrapper-" + ctx_r0.state.bubblePos + ctx_r0._theme);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-popup-arrow mbsc-popup-arrow-" + ctx_r0.state.bubblePos + ctx_r0._theme);
    i0.ɵɵproperty("ngStyle", ctx_r0.state.arrowPos);
  }
}
function MbscPopup_ng_container_2_div_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 17);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-flex-none mbsc-popup-header mbsc-popup-header-" + ctx_r0.s.display + ctx_r0._theme + ctx_r0._hb + (ctx_r0._buttons ? "" : " mbsc-popup-header-no-buttons"));
    i0.ɵɵproperty("innerHTML", ctx_r0._headerText, i0.ɵɵsanitizeHtml);
  }
}
function MbscPopup_ng_container_2_div_16_mbsc_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mbsc-button", 19);
    i0.ɵɵlistener("click", function MbscPopup_ng_container_2_div_16_mbsc_button_1_Template_mbsc_button_click_0_listener($event) {
      const btn_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      return i0.ɵɵresetView(!btn_r5.disabled && btn_r5.handler($event));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const btn_r5 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap("mbsc-popup-button mbsc-popup-button-" + ctx_r0.s.display + ctx_r0._rtl + ctx_r0._hb + (ctx_r0._flexButtons ? " mbsc-popup-button-flex" : "") + " " + (btn_r5.cssClass || ""));
    i0.ɵɵproperty("color", btn_r5.color)("disabled", btn_r5.disabled)("icon", btn_r5.icon)("theme", ctx_r0.s.theme)("themeVariant", ctx_r0.s.themeVariant)("variant", btn_r5.variant || ctx_r0.s.buttonVariant);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", btn_r5.text, " ");
  }
}
function MbscPopup_ng_container_2_div_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MbscPopup_ng_container_2_div_16_mbsc_button_1_Template, 2, 9, "mbsc-button", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-flex-none mbsc-popup-buttons mbsc-popup-buttons-" + ctx_r0.s.display + ctx_r0._theme + ctx_r0._rtl + ctx_r0._hb + (ctx_r0._flexButtons ? " mbsc-flex" : "") + (ctx_r0.s.fullScreen ? " mbsc-popup-buttons-" + ctx_r0.s.display + "-full" : ""));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0._buttons);
  }
}
function MbscPopup_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 8, 1);
    i0.ɵɵlistener("keydown", function MbscPopup_ng_container_2_Template_div_keydown_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0._onKeyDown($event));
    });
    i0.ɵɵtemplate(3, MbscPopup_ng_container_2_div_3_Template, 1, 2, "div", 9);
    i0.ɵɵelement(4, "div", 10, 2);
    i0.ɵɵelementStart(6, "div", 11, 3);
    i0.ɵɵlistener("animationend", function MbscPopup_ng_container_2_Template_div_animationend_6_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0._onAnimationEnd($event));
    })("click", function MbscPopup_ng_container_2_Template_div_click_6_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0._onPopupClick());
    });
    i0.ɵɵtemplate(8, MbscPopup_ng_container_2_div_8_Template, 2, 5, "div", 12);
    i0.ɵɵelement(9, "div", 13, 4);
    i0.ɵɵelementStart(11, "div");
    i0.ɵɵtemplate(12, MbscPopup_ng_container_2_div_12_Template, 1, 3, "div", 14);
    i0.ɵɵelementStart(13, "div", null, 5);
    i0.ɵɵelementContainer(15, 15);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(16, MbscPopup_ng_container_2_div_16_Template, 2, 3, "div", 12);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const ngcontent_r6 = i0.ɵɵreference(1);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-font mbsc-flex mbsc-popup-wrapper mbsc-popup-wrapper-" + ctx_r0.s.display + ctx_r0._theme + ctx_r0._rtl + " " + ctx_r0._className + (ctx_r0.s.fullScreen ? " mbsc-popup-wrapper-" + ctx_r0.s.display + "-full" : "") + (ctx_r0._touchUi ? "" : " mbsc-popup-pointer") + (ctx_r0._round ? " mbsc-popup-round" : "") + (ctx_r0._hasContext ? " mbsc-popup-wrapper-ctx" : "") + (ctx_r0.state.isReady ? "" : " mbsc-popup-hidden"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.s.showOverlay);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-popup-limits mbsc-popup-limits-" + ctx_r0.s.display);
    i0.ɵɵproperty("ngStyle", ctx_r0._limits);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap("mbsc-flex-col mbsc-popup mbsc-popup-" + ctx_r0.s.display + ctx_r0._theme + ctx_r0._hb + (ctx_r0.s.fullScreen ? "-full" : "") + (ctx_r0.state.bubblePos && ctx_r0.state.showArrow && ctx_r0.s.display === "anchored" ? " mbsc-popup-anchored-" + ctx_r0.state.bubblePos : "") + (ctx_r0._isClosing ? " mbsc-popup-" + ctx_r0._animation + "-out" : "") + (ctx_r0._isOpening && ctx_r0.state.isReady ? " mbsc-popup-" + ctx_r0._animation + "-in" : ""));
    i0.ɵɵproperty("ngStyle", ctx_r0._style);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.s.display === "anchored" && ctx_r0.state.showArrow);
    i0.ɵɵadvance(3);
    i0.ɵɵclassMap("mbsc-flex-col mbsc-flex-1-1 mbsc-popup-body mbsc-popup-body-" + ctx_r0.s.display + ctx_r0._theme + ctx_r0._hb + (ctx_r0.s.fullScreen ? " mbsc-popup-body-" + ctx_r0.s.display + "-full" : "") + (ctx_r0._round ? " mbsc-popup-body-round" : ""));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0._headerText);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-flex-1-1 mbsc-popup-content" + (ctx_r0.s.contentPadding ? " mbsc-popup-padding" : ""));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ngcontent_r6);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0._buttons);
  }
}
function MbscPopup_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 15);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const ngcontent_r6 = i0.ɵɵreference(1);
    i0.ɵɵproperty("ngTemplateOutlet", ngcontent_r6);
  }
}
function MbscPrompt_h2_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.title);
  }
}
function MbscSnackbar_mbsc_button_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mbsc-button", 5);
    i0.ɵɵlistener("click", function MbscSnackbar_mbsc_button_5_Template_mbsc_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onButtonClick());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("icon", ctx_r1.button.icon)("theme", ctx_r1.props.theme)("themeVariant", ctx_r1.props.themeVariant);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.button.text, " ");
  }
}
const _c14 = a0 => ({
  $implicit: a0
});
function MbscCalendarLabel_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-calendar-label-resize mbsc-calendar-label-resize-start" + ctx_r0._rtl + (ctx_r0.isUpdate ? " mbsc-calendar-label-resize-start-touch" : ""));
  }
}
function MbscCalendarLabel_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-calendar-label-resize mbsc-calendar-label-resize-end" + ctx_r0._rtl + (ctx_r0.isUpdate ? " mbsc-calendar-label-resize-start-touch" : ""));
  }
}
function MbscCalendarLabel_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-calendar-label-background" + ctx_r0._theme);
  }
}
function MbscCalendarLabel_div_3_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 5);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-calendar-label-text" + ctx_r0._theme);
    i0.ɵɵstyleProp("color", ctx_r0.event && ctx_r0.event.textColor);
    i0.ɵɵproperty("innerHTML", ctx_r0._html, i0.ɵɵsanitizeHtml);
  }
}
function MbscCalendarLabel_div_3_div_2_ng_template_1_Template(rf, ctx) {}
function MbscCalendarLabel_div_3_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MbscCalendarLabel_div_3_div_2_ng_template_1_Template, 0, 0, "ng-template", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-calendar-label-text" + ctx_r0._theme);
    i0.ɵɵstyleProp("color", ctx_r0.event && ctx_r0.event.textColor);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.contentTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(6, _c14, ctx_r0._data));
  }
}
function MbscCalendarLabel_div_3_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.s.label);
  }
}
function MbscCalendarLabel_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MbscCalendarLabel_div_3_div_1_Template, 1, 5, "div", 3)(2, MbscCalendarLabel_div_3_div_2_Template, 2, 8, "div", 1)(3, MbscCalendarLabel_div_3_div_3_Template, 2, 1, "div", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-calendar-label-inner" + ctx_r0._theme);
    i0.ɵɵstyleProp("color", ctx_r0._textColor);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0._html);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0._html);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.s.label);
  }
}
function MbscCalendarLabel_4_ng_template_0_Template(rf, ctx) {}
function MbscCalendarLabel_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscCalendarLabel_4_ng_template_0_Template, 0, 0, "ng-template", 6);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.template)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c14, ctx_r0._data));
  }
}
function MbscCalendarDay_1_ng_template_0_Template(rf, ctx) {}
function MbscCalendarDay_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscCalendarDay_1_ng_template_0_Template, 0, 0, "ng-template", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.dayTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c14, ctx_r0._data));
  }
}
function MbscCalendarDay_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-calendar-month-name" + ctx_r0._theme + ctx_r0._rtl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.s.monthShort, " ");
  }
}
function MbscCalendarDay_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-calendar-cell-text mbsc-calendar-" + ctx_r0.s.type + "-text" + ctx_r0._theme + ctx_r0._todayClass);
    i0.ɵɵproperty("ngStyle", ctx_r0._circleStyles);
    i0.ɵɵattribute("aria-label", ctx_r0._ariaLabel)("aria-pressed", ctx_r0.s.selected);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.s.text, " ");
  }
}
function MbscCalendarDay_div_4_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div");
  }
  if (rf & 2) {
    const mark_r2 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-calendar-mark " + (mark_r2.markCssClass || "") + ctx_r0._theme);
    i0.ɵɵstyleProp("background", mark_r2.color);
  }
}
function MbscCalendarDay_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div");
    i0.ɵɵtemplate(2, MbscCalendarDay_div_4_div_2_Template, 1, 4, "div", 6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-calendar-marks" + ctx_r0._theme + ctx_r0._rtl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.s.marks)("ngForTrackBy", ctx_r0._getKey);
  }
}
function MbscCalendarDay_5_ng_template_0_Template(rf, ctx) {}
function MbscCalendarDay_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscCalendarDay_5_ng_template_0_Template, 0, 0, "ng-template", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.dayContentTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c14, ctx_r0._data));
  }
}
function MbscCalendarDay_div_6_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div");
    i0.ɵɵelement(2, "mbsc-calendar-label", 11);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-calendar-labels mbsc-calendar-labels-dragging");
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("width", ctx_r0._draggedLabelOrig.width + "%" || 100 + "%");
    i0.ɵɵadvance();
    i0.ɵɵproperty("amText", ctx_r0.s.amText)("date", ctx_r0.s.date)("dataTimezone", ctx_r0.dataTimezone)("displayTimezone", ctx_r0.displayTimezone)("drag", ctx_r0.s.dragToMove)("resize", ctx_r0._computeEventResize(ctx_r0._draggedLabelOrig.event.resize, ctx_r0.s.dragToResize))("event", ctx_r0._draggedLabelOrig.event)("exclusiveEndDates", ctx_r0.exclusiveEndDates)("firstDay", ctx_r0.s.firstDay)("hidden", !!ctx_r0.s.dragData.draggedDates)("isUpdate", true)("pmText", ctx_r0.s.pmText)("resourcesMap", ctx_r0.s.resourcesMap)("rtl", ctx_r0.s.rtl)("showEventTooltip", ctx_r0.s.showEventTooltip)("showText", true)("theme", ctx_r0.s.theme)("timeFormat", ctx_r0.s.timeFormat)("timezonePlugin", ctx_r0.timezonePlugin)("template", ctx_r0.labelTemplate)("contentTemplate", ctx_r0.labelContentTemplate)("onClick", ctx_r0._onLabelClick)("onDoubleClick", ctx_r0._onLabelDoubleClick)("onRightClick", ctx_r0._onLabelRightClick)("onHoverIn", ctx_r0._onLabelHoverIn)("onHoverOut", ctx_r0._onLabelHoverOut)("onDelete", ctx_r0.s.onLabelDelete)("onDragStart", ctx_r0.s.onLabelUpdateStart)("onDragMove", ctx_r0.s.onLabelUpdateMove)("onDragEnd", ctx_r0.s.onLabelUpdateEnd)("onDragModeOn", ctx_r0.s.onLabelUpdateModeOn)("onDragModeOff", ctx_r0.s.onLabelUpdateModeOff);
  }
}
function MbscCalendarDay_div_6_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div");
    i0.ɵɵelement(2, "mbsc-calendar-label", 12);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-calendar-labels mbsc-calendar-labels-dragging");
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-calendar-label-wrapper");
    i0.ɵɵstyleProp("width", ctx_r0._draggedLabel.width + "%" || 100 + "%");
    i0.ɵɵadvance();
    i0.ɵɵproperty("amText", ctx_r0.s.amText)("date", ctx_r0.s.date)("dataTimezone", ctx_r0.dataTimezone)("displayTimezone", ctx_r0.displayTimezone)("drag", ctx_r0.s.dragToMove)("resize", ctx_r0._computeEventResize(ctx_r0._draggedLabel.event.resize, ctx_r0.s.dragToResize))("event", ctx_r0._draggedLabel.event)("exclusiveEndDates", ctx_r0.exclusiveEndDates)("firstDay", ctx_r0.s.firstDay)("isUpdate", true)("pmText", ctx_r0.s.pmText)("resourcesMap", ctx_r0.s.resourcesMap)("rtl", ctx_r0.s.rtl)("showEventTooltip", ctx_r0.s.showEventTooltip)("showText", true)("theme", ctx_r0.s.theme)("timeFormat", ctx_r0.s.timeFormat)("timezonePlugin", ctx_r0.timezonePlugin)("template", ctx_r0.labelTemplate)("contentTemplate", ctx_r0.labelContentTemplate)("onClick", ctx_r0._onLabelClick)("onDoubleClick", ctx_r0._onLabelDoubleClick)("onRightClick", ctx_r0._onLabelRightClick)("onHoverIn", ctx_r0._onLabelHoverIn)("onHoverOut", ctx_r0._onLabelHoverOut)("onDelete", ctx_r0.s.onLabelDelete)("onDragStart", ctx_r0.s.onLabelUpdateStart)("onDragMove", ctx_r0.s.onLabelUpdateMove)("onDragEnd", ctx_r0.s.onLabelUpdateEnd)("onDragModeOn", ctx_r0.s.onLabelUpdateModeOn)("onDragModeOff", ctx_r0.s.onLabelUpdateModeOff);
  }
}
function MbscCalendarDay_div_6_ng_container_4_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 10);
  }
}
function MbscCalendarDay_div_6_ng_container_4_mbsc_calendar_label_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mbsc-calendar-label", 16);
  }
  if (rf & 2) {
    const label_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("count", label_r3.count ? label_r3.count + " " + (label_r3.count > 1 ? ctx_r0.s.eventsText : ctx_r0.s.eventText) : undefined)("id", label_r3.id)("isActiveMonth", ctx_r0.isActiveMonth)("label", label_r3.label)("more", label_r3.more)("rtl", ctx_r0.s.rtl)("theme", ctx_r0.s.theme)("onClick", ctx_r0._onLabelClick)("onDoubleClick", ctx_r0._onLabelDoubleClick)("onRightClick", ctx_r0._onLabelRightClick)("onHoverIn", ctx_r0._onLabelHoverIn)("onHoverOut", ctx_r0._onLabelHoverOut)("showText", true);
  }
}
function MbscCalendarDay_div_6_ng_container_4_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵelement(2, "mbsc-calendar-label", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "mbsc-calendar-label", 19);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const label_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("width", label_r3.width + "%");
    i0.ɵɵadvance();
    i0.ɵɵproperty("amText", ctx_r0.s.amText)("date", ctx_r0.s.date)("dataTimezone", ctx_r0.dataTimezone)("displayTimezone", ctx_r0.displayTimezone)("drag", ctx_r0.s.dragToMove)("resize", ctx_r0._computeEventResize(label_r3.event.resize, ctx_r0.s.dragToResize))("event", label_r3.event)("exclusiveEndDates", ctx_r0.exclusiveEndDates)("firstDay", ctx_r0.s.firstDay)("id", label_r3.id)("inactive", label_r3.event && ctx_r0.s.dragData && ctx_r0.s.dragData.draggedEvent && label_r3.event.id === ctx_r0.s.dragData.draggedEvent.id)("isActiveMonth", ctx_r0.isActiveMonth)("isPicker", ctx_r0.s.isPicker)("label", label_r3.label)("lastDay", label_r3.lastDay)("pmText", ctx_r0.s.pmText)("resourcesMap", ctx_r0.s.resourcesMap)("rtl", ctx_r0.s.rtl)("selected", label_r3.event && ctx_r0.selectedEventsMap && !!(ctx_r0.selectedEventsMap[label_r3.id] || ctx_r0.selectedEventsMap[label_r3.event.id]))("showEventTooltip", ctx_r0.s.showEventTooltip)("showText", true)("theme", ctx_r0.s.theme)("timeFormat", ctx_r0.s.timeFormat)("timezonePlugin", ctx_r0.timezonePlugin)("template", ctx_r0.labelTemplate)("contentTemplate", ctx_r0.labelContentTemplate)("onClick", ctx_r0._onLabelClick)("onDoubleClick", ctx_r0._onLabelDoubleClick)("onRightClick", ctx_r0._onLabelRightClick)("onHoverIn", ctx_r0._onLabelHoverIn)("onHoverOut", ctx_r0._onLabelHoverOut)("onDelete", ctx_r0.s.onLabelDelete)("onDragStart", ctx_r0.s.onLabelUpdateStart)("onDragMove", ctx_r0.s.onLabelUpdateMove)("onDragEnd", ctx_r0.s.onLabelUpdateEnd)("onDragModeOn", ctx_r0.s.onLabelUpdateModeOn)("onDragModeOff", ctx_r0.s.onLabelUpdateModeOff);
    i0.ɵɵadvance();
    i0.ɵɵproperty("date", ctx_r0.s.date)("dataTimezone", ctx_r0.dataTimezone)("displayTimezone", ctx_r0.displayTimezone)("drag", ctx_r0.s.dragToMove)("resize", ctx_r0._computeEventResize(label_r3.event.resize, ctx_r0.s.dragToResize))("event", label_r3.event)("exclusiveEndDates", ctx_r0.exclusiveEndDates)("firstDay", ctx_r0.s.firstDay)("id", label_r3.id)("inactive", label_r3.event && ctx_r0.s.dragData && ctx_r0.s.dragData.draggedEvent && label_r3.event.id === ctx_r0.s.dragData.draggedEvent.id)("label", label_r3.label)("resourcesMap", ctx_r0.s.resourcesMap)("rtl", ctx_r0.s.rtl)("showEventTooltip", ctx_r0.s.showEventTooltip)("theme", ctx_r0.s.theme)("timeFormat", ctx_r0.s.timeFormat)("timezonePlugin", ctx_r0.timezonePlugin)("template", ctx_r0.labelTemplate)("contentTemplate", ctx_r0.labelContentTemplate)("onClick", ctx_r0._onLabelClick)("onDoubleClick", ctx_r0._onLabelDoubleClick)("onRightClick", ctx_r0._onLabelRightClick)("onHoverIn", ctx_r0._onLabelHoverIn)("onHoverOut", ctx_r0._onLabelHoverOut)("onDelete", ctx_r0.s.onLabelDelete)("onDragStart", ctx_r0.s.onLabelUpdateStart)("onDragMove", ctx_r0.s.onLabelUpdateMove)("onDragEnd", ctx_r0.s.onLabelUpdateEnd)("onDragModeOn", ctx_r0.s.onLabelUpdateModeOn)("onDragModeOff", ctx_r0.s.onLabelUpdateModeOff);
  }
}
function MbscCalendarDay_div_6_ng_container_4_mbsc_calendar_label_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mbsc-calendar-label", 20);
  }
  if (rf & 2) {
    const label_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("amText", ctx_r0.s.amText)("date", ctx_r0.s.date)("dataTimezone", ctx_r0.dataTimezone)("displayTimezone", ctx_r0.displayTimezone)("drag", ctx_r0.s.dragToMove)("resize", ctx_r0._computeEventResize(label_r3.event.resize, ctx_r0.s.dragToResize))("event", label_r3.event)("exclusiveEndDates", ctx_r0.exclusiveEndDates)("firstDay", ctx_r0.s.firstDay)("id", label_r3.id)("inactive", label_r3.event && ctx_r0.s.dragData && ctx_r0.s.dragData.draggedEvent && label_r3.event.id === ctx_r0.s.dragData.draggedEvent.id)("isActiveMonth", ctx_r0.isActiveMonth)("isPicker", ctx_r0.s.isPicker)("label", label_r3.label)("pmText", ctx_r0.s.pmText)("resourcesMap", ctx_r0.s.resourcesMap)("rtl", ctx_r0.s.rtl)("selected", label_r3.event && ctx_r0.selectedEventsMap && !!(ctx_r0.selectedEventsMap[label_r3.id] || ctx_r0.selectedEventsMap[label_r3.event.id]))("showText", label_r3.showText)("showEventTooltip", ctx_r0.s.showEventTooltip)("theme", ctx_r0.s.theme)("timeFormat", ctx_r0.s.timeFormat)("timezonePlugin", ctx_r0.timezonePlugin)("template", ctx_r0.labelTemplate)("contentTemplate", ctx_r0.labelContentTemplate)("onClick", ctx_r0._onLabelClick)("onDoubleClick", ctx_r0._onLabelDoubleClick)("onRightClick", ctx_r0._onLabelRightClick)("onHoverIn", ctx_r0._onLabelHoverIn)("onHoverOut", ctx_r0._onLabelHoverOut)("onDelete", ctx_r0.s.onLabelDelete)("onDragStart", ctx_r0.s.onLabelUpdateStart)("onDragMove", ctx_r0.s.onLabelUpdateMove)("onDragEnd", ctx_r0.s.onLabelUpdateEnd)("onDragModeOn", ctx_r0.s.onLabelUpdateModeOn)("onDragModeOff", ctx_r0.s.onLabelUpdateModeOff);
  }
}
function MbscCalendarDay_div_6_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscCalendarDay_div_6_ng_container_4_div_1_Template, 1, 0, "div", 13)(2, MbscCalendarDay_div_6_ng_container_4_mbsc_calendar_label_2_Template, 1, 13, "mbsc-calendar-label", 14)(3, MbscCalendarDay_div_6_ng_container_4_ng_container_3_Template, 4, 69, "ng-container", 0)(4, MbscCalendarDay_div_6_ng_container_4_mbsc_calendar_label_4_Template, 1, 36, "mbsc-calendar-label", 15);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const label_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", label_r3.placeholder);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", label_r3.more || label_r3.count);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", label_r3.multiDay);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !label_r3.multiDay && label_r3.event);
  }
}
function MbscCalendarDay_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MbscCalendarDay_div_6_div_1_Template, 3, 36, "div", 7)(2, MbscCalendarDay_div_6_div_2_Template, 3, 37, "div", 7);
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵtemplate(4, MbscCalendarDay_div_6_ng_container_4_Template, 5, 4, "ng-container", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "div", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0._draggedLabelOrig && ctx_r0._draggedLabelOrig.event);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0._draggedLabel && ctx_r0._draggedLabel.event);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.s.labels.data)("ngForTrackBy", ctx_r0._getLabelKey);
  }
}
function MbscCalendarWeekDays_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", "mbsc-calendar-week-day mbsc-calendar-week-nr mbsc-flex-none" + ctx_r0.theme + ctx_r0.rtl);
  }
}
function MbscCalendarWeekDays_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r2 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", "mbsc-calendar-week-day mbsc-flex-1-0-0" + ctx_r0.theme + ctx_r0.rtl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.dayNamesShort[(i_r2 + ctx_r0.firstDay) % 7], " ");
  }
}
function MbscCalendarWeekDays_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 4);
  }
}
function MbscMonthView_mbsc_calendar_weekdays_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mbsc-calendar-weekdays", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("rtl", ctx_r0._rtl)("theme", ctx_r0._theme)("firstDay", ctx_r0.s.firstDay)("dayNamesShort", ctx_r0.s.dayNamesShort)("showWeekNumbers", ctx_r0.s.showWeekNumbers);
  }
}
function MbscMonthView_div_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "div", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 8);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const row_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", "mbsc-calendar-cell mbsc-flex-none mbsc-calendar-day mbsc-calendar-week-nr" + ctx_r0._theme);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0._getWeekNr(ctx_r0.s, row_r2[0].date));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.s.weekText.replace("{count}", ctx_r0._getWeekNr(ctx_r0.s, row_r2[0].date)));
  }
}
function MbscMonthView_div_2_mbsc_calendar_day_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mbsc-calendar-day", 9);
  }
  if (rf & 2) {
    const cell_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("active", cell_r3.display && ctx_r0._isActive(cell_r3.date))("amText", ctx_r0.s.amText)("colors", cell_r3.colors)("clickToCreate", ctx_r0.s.clickToCreate)("date", cell_r3.date)("day", cell_r3.day)("dayTemplate", ctx_r0.dayTemplate)("dayContentTemplate", ctx_r0.dayContentTemplate)("disabled", ctx_r0._isInvalid(cell_r3.date))("display", cell_r3.display)("dataTimezone", ctx_r0.dataTimezone)("displayTimezone", ctx_r0.displayTimezone)("dragToCreate", ctx_r0.s.dragToCreate)("dragToResize", ctx_r0.s.dragToResize)("dragToMove", ctx_r0.s.dragToMove)("eventText", ctx_r0.s.eventText)("events", cell_r3.events)("eventsText", ctx_r0.s.eventsText)("exclusiveEndDates", ctx_r0.exclusiveEndDates)("firstDay", ctx_r0.s.firstDay)("hasMarks", ctx_r0.s.hasMarks)("hoverEnd", ctx_r0.s.hoverEnd)("hoverStart", ctx_r0.s.hoverStart)("isActiveMonth", ctx_r0.s.isActive)("isPicker", ctx_r0.s.isPicker)("labels", cell_r3.labels)("labelTemplate", ctx_r0.labelTemplate)("labelContentTemplate", ctx_r0.labelContentTemplate)("dragData", ctx_r0.s.dragData)("marks", cell_r3.marks)("month", cell_r3.month)("monthShort", cell_r3.monthShort)("outer", cell_r3.outer)("pmText", ctx_r0.s.pmText)("rangeEnd", ctx_r0.s.rangeEnd)("rangeStart", ctx_r0.s.rangeStart)("resourcesMap", ctx_r0.s.resourcesMap)("rtl", ctx_r0.s.rtl)("selected", ctx_r0._isSelected(cell_r3.date))("selectedEventsMap", ctx_r0.s.selectedEventsMap)("showEventTooltip", ctx_r0.s.showEventTooltip)("text", cell_r3.text)("timeFormat", ctx_r0.s.timeFormat)("timezonePlugin", ctx_r0.timezonePlugin)("todayText", ctx_r0.s.todayText)("theme", ctx_r0.s.theme)("year", cell_r3.year)("onDayClick", ctx_r0.s.onDayClick)("onDayDoubleClick", ctx_r0.s.onDayDoubleClick)("onDayRightClick", ctx_r0.s.onDayRightClick)("onHoverIn", ctx_r0.s.onDayHoverIn)("onHoverOut", ctx_r0.s.onDayHoverOut)("onLabelClick", ctx_r0.s.onLabelClick)("onLabelDoubleClick", ctx_r0.s.onLabelDoubleClick)("onLabelRightClick", ctx_r0.s.onLabelRightClick)("onLabelHoverIn", ctx_r0.s.onLabelHoverIn)("onLabelHoverOut", ctx_r0.s.onLabelHoverOut)("onLabelDelete", ctx_r0.s.onLabelDelete)("onLabelUpdateStart", ctx_r0.s.onLabelUpdateStart)("onLabelUpdateMove", ctx_r0.s.onLabelUpdateMove)("onLabelUpdateEnd", ctx_r0.s.onLabelUpdateEnd)("onLabelUpdateModeOn", ctx_r0.s.onLabelUpdateModeOn)("onLabelUpdateModeOff", ctx_r0.s.onLabelUpdateModeOff);
  }
}
function MbscMonthView_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, MbscMonthView_div_2_div_1_Template, 5, 3, "div", 4)(2, MbscMonthView_div_2_mbsc_calendar_day_2_Template, 1, 63, "mbsc-calendar-day", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r2 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("min-height", ctx_r0._rowHeights[i_r4] || 0, "px");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.s.showWeekNumbers);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", row_r2)("ngForTrackBy", ctx_r0._getKey);
  }
}
const _c15 = ["el"];
const _c16 = ["el3d"];
const _c17 = ["innerEl"];
const _c18 = ["barCont"];
const _c19 = ["bar"];
const _c20 = ["*", [["", "content-3d", ""]]];
const _c21 = ["*", "[content-3d]"];
function MbscScrollviewBase_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7, 4);
    i0.ɵɵprojection(2, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("height", ctx_r0.s.itemSize, "px");
  }
}
function MbscMultiYearView_div_0_mbsc_calendar_day_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mbsc-calendar-day", 3);
  }
  if (rf & 2) {
    const cell_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("active", cell_r1.year === ctx_r1._activeYear)("date", cell_r1.d)("display", true)("selected", cell_r1.year === ctx_r1._selectedYear)("disabled", cell_r1.year < ctx_r1.min || cell_r1.year > ctx_r1.max)("rtl", ctx_r1.rtl)("text", cell_r1.year + ctx_r1.yearSuffix)("theme", ctx_r1.theme)("onDayClick", ctx_r1.onYearClick);
  }
}
function MbscMultiYearView_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, MbscMultiYearView_div_0_mbsc_calendar_day_1_Template, 1, 9, "mbsc-calendar-day", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", row_r3)("ngForTrackBy", ctx_r1.getKey);
  }
}
function MbscYearView_div_0_mbsc_calendar_day_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mbsc-calendar-day", 3);
  }
  if (rf & 2) {
    const cell_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("active", cell_r1.y === ctx_r1._activeYear && cell_r1.m === ctx_r1._activeMonth)("date", cell_r1.d)("display", true)("selected", cell_r1.y === ctx_r1._selectedYear && cell_r1.m === ctx_r1._selectedMonth)("disabled", cell_r1.d < ctx_r1.min || cell_r1.d >= ctx_r1.max)("rtl", ctx_r1.rtl)("text", ctx_r1.monthNamesShort[cell_r1.m])("theme", ctx_r1.theme)("onDayClick", ctx_r1.onMonthClick);
  }
}
function MbscYearView_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, MbscYearView_div_0_mbsc_calendar_day_1_Template, 1, 9, "mbsc-calendar-day", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", row_r3)("ngForTrackBy", ctx_r1.getKey);
  }
}
const _c22 = ["body"];
const _c23 = ["pickerCont"];
const _c24 = a0 => ({
  timestamp: a0,
  drag: false,
  isActive: true
});
const _c25 = a0 => ({
  timestamp: a0,
  isActive: true,
  drag: true
});
const _c26 = (a0, a1) => ({
  timestamp: a0,
  drag: true,
  isActive: a1
});
function MbscCalendarView_div_2_ng_template_1_Template(rf, ctx) {}
function MbscCalendarView_div_2_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mbsc-calendar-nav", 14)(1, "mbsc-calendar-prev")(2, "mbsc-calendar-today", 15)(3, "mbsc-calendar-next");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-calendar-button-prev" + (ctx_r1._pageNr > 1 ? " mbsc-calendar-button-prev-multi" : ""));
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap("mbsc-calendar-button-next" + (ctx_r1._pageNr > 1 ? " mbsc-calendar-button-next-multi" : ""));
  }
}
function MbscCalendarView_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MbscCalendarView_div_2_ng_template_1_Template, 0, 0, "ng-template", 13)(2, MbscCalendarView_div_2_ng_template_2_Template, 4, 4, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const defaultHeader_r3 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-calendar-controls mbsc-flex" + ctx_r1._theme);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.headerTemplate || defaultHeader_r3);
  }
}
function MbscCalendarView_mbsc_calendar_weekdays_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mbsc-calendar-weekdays", 16);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("dayNamesShort", ctx_r1._dayNames)("firstDay", ctx_r1.s.firstDay)("hasScroll", ctx_r1.state.hasScrollY)("hidden", ctx_r1._view !== ctx_r1.PAGE_VIEW && !ctx_r1._hasPicker)("showWeekNumbers", ctx_r1.s.showWeekNumbers)("rtl", ctx_r1._rtl)("theme", ctx_r1._theme);
  }
}
function MbscCalendarView_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mbsc-month-view", 17);
  }
  if (rf & 2) {
    const timestamp_r4 = ctx.timestamp;
    const drag_r5 = ctx.drag;
    const isActive_r6 = ctx.isActive;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("activeDate", ctx_r1._active)("amText", ctx_r1.s.amText)("calendarType", ctx_r1.s.calendarType)("cellTextHeight", ctx_r1.state.cellTextHeight)("clickToCreate", ctx_r1.s.clickToCreate)("colors", ctx_r1._colors)("dayNames", ctx_r1.s.dayNames)("dayNamesShort", ctx_r1._dayNames)("dayTemplate", ctx_r1.dayTemplate)("dayContentTemplate", ctx_r1.dayContentTemplate)("dataTimezone", ctx_r1.dataTimezone)("displayTimezone", ctx_r1.displayTimezone)("dragData", drag_r5 && ctx_r1.s.dragData)("dragToCreate", drag_r5 && ctx_r1.s.dragToCreate)("dragToResize", drag_r5 && ctx_r1.s.dragToResize)("dragToMove", drag_r5 && ctx_r1.s.dragToMove)("eventText", ctx_r1.s.eventText)("events", ctx_r1.s.eventMap)("eventsText", ctx_r1.s.eventsText)("exclusiveEndDates", ctx_r1.exclusiveEndDates)("firstDay", ctx_r1.s.firstDay)("firstPageDay", timestamp_r4)("getDate", ctx_r1.s.getDate)("getDay", ctx_r1.s.getDay)("getMonth", ctx_r1.s.getMonth)("getYear", ctx_r1.s.getYear)("getWeekNumber", ctx_r1.s.getWeekNumber)("hasMarks", !!ctx_r1._marked)("hoverEnd", ctx_r1.s.hoverEnd)("hoverStart", ctx_r1.s.hoverStart)("invalid", ctx_r1._invalid)("isActive", isActive_r6)("isPicker", ctx_r1.s.isPicker)("labels", ctx_r1._labelsLayout)("labelHeight", ctx_r1.state.labelHeight)("labelTemplate", ctx_r1.labelTemplate)("labelContentTemplate", ctx_r1.labelContentTemplate)("marked", ctx_r1._marked)("max", ctx_r1._maxDate)("min", ctx_r1._minDate)("monthNames", ctx_r1.s.monthNames)("monthNamesShort", ctx_r1.s.monthNamesShort)("onDayClick", ctx_r1._onDayClick)("onDayDoubleClick", ctx_r1.s.onDayDoubleClick)("onDayRightClick", ctx_r1.s.onDayRightClick)("onDayHoverIn", ctx_r1._onDayHoverIn)("onDayHoverOut", ctx_r1._onDayHoverOut)("onLabelClick", ctx_r1._onLabelClick)("onLabelDoubleClick", ctx_r1.s.onLabelDoubleClick)("onLabelRightClick", ctx_r1.s.onLabelRightClick)("onLabelHoverIn", ctx_r1.s.onLabelHoverIn)("onLabelHoverOut", ctx_r1.s.onLabelHoverOut)("onLabelDelete", ctx_r1.s.onLabelDelete)("onLabelUpdateStart", drag_r5 && ctx_r1.s.onLabelUpdateStart)("onLabelUpdateMove", drag_r5 && ctx_r1.s.onLabelUpdateMove)("onLabelUpdateEnd", drag_r5 && ctx_r1.s.onLabelUpdateEnd)("onLabelUpdateModeOn", drag_r5 && ctx_r1.s.onLabelUpdateModeOn)("onLabelUpdateModeOff", drag_r5 && ctx_r1.s.onLabelUpdateModeOff)("pmText", ctx_r1.s.pmText)("rangeEnd", ctx_r1.s.rangeEnd)("rangeStart", ctx_r1.s.rangeStart)("resourcesMap", ctx_r1.s.resourcesMap)("rtl", ctx_r1.s.rtl)("selectedDates", ctx_r1.s.selectedDates)("selectedEventsMap", ctx_r1.s.selectedEventsMap)("showEventTooltip", ctx_r1.s.showEventTooltip)("showOuter", ctx_r1._showOuter)("showSingleMark", !!ctx_r1.s.marksMap)("showWeekDays", !ctx_r1._showDaysTop)("showWeekNumbers", ctx_r1.s.showWeekNumbers)("theme", ctx_r1.s.theme)("timeFormat", ctx_r1.s.timeFormat)("timezonePlugin", ctx_r1.timezonePlugin)("todayText", ctx_r1.s.todayText)("valid", ctx_r1._valid)("variableRow", !!ctx_r1._variableRow)("weeks", ctx_r1._weeks)("weekText", ctx_r1.s.weekText);
  }
}
function MbscCalendarView_div_8_div_1_div_1_div_1_ng_template_3_Template(rf, ctx) {}
function MbscCalendarView_div_8_div_1_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, MbscCalendarView_div_8_div_1_div_1_div_1_ng_template_3_Template, 0, 0, "ng-template", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r7 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    const monthView_r8 = i0.ɵɵreference(5);
    i0.ɵɵclassMap("mbsc-calendar-grid-item mbsc-flex-col mbsc-flex-1-1" + ctx_r1._theme);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-calendar-month-title" + ctx_r1._theme);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1._getMonthName(item_r7));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", monthView_r8)("ngTemplateOutletContext", i0.ɵɵpureFunction1(7, _c24, item_r7));
  }
}
function MbscCalendarView_div_8_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtemplate(1, MbscCalendarView_div_8_div_1_div_1_div_1_Template, 4, 9, "div", 22);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r9 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", row_r9)("ngForTrackBy", ctx_r1._getKey);
  }
}
function MbscCalendarView_div_8_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MbscCalendarView_div_8_div_1_div_1_Template, 2, 2, "div", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-calendar-grid mbsc-flex-1-1 mbsc-flex-col" + ctx_r1._theme + ctx_r1._hb);
    i0.ɵɵattribute("aria-hidden", ctx_r1._view !== ctx_r1.PAGE_VIEW);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1._monthsMulti)("ngForTrackBy", ctx_r1._getKey);
  }
}
function MbscCalendarView_div_8_div_2_ng_template_1_Template(rf, ctx) {}
function MbscCalendarView_div_8_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MbscCalendarView_div_8_div_2_ng_template_1_Template, 0, 0, "ng-template", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    const monthView_r8 = i0.ɵɵreference(5);
    i0.ɵɵclassMap("mbsc-calendar-slide mbsc-calendar-slide-active " + ctx_r1._getPickerClass(ctx_r1.PAGE_VIEW));
    i0.ɵɵattribute("aria-hidden", ctx_r1._view !== ctx_r1.PAGE_VIEW);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", monthView_r8)("ngTemplateOutletContext", i0.ɵɵpureFunction1(5, _c25, ctx_r1._getFirstDay()));
  }
}
function MbscCalendarView_div_8_div_3_div_3_ng_template_1_Template(rf, ctx) {}
function MbscCalendarView_div_8_div_3_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵtemplate(1, MbscCalendarView_div_8_div_3_div_3_ng_template_1_Template, 0, 0, "ng-template", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r11 = ctx.$implicit;
    i0.ɵɵnextContext();
    const scrollview_r12 = i0.ɵɵreference(2);
    const ctx_r1 = i0.ɵɵnextContext(2);
    const monthView_r8 = i0.ɵɵreference(5);
    i0.ɵɵclassMap("mbsc-calendar-slide" + (item_r11.key >= ctx_r1._pageIndex && item_r11.key < ctx_r1._pageIndex + ctx_r1._pageNr && ctx_r1._view === ctx_r1.PAGE_VIEW ? " mbsc-calendar-slide-active" : "") + ctx_r1._theme + ctx_r1._rtl);
    i0.ɵɵproperty("ngStyle", ctx_r1._getPageStyle(item_r11.key, scrollview_r12._offset, ctx_r1._pageIndex, ctx_r1._pageNr));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", monthView_r8)("ngTemplateOutletContext", i0.ɵɵpureFunction2(5, _c26, ctx_r1._getPageDay(item_r11.key), item_r11.key >= ctx_r1._pageIndex && item_r11.key < ctx_r1._pageIndex + ctx_r1._pageNr && ctx_r1._view === ctx_r1.PAGE_VIEW));
  }
}
function MbscCalendarView_div_8_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵlistener("animationend", function MbscCalendarView_div_8_div_3_Template_div_animationend_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1._onViewAnimationEnd());
    });
    i0.ɵɵelementStart(1, "mbsc-scrollview-base", 25, 4);
    i0.ɵɵtemplate(3, MbscCalendarView_div_8_div_3_div_3_Template, 2, 8, "div", 26);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const scrollview_r12 = i0.ɵɵreference(2);
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r1._getPickerClass(ctx_r1.PAGE_VIEW));
    i0.ɵɵattribute("aria-hidden", ctx_r1._view !== ctx_r1.PAGE_VIEW);
    i0.ɵɵadvance();
    i0.ɵɵproperty("axis", ctx_r1._axis)("batchSize", 1)("changeOnEnd", true)("items", ctx_r1._months)("itemNr", ctx_r1._pageNr)("itemSize", ctx_r1.state.pageSize / ctx_r1._pageNr)("maxIndex", ctx_r1._maxIndex)("minIndex", ctx_r1._minIndex)("mouseSwipe", ctx_r1.s.mouseSwipe)("mousewheel", ctx_r1._mousewheel)("onAnimationEnd", ctx_r1._onAnimationEnd)("onGestureStart", ctx_r1._onGestureStart)("onIndexChange", ctx_r1._onPageChange)("onStart", ctx_r1._onStart)("prevAnim", ctx_r1._prevAnim)("rtl", ctx_r1.s.rtl)("selectedIndex", ctx_r1._pageIndex)("snap", true)("swipe", ctx_r1.s.swipe)("time", 200);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", scrollview_r12.visibleItems)("ngForTrackBy", ctx_r1._getKey);
  }
}
function MbscCalendarView_div_8_div_4_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function MbscCalendarView_div_8_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", null, 5);
    i0.ɵɵtemplate(2, MbscCalendarView_div_8_div_4_ng_container_2_Template, 1, 0, "ng-container", 28);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const picker_r13 = i0.ɵɵreference(12);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", picker_r13);
  }
}
function MbscCalendarView_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MbscCalendarView_div_8_div_1_Template, 2, 5, "div", 9)(2, MbscCalendarView_div_8_div_2_Template, 2, 7, "div", 9)(3, MbscCalendarView_div_8_div_3_Template, 4, 25, "div", 18)(4, MbscCalendarView_div_8_div_4_Template, 3, 1, "div", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-calendar-body-inner mbsc-flex-col mbsc-flex-1-1" + (ctx_r1._variableRow ? " mbsc-calendar-body-inner-variable" : ""));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._isGrid);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1._isGrid && ctx_r1._variableRow);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.s.selectView === ctx_r1.PAGE_VIEW && !ctx_r1._isGrid && !ctx_r1._variableRow);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1._hasPicker);
  }
}
function MbscCalendarView_mbsc_popup_10_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function MbscCalendarView_mbsc_popup_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mbsc-popup", 29);
    i0.ɵɵlistener("onClose", function MbscCalendarView_mbsc_popup_10_Template_mbsc_popup_onClose_0_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._onPickerClose());
    })("onOpen", function MbscCalendarView_mbsc_popup_10_Template_mbsc_popup_onOpen_0_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._onPickerOpen());
    });
    i0.ɵɵelementStart(1, "div", 11);
    i0.ɵɵlistener("keydown", function MbscCalendarView_mbsc_popup_10_Template_div_keydown_1_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._onKeyDown($event));
    });
    i0.ɵɵelementStart(2, "div")(3, "div", 30)(4, "mbsc-button", 31);
    i0.ɵɵlistener("click", function MbscCalendarView_mbsc_popup_10_Template_mbsc_button_click_4_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._onPickerBtnClick($event));
    });
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "mbsc-button", 32);
    i0.ɵɵlistener("click", function MbscCalendarView_mbsc_popup_10_Template_mbsc_button_click_6_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.prevPage());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "mbsc-button", 32);
    i0.ɵɵlistener("click", function MbscCalendarView_mbsc_popup_10_Template_mbsc_button_click_7_listener() {
      i0.ɵɵrestoreView(_r14);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.nextPage());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 33, 5);
    i0.ɵɵtemplate(10, MbscCalendarView_mbsc_popup_10_ng_container_10_Template, 1, 0, "ng-container", 28);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const picker_r13 = i0.ɵɵreference(12);
    i0.ɵɵproperty("anchor", ctx_r1._pickerBtn)("closeOnScroll", true)("contentPadding", false)("context", ctx_r1.s.context)("isOpen", ctx_r1._view !== ctx_r1.PAGE_VIEW)("locale", ctx_r1.s.locale)("rtl", ctx_r1.s.rtl)("scrollLock", false)("showOverlay", false)("theme", ctx_r1.s.theme)("themeVariant", ctx_r1.s.themeVariant);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap("mbsc-calendar-controls mbsc-flex" + ctx_r1._theme);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-calendar-picker-button-wrapper mbsc-calendar-title-wrapper mbsc-flex mbsc-flex-1-1" + ctx_r1._theme);
    i0.ɵɵadvance();
    i0.ɵɵproperty("theme", ctx_r1.s.theme)("themeVariant", ctx_r1.s.themeVariant);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1._viewTitle, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1._isPrevDisabled(true))("iconSvg", ctx_r1._prevIcon)("theme", ctx_r1.s.theme)("themeVariant", ctx_r1.s.themeVariant);
    i0.ɵɵattribute("aria-label", ctx_r1.s.prevPageText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1._isNextDisabled(true))("iconSvg", ctx_r1._nextIcon)("theme", ctx_r1.s.theme)("themeVariant", ctx_r1.s.themeVariant);
    i0.ɵɵattribute("aria-label", ctx_r1.s.nextPageText);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", picker_r13);
  }
}
function MbscCalendarView_ng_template_11_div_0_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelement(1, "mbsc-multi-year-view", 35);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r16 = ctx.$implicit;
    i0.ɵɵnextContext();
    const multiYearView_r17 = i0.ɵɵreference(2);
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-calendar-picker-slide mbsc-calendar-slide" + ctx_r1._theme + ctx_r1._rtl);
    i0.ɵɵproperty("ngStyle", ctx_r1._getPageStyle(item_r16.key, multiYearView_r17._offset, ctx_r1._yearsIndex));
    i0.ɵɵattribute("aria-hidden", item_r16.key === ctx_r1._yearsIndex ? undefined : "true");
    i0.ɵɵadvance();
    i0.ɵɵproperty("active", ctx_r1._active)("activeMonth", ctx_r1._activeMonth)("firstYear", ctx_r1._getPageYears(item_r16.key))("getDate", ctx_r1.s.getDate)("getYear", ctx_r1.s.getYear)("max", ctx_r1._maxYears)("min", ctx_r1._minYears)("rtl", ctx_r1.s.rtl)("theme", ctx_r1.s.theme)("yearSuffix", ctx_r1.s.yearSuffix)("onYearClick", ctx_r1._onYearClick);
  }
}
function MbscCalendarView_ng_template_11_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵlistener("animationend", function MbscCalendarView_ng_template_11_div_0_Template_div_animationend_0_listener() {
      i0.ɵɵrestoreView(_r15);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1._onViewAnimationEnd());
    });
    i0.ɵɵelementStart(1, "mbsc-scrollview-base", 34, 6);
    i0.ɵɵtemplate(3, MbscCalendarView_ng_template_11_div_0_div_3_Template, 2, 15, "div", 26);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const multiYearView_r17 = i0.ɵɵreference(2);
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r1._getPickerClass(ctx_r1.MULTI_YEAR_VIEW));
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-calendar-scroll-wrapper" + ctx_r1._theme);
    i0.ɵɵproperty("axis", ctx_r1._axis)("batchSize", 1)("changeOnEnd", true)("items", ctx_r1._months)("itemSize", ctx_r1.state.pickerSize)("maxIndex", ctx_r1._maxYearsIndex)("minIndex", ctx_r1._minYearsIndex)("mousewheel", ctx_r1._mousewheel)("onGestureEnd", ctx_r1._onGestureEnd)("onIndexChange", ctx_r1._onYearsPageChange)("prevAnim", ctx_r1._prevAnim)("rtl", ctx_r1.s.rtl)("selectedIndex", ctx_r1._yearsIndex)("snap", true)("time", 200);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", multiYearView_r17.visibleItems)("ngForTrackBy", ctx_r1._getKey);
  }
}
function MbscCalendarView_ng_template_11_div_1_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelement(1, "mbsc-year-view", 36);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r19 = ctx.$implicit;
    i0.ɵɵnextContext();
    const yearView_r20 = i0.ɵɵreference(2);
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-calendar-picker-slide mbsc-calendar-slide" + ctx_r1._theme + ctx_r1._rtl);
    i0.ɵɵproperty("ngStyle", ctx_r1._getPageStyle(item_r19.key, yearView_r20._offset, ctx_r1._yearIndex));
    i0.ɵɵattribute("aria-hidden", item_r19.key === ctx_r1._yearIndex ? undefined : "true");
    i0.ɵɵadvance();
    i0.ɵɵproperty("active", ctx_r1._active)("activeMonth", ctx_r1._activeMonth)("getDate", ctx_r1.s.getDate)("getMonth", ctx_r1.s.getMonth)("getYear", ctx_r1.s.getYear)("max", ctx_r1._maxYear)("min", ctx_r1._minYear)("monthNames", ctx_r1.s.monthNames)("monthNamesShort", ctx_r1.s.monthNamesShort)("onMonthClick", ctx_r1._onMonthClick)("rtl", ctx_r1.s.rtl)("theme", ctx_r1.s.theme)("year", ctx_r1._getPageYear(item_r19.key));
  }
}
function MbscCalendarView_ng_template_11_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵlistener("animationend", function MbscCalendarView_ng_template_11_div_1_Template_div_animationend_0_listener() {
      i0.ɵɵrestoreView(_r18);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1._onViewAnimationEnd());
    });
    i0.ɵɵelementStart(1, "mbsc-scrollview-base", 34, 7);
    i0.ɵɵtemplate(3, MbscCalendarView_ng_template_11_div_1_div_3_Template, 2, 17, "div", 26);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const yearView_r20 = i0.ɵɵreference(2);
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r1._getPickerClass(ctx_r1.YEAR_VIEW));
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-calendar-scroll-wrapper" + ctx_r1._theme);
    i0.ɵɵproperty("axis", ctx_r1._axis)("batchSize", 1)("changeOnEnd", true)("items", ctx_r1._months)("itemSize", ctx_r1.state.pickerSize)("maxIndex", ctx_r1._maxYearIndex)("minIndex", ctx_r1._minYearIndex)("mousewheel", ctx_r1._mousewheel)("onGestureEnd", ctx_r1._onGestureEnd)("onIndexChange", ctx_r1._onYearPageChange)("prevAnim", ctx_r1._prevAnim)("rtl", ctx_r1.s.rtl)("selectedIndex", ctx_r1._yearIndex)("snap", true)("time", 200);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", yearView_r20.visibleItems)("ngForTrackBy", ctx_r1._getKey);
  }
}
function MbscCalendarView_ng_template_11_div_2_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelement(1, "mbsc-month-view", 37);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r22 = ctx.$implicit;
    i0.ɵɵnextContext();
    const montView_r23 = i0.ɵɵreference(2);
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-calendar-picker-slide mbsc-calendar-slide" + ctx_r1._theme + ctx_r1._rtl);
    i0.ɵɵproperty("ngStyle", ctx_r1._getPageStyle(item_r22.key, montView_r23._offset, 1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("activeDate", ctx_r1._activeMonth)("dataTimezone", ctx_r1.dataTimezone)("dayNames", ctx_r1.s.dayNames)("dayNamesShort", ctx_r1.s.dayNamesMin)("displayTimezone", ctx_r1.displayTimezone)("firstDay", ctx_r1.s.firstDay)("firstPageDay", ctx_r1._getPageMonth(item_r22.key))("getDate", ctx_r1.s.getDate)("getDay", ctx_r1.s.getDay)("getMonth", ctx_r1.s.getMonth)("getYear", ctx_r1.s.getYear)("isActive", item_r22.key >= ctx_r1._monthIndex && item_r22.key < ctx_r1._monthIndex + 1)("max", ctx_r1._maxDate)("min", ctx_r1._minDate)("monthNames", ctx_r1.s.monthNames)("monthNamesShort", ctx_r1.s.monthNamesShort)("onDayClick", ctx_r1._onNavDayClick)("rtl", ctx_r1.s.rtl)("selectedDates", ctx_r1.s.selectedDates)("showOuter", true)("showWeekDays", !ctx_r1._showDaysTop)("theme", ctx_r1.s.theme)("timezonePlugin", ctx_r1.timezonePlugin)("todayText", ctx_r1.s.todayText);
  }
}
function MbscCalendarView_ng_template_11_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵlistener("animationend", function MbscCalendarView_ng_template_11_div_2_Template_div_animationend_0_listener() {
      i0.ɵɵrestoreView(_r21);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1._onViewAnimationEnd());
    });
    i0.ɵɵelementStart(1, "mbsc-scrollview-base", 34, 8);
    i0.ɵɵtemplate(3, MbscCalendarView_ng_template_11_div_2_div_3_Template, 2, 27, "div", 26);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const montView_r23 = i0.ɵɵreference(2);
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r1._getPickerClass(ctx_r1.MONTH_VIEW));
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-calendar-scroll-wrapper" + ctx_r1._theme);
    i0.ɵɵproperty("axis", ctx_r1._axis)("batchSize", 1)("changeOnEnd", true)("items", ctx_r1._months)("itemSize", ctx_r1.state.pickerSize)("maxIndex", ctx_r1._maxMonthIndex)("minIndex", ctx_r1._minMonthIndex)("mousewheel", ctx_r1._mousewheel)("onGestureEnd", ctx_r1._onGestureEnd)("onIndexChange", ctx_r1._onMonthPageChange)("prevAnim", ctx_r1._prevAnim)("rtl", ctx_r1.s.rtl)("selectedIndex", ctx_r1._monthIndex)("snap", true)("time", 200);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", montView_r23.visibleItems)("ngForTrackBy", ctx_r1._getKey);
  }
}
function MbscCalendarView_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscCalendarView_ng_template_11_div_0_Template, 4, 21, "div", 18)(1, MbscCalendarView_ng_template_11_div_1_Template, 4, 21, "div", 18)(2, MbscCalendarView_ng_template_11_div_2_Template, 4, 21, "div", 18);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r1.state.view === ctx_r1.MULTI_YEAR_VIEW || ctx_r1.state.viewClosing === ctx_r1.MULTI_YEAR_VIEW || ctx_r1.selectView === ctx_r1.MULTI_YEAR_VIEW);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.state.view === ctx_r1.YEAR_VIEW || ctx_r1.state.viewClosing === ctx_r1.YEAR_VIEW || ctx_r1.selectView === ctx_r1.YEAR_VIEW);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._hasPicker && (ctx_r1.state.view === ctx_r1.MONTH_VIEW || ctx_r1.state.viewClosing === ctx_r1.MONTH_VIEW));
  }
}
const _c27 = ["cal"];
function MbscWheelItem_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0._checkmarkClass);
  }
}
function MbscWheelItem_div_1_ng_template_1_Template(rf, ctx) {}
function MbscWheelItem_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MbscWheelItem_div_1_ng_template_1_Template, 0, 0, "ng-template", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.itemTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c14, ctx_r0.data));
  }
}
function MbscWheelItem_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.text);
  }
}
function MbscWheel_mbsc_wheel_item_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mbsc-wheel-item", 4);
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    const scrollview_r3 = i0.ɵɵreference(1);
    i0.ɵɵproperty("active", ctx_r1._isActive(item_r1, ctx_r1._getText(item_r1.data), false))("angle3d", ctx_r1._angle3d)("data", item_r1.data)("disabled", ctx_r1._isDisabled(item_r1.data))("height", ctx_r1.itemHeight)("is3d", false)("isGroup", item_r1.data && item_r1.data.isGroup)("index", item_r1.key)("itemTemplate", ctx_r1.itemTemplate)("multiple", ctx_r1.multiple)("offset", scrollview_r3._offset)("checkmark", ctx_r1.wheel.checkmark)("rows", ctx_r1.rows)("rtl", ctx_r1.rtl)("scroll3d", ctx_r1.scroll3d)("selected", ctx_r1._isSelected(item_r1))("text", ctx_r1._getText(item_r1.data))("theme", ctx_r1.theme)("onClick", ctx_r1._onItemClick);
  }
}
function MbscWheel_mbsc_wheel_item_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mbsc-wheel-item", 4);
  }
  if (rf & 2) {
    const item_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    const scrollview_r3 = i0.ɵɵreference(1);
    i0.ɵɵproperty("active", ctx_r1._isActive(item_r4, ctx_r1._getText(item_r4.data), true))("angle3d", ctx_r1._angle3d)("data", item_r4.data)("disabled", ctx_r1._isDisabled(item_r4.data))("height", ctx_r1.itemHeight)("is3d", true)("isGroup", item_r4.data && item_r4.data.isGroup)("index", item_r4.key)("itemTemplate", ctx_r1.itemTemplate)("multiple", ctx_r1.multiple)("offset", scrollview_r3._offset)("checkmark", ctx_r1.wheel.checkmark)("rows", ctx_r1.rows)("rtl", ctx_r1.rtl)("scroll3d", ctx_r1.scroll3d)("selected", ctx_r1._isSelected(item_r4))("text", ctx_r1._getText(item_r4.data))("theme", ctx_r1.theme)("onClick", ctx_r1._onItemClick);
  }
}
const _c28 = a0 => ({
  data: a0
});
function MbscScroller_mbsc_input_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mbsc-input", 5, 1);
    i0.ɵɵprojection(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ariaExpanded", !!ctx_r1._isOpen)("ariaHaspopup", "dialog")("ariaLabel", ctx_r1.ariaLabel)("dropdown", ctx_r1.dropdown)("disabled", ctx_r1.disabled)("endIcon", ctx_r1.endIcon)("endIconSrc", ctx_r1.endIconSrc)("endIconSvg", ctx_r1.endIconSvg)("error", ctx_r1.error)("errorMessage", ctx_r1.errorMessage)("inputStyle", ctx_r1.s.inputStyle)("label", ctx_r1.label)("labelStyle", ctx_r1.s.labelStyle)("name", ctx_r1.name)("placeholder", ctx_r1.placeholder)("pickerMap", ctx_r1.s.valueMap)("pickerValue", ctx_r1._value)("role", "combobox")("rtl", ctx_r1.s.rtl)("startIcon", ctx_r1.startIcon)("startIconSrc", ctx_r1.startIconSrc)("startIconSvg", ctx_r1.startIconSvg)("tags", ctx_r1.s.tagInput === undefined ? ctx_r1.s.selectMultiple : ctx_r1.s.tagInput)("theme", ctx_r1.s.theme)("themeVariant", ctx_r1.s.themeVariant)("value", ctx_r1._value != null && ctx_r1._valueText || "");
  }
}
function MbscScroller_ng_container_3_ng_template_1_Template(rf, ctx) {}
function MbscScroller_ng_container_3_ng_template_3_Template(rf, ctx) {}
function MbscScroller_ng_container_3_div_4_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap("mbsc-scroller-wheel-line" + ctx_r1._theme);
    i0.ɵɵproperty("ngStyle", ctx_r1._lineStyle);
  }
}
function MbscScroller_ng_container_3_div_4_mbsc_wheel_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mbsc-wheel", 11);
  }
  if (rf & 2) {
    const wheel_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("activeIndex", ctx_r1._activeIndexes[wheel_r3._key])("disabled", ctx_r1._disabled && ctx_r1._disabled[wheel_r3._key])("display", ctx_r1._displayStyle)("itemHeight", ctx_r1.s.itemHeight)("onActiveChange", ctx_r1._onActiveChange)("onIndexChange", ctx_r1._onWheelIndexChange)("onSet", ctx_r1._onSet)("maxIndex", wheel_r3.max)("maxWheelWidth", ctx_r1.s.maxWheelWidth)("minIndex", wheel_r3.min)("minWheelWidth", ctx_r1.s.minWheelWidth)("multiple", wheel_r3.multiple)("rows", ctx_r1._rows)("scroll3d", ctx_r1._scroll3d)("selectedIndex", ctx_r1._indexes[wheel_r3._key])("selectedValues", ctx_r1._tempValueRep[wheel_r3._key])("selectOnScroll", ctx_r1.s.selectOnScroll)("itemTemplate", ctx_r1.s.itemTemplate)("theme", ctx_r1.s.theme)("rtl", ctx_r1.s.rtl)("wheel", wheel_r3)("wheelWidth", ctx_r1.s.wheelWidth)("touchUi", ctx_r1.s.touchUi);
  }
}
function MbscScroller_ng_container_3_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MbscScroller_ng_container_3_div_4_div_1_Template, 1, 3, "div", 8);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵelement(3, "div", 9);
    i0.ɵɵtemplate(4, MbscScroller_ng_container_3_div_4_mbsc_wheel_4_Template, 1, 23, "mbsc-wheel", 10);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const wheelGroup_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-scroller-wheel-group-cont" + (ctx_r1.s.scroll3d ? " mbsc-scroller-wheel-group-cont-3d" : "") + ctx_r1._theme);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.s.selectOnScroll);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-flex mbsc-scroller-wheel-group" + (ctx_r1.s.scroll3d ? " mbsc-scroller-wheel-group-3d" : "") + ctx_r1._theme);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-scroller-wheel-overlay mbsc-scroller-wheel-overlay-" + ctx_r1._displayStyle + ctx_r1._theme);
    i0.ɵɵproperty("ngStyle", ctx_r1._overlayStyle);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", wheelGroup_r4);
  }
}
function MbscScroller_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscScroller_ng_container_3_ng_template_1_Template, 0, 0, "ng-template", 6);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵtemplate(3, MbscScroller_ng_container_3_ng_template_3_Template, 0, 0, "ng-template", 6)(4, MbscScroller_ng_container_3_div_4_Template, 5, 9, "div", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.preContentTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(7, _c28, ctx_r1.preContentData));
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-scroller mbsc-scroller-" + ctx_r1._displayStyle + ctx_r1._theme + ctx_r1._rtl + (ctx_r1._touchUi ? " mbsc-scroller-touch" : " mbsc-scroller-pointer ") + (ctx_r1.s.display === "inline" ? " mbsc-font " : " ") + ctx_r1._className);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.inContentTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(9, _c28, ctx_r1.preContentData));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1._wheels);
  }
}
const _c29 = ["scroller"];
function MbscTimegrid_div_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "mbsc-timebox", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const v_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-timegrid-cell" + (ctx_r1._isDisabled(v_r1.value) ? " mbsc-disabled" : ""));
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1._isDisabled(v_r1.value))("selected", ctx_r1._value === v_r1.value)("timeSlot", v_r1)("theme", ctx_r1._theme)("onClick", ctx_r1._setTime)("onKeyDown", ctx_r1._onKeyDown);
  }
}
function MbscTimegrid_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, MbscTimegrid_div_0_div_1_Template, 2, 8, "div", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const arr_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", arr_r3)("ngForTrackBy", ctx_r1._getKey);
  }
}
const _c30 = ["box"];
const _c31 = ["ctrlVar"];
function MbscDatepicker_mbsc_input_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mbsc-input", 7, 1);
    i0.ɵɵprojection(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ariaExpanded", !!ctx_r1._isOpen)("ariaHaspopup", "dialog")("ariaLabel", ctx_r1.ariaLabel)("dropdown", ctx_r1.dropdown)("disabled", ctx_r1.disabled)("endIcon", ctx_r1.endIcon)("endIconSrc", ctx_r1.endIconSrc)("endIconSvg", ctx_r1.endIconSvg)("error", ctx_r1.error)("errorMessage", ctx_r1.errorMessage)("inputStyle", ctx_r1.s.inputStyle)("label", ctx_r1.label)("labelStyle", ctx_r1.s.labelStyle)("name", ctx_r1.name)("placeholder", ctx_r1.placeholder)("pickerMap", ctx_r1.s.valueMap)("pickerValue", ctx_r1._value)("role", "combobox")("rtl", ctx_r1.s.rtl)("startIcon", ctx_r1.startIcon)("startIconSrc", ctx_r1.startIconSrc)("startIconSvg", ctx_r1.startIconSvg)("tags", ctx_r1.s.tagInput === undefined ? ctx_r1.s.selectMultiple : ctx_r1.s.tagInput)("theme", ctx_r1.s.theme)("themeVariant", ctx_r1.s.themeVariant)("value", ctx_r1._value != null && ctx_r1._valueText || "");
  }
}
function MbscDatepicker_ng_container_3_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-picker-header" + ctx_r1._theme + ctx_r1._hb);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1._headerText, " ");
  }
}
function MbscDatepicker_ng_container_3_mbsc_segmented_group_3_mbsc_segmented_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mbsc-segmented", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const control_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("rtl", ctx_r1.s.rtl)("theme", ctx_r1.s.theme)("themeVariant", ctx_r1.s.themeVariant)("value", control_r4.name);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", control_r4.title, " ");
  }
}
function MbscDatepicker_ng_container_3_mbsc_segmented_group_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mbsc-segmented-group", 11);
    i0.ɵɵtwoWayListener("ngModelChange", function MbscDatepicker_ng_container_3_mbsc_segmented_group_3_Template_mbsc_segmented_group_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1._activeTab, $event) || (ctx_r1._activeTab = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("change", function MbscDatepicker_ng_container_3_mbsc_segmented_group_3_Template_mbsc_segmented_group_change_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1._changeActiveTab($event));
    });
    i0.ɵɵtemplate(1, MbscDatepicker_ng_container_3_mbsc_segmented_group_3_mbsc_segmented_1_Template, 2, 5, "mbsc-segmented", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("rtl", ctx_r1.s.rtl)("theme", ctx_r1.s.theme)("themeVariant", ctx_r1.s.themeVariant);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1._activeTab);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1._controls);
  }
}
function MbscDatepicker_ng_container_3_div_4_mbsc_icon_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mbsc-icon", 17);
    i0.ɵɵlistener("click", function MbscDatepicker_ng_container_3_div_4_mbsc_icon_7_Template_mbsc_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1._clearStart());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap("mbsc-range-label-clear" + ctx_r1._rtl);
    i0.ɵɵproperty("svg", ctx_r1.s.clearIcon)("theme", ctx_r1.s.theme);
  }
}
function MbscDatepicker_ng_container_3_div_4_mbsc_icon_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mbsc-icon", 17);
    i0.ɵɵlistener("click", function MbscDatepicker_ng_container_3_div_4_mbsc_icon_13_Template_mbsc_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1._clearEnd());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap("mbsc-range-label-clear" + ctx_r1._rtl);
    i0.ɵɵproperty("svg", ctx_r1.s.clearIcon)("theme", ctx_r1.s.theme);
  }
}
function MbscDatepicker_ng_container_3_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "mbsc-segmented-group", 11);
    i0.ɵɵtwoWayListener("ngModelChange", function MbscDatepicker_ng_container_3_div_4_Template_mbsc_segmented_group_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1._activeSelect, $event) || (ctx_r1._activeSelect = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("change", function MbscDatepicker_ng_container_3_div_4_Template_mbsc_segmented_group_change_1_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1._changeActiveSelect($event));
    });
    i0.ɵɵelementStart(2, "mbsc-segmented", 14)(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, MbscDatepicker_ng_container_3_div_4_mbsc_icon_7_Template, 1, 4, "mbsc-icon", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "mbsc-segmented", 16)(9, "div");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div");
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, MbscDatepicker_ng_container_3_div_4_mbsc_icon_13_Template, 1, 4, "mbsc-icon", 15);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-range-control-wrapper" + ctx_r1._theme);
    i0.ɵɵadvance();
    i0.ɵɵproperty("rtl", ctx_r1.s.rtl)("theme", ctx_r1.s.theme)("themeVariant", ctx_r1.s.themeVariant);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1._activeSelect);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-range-start" + (ctx_r1._tempStartText ? " mbsc-range-value-nonempty" : ""));
    i0.ɵɵproperty("rtl", ctx_r1.s.rtl)("theme", ctx_r1.s.theme)("themeVariant", ctx_r1.s.themeVariant);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-range-control-label" + ctx_r1._theme + ctx_r1._rtl + (ctx_r1._activeSelect === "start" ? " active" : ""));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.s.rangeStartLabel);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-range-control-value" + ctx_r1._theme + ctx_r1._rtl + (ctx_r1._activeSelect === "start" ? " active" : "") + (!ctx_r1._tempStartText ? " mbsc-range-control-text-empty" : ""));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1._tempStartText || ctx_r1.s.rangeStartHelp);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._activeSelect === "start" && ctx_r1._tempStartText);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-range-end" + (ctx_r1._tempEndText ? " mbsc-range-value-nonempty" : ""));
    i0.ɵɵproperty("rtl", ctx_r1.s.rtl)("theme", ctx_r1.s.theme)("themeVariant", ctx_r1.s.themeVariant);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-range-control-label" + ctx_r1._theme + ctx_r1._rtl + (ctx_r1._activeSelect === "end" ? " active" : ""));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.s.rangeEndLabel);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-range-control-value" + ctx_r1._theme + ctx_r1._rtl + (ctx_r1._activeSelect === "end" ? " active" : "") + (!ctx_r1._tempEndText ? " mbsc-range-control-text-empty" : ""));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1._tempEndText || ctx_r1.s.rangeEndHelp);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._activeSelect === "end" && ctx_r1._tempEndText);
  }
}
function MbscDatepicker_ng_container_3_div_7_mbsc_calendar_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mbsc-calendar", 19, 3);
  }
  if (rf & 2) {
    const control_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("options", control_r8.options);
  }
}
function MbscDatepicker_ng_container_3_div_7_mbsc_datetime_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mbsc-datetime", 19, 3);
  }
  if (rf & 2) {
    const control_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("options", control_r8.options);
  }
}
function MbscDatepicker_ng_container_3_div_7_mbsc_date_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mbsc-date", 19, 3);
  }
  if (rf & 2) {
    const control_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("options", control_r8.options);
  }
}
function MbscDatepicker_ng_container_3_div_7_mbsc_time_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mbsc-time", 19, 3);
  }
  if (rf & 2) {
    const control_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("options", control_r8.options);
  }
}
function MbscDatepicker_ng_container_3_div_7_mbsc_timegrid_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mbsc-timegrid", 19, 3);
  }
  if (rf & 2) {
    const control_r8 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("options", control_r8.options);
  }
}
function MbscDatepicker_ng_container_3_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MbscDatepicker_ng_container_3_div_7_mbsc_calendar_1_Template, 2, 1, "mbsc-calendar", 18)(2, MbscDatepicker_ng_container_3_div_7_mbsc_datetime_2_Template, 2, 1, "mbsc-datetime", 18)(3, MbscDatepicker_ng_container_3_div_7_mbsc_date_3_Template, 2, 1, "mbsc-date", 18)(4, MbscDatepicker_ng_container_3_div_7_mbsc_time_4_Template, 2, 1, "mbsc-time", 18)(5, MbscDatepicker_ng_container_3_div_7_mbsc_timegrid_5_Template, 2, 1, "mbsc-timegrid", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const control_r8 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-flex mbsc-datepicker-tab mbsc-datepicker-tab-" + control_r8.name + ctx_r1._theme + (ctx_r1._renderTabs && control_r8.name === ctx_r1._activeTab || !ctx_r1._renderTabs ? " mbsc-datepicker-tab-active" : "") + (ctx_r1._renderTabs && control_r8.name === "time" ? " mbsc-datepicker-time-modal" : "") + (ctx_r1._renderTabs || ctx_r1._controls.length === 1 ? " mbsc-datepicker-tab-expand mbsc-flex-1-1" : ""));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", control_r8.name === "calendar");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", control_r8.name === "datetime");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", control_r8.name === "date");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", control_r8.name === "time");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", control_r8.name === "timegrid");
  }
}
function MbscDatepicker_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtemplate(2, MbscDatepicker_ng_container_3_div_2_Template, 2, 3, "div", 8)(3, MbscDatepicker_ng_container_3_mbsc_segmented_group_3_Template, 2, 5, "mbsc-segmented-group", 9)(4, MbscDatepicker_ng_container_3_div_4_Template, 14, 30, "div", 8);
    i0.ɵɵelementStart(5, "div", null, 2);
    i0.ɵɵtemplate(7, MbscDatepicker_ng_container_3_div_7_Template, 6, 7, "div", 10);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-datepicker mbsc-flex-col mbsc-datepicker-" + ctx_r1.s.display + ctx_r1._theme + (ctx_r1.s.display === "inline" ? " " + ctx_r1._className + ctx_r1._hb : "") + ctx_r1._controlsClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._headerText && ctx_r1.s.display === "inline");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._renderTabs);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._renderControls);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-datepicker-tab-wrapper mbsc-flex mbsc-flex-1-1 " + ctx_r1._theme);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1._controls);
  }
}
function MbscSelect_ng_template_2_mbsc_icon_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mbsc-icon", 9);
    i0.ɵɵlistener("click", function MbscSelect_ng_template_2_mbsc_icon_3_Template_mbsc_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const inst_r3 = i0.ɵɵnextContext().data;
      return i0.ɵɵresetView(inst_r3._onFilterClear());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const inst_r3 = i0.ɵɵnextContext().data;
    i0.ɵɵclassMap("mbsc-select-filter-clear" + inst_r3._rtl);
    i0.ɵɵproperty("svg", inst_r3.s.clearIcon)("theme", inst_r3.s.theme);
  }
}
function MbscSelect_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "mbsc-input", 7, 4);
    i0.ɵɵlistener("input", function MbscSelect_ng_template_2_Template_mbsc_input_input_1_listener($event) {
      const inst_r3 = i0.ɵɵrestoreView(_r2).data;
      return i0.ɵɵresetView(inst_r3._onFilterChange($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, MbscSelect_ng_template_2_mbsc_icon_3_Template, 1, 4, "mbsc-icon", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const inst_r3 = ctx.data;
    i0.ɵɵclassMap("mbsc-select-filter-cont" + inst_r3._theme + inst_r3._rtl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("placeholder", inst_r3.s.filterPlaceholderText)("rtl", inst_r3.s.rtl)("theme", inst_r3.s.theme)("themeVariant", inst_r3.s.themeVariant);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", inst_r3._filterText);
  }
}
function MbscSelect_ng_template_4_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const inst_r5 = i0.ɵɵnextContext().data;
    i0.ɵɵclassMap("mbsc-select-empty-text mbsc-flex" + inst_r5._theme);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(inst_r5.s.filterEmptyText);
  }
}
function MbscSelect_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscSelect_ng_template_4_div_0_Template, 2, 3, "div", 10);
  }
  if (rf & 2) {
    const inst_r5 = ctx.data;
    i0.ɵɵproperty("ngIf", inst_r5._noResults);
  }
}
function MbscScheduleEvent_div_0_1_ng_template_0_Template(rf, ctx) {}
function MbscScheduleEvent_div_0_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscScheduleEvent_div_0_1_ng_template_0_Template, 0, 0, "ng-template", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.bufferBeforeTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c14, ctx_r0.event));
  }
}
function MbscScheduleEvent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, MbscScheduleEvent_div_0_1_Template, 1, 4, null, 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-" + ctx_r0._host + "-event-buffer " + "mbsc-" + ctx_r0._host + "-event-buffer-before" + (ctx_r0.bufferBeforeTemplate ? "" : " mbsc-schedule-event-buffer-background") + ctx_r0._theme + ctx_r0._rtl);
    i0.ɵɵproperty("ngStyle", ctx_r0._bufferStyleStart);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.bufferBeforeTemplate);
  }
}
function MbscScheduleEvent_div_1_1_ng_template_0_Template(rf, ctx) {}
function MbscScheduleEvent_div_1_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscScheduleEvent_div_1_1_ng_template_0_Template, 0, 0, "ng-template", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.bufferAfterTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c14, ctx_r0.event));
  }
}
function MbscScheduleEvent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, MbscScheduleEvent_div_1_1_Template, 1, 4, null, 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-" + ctx_r0._host + "-event-buffer " + "mbsc-" + ctx_r0._host + "-event-buffer-after" + (ctx_r0.isTimeline ? " mbsc-timeline-event-buffer" : "") + (ctx_r0.bufferAfterTemplate ? "" : " mbsc-schedule-event-buffer-background") + ctx_r0._theme + ctx_r0._rtl);
    i0.ɵɵproperty("ngStyle", ctx_r0._bufferStyleEnd);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.bufferAfterTemplate);
  }
}
function MbscScheduleEvent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-schedule-event-resize mbsc-schedule-event-resize-start" + (ctx_r0.isDrag ? " mbsc-schedule-event-resize-start-touch" : "") + (ctx_r0.isTimeline ? " mbsc-timeline-event-resize" : "") + ctx_r0._rtl);
  }
}
function MbscScheduleEvent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-schedule-event-resize mbsc-schedule-event-resize-end" + (ctx_r0.isDrag ? " mbsc-schedule-event-resize-start-touch" : "") + (ctx_r0.isTimeline ? " mbsc-timeline-event-resize" : "") + ctx_r0._rtl);
  }
}
function MbscScheduleEvent_ng_template_4_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-schedule-event-bar" + ctx_r0._theme + ctx_r0._rtl);
  }
}
function MbscScheduleEvent_ng_template_4_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", ctx_r0._html, i0.ɵɵsanitizeHtml);
  }
}
function MbscScheduleEvent_ng_template_4_5_ng_template_0_Template(rf, ctx) {}
function MbscScheduleEvent_ng_template_4_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscScheduleEvent_ng_template_4_5_ng_template_0_Template, 0, 0, "ng-template", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.contentTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c14, ctx_r0.event));
  }
}
function MbscScheduleEvent_ng_template_4_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-schedule-event-range" + ctx_r0._theme);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0._rangeText, " ");
  }
}
function MbscScheduleEvent_ng_template_4_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.event.ariaLabel);
  }
}
function MbscScheduleEvent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscScheduleEvent_ng_template_4_div_0_Template, 1, 2, "div", 2);
    i0.ɵɵelement(1, "div");
    i0.ɵɵelementStart(2, "div", 6)(3, "div");
    i0.ɵɵtemplate(4, MbscScheduleEvent_ng_template_4_div_4_Template, 1, 1, "div", 7)(5, MbscScheduleEvent_ng_template_4_5_Template, 1, 4, null, 5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, MbscScheduleEvent_ng_template_4_div_6_Template, 2, 3, "div", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, MbscScheduleEvent_ng_template_4_div_7_Template, 2, 1, "div", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r0._isAllDay && !ctx_r0._isMore && !ctx_r0.isTimeline);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-schedule-event-background" + (ctx_r0.isTimeline ? " mbsc-timeline-event-background" : "") + (ctx_r0._isAllDay ? " mbsc-schedule-event-all-day-background" : "") + ctx_r0._theme);
    i0.ɵɵstyleProp("background", ctx_r0.event.style.background);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-schedule-event-inner" + ctx_r0._theme + (ctx_r0._isAllDay ? " mbsc-schedule-event-all-day-inner" : "") + (ctx_r0.event.cssClass || ""));
    i0.ɵɵstyleProp("color", ctx_r0.event.style.color);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-schedule-event-title" + (ctx_r0._isAllDay ? " mbsc-schedule-event-all-day-title" : "") + ctx_r0._theme);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.contentTemplate || ctx_r0._isMore);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.contentTemplate && !ctx_r0._isMore);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0._isAllDay && !ctx_r0._isMore);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.event.ariaLabel);
  }
}
function MbscScheduleEvent_ng_template_6_Template(rf, ctx) {}
function MbscWeekDay_0_ng_template_0_Template(rf, ctx) {}
function MbscWeekDay_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscWeekDay_0_ng_template_0_Template, 0, 0, "ng-template", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.dayTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c14, ctx_r0._data));
  }
}
function MbscWeekDay_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-schedule-header-dayname" + ctx_r0._theme + (ctx_r0.s.selected ? " mbsc-selected" : "") + (ctx_r0.s.isToday ? " mbsc-schedule-header-dayname-curr" : ""));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.dayNames[ctx_r0._day], " ");
  }
}
function MbscWeekDay_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-schedule-header-day" + ctx_r0._theme + ctx_r0._rtl + (ctx_r0.s.selected ? " mbsc-selected" : "") + (ctx_r0.s.isToday ? " mbsc-schedule-header-day-today" : "") + (ctx_r0.state.hasHover ? " mbsc-hover" : ""));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.day, " ");
  }
}
function MbscWeekDay_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("role", ctx_r0.s.selectable ? "button" : null)("aria-pressed", ctx_r0.s.selectable ? ctx_r0.s.selected ? "true" : "false" : null);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.label, " ");
  }
}
function MbscWeekDay_4_ng_template_0_Template(rf, ctx) {}
function MbscWeekDay_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscWeekDay_4_ng_template_0_Template, 0, 0, "ng-template", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.dayContentTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c14, ctx_r0._data));
  }
}
function MbscTimeIndicator_ng_container_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r1 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-schedule-time-indicator-tz" + ctx_r1._theme + ctx_r1._rtl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1._times[i_r1], " ");
  }
}
function MbscTimeIndicator_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscTimeIndicator_ng_container_2_div_1_Template, 2, 3, "div", 3);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.timezones)("ngForTrackBy", ctx_r1._getKey);
  }
}
function MbscTimeIndicator_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1._time, " ");
  }
}
function MbscTimeIndicator_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 4);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-schedule-time-indicator-day" + ctx_r1._theme + ctx_r1._rtl);
    i0.ɵɵproperty("ngStyle", ctx_r1._dayPos);
  }
}
const _c32 = ["scrollCont"];
const _c33 = ["gridCont"];
const _c34 = ["headerCont"];
const _c35 = ["allDayCont"];
const _c36 = ["timeCont"];
const _c37 = ["cursorTimeCont"];
const _c38 = (a0, a1, a2, a3, a4) => ({
  allDay: true,
  dateKey: a0,
  dragData: a1,
  dragKey: a2,
  events: a3,
  resource: a4
});
const _c39 = (a0, a1, a2, a3, a4) => ({
  allDay: false,
  dateKey: a0,
  dragData: a1,
  dragKey: a2,
  events: a3,
  resource: a4
});
const _c40 = () => ({});
const _c41 = (a0, a1, a2) => ({
  dateKey: a0,
  resource: a1,
  timestamp: a2
});
const _c42 = a0 => ({
  tz: a0
});
function MbscScheduler_ng_template_0_ng_container_0_ng_container_1_mbsc_schedule_event_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mbsc-schedule-event", 35);
    i0.ɵɵlistener("onClick", function MbscScheduler_ng_template_0_ng_container_0_ng_container_1_mbsc_schedule_event_1_Template_mbsc_schedule_event_onClick_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2._onEventClick($event));
    })("onDoubleClick", function MbscScheduler_ng_template_0_ng_container_0_ng_container_1_mbsc_schedule_event_1_Template_mbsc_schedule_event_onDoubleClick_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.onEventDoubleClick($event));
    })("onRightClick", function MbscScheduler_ng_template_0_ng_container_0_ng_container_1_mbsc_schedule_event_1_Template_mbsc_schedule_event_onRightClick_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.onEventRightClick($event));
    })("onHoverIn", function MbscScheduler_ng_template_0_ng_container_0_ng_container_1_mbsc_schedule_event_1_Template_mbsc_schedule_event_onHoverIn_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.onEventHoverIn($event));
    })("onHoverOut", function MbscScheduler_ng_template_0_ng_container_0_ng_container_1_mbsc_schedule_event_1_Template_mbsc_schedule_event_onHoverOut_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.onEventHoverOut($event));
    })("onDelete", function MbscScheduler_ng_template_0_ng_container_0_ng_container_1_mbsc_schedule_event_1_Template_mbsc_schedule_event_onDelete_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.onEventDelete($event));
    })("onDragStart", function MbscScheduler_ng_template_0_ng_container_0_ng_container_1_mbsc_schedule_event_1_Template_mbsc_schedule_event_onDragStart_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2._onEventDragStart($event));
    })("onDragMove", function MbscScheduler_ng_template_0_ng_container_0_ng_container_1_mbsc_schedule_event_1_Template_mbsc_schedule_event_onDragMove_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2._onEventDragMove($event));
    })("onDragEnd", function MbscScheduler_ng_template_0_ng_container_0_ng_container_1_mbsc_schedule_event_1_Template_mbsc_schedule_event_onDragEnd_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2._onEventDragEnd($event));
    })("onDragModeOn", function MbscScheduler_ng_template_0_ng_container_0_ng_container_1_mbsc_schedule_event_1_Template_mbsc_schedule_event_onDragModeOn_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2._onEventDragModeOn($event));
    })("onDragModeOff", function MbscScheduler_ng_template_0_ng_container_0_ng_container_1_mbsc_schedule_event_1_Template_mbsc_schedule_event_onDragModeOff_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2._onEventDragModeOff($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const event_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r4 = i0.ɵɵnextContext(2);
    const dragData_r6 = ctx_r4.dragData;
    const resource_r7 = ctx_r4.resource;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("bufferAfterTemplate", ctx_r2.bufferAfterTemplate)("bufferBeforeTemplate", ctx_r2.bufferBeforeTemplate)("contentTemplate", ctx_r2.eventContentTemplate)("displayTimezone", ctx_r2.displayTimezone)("drag", ctx_r2.dragToMove || ctx_r2.externalDrag)("event", event_r4)("endDay", ctx_r2.endDay)("exclusiveEndDates", ctx_r2.exclusiveEndDates)("gridEndTime", ctx_r2._endTime)("gridStartTime", ctx_r2._startTime)("inactive", dragData_r6 && dragData_r6.draggedEvent && dragData_r6.draggedEvent.id === event_r4.id)("lastDay", ctx_r2._lastDay)("resize", ctx_r2._computeEventResize(event_r4.original.resize, ctx_r2.dragToResize, ctx_r2._resourcesMap[resource_r7].eventResize))("resource", resource_r7)("rtl", ctx_r2.rtl)("singleDay", !ctx_r2._groupByResource)("selected", !!(ctx_r2.selectedEventsMap[event_r4.uid] || ctx_r2.selectedEventsMap[event_r4.id]))("slot", ctx_r2._defId)("startDay", ctx_r2.startDay)("theme", ctx_r2.theme)("template", ctx_r2.eventTemplate)("timezonePlugin", ctx_r2.timezonePlugin);
  }
}
function MbscScheduler_ng_template_0_ng_container_0_ng_container_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵelement(1, "div");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-schedule-event-all-day-inner" + ctx_r2._theme);
  }
}
function MbscScheduler_ng_template_0_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscScheduler_ng_template_0_ng_container_0_ng_container_1_mbsc_schedule_event_1_Template, 1, 22, "mbsc-schedule-event", 33)(2, MbscScheduler_ng_template_0_ng_container_0_ng_container_1_div_2_Template, 2, 2, "div", 34);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const event_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", event_r4.showText && event_r4.position);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !event_r4.showText);
  }
}
function MbscScheduler_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscScheduler_ng_template_0_ng_container_0_ng_container_1_Template, 3, 2, "ng-container", 32);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const events_r8 = i0.ɵɵnextContext().events;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", events_r8)("ngForTrackBy", ctx_r2._getEventKey);
  }
}
function MbscScheduler_ng_template_0_mbsc_schedule_event_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mbsc-schedule-event", 37);
    i0.ɵɵlistener("onDragStart", function MbscScheduler_ng_template_0_mbsc_schedule_event_1_Template_mbsc_schedule_event_onDragStart_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2._onEventDragStart($event));
    })("onDragMove", function MbscScheduler_ng_template_0_mbsc_schedule_event_1_Template_mbsc_schedule_event_onDragMove_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2._onEventDragMove($event));
    })("onDragEnd", function MbscScheduler_ng_template_0_mbsc_schedule_event_1_Template_mbsc_schedule_event_onDragEnd_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2._onEventDragEnd($event));
    })("onDragModeOff", function MbscScheduler_ng_template_0_mbsc_schedule_event_1_Template_mbsc_schedule_event_onDragModeOff_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2._onEventDragModeOff($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    const dragData_r6 = ctx_r4.dragData;
    const dragKey_r10 = ctx_r4.dragKey;
    const resource_r7 = ctx_r4.resource;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("bufferAfterTemplate", ctx_r2.bufferAfterTemplate)("bufferBeforeTemplate", ctx_r2.bufferBeforeTemplate)("contentTemplate", ctx_r2.eventContentTemplate)("displayTimezone", ctx_r2.displayTimezone)("drag", ctx_r2.dragToMove || ctx_r2.externalDrag)("event", dragData_r6.originDates[dragKey_r10])("endDay", ctx_r2.endDay)("exclusiveEndDates", ctx_r2.exclusiveEndDates)("gridEndTime", ctx_r2._endTime)("gridStartTime", ctx_r2._startTime)("hidden", !!dragData_r6.draggedDates)("isDrag", true)("lastDay", ctx_r2._lastDay)("resize", ctx_r2._computeEventResize(dragData_r6.originDates[dragKey_r10].original.resize, ctx_r2.dragToResize, ctx_r2._resourcesMap[resource_r7].eventResize))("resource", resource_r7)("rtl", ctx_r2.rtl)("singleDay", !ctx_r2._groupByResource)("slot", ctx_r2._defId)("startDay", ctx_r2.startDay)("theme", ctx_r2.theme)("template", ctx_r2.eventTemplate)("timezonePlugin", ctx_r2.timezonePlugin);
  }
}
function MbscScheduler_ng_template_0_mbsc_schedule_event_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mbsc-schedule-event", 38);
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    const dragData_r6 = ctx_r4.dragData;
    const dragKey_r10 = ctx_r4.dragKey;
    const resource_r7 = ctx_r4.resource;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("bufferAfterTemplate", ctx_r2.bufferAfterTemplate)("bufferBeforeTemplate", ctx_r2.bufferBeforeTemplate)("contentTemplate", ctx_r2.eventContentTemplate)("displayTimezone", ctx_r2.displayTimezone)("drag", ctx_r2.dragToMove || ctx_r2.externalDrag)("event", dragData_r6.draggedDates[dragKey_r10])("endDay", ctx_r2.endDay)("exclusiveEndDates", ctx_r2.exclusiveEndDates)("gridEndTime", ctx_r2._endTime)("gridStartTime", ctx_r2._startTime)("isDrag", true)("lastDay", ctx_r2._lastDay)("resize", ctx_r2._computeEventResize(dragData_r6.draggedDates[dragKey_r10].original.resize, ctx_r2.dragToResize, ctx_r2._resourcesMap[resource_r7].eventResize))("resource", resource_r7)("rtl", ctx_r2.rtl)("singleDay", !ctx_r2._groupByResource)("slot", ctx_r2._defId)("startDay", ctx_r2.startDay)("theme", ctx_r2.theme)("template", ctx_r2.eventTemplate)("timezonePlugin", ctx_r2.timezonePlugin);
  }
}
function MbscScheduler_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscScheduler_ng_template_0_ng_container_0_Template, 2, 2, "ng-container", 15)(1, MbscScheduler_ng_template_0_mbsc_schedule_event_1_Template, 1, 22, "mbsc-schedule-event", 30)(2, MbscScheduler_ng_template_0_mbsc_schedule_event_2_Template, 1, 21, "mbsc-schedule-event", 31);
  }
  if (rf & 2) {
    const allDay_r11 = ctx.allDay;
    const events_r8 = ctx.events;
    const dragData_r6 = ctx.dragData;
    const dragKey_r10 = ctx.dragKey;
    i0.ɵɵproperty("ngIf", events_r8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", dragData_r6 && dragData_r6.originDates && dragData_r6.originDates[dragKey_r10] && !!dragData_r6.originDates[dragKey_r10].allDay === allDay_r11);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", dragData_r6 && dragData_r6.draggedDates && dragData_r6.draggedDates[dragKey_r10] && !!dragData_r6.draggedDates[dragKey_r10].allDay === allDay_r11);
  }
}
function MbscScheduler_ng_template_2_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 41);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    const dateKey_r13 = ctx_r11.dateKey;
    const resId_r14 = ctx_r11.resource.id;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-schedule-invalid mbsc-schedule-invalid-all-day" + ctx_r2._invalids[resId_r14][ctx_r2._defId][dateKey_r13].allDay[0].cssClass + ctx_r2._theme);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2._invalids[resId_r14][ctx_r2._defId][dateKey_r13].allDay[0].title, " ");
  }
}
function MbscScheduler_ng_template_2_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "div", 42);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    const dateKey_r13 = ctx_r11.dateKey;
    const resId_r14 = ctx_r11.resource.id;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-schedule-color mbsc-schedule-color-all-day" + ctx_r2._colors[resId_r14][ctx_r2._defId][dateKey_r13].allDay[0].cssClass + ctx_r2._theme);
    i0.ɵɵproperty("ngStyle", ctx_r2._colors[resId_r14][ctx_r2._defId][dateKey_r13].allDay[0].position);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2._colors[resId_r14][ctx_r2._defId][dateKey_r13].allDay[0].title, " ");
  }
}
function MbscScheduler_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementContainer(1, 39);
    i0.ɵɵtemplate(2, MbscScheduler_ng_template_2_div_2_Template, 3, 3, "div", 18)(3, MbscScheduler_ng_template_2_div_3_Template, 3, 4, "div", 40);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dateKey_r13 = ctx.dateKey;
    const r_r15 = ctx.resource;
    const resId_r14 = ctx.resource.id;
    const ctx_r2 = i0.ɵɵnextContext();
    const tplEvents_r16 = i0.ɵɵreference(1);
    i0.ɵɵclassMap("mbsc-schedule-all-day-item mbsc-schedule-col-width mbsc-flex-1-0 " + (r_r15.cssClass || "") + ctx_r2._theme + ctx_r2._rtl + ctx_r2._hb);
    i0.ɵɵstyleProp("background", r_r15.background);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", tplEvents_r16)("ngTemplateOutletContext", i0.ɵɵpureFunction5(8, _c38, dateKey_r13, ctx_r2.state.dragData, ctx_r2._getDragKey(resId_r14, dateKey_r13), ctx_r2._events[resId_r14][ctx_r2._defId][dateKey_r13] && ctx_r2._events[resId_r14][ctx_r2._defId][dateKey_r13].allDay, resId_r14));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2._invalids[resId_r14][ctx_r2._defId][dateKey_r13] && ctx_r2._invalids[resId_r14][ctx_r2._defId][dateKey_r13].allDay[0]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2._colors[resId_r14][ctx_r2._defId][dateKey_r13] && ctx_r2._colors[resId_r14][ctx_r2._defId][dateKey_r13].allDay[0]);
  }
}
function MbscScheduler_ng_template_4_ng_container_4_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "div", 41);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const invalid_r17 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap("mbsc-schedule-invalid" + invalid_r17.cssClass + ctx_r2._theme);
    i0.ɵɵproperty("ngStyle", invalid_r17.position);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(invalid_r17.allDay ? "" : invalid_r17.title);
  }
}
function MbscScheduler_ng_template_4_ng_container_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscScheduler_ng_template_4_ng_container_4_ng_container_1_div_1_Template, 3, 4, "div", 40);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const invalid_r17 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", invalid_r17.position);
  }
}
function MbscScheduler_ng_template_4_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscScheduler_ng_template_4_ng_container_4_ng_container_1_Template, 2, 1, "ng-container", 32);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext();
    const dateKey_r19 = ctx_r17.dateKey;
    const resId_r20 = ctx_r17.resource.id;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2._invalids[resId_r20][ctx_r2._defId][dateKey_r19].data)("ngForTrackBy", ctx_r2._getKey);
  }
}
function MbscScheduler_ng_template_4_ng_container_5_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "div", 42);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const color_r21 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap("mbsc-schedule-color" + color_r21.cssClass + ctx_r2._theme);
    i0.ɵɵproperty("ngStyle", color_r21.position);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(color_r21.title);
  }
}
function MbscScheduler_ng_template_4_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscScheduler_ng_template_4_ng_container_5_div_1_Template, 3, 4, "div", 44);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext();
    const dateKey_r19 = ctx_r17.dateKey;
    const resId_r20 = ctx_r17.resource.id;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2._colors[resId_r20][ctx_r2._defId][dateKey_r19].data)("ngForTrackBy", ctx_r2._getKey);
  }
}
function MbscScheduler_ng_template_4_div_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵlistener("click", function MbscScheduler_ng_template_4_div_6_Template_div_click_0_listener($event) {
      const v_r23 = i0.ɵɵrestoreView(_r22).$implicit;
      const ctx_r17 = i0.ɵɵnextContext();
      const resId_r20 = ctx_r17.resource.id;
      const timestamp_r24 = ctx_r17.timestamp;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onCellClick(ctx_r2._getEventArgs(timestamp_r24, v_r23, $event, resId_r20)));
    })("dblclick", function MbscScheduler_ng_template_4_div_6_Template_div_dblclick_0_listener($event) {
      const v_r23 = i0.ɵɵrestoreView(_r22).$implicit;
      const ctx_r17 = i0.ɵɵnextContext();
      const resId_r20 = ctx_r17.resource.id;
      const timestamp_r24 = ctx_r17.timestamp;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onCellDoubleClick(ctx_r2._getEventArgs(timestamp_r24, v_r23, $event, resId_r20)));
    })("contextmenu", function MbscScheduler_ng_template_4_div_6_Template_div_contextmenu_0_listener($event) {
      const v_r23 = i0.ɵɵrestoreView(_r22).$implicit;
      const ctx_r17 = i0.ɵɵnextContext();
      const resId_r20 = ctx_r17.resource.id;
      const timestamp_r24 = ctx_r17.timestamp;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onCellRightClick(ctx_r2._getEventArgs(timestamp_r24, v_r23, $event, resId_r20)));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const first_r25 = ctx.first;
    const last_r26 = ctx.last;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-schedule-item mbsc-flex-1-0" + ctx_r2._theme + ctx_r2._hb + (last_r26 ? " mbsc-schedule-item-last" : "") + (first_r25 && !last_r26 && ctx_r2._startCellStyle || last_r26 && !first_r25 && ctx_r2._endCellStyle ? " mbsc-flex-none" : ""));
    i0.ɵɵproperty("ngStyle", first_r25 && !last_r26 ? ctx_r2._startCellStyle : last_r26 && !first_r25 ? ctx_r2._endCellStyle : i0.ɵɵpureFunction0(3, _c40));
  }
}
function MbscScheduler_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div")(2, "div");
    i0.ɵɵelementContainer(3, 39);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, MbscScheduler_ng_template_4_ng_container_4_Template, 2, 2, "ng-container", 15)(5, MbscScheduler_ng_template_4_ng_container_5_Template, 2, 2, "ng-container", 15)(6, MbscScheduler_ng_template_4_div_6_Template, 1, 4, "div", 43);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const dateKey_r19 = ctx.dateKey;
    const r_r27 = ctx.resource;
    const resId_r20 = ctx.resource.id;
    const ctx_r2 = i0.ɵɵnextContext();
    const tplEvents_r16 = i0.ɵɵreference(1);
    i0.ɵɵclassMap("mbsc-flex-col mbsc-flex-1-0 mbsc-schedule-column mbsc-schedule-col-width " + (r_r27.cssClass || "") + ctx_r2._theme + ctx_r2._rtl + ctx_r2._hb);
    i0.ɵɵstyleProp("background", r_r27.background);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-flex-col mbsc-flex-1-1 mbsc-schedule-column-inner" + ctx_r2._theme + ctx_r2._rtl + ctx_r2._hb);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-schedule-events" + (ctx_r2._events[resId_r20][ctx_r2._defId][dateKey_r19] && ctx_r2._events[resId_r20][ctx_r2._defId][dateKey_r19].hasMore ? " mbsc-schedule-events-more" : "") + ctx_r2._rtl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", tplEvents_r16)("ngTemplateOutletContext", i0.ɵɵpureFunction5(14, _c39, dateKey_r19, ctx_r2.state.dragData, ctx_r2._getDragKey(resId_r20, dateKey_r19), ctx_r2._events[resId_r20][ctx_r2._defId][dateKey_r19] && ctx_r2._events[resId_r20][ctx_r2._defId][dateKey_r19].data, resId_r20));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2._invalids[resId_r20][ctx_r2._defId][dateKey_r19]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2._colors[resId_r20][ctx_r2._defId][dateKey_r19]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2._times)("ngForTrackBy", ctx_r2._getKey);
  }
}
function MbscScheduler_ng_template_6_div_0_ng_container_3_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const j_r28 = i0.ɵɵnextContext().index;
    const v_r29 = i0.ɵɵnextContext().$implicit;
    const tz_r30 = i0.ɵɵnextContext().tz;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-flex-1-1 mbsc-schedule-time" + ctx_r2._theme + ctx_r2._rtl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2._formatTime(v_r29 + (j_r28 + 1) * ctx_r2._stepLabel, tz_r30 ? tz_r30.timezone : ""), " ");
  }
}
function MbscScheduler_ng_template_6_div_0_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscScheduler_ng_template_6_div_0_ng_container_3_div_1_Template, 2, 3, "div", 18);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const j_r28 = ctx.index;
    const v_r29 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", v_r29 + (j_r28 + 1) * ctx_r2._stepLabel > ctx_r2._startTime && v_r29 + (j_r28 + 1) * ctx_r2._stepLabel < ctx_r2._endTime);
  }
}
function MbscScheduler_ng_template_6_div_0_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tz_r30 = i0.ɵɵnextContext(2).tz;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-schedule-time mbsc-schedule-time-end" + ctx_r2._theme + ctx_r2._rtl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2._formatTime(ctx_r2._endTime + 1, tz_r30 ? tz_r30.timezone : tz_r30), " ");
  }
}
function MbscScheduler_ng_template_6_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, MbscScheduler_ng_template_6_div_0_ng_container_3_Template, 2, 1, "ng-container", 32)(4, MbscScheduler_ng_template_6_div_0_div_4_Template, 2, 3, "div", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const v_r29 = ctx.$implicit;
    const first_r31 = ctx.first;
    const last_r32 = ctx.last;
    const tz_r30 = i0.ɵɵnextContext().tz;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-flex-col mbsc-flex-1-0 mbsc-schedule-time-wrapper" + ctx_r2._theme + ctx_r2._rtl + (last_r32 ? " mbsc-schedule-time-wrapper-end" : "") + (first_r31 && !last_r32 && ctx_r2._startCellStyle || last_r32 && !first_r31 && ctx_r2._endCellStyle ? " mbsc-flex-none" : ""));
    i0.ɵɵproperty("ngStyle", first_r31 && !last_r32 ? ctx_r2._startCellStyle : last_r32 && !first_r31 ? ctx_r2._endCellStyle : i0.ɵɵpureFunction0(9, _c40));
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-flex-1-1 mbsc-schedule-time" + ctx_r2._theme + ctx_r2._rtl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", first_r31 || v_r29 % ctx_r2._stepLabel === 0 ? ctx_r2._formatTime(first_r31 ? ctx_r2._startTime : v_r29, tz_r30 ? tz_r30.timezone : "") : "", " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2._timesBetween)("ngForTrackBy", ctx_r2._getKey);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", last_r32);
  }
}
function MbscScheduler_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscScheduler_ng_template_6_div_0_Template, 5, 10, "div", 44);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngForOf", ctx_r2._times)("ngForTrackBy", ctx_r2._getKey);
  }
}
function MbscScheduler_div_13_div_1_mbsc_week_day_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mbsc-week-day", 49);
  }
  if (rf & 2) {
    const dayData_r33 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("day", dayData_r33.day)("dayNames", ctx_r2._dayNames)("dayTemplate", ctx_r2.dayTemplate)("dayContentTemplate", ctx_r2.dayContentTemplate)("events", ctx_r2.eventMap[dayData_r33.dateKey])("isToday", ctx_r2._isToday(dayData_r33.timestamp))("label", dayData_r33.label)("largeNames", ctx_r2._largeDayNames)("onClick", ctx_r2.onWeekDayClick)("rtl", ctx_r2.rtl)("selectable", true)("selected", ctx_r2._selectedDay === dayData_r33.timestamp)("theme", ctx_r2.theme)("timestamp", dayData_r33.timestamp);
  }
}
function MbscScheduler_div_13_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtemplate(1, MbscScheduler_div_13_div_1_mbsc_week_day_1_Template, 1, 14, "mbsc-week-day", 48);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2._headerDays)("ngForTrackBy", ctx_r2._getDayKey);
  }
}
function MbscScheduler_div_13_div_2_ng_container_1_div_1_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const r_r34 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵtextInterpolate1(" ", r_r34.name, " ");
  }
}
function MbscScheduler_div_13_div_2_ng_container_1_div_1_ng_template_4_Template(rf, ctx) {}
function MbscScheduler_div_13_div_2_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 51);
    i0.ɵɵtemplate(2, MbscScheduler_div_13_div_2_ng_container_1_div_1_ng_template_2_Template, 1, 1, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor)(4, MbscScheduler_div_13_div_2_ng_container_1_div_1_ng_template_4_Template, 0, 0, "ng-template", 39);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const default_r35 = i0.ɵɵreference(3);
    const r_r34 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap("mbsc-schedule-resource mbsc-flex-1-0 mbsc-schedule-col-width " + (r_r34.cssClass || "") + ctx_r2._theme + ctx_r2._rtl + ctx_r2._hb);
    i0.ɵɵstyleProp("background", r_r34.background);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.resourceTemplate || default_r35)("ngTemplateOutletContext", i0.ɵɵpureFunction1(6, _c14, r_r34));
  }
}
function MbscScheduler_div_13_div_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscScheduler_div_13_div_2_ng_container_1_div_1_Template, 5, 8, "div", 50);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const r_r34 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", r_r34.name || ctx_r2.resourceTemplate);
  }
}
function MbscScheduler_div_13_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtemplate(1, MbscScheduler_div_13_div_2_ng_container_1_Template, 2, 1, "ng-container", 32);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2._resources)("ngForTrackBy", ctx_r2._getId);
  }
}
function MbscScheduler_div_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 46);
    i0.ɵɵtemplate(1, MbscScheduler_div_13_div_1_Template, 2, 2, "div", 47)(2, MbscScheduler_div_13_div_2_Template, 2, 2, "div", 47);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.showDays);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.resources);
  }
}
function MbscScheduler_ng_container_14_ng_container_1_div_1_div_1_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const r_r36 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵtextInterpolate1(" ", r_r36.name, " ");
  }
}
function MbscScheduler_ng_container_14_ng_container_1_div_1_div_1_ng_template_4_Template(rf, ctx) {}
function MbscScheduler_ng_container_14_ng_container_1_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 51);
    i0.ɵɵtemplate(2, MbscScheduler_ng_container_14_ng_container_1_div_1_div_1_ng_template_2_Template, 1, 1, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor)(4, MbscScheduler_ng_container_14_ng_container_1_div_1_div_1_ng_template_4_Template, 0, 0, "ng-template", 39);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const default_r37 = i0.ɵɵreference(3);
    const r_r36 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap("mbsc-schedule-resource " + (r_r36.cssClass || "") + ctx_r2._theme + ctx_r2._rtl + ctx_r2._hb);
    i0.ɵɵstyleProp("background", r_r36.background);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.resourceTemplate || default_r37)("ngTemplateOutletContext", i0.ɵɵpureFunction1(6, _c14, r_r36));
  }
}
function MbscScheduler_ng_container_14_ng_container_1_div_1_div_2_mbsc_week_day_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mbsc-week-day", 54);
  }
  if (rf & 2) {
    const dayData_r38 = ctx.$implicit;
    const r_r36 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap("mbsc-flex-1-0 mbsc-schedule-col-width " + (r_r36.cssClass || ""));
    i0.ɵɵproperty("background", r_r36.background)("day", dayData_r38.day)("dayNames", ctx_r2._dayNames)("dayTemplate", ctx_r2.dayTemplate)("dayContentTemplate", ctx_r2.dayContentTemplate)("events", ctx_r2.eventMap[dayData_r38.dateKey])("isToday", ctx_r2._isSingleResource && ctx_r2._isToday(dayData_r38.timestamp))("label", dayData_r38.label)("largeNames", ctx_r2._largeDayNames)("onClick", ctx_r2.onWeekDayClick)("resource", r_r36.id)("rtl", ctx_r2.rtl)("selectable", false)("selected", ctx_r2._isSingleResource && ctx_r2._isToday(dayData_r38.timestamp))("theme", ctx_r2.theme)("timestamp", dayData_r38.timestamp);
  }
}
function MbscScheduler_ng_container_14_ng_container_1_div_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtemplate(1, MbscScheduler_ng_container_14_ng_container_1_div_1_div_2_mbsc_week_day_1_Template, 1, 18, "mbsc-week-day", 53);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2._days)("ngForTrackBy", ctx_r2._getDayKey);
  }
}
function MbscScheduler_ng_container_14_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MbscScheduler_ng_container_14_ng_container_1_div_1_div_1_Template, 5, 8, "div", 52)(2, MbscScheduler_ng_container_14_ng_container_1_div_1_div_2_Template, 2, 2, "div", 47);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const r_r36 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap("mbsc-flex-1-0 mbsc-schedule-resource-group" + ctx_r2._theme + ctx_r2._rtl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", r_r36.name || ctx_r2.resourceTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.showDays);
  }
}
function MbscScheduler_ng_container_14_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscScheduler_ng_container_14_ng_container_1_div_1_Template, 3, 4, "div", 22);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2._resources)("ngForTrackBy", ctx_r2._getId);
  }
}
function MbscScheduler_ng_container_14_ng_container_2_div_1_mbsc_week_day_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mbsc-week-day", 56);
  }
  if (rf & 2) {
    const dayData_r39 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("day", dayData_r39.day)("dayNames", ctx_r2._dayNames)("dayTemplate", ctx_r2.dayTemplate)("dayContentTemplate", ctx_r2.dayContentTemplate)("events", ctx_r2.eventMap[dayData_r39.dateKey])("isToday", ctx_r2._isSingleResource && ctx_r2._isToday(dayData_r39.timestamp))("label", dayData_r39.label)("largeNames", ctx_r2._largeDayNames)("onClick", ctx_r2.onWeekDayClick)("rtl", ctx_r2.rtl)("selectable", false)("selected", ctx_r2._isToday(dayData_r39.timestamp))("theme", ctx_r2.theme)("timestamp", dayData_r39.timestamp);
  }
}
function MbscScheduler_ng_container_14_ng_container_2_div_1_div_2_ng_container_1_div_1_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const r_r40 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵtextInterpolate1(" ", r_r40.name, " ");
  }
}
function MbscScheduler_ng_container_14_ng_container_2_div_1_div_2_ng_container_1_div_1_ng_template_4_Template(rf, ctx) {}
function MbscScheduler_ng_container_14_ng_container_2_div_1_div_2_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 51);
    i0.ɵɵtemplate(2, MbscScheduler_ng_container_14_ng_container_2_div_1_div_2_ng_container_1_div_1_ng_template_2_Template, 1, 1, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor)(4, MbscScheduler_ng_container_14_ng_container_2_div_1_div_2_ng_container_1_div_1_ng_template_4_Template, 0, 0, "ng-template", 39);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const default_r41 = i0.ɵɵreference(3);
    const r_r40 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(5);
    i0.ɵɵclassMap("mbsc-schedule-resource mbsc-flex-1-0 mbsc-schedule-col-width " + (r_r40.cssClass || "") + ctx_r2._theme + ctx_r2._rtl + ctx_r2._hb);
    i0.ɵɵstyleProp("background", r_r40.background);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.resourceTemplate || default_r41)("ngTemplateOutletContext", i0.ɵɵpureFunction1(6, _c14, r_r40));
  }
}
function MbscScheduler_ng_container_14_ng_container_2_div_1_div_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscScheduler_ng_container_14_ng_container_2_div_1_div_2_ng_container_1_div_1_Template, 5, 8, "div", 50);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const r_r40 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", r_r40.name || ctx_r2.resourceTemplate);
  }
}
function MbscScheduler_ng_container_14_ng_container_2_div_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtemplate(1, MbscScheduler_ng_container_14_ng_container_2_div_1_div_2_ng_container_1_Template, 2, 1, "ng-container", 32);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2._resources)("ngForTrackBy", ctx_r2._getId);
  }
}
function MbscScheduler_ng_container_14_ng_container_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MbscScheduler_ng_container_14_ng_container_2_div_1_mbsc_week_day_1_Template, 1, 14, "mbsc-week-day", 55)(2, MbscScheduler_ng_container_14_ng_container_2_div_1_div_2_Template, 2, 2, "div", 47);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap("mbsc-flex-1-0 mbsc-schedule-resource-group" + ctx_r2._theme + ctx_r2._rtl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.showDays);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.resources);
  }
}
function MbscScheduler_ng_container_14_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscScheduler_ng_container_14_ng_container_2_div_1_Template, 3, 4, "div", 22);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2._days)("ngForTrackBy", ctx_r2._getDayKey);
  }
}
function MbscScheduler_ng_container_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscScheduler_ng_container_14_ng_container_1_Template, 2, 2, "ng-container", 15)(2, MbscScheduler_ng_container_14_ng_container_2_Template, 2, 2, "ng-container", 15);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2._groupByResource);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2._groupByResource);
  }
}
function MbscScheduler_div_17_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const tz_r42 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-flex-1-0-0 mbsc-schedule-timezone-label" + ctx_r2._theme + ctx_r2._rtl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", tz_r42.label, " ");
  }
}
function MbscScheduler_div_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 57);
    i0.ɵɵtemplate(1, MbscScheduler_div_17_div_1_Template, 2, 3, "div", 22);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", ctx_r2._timeWidth);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2._timezones)("ngForTrackBy", ctx_r2._getKey);
  }
}
function MbscScheduler_div_18_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-schedule-all-day-text" + ctx_r2._theme + ctx_r2._rtl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r2.allDayText);
  }
}
function MbscScheduler_div_18_ng_container_7_div_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 39);
  }
  if (rf & 2) {
    const dayData_r43 = ctx.$implicit;
    const r_r44 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵnextContext(3);
    const tplAllDay_r45 = i0.ɵɵreference(3);
    i0.ɵɵproperty("ngTemplateOutlet", tplAllDay_r45)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c41, dayData_r43.dateKey, r_r44, dayData_r43.timestamp));
  }
}
function MbscScheduler_div_18_ng_container_7_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MbscScheduler_div_18_ng_container_7_div_1_ng_container_1_Template, 1, 6, "ng-container", 59);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap("mbsc-flex mbsc-flex-1-0 mbsc-schedule-resource-group" + ctx_r2._theme + ctx_r2._rtl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2._days)("ngForTrackBy", ctx_r2._getDayKey);
  }
}
function MbscScheduler_div_18_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscScheduler_div_18_ng_container_7_div_1_Template, 2, 4, "div", 22);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2._resources)("ngForTrackBy", ctx_r2._getId);
  }
}
function MbscScheduler_div_18_ng_container_8_div_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 39);
  }
  if (rf & 2) {
    const r_r46 = ctx.$implicit;
    const dayData_r47 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵnextContext(3);
    const tplAllDay_r45 = i0.ɵɵreference(3);
    i0.ɵɵproperty("ngTemplateOutlet", tplAllDay_r45)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c41, dayData_r47.dateKey, r_r46, dayData_r47.timestamp));
  }
}
function MbscScheduler_div_18_ng_container_8_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MbscScheduler_div_18_ng_container_8_div_1_ng_container_1_Template, 1, 6, "ng-container", 59);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap("mbsc-flex mbsc-flex-1-0 mbsc-schedule-resource-group" + ctx_r2._theme + ctx_r2._rtl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2._resources)("ngForTrackBy", ctx_r2._getId);
  }
}
function MbscScheduler_div_18_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscScheduler_div_18_ng_container_8_div_1_Template, 2, 4, "div", 22);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2._days)("ngForTrackBy", ctx_r2._getDayKey);
  }
}
function MbscScheduler_div_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div")(2, "div", 11);
    i0.ɵɵtemplate(3, MbscScheduler_div_18_div_3_Template, 2, 3, "div", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 58)(5, "div", 27, 9);
    i0.ɵɵtemplate(7, MbscScheduler_div_18_ng_container_7_Template, 2, 2, "ng-container", 15)(8, MbscScheduler_div_18_ng_container_8_Template, 2, 2, "ng-container", 15);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-schedule-all-day-wrapper mbsc-flex-none" + ctx_r2._theme + ctx_r2._hb);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-flex mbsc-schedule-all-day" + ctx_r2._theme);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-schedule-time-col" + ctx_r2._theme + ctx_r2._rtl);
    i0.ɵɵproperty("ngStyle", ctx_r2._timeWidth);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.timezones);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r2._groupByResource);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2._groupByResource);
  }
}
function MbscScheduler_div_25_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 39);
  }
  if (rf & 2) {
    const tz_r48 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵnextContext();
    const tplTimes_r49 = i0.ɵɵreference(7);
    i0.ɵɵproperty("ngTemplateOutlet", tplTimes_r49)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c42, tz_r48));
  }
}
function MbscScheduler_div_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MbscScheduler_div_25_ng_container_1_Template, 1, 4, "ng-container", 60);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const last_r50 = ctx.last;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-flex-col" + ctx_r2._theme + (last_r50 ? " mbsc-schedule-time-col-last" : ""));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.timezones);
  }
}
function MbscScheduler_ng_container_26_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 61);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const tplTimes_r49 = i0.ɵɵreference(7);
    i0.ɵɵproperty("ngTemplateOutlet", tplTimes_r49);
  }
}
function MbscScheduler_mbsc_time_indicator_27_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mbsc-time-indicator", 62);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("amText", ctx_r2.s.amText)("displayedTime", ctx_r2._time)("displayedDays", ctx_r2._daysNr)("displayTimezone", ctx_r2.displayTimezone)("endDay", ctx_r2.endDay)("firstDay", ctx_r2._firstDayTz)("pmText", ctx_r2.s.pmText)("rtl", ctx_r2.rtl)("showDayIndicator", ctx_r2._isSingleResource && !ctx_r2._isMulti && ctx_r2.type === "week")("startDay", ctx_r2.startDay)("startTime", ctx_r2._startTime)("theme", ctx_r2.theme)("timeFormat", ctx_r2.timeFormat)("timezones", ctx_r2._timezones)("timezonePlugin", ctx_r2.timezonePlugin);
  }
}
function MbscScheduler_div_28_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", null, 10);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-schedule-cursor-time mbsc-schedule-cursor-time-x" + ctx_r2._theme + ctx_r2._rtl);
  }
}
function MbscScheduler_div_29_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 63);
  }
}
function MbscScheduler_ng_container_36_div_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainer(1, 39);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const dayData_r51 = ctx.$implicit;
    const r_r52 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵnextContext(2);
    const tplDay_r53 = i0.ɵɵreference(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", tplDay_r53)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c41, dayData_r51.dateKey, r_r52, dayData_r51.timestamp));
  }
}
function MbscScheduler_ng_container_36_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MbscScheduler_ng_container_36_div_1_ng_container_1_Template, 2, 6, "ng-container", 32);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-flex mbsc-flex-1-0 mbsc-schedule-resource-group" + ctx_r2._theme + ctx_r2._rtl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2._days)("ngForTrackBy", ctx_r2._getDayKey);
  }
}
function MbscScheduler_ng_container_36_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscScheduler_ng_container_36_div_1_Template, 2, 4, "div", 22);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2._resources)("ngForTrackBy", ctx_r2._getId);
  }
}
function MbscScheduler_ng_container_37_div_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementContainer(1, 39);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const r_r54 = ctx.$implicit;
    const dayData_r55 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵnextContext(2);
    const tplDay_r53 = i0.ɵɵreference(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", tplDay_r53)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c41, dayData_r55.dateKey, r_r54, dayData_r55.timestamp));
  }
}
function MbscScheduler_ng_container_37_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MbscScheduler_ng_container_37_div_1_ng_container_1_Template, 2, 6, "ng-container", 32);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-flex mbsc-flex-1-0 mbsc-schedule-resource-group" + ctx_r2._theme + ctx_r2._rtl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2._resources)("ngForTrackBy", ctx_r2._getId);
  }
}
function MbscScheduler_ng_container_37_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscScheduler_ng_container_37_div_1_Template, 2, 4, "div", 22);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2._days)("ngForTrackBy", ctx_r2._getDayKey);
  }
}
function MbscScheduler_div_38_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 64);
  }
}
const _c43 = ["footerCont"];
const _c44 = ["resCont"];
const _c45 = ["sidebarCont"];
const _c46 = ["stickyFooter"];
const _c47 = ["stickyHeader"];
const _c48 = ["stickyDate"];
const _c49 = ["stickyMonth"];
const _c50 = ["stickyWeek"];
const _c51 = (a0, a1, a2, a3, a4) => ({
  dateKey: a0,
  dragData: a1,
  dragKey: a2,
  resource: a3,
  slot: a4
});
const _c52 = () => [];
const _c53 = (a0, a1, a2) => ({
  date: a0,
  events: a1,
  isActive: a2
});
const _c54 = (a0, a1) => ({
  date: a0,
  events: a1
});
const _c55 = (a0, a1, a2, a3, a4, a5) => ({
  date: a0,
  events: a1,
  isActive: a2,
  startDate: a3,
  endDate: a4,
  weekNr: a5
});
const _c56 = a0 => ({
  month: a0
});
const _c57 = a0 => ({
  week: a0
});
const _c58 = a0 => ({
  day: a0
});
const _c59 = (a0, a1) => ({
  slot: a0,
  date: a1
});
const _c60 = (a0, a1) => ({
  hour: a0,
  timestamp: a1
});
const _c61 = a0 => ({
  quarter: a0
});
const _c62 = a0 => ({
  year: a0
});
const _c63 = (a0, a1) => ({
  res: a0,
  key: a1
});
const _c64 = (a0, a1) => ({
  res: a0,
  dateKey: a1
});
function MbscTimeline_ng_template_0_div_0_mbsc_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mbsc-icon", 57);
    i0.ɵɵlistener("click", function MbscTimeline_ng_template_0_div_0_mbsc_icon_1_Template_mbsc_icon_click_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const res_r3 = i0.ɵɵnextContext(2).res;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3._onParentClick($event, res_r3));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const res_r3 = i0.ɵɵnextContext(2).res;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-timeline-resource-icon" + ctx_r3._rtl + ctx_r3._hb);
    i0.ɵɵproperty("svg", res_r3.collapsed ? ctx_r3.rtl ? ctx_r3.nextIconRtl : ctx_r3.nextIcon : ctx_r3.downIcon)("theme", ctx_r3.theme);
  }
}
function MbscTimeline_ng_template_0_div_0_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const res_r3 = i0.ɵɵnextContext(2).res;
    i0.ɵɵtextInterpolate(res_r3.name);
  }
}
function MbscTimeline_ng_template_0_div_0_ng_template_5_Template(rf, ctx) {}
function MbscTimeline_ng_template_0_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MbscTimeline_ng_template_0_div_0_mbsc_icon_1_Template, 1, 4, "mbsc-icon", 55);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵtemplate(3, MbscTimeline_ng_template_0_div_0_ng_template_3_Template, 1, 1, "ng-template", null, 20, i0.ɵɵtemplateRefExtractor)(5, MbscTimeline_ng_template_0_div_0_ng_template_5_Template, 0, 0, "ng-template", 56);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const default_r5 = i0.ɵɵreference(4);
    const ctx_r5 = i0.ɵɵnextContext();
    const res_r3 = ctx_r5.res;
    const key_r7 = ctx_r5.key;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-timeline-resource mbsc-timeline-row mbsc-flex-1-0" + (res_r3.isParent ? " mbsc-timeline-parent mbsc-flex" : "") + (res_r3.fixed && !ctx_r3._hasResY ? " mbsc-timeline-row-fixed" : "") + (res_r3.cssClass ? " " + res_r3.cssClass : "") + ctx_r3._theme + ctx_r3._rtl + ctx_r3._hb);
    i0.ɵɵstyleProp("background", res_r3.background)("min-height", ctx_r3._rowHeights[key_r7])("padding-left", ctx_r3.rtl ? undefined : res_r3.depth * 1.75, "em")("padding-right", ctx_r3.rtl ? res_r3.depth * 1.75 : undefined, "em")("top", res_r3.fixed && !ctx_r3._hasResY ? ctx_r3._fixedResourceTops[key_r7] + "px" : undefined);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", res_r3.isParent);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-timeline-resource-title" + (res_r3.isParent ? " mbsc-flex-1-1" : ""));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.resourceTemplate || default_r5)("ngTemplateOutletContext", i0.ɵɵpureFunction1(17, _c14, res_r3));
  }
}
function MbscTimeline_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscTimeline_ng_template_0_div_0_Template, 6, 19, "div", 54);
  }
  if (rf & 2) {
    const key_r7 = ctx.key;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", key_r7 !== ctx_r3._dragRow);
  }
}
function MbscTimeline_ng_template_2_div_0_ng_template_2_Template(rf, ctx) {}
function MbscTimeline_ng_template_2_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 59);
    i0.ɵɵtemplate(2, MbscTimeline_ng_template_2_div_0_ng_template_2_Template, 0, 0, "ng-template", 56);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    const res_r9 = ctx_r7.res;
    const key_r10 = ctx_r7.key;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-timeline-sidebar-resource mbsc-timeline-row mbsc-flex-1-0" + (res_r9.isParent ? " mbsc-timeline-parent mbsc-flex" : "") + (res_r9.fixed && !ctx_r3._hasResY ? " mbsc-timeline-row-fixed" : "") + (res_r9.cssClass ? " " + res_r9.cssClass : "") + ctx_r3._theme + ctx_r3._rtl + ctx_r3._hb);
    i0.ɵɵstyleProp("background", res_r9.background)("min-height", ctx_r3._rowHeights[key_r10])("top", res_r9.fixed && !ctx_r3._hasResY ? ctx_r3._fixedResourceTops[key_r10] + "px" : undefined);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.sidebarTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(10, _c14, res_r9));
  }
}
function MbscTimeline_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscTimeline_ng_template_2_div_0_Template, 3, 12, "div", 58);
  }
  if (rf & 2) {
    const key_r10 = ctx.key;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", key_r10 !== ctx_r3._dragRow);
  }
}
function MbscTimeline_ng_template_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 56);
  }
  if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    const res_r12 = ctx_r10.res;
    const dateKey_r13 = ctx_r10.dateKey;
    const ctx_r3 = i0.ɵɵnextContext();
    const tplDayData_r14 = i0.ɵɵreference(31);
    i0.ɵɵproperty("ngTemplateOutlet", tplDayData_r14)("ngTemplateOutletContext", i0.ɵɵpureFunction5(2, _c51, dateKey_r13 || "all", ctx_r3.state.dragData, ctx_r3._getDragKey(res_r12.id, ctx_r3._defId, dateKey_r13 || "all"), res_r12.id, ctx_r3._defId));
  }
}
function MbscTimeline_ng_template_4_ng_container_3_div_1_div_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 56);
  }
  if (rf & 2) {
    const slot_r15 = i0.ɵɵnextContext().$implicit;
    const dayData_r16 = i0.ɵɵnextContext(2).$implicit;
    const res_r12 = i0.ɵɵnextContext().res;
    const ctx_r3 = i0.ɵɵnextContext();
    const tplDayData_r14 = i0.ɵɵreference(31);
    i0.ɵɵproperty("ngTemplateOutlet", tplDayData_r14)("ngTemplateOutletContext", i0.ɵɵpureFunction5(2, _c51, dayData_r16.dateKey, ctx_r3.state.dragData, ctx_r3._getDragKey(res_r12.id, slot_r15.id, dayData_r16.dateKey), res_r12.id, slot_r15.id));
  }
}
function MbscTimeline_ng_template_4_ng_container_3_div_1_div_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 64);
    i0.ɵɵlistener("click", function MbscTimeline_ng_template_4_ng_container_3_div_1_div_1_div_2_Template_div_click_0_listener($event) {
      const v_r18 = i0.ɵɵrestoreView(_r17).$implicit;
      const slot_r15 = i0.ɵɵnextContext().$implicit;
      const dayData_r16 = i0.ɵɵnextContext(2).$implicit;
      const res_r12 = i0.ɵɵnextContext().res;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onCellClick(ctx_r3._getEventArgs(dayData_r16, slot_r15, v_r18, $event, res_r12.id)));
    })("dblclick", function MbscTimeline_ng_template_4_ng_container_3_div_1_div_1_div_2_Template_div_dblclick_0_listener($event) {
      const v_r18 = i0.ɵɵrestoreView(_r17).$implicit;
      const slot_r15 = i0.ɵɵnextContext().$implicit;
      const dayData_r16 = i0.ɵɵnextContext(2).$implicit;
      const res_r12 = i0.ɵɵnextContext().res;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onCellDoubleClick(ctx_r3._getEventArgs(dayData_r16, slot_r15, v_r18, $event, res_r12.id)));
    })("contextmenu", function MbscTimeline_ng_template_4_ng_container_3_div_1_div_1_div_2_Template_div_contextmenu_0_listener($event) {
      const v_r18 = i0.ɵɵrestoreView(_r17).$implicit;
      const slot_r15 = i0.ɵɵnextContext().$implicit;
      const dayData_r16 = i0.ɵɵnextContext(2).$implicit;
      const res_r12 = i0.ɵɵnextContext().res;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onCellRightClick(ctx_r3._getEventArgs(dayData_r16, slot_r15, v_r18, $event, res_r12.id)));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const first_r19 = ctx.first;
    const last_r20 = ctx.last;
    const ctx_r3 = i0.ɵɵnextContext(5);
    i0.ɵɵclassMap("mbsc-timeline-column mbsc-flex-1-1" + ctx_r3._theme + ctx_r3._rtl + ctx_r3._hb + (first_r19 && ctx_r3._startCellStyle || last_r20 && ctx_r3._endCellStyle ? " mbsc-flex-none" : ""));
    i0.ɵɵproperty("ngStyle", first_r19 && !last_r20 ? ctx_r3._startCellStyle : last_r20 && !first_r19 ? ctx_r3._endCellStyle : i0.ɵɵpureFunction0(3, _c40));
  }
}
function MbscTimeline_ng_template_4_ng_container_3_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MbscTimeline_ng_template_4_ng_container_3_div_1_div_1_ng_container_1_Template, 1, 8, "ng-container", 60)(2, MbscTimeline_ng_template_4_ng_container_3_div_1_div_1_div_2_Template, 1, 4, "div", 63);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(4);
    i0.ɵɵclassMap("mbsc-flex mbsc-flex-1-1" + (ctx_r3._hasSlots ? " mbsc-timeline-slot" : ""));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3._hasSlots);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3._times)("ngForTrackBy", ctx_r3._getKey);
  }
}
function MbscTimeline_ng_template_4_ng_container_3_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MbscTimeline_ng_template_4_ng_container_3_div_1_div_1_Template, 3, 5, "div", 62);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dayData_r16 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-timeline-day mbsc-flex" + ctx_r3._theme + ctx_r3._rtl + ctx_r3._hb + (dayData_r16.dateKey === ctx_r3._dragCol ? " mbsc-timeline-hidden" : "") + (dayData_r16.dateIndex < ctx_r3._daysNr - 1 && (ctx_r3._stepCell < ctx_r3._oneDay || dayData_r16.lastOfMonth) ? " mbsc-timeline-day-border" : "") + (ctx_r3.state.hasScrollX ? " mbsc-flex-none" : " mbsc-flex-1-0-0") + (ctx_r3.type === "month" || ctx_r3._isMulti ? " mbsc-timeline-day-month" : ""));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3._slots)("ngForTrackBy", ctx_r3._getId);
  }
}
function MbscTimeline_ng_template_4_ng_container_3_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 65);
    i0.ɵɵlistener("click", function MbscTimeline_ng_template_4_ng_container_3_div_2_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r21);
      const dayData_r16 = i0.ɵɵnextContext().$implicit;
      const res_r12 = i0.ɵɵnextContext().res;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onCellClick({
        date: dayData_r16.date,
        domEvent: $event,
        resource: res_r12.id,
        source: "timeline"
      }));
    })("dblclick", function MbscTimeline_ng_template_4_ng_container_3_div_2_Template_div_dblclick_0_listener($event) {
      i0.ɵɵrestoreView(_r21);
      const dayData_r16 = i0.ɵɵnextContext().$implicit;
      const res_r12 = i0.ɵɵnextContext().res;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onCellDoubleClick({
        date: dayData_r16.date,
        domEvent: $event,
        resource: res_r12.id,
        source: "timeline"
      }));
    })("contextmenu", function MbscTimeline_ng_template_4_ng_container_3_div_2_Template_div_contextmenu_0_listener($event) {
      i0.ɵɵrestoreView(_r21);
      const dayData_r16 = i0.ɵɵnextContext().$implicit;
      const res_r12 = i0.ɵɵnextContext().res;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onCellRightClick({
        date: dayData_r16.date,
        domEvent: $event,
        resource: res_r12.id,
        source: "timeline"
      }));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const dayData_r16 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-timeline-day mbsc-timeline-column" + ctx_r3._theme + ctx_r3._rtl + ctx_r3._hb + (dayData_r16.dateKey === ctx_r3._dragCol ? " mbsc-timeline-hidden" : "") + (ctx_r3.state.hasScrollX ? " mbsc-flex-none" : " mbsc-flex-1-0-0"));
  }
}
function MbscTimeline_ng_template_4_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscTimeline_ng_template_4_ng_container_3_div_1_Template, 2, 4, "div", 41)(2, MbscTimeline_ng_template_4_ng_container_3_div_2_Template, 1, 2, "div", 61);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3._isDailyResolution);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r3._isDailyResolution);
  }
}
function MbscTimeline_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MbscTimeline_ng_template_4_ng_container_1_Template, 1, 8, "ng-container", 60);
    i0.ɵɵelement(2, "div", 45);
    i0.ɵɵtemplate(3, MbscTimeline_ng_template_4_ng_container_3_Template, 3, 2, "ng-container", 51);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const res_r12 = ctx.res;
    const dateKey_r13 = ctx.dateKey;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-timeline-row mbsc-flex mbsc-flex-1-0" + (res_r12.isParent ? " mbsc-timeline-parent" : "") + (res_r12.fixed && !ctx_r3._hasResY ? " mbsc-timeline-row-fixed" : "") + (res_r12.cssClass ? " " + res_r12.cssClass : "") + ((dateKey_r13 ? dateKey_r13 + "-" : "") + res_r12.id === ctx_r3._dragRow ? " mbsc-timeline-hidden" : "") + ctx_r3._theme + ctx_r3._hb);
    i0.ɵɵstyleProp("background", res_r12.background)("min-height", ctx_r3._rowHeights[(dateKey_r13 ? dateKey_r13 + "-" : "") + res_r12.id])("top", res_r12.fixed && !ctx_r3._hasResY ? ctx_r3._fixedResourceTops[(dateKey_r13 ? dateKey_r13 + "-" : "") + res_r12.id] + "px" : undefined);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r3._hasSlots);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("width", ctx_r3._placeholderSizeX, "px");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3._daysBatch)("ngForTrackBy", ctx_r3._getDayKey);
  }
}
function MbscTimeline_ng_template_6_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const timestamp_r22 = i0.ɵɵnextContext().timestamp;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate(ctx_r3._timeLabels[timestamp_r22]);
  }
}
function MbscTimeline_ng_template_6_3_ng_template_0_Template(rf, ctx) {}
function MbscTimeline_ng_template_6_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscTimeline_ng_template_6_3_ng_template_0_Template, 0, 0, "ng-template", 56);
  }
  if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext();
    const hour_r24 = ctx_r22.hour;
    const timestamp_r22 = ctx_r22.timestamp;
    const defaultHour_r25 = i0.ɵɵreference(2);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.hourTemplate || defaultHour_r25)("ngTemplateOutletContext", i0.ɵɵpureFunction1(7, _c14, i0.ɵɵpureFunction3(3, _c53, ctx_r3._getDate(+hour_r24.date + timestamp_r22), hour_r24.eventMap[+hour_r24.date + timestamp_r22] || i0.ɵɵpureFunction0(2, _c52), hour_r24.isActive)));
  }
}
function MbscTimeline_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 66);
    i0.ɵɵtemplate(1, MbscTimeline_ng_template_6_ng_template_1_Template, 1, 1, "ng-template", null, 21, i0.ɵɵtemplateRefExtractor)(3, MbscTimeline_ng_template_6_3_Template, 1, 9, null, 46);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const timestamp_r22 = ctx.timestamp;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-timeline-header-time mbsc-flex-1-1" + ctx_r3._theme);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r3._timeLabels[timestamp_r22]);
  }
}
function MbscTimeline_ng_template_8_1_ng_template_0_Template(rf, ctx) {}
function MbscTimeline_ng_template_8_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscTimeline_ng_template_8_1_ng_template_0_Template, 0, 0, "ng-template", 56);
  }
  if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext();
    const hour_r27 = ctx_r25.hour;
    const timestamp_r28 = ctx_r25.timestamp;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.hourFooterTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(7, _c14, i0.ɵɵpureFunction3(3, _c53, ctx_r3._getDate(+hour_r27.date + timestamp_r28), hour_r27.eventMap[+hour_r27.date + timestamp_r28] || i0.ɵɵpureFunction0(2, _c52), hour_r27.isActive)));
  }
}
function MbscTimeline_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 66);
    i0.ɵɵtemplate(1, MbscTimeline_ng_template_8_1_Template, 1, 9, null, 46);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const timestamp_r28 = ctx.timestamp;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-timeline-footer-time mbsc-flex-1-1 " + ctx_r3._theme);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3._timeLabels[timestamp_r28]);
  }
}
function MbscTimeline_ng_template_10_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const day_r29 = i0.ɵɵnextContext().day;
    i0.ɵɵtextInterpolate(day_r29.dateText);
  }
}
function MbscTimeline_ng_template_10_ng_template_3_Template(rf, ctx) {}
function MbscTimeline_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 66);
    i0.ɵɵtemplate(1, MbscTimeline_ng_template_10_ng_template_1_Template, 1, 1, "ng-template", null, 22, i0.ɵɵtemplateRefExtractor)(3, MbscTimeline_ng_template_10_ng_template_3_Template, 0, 0, "ng-template", 56);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const day_r29 = ctx.day;
    const defaultDay_r30 = i0.ɵɵreference(2);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMap((ctx_r3.dayTemplate ? "" : "mbsc-timeline-header-date-text") + (day_r29.isActive && !ctx_r3.dayTemplate ? " mbsc-timeline-header-active" : "") + ctx_r3._theme);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.dayTemplate || defaultDay_r30)("ngTemplateOutletContext", i0.ɵɵpureFunction1(8, _c14, i0.ɵɵpureFunction3(4, _c53, day_r29.date, day_r29.eventMap.all, day_r29.isActive)));
  }
}
function MbscTimeline_ng_template_12_ng_template_1_Template(rf, ctx) {}
function MbscTimeline_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MbscTimeline_ng_template_12_ng_template_1_Template, 0, 0, "ng-template", 56);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const day_r31 = ctx.day;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-timeline-footer-date-cont" + ctx_r3._theme);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.dayFooterTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(7, _c14, i0.ɵɵpureFunction2(4, _c54, day_r31.date, day_r31.eventMap.all)));
  }
}
function MbscTimeline_ng_template_14_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const week_r32 = i0.ɵɵnextContext().week;
    i0.ɵɵtextInterpolate(week_r32.weekText);
  }
}
function MbscTimeline_ng_template_14_ng_template_2_Template(rf, ctx) {}
function MbscTimeline_ng_template_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscTimeline_ng_template_14_ng_template_0_Template, 1, 1, "ng-template", null, 23, i0.ɵɵtemplateRefExtractor)(2, MbscTimeline_ng_template_14_ng_template_2_Template, 0, 0, "ng-template", 56);
  }
  if (rf & 2) {
    const week_r32 = ctx.week;
    const defaultWeek_r33 = i0.ɵɵreference(1);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.weekTemplate || defaultWeek_r33)("ngTemplateOutletContext", i0.ɵɵpureFunction1(10, _c14, i0.ɵɵpureFunction6(3, _c55, week_r32.date, week_r32.eventMap[week_r32.timestamp] || i0.ɵɵpureFunction0(2, _c52), week_r32.isActive, week_r32.date, week_r32.endDate, week_r32.weekNr)));
  }
}
function MbscTimeline_ng_template_16_ng_template_1_Template(rf, ctx) {}
function MbscTimeline_ng_template_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 67);
    i0.ɵɵtemplate(1, MbscTimeline_ng_template_16_ng_template_1_Template, 0, 0, "ng-template", 56);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const week_r34 = ctx.week;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.weekFooterTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(10, _c14, i0.ɵɵpureFunction6(3, _c55, week_r34.date, week_r34.eventMap[week_r34.timestamp] || i0.ɵɵpureFunction0(2, _c52), week_r34.isActive, week_r34.date, week_r34.endDate, week_r34.weekNr)));
  }
}
function MbscTimeline_ng_template_18_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const month_r35 = i0.ɵɵnextContext().month;
    i0.ɵɵtextInterpolate(month_r35.monthText);
  }
}
function MbscTimeline_ng_template_18_ng_template_2_Template(rf, ctx) {}
function MbscTimeline_ng_template_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscTimeline_ng_template_18_ng_template_0_Template, 1, 1, "ng-template", null, 24, i0.ɵɵtemplateRefExtractor)(2, MbscTimeline_ng_template_18_ng_template_2_Template, 0, 0, "ng-template", 56);
  }
  if (rf & 2) {
    const month_r35 = ctx.month;
    const defaultMonth_r36 = i0.ɵɵreference(1);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.monthTemplate || defaultMonth_r36)("ngTemplateOutletContext", i0.ɵɵpureFunction1(7, _c14, i0.ɵɵpureFunction3(3, _c53, month_r35.date, month_r35.eventMap[month_r35.timestamp] || i0.ɵɵpureFunction0(2, _c52), month_r35.isActive)));
  }
}
function MbscTimeline_ng_template_20_ng_template_1_Template(rf, ctx) {}
function MbscTimeline_ng_template_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 68);
    i0.ɵɵtemplate(1, MbscTimeline_ng_template_20_ng_template_1_Template, 0, 0, "ng-template", 56);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const month_r37 = ctx.month;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.monthFooterTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(6, _c14, i0.ɵɵpureFunction2(3, _c54, month_r37.date, month_r37.eventMap[month_r37.timestamp] || i0.ɵɵpureFunction0(2, _c52))));
  }
}
function MbscTimeline_ng_template_22_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const quarter_r38 = i0.ɵɵnextContext().quarter;
    i0.ɵɵtextInterpolate(quarter_r38.quarterText);
  }
}
function MbscTimeline_ng_template_22_ng_template_2_Template(rf, ctx) {}
function MbscTimeline_ng_template_22_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscTimeline_ng_template_22_ng_template_0_Template, 1, 1, "ng-template", null, 25, i0.ɵɵtemplateRefExtractor)(2, MbscTimeline_ng_template_22_ng_template_2_Template, 0, 0, "ng-template", 56);
  }
  if (rf & 2) {
    const quarter_r38 = ctx.quarter;
    const defaultQuarter_r39 = i0.ɵɵreference(1);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.quarterTemplate || defaultQuarter_r39)("ngTemplateOutletContext", i0.ɵɵpureFunction1(7, _c14, i0.ɵɵpureFunction3(3, _c53, quarter_r38.date, quarter_r38.eventMap[quarter_r38.timestamp] || i0.ɵɵpureFunction0(2, _c52), quarter_r38.isActive)));
  }
}
function MbscTimeline_ng_template_24_ng_template_1_Template(rf, ctx) {}
function MbscTimeline_ng_template_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 69);
    i0.ɵɵtemplate(1, MbscTimeline_ng_template_24_ng_template_1_Template, 0, 0, "ng-template", 56);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const quarter_r40 = ctx.quarter;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.quarterFooterTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(7, _c14, i0.ɵɵpureFunction3(3, _c53, quarter_r40.date, quarter_r40.eventMap[quarter_r40.timestamp] || i0.ɵɵpureFunction0(2, _c52), quarter_r40.isActive)));
  }
}
function MbscTimeline_ng_template_26_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const year_r41 = i0.ɵɵnextContext().year;
    i0.ɵɵtextInterpolate(year_r41.columnTitle);
  }
}
function MbscTimeline_ng_template_26_ng_template_2_Template(rf, ctx) {}
function MbscTimeline_ng_template_26_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscTimeline_ng_template_26_ng_template_0_Template, 1, 1, "ng-template", null, 26, i0.ɵɵtemplateRefExtractor)(2, MbscTimeline_ng_template_26_ng_template_2_Template, 0, 0, "ng-template", 56);
  }
  if (rf & 2) {
    const year_r41 = ctx.year;
    const defaultYear_r42 = i0.ɵɵreference(1);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.yearTemplate || defaultYear_r42)("ngTemplateOutletContext", i0.ɵɵpureFunction1(7, _c14, i0.ɵɵpureFunction3(3, _c53, year_r41.date, year_r41.eventMap[year_r41.timestamp] || i0.ɵɵpureFunction0(2, _c52), year_r41.isActive)));
  }
}
function MbscTimeline_ng_template_28_ng_template_1_Template(rf, ctx) {}
function MbscTimeline_ng_template_28_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 70);
    i0.ɵɵtemplate(1, MbscTimeline_ng_template_28_ng_template_1_Template, 0, 0, "ng-template", 56);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const year_r43 = ctx.year;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.yearFooterTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(7, _c14, i0.ɵɵpureFunction3(3, _c53, year_r43.date, year_r43.eventMap[year_r43.timestamp] || i0.ɵɵpureFunction0(2, _c52), year_r43.isActive)));
  }
}
function MbscTimeline_ng_template_30_ng_container_1_ng_container_1_mbsc_schedule_event_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r44 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mbsc-schedule-event", 75);
    i0.ɵɵlistener("onClick", function MbscTimeline_ng_template_30_ng_container_1_ng_container_1_mbsc_schedule_event_1_Template_mbsc_schedule_event_onClick_0_listener($event) {
      i0.ɵɵrestoreView(_r44);
      const ctx_r3 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r3._onEventClick($event));
    })("onDoubleClick", function MbscTimeline_ng_template_30_ng_container_1_ng_container_1_mbsc_schedule_event_1_Template_mbsc_schedule_event_onDoubleClick_0_listener($event) {
      i0.ɵɵrestoreView(_r44);
      const ctx_r3 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r3.onEventDoubleClick($event));
    })("onRightClick", function MbscTimeline_ng_template_30_ng_container_1_ng_container_1_mbsc_schedule_event_1_Template_mbsc_schedule_event_onRightClick_0_listener($event) {
      i0.ɵɵrestoreView(_r44);
      const ctx_r3 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r3.onEventRightClick($event));
    })("onHoverIn", function MbscTimeline_ng_template_30_ng_container_1_ng_container_1_mbsc_schedule_event_1_Template_mbsc_schedule_event_onHoverIn_0_listener($event) {
      i0.ɵɵrestoreView(_r44);
      const ctx_r3 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r3.onEventHoverIn($event));
    })("onHoverOut", function MbscTimeline_ng_template_30_ng_container_1_ng_container_1_mbsc_schedule_event_1_Template_mbsc_schedule_event_onHoverOut_0_listener($event) {
      i0.ɵɵrestoreView(_r44);
      const ctx_r3 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r3.onEventHoverOut($event));
    })("onDelete", function MbscTimeline_ng_template_30_ng_container_1_ng_container_1_mbsc_schedule_event_1_Template_mbsc_schedule_event_onDelete_0_listener($event) {
      i0.ɵɵrestoreView(_r44);
      const ctx_r3 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r3.onEventDelete($event));
    })("onDragStart", function MbscTimeline_ng_template_30_ng_container_1_ng_container_1_mbsc_schedule_event_1_Template_mbsc_schedule_event_onDragStart_0_listener($event) {
      i0.ɵɵrestoreView(_r44);
      const ctx_r3 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r3._onEventDragStart($event));
    })("onDragMove", function MbscTimeline_ng_template_30_ng_container_1_ng_container_1_mbsc_schedule_event_1_Template_mbsc_schedule_event_onDragMove_0_listener($event) {
      i0.ɵɵrestoreView(_r44);
      const ctx_r3 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r3._onEventDragMove($event));
    })("onDragEnd", function MbscTimeline_ng_template_30_ng_container_1_ng_container_1_mbsc_schedule_event_1_Template_mbsc_schedule_event_onDragEnd_0_listener($event) {
      i0.ɵɵrestoreView(_r44);
      const ctx_r3 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r3._onEventDragEnd($event));
    })("onDragModeOn", function MbscTimeline_ng_template_30_ng_container_1_ng_container_1_mbsc_schedule_event_1_Template_mbsc_schedule_event_onDragModeOn_0_listener($event) {
      i0.ɵɵrestoreView(_r44);
      const ctx_r3 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r3._onEventDragModeOn($event));
    })("onDragModeOff", function MbscTimeline_ng_template_30_ng_container_1_ng_container_1_mbsc_schedule_event_1_Template_mbsc_schedule_event_onDragModeOff_0_listener($event) {
      i0.ɵɵrestoreView(_r44);
      const ctx_r3 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r3._onEventDragModeOff($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const event_r45 = i0.ɵɵnextContext().$implicit;
    const ctx_r45 = i0.ɵɵnextContext(2);
    const dragData_r47 = ctx_r45.dragData;
    const resource_r48 = ctx_r45.resource;
    const slot_r49 = ctx_r45.slot;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("bufferAfterTemplate", ctx_r3.bufferAfterTemplate)("bufferBeforeTemplate", ctx_r3.bufferBeforeTemplate)("contentTemplate", ctx_r3.eventContentTemplate)("displayTimezone", ctx_r3.displayTimezone)("drag", ctx_r3.dragToMove || ctx_r3.externalDrag)("endDay", ctx_r3.endDay)("event", event_r45)("eventHeight", ctx_r3._setRowHeight ? ctx_r3._eventHeight : undefined)("exclusiveEndDates", ctx_r3.exclusiveEndDates)("gridEndTime", ctx_r3._endTime)("gridStartTime", ctx_r3._startTime)("hasResY", ctx_r3._hasResY)("inactive", dragData_r47 && dragData_r47.draggedEvent && dragData_r47.draggedEvent.id === event_r45.id)("isTimeline", true)("isListing", ctx_r3.eventList)("lastDay", ctx_r3._lastDay)("resize", ctx_r3._computeEventResize(event_r45.original.resize, ctx_r3.dragToResize, ctx_r3._resourcesMap[resource_r48].eventResize))("resource", resource_r48)("rtl", ctx_r3.rtl)("selected", !!(ctx_r3.selectedEventsMap[event_r45.uid] || ctx_r3.selectedEventsMap[event_r45.id]))("slot", slot_r49)("startDay", ctx_r3.startDay)("theme", ctx_r3.theme)("template", ctx_r3.eventTemplate)("timezonePlugin", ctx_r3.timezonePlugin);
  }
}
function MbscTimeline_ng_template_30_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscTimeline_ng_template_30_ng_container_1_ng_container_1_mbsc_schedule_event_1_Template, 1, 25, "mbsc-schedule-event", 74);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const event_r45 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", event_r45.position && ctx_r3._checkDisplay(event_r45, true));
  }
}
function MbscTimeline_ng_template_30_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscTimeline_ng_template_30_ng_container_1_ng_container_1_Template, 2, 1, "ng-container", 51);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r45 = i0.ɵɵnextContext();
    const dateKey_r50 = ctx_r45.dateKey;
    const resource_r48 = ctx_r45.resource;
    const slot_r49 = ctx_r45.slot;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3._events[resource_r48][slot_r49][dateKey_r50].data)("ngForTrackBy", ctx_r3._getEventKey);
  }
}
function MbscTimeline_ng_template_30_mbsc_schedule_event_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r51 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mbsc-schedule-event", 76);
    i0.ɵɵlistener("onDragStart", function MbscTimeline_ng_template_30_mbsc_schedule_event_2_Template_mbsc_schedule_event_onDragStart_0_listener($event) {
      i0.ɵɵrestoreView(_r51);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3._onEventDragStart($event));
    })("onDragMove", function MbscTimeline_ng_template_30_mbsc_schedule_event_2_Template_mbsc_schedule_event_onDragMove_0_listener($event) {
      i0.ɵɵrestoreView(_r51);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3._onEventDragMove($event));
    })("onDragEnd", function MbscTimeline_ng_template_30_mbsc_schedule_event_2_Template_mbsc_schedule_event_onDragEnd_0_listener($event) {
      i0.ɵɵrestoreView(_r51);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3._onEventDragEnd($event));
    })("onDragModeOff", function MbscTimeline_ng_template_30_mbsc_schedule_event_2_Template_mbsc_schedule_event_onDragModeOff_0_listener($event) {
      i0.ɵɵrestoreView(_r51);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3._onEventDragModeOff($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r45 = i0.ɵɵnextContext();
    const dragData_r47 = ctx_r45.dragData;
    const dragKey_r52 = ctx_r45.dragKey;
    const resource_r48 = ctx_r45.resource;
    const slot_r49 = ctx_r45.slot;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("bufferAfterTemplate", ctx_r3.bufferAfterTemplate)("bufferBeforeTemplate", ctx_r3.bufferBeforeTemplate)("contentTemplate", ctx_r3.eventContentTemplate)("displayTimezone", ctx_r3.displayTimezone)("drag", ctx_r3.dragToMove || ctx_r3.externalDrag)("endDay", ctx_r3.endDay)("event", dragData_r47.originDates[dragKey_r52])("eventHeight", ctx_r3._setRowHeight ? ctx_r3._eventHeight : undefined)("exclusiveEndDates", ctx_r3.exclusiveEndDates)("gridEndTime", ctx_r3._endTime)("gridStartTime", ctx_r3._startTime)("hasResY", ctx_r3._hasResY)("hidden", !!dragData_r47.draggedDates)("isDrag", true)("isTimeline", true)("isListing", ctx_r3.eventList)("lastDay", ctx_r3._lastDay)("resize", ctx_r3._computeEventResize(dragData_r47.originDates[dragKey_r52].original.resize, ctx_r3.dragToResize, ctx_r3._resourcesMap[resource_r48].eventResize))("resource", resource_r48)("rtl", ctx_r3.rtl)("slot", slot_r49)("startDay", ctx_r3.startDay)("theme", ctx_r3.theme)("template", ctx_r3.eventTemplate)("timezonePlugin", ctx_r3.timezonePlugin);
  }
}
function MbscTimeline_ng_template_30_mbsc_schedule_event_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mbsc-schedule-event", 77);
  }
  if (rf & 2) {
    const ctx_r45 = i0.ɵɵnextContext();
    const dragData_r47 = ctx_r45.dragData;
    const dragKey_r52 = ctx_r45.dragKey;
    const resource_r48 = ctx_r45.resource;
    const slot_r49 = ctx_r45.slot;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("bufferAfterTemplate", ctx_r3.bufferAfterTemplate)("bufferBeforeTemplate", ctx_r3.bufferBeforeTemplate)("contentTemplate", ctx_r3.eventContentTemplate)("displayTimezone", ctx_r3.displayTimezone)("drag", ctx_r3.dragToMove || ctx_r3.externalDrag)("endDay", ctx_r3.endDay)("event", dragData_r47.draggedDates[dragKey_r52])("eventHeight", ctx_r3._setRowHeight ? ctx_r3._eventHeight : undefined)("exclusiveEndDates", ctx_r3.exclusiveEndDates)("gridEndTime", ctx_r3._endTime)("gridStartTime", ctx_r3._startTime)("hasResY", ctx_r3._hasResY)("isDrag", true)("isTimeline", true)("isListing", ctx_r3.eventList)("lastDay", ctx_r3._lastDay)("resize", ctx_r3._computeEventResize(dragData_r47.draggedDates[dragKey_r52].original.resize, ctx_r3.dragToResize, ctx_r3._resourcesMap[resource_r48].eventResize))("resource", resource_r48)("rtl", ctx_r3.rtl)("slot", slot_r49)("startDay", ctx_r3.startDay)("theme", ctx_r3.theme)("template", ctx_r3.eventTemplate)("timezonePlugin", ctx_r3.timezonePlugin);
  }
}
function MbscTimeline_ng_template_30_ng_container_4_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 79)(1, "div", 80);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const invalid_r53 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap("mbsc-schedule-invalid mbsc-timeline-invalid" + invalid_r53.cssClass + ctx_r3._theme);
    i0.ɵɵproperty("ngStyle", invalid_r53.position);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(invalid_r53.title);
  }
}
function MbscTimeline_ng_template_30_ng_container_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscTimeline_ng_template_30_ng_container_4_ng_container_1_div_1_Template, 3, 4, "div", 78);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const invalid_r53 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", invalid_r53.position && ctx_r3._checkDisplay(invalid_r53));
  }
}
function MbscTimeline_ng_template_30_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscTimeline_ng_template_30_ng_container_4_ng_container_1_Template, 2, 1, "ng-container", 51);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r45 = i0.ɵɵnextContext();
    const dateKey_r50 = ctx_r45.dateKey;
    const resource_r48 = ctx_r45.resource;
    const slot_r49 = ctx_r45.slot;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3._invalids[resource_r48][slot_r49][dateKey_r50].data)("ngForTrackBy", ctx_r3._getKey);
  }
}
function MbscTimeline_ng_template_30_ng_container_5_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 79)(1, "div", 81);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const color_r54 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap("mbsc-schedule-color mbsc-timeline-color" + color_r54.cssClass + ctx_r3._theme);
    i0.ɵɵproperty("ngStyle", color_r54.position);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(color_r54.title);
  }
}
function MbscTimeline_ng_template_30_ng_container_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscTimeline_ng_template_30_ng_container_5_ng_container_1_div_1_Template, 3, 4, "div", 78);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const color_r54 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3._checkDisplay(color_r54));
  }
}
function MbscTimeline_ng_template_30_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscTimeline_ng_template_30_ng_container_5_ng_container_1_Template, 2, 1, "ng-container", 51);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r45 = i0.ɵɵnextContext();
    const dateKey_r50 = ctx_r45.dateKey;
    const resource_r48 = ctx_r45.resource;
    const slot_r49 = ctx_r45.slot;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3._colors[resource_r48][slot_r49][dateKey_r50].data)("ngForTrackBy", ctx_r3._getKey);
  }
}
function MbscTimeline_ng_template_30_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 71);
    i0.ɵɵtemplate(1, MbscTimeline_ng_template_30_ng_container_1_Template, 2, 2, "ng-container", 46)(2, MbscTimeline_ng_template_30_mbsc_schedule_event_2_Template, 1, 25, "mbsc-schedule-event", 72)(3, MbscTimeline_ng_template_30_mbsc_schedule_event_3_Template, 1, 24, "mbsc-schedule-event", 73);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, MbscTimeline_ng_template_30_ng_container_4_Template, 2, 2, "ng-container", 46)(5, MbscTimeline_ng_template_30_ng_container_5_Template, 2, 2, "ng-container", 46);
  }
  if (rf & 2) {
    const dateKey_r50 = ctx.dateKey;
    const dragData_r47 = ctx.dragData;
    const dragKey_r52 = ctx.dragKey;
    const resource_r48 = ctx.resource;
    const slot_r49 = ctx.slot;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3._events[resource_r48][slot_r49][dateKey_r50]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", dragData_r47 && dragData_r47.originDates && dragData_r47.originDates[dragKey_r52]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", dragData_r47 && dragData_r47.draggedDates && dragData_r47.draggedDates[dragKey_r52]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3._invalids[resource_r48][slot_r49][dateKey_r50]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3._colors[resource_r48][slot_r49][dateKey_r50]);
  }
}
function MbscTimeline_div_34_ng_template_2_Template(rf, ctx) {}
function MbscTimeline_div_34_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 82);
    i0.ɵɵtemplate(2, MbscTimeline_div_34_ng_template_2_Template, 0, 0, "ng-template", 83);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-timeline-resource-header-cont " + ctx_r3._colClass + ctx_r3._theme + ctx_r3._rtl + ctx_r3._hb);
    i0.ɵɵstyleProp("height", ctx_r3.state.headerHeight, "px");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.resourceHeaderTemplate);
  }
}
function MbscTimeline_div_35_ng_container_1_div_1_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(4);
    i0.ɵɵtextInterpolate(ctx_r3._stickyDay.monthText);
  }
}
function MbscTimeline_div_35_ng_container_1_div_1_ng_template_5_Template(rf, ctx) {}
function MbscTimeline_div_35_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", null, 27);
    i0.ɵɵtemplate(3, MbscTimeline_div_35_ng_container_1_div_1_ng_template_3_Template, 1, 1, "ng-template", null, 28, i0.ɵɵtemplateRefExtractor)(5, MbscTimeline_div_35_ng_container_1_div_1_ng_template_5_Template, 0, 0, "ng-template", 56);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const defaultTmpl_r55 = i0.ɵɵreference(4);
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap("mbsc-timeline-header-month" + ctx_r3._theme + ctx_r3._rtl + ctx_r3._hb);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-timeline-header-text " + (ctx_r3.monthTemplate ? "mbsc-timeline-header-month-cont" : "mbsc-timeline-header-month-text") + ctx_r3._theme);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.monthTemplate || defaultTmpl_r55)("ngTemplateOutletContext", i0.ɵɵpureFunction1(11, _c14, i0.ɵɵpureFunction3(7, _c53, ctx_r3._stickyDay.date, ctx_r3._stickyDay.eventMap[ctx_r3._stickyDay.timestamp] || i0.ɵɵpureFunction0(6, _c52), ctx_r3._stickyDay.isActive)));
  }
}
function MbscTimeline_div_35_ng_container_1_div_2_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(4);
    i0.ɵɵtextInterpolate(ctx_r3._stickyDay.weekText);
  }
}
function MbscTimeline_div_35_ng_container_1_div_2_ng_template_5_Template(rf, ctx) {}
function MbscTimeline_div_35_ng_container_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", null, 29);
    i0.ɵɵtemplate(3, MbscTimeline_div_35_ng_container_1_div_2_ng_template_3_Template, 1, 1, "ng-template", null, 28, i0.ɵɵtemplateRefExtractor)(5, MbscTimeline_div_35_ng_container_1_div_2_ng_template_5_Template, 0, 0, "ng-template", 56);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const defaultTmpl_r56 = i0.ɵɵreference(4);
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap("mbsc-timeline-header-week" + ctx_r3._theme + ctx_r3._rtl + ctx_r3._hb);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-timeline-header-text " + (ctx_r3.weekTemplate ? "mbsc-timeline-header-week-cont" : "mbsc-timeline-header-week-text") + ctx_r3._theme);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.weekTemplate || defaultTmpl_r56)("ngTemplateOutletContext", i0.ɵɵpureFunction1(14, _c14, i0.ɵɵpureFunction6(7, _c55, ctx_r3._stickyDay.date, ctx_r3._stickyDay.eventMap[ctx_r3._stickyDay.timestamp] || i0.ɵɵpureFunction0(6, _c52), ctx_r3._stickyDay.isActive, ctx_r3._stickyDay.date, ctx_r3._stickyDay.endDate, ctx_r3._stickyDay.weekNr)));
  }
}
function MbscTimeline_div_35_ng_container_1_div_3_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(4);
    i0.ɵɵtextInterpolate(ctx_r3._stickyDay.dateText);
  }
}
function MbscTimeline_div_35_ng_container_1_div_3_ng_template_5_Template(rf, ctx) {}
function MbscTimeline_div_35_ng_container_1_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", null, 30);
    i0.ɵɵtemplate(3, MbscTimeline_div_35_ng_container_1_div_3_ng_template_3_Template, 1, 1, "ng-template", null, 22, i0.ɵɵtemplateRefExtractor)(5, MbscTimeline_div_35_ng_container_1_div_3_ng_template_5_Template, 0, 0, "ng-template", 56);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const defaultDay_r57 = i0.ɵɵreference(4);
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap("mbsc-timeline-header-date mbsc-flex" + ctx_r3._theme + ctx_r3._rtl + ctx_r3._hb);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-timeline-header-text " + (ctx_r3._stickyDay.isActive && !ctx_r3.dayTemplate ? "mbsc-timeline-header-active " : "") + (ctx_r3.dayTemplate ? "mbsc-timeline-header-date-cont" : "mbsc-timeline-header-date-text") + ctx_r3._theme);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.dayTemplate || defaultDay_r57)("ngTemplateOutletContext", i0.ɵɵpureFunction1(10, _c14, i0.ɵɵpureFunction3(6, _c53, ctx_r3._stickyDay.date, ctx_r3._stickyDay.eventMap.all, ctx_r3._stickyDay.isActive)));
  }
}
function MbscTimeline_div_35_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscTimeline_div_35_ng_container_1_div_1_Template, 6, 13, "div", 41)(2, MbscTimeline_div_35_ng_container_1_div_2_Template, 6, 16, "div", 41)(3, MbscTimeline_div_35_ng_container_1_div_3_Template, 6, 12, "div", 41);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3._isMulti);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.weekNumbers);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3._hasSlots || ctx_r3._stepCell < ctx_r3._oneDay);
  }
}
function MbscTimeline_div_35_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 84);
    i0.ɵɵtemplate(1, MbscTimeline_div_35_ng_container_1_Template, 4, 3, "ng-container", 46);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r3._hasResY);
  }
}
function MbscTimeline_div_36_ng_template_2_Template(rf, ctx) {}
function MbscTimeline_div_36_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 85);
    i0.ɵɵtemplate(2, MbscTimeline_div_36_ng_template_2_Template, 0, 0, "ng-template", 83);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-timeline-sidebar-header-cont mbsc-timeline-sidebar-col" + ctx_r3._theme + ctx_r3._rtl + ctx_r3._hb);
    i0.ɵɵstyleProp("height", ctx_r3.state.headerHeight, "px");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.sidebarHeaderTemplate);
  }
}
function MbscTimeline_div_37_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 86);
  }
}
function MbscTimeline_div_38_div_2_ng_template_2_Template(rf, ctx) {}
function MbscTimeline_div_38_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 87);
    i0.ɵɵtemplate(2, MbscTimeline_div_38_div_2_ng_template_2_Template, 0, 0, "ng-template", 83);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-timeline-resource-footer-cont " + ctx_r3._colClass + ctx_r3._theme + ctx_r3._rtl + ctx_r3._hb);
    i0.ɵɵstyleProp("height", ctx_r3.state.footerHeight, "px");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.resourceFooterTemplate);
  }
}
function MbscTimeline_div_38_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 84);
  }
}
function MbscTimeline_div_38_div_4_ng_template_2_Template(rf, ctx) {}
function MbscTimeline_div_38_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 88);
    i0.ɵɵtemplate(2, MbscTimeline_div_38_div_4_ng_template_2_Template, 0, 0, "ng-template", 83);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-timeline-sidebar-footer-cont mbsc-timeline-sidebar-col" + ctx_r3._theme + ctx_r3._rtl + ctx_r3._hb);
    i0.ɵɵstyleProp("height", ctx_r3.state.footerHeight, "px");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.sidebarFooterTemplate);
  }
}
function MbscTimeline_div_38_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 86);
  }
}
function MbscTimeline_div_38_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", null, 31);
    i0.ɵɵtemplate(2, MbscTimeline_div_38_div_2_Template, 3, 5, "div", 38)(3, MbscTimeline_div_38_div_3_Template, 1, 0, "div", 39)(4, MbscTimeline_div_38_div_4_Template, 3, 5, "div", 38)(5, MbscTimeline_div_38_div_5_Template, 1, 0, "div", 40);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-timeline-footer-sticky mbsc-flex" + ctx_r3._theme);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3._hasRows);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3._isDailyResolution);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3._hasRows && !!ctx_r3.sidebarTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.state.hasScrollY);
  }
}
function MbscTimeline_div_44_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div");
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-timeline-resource-header-cont " + ctx_r3._colClass + ctx_r3._theme + ctx_r3._rtl + ctx_r3._hb);
  }
}
function MbscTimeline_mbsc_time_indicator_47_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mbsc-time-indicator", 89);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("amText", ctx_r3.s.amText)("displayedTime", ctx_r3._time)("displayedDays", ctx_r3._daysNr)("displayTimezone", ctx_r3.displayTimezone)("endDay", ctx_r3.endDay)("firstDay", ctx_r3._firstDayTz)("hasResY", ctx_r3._hasResY)("pmText", ctx_r3.s.pmText)("rtl", ctx_r3.rtl)("startDay", ctx_r3.startDay)("startTime", ctx_r3._startTime)("theme", ctx_r3.theme)("timeFormat", ctx_r3.timeFormat)("timezonePlugin", ctx_r3.timezonePlugin);
  }
}
function MbscTimeline_div_48_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", null, 32);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-schedule-cursor-time mbsc-schedule-cursor-time-y" + ctx_r3._theme);
  }
}
function MbscTimeline_ng_container_51_div_1_ng_container_1_div_1_3_ng_template_0_Template(rf, ctx) {}
function MbscTimeline_ng_container_51_div_1_ng_container_1_div_1_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscTimeline_ng_container_51_div_1_ng_container_1_div_1_3_ng_template_0_Template, 0, 0, "ng-template", 56);
  }
  if (rf & 2) {
    const d_r58 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵnextContext(3);
    const tplMonth_r59 = i0.ɵɵreference(19);
    i0.ɵɵproperty("ngTemplateOutlet", tplMonth_r59)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c56, d_r58));
  }
}
function MbscTimeline_ng_container_51_div_1_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div")(2, "div");
    i0.ɵɵtemplate(3, MbscTimeline_ng_container_51_div_1_ng_container_1_div_1_3_Template, 1, 4, null, 46);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const d_r58 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap("mbsc-timeline-month mbsc-flex-1-0-0" + ctx_r3._theme + ctx_r3._rtl + ctx_r3._hb + (d_r58.dateIndex < ctx_r3._daysNr - 1 && d_r58.lastOfMonth ? " mbsc-timeline-day mbsc-timeline-day-border" : ""));
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-timeline-header-month" + ctx_r3._theme + ctx_r3._rtl + ctx_r3._hb + (d_r58.lastOfMonth ? " mbsc-timeline-header-month-last" : ""));
    i0.ɵɵadvance();
    i0.ɵɵclassMap((ctx_r3.monthTemplate ? "mbsc-timeline-header-month-cont" : "mbsc-timeline-header-month-text") + (d_r58.lastOfMonth ? " mbsc-timeline-header-month-text-last" : "") + ctx_r3._theme);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", d_r58.monthTitle);
  }
}
function MbscTimeline_ng_container_51_div_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscTimeline_ng_container_51_div_1_ng_container_1_div_1_Template, 4, 7, "div", 41);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const d_r58 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", d_r58.dateKey !== ctx_r3._dragCol);
  }
}
function MbscTimeline_ng_container_51_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 90);
    i0.ɵɵtemplate(1, MbscTimeline_ng_container_51_div_1_ng_container_1_Template, 2, 1, "ng-container", 51);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3._daysBatch)("ngForTrackBy", ctx_r3._getDayKey);
  }
}
function MbscTimeline_ng_container_51_div_2_ng_container_1_div_1_3_ng_template_0_Template(rf, ctx) {}
function MbscTimeline_ng_container_51_div_2_ng_container_1_div_1_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscTimeline_ng_container_51_div_2_ng_container_1_div_1_3_ng_template_0_Template, 0, 0, "ng-template", 56);
  }
  if (rf & 2) {
    const d_r60 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵnextContext(3);
    const tplWeek_r61 = i0.ɵɵreference(15);
    i0.ɵɵproperty("ngTemplateOutlet", tplWeek_r61)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c57, d_r60));
  }
}
function MbscTimeline_ng_container_51_div_2_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div")(2, "div");
    i0.ɵɵtemplate(3, MbscTimeline_ng_container_51_div_2_ng_container_1_div_1_3_Template, 1, 4, null, 46);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const d_r60 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap("mbsc-timeline-month mbsc-flex-1-0-0" + ctx_r3._theme + ctx_r3._rtl + ctx_r3._hb + (d_r60.dateIndex < ctx_r3._daysNr - 1 && d_r60.lastOfWeek && (ctx_r3._stepCell < ctx_r3._oneDay || d_r60.lastOfMonth) ? " mbsc-timeline-day mbsc-timeline-day-border" : ""));
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-timeline-header-week" + ctx_r3._theme + ctx_r3._rtl + ctx_r3._hb + (d_r60.lastOfWeek ? " mbsc-timeline-header-week-last" : ""));
    i0.ɵɵadvance();
    i0.ɵɵclassMap((ctx_r3.weekTemplate ? "mbsc-timeline-header-week-cont" : "mbsc-timeline-header-week-text") + (d_r60.lastOfWeek ? " mbsc-timeline-header-week-text-last" : "") + ctx_r3._theme);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", d_r60.weekTitle);
  }
}
function MbscTimeline_ng_container_51_div_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscTimeline_ng_container_51_div_2_ng_container_1_div_1_Template, 4, 7, "div", 41);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const d_r60 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", d_r60.dateKey !== ctx_r3._dragCol);
  }
}
function MbscTimeline_ng_container_51_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 90);
    i0.ɵɵtemplate(1, MbscTimeline_ng_container_51_div_2_ng_container_1_Template, 2, 1, "ng-container", 51);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3._daysBatch)("ngForTrackBy", ctx_r3._getDayKey);
  }
}
function MbscTimeline_ng_container_51_ng_container_4_div_1_div_1_ng_template_1_Template(rf, ctx) {}
function MbscTimeline_ng_container_51_ng_container_4_div_1_div_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 94);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const d_r62 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(d_r62.label);
  }
}
function MbscTimeline_ng_container_51_ng_container_4_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MbscTimeline_ng_container_51_ng_container_4_div_1_div_1_ng_template_1_Template, 0, 0, "ng-template", 56)(2, MbscTimeline_ng_container_51_ng_container_4_div_1_div_1_div_2_Template, 2, 1, "div", 93);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const d_r62 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    const tplDay_r63 = i0.ɵɵreference(11);
    i0.ɵɵclassMap("mbsc-timeline-header-date" + ctx_r3._theme + ctx_r3._rtl + ctx_r3._hb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", tplDay_r63)("ngTemplateOutletContext", i0.ɵɵpureFunction1(5, _c58, d_r62));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", d_r62.label);
  }
}
function MbscTimeline_ng_container_51_ng_container_4_div_1_div_2_div_1_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const slot_r64 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵtextInterpolate1(" ", slot_r64.name, " ");
  }
}
function MbscTimeline_ng_container_51_ng_container_4_div_1_div_2_div_1_ng_template_4_Template(rf, ctx) {}
function MbscTimeline_ng_container_51_ng_container_4_div_1_div_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 95);
    i0.ɵɵtemplate(2, MbscTimeline_ng_container_51_ng_container_4_div_1_div_2_div_1_ng_template_2_Template, 1, 1, "ng-template", null, 33, i0.ɵɵtemplateRefExtractor)(4, MbscTimeline_ng_container_51_ng_container_4_div_1_div_2_div_1_ng_template_4_Template, 0, 0, "ng-template", 56);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const slot_r64 = ctx.$implicit;
    const defaultSlot_r65 = i0.ɵɵreference(3);
    const d_r62 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-timeline-slot mbsc-timeline-slot-header mbsc-flex-1-1" + ctx_r3._rtl + ctx_r3._theme);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r3.slotTemplate || defaultSlot_r65)("ngTemplateOutletContext", i0.ɵɵpureFunction1(7, _c14, i0.ɵɵpureFunction2(4, _c59, slot_r64, d_r62.date)));
  }
}
function MbscTimeline_ng_container_51_ng_container_4_div_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MbscTimeline_ng_container_51_ng_container_4_div_1_div_2_div_1_Template, 5, 9, "div", 62);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(4);
    i0.ɵɵclassMap("mbsc-flex mbsc-timeline-slots" + ctx_r3._theme);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3._slots)("ngForTrackBy", ctx_r3._getId);
  }
}
function MbscTimeline_ng_container_51_ng_container_4_div_1_div_4_1_ng_template_0_Template(rf, ctx) {}
function MbscTimeline_ng_container_51_ng_container_4_div_1_div_4_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscTimeline_ng_container_51_ng_container_4_div_1_div_4_1_ng_template_0_Template, 0, 0, "ng-template", 56);
  }
  if (rf & 2) {
    const t_r66 = i0.ɵɵnextContext().$implicit;
    const d_r62 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵnextContext(2);
    const tplHour_r67 = i0.ɵɵreference(7);
    i0.ɵɵproperty("ngTemplateOutlet", tplHour_r67)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c60, d_r62, t_r66));
  }
}
function MbscTimeline_ng_container_51_ng_container_4_div_1_div_4_ng_container_2_1_ng_template_0_Template(rf, ctx) {}
function MbscTimeline_ng_container_51_ng_container_4_div_1_div_4_ng_container_2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscTimeline_ng_container_51_ng_container_4_div_1_div_4_ng_container_2_1_ng_template_0_Template, 0, 0, "ng-template", 56);
  }
  if (rf & 2) {
    const j_r68 = i0.ɵɵnextContext().index;
    const t_r66 = i0.ɵɵnextContext().$implicit;
    const d_r62 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    const tplHour_r67 = i0.ɵɵreference(7);
    i0.ɵɵproperty("ngTemplateOutlet", tplHour_r67)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c60, d_r62, t_r66 + (j_r68 + 1) * ctx_r3._stepLabel));
  }
}
function MbscTimeline_ng_container_51_ng_container_4_div_1_div_4_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscTimeline_ng_container_51_ng_container_4_div_1_div_4_ng_container_2_1_Template, 1, 5, null, 46);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const j_r68 = ctx.index;
    const t_r66 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", t_r66 + (j_r68 + 1) * ctx_r3._stepLabel > ctx_r3._startTime && t_r66 + (j_r68 + 1) * ctx_r3._stepLabel < ctx_r3._endTime);
  }
}
function MbscTimeline_ng_container_51_ng_container_4_div_1_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 79);
    i0.ɵɵtemplate(1, MbscTimeline_ng_container_51_ng_container_4_div_1_div_4_1_Template, 1, 5, null, 46)(2, MbscTimeline_ng_container_51_ng_container_4_div_1_div_4_ng_container_2_Template, 2, 1, "ng-container", 51);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r69 = ctx.index;
    const first_r70 = ctx.first;
    const last_r71 = ctx.last;
    const ctx_r3 = i0.ɵɵnextContext(4);
    i0.ɵɵclassMap("mbsc-flex mbsc-flex-1-1 mbsc-timeline-header-column" + ctx_r3._theme + ctx_r3._rtl + ctx_r3._hb + (!ctx_r3._displayTime || ctx_r3._hasSlots ? " mbsc-timeline-no-height" : "") + (ctx_r3._stepLabel > ctx_r3._stepCell && ctx_r3._times[i_r69 + 1] % ctx_r3._stepLabel ? " mbsc-timeline-no-border" : "") + (first_r70 && !last_r71 && ctx_r3._startCellStyle || last_r71 && !first_r70 && ctx_r3._endCellStyle ? " mbsc-flex-none" : ""));
    i0.ɵɵproperty("ngStyle", first_r70 && !last_r71 ? ctx_r3._startCellStyle : last_r71 && !first_r70 ? ctx_r3._endCellStyle : i0.ɵɵpureFunction0(6, _c40));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3._displayTime);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3._timesBetween)("ngForTrackBy", ctx_r3._getKey);
  }
}
function MbscTimeline_ng_container_51_ng_container_4_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MbscTimeline_ng_container_51_ng_container_4_div_1_div_1_Template, 3, 7, "div", 41)(2, MbscTimeline_ng_container_51_ng_container_4_div_1_div_2_Template, 2, 4, "div", 41);
    i0.ɵɵelementStart(3, "div", 91);
    i0.ɵɵtemplate(4, MbscTimeline_ng_container_51_ng_container_4_div_1_div_4_Template, 3, 7, "div", 92);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const d_r62 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-timeline-day mbsc-flex-1-0-0" + ctx_r3._theme + ctx_r3._rtl + ctx_r3._hb + (d_r62.dateIndex < ctx_r3._daysNr - 1 && (ctx_r3._stepCell < ctx_r3._oneDay || d_r62.lastOfMonth) ? " mbsc-timeline-day-border" : "") + (ctx_r3.type === "month" || ctx_r3._isMulti ? " mbsc-timeline-day-month" : ""));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r3._hasResY);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3._hasSlots);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r3._times)("ngForTrackBy", ctx_r3._getKey);
  }
}
function MbscTimeline_ng_container_51_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscTimeline_ng_container_51_ng_container_4_div_1_Template, 5, 6, "div", 41);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const d_r62 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", d_r62.dateKey !== ctx_r3._dragCol);
  }
}
function MbscTimeline_ng_container_51_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscTimeline_ng_container_51_div_1_Template, 2, 2, "div", 47)(2, MbscTimeline_ng_container_51_div_2_Template, 2, 2, "div", 47);
    i0.ɵɵelementStart(3, "div", 90);
    i0.ɵɵtemplate(4, MbscTimeline_ng_container_51_ng_container_4_Template, 2, 1, "ng-container", 51);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3._isMulti && !ctx_r3._hasResY);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.s.weekNumbers);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r3._daysBatch)("ngForTrackBy", ctx_r3._getDayKey);
  }
}
function MbscTimeline_div_52_ng_container_1_div_1_ng_container_3_2_ng_template_0_Template(rf, ctx) {}
function MbscTimeline_div_52_ng_container_1_div_1_ng_container_3_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscTimeline_div_52_ng_container_1_div_1_ng_container_3_2_ng_template_0_Template, 0, 0, "ng-template", 56);
  }
  if (rf & 2) {
    const d_r72 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵnextContext(2);
    const tplWeek_r61 = i0.ɵɵreference(15);
    i0.ɵɵproperty("ngTemplateOutlet", tplWeek_r61)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c57, d_r72));
  }
}
function MbscTimeline_div_52_ng_container_1_div_1_ng_container_3_3_ng_template_0_Template(rf, ctx) {}
function MbscTimeline_div_52_ng_container_1_div_1_ng_container_3_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscTimeline_div_52_ng_container_1_div_1_ng_container_3_3_ng_template_0_Template, 0, 0, "ng-template", 56);
  }
  if (rf & 2) {
    const d_r72 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵnextContext(2);
    const tplMonth_r59 = i0.ɵɵreference(19);
    i0.ɵɵproperty("ngTemplateOutlet", tplMonth_r59)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c56, d_r72));
  }
}
function MbscTimeline_div_52_ng_container_1_div_1_ng_container_3_4_ng_template_0_Template(rf, ctx) {}
function MbscTimeline_div_52_ng_container_1_div_1_ng_container_3_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscTimeline_div_52_ng_container_1_div_1_ng_container_3_4_ng_template_0_Template, 0, 0, "ng-template", 56);
  }
  if (rf & 2) {
    const d_r72 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵnextContext(2);
    const tplQuarter_r73 = i0.ɵɵreference(23);
    i0.ɵɵproperty("ngTemplateOutlet", tplQuarter_r73)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c61, d_r72));
  }
}
function MbscTimeline_div_52_ng_container_1_div_1_ng_container_3_5_ng_template_0_Template(rf, ctx) {}
function MbscTimeline_div_52_ng_container_1_div_1_ng_container_3_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscTimeline_div_52_ng_container_1_div_1_ng_container_3_5_ng_template_0_Template, 0, 0, "ng-template", 56);
  }
  if (rf & 2) {
    const d_r72 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵnextContext(2);
    const tplYear_r74 = i0.ɵɵreference(27);
    i0.ɵɵproperty("ngTemplateOutlet", tplYear_r74)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c62, d_r72));
  }
}
function MbscTimeline_div_52_ng_container_1_div_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 97);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtemplate(2, MbscTimeline_div_52_ng_container_1_div_1_ng_container_3_2_Template, 1, 4, null, 98)(3, MbscTimeline_div_52_ng_container_1_div_1_ng_container_3_3_Template, 1, 4, null, 98)(4, MbscTimeline_div_52_ng_container_1_div_1_ng_container_3_4_Template, 1, 4, null, 98)(5, MbscTimeline_div_52_ng_container_1_div_1_ng_container_3_5_Template, 1, 4, null, 98);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngSwitch", ctx_r3.resolution);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-timeline-header-" + ctx_r3.resolution + "-cont");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "week");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "month");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "quarter");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "year");
  }
}
function MbscTimeline_div_52_ng_container_1_div_1_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const d_r72 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵtextInterpolate(d_r72.columnTitle);
  }
}
function MbscTimeline_div_52_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div")(2, "div");
    i0.ɵɵtemplate(3, MbscTimeline_div_52_ng_container_1_div_1_ng_container_3_Template, 6, 7, "ng-container", 96)(4, MbscTimeline_div_52_ng_container_1_div_1_ng_template_4_Template, 1, 1, "ng-template", null, 34, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const defaultTitle_r75 = i0.ɵɵreference(5);
    const d_r72 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-timeline-day mbsc-flex-1-0-0" + ctx_r3._theme + ctx_r3._rtl + ctx_r3._hb);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-timeline-header-week mbsc-timeline-header-week-last" + ctx_r3._theme + ctx_r3._rtl + ctx_r3._hb);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-timeline-header-week-text mbsc-timeline-header-week-text-last" + (d_r72.isActive && !(ctx_r3.weekTemplate || ctx_r3.dayTemplate || ctx_r3.monthTemplate || ctx_r3.quarterTemplate || ctx_r3.yearTemplate) ? " mbsc-timeline-header-active" : "") + ctx_r3._theme);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.weekTemplate || ctx_r3.monthTemplate || ctx_r3.quarterTemplate || ctx_r3.yearTemplate)("ngIfElse", defaultTitle_r75);
  }
}
function MbscTimeline_div_52_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscTimeline_div_52_ng_container_1_div_1_Template, 6, 8, "div", 41);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const d_r72 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", d_r72.dateKey !== ctx_r3._dragCol);
  }
}
function MbscTimeline_div_52_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 90);
    i0.ɵɵtemplate(1, MbscTimeline_div_52_ng_container_1_Template, 2, 1, "ng-container", 51);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3._daysBatch)("ngForTrackBy", ctx_r3._getDayKey);
  }
}
function MbscTimeline_div_53_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div");
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-timeline-sidebar-header-cont mbsc-timeline-sidebar-col" + ctx_r3._theme + ctx_r3._rtl + ctx_r3._hb);
  }
}
function MbscTimeline_div_56_ng_container_5_ng_container_1_1_ng_template_0_Template(rf, ctx) {}
function MbscTimeline_div_56_ng_container_5_ng_container_1_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscTimeline_div_56_ng_container_5_ng_container_1_1_ng_template_0_Template, 0, 0, "ng-template", 56);
  }
  if (rf & 2) {
    const r_r76 = ctx.$implicit;
    i0.ɵɵnextContext(4);
    const tplResource_r77 = i0.ɵɵreference(1);
    i0.ɵɵproperty("ngTemplateOutlet", tplResource_r77)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c63, r_r76, r_r76.id));
  }
}
function MbscTimeline_div_56_ng_container_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscTimeline_div_56_ng_container_5_ng_container_1_1_Template, 1, 5, null, 51);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const rowGroup_r78 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", rowGroup_r78.rows)("ngForTrackBy", ctx_r3._getId);
  }
}
function MbscTimeline_div_56_ng_container_5_ng_container_2_div_1_ng_template_2_Template(rf, ctx) {}
function MbscTimeline_div_56_ng_container_5_ng_container_2_div_1_4_ng_template_0_Template(rf, ctx) {}
function MbscTimeline_div_56_ng_container_5_ng_container_2_div_1_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscTimeline_div_56_ng_container_5_ng_container_2_div_1_4_ng_template_0_Template, 0, 0, "ng-template", 56);
  }
  if (rf & 2) {
    const r_r79 = ctx.$implicit;
    const rowGroup_r78 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵnextContext(2);
    const tplResource_r77 = i0.ɵɵreference(1);
    i0.ɵɵproperty("ngTemplateOutlet", tplResource_r77)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c63, r_r79, rowGroup_r78.day.dateKey + "-" + r_r79.id));
  }
}
function MbscTimeline_div_56_ng_container_5_ng_container_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div");
    i0.ɵɵtemplate(2, MbscTimeline_div_56_ng_container_5_ng_container_2_div_1_ng_template_2_Template, 0, 0, "ng-template", 56);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 100);
    i0.ɵɵtemplate(4, MbscTimeline_div_56_ng_container_5_ng_container_2_div_1_4_Template, 1, 5, null, 51);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const rowGroup_r78 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    const tplDay_r63 = i0.ɵɵreference(11);
    i0.ɵɵclassMap("mbsc-timeline-row-group mbsc-flex mbsc-flex-1-0" + ctx_r3._theme + ctx_r3._hb);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-timeline-row-date mbsc-timeline-row-date-col mbsc-flex-none" + ctx_r3._rtl + ctx_r3._theme + ctx_r3._hb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", tplDay_r63)("ngTemplateOutletContext", i0.ɵɵpureFunction1(8, _c58, rowGroup_r78.day));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", rowGroup_r78.rows)("ngForTrackBy", ctx_r3._getId);
  }
}
function MbscTimeline_div_56_ng_container_5_ng_container_2_div_2_ng_template_1_Template(rf, ctx) {}
function MbscTimeline_div_56_ng_container_5_ng_container_2_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MbscTimeline_div_56_ng_container_5_ng_container_2_div_2_ng_template_1_Template, 0, 0, "ng-template", 56);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const rowGroup_r78 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    const tplDay_r63 = i0.ɵɵreference(11);
    i0.ɵɵclassMap("mbsc-timeline-row-date mbsc-flex-1-0" + ctx_r3._rtl + ctx_r3._theme + ctx_r3._hb);
    i0.ɵɵstyleProp("min-height", ctx_r3._rowHeights[rowGroup_r78.day.dateKey + "-" + ctx_r3._defId]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", tplDay_r63)("ngTemplateOutletContext", i0.ɵɵpureFunction1(6, _c58, rowGroup_r78.day));
  }
}
function MbscTimeline_div_56_ng_container_5_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscTimeline_div_56_ng_container_5_ng_container_2_div_1_Template, 5, 10, "div", 41)(2, MbscTimeline_div_56_ng_container_5_ng_container_2_div_2_Template, 2, 8, "div", 99);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3._hasResources);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r3._hasResources);
  }
}
function MbscTimeline_div_56_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscTimeline_div_56_ng_container_5_ng_container_1_Template, 2, 2, "ng-container", 46)(2, MbscTimeline_div_56_ng_container_5_ng_container_2_Template, 3, 2, "ng-container", 46);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const rowGroup_r78 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !rowGroup_r78.day && !rowGroup_r78.hidden);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", rowGroup_r78.day && !rowGroup_r78.hidden);
  }
}
function MbscTimeline_div_56_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", null, 35);
    i0.ɵɵelement(2, "div");
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵelement(4, "div", 45);
    i0.ɵɵtemplate(5, MbscTimeline_div_56_ng_container_5_Template, 3, 2, "ng-container", 51);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "div");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-timeline-resources mbsc-flex-col " + ctx_r3._colClass + ctx_r3._theme + ctx_r3._rtl);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap("mbsc-flex-none");
    i0.ɵɵstyleProp("height", ctx_r3._hasSticky ? undefined : ctx_r3.state.headerHeight, "px");
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-timeline-resource-bg mbsc-flex-1-1" + (ctx_r3._hasHierarchy || ctx_r3.state.hasScrollY ? "" : " mbsc-flex-col") + ctx_r3._theme);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("height", ctx_r3._placeholderSizeY, "px");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3._rowBatch)("ngForTrackBy", ctx_r3._getRowKey);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-flex-none");
    i0.ɵɵstyleProp("height", ctx_r3._hasSticky ? undefined : ctx_r3.state.footerHeight, "px");
  }
}
function MbscTimeline_div_57_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div");
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r3._hasSideSticky ? "" : ctx_r3._colClass);
  }
}
function MbscTimeline_ng_container_65_ng_container_1_1_ng_template_0_Template(rf, ctx) {}
function MbscTimeline_ng_container_65_ng_container_1_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscTimeline_ng_container_65_ng_container_1_1_ng_template_0_Template, 0, 0, "ng-template", 56);
  }
  if (rf & 2) {
    const r_r80 = ctx.$implicit;
    const rowGroup_r81 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵnextContext();
    const tplRow_r82 = i0.ɵɵreference(5);
    i0.ɵɵproperty("ngTemplateOutlet", tplRow_r82)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c64, r_r80, rowGroup_r81.day ? rowGroup_r81.day.dateKey : ""));
  }
}
function MbscTimeline_ng_container_65_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscTimeline_ng_container_65_ng_container_1_1_Template, 1, 5, null, 51);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const rowGroup_r81 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", rowGroup_r81.rows)("ngForTrackBy", ctx_r3._getId);
  }
}
function MbscTimeline_ng_container_65_ng_container_2_2_ng_template_0_Template(rf, ctx) {}
function MbscTimeline_ng_container_65_ng_container_2_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscTimeline_ng_container_65_ng_container_2_2_ng_template_0_Template, 0, 0, "ng-template", 56);
  }
  if (rf & 2) {
    const r_r83 = ctx.$implicit;
    const rowGroup_r81 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵnextContext();
    const tplRow_r82 = i0.ɵɵreference(5);
    i0.ɵɵproperty("ngTemplateOutlet", tplRow_r82)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c64, r_r83, rowGroup_r81.day.dateKey));
  }
}
function MbscTimeline_ng_container_65_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtemplate(2, MbscTimeline_ng_container_65_ng_container_2_2_Template, 1, 5, null, 51);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const rowGroup_r81 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-timeline-row-group mbsc-flex-col mbsc-flex-1-0" + ctx_r3._theme + ctx_r3._hb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", rowGroup_r81.rows)("ngForTrackBy", ctx_r3._getId);
  }
}
function MbscTimeline_ng_container_65_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscTimeline_ng_container_65_ng_container_1_Template, 2, 2, "ng-container", 46)(2, MbscTimeline_ng_container_65_ng_container_2_Template, 3, 4, "ng-container", 46);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const rowGroup_r81 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !rowGroup_r81.day || !ctx_r3._hasResources);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", rowGroup_r81.day && ctx_r3._hasResources);
  }
}
function MbscTimeline__svg_svg_66__svg_ng_container_1__svg_path_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "path", 103);
  }
  if (rf & 2) {
    const c_r84 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("stroke", c_r84.color)("fill", c_r84.fill);
    i0.ɵɵattribute("d", c_r84.pathD)("class", "mbsc-connection " + c_r84.cssClass + ctx_r3._theme);
  }
}
function MbscTimeline__svg_svg_66__svg_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscTimeline__svg_svg_66__svg_ng_container_1__svg_path_1_Template, 1, 6, "path", 102);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const c_r84 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3._checkDisplay(c_r84));
  }
}
function MbscTimeline__svg_svg_66_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 101);
    i0.ɵɵtemplate(1, MbscTimeline__svg_svg_66__svg_ng_container_1_Template, 2, 1, "ng-container", 51);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵattribute("class", "mbsc-connections" + ctx_r3._theme);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3._connections)("ngForTrackBy", ctx_r3._getId);
  }
}
function MbscTimeline_div_67_ng_container_5_ng_container_1_1_ng_template_0_Template(rf, ctx) {}
function MbscTimeline_div_67_ng_container_5_ng_container_1_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscTimeline_div_67_ng_container_5_ng_container_1_1_ng_template_0_Template, 0, 0, "ng-template", 56);
  }
  if (rf & 2) {
    const r_r85 = ctx.$implicit;
    i0.ɵɵnextContext(4);
    const tplSidebar_r86 = i0.ɵɵreference(3);
    i0.ɵɵproperty("ngTemplateOutlet", tplSidebar_r86)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c63, r_r85, r_r85.id));
  }
}
function MbscTimeline_div_67_ng_container_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscTimeline_div_67_ng_container_5_ng_container_1_1_Template, 1, 5, null, 51);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const rowGroup_r87 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", rowGroup_r87.rows)("ngForTrackBy", ctx_r3._getId);
  }
}
function MbscTimeline_div_67_ng_container_5_ng_container_2_2_ng_template_0_Template(rf, ctx) {}
function MbscTimeline_div_67_ng_container_5_ng_container_2_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscTimeline_div_67_ng_container_5_ng_container_2_2_ng_template_0_Template, 0, 0, "ng-template", 56);
  }
  if (rf & 2) {
    const r_r88 = ctx.$implicit;
    const rowGroup_r87 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵnextContext(2);
    const tplSidebar_r86 = i0.ɵɵreference(3);
    i0.ɵɵproperty("ngTemplateOutlet", tplSidebar_r86)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c63, r_r88, rowGroup_r87.day.dateKey + "-" + r_r88.id));
  }
}
function MbscTimeline_div_67_ng_container_5_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtemplate(2, MbscTimeline_div_67_ng_container_5_ng_container_2_2_Template, 1, 5, null, 51);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const rowGroup_r87 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-timeline-row-group mbsc-flex-col mbsc-flex-1-0" + ctx_r3._theme + ctx_r3._hb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", rowGroup_r87.rows)("ngForTrackBy", ctx_r3._getId);
  }
}
function MbscTimeline_div_67_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscTimeline_div_67_ng_container_5_ng_container_1_Template, 2, 2, "ng-container", 46)(2, MbscTimeline_div_67_ng_container_5_ng_container_2_Template, 3, 4, "ng-container", 46);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const rowGroup_r87 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !rowGroup_r87.day);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", rowGroup_r87.day);
  }
}
function MbscTimeline_div_67_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", null, 36);
    i0.ɵɵelement(2, "div");
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵelement(4, "div", 45);
    i0.ɵɵtemplate(5, MbscTimeline_div_67_ng_container_5_Template, 3, 2, "ng-container", 51);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "div");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-timeline-sidebar mbsc-timeline-sidebar-col mbsc-flex-col" + ctx_r3._theme + ctx_r3._rtl);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap("mbsc-flex-none");
    i0.ɵɵstyleProp("height", ctx_r3._hasSticky ? undefined : ctx_r3.state.headerHeight, "px");
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-timeline-resource-bg mbsc-flex-1-1" + (ctx_r3._hasHierarchy || ctx_r3.state.hasScrollY ? "" : " mbsc-flex-col") + ctx_r3._theme);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("height", ctx_r3._placeholderSizeY, "px");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3._rowBatch)("ngForTrackBy", ctx_r3._getRowKey);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-flex-none");
    i0.ɵɵstyleProp("height", ctx_r3._hasSticky ? undefined : ctx_r3.state.footerHeight, "px");
  }
}
function MbscTimeline_div_68_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div");
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r3._hasSideSticky ? "" : "mbsc-timeline-sidebar-col");
  }
}
function MbscTimeline_ng_container_69_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div");
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-timeline-resource-footer-cont " + ctx_r3._colClass + ctx_r3._theme + ctx_r3._rtl + ctx_r3._hb);
  }
}
function MbscTimeline_ng_container_69_div_8_ng_container_1_div_1_div_2_1_ng_template_0_Template(rf, ctx) {}
function MbscTimeline_ng_container_69_div_8_ng_container_1_div_1_div_2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscTimeline_ng_container_69_div_8_ng_container_1_div_1_div_2_1_ng_template_0_Template, 0, 0, "ng-template", 56);
  }
  if (rf & 2) {
    const t_r89 = i0.ɵɵnextContext().$implicit;
    const d_r90 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵnextContext(3);
    const tplHourFooter_r91 = i0.ɵɵreference(9);
    i0.ɵɵproperty("ngTemplateOutlet", tplHourFooter_r91)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c60, d_r90, t_r89));
  }
}
function MbscTimeline_ng_container_69_div_8_ng_container_1_div_1_div_2_ng_container_2_1_ng_template_0_Template(rf, ctx) {}
function MbscTimeline_ng_container_69_div_8_ng_container_1_div_1_div_2_ng_container_2_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscTimeline_ng_container_69_div_8_ng_container_1_div_1_div_2_ng_container_2_1_ng_template_0_Template, 0, 0, "ng-template", 56);
  }
  if (rf & 2) {
    const j_r92 = i0.ɵɵnextContext().index;
    const t_r89 = i0.ɵɵnextContext().$implicit;
    const d_r90 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r3 = i0.ɵɵnextContext(3);
    const tplHourFooter_r91 = i0.ɵɵreference(9);
    i0.ɵɵproperty("ngTemplateOutlet", tplHourFooter_r91)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c60, d_r90, t_r89 + (j_r92 + 1) * ctx_r3._stepLabel));
  }
}
function MbscTimeline_ng_container_69_div_8_ng_container_1_div_1_div_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscTimeline_ng_container_69_div_8_ng_container_1_div_1_div_2_ng_container_2_1_Template, 1, 5, null, 46);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const j_r92 = ctx.index;
    const t_r89 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", t_r89 + (j_r92 + 1) * ctx_r3._stepLabel > ctx_r3._startTime && t_r89 + (j_r92 + 1) * ctx_r3._stepLabel < ctx_r3._endTime);
  }
}
function MbscTimeline_ng_container_69_div_8_ng_container_1_div_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 79);
    i0.ɵɵtemplate(1, MbscTimeline_ng_container_69_div_8_ng_container_1_div_1_div_2_1_Template, 1, 5, null, 46)(2, MbscTimeline_ng_container_69_div_8_ng_container_1_div_1_div_2_ng_container_2_Template, 2, 1, "ng-container", 51);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const i_r93 = ctx.index;
    const first_r94 = ctx.first;
    const last_r95 = ctx.last;
    const ctx_r3 = i0.ɵɵnextContext(5);
    i0.ɵɵclassMap("mbsc-flex mbsc-flex-1-1 mbsc-timeline-column mbsc-timeline-footer-column" + ctx_r3._theme + ctx_r3._rtl + ctx_r3._hb + (!ctx_r3._displayTime || ctx_r3._hasSlots ? " mbsc-timeline-no-height" : "") + (ctx_r3._stepLabel > ctx_r3._stepCell && ctx_r3._times[i_r93 + 1] % ctx_r3._stepLabel ? " mbsc-timeline-no-border" : "") + (first_r94 && !last_r95 && ctx_r3._startCellStyle || last_r95 && !first_r94 && ctx_r3._endCellStyle ? " mbsc-flex-none" : ""));
    i0.ɵɵproperty("ngStyle", first_r94 && !last_r95 ? ctx_r3._startCellStyle : last_r95 && !first_r94 ? ctx_r3._endCellStyle : i0.ɵɵpureFunction0(6, _c40));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3._displayTime);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3._timesBetween)("ngForTrackBy", ctx_r3._getKey);
  }
}
function MbscTimeline_ng_container_69_div_8_ng_container_1_div_1_div_3_ng_template_1_Template(rf, ctx) {}
function MbscTimeline_ng_container_69_div_8_ng_container_1_div_1_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MbscTimeline_ng_container_69_div_8_ng_container_1_div_1_div_3_ng_template_1_Template, 0, 0, "ng-template", 56);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const d_r90 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r3 = i0.ɵɵnextContext(3);
    const tplDayFooter_r96 = i0.ɵɵreference(13);
    i0.ɵɵclassMap("mbsc-timeline-footer-date" + ctx_r3._theme + ctx_r3._rtl + ctx_r3._hb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", tplDayFooter_r96)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c58, d_r90));
  }
}
function MbscTimeline_ng_container_69_div_8_ng_container_1_div_1_div_4_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div");
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(6);
    i0.ɵɵclassMap("mbsc-timeline-slot mbsc-flex-1-1" + ctx_r3._rtl + ctx_r3._theme);
  }
}
function MbscTimeline_ng_container_69_div_8_ng_container_1_div_1_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 90);
    i0.ɵɵtemplate(1, MbscTimeline_ng_container_69_div_8_ng_container_1_div_1_div_4_div_1_Template, 1, 2, "div", 62);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3._slots)("ngForTrackBy", ctx_r3._getId);
  }
}
function MbscTimeline_ng_container_69_div_8_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 90);
    i0.ɵɵtemplate(2, MbscTimeline_ng_container_69_div_8_ng_container_1_div_1_div_2_Template, 3, 7, "div", 92);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, MbscTimeline_ng_container_69_div_8_ng_container_1_div_1_div_3_Template, 2, 6, "div", 41)(4, MbscTimeline_ng_container_69_div_8_ng_container_1_div_1_div_4_Template, 2, 2, "div", 47);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const d_r90 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap("mbsc-timeline-day mbsc-flex-1-0-0" + ctx_r3._theme + ctx_r3._rtl + ctx_r3._hb + (d_r90.dateIndex < ctx_r3._daysNr - 1 && (ctx_r3._stepCell < ctx_r3._oneDay || d_r90.lastOfMonth) ? " mbsc-timeline-day-border" : "") + (ctx_r3.type === "month" || ctx_r3._isMulti ? " mbsc-timeline-day-month" : ""));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r3._times)("ngForTrackBy", ctx_r3._getKey);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.dayFooterTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3._hasSlots);
  }
}
function MbscTimeline_ng_container_69_div_8_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscTimeline_ng_container_69_div_8_ng_container_1_div_1_Template, 5, 6, "div", 41);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const d_r90 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", d_r90.dateKey !== ctx_r3._dragCol);
  }
}
function MbscTimeline_ng_container_69_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 90);
    i0.ɵɵtemplate(1, MbscTimeline_ng_container_69_div_8_ng_container_1_Template, 2, 1, "ng-container", 51);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3._daysBatch)("ngForTrackBy", ctx_r3._getDayKey);
  }
}
function MbscTimeline_ng_container_69_div_9_ng_container_1_div_1_ng_container_3_1_ng_template_0_Template(rf, ctx) {}
function MbscTimeline_ng_container_69_div_9_ng_container_1_div_1_ng_container_3_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscTimeline_ng_container_69_div_9_ng_container_1_div_1_ng_container_3_1_ng_template_0_Template, 0, 0, "ng-template", 56);
  }
  if (rf & 2) {
    const d_r97 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵnextContext(3);
    const tplWeekFooter_r98 = i0.ɵɵreference(17);
    i0.ɵɵproperty("ngTemplateOutlet", tplWeekFooter_r98)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c57, d_r97));
  }
}
function MbscTimeline_ng_container_69_div_9_ng_container_1_div_1_ng_container_3_2_ng_template_0_Template(rf, ctx) {}
function MbscTimeline_ng_container_69_div_9_ng_container_1_div_1_ng_container_3_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscTimeline_ng_container_69_div_9_ng_container_1_div_1_ng_container_3_2_ng_template_0_Template, 0, 0, "ng-template", 56);
  }
  if (rf & 2) {
    const d_r97 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵnextContext(3);
    const tplMonthFooter_r99 = i0.ɵɵreference(21);
    i0.ɵɵproperty("ngTemplateOutlet", tplMonthFooter_r99)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c56, d_r97));
  }
}
function MbscTimeline_ng_container_69_div_9_ng_container_1_div_1_ng_container_3_3_ng_template_0_Template(rf, ctx) {}
function MbscTimeline_ng_container_69_div_9_ng_container_1_div_1_ng_container_3_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscTimeline_ng_container_69_div_9_ng_container_1_div_1_ng_container_3_3_ng_template_0_Template, 0, 0, "ng-template", 56);
  }
  if (rf & 2) {
    const d_r97 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵnextContext(3);
    const tplQuarterFooter_r100 = i0.ɵɵreference(25);
    i0.ɵɵproperty("ngTemplateOutlet", tplQuarterFooter_r100)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c61, d_r97));
  }
}
function MbscTimeline_ng_container_69_div_9_ng_container_1_div_1_ng_container_3_4_ng_template_0_Template(rf, ctx) {}
function MbscTimeline_ng_container_69_div_9_ng_container_1_div_1_ng_container_3_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscTimeline_ng_container_69_div_9_ng_container_1_div_1_ng_container_3_4_ng_template_0_Template, 0, 0, "ng-template", 56);
  }
  if (rf & 2) {
    const d_r97 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵnextContext(3);
    const tplYearFooter_r101 = i0.ɵɵreference(29);
    i0.ɵɵproperty("ngTemplateOutlet", tplYearFooter_r101)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c62, d_r97));
  }
}
function MbscTimeline_ng_container_69_div_9_ng_container_1_div_1_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 97);
    i0.ɵɵtemplate(1, MbscTimeline_ng_container_69_div_9_ng_container_1_div_1_ng_container_3_1_Template, 1, 4, null, 98)(2, MbscTimeline_ng_container_69_div_9_ng_container_1_div_1_ng_container_3_2_Template, 1, 4, null, 98)(3, MbscTimeline_ng_container_69_div_9_ng_container_1_div_1_ng_container_3_3_Template, 1, 4, null, 98)(4, MbscTimeline_ng_container_69_div_9_ng_container_1_div_1_ng_container_3_4_Template, 1, 4, null, 98);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("ngSwitch", ctx_r3.s.resolution);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "week");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "month");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "quarter");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", "year");
  }
}
function MbscTimeline_ng_container_69_div_9_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div")(2, "div");
    i0.ɵɵtemplate(3, MbscTimeline_ng_container_69_div_9_ng_container_1_div_1_ng_container_3_Template, 5, 5, "ng-container", 104);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(4);
    i0.ɵɵclassMap("mbsc-timeline-day mbsc-flex-1-0-0" + ctx_r3._theme + ctx_r3._rtl + ctx_r3._hb);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-timeline-footer-week mbsc-timeline-footer-week-last" + ctx_r3._theme + ctx_r3._rtl + ctx_r3._hb);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-timeline-footer-week-text" + ctx_r3._theme);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.weekFooterTemplate || ctx_r3.monthFooterTemplate || ctx_r3.quarterFooterTemplate || ctx_r3.yearFooterTemplate);
  }
}
function MbscTimeline_ng_container_69_div_9_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MbscTimeline_ng_container_69_div_9_ng_container_1_div_1_Template, 4, 7, "div", 41);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const d_r97 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", d_r97.dateKey !== ctx_r3._dragCol);
  }
}
function MbscTimeline_ng_container_69_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 90);
    i0.ɵɵtemplate(1, MbscTimeline_ng_container_69_div_9_ng_container_1_Template, 2, 1, "ng-container", 51);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3._daysBatch)("ngForTrackBy", ctx_r3._getDayKey);
  }
}
function MbscTimeline_ng_container_69_div_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div");
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-timeline-sidebar-footer-cont mbsc-timeline-sidebar-col" + ctx_r3._theme + ctx_r3._rtl + ctx_r3._hb);
  }
}
function MbscTimeline_ng_container_69_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "div");
    i0.ɵɵelementStart(2, "div", null, 37);
    i0.ɵɵtemplate(4, MbscTimeline_ng_container_69_div_4_Template, 1, 2, "div", 41);
    i0.ɵɵelementStart(5, "div");
    i0.ɵɵelement(6, "div", 45);
    i0.ɵɵelementStart(7, "div");
    i0.ɵɵtemplate(8, MbscTimeline_ng_container_69_div_8_Template, 2, 2, "div", 47)(9, MbscTimeline_ng_container_69_div_9_Template, 2, 2, "div", 47);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(10, MbscTimeline_ng_container_69_div_10_Template, 1, 2, "div", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-flex-none");
    i0.ɵɵstyleProp("height", ctx_r3._hasSticky ? undefined : ctx_r3.state.footerHeight, "px");
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-timeline-footer mbsc-flex" + ctx_r3._theme + ctx_r3._rtl + ctx_r3._hb);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3._hasRows);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-timeline-footer-bg mbsc-flex-1-0 mbsc-flex" + ctx_r3._theme);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("width", ctx_r3._placeholderSizeX, "px");
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r3.state.hasScrollX ? "mbsc-flex-none" : "mbsc-flex-1-1");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3._isDailyResolution);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r3._isDailyResolution);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3._hasRows && !!ctx_r3.sidebarTemplate);
  }
}
function MbscTimeline_div_70_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 105);
  }
}
function MbscEventListItem_ng_template_0_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 5);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-event-color" + ctx_r0._theme + ctx_r0._rtl);
    i0.ɵɵproperty("ngStyle", ctx_r0.eventData.style);
  }
}
function MbscEventListItem_ng_template_0_ng_template_2_Template(rf, ctx) {}
function MbscEventListItem_ng_template_0_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-event-all-day" + ctx_r0._theme);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.eventData.allDayText);
  }
}
function MbscEventListItem_ng_template_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-event-until" + ctx_r0._theme);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.eventData.lastDay);
  }
}
function MbscEventListItem_ng_template_0_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-event-start" + ctx_r0._theme);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.eventData.start);
  }
}
function MbscEventListItem_ng_template_0_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "-");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-event-sep" + ctx_r0._theme);
  }
}
function MbscEventListItem_ng_template_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-event-end" + ctx_r0._theme);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.eventData.end);
  }
}
function MbscEventListItem_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MbscEventListItem_ng_template_0_div_0_Template, 1, 3, "div", 3);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtemplate(2, MbscEventListItem_ng_template_0_ng_template_2_Template, 0, 0, "ng-template", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtemplate(4, MbscEventListItem_ng_template_0_div_4_Template, 2, 3, "div", 4)(5, MbscEventListItem_ng_template_0_div_5_Template, 2, 3, "div", 4)(6, MbscEventListItem_ng_template_0_div_6_Template, 2, 3, "div", 4)(7, MbscEventListItem_ng_template_0_div_7_Template, 2, 2, "div", 4)(8, MbscEventListItem_ng_template_0_div_8_Template, 2, 3, "div", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const defaultEventContent_r2 = i0.ɵɵreference(3);
    i0.ɵɵproperty("ngIf", ctx_r0.showColor);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-event-content mbsc-flex-1-1 " + ctx_r0._theme);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.eventContentTemplate || defaultEventContent_r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(12, _c14, ctx_r0.eventData));
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-event-time" + (ctx_r0.hasDate ? " mbsc-event-date" : "") + ctx_r0._theme + ctx_r0._rtl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.eventData.allDayText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.eventData.lastDay);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.eventData.start);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.eventData.start && ctx_r0.eventData.end);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.eventData.end);
  }
}
function MbscEventListItem_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 6);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-event-text" + ctx_r0._theme);
    i0.ɵɵproperty("innerHTML", ctx_r0.eventData.html, i0.ɵɵsanitizeHtml);
    i0.ɵɵattribute("title", ctx_r0.eventData.tooltip);
  }
}
function MbscEventListItem_ng_template_4_Template(rf, ctx) {}
const _c65 = ["list"];
const _c66 = ["calendar"];
function MbscEventcalendar_div_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 15);
  }
}
function MbscEventcalendar_div_2_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 16);
  }
}
function MbscEventcalendar_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MbscEventcalendar_div_2_div_1_Template, 1, 0, "div", 13);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, MbscEventcalendar_div_2_div_4_Template, 1, 0, "div", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-schedule-date-header mbsc-flex" + ctx_r1._theme + ctx_r1._hb);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._showSchedule && !ctx_r1._showCalendar && ctx_r1.s.resources);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("mbsc-schedule-date-header-text mbsc-flex-1-1" + ctx_r1._theme);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1._selectedDateHeader);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._showSchedule && !ctx_r1._showCalendar && ctx_r1.s.resources);
  }
}
function MbscEventcalendar_div_3_ng_template_2_div_1_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.s.noEventsText, " ");
  }
}
function MbscEventcalendar_div_3_ng_template_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MbscEventcalendar_div_3_ng_template_2_div_1_ng_template_1_Template, 1, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainer(3, 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const noEventsText_r4 = i0.ɵɵreference(2);
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(!ctx_r1.agendaEmptyTemplate ? "mbsc-event-list-empty" + ctx_r1._theme : "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.agendaEmptyTemplate || noEventsText_r4);
  }
}
function MbscEventcalendar_div_3_ng_template_2_div_2_mbsc_list_header_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mbsc-list-header", 25);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const eventList_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("theme", ctx_r1.s.theme)("themeVariant", ctx_r1.s.themeVariant);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", eventList_r5.date, " ");
  }
}
function MbscEventcalendar_div_3_ng_template_2_div_2_mbsc_event_list_item_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mbsc-event-list-item", 26);
    i0.ɵɵlistener("onHoverIn", function MbscEventcalendar_div_3_ng_template_2_div_2_mbsc_event_list_item_2_Template_mbsc_event_list_item_onHoverIn_0_listener($event) {
      const event_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const eventList_r5 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1._onEventHoverIn(ctx_r1._getEventArgs(eventList_r5, $event.domEvent, event_r7)));
    })("onHoverOut", function MbscEventcalendar_div_3_ng_template_2_div_2_mbsc_event_list_item_2_Template_mbsc_event_list_item_onHoverOut_0_listener($event) {
      const event_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const eventList_r5 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1._onEventHoverOut(ctx_r1._getEventArgs(eventList_r5, $event.domEvent, event_r7)));
    })("click", function MbscEventcalendar_div_3_ng_template_2_div_2_mbsc_event_list_item_2_Template_mbsc_event_list_item_click_0_listener($event) {
      const event_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const eventList_r5 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1._onEventClick(ctx_r1._getEventArgs(eventList_r5, $event, event_r7)));
    })("dblclick", function MbscEventcalendar_div_3_ng_template_2_div_2_mbsc_event_list_item_2_Template_mbsc_event_list_item_dblclick_0_listener($event) {
      const event_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const eventList_r5 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1._onEventDoubleClick(ctx_r1._getEventArgs(eventList_r5, $event, event_r7)));
    })("contextmenu", function MbscEventcalendar_div_3_ng_template_2_div_2_mbsc_event_list_item_2_Template_mbsc_event_list_item_contextmenu_0_listener($event) {
      const event_r7 = i0.ɵɵrestoreView(_r6).$implicit;
      const eventList_r5 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1._onEventRightClick(ctx_r1._getEventArgs(eventList_r5, $event, event_r7)));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const event_r7 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("actionable", ctx_r1.s.actionableEvents)("cssClass", event_r7.original.cssClass)("eventContentTemplate", ctx_r1.eventContentTemplate)("eventData", event_r7)("rtl", ctx_r1.s.rtl)("selected", !!(ctx_r1._selectedEventsMap[event_r7.uid] || ctx_r1._selectedEventsMap[event_r7.id]))("showColor", !ctx_r1._colorEventList)("template", ctx_r1.eventTemplate)("theme", ctx_r1.s.theme)("themeVariant", ctx_r1.s.themeVariant);
  }
}
function MbscEventcalendar_div_3_ng_template_2_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵtemplate(1, MbscEventcalendar_div_3_ng_template_2_div_2_mbsc_list_header_1_Template, 2, 3, "mbsc-list-header", 23)(2, MbscEventcalendar_div_3_ng_template_2_div_2_mbsc_event_list_item_2_Template, 1, 10, "mbsc-event-list-item", 24);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const eventList_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap("mbsc-event-group" + ctx_r1._theme);
    i0.ɵɵproperty("timestamp", eventList_r5.timestamp);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1._eventListType !== "day" || ctx_r1._eventListSize > 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", eventList_r5.events)("ngForTrackBy", ctx_r1._getEventKey);
  }
}
function MbscEventcalendar_div_3_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mbsc-list", 19);
    i0.ɵɵtemplate(1, MbscEventcalendar_div_3_ng_template_2_div_1_Template, 4, 3, "div", 5)(2, MbscEventcalendar_div_3_ng_template_2_div_2_Template, 3, 6, "div", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("rtl", ctx_r1.s.rtl)("theme", ctx_r1.s.theme)("themeVariant", ctx_r1.s.themeVariant);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.eventList.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.state.eventList)("ngForTrackBy", ctx_r1._getDayKey);
  }
}
function MbscEventcalendar_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17, 1);
    i0.ɵɵlistener("scroll", function MbscEventcalendar_div_3_Template_div_scroll_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._onScroll());
    });
    i0.ɵɵtemplate(2, MbscEventcalendar_div_3_ng_template_2_Template, 3, 6, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainer(4, 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const def_r8 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-flex-1-1 mbsc-event-list" + (ctx_r1.state.isListScrollable ? " mbsc-event-list-scroll" : ""));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.agendaTemplate || def_r8)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c14, ctx_r1.state.eventList));
  }
}
function MbscEventcalendar_mbsc_scheduler_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mbsc-scheduler", 27);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("allDayText", ctx_r1.s.allDayText)("amText", ctx_r1.s.amText)("bufferAfterTemplate", ctx_r1.bufferAfterTemplate)("bufferBeforeTemplate", ctx_r1.bufferBeforeTemplate)("checkSize", ctx_r1._checkSize)("clickToCreate", ctx_r1.s.clickToCreate)("colorsMap", ctx_r1._colorsMap)("currentTimeIndicator", ctx_r1._currentTimeIndicator)("dataTimezone", ctx_r1.s.dataTimezone)("dateFormat", ctx_r1.s.dateFormat)("dateFormatFull", ctx_r1.s.dateFormatFull)("dateFormatLong", ctx_r1.s.dateFormatLong)("dayNames", ctx_r1.s.dayNames)("dayNamesMin", ctx_r1.s.dayNamesMin)("dayNamesShort", ctx_r1.s.dayNamesShort)("dayTemplate", ctx_r1.dayTemplate)("dayContentTemplate", ctx_r1.dayContentTemplate)("displayTimezone", ctx_r1.s.displayTimezone)("dragBetweenResources", ctx_r1.s.dragBetweenResources)("dragInTime", ctx_r1.s.dragInTime)("dragTimeStep", ctx_r1._dragTimeStep)("dragToCreate", ctx_r1.s.dragToCreate)("dragToMove", ctx_r1.s.dragToMove)("dragToResize", ctx_r1.s.dragToResize)("endDay", ctx_r1._scheduleEndDay)("endTime", ctx_r1._scheduleEndTime)("eventContentTemplate", ctx_r1.scheduleEventContentTemplate)("eventDragEnd", ctx_r1._onEventDragStop)("eventMap", ctx_r1._eventMap)("eventOrder", ctx_r1.s.eventOrder)("eventOverlap", ctx_r1.s.eventOverlap)("eventTemplate", ctx_r1.scheduleEventTemplate)("exclusiveEndDates", ctx_r1.s.exclusiveEndDates)("extendDefaultEvent", ctx_r1.s.extendDefaultEvent)("externalDrag", ctx_r1.s.externalDrag)("externalDrop", ctx_r1.s.externalDrop)("firstDay", ctx_r1.s.firstDay)("fromText", ctx_r1.s.fromText)("getDay", ctx_r1.s.getDay)("getDate", ctx_r1.s.getDate)("getMaxDayOfMonth", ctx_r1.s.getMaxDayOfMonth)("getMonth", ctx_r1.s.getMonth)("getYear", ctx_r1.s.getYear)("getWeekNumber", ctx_r1.s.getWeekNumber)("groupBy", ctx_r1.s.groupBy)("height", ctx_r1.state.height)("immutableData", ctx_r1.s.immutableData)("invalidateEvent", ctx_r1.s.invalidateEvent)("invalidsMap", ctx_r1._invalidsMap)("maxDate", ctx_r1._maxDate)("maxEventStack", ctx_r1._scheduleMaxEventStack)("minEventWidth", ctx_r1._scheduleMinEventWidth)("moreEventsPluralText", ctx_r1.s.moreEventsPluralText)("moreEventsText", ctx_r1.s.moreEventsText)("navigateToEvent", ctx_r1._navigateToEvent)("minDate", ctx_r1._minDate)("monthNames", ctx_r1.s.monthNames)("monthNamesShort", ctx_r1.s.monthNamesShort)("navService", ctx_r1._navService)("newEventText", ctx_r1.s.newEventText)("pmText", ctx_r1.s.pmText)("refDate", ctx_r1._refDate)("resources", ctx_r1.s.resources)("resourceTemplate", ctx_r1.resourceTemplate)("rtl", ctx_r1.s.rtl)("scroll", ctx_r1._shouldScrollSchedule)("selected", ctx_r1._selectedDateTime)("selectedEventsMap", ctx_r1._selectedEventsMap)("showAllDay", ctx_r1._showScheduleAllDay)("showDays", ctx_r1._showScheduleDays)("showEventBuffer", ctx_r1.s.showEventBuffer)("showEventTooltip", ctx_r1.s.showEventTooltip)("size", ctx_r1._scheduleSize)("startDay", ctx_r1._scheduleStartDay)("startTime", ctx_r1._scheduleStartTime)("timeCellStep", ctx_r1._scheduleTimeCellStep)("timeFormat", ctx_r1.s.timeFormat)("timeLabelStep", ctx_r1._scheduleTimeLabelStep)("timezonePlugin", ctx_r1.s.timezonePlugin)("timezones", ctx_r1._scheduleTimezones)("theme", ctx_r1.s.theme)("themeVariant", ctx_r1.s.themeVariant)("toText", ctx_r1.s.toText)("type", ctx_r1._scheduleType)("width", ctx_r1.state.width)("onCellClick", ctx_r1._onCellClick)("onCellDoubleClick", ctx_r1._onCellDoubleClick)("onCellRightClick", ctx_r1._onCellRightClick)("onEventClick", ctx_r1._onEventClick)("onEventDoubleClick", ctx_r1._onEventDoubleClick)("onEventRightClick", ctx_r1._onEventRightClick)("onEventHoverIn", ctx_r1._onEventHoverIn)("onEventHoverOut", ctx_r1._onEventHoverOut)("onEventDelete", ctx_r1._onEventDelete)("onEventDragEnd", ctx_r1._onEventDragEnd)("onEventDragStart", ctx_r1._onEventDragStart)("onEventDragEnter", ctx_r1._onEventDragEnter)("onEventDragLeave", ctx_r1._onEventDragLeave)("onMoreClick", ctx_r1._onMoreClick)("onPopoverClose", ctx_r1._onPopoverClose)("onWeekDayClick", ctx_r1._onWeekDayClick);
  }
}
function MbscEventcalendar_mbsc_timeline_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mbsc-timeline", 28);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("allDayText", ctx_r1.s.allDayText)("amText", ctx_r1.s.amText)("bufferAfterTemplate", ctx_r1.bufferAfterTemplate)("bufferBeforeTemplate", ctx_r1.bufferBeforeTemplate)("checkSize", ctx_r1._checkSize)("clickToCreate", ctx_r1.s.clickToCreate)("colorsMap", ctx_r1._colorsMap)("connections", ctx_r1.s.connections)("currentTimeIndicator", ctx_r1._currentTimeIndicator)("dataTimezone", ctx_r1.s.dataTimezone)("dateFormat", ctx_r1.s.dateFormat)("dateFormatFull", ctx_r1.s.dateFormatFull)("dateFormatLong", ctx_r1.s.dateFormatLong)("dayNames", ctx_r1.s.dayNames)("dayNamesMin", ctx_r1.s.dayNamesMin)("dayNamesShort", ctx_r1.s.dayNamesShort)("dayFooterTemplate", ctx_r1.dayFooterTemplate)("dayTemplate", ctx_r1.dayTemplate)("weekTemplate", ctx_r1.weekTemplate)("weekFooterTemplate", ctx_r1.weekFooterTemplate)("yearTemplate", ctx_r1.yearTemplate)("yearFooterTemplate", ctx_r1.yearFooterTemplate)("hourTemplate", ctx_r1.hourTemplate)("hourFooterTemplate", ctx_r1.hourFooterTemplate)("monthTemplate", ctx_r1.monthTemplate)("monthFooterTemplate", ctx_r1.monthFooterTemplate)("displayTimezone", ctx_r1.s.displayTimezone)("dragBetweenResources", ctx_r1.s.dragBetweenResources)("dragBetweenSlots", ctx_r1.s.dragBetweenSlots)("dragInTime", ctx_r1.s.dragInTime)("dragTimeStep", ctx_r1._dragTimeStep)("dragToCreate", ctx_r1.slots ? false : ctx_r1.s.dragToCreate)("dragToMove", ctx_r1.s.dragToMove)("dragToResize", ctx_r1.slots ? false : ctx_r1.s.dragToResize)("downIcon", ctx_r1.s.chevronIconDown)("endDay", ctx_r1._timelineEndDay)("endTime", ctx_r1._timelineEndTime)("eventList", ctx_r1._timelineListing)("eventDragEnd", ctx_r1._onEventDragStop)("eventContentTemplate", ctx_r1.scheduleEventContentTemplate)("eventMap", ctx_r1._eventMap)("eventOrder", ctx_r1.s.eventOrder)("eventOverlap", ctx_r1.s.eventOverlap)("eventTemplate", ctx_r1.scheduleEventTemplate)("exclusiveEndDates", ctx_r1.s.exclusiveEndDates)("extendDefaultEvent", ctx_r1.s.extendDefaultEvent)("externalDrag", ctx_r1.s.externalDrag)("externalDrop", ctx_r1.s.externalDrop)("firstDay", ctx_r1.s.firstDay)("fromText", ctx_r1.s.fromText)("getDay", ctx_r1.s.getDay)("getDate", ctx_r1.s.getDate)("getMaxDayOfMonth", ctx_r1.s.getMaxDayOfMonth)("getMonth", ctx_r1.s.getMonth)("getWeekNumber", ctx_r1.s.getWeekNumber)("getYear", ctx_r1.s.getYear)("groupBy", ctx_r1.s.groupBy)("height", ctx_r1.state.height)("immutableData", ctx_r1.s.immutableData)("invalidateEvent", ctx_r1.s.invalidateEvent)("invalidsMap", ctx_r1._invalidsMap)("maxDate", ctx_r1._maxDate)("maxEventStack", ctx_r1._timelineMaxEventStack)("minDate", ctx_r1._minDate)("moreEventsPluralText", ctx_r1.s.moreEventsPluralText)("moreEventsText", ctx_r1.s.moreEventsText)("navigateToEvent", ctx_r1._navigateToEvent)("monthNames", ctx_r1.s.monthNames)("monthNamesShort", ctx_r1.s.monthNamesShort)("navService", ctx_r1._navService)("newEventText", ctx_r1.s.newEventText)("nextIcon", ctx_r1.s.nextIconH)("nextIconRtl", ctx_r1.s.nextIconV)("pmText", ctx_r1.s.pmText)("refDate", ctx_r1._refDate)("resolution", ctx_r1._timelineResolution)("resolutionVertical", ctx_r1._timelineResolutionVertical)("resources", ctx_r1.s.resources)("resourceFooterTemplate", ctx_r1.resourceFooterTemplate)("resourceHeaderTemplate", ctx_r1.resourceHeaderTemplate)("resourceTemplate", ctx_r1.resourceTemplate)("rtl", ctx_r1.s.rtl)("rowHeight", ctx_r1._timelineRowHeight)("scroll", ctx_r1._shouldScrollSchedule)("showEventBuffer", ctx_r1.s.showEventBuffer)("showEventTooltip", ctx_r1.s.showEventTooltip)("slots", ctx_r1.s.slots)("slotTemplate", ctx_r1.slotTemplate)("selected", ctx_r1._selectedDateTime)("selectedEventsMap", ctx_r1._selectedEventsMap)("sidebarFooterTemplate", ctx_r1.sidebarFooterTemplate)("sidebarHeaderTemplate", ctx_r1.sidebarHeaderTemplate)("sidebarTemplate", ctx_r1.sidebarTemplate)("size", ctx_r1._timelineSize)("startDay", ctx_r1._timelineStartDay)("startTime", ctx_r1._timelineStartTime)("quarterFooterTemplate", ctx_r1.quarterFooterTemplate)("quarterTemplate", ctx_r1.quarterTemplate)("quarterText", ctx_r1.s.quarterText)("timeCellStep", ctx_r1._timelineTimeCellStep)("timeFormat", ctx_r1.s.timeFormat)("timeLabelStep", ctx_r1._timelineTimeLabelStep)("timezonePlugin", ctx_r1.s.timezonePlugin)("theme", ctx_r1.s.theme)("themeVariant", ctx_r1.s.themeVariant)("toText", ctx_r1.s.toText)("type", ctx_r1._timelineType)("virtualScroll", !ctx_r1._print && ctx_r1._timelineVirtualScroll)("weekNumbers", ctx_r1._showTimelineWeekNumbers)("weekText", ctx_r1.s.weekText)("width", ctx_r1.state.width)("onActiveChange", ctx_r1._onActiveChange)("onCellClick", ctx_r1._onCellClick)("onCellDoubleClick", ctx_r1._onCellDoubleClick)("onCellRightClick", ctx_r1._onCellRightClick)("onEventClick", ctx_r1._onEventClick)("onEventDoubleClick", ctx_r1._onEventDoubleClick)("onEventRightClick", ctx_r1._onEventRightClick)("onEventHoverIn", ctx_r1._onEventHoverIn)("onEventHoverOut", ctx_r1._onEventHoverOut)("onEventDelete", ctx_r1._onEventDelete)("onEventDragEnd", ctx_r1._onEventDragEnd)("onEventDragStart", ctx_r1._onEventDragStart)("onEventDragEnter", ctx_r1._onEventDragEnter)("onEventDragLeave", ctx_r1._onEventDragLeave)("onMoreClick", ctx_r1._onMoreClick)("onPopoverClose", ctx_r1._onPopoverClose)("onResourceCollapse", ctx_r1._proxy)("onResourceExpand", ctx_r1._proxy);
  }
}
function MbscEventcalendar_mbsc_event_list_item_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mbsc-event-list-item", 29);
    i0.ɵɵlistener("onHoverIn", function MbscEventcalendar_mbsc_event_list_item_8_Template_mbsc_event_list_item_onHoverIn_0_listener($event) {
      const event_r10 = i0.ɵɵrestoreView(_r9).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._onEventHoverIn(ctx_r1._getPopoverEventArgs(ctx_r1.state, $event.domEvent, event_r10)));
    })("onHoverOut", function MbscEventcalendar_mbsc_event_list_item_8_Template_mbsc_event_list_item_onHoverOut_0_listener($event) {
      const event_r10 = i0.ɵɵrestoreView(_r9).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._onEventHoverOut(ctx_r1._getPopoverEventArgs(ctx_r1.state, $event.domEvent, event_r10)));
    })("click", function MbscEventcalendar_mbsc_event_list_item_8_Template_mbsc_event_list_item_click_0_listener($event) {
      const event_r10 = i0.ɵɵrestoreView(_r9).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._onEventClick(ctx_r1._getPopoverEventArgs(ctx_r1.state, $event, event_r10)));
    })("dblclick", function MbscEventcalendar_mbsc_event_list_item_8_Template_mbsc_event_list_item_dblclick_0_listener($event) {
      const event_r10 = i0.ɵɵrestoreView(_r9).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._onEventDoubleClick(ctx_r1._getPopoverEventArgs(ctx_r1.state, $event, event_r10)));
    })("contextmenu", function MbscEventcalendar_mbsc_event_list_item_8_Template_mbsc_event_list_item_contextmenu_0_listener($event) {
      const event_r10 = i0.ɵɵrestoreView(_r9).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._onEventRightClick(ctx_r1._getPopoverEventArgs(ctx_r1.state, $event, event_r10)));
    })("onDragEnd", function MbscEventcalendar_mbsc_event_list_item_8_Template_mbsc_event_list_item_onDragEnd_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.state.popoverHost ? ctx_r1.state.popoverHost._onEventDragEnd($event) : ctx_r1._onLabelUpdateEnd($event));
    })("onDragModeOff", function MbscEventcalendar_mbsc_event_list_item_8_Template_mbsc_event_list_item_onDragModeOff_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.state.popoverHost ? ctx_r1.state.popoverHost._onEventDragModeOff($event) : ctx_r1._onLabelUpdateModeOff($event));
    })("onDragModeOn", function MbscEventcalendar_mbsc_event_list_item_8_Template_mbsc_event_list_item_onDragModeOn_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.state.popoverHost ? ctx_r1.state.popoverHost._onEventDragModeOn($event) : ctx_r1._onLabelUpdateModeOn($event));
    })("onDragMove", function MbscEventcalendar_mbsc_event_list_item_8_Template_mbsc_event_list_item_onDragMove_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.state.popoverHost ? ctx_r1.state.popoverHost._onEventDragMove($event) : ctx_r1._onLabelUpdateMove($event));
    })("onDragStart", function MbscEventcalendar_mbsc_event_list_item_8_Template_mbsc_event_list_item_onDragStart_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.state.popoverHost ? ctx_r1.state.popoverHost._onEventDragStart($event) : ctx_r1._onLabelUpdateStart($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const event_r10 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("actionable", ctx_r1.s.actionableEvents)("cssClass", event_r10.original.cssClass)("eventContentTemplate", ctx_r1.eventContentTemplate)("event", event_r10.original)("eventData", event_r10)("hasDate", !!ctx_r1.state.popoverHost)("rtl", ctx_r1.s.rtl)("selected", !!(ctx_r1._selectedEventsMap[event_r10.uid] || ctx_r1._selectedEventsMap[event_r10.id]))("showColor", !ctx_r1._colorEventList)("template", ctx_r1.eventTemplate)("theme", ctx_r1.s.theme)("themeVariant", ctx_r1.s.themeVariant)("drag", (ctx_r1._showEventLabels || ctx_r1.state.popoverHost) && (ctx_r1.s.dragToMove || ctx_r1.s.externalDrag));
  }
}
function MbscEventcalendar_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 30);
  }
}
function MbscCheckbox_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-form-control-label" + ctx_r1._theme + (ctx_r1._disabled ? " mbsc-disabled" : ""));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.s.label);
  }
}
function MbscCheckbox_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-description" + ctx_r1._theme + (ctx_r1._disabled ? " mbsc-disabled" : ""));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.s.description);
  }
}
function MbscRadio_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-form-control-label" + ctx_r1._theme + (ctx_r1._disabled ? " mbsc-disabled" : ""));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.s.label);
  }
}
function MbscRadio_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-description" + ctx_r1._theme + (ctx_r1._disabled ? " mbsc-disabled" : ""));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.s.description);
  }
}
function MbscStepper_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-stepper-label" + ctx_r1._theme + (ctx_r1._disabled ? " mbsc-disabled" : ""));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.s.label);
  }
}
function MbscStepper_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-description" + ctx_r1._theme + (ctx_r1._disabled ? " mbsc-disabled" : ""));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.s.description);
  }
}
const _c67 = ["handle"];
const _c68 = ["handleCont"];
function MbscSwitch_label_0_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap("mbsc-description" + ctx_r0._theme + (ctx_r0._disabled ? " mbsc-disabled" : ""));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.s.description);
  }
}
function MbscSwitch_label_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 5);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, MbscSwitch_label_0_span_2_Template, 2, 3, "span", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap("mbsc-form-control-label" + ctx_r0._theme + (ctx_r0._disabled ? " mbsc-disabled" : ""));
    i0.ɵɵproperty("for", ctx_r0.id || ctx_r0._id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r0.s.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.s.description);
  }
}
var arrowBack = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M217.9 256L345 129c9.4-9.4 9.4-24.6 0-33.9-9.4-9.4-24.6-9.3-34 0L167 239c-9.1 9.1-9.3 23.7-.7 33.1L310.9 417c4.7 4.7 10.9 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9L217.9 256z"/></svg>';
var arrowDown = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 294.1L383 167c9.4-9.4 24.6-9.4 33.9 0s9.3 24.6 0 34L273 345c-9.1 9.1-23.7 9.3-33.1.7L95 201.1c-4.7-4.7-7-10.9-7-17s2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l127.1 127z"/></svg>';
var arrowForward = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M294.1 256L167 129c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.3 34 0L345 239c9.1 9.1 9.3 23.7.7 33.1L201.1 417c-4.7 4.7-10.9 7-17 7s-12.3-2.3-17-7c-9.4-9.4-9.4-24.6 0-33.9l127-127.1z"/></svg>';
var arrowUp = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 217.9L383 345c9.4 9.4 24.6 9.4 33.9 0 9.4-9.4 9.3-24.6 0-34L273 167c-9.1-9.1-23.7-9.3-33.1-.7L95 310.9c-4.7 4.7-7 10.9-7 17s2.3 12.3 7 17c9.4 9.4 24.6 9.4 33.9 0l127.1-127z"/></svg>';
var clear = '<svg xmlns="http://www.w3.org/2000/svg" height="17" viewBox="0 0 17 17" width="17"><path d="M8.5 0a8.5 8.5 0 110 17 8.5 8.5 0 010-17zm3.364 5.005a.7.7 0 00-.99 0l-2.44 2.44-2.439-2.44-.087-.074a.7.7 0 00-.903 1.064l2.44 2.439-2.44 2.44-.074.087a.7.7 0 001.064.903l2.439-2.441 2.44 2.441.087.074a.7.7 0 00.903-1.064l-2.441-2.44 2.441-2.439.074-.087a.7.7 0 00-.074-.903z" fill="currentColor" fill-rule="evenodd"/></svg>';
var extendStatics = function (d, b) {
  extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
  };
  return extendStatics(d, b);
};
function __extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __decorate(decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
var Observable = /*#__PURE__*/function () {
  function Observable() {
    this.nr = 0;
    this.keys = 1;
    this.subscribers = {};
  }
  Observable.prototype.subscribe = function (handler) {
    var key = this.keys++;
    this.subscribers[key] = handler;
    this.nr++;
    return key;
  };
  Observable.prototype.unsubscribe = function (key) {
    this.nr--;
    delete this.subscribers[key];
  };
  Observable.prototype.next = function (value) {
    var subscribers = this.subscribers;
    for (var _i = 0, _a = Object.keys(subscribers); _i < _a.length; _i++) {
      var key = _a[_i];
      if (subscribers[key]) {
        subscribers[key](value);
      }
    }
  };
  return Observable;
}();
var os;
var vers;
var version = [];
var touchUi = false;
var isBrowser = typeof window !== "undefined";
var isDarkQuery = isBrowser && window.matchMedia && window.matchMedia("(prefers-color-scheme:dark)");
var userAgent = isBrowser ? navigator.userAgent : "";
var platform = isBrowser ? navigator.platform : "";
var maxTouchPoints = isBrowser ? navigator.maxTouchPoints : 0;
var device = userAgent && userAgent.match(/Android|iPhone|iPad|iPod|Windows Phone|Windows|MSIE/i);
var isSafari = userAgent && /Safari/.test(userAgent);
if (/Android/i.test(device)) {
  os = "android";
  vers = userAgent.match(/Android\s+([\d.]+)/i);
  touchUi = true;
  if (vers) {
    version = vers[0].replace("Android ", "").split(".");
  }
} else if (/iPhone|iPad|iPod/i.test(device) || /iPhone|iPad|iPod/i.test(platform) || platform === "MacIntel" && maxTouchPoints > 1) {
  os = "ios";
  vers = userAgent.match(/OS\s+([\d_]+)/i);
  touchUi = true;
  if (vers) {
    version = vers[0].replace(/_/g, ".").replace("OS ", "").split(".");
  }
} else if (/Windows Phone/i.test(device)) {
  os = "wp";
  touchUi = true;
} else if (/Windows|MSIE/i.test(device)) {
  os = "windows";
}
var majorVersion = +version[0];
var minorVersion = +version[1];
var options = {};
var util = {};
var themes = {};
var autoDetect = {};
var globalChanges = new Observable();
function getAutoTheme() {
  var autoTheme = "";
  var theme = "";
  var firstTheme = "";
  if (os === "android") {
    theme = "material";
  } else if (os === "wp" || os === "windows") {
    theme = "windows";
  } else {
    theme = "ios";
  }
  for (var key in themes) {
    if (themes[key].baseTheme === theme && themes[key].auto !== false && key !== theme + "-dark") {
      autoTheme = key;
      break;
    } else if (key === theme) {
      autoTheme = key;
    } else if (!firstTheme) {
      firstTheme = key;
    }
  }
  return autoTheme || firstTheme;
}
function setOptions(local) {
  for (var _i = 0, _a = Object.keys(local); _i < _a.length; _i++) {
    var k = _a[_i];
    options[k] = local[k];
  }
  if (isBrowser) {
    globalChanges.next(options);
  }
}
function createCustomTheme(name, baseTheme, auto) {
  var base = themes[baseTheme];
  themes[name] = __assign(__assign({}, base), {
    auto: auto,
    baseTheme: baseTheme
  });
  autoDetect.theme = getAutoTheme();
}
var platform$1 = {
  majorVersion: majorVersion,
  minorVersion: minorVersion,
  name: os
};
var textFieldOpt = {
  clearIcon: clear,
  labelStyle: "inline"
};
var themeName = "ios";
themes[themeName] = {
  Calendar: {
    nextIconH: arrowForward,
    nextIconV: arrowDown,
    prevIconH: arrowBack,
    prevIconV: arrowUp
  },
  Checkbox: {
    position: "end"
  },
  Datepicker: {
    clearIcon: clear,
    display: "bottom"
  },
  Dropdown: textFieldOpt,
  Eventcalendar: {
    chevronIconDown: arrowDown,
    nextIconH: arrowForward,
    nextIconV: arrowDown,
    prevIconH: arrowBack,
    prevIconV: arrowUp
  },
  Input: textFieldOpt,
  Radio: {
    position: "end"
  },
  Scroller: {
    display: "bottom",
    itemHeight: 34,
    minWheelWidth: 55,
    rows: 5,
    scroll3d: true
  },
  SegmentedGroup: {
    drag: true
  },
  Select: {
    clearIcon: clear
  },
  Textarea: textFieldOpt
};
createCustomTheme("ios-dark", themeName);
var arrowDropDown = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7 10l5 5 5-5z"/><path d="M0 0h24v24H0z" fill="none"/></svg>';
var arrowDropUp = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7 14l5-5 5 5z"/><path d="M0 0h24v24H0z" fill="none"/></svg>';
var chevronLeft = '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><path d="M23.12 11.12L21 9l-9 9 9 9 2.12-2.12L16.24 18z"/></svg>';
var chevronRight = '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36"><path d="M15 9l-2.12 2.12L19.76 18l-6.88 6.88L15 27l9-9z"/></svg>';
var clear$1 = '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"/></svg>';
var keyboardArrowDown = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/><path fill="none" d="M0 0h24v24H0V0z"/></svg>';
var keyboardArrowUp = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/><path d="M0 0h24v24H0z" fill="none"/></svg>';
var textFieldOpt$1 = {
  clearIcon: clear$1,
  dropdownIcon: arrowDropDown,
  inputStyle: "box",
  labelStyle: "floating",
  notch: true,
  ripple: true
};
var themeName$1 = "material";
themes[themeName$1] = {
  Button: {
    ripple: true
  },
  Calendar: {
    downIcon: arrowDropDown,
    nextIconH: chevronRight,
    nextIconV: keyboardArrowDown,
    prevIconH: chevronLeft,
    prevIconV: keyboardArrowUp,
    upIcon: arrowDropUp
  },
  Datepicker: {
    clearIcon: clear$1,
    display: "center"
  },
  Dropdown: textFieldOpt$1,
  Eventcalendar: {
    chevronIconDown: keyboardArrowDown,
    colorEventList: true,
    downIcon: arrowDropDown,
    nextIconH: chevronRight,
    nextIconV: keyboardArrowDown,
    prevIconH: chevronLeft,
    prevIconV: keyboardArrowUp,
    upIcon: arrowDropUp
  },
  Input: textFieldOpt$1,
  ListItem: {
    ripple: true
  },
  Scroller: {
    display: "center",
    rows: 3
  },
  Select: {
    clearIcon: clear$1,
    rows: 3
  },
  Textarea: textFieldOpt$1
};
createCustomTheme("material-dark", themeName$1);
var angleDown = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M4.22 10.78l-1.44 1.44 12.5 12.5.72.686.72-.687 12.5-12.5-1.44-1.44L16 22.564 4.22 10.78z"/></svg>';
var angleLeft = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M19.03 4.28l-11 11-.686.72.687.72 11 11 1.44-1.44L10.187 16l10.28-10.28-1.437-1.44z"/></svg>';
var angleRight = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M12.97 4.28l-1.44 1.44L21.814 16 11.53 26.28l1.44 1.44 11-11 .686-.72-.687-.72-11-11z"/></svg>';
var arrowDown$1 = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M15 4v20.063L8.22 17.28l-1.44 1.44 8.5 8.5.72.686.72-.687 8.5-8.5-1.44-1.44L17 24.063V4h-2z"/></svg>';
var arrowUp$1 = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M16 4.094l-.72.687-8.5 8.5 1.44 1.44L15 7.936V28h2V7.937l6.78 6.782 1.44-1.44-8.5-8.5-.72-.686z"/></svg>';
var close = '<svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32px" height="32px"><path d="M 7.21875 5.78125 L 5.78125 7.21875 L 14.5625 16 L 5.78125 24.78125 L 7.21875 26.21875 L 16 17.4375 L 24.78125 26.21875 L 26.21875 24.78125 L 17.4375 16 L 26.21875 7.21875 L 24.78125 5.78125 L 16 14.5625 Z"/></svg>';
var textFieldOpt$2 = {
  clearIcon: close,
  inputStyle: "box",
  labelStyle: "stacked"
};
var themeName$2 = "windows";
themes[themeName$2] = {
  Calendar: {
    nextIconH: angleRight,
    nextIconV: arrowDown$1,
    prevIconH: angleLeft,
    prevIconV: arrowUp$1
  },
  Checkbox: {
    position: "start"
  },
  Datepicker: {
    clearIcon: close,
    display: "center"
  },
  Dropdown: textFieldOpt$2,
  Eventcalendar: {
    chevronIconDown: angleDown,
    nextIconH: angleRight,
    nextIconV: arrowDown$1,
    prevIconH: angleLeft,
    prevIconV: arrowUp$1
  },
  Input: textFieldOpt$2,
  Scroller: {
    display: "center",
    itemHeight: 44,
    minWheelWidth: 88,
    rows: 6
  },
  Select: {
    clearIcon: close,
    rows: 6
  },
  Textarea: textFieldOpt$2
};
createCustomTheme("windows-dark", themeName$2);
autoDetect.theme = getAutoTheme();
var ar = {
  rtl: true,
  setText: "تعيين",
  cancelText: "إلغاء",
  clearText: "مسح",
  closeText: "إغلاق",
  selectedText: "{count} المحدد",
  dateFormat: "DD/MM/YYYY",
  dateFormatLong: "DDD. D MMM YYYY",
  dateWheelFormat: "|DDD D MMM|",
  dayNames: ["الأحد", "الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"],
  dayNamesShort: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  dayNamesMin: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  fromText: "يبدا",
  monthNames: ["يناير", "فبراير", "مارس", "ابريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"],
  monthNamesShort: ["يناير", "فبراير", "مارس", "ابريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"],
  amText: "ص",
  pmText: "م",
  timeFormat: "hh:mm A",
  timeWheels: "Ammhh",
  toText: "ينتهي",
  nowText: "الآن",
  firstDay: 0,
  dateText: "تاريخ",
  timeText: "وقت",
  todayText: "اليوم",
  allDayText: "اليوم كله",
  noEventsText: "لا توجد احداث",
  eventText: "الحدث",
  eventsText: "أحداث",
  moreEventsText: "واحد آخر",
  moreEventsPluralText: "اثنان آخران {count}",
  weekText: "أسبوع {count}",
  rangeEndHelp: "أختر",
  rangeEndLabel: "ينتهي",
  rangeStartHelp: "أختر",
  rangeStartLabel: "يبدا",
  filterEmptyText: "لا نتيجة",
  filterPlaceholderText: "بحث"
};
var bg = {
  setText: "Задаване",
  cancelText: "Отмяна",
  clearText: "Изчистване",
  closeText: "затвори",
  selectedText: "{count} подбран",
  dateFormat: "DD.MM.YYYY",
  dateFormatLong: "DDD, D MMMM YYYY",
  dateWheelFormat: "|DDD MM.DD|",
  dayNames: ["Неделя", "Понеделник", "Вторник", "Сряда", "Четвъртък", "Петък", "Събота"],
  dayNamesShort: ["Нед", "Пон", "Вто", "Сря", "Чет", "Пет", "Съб"],
  dayNamesMin: ["Не", "По", "Вт", "Ср", "Че", "Пе", "Съ"],
  fromText: "ОТ",
  monthNames: ["Януари", "Февруари", "Март", "Април", "Май", "Юни", "Юли", "Август", "Септември", "Октомври", "Ноември", "Декември"],
  monthNamesShort: ["Яну", "Фев", "Мар", "Апр", "Май", "Юни", "Юли", "Авг", "Сеп", "Окт", "Нов", "Дек"],
  timeFormat: "H:mm",
  toText: "ДО",
  nowText: "Сега",
  pmText: "pm",
  amText: "am",
  firstDay: 1,
  dateText: "Дата",
  timeText: "път",
  todayText: "днес",
  eventText: "Събитие",
  eventsText: "Събития",
  allDayText: "Цял ден",
  noEventsText: "Няма събития",
  moreEventsText: "Още {count}",
  weekText: "Седмица {count}",
  rangeStartLabel: "ОТ",
  rangeEndLabel: "ДО",
  rangeStartHelp: "Избирам",
  rangeEndHelp: "Избирам",
  filterEmptyText: "Без резултат",
  filterPlaceholderText: "Търсене"
};
var ca = {
  setText: "Acceptar",
  cancelText: "Cancel·lar",
  clearText: "Esborrar",
  closeText: "Tancar",
  selectedText: "{count} seleccionat",
  selectedPluralText: "{count} seleccionats",
  dateFormat: "DD/MM/YYYY",
  dateFormatLong: "DDD, D MMM YYYY",
  dateWheelFormat: "|DDD D MMM|",
  dayNames: ["Diumenge", "Dilluns", "Dimarts", "Dimecres", "Dijous", "Divendres", "Dissabte"],
  dayNamesShort: ["Dg", "Dl", "Dt", "Dc", "Dj", "Dv", "Ds"],
  dayNamesMin: ["Dg", "Dl", "Dt", "Dc", "Dj", "Dv", "Ds"],
  fromText: "Iniciar",
  monthNames: ["Gener", "Febrer", "Març", "Abril", "Maig", "Juny", "Juliol", "Agost", "Setembre", "Octubre", "Novembre", "Desembre"],
  monthNamesShort: ["Gen", "Feb", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Oct", "Nov", "Des"],
  timeFormat: "H:mm",
  toText: "Final",
  nowText: "Ara",
  pmText: "pm",
  amText: "am",
  todayText: "Avui",
  firstDay: 1,
  dateText: "Data",
  timeText: "Temps",
  allDayText: "Tot el dia",
  noEventsText: "Cap esdeveniment",
  eventText: "Esdeveniments",
  eventsText: "Esdeveniments",
  moreEventsText: "{count} més",
  weekText: "Setmana {count}",
  rangeStartLabel: "Iniciar",
  rangeEndLabel: "Final",
  rangeStartHelp: "Seleccionar",
  rangeEndHelp: "Seleccionar",
  filterEmptyText: "Cap resultat",
  filterPlaceholderText: "Buscar"
};
var cs = {
  setText: "Zadej",
  cancelText: "Storno",
  clearText: "Vymazat",
  closeText: "Zavřít",
  selectedText: "Označený: {count}",
  dateFormat: "DD.MM.YYYY",
  dateFormatLong: "DDD, D.M.YYYY",
  dateWheelFormat: "|DDD D. M.|",
  dayNames: ["Neděle", "Pondělí", "Úterý", "Středa", "Čtvrtek", "Pátek", "Sobota"],
  dayNamesShort: ["Ne", "Po", "Út", "St", "Čt", "Pá", "So"],
  dayNamesMin: ["N", "P", "Ú", "S", "Č", "P", "S"],
  fromText: "Začátek",
  monthNames: ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"],
  monthNamesShort: ["Led", "Úno", "Bře", "Dub", "Kvě", "Čer", "Čvc", "Spr", "Zář", "Říj", "Lis", "Pro"],
  timeFormat: "H:mm",
  toText: "Konec",
  nowText: "Teď",
  amText: "am",
  pmText: "pm",
  todayText: "Dnes",
  firstDay: 1,
  dateText: "Datum",
  timeText: "Čas",
  allDayText: "Celý den",
  noEventsText: "Žádné události",
  eventText: "Událostí",
  eventsText: "Události",
  moreEventsText: "{count} další",
  weekText: "{count}. týden",
  rangeStartLabel: "Začátek",
  rangeEndLabel: "Konec",
  rangeStartHelp: "Vybrat",
  rangeEndHelp: "Vybrat",
  filterEmptyText: "Žádné výsledky",
  filterPlaceholderText: "Hledat"
};
var da = {
  setText: "Sæt",
  cancelText: "Annuller",
  clearText: "Ryd",
  closeText: "Luk",
  selectedText: "{count} valgt",
  selectedPluralText: "{count} valgt",
  dateFormat: "DD/MM/YYY",
  dateFormatLong: "DDD. D. MMM. YYYY.",
  dateWheelFormat: "|DDD. D. MMM.|",
  dayNames: ["Søndag", "Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "Lørdag"],
  dayNamesShort: ["Søn", "Man", "Tir", "Ons", "Tor", "Fre", "Lør"],
  dayNamesMin: ["S", "M", "T", "O", "T", "F", "L"],
  fromText: "Start",
  monthNames: ["Januar", "Februar", "Marts", "April", "Maj", "Juni", "Juli", "August", "September", "Oktober", "November", "December"],
  monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
  amText: "am",
  pmText: "pm",
  timeFormat: "HH.mm",
  toText: "Slut",
  nowText: "Nu",
  todayText: "I dag",
  firstDay: 1,
  dateText: "Dato",
  timeText: "Tid",
  allDayText: "Hele dagen",
  noEventsText: "Ingen begivenheder",
  eventText: "Begivenheder",
  eventsText: "Begivenheder",
  moreEventsText: "{count} mere",
  weekText: "Uge {count}",
  rangeStartLabel: "Start",
  rangeEndLabel: "Slut",
  rangeStartHelp: "Vælg",
  rangeEndHelp: "Vælg",
  filterEmptyText: "Ingen resultater",
  filterPlaceholderText: "Søg"
};
var de = {
  setText: "OK",
  cancelText: "Abbrechen",
  clearText: "Löschen",
  closeText: "Schließen",
  selectedText: "{count} ausgewählt",
  dateFormat: "DD.MM.YYYY",
  dateFormatFull: "DDDD, D. MMMM YYYY",
  dateFormatLong: "DDD. D. MMM. YYYY",
  dateWheelFormat: "|DDD. D. MMM.|",
  dayNames: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
  dayNamesShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  dayNamesMin: ["S", "M", "D", "M", "D", "F", "S"],
  fromText: "Von",
  monthNames: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
  monthNamesShort: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
  timeFormat: "HH:mm",
  nowText: "Jetzt",
  pmText: "pm",
  amText: "am",
  todayText: "Heute",
  toText: "Bis",
  firstDay: 1,
  dateText: "Datum",
  timeText: "Zeit",
  allDayText: "Ganztägig",
  noEventsText: "Keine Ereignisse",
  eventText: "Ereignis",
  eventsText: "Ereignisse",
  moreEventsText: "{count} weiteres Element",
  moreEventsPluralText: "{count} weitere Elemente",
  weekText: "Woche {count}",
  rangeStartLabel: "Von",
  rangeEndLabel: "Bis",
  rangeStartHelp: "Auswählen",
  rangeEndHelp: "Auswählen",
  filterEmptyText: "Keine Treffer",
  filterPlaceholderText: "Suchen"
};
var el = {
  setText: "Ορισμος",
  cancelText: "Ακυρωση",
  clearText: "Διαγραφη",
  closeText: "Κλείσιμο",
  selectedText: "{count} επιλεγμένα",
  dateFormat: "DD/MM/YYYY",
  dateFormatLong: "DDD, D MMM YYYY",
  dateWheelFormat: "|DDD D MMM|",
  dayNames: ["Κυριακή", "Δευτέρα", "Τρίτη", "Τετάρτη", "Πέμπτη", "Παρασκευή", "Σάββατο"],
  dayNamesShort: ["Κυρ", "Δευ", "Τρι", "Τετ", "Πεμ", "Παρ", "Σαβ"],
  dayNamesMin: ["Κυ", "Δε", "Τρ", "Τε", "Πε", "Πα", "Σα"],
  fromText: "Αρχή",
  monthNames: ["Ιανουάριος", "Φεβρουάριος", "Μάρτιος", "Απρίλιος", "Μάιος", "Ιούνιος", "Ιούλιος", "Αύγουστος", "Σεπτέμβριος", "Οκτώβριος", "Νοέμβριος", "Δεκέμβριος"],
  monthNamesShort: ["Ιαν", "Φεβ", "Μαρ", "Απρ", "Μαι", "Ιουν", "Ιουλ", "Αυγ", "Σεπ", "Οκτ", "Νοε", "Δεκ"],
  timeFormat: "H:mm",
  toText: "Τέλος",
  nowText: "τώρα",
  pmText: "μμ",
  amText: "πμ",
  firstDay: 1,
  dateText: "Ημερομηνία",
  timeText: "φορά",
  todayText: "Σήμερα",
  eventText: "Γεγονότα",
  eventsText: "Γεγονότα",
  allDayText: "Ολοήμερο",
  noEventsText: "Δεν υπάρχουν γεγονότα",
  moreEventsText: "{count} ακόμη",
  weekText: "Εβδομάδα {count}",
  rangeStartLabel: "Αρχή",
  rangeEndLabel: "Τέλος",
  rangeStartHelp: "Επιλογή",
  rangeEndHelp: "Επιλογή",
  filterEmptyText: "Κανένα αποτέλεσμα",
  filterPlaceholderText: "Αναζήτηση"
};
var enGB = {
  dateFormat: "DD/MM/YYYY",
  dateFormatFull: "DDDD, D MMMM YYYY",
  dateWheelFormat: "|DDD D MMM|",
  timeFormat: "H:mm"
};
var es = {
  setText: "Aceptar",
  cancelText: "Cancelar",
  clearText: "Borrar",
  closeText: "Cerrar",
  selectedText: "{count} seleccionado",
  selectedPluralText: "{count} seleccionados",
  dateFormat: "DD/MM/YYYY",
  dateFormatLong: "DDD, MMM. D. YYYY",
  dateWheelFormat: "|DDD D MMM|",
  dayNames: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
  dayNamesShort: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sá"],
  dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
  fromText: "Iniciar",
  monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
  monthNamesShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
  timeFormat: "H:mm",
  toText: "Final",
  nowText: "Ahora",
  pmText: "pm",
  amText: "am",
  todayText: "Hoy",
  firstDay: 1,
  dateText: "Fecha",
  timeText: "Tiempo",
  allDayText: "Todo el día",
  noEventsText: "No hay eventos",
  eventText: "Evento",
  eventsText: "Eventos",
  moreEventsText: "{count} más",
  weekText: "Semana {count}",
  rangeStartLabel: "Iniciar",
  rangeEndLabel: "Final",
  rangeStartHelp: "Seleccionar",
  rangeEndHelp: "Seleccionar",
  filterEmptyText: "Sin resultados",
  filterPlaceholderText: "Buscar"
};
var UNDEFINED = undefined;
getArray(3);
getArray(4);
var ARRAY7 = getArray(7);
var ARRAY24 = getArray(24);
function constrain(val, min, max) {
  return Math.max(min, Math.min(val, max));
}
function extend(obj1, obj2) {
  return __assign(__assign({}, obj1), obj2);
}
function isArray(obj) {
  return Array.isArray(obj);
}
function isNumeric(a) {
  return a - parseFloat(a) >= 0;
}
function isNumber(a) {
  return typeof a === "number";
}
function isString(s) {
  return typeof s === "string";
}
function isEmpty(v) {
  return v === UNDEFINED || v === null || v === "";
}
function isUndefined(v) {
  return typeof v === "undefined";
}
function isObject(v) {
  return typeof v === "object";
}
function emptyOrTrue(value) {
  return value !== null && value !== UNDEFINED && "".concat(value) !== "false";
}
function getArray(nr) {
  return Array.apply(0, Array(Math.max(0, nr)));
}
function addPixel(value) {
  return value !== UNDEFINED ? value + (isNumeric(value) ? "px" : "") : "";
}
function noop() {
  return;
}
function pad(num, size) {
  if (size === void 0) {
    size = 2;
  }
  var str = num + "";
  while (str.length < size) {
    str = "0" + str;
  }
  return str;
}
function round(nr) {
  return Math.round(nr);
}
function step(value, st) {
  return floor(value / st) * st;
}
function floor(nr) {
  return Math.floor(nr);
}
function throttle(fn, threshhold) {
  if (threshhold === void 0) {
    threshhold = 100;
  }
  var last;
  var timer;
  return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    var now = +new Date();
    if (last && now < last + threshhold) {
      clearTimeout(timer);
      timer = setTimeout(function () {
        last = now;
        fn.apply(void 0, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(void 0, args);
    }
  };
}
function debounce(fn, threshhold) {
  if (threshhold === void 0) {
    threshhold = 100;
  }
  var timer;
  return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(void 0, args);
    }, threshhold);
  };
}
function arrayContentEquals(arr1, arr2) {
  if (arr1 === arr2) {
    return true;
  }
  if (arr1 && !arr2 || arr2 && !arr1) {
    return false;
  }
  if (arr1.length !== arr2.length) {
    return false;
  }
  for (var i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }
  return true;
}
function ngSetTimeout(inst, cb) {
  if (inst._cdr) {
    setTimeout(cb);
  } else {
    cb();
  }
}
function find(arr, fn) {
  return findItemOrIndex(arr, fn);
}
function findIndex(arr, fn) {
  return findItemOrIndex(arr, fn, true);
}
function findItemOrIndex(arr, fn, index) {
  var len = arr.length;
  for (var i = 0; i < len; i++) {
    var item = arr[i];
    if (fn(item, i)) {
      return index ? i : item;
    }
  }
  return index ? -1 : UNDEFINED;
}
function map(v, fn) {
  if (isArray(v)) {
    return v.map(fn);
  } else {
    return fn(v, 0, [v]);
  }
}
function toArray(m) {
  var arr = [];
  if (m) {
    for (var _i = 0, _a = Object.keys(m); _i < _a.length; _i++) {
      var key = _a[_i];
      arr.push(m[key]);
    }
  }
  return arr;
}
var gDaysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var jDaysInMonth = [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29];
function jalaliToGregorian(jY, jM, jD) {
  var i;
  var jy = jY - 979;
  var jm = jM - 1;
  var jd = jD - 1;
  var jDayNo = 365 * jy + floor(jy / 33) * 8 + floor((jy % 33 + 3) / 4);
  for (i = 0; i < jm; ++i) {
    jDayNo += jDaysInMonth[i];
  }
  jDayNo += jd;
  var gDayNo = jDayNo + 79;
  var gy = 1600 + 400 * floor(gDayNo / 146097);
  gDayNo = gDayNo % 146097;
  var leap = true;
  if (gDayNo >= 36525) {
    gDayNo--;
    gy += 100 * floor(gDayNo / 36524);
    gDayNo = gDayNo % 36524;
    if (gDayNo >= 365) {
      gDayNo++;
    } else {
      leap = false;
    }
  }
  gy += 4 * floor(gDayNo / 1461);
  gDayNo %= 1461;
  if (gDayNo >= 366) {
    leap = false;
    gDayNo--;
    gy += floor(gDayNo / 365);
    gDayNo = gDayNo % 365;
  }
  for (i = 0; gDayNo >= gDaysInMonth[i] + (i === 1 && leap ? 1 : 0); i++) {
    gDayNo -= gDaysInMonth[i] + (i === 1 && leap ? 1 : 0);
  }
  var gm = i + 1;
  var gd = gDayNo + 1;
  return [gy, gm, gd];
}
function checkDate(jY, jM, jD) {
  return !(jY < 0 || jY > 32767 || jM < 1 || jM > 12 || jD < 1 || jD > jDaysInMonth[jM - 1] + (jM === 12 && (jY - 979) % 33 % 4 === 0 ? 1 : 0));
}
function gregorianToJalali(gY, gM, gD) {
  var i;
  var gy = gY - 1600;
  var gm = gM - 1;
  var gd = gD - 1;
  var gDayNo = 365 * gy + floor((gy + 3) / 4) - floor((gy + 99) / 100) + floor((gy + 399) / 400);
  for (i = 0; i < gm; ++i) {
    gDayNo += gDaysInMonth[i];
  }
  if (gm > 1 && (gy % 4 === 0 && gy % 100 !== 0 || gy % 400 === 0)) {
    ++gDayNo;
  }
  gDayNo += gd;
  var jDayNo = gDayNo - 79;
  var jNp = floor(jDayNo / 12053);
  jDayNo %= 12053;
  var jy = 979 + 33 * jNp + 4 * floor(jDayNo / 1461);
  jDayNo %= 1461;
  if (jDayNo >= 366) {
    jy += floor((jDayNo - 1) / 365);
    jDayNo = (jDayNo - 1) % 365;
  }
  for (i = 0; i < 11 && jDayNo >= jDaysInMonth[i]; ++i) {
    jDayNo -= jDaysInMonth[i];
  }
  var jm = i + 1;
  var jd = jDayNo + 1;
  return [jy, jm, jd];
}
var jalaliCalendar = {
  getYear: function (date) {
    return gregorianToJalali(date.getFullYear(), date.getMonth() + 1, date.getDate())[0];
  },
  getMonth: function (date) {
    return --gregorianToJalali(date.getFullYear(), date.getMonth() + 1, date.getDate())[1];
  },
  getDay: function (date) {
    return gregorianToJalali(date.getFullYear(), date.getMonth() + 1, date.getDate())[2];
  },
  getDate: function (y, m, d, h, i, s, u) {
    if (m < 0) {
      y += floor(m / 12);
      m = m % 12 ? 12 + m % 12 : 0;
    }
    if (m > 11) {
      y += floor(m / 12);
      m = m % 12;
    }
    var gregorianDate = jalaliToGregorian(y, +m + 1, d);
    return new Date(gregorianDate[0], gregorianDate[1] - 1, gregorianDate[2], h || 0, i || 0, s || 0, u || 0);
  },
  getMaxDayOfMonth: function (y, m) {
    var maxdays = 31;
    if (m < 0) {
      y += floor(m / 12);
      m = m % 12 ? 12 + m % 12 : 0;
    }
    if (m > 11) {
      y += floor(m / 12);
      m = m % 12;
    }
    while (!checkDate(y, m + 1, maxdays) && maxdays > 29) {
      maxdays--;
    }
    return maxdays;
  }
};
var fa = {
  setText: "تاييد",
  cancelText: "انصراف",
  clearText: "واضح ",
  closeText: "نزدیک",
  selectedText: "{count} منتخب",
  rtl: true,
  calendarSystem: jalaliCalendar,
  dateFormat: "YYYY/MM/DD",
  dateFormatLong: "DDD D MMM YYYY",
  dateWheelFormat: "|DDDD MMM D|",
  dayNames: ["يکشنبه", "دوشنبه", "سه‌شنبه", "چهارشنبه", "پنج‌شنبه", "جمعه", "شنبه"],
  dayNamesShort: ["ی", "د", "س", "چ", "پ", "ج", "ش"],
  dayNamesMin: ["ی", "د", "س", "چ", "پ", "ج", "ش"],
  fromText: "شروع ",
  monthNames: ["فروردين", "ارديبهشت", "خرداد", "تير", "مرداد", "شهريور", "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"],
  monthNamesShort: ["فروردين", "ارديبهشت", "خرداد", "تير", "مرداد", "شهريور", "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"],
  timeFormat: "HH:mm",
  timeWheels: "mmHH",
  toText: "پایان",
  nowText: "اکنون",
  amText: "ب",
  pmText: "ص",
  todayText: "امروز",
  firstDay: 6,
  dateText: "تاریخ ",
  timeText: "زمان ",
  allDayText: "تمام روز",
  noEventsText: "هیچ رویداد",
  eventText: "رویداد",
  eventsText: "رویدادها",
  moreEventsText: "{count} مورد دیگر",
  weekText: "{count} هفته",
  rangeStartLabel: "شروع ",
  rangeEndLabel: "پایان",
  rangeStartHelp: "انتخاب کنید",
  rangeEndHelp: "انتخاب کنید",
  filterEmptyText: "نتیجه ای ندارد",
  filterPlaceholderText: "جستجو کردن"
};
var fi = {
  setText: "Aseta",
  cancelText: "Peruuta",
  clearText: "Tyhjennä",
  closeText: "Sulje",
  selectedText: "{count} valita",
  dateFormat: "D. MMMM YYYY",
  dateFormatLong: "DDD, D. MMMM, YYYY",
  dateWheelFormat: "|DDD D. M.|",
  dayNames: ["Sunnuntai", "Maanantai", "Tiistai", "Keskiviiko", "Torstai", "Perjantai", "Lauantai"],
  dayNamesShort: ["Su", "Ma", "Ti", "Ke", "To", "Pe", "La"],
  dayNamesMin: ["S", "M", "T", "K", "T", "P", "L"],
  fromText: "Alkaa",
  monthNames: ["Tammikuu", "Helmikuu", "Maaliskuu", "Huhtikuu", "Toukokuu", "Kesäkuu", "Heinäkuu", "Elokuu", "Syyskuu", "Lokakuu", "Marraskuu", "Joulukuu"],
  monthNamesShort: ["Tam", "Hel", "Maa", "Huh", "Tou", "Kes", "Hei", "Elo", "Syy", "Lok", "Mar", "Jou"],
  timeFormat: "H:mm",
  toText: "Päättyy",
  nowText: "Nyt",
  pmText: "pm",
  amText: "am",
  firstDay: 1,
  dateText: "Päiväys",
  timeText: "Aika",
  todayText: "Tänään",
  eventText: "Tapahtumia",
  eventsText: "Tapahtumia",
  allDayText: "Koko päivä",
  noEventsText: "Ei tapahtumia",
  moreEventsText: "{count} muu",
  moreEventsPluralText: "{count} muuta",
  weekText: "Viikko {count}",
  rangeStartLabel: "Alkaa",
  rangeEndLabel: "Päättyy",
  rangeStartHelp: "Valitse",
  rangeEndHelp: "Valitse",
  filterEmptyText: "Ei tuloksia",
  filterPlaceholderText: "Haku"
};
var fr = {
  setText: "Terminer",
  cancelText: "Annuler",
  clearText: "Effacer",
  closeText: "Fermer",
  selectedText: "{count} sélectionné",
  selectedPluralText: "{count} sélectionnés",
  dateFormat: "DD/MM/YYYY",
  dateFormatLong: "DDD D MMM YYYY",
  dateWheelFormat: "|DDD D MMM|",
  dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
  dayNamesShort: ["Dim.", "Lun.", "Mar.", "Mer.", "Jeu.", "Ven.", "Sam."],
  dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
  fromText: "Démarrer",
  monthNames: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
  monthNamesShort: ["Janv.", "Févr.", "Mars", "Avril", "Mai", "Juin", "Juil.", "Août", "Sept.", "Oct.", "Nov.", "Déc."],
  timeFormat: "HH:mm",
  toText: "Fin",
  nowText: "Maintenant",
  pmText: "pm",
  amText: "am",
  todayText: "Aujourd'hui",
  firstDay: 1,
  dateText: "Date",
  timeText: "Heure",
  allDayText: "Toute la journée",
  noEventsText: "Aucun événement",
  eventText: "Événement",
  eventsText: "Événements",
  moreEventsText: "{count} autre",
  moreEventsPluralText: "{count} autres",
  weekText: "Semaine {count}",
  rangeStartLabel: "Démarrer",
  rangeEndLabel: "Fin",
  rangeStartHelp: "Choisir",
  rangeEndHelp: "Choisir",
  filterEmptyText: "Aucun résultat",
  filterPlaceholderText: "Rechercher"
};
var he = {
  rtl: true,
  setText: "שמירה",
  cancelText: "ביטול",
  clearText: "נקה",
  closeText: "סגירה",
  selectedText: "{count} נבחר",
  selectedPluralText: "{count} נבחרו",
  dateFormat: "DD/MM/YYYY",
  dateFormatLong: "DDD, D בMMM YYYY",
  dateWheelFormat: "|DDD D MMM|",
  dayNames: ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"],
  dayNamesShort: ["א'", "ב'", "ג'", "ד'", "ה'", "ו'", "ש'"],
  dayNamesMin: ["א", "ב", "ג", "ד", "ה", "ו", "ש"],
  fromText: "התחלה",
  monthNames: ["ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני", "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"],
  monthNamesShort: ["ינו", "פבר", "מרץ", "אפר", "מאי", "יונ", "יול", "אוג", "ספט", "אוק", "נוב", "דצמ"],
  amText: "am",
  pmText: "pm",
  timeFormat: "H:mm",
  timeWheels: "mmH",
  toText: "סיום",
  nowText: "עכשיו",
  firstDay: 0,
  dateText: "תאריך",
  timeText: "זמן",
  todayText: "היום",
  allDayText: "כל היום",
  noEventsText: "אין אירועים",
  eventText: "מִקרֶה",
  eventsText: "מִקרֶה",
  moreEventsText: "אירוע אחד נוסף",
  moreEventsPluralText: "{count} אירועים נוספים",
  weekText: "{count} שבוע",
  rangeStartLabel: "התחלה",
  rangeEndLabel: "סיום",
  rangeStartHelp: "בחר",
  rangeEndHelp: "בחר",
  filterEmptyText: "אין תוצאוה",
  filterPlaceholderText: "לחפש"
};
var hi = {
  setText: "सैट करें",
  cancelText: "रद्द करें",
  clearText: "साफ़ को",
  closeText: "बंद",
  selectedText: "{count} चयनित",
  dateFormat: "DD/MM/YYYY",
  dateFormatLong: "DDD, D MMM YYYY",
  dateWheelFormat: "|DDD D MMM|",
  dayNames: ["रविवार", "सोमवार", "मंगलवार", "बुधवार", "गुरुवार", "शुक्रवार", "शनिवार"],
  dayNamesShort: ["रवि", "सोम", "मंगल", "बुध", "गुरु", "शुक्र", "शनि"],
  dayNamesMin: ["रवि", "सोम", "मंगल", "बुध", "गुरु", "शुक्र", "शनि"],
  fromText: "से",
  monthNames: ["जनवरी ", "फरवरी", "मार्च", "अप्रेल", "मई", "जून", "जूलाई", "अगस्त ", "सितम्बर", "अक्टूबर", "नवम्बर", "दिसम्बर"],
  monthNamesShort: ["जन", "फर", "मार्च", "अप्रेल", "मई", "जून", "जूलाई", "अग", "सित", "अक्ट", "नव", "दि"],
  timeFormat: "H:mm",
  toText: "तक",
  nowText: "अब",
  pmText: "अपराह्न",
  amText: "पूर्वाह्न",
  firstDay: 1,
  dateText: "तिथि",
  timeText: "समय",
  todayText: "आज",
  eventText: "इवेट३",
  eventsText: "इवेट३",
  allDayText: "पूरे दिन",
  noEventsText: "Ei tapahtumia",
  moreEventsText: "{count} और",
  weekText: "सप्ताह {count}",
  rangeStartLabel: "से",
  rangeEndLabel: "तक",
  rangeStartHelp: "चुनें",
  rangeEndHelp: "चुनें",
  filterEmptyText: "कोई परिणाम नही",
  filterPlaceholderText: "खोज"
};
var hr = {
  setText: "Postavi",
  cancelText: "Izlaz",
  clearText: "Izbriši",
  closeText: "Zatvori",
  selectedText: "{count} odabran",
  dateFormat: "DD.MM.YYYY",
  dateFormatLong: "DDD, D. MMM. YYYY.",
  dateWheelFormat: "|DDD D MMM|",
  dayNames: ["Nedjelja", "Ponedjeljak", "Utorak", "Srijeda", "Četvrtak", "Petak", "Subota"],
  dayNamesShort: ["Ned", "Pon", "Uto", "Sri", "Čet", "Pet", "Sub"],
  dayNamesMin: ["Ne", "Po", "Ut", "Sr", "Če", "Pe", "Su"],
  fromText: "Počinje",
  monthNames: ["Siječanj", "Veljača", "Ožujak", "Travanj", "Svibanj", "Lipanj", "Srpanj", "Kolovoz", "Rujan", "Listopad", "Studeni", "Prosinac"],
  monthNamesShort: ["Sij", "Velj", "Ožu", "Tra", "Svi", "Lip", "Srp", "Kol", "Ruj", "Lis", "Stu", "Pro"],
  timeFormat: "H:mm",
  toText: "Završava",
  nowText: "Sada",
  pmText: "pm",
  amText: "am",
  firstDay: 1,
  dateText: "Datum",
  timeText: "Vrijeme",
  todayText: "Danas",
  eventText: "Događaj",
  eventsText: "događaja",
  allDayText: "Cijeli dan",
  noEventsText: "Bez događaja",
  moreEventsText: "Još {count}",
  weekText: "{count}. tjedan",
  rangeStartLabel: "Počinje",
  rangeEndLabel: "Završava",
  rangeStartHelp: "Odaberite",
  rangeEndHelp: "Odaberite",
  filterEmptyText: "Bez rezultata",
  filterPlaceholderText: "Traži"
};
var hu = {
  setText: "OK",
  cancelText: "Mégse",
  clearText: "Törlés",
  closeText: "Bezár",
  selectedText: "{count} kiválasztva",
  dateFormat: "YYYY.MM.DD.",
  dateFormatLong: "YYYY. MMM. D., DDD",
  dateWheelFormat: "|MMM. D. DDD|",
  dayNames: ["Vasárnap", "Hétfő", "Kedd", "Szerda", "Csütörtök", "Péntek", "Szombat"],
  dayNamesShort: ["Va", "Hé", "Ke", "Sze", "Csü", "Pé", "Szo"],
  dayNamesMin: ["V", "H", "K", "Sz", "Cs", "P", "Sz"],
  fromText: "Eleje",
  monthNames: ["Január", "Február", "Március", "Április", "Május", "Június", "Július", "Augusztus", "Szeptember", "Október", "November", "December"],
  monthNamesShort: ["Jan", "Feb", "Már", "Ápr", "Máj", "Jún", "Júl", "Aug", "Szep", "Okt", "Nov", "Dec"],
  timeFormat: "H:mm",
  toText: "Vége",
  nowText: "Most",
  pmText: "pm",
  amText: "am",
  firstDay: 1,
  dateText: "Dátum",
  timeText: "Idő",
  todayText: "Ma",
  eventText: "esemény",
  eventsText: "esemény",
  allDayText: "Egész nap",
  noEventsText: "Nincs esemény",
  moreEventsText: "{count} további",
  weekText: "{count}. hét",
  rangeStartLabel: "Eleje",
  rangeEndLabel: "Vége",
  rangeStartHelp: "Válasszon",
  rangeEndHelp: "Válasszon",
  filterEmptyText: "Nincs találat",
  filterPlaceholderText: "Keresés"
};
var it = {
  setText: "OK",
  cancelText: "Annulla",
  clearText: "Chiarire",
  closeText: "Chiudere",
  selectedText: "{count} selezionato",
  selectedPluralText: "{count} selezionati",
  dateFormat: "DD/MM/YYYY",
  dateFormatLong: "DDD D MMM YYYY",
  dateWheelFormat: "|DDD D MMM|",
  dayNames: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
  dayNamesShort: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
  dayNamesMin: ["D", "L", "M", "M", "G", "V", "S"],
  fromText: "Inizio",
  monthNames: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
  monthNamesShort: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
  timeFormat: "HH:mm",
  toText: "Fine",
  nowText: "Ora",
  pmText: "pm",
  amText: "am",
  todayText: "Oggi",
  firstDay: 1,
  dateText: "Data",
  timeText: "Volta",
  allDayText: "Tutto il giorno",
  noEventsText: "Nessun evento",
  eventText: "Evento",
  eventsText: "Eventi",
  moreEventsText: "{count} altro",
  moreEventsPluralText: "altri {count}",
  weekText: "Settimana {count}",
  rangeStartLabel: "Inizio",
  rangeEndLabel: "Fine",
  rangeStartHelp: "Scegli",
  rangeEndHelp: "Scegli",
  filterEmptyText: "Nessun risultato",
  filterPlaceholderText: "Cerca"
};
var ja = {
  setText: "セット",
  cancelText: "キャンセル",
  clearText: "クリア",
  closeText: "クローズ",
  selectedText: "{count} 選択",
  dateFormat: "YYYY年MM月DD日",
  dateFormatLong: "YYYY年MM月DD日",
  dateWheelFormat: "|M月D日 DDD|",
  dayNames: ["日", "月", "火", "水", "木", "金", "土"],
  dayNamesShort: ["日", "月", "火", "水", "木", "金", "土"],
  dayNamesMin: ["日", "月", "火", "水", "木", "金", "土"],
  fromText: "開始",
  monthNames: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
  monthNamesShort: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
  timeFormat: "H:mm",
  toText: "終わり",
  nowText: "今",
  pmText: "午後",
  amText: "午前",
  yearSuffix: "年",
  monthSuffix: "月",
  daySuffix: "日",
  todayText: "今日",
  dateText: "日付",
  timeText: "時間",
  allDayText: "終日",
  noEventsText: "イベントはありません",
  eventText: "イベント",
  eventsText: "イベント",
  moreEventsText: "他 {count} 件",
  weekText: "{count}週目",
  rangeStartLabel: "開始",
  rangeEndLabel: "終わり",
  rangeStartHelp: "選択",
  rangeEndHelp: "選択",
  filterEmptyText: "検索結果はありません",
  filterPlaceholderText: "探す"
};
var ko = {
  setText: "설정",
  cancelText: "취소",
  clearText: "삭제",
  closeText: "닫기",
  selectedText: "{count} 선택된",
  dateFormat: "YYYY년MM월DD일",
  dateFormatLong: "YYYY년MM월DD일",
  dateWheelFormat: "|M월 D일 DDD|",
  dayNames: ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"],
  dayNamesShort: ["일", "월", "화", "수", "목", "금", "토"],
  dayNamesMin: ["일", "월", "화", "수", "목", "금", "토"],
  fromText: "시작",
  monthNames: ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"],
  monthNamesShort: ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"],
  timeFormat: "H:mm",
  toText: "종료",
  nowText: "지금",
  pmText: "오후",
  amText: "오전",
  yearSuffix: "년",
  monthSuffix: "월",
  daySuffix: "일",
  firstDay: 0,
  dateText: "날짜",
  timeText: "시간",
  todayText: "오늘",
  eventText: "이벤트",
  eventsText: "이벤트",
  allDayText: "종일",
  noEventsText: "이벤트 없음",
  moreEventsText: "{count}개 더보기",
  weekText: "{count}주차",
  rangeStartLabel: "시작",
  rangeEndLabel: "종료",
  rangeStartHelp: "선택",
  rangeEndHelp: "선택",
  filterEmptyText: "결과가 없다",
  filterPlaceholderText: "찾다"
};
var lt = {
  setText: "OK",
  cancelText: "Atšaukti",
  clearText: "Išvalyti",
  closeText: "Uždaryti",
  selectedText: "Pasirinktas {count}",
  selectedPluralText: "Pasirinkti {count}",
  dateFormat: "YYYY-MM-DD",
  dateFormatLong: "YYYY-MM-DD",
  dateWheelFormat: "|MM-DD DDD|",
  dayNames: ["Sekmadienis", "Pirmadienis", "Antradienis", "Trečiadienis", "Ketvirtadienis", "Penktadienis", "Šeštadienis"],
  dayNamesShort: ["S", "Pr", "A", "T", "K", "Pn", "Š"],
  dayNamesMin: ["S", "Pr", "A", "T", "K", "Pn", "Š"],
  fromText: "Nuo",
  monthNames: ["Sausis", "Vasaris", "Kovas", "Balandis", "Gegužė", "Birželis", "Liepa", "Rugpjūtis", "Rugsėjis", "Spalis", "Lapkritis", "Gruodis"],
  monthNamesShort: ["Sau", "Vas", "Kov", "Bal", "Geg", "Bir", "Lie", "Rugp", "Rugs", "Spa", "Lap", "Gruo"],
  amText: "am",
  pmText: "pm",
  timeFormat: "HH:mm",
  toText: "Iki",
  nowText: "Dabar",
  todayText: "Šiandien",
  firstDay: 1,
  dateText: "Data",
  timeText: "Laikas",
  allDayText: "Visą dieną",
  noEventsText: "Nėra įvykių",
  eventText: "Įvykių",
  eventsText: "Įvykiai",
  moreEventsText: "Dar {count}",
  weekText: "{count} savaitė",
  rangeStartLabel: "Nuo",
  rangeEndLabel: "Iki",
  rangeStartHelp: "Pasirinkti",
  rangeEndHelp: "Pasirinkti",
  filterEmptyText: "Nėra rezultatų",
  filterPlaceholderText: "Paieška"
};
var nl = {
  setText: "Instellen",
  cancelText: "Annuleren",
  clearText: "Leegmaken",
  closeText: "Sluiten",
  selectedText: "{count} gekozen",
  dateFormat: "DD-MM-YYYY",
  dateFormatLong: "DD-MM-YYYY",
  dateWheelFormat: "|DDD D MMM|",
  dayNames: ["Zondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag"],
  dayNamesShort: ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"],
  dayNamesMin: ["Z", "M", "D", "W", "D", "V", "Z"],
  fromText: "Start",
  monthNames: ["Januari", "Februari", "Maart", "April", "Mei", "Juni", "Juli", "Augustus", "September", "Oktober", "November", "December"],
  monthNamesShort: ["Jan", "Feb", "Mrt", "Apr", "Mei", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
  timeFormat: "HH:mm",
  toText: "Einde",
  nowText: "Nu",
  pmText: "pm",
  amText: "am",
  todayText: "Vandaag",
  firstDay: 1,
  dateText: "Datum",
  timeText: "Tijd",
  allDayText: "Hele dag",
  noEventsText: "Geen activiteiten",
  eventText: "Activiteit",
  eventsText: "Activiteiten",
  moreEventsText: "nog {count}",
  weekText: "Week {count}",
  rangeStartLabel: "Start",
  rangeEndLabel: "Einde",
  rangeStartHelp: "Kies",
  rangeEndHelp: "Kies",
  filterEmptyText: "Niets gevonden",
  filterPlaceholderText: "Zoek"
};
var no = {
  setText: "OK",
  cancelText: "Avbryt",
  clearText: "Tømme",
  closeText: "Lukk",
  selectedText: "{count} valgt",
  dateFormat: "DD.MM.YYY",
  dateFormatLong: "DDD. D. MMM. YYYY",
  dateWheelFormat: "|DDD. D. MMM.|",
  dayNames: ["Søndag", "Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "Lørdag"],
  dayNamesShort: ["Sø", "Ma", "Ti", "On", "To", "Fr", "Lø"],
  dayNamesMin: ["S", "M", "T", "O", "T", "F", "L"],
  fromText: "Start",
  monthNames: ["Januar", "Februar", "Mars", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Desember"],
  monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"],
  timeFormat: "HH:mm",
  toText: "End",
  nowText: "Nå",
  pmText: "pm",
  amText: "am",
  todayText: "I dag",
  firstDay: 1,
  dateText: "Dato",
  timeText: "Tid",
  allDayText: "Hele dagen",
  noEventsText: "Ingen hendelser",
  eventText: "Hendelse",
  eventsText: "Hendelser",
  moreEventsText: "{count} mere",
  weekText: "Uke {count}",
  rangeStartLabel: "Start",
  rangeEndLabel: "End",
  rangeStartHelp: "Velg",
  rangeEndHelp: "Velg",
  filterEmptyText: "Ingen treff",
  filterPlaceholderText: "Søk"
};
var pl = {
  setText: "Zestaw",
  cancelText: "Anuluj",
  clearText: "Oczyścić",
  closeText: "Zakończenie",
  selectedText: "Wybór: {count}",
  dateFormat: "YYYY-MM-DD",
  dateFormatLong: "DDD, D MMM YYYY",
  dateWheelFormat: "|DDD D.MM|",
  dayNames: ["Niedziela", "Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota"],
  dayNamesShort: ["Nie.", "Pon.", "Wt.", "Śr.", "Czw.", "Pt.", "Sob."],
  dayNamesMin: ["N", "P", "W", "Ś", "C", "P", "S"],
  fromText: "Rozpoczęcie",
  monthNames: ["Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień"],
  monthNamesShort: ["Sty", "Lut", "Mar", "Kwi", "Maj", "Cze", "Lip", "Sie", "Wrz", "Paź", "Lis", "Gru"],
  timeFormat: "HH:mm",
  toText: "Koniec",
  nowText: "Teraz",
  amText: "am",
  pmText: "pm",
  todayText: "Dzisiaj",
  firstDay: 1,
  dateText: "Data",
  timeText: "Czas",
  allDayText: "Cały dzień",
  noEventsText: "Brak wydarzeń",
  eventText: "Wydarzeń",
  eventsText: "Wydarzenia",
  moreEventsText: "Jeszcze {count}",
  weekText: "Tydzień {count}",
  rangeStartLabel: "Rozpoczęcie",
  rangeEndLabel: "Koniec",
  rangeStartHelp: "Wybierz",
  rangeEndHelp: "Wybierz",
  filterEmptyText: "Brak wyników",
  filterPlaceholderText: "Szukaj"
};
var ptPT = {
  setText: "Seleccionar",
  cancelText: "Cancelar",
  clearText: "Claro",
  closeText: "Fechar",
  selectedText: "{count} selecionado",
  selectedPluralText: "{count} selecionados",
  dateFormat: "DD-MM-YYYY",
  dateFormatLong: "DDD, D MMM, YYYY",
  dateWheelFormat: "|DDD D de MMM|",
  dayNames: ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"],
  dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
  dayNamesMin: ["D", "S", "T", "Q", "Q", "S", "S"],
  fromText: "Início",
  monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
  monthNamesShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
  timeFormat: "HH:mm",
  toText: "Fim",
  nowText: "Actualizar",
  pmText: "pm",
  amText: "am",
  todayText: "Hoje",
  firstDay: 1,
  dateText: "Data",
  timeText: "Tempo",
  allDayText: "Todo o dia",
  noEventsText: "Nenhum evento",
  eventText: "Evento",
  eventsText: "Eventos",
  moreEventsText: "Mais {count}",
  weekText: "Semana {count}",
  rangeStartLabel: "Início",
  rangeEndLabel: "Fim",
  rangeStartHelp: "Escolha",
  rangeEndHelp: "Escolha",
  filterEmptyText: "Nenhum resultado",
  filterPlaceholderText: "Pesquisa"
};
var ptBR = {
  setText: "Selecionar",
  dateFormat: "DD/MM/YYYY",
  nowText: "Agora",
  allDayText: "Dia inteiro",
  filterPlaceholderText: "Buscar"
};
var localePtBR = /*#__PURE__*/extend(ptPT, ptBR);
var ro = {
  setText: "Setare",
  cancelText: "Anulare",
  clearText: "Ştergere",
  closeText: "Închidere",
  selectedText: "{count} selectat",
  selectedPluralText: "{count} selectate",
  dateFormat: "DD.MM.YYYY",
  dateFormatLong: "DDD., D MMM YYYY",
  dateWheelFormat: "|DDD. D MMM|",
  dayNames: ["Duminică", "Luni", "Marți", "Miercuri", "Joi", "Vineri", "Sâmbătă"],
  dayNamesShort: ["Du", "Lu", "Ma", "Mi", "Jo", "Vi", "Sâ"],
  dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
  fromText: "Start",
  monthNames: ["Ianuarie", "Februarie", "Martie", "Aprilie", "Mai", "Iunie", "Iulie", "August", "Septembrie", "Octombrie", "Noiembrie", "Decembrie"],
  monthNamesShort: ["Ian.", "Feb.", "Mar.", "Apr.", "Mai", "Iun.", "Iul.", "Aug.", "Sept.", "Oct.", "Nov.", "Dec."],
  timeFormat: "HH:mm",
  toText: "Final",
  nowText: "Acum",
  amText: "am",
  pmText: "pm",
  todayText: "Astăzi",
  eventText: "Eveniment",
  eventsText: "Evenimente",
  allDayText: "Toată ziua",
  noEventsText: "Niciun eveniment",
  moreEventsText: "Încă unul",
  moreEventsPluralText: "Încă {count}",
  firstDay: 1,
  dateText: "Data",
  timeText: "Ora",
  weekText: "Săptămâna {count}",
  rangeStartLabel: "Start",
  rangeEndLabel: "Final",
  rangeStartHelp: "Selectare",
  rangeEndHelp: "Selectare",
  filterEmptyText: "Niciun rezultat",
  filterPlaceholderText: "Căutare"
};
var ru = {
  setText: "Установить",
  cancelText: "Отмена",
  clearText: "Очистить",
  closeText: "Закрыть",
  selectedText: "{count} Выбрать",
  dateFormat: "DD.MM.YYYY",
  dateFormatLong: "DDD, D MMM YYYY",
  dateWheelFormat: "|DDD D MMM|",
  dayNames: ["воскресенье", "понедельник", "вторник", "среда", "четверг", "пятница", "суббота"],
  dayNamesShort: ["вс", "пн", "вт", "ср", "чт", "пт", "сб"],
  dayNamesMin: ["в", "п", "в", "с", "ч", "п", "с"],
  fromText: "Начало",
  monthNames: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
  monthNamesShort: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"],
  timeFormat: "HH:mm",
  toText: "Конец",
  nowText: "Сейчас",
  amText: "am",
  pmText: "pm",
  todayText: "Cегодня",
  firstDay: 1,
  dateText: "Дата",
  timeText: "Время",
  allDayText: "Весь день",
  noEventsText: "Нет событий",
  eventText: "Мероприятия",
  eventsText: "Мероприятия",
  moreEventsText: "Ещё {count}",
  weekText: "Неделя {count}",
  rangeStartLabel: "Начало",
  rangeEndLabel: "Конец",
  rangeStartHelp: "выбирать",
  rangeEndHelp: "выбирать",
  filterEmptyText: "Нет результатов",
  filterPlaceholderText: "Поиск"
};
var ruUA = {
  cancelText: "Отменить",
  clearText: "Очиститьr",
  selectedText: "{count} Вібрать",
  monthNamesShort: ["Янв.", "Февр.", "Март", "Апр.", "Май", "Июнь", "Июль", "Авг.", "Сент.", "Окт.", "Нояб.", "Дек."],
  filterEmptyText: "Ніякага выніку",
  filterPlaceholderText: "Пошук"
};
var localeRuUA = /*#__PURE__*/extend(ru, ruUA);
var sk = {
  setText: "Zadaj",
  cancelText: "Zrušiť",
  clearText: "Vymazať",
  closeText: "Zavrieť",
  selectedText: "Označený: {count}",
  dateFormat: "D.M.YYYY",
  dateFormatLong: "DDD D. MMM YYYY",
  dateWheelFormat: "|DDD D. MMM|",
  dayNames: ["Nedeľa", "Pondelok", "Utorok", "Streda", "Štvrtok", "Piatok", "Sobota"],
  dayNamesShort: ["Ne", "Po", "Ut", "St", "Št", "Pi", "So"],
  dayNamesMin: ["N", "P", "U", "S", "Š", "P", "S"],
  fromText: "Začiatok",
  monthNames: ["Január", "Február", "Marec", "Apríl", "Máj", "Jún", "Júl", "August", "September", "Október", "November", "December"],
  monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "Máj", "Jún", "Júl", "Aug", "Sep", "Okt", "Nov", "Dec"],
  timeFormat: "H:mm",
  toText: "Koniec",
  nowText: "Teraz",
  amText: "am",
  pmText: "pm",
  todayText: "Dnes",
  firstDay: 1,
  dateText: "Datum",
  timeText: "Čas",
  allDayText: "Celý deň",
  noEventsText: "Žiadne udalosti",
  eventText: "Udalostí",
  eventsText: "Udalosti",
  moreEventsText: "{count} ďalšia",
  moreEventsPluralText: "{count} ďalšie",
  weekText: "{count}. týždeň",
  rangeStartLabel: "Začiatok",
  rangeEndLabel: "Koniec",
  rangeStartHelp: "Vybrať",
  rangeEndHelp: "Vybrať",
  filterEmptyText: "Žiadne výsledky",
  filterPlaceholderText: "Vyhľadávanie"
};
var sr = {
  setText: "Постави",
  cancelText: "Откажи",
  clearText: "Обриши",
  selectedText: "{count} изабрана",
  dateFormat: "DD.MM.YYYY",
  dateFormatLong: "DDD, D. MMM YYYY.",
  dateWheelFormat: "|DDD D. MMM|",
  dayNames: ["Недеља", "Понедељак", "Уторак", "Среда", "Четвртак", "Петак", "Субота"],
  dayNamesShort: ["Нед", "Пон", "Уто", "Сре", "Чет", "Пет", "Суб"],
  dayNamesMin: ["Не", "По", "Ут", "Ср", "Че", "Пе", "Су"],
  fromText: "Од",
  monthNames: ["Јануар", "Фебруар", "Март", "Април", "Мај", "Јун", "Јул", "Август", "Септембар", "Октобар", "Новембар", "Децембар"],
  monthNamesShort: ["Јан", "Феб", "Мар", "Апр", "Мај", "Јун", "Јул", "Авг", "Сеп", "Окт", "Нов", "Дец"],
  timeFormat: "HH:mm",
  toText: "До",
  nowText: "сада",
  pmText: "pm",
  amText: "am",
  firstDay: 1,
  dateText: "Датум",
  timeText: "време",
  todayText: "Данас",
  closeText: "Затвори",
  eventText: "Догађај",
  eventsText: "Догађаји",
  allDayText: "Цео дан",
  noEventsText: "Нема догађаја",
  moreEventsText: "Још {count}",
  weekText: "{count}. недеља",
  rangeStartLabel: "Од",
  rangeEndLabel: "До",
  rangeStartHelp: "Изаберите",
  rangeEndHelp: "Изаберите",
  filterEmptyText: "Без резултата",
  filterPlaceholderText: "Претрага"
};
var sv = {
  setText: "OK",
  cancelText: "Avbryt",
  clearText: "Klara",
  closeText: "Stäng",
  selectedText: "{count} vald",
  dateFormat: "YYYY-MM-DD",
  dateFormatLong: "DDD D MMM. YYYY",
  dateWheelFormat: "|DDD D MMM|",
  dayNames: ["Söndag", "Måndag", "Tisdag", "Onsdag", "Torsdag", "Fredag", "Lördag"],
  dayNamesShort: ["Sö", "Må", "Ti", "On", "To", "Fr", "Lö"],
  dayNamesMin: ["S", "M", "T", "O", "T", "F", "L"],
  fromText: "Start",
  monthNames: ["Januari", "Februari", "Mars", "April", "Maj", "Juni", "Juli", "Augusti", "September", "Oktober", "November", "December"],
  monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
  timeFormat: "HH:mm",
  toText: "Slut",
  nowText: "Nu",
  pmText: "pm",
  amText: "am",
  todayText: "I dag",
  firstDay: 1,
  dateText: "Datum",
  timeText: "Tid",
  allDayText: "Heldag",
  noEventsText: "Inga aktiviteter",
  eventText: "Händelse",
  eventsText: "Händelser",
  moreEventsText: "{count} till",
  weekText: "Vecka {count}",
  rangeStartLabel: "Start",
  rangeEndLabel: "Slut",
  rangeStartHelp: "Välj",
  rangeEndHelp: "Välj",
  filterEmptyText: "Inga träffar",
  filterPlaceholderText: "Sök"
};
var th = {
  setText: "ตั้งค่า",
  cancelText: "ยกเลิก",
  clearText: "ล้าง",
  closeText: "ปิด",
  selectedText: "{count} เลือก",
  dateFormat: "DD/MM/YYYY",
  dateFormatLong: "วันDDDที่ D MMM YYYY",
  dateWheelFormat: "|DDD D MMM|",
  dayNames: ["อาทิตย์", "จันทร์", "อังคาร", "พุธ", "พฤหัสบดี", "ศุกร์", "เสาร์"],
  dayNamesShort: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
  dayNamesMin: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
  fromText: "จาก",
  monthNames: ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"],
  monthNamesShort: ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."],
  timeFormat: "HH:mm",
  toText: "ถึง",
  nowText: "ตอนนี้",
  pmText: "pm",
  amText: "am",
  firstDay: 0,
  dateText: "วัน",
  timeText: "เวลา",
  todayText: "วันนี้",
  eventText: "เหตุการณ์",
  eventsText: "เหตุการณ์",
  allDayText: "ตลอดวัน",
  noEventsText: "ไม่มีกิจกรรม",
  moreEventsText: "อีก {count} กิจกรรม",
  weekText: "สัปดาห์ที่ {count}",
  rangeStartLabel: "จาก",
  rangeEndLabel: "ถึง",
  rangeStartHelp: "เลือก",
  rangeEndHelp: "เลือก",
  filterEmptyText: "ไม่มีผลลัพธ์",
  filterPlaceholderText: "ค้นหา"
};
var tr = {
  setText: "Seç",
  cancelText: "İptal",
  clearText: "Temizleyin",
  closeText: "Kapatmak",
  selectedText: "{count} seçilmiş",
  dateFormat: "DD.MM.YYYY",
  dateFormatLong: "D MMMM DDD, YYYY",
  dateWheelFormat: "|D MMM DDD|",
  dayNames: ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"],
  dayNamesShort: ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cmt"],
  dayNamesMin: ["P", "P", "S", "Ç", "P", "C", "C"],
  fromText: "Başla",
  monthNames: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"],
  monthNamesShort: ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"],
  timeFormat: "HH:mm",
  toText: "Son",
  nowText: "Şimdi",
  pmText: "pm",
  amText: "am",
  todayText: "Bugün",
  firstDay: 1,
  dateText: "Tarih",
  timeText: "Zaman",
  allDayText: "Tüm gün",
  noEventsText: "Etkinlik Yok",
  eventText: "Etkinlik",
  eventsText: "Etkinlikler",
  moreEventsText: "{count} tane daha",
  weekText: "{count}. Hafta",
  rangeStartLabel: "Başla",
  rangeEndLabel: "Son",
  rangeStartHelp: "Seç",
  rangeEndHelp: "Seç",
  filterEmptyText: "Sonuç Yok",
  filterPlaceholderText: "Arayın"
};
var ua = {
  setText: "встановити",
  cancelText: "відміна",
  clearText: "очистити",
  closeText: "Закрити",
  selectedText: "{count} вибрані",
  dateFormat: "DD.MM.YYYY",
  dateFormatLong: "DDD, D MMM. YYYY",
  dateWheelFormat: "|DDD D MMM.|",
  dayNames: ["неділя", "понеділок", "вівторок", "середа", "четвер", "п’ятниця", "субота"],
  dayNamesShort: ["нед", "пнд", "вів", "срд", "чтв", "птн", "сбт"],
  dayNamesMin: ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
  fromText: "від",
  monthNames: ["Січень", "Лютий", "Березень", "Квітень", "Травень", "Червень", "Липень", "Серпень", "Вересень", "Жовтень", "Листопад", "Грудень"],
  monthNamesShort: ["Січ", "Лют", "Бер", "Кві", "Тра", "Чер", "Лип", "Сер", "Вер", "Жов", "Лис", "Гру"],
  timeFormat: "H:mm",
  toText: "кінець",
  nowText: "Зараз",
  pmText: "pm",
  amText: "am",
  firstDay: 1,
  dateText: "дата",
  timeText: "Час",
  todayText: "Сьогодні",
  eventText: "подія",
  eventsText: "події",
  allDayText: "Увесь день",
  noEventsText: "Жодної події",
  moreEventsText: "та ще {count}",
  weekText: "{count} тиждень",
  rangeStartLabel: "від",
  rangeEndLabel: "кінець",
  rangeEndHelp: "Обрати",
  rangeStartHelp: "Обрати",
  filterEmptyText: "Ніякого результату",
  filterPlaceholderText: "Пошук"
};
var vi = {
  setText: "Đặt",
  cancelText: "Hủy bò",
  clearText: "Xóa",
  closeText: "Đóng",
  selectedText: "{count} chọn",
  dateFormat: "DD/MM/YYYY",
  dateFormatLong: "DDD D, MMM YYYY",
  dateWheelFormat: "|DDD D MMM|",
  dayNames: ["Chủ Nhật", "Thứ Hai", "Thứ Ba", "Thứ Tư", "Thứ Năm", "Thứ Sáu", "Thứ Bảy"],
  dayNamesShort: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
  dayNamesMin: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
  fromText: "Từ",
  monthNames: ["Tháng Một", "Tháng Hai", "Tháng Ba", "Tháng Tư", "Tháng Năm", "Tháng Sáu", "Tháng Bảy", "Tháng Tám", "Tháng Chín", "Tháng Mười", "Tháng Mười Một", "Tháng Mười Hai"],
  monthNamesShort: ["Tháng 1", "Tháng 2", "Tháng 3", "Tháng 4", "Tháng 5", "Tháng 6", "Tháng 7", "Tháng 8", "Tháng 9", "Tháng 10", "Tháng 11", "Tháng 12"],
  timeFormat: "H:mm",
  toText: "Tới",
  nowText: "Bây giờ",
  pmText: "pm",
  amText: "am",
  firstDay: 0,
  dateText: "Ngày",
  timeText: "Hồi",
  todayText: "Hôm nay",
  eventText: "Sự kiện",
  eventsText: "Sự kiện",
  allDayText: "Cả ngày",
  noEventsText: "Không có sự kiện",
  moreEventsText: "{count} thẻ khác",
  weekText: "Tuần {count}",
  rangeStartLabel: "Từ",
  rangeEndLabel: "Tới",
  rangeStartHelp: "Chọn",
  rangeEndHelp: "Chọn",
  filterEmptyText: "Không kết quả",
  filterPlaceholderText: "Tìm kiếm"
};
var zh = {
  setText: "确定",
  cancelText: "取消",
  clearText: "明确",
  closeText: "关闭",
  selectedText: "{count} 选",
  dateFormat: "YYYY年M月D日",
  dateFormatLong: "YYYY年M月D日",
  dateWheelFormat: "|M月D日 DDD|",
  dayNames: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
  dayNamesShort: ["日", "一", "二", "三", "四", "五", "六"],
  dayNamesMin: ["日", "一", "二", "三", "四", "五", "六"],
  fromText: "开始时间",
  monthNames: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
  monthNamesShort: ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", "十一", "十二"],
  timeFormat: "H:mm",
  toText: "结束时间",
  nowText: "当前",
  pmText: "下午",
  amText: "上午",
  yearSuffix: "年",
  monthSuffix: "月",
  daySuffix: "日",
  todayText: "今天",
  dateText: "日",
  timeText: "时间",
  allDayText: "全天",
  noEventsText: "无事件",
  eventText: "活动",
  eventsText: "活动",
  moreEventsText: "他 {count} 件",
  weekText: "第 {count} 週",
  rangeStartLabel: "开始时间",
  rangeEndLabel: "结束时间",
  rangeStartHelp: "选取",
  rangeEndHelp: "选取",
  filterEmptyText: "没有结果",
  filterPlaceholderText: "搜索"
};
function intPart(floatNum) {
  if (floatNum < -1e-7) {
    return Math.ceil(floatNum - 1e-7);
  }
  return Math.floor(floatNum + 1e-7);
}
function hijriToGregorian(hY, hM, hD) {
  var l;
  var j;
  var n;
  var i;
  var k;
  var gregDate = new Array(3);
  var jd = intPart((11 * hY + 3) / 30) + 354 * hY + 30 * hM - intPart((hM - 1) / 2) + hD + 1948440 - 385;
  if (jd > 2299160) {
    l = jd + 68569;
    n = intPart(4 * l / 146097);
    l = l - intPart((146097 * n + 3) / 4);
    i = intPart(4e3 * (l + 1) / 1461001);
    l = l - intPart(1461 * i / 4) + 31;
    j = intPart(80 * l / 2447);
    hD = l - intPart(2447 * j / 80);
    l = intPart(j / 11);
    hM = j + 2 - 12 * l;
    hY = 100 * (n - 49) + i + l;
  } else {
    j = jd + 1402;
    k = intPart((j - 1) / 1461);
    l = j - 1461 * k;
    n = intPart((l - 1) / 365) - intPart(l / 1461);
    i = l - 365 * n + 30;
    j = intPart(80 * i / 2447);
    hD = i - intPart(2447 * j / 80);
    i = intPart(j / 11);
    hM = j + 2 - 12 * i;
    hY = 4 * k + n + i - 4716;
  }
  gregDate[2] = hD;
  gregDate[1] = hM;
  gregDate[0] = hY;
  return gregDate;
}
function gregorianToHijri(gY, gM, gD) {
  var jd;
  var l;
  var hijriDate = [0, 0, 0];
  if (gY > 1582 || gY === 1582 && gM > 10 || gY === 1582 && gM === 10 && gD > 14) {
    jd = intPart(1461 * (gY + 4800 + intPart((gM - 14) / 12)) / 4) + intPart(367 * (gM - 2 - 12 * intPart((gM - 14) / 12)) / 12) - intPart(3 * intPart((gY + 4900 + intPart((gM - 14) / 12)) / 100) / 4) + gD - 32075;
  } else {
    jd = 367 * gY - intPart(7 * (gY + 5001 + intPart((gM - 9) / 7)) / 4) + intPart(275 * gM / 9) + gD + 1729777;
  }
  l = jd - 1948440 + 10632;
  var n = intPart((l - 1) / 10631);
  l = l - 10631 * n + 354;
  var j = intPart((10985 - l) / 5316) * intPart(50 * l / 17719) + intPart(l / 5670) * intPart(43 * l / 15238);
  l = l - intPart((30 - j) / 15) * intPart(17719 * j / 50) - intPart(j / 16) * intPart(15238 * j / 43) + 29;
  gM = intPart(24 * l / 709);
  gD = l - intPart(709 * gM / 24);
  gY = 30 * n + j - 30;
  hijriDate[2] = gD;
  hijriDate[1] = gM;
  hijriDate[0] = gY;
  return hijriDate;
}
var hijriCalendar = {
  getYear: function (date) {
    return gregorianToHijri(date.getFullYear(), date.getMonth() + 1, date.getDate())[0];
  },
  getMonth: function (date) {
    return --gregorianToHijri(date.getFullYear(), date.getMonth() + 1, date.getDate())[1];
  },
  getDay: function (date) {
    return gregorianToHijri(date.getFullYear(), date.getMonth() + 1, date.getDate())[2];
  },
  getDate: function (y, m, d, h, i, s, u) {
    if (m < 0) {
      y += Math.floor(m / 12);
      m = m % 12 ? 12 + m % 12 : 0;
    }
    if (m > 11) {
      y += Math.floor(m / 12);
      m = m % 12;
    }
    var gregorianDate = hijriToGregorian(y, +m + 1, d);
    return new Date(gregorianDate[0], gregorianDate[1] - 1, gregorianDate[2], h || 0, i || 0, s || 0, u || 0);
  },
  getMaxDayOfMonth: function (hY, hM) {
    if (hM < 0) {
      hY += Math.floor(hM / 12);
      hM = hM % 12 ? 12 + hM % 12 : 0;
    }
    if (hM > 11) {
      hY += Math.floor(hM / 12);
      hM = hM % 12;
    }
    var daysPerMonth = [30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 30, 29];
    var leapYear = (hY * 11 + 14) % 30 < 11;
    return daysPerMonth[hM] + (hM === 11 && leapYear ? 1 : 0);
  }
};
var localeEn = {};
var locale = {
  ar: ar,
  bg: bg,
  ca: ca,
  cs: cs,
  da: da,
  de: de,
  el: el,
  en: localeEn,
  "en-GB": enGB,
  es: es,
  fa: fa,
  fi: fi,
  fr: fr,
  he: he,
  hi: hi,
  hr: hr,
  hu: hu,
  it: it,
  ja: ja,
  ko: ko,
  lt: lt,
  nl: nl,
  no: no,
  pl: pl,
  "pt-BR": localePtBR,
  "pt-PT": ptPT,
  ro: ro,
  ru: ru,
  "ru-UA": localeRuUA,
  sk: sk,
  sr: sr,
  sv: sv,
  th: th,
  tr: tr,
  ua: ua,
  vi: vi,
  zh: zh
};
var REF_DATE = new Date(1970, 0, 1);
var ONE_MIN = 6e4;
var ONE_HOUR = 60 * ONE_MIN;
var ONE_DAY = 24 * ONE_HOUR;
function isMBSCDate(d) {
  return !!d._mbsc;
}
function convertTimezone(d, s, tz) {
  var timezone = tz || s.dataTimezone || s.displayTimezone;
  var timezonePlugin = s.timezonePlugin;
  if (timezone && timezonePlugin && isMBSCDate(d)) {
    var clone = d.clone();
    clone.setTimezone(timezone);
    return clone.toISOString();
  }
  return d;
}
var dateTimeLocale = {
  amText: "am",
  dateFormat: "MM/DD/YYYY",
  dateFormatFull: "DDDD, MMMM D, YYYY",
  dateFormatLong: "D DDD MMM YYYY",
  dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"],
  dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  daySuffix: "",
  firstDay: 0,
  fromText: "Start",
  getDate: adjustedDate,
  monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  monthSuffix: "",
  pmText: "pm",
  quarterText: "Q{count}",
  separator: " ",
  shortYearCutoff: "+10",
  timeFormat: "h:mm A",
  toText: "End",
  todayText: "Today",
  weekText: "Week {count}",
  yearSuffix: "",
  getMonth: function (d) {
    return d.getMonth();
  },
  getDay: function (d) {
    return d.getDate();
  },
  getYear: function (d) {
    return d.getFullYear();
  },
  getMaxDayOfMonth: function (y, m) {
    return 32 - new Date(y, m, 32, 12).getDate();
  },
  getWeekNumber: function (dt) {
    var d = new Date(+dt);
    d.setHours(0, 0, 0);
    d.setDate(d.getDate() + 4 - (d.getDay() || 7));
    var yearStart = new Date(d.getFullYear(), 0, 1);
    return Math.ceil(((d - yearStart) / 864e5 + 1) / 7);
  }
};
var ISO_8601_FULL = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[T\s](\d{2}):?(\d{2})(?::?(\d{2})(?:\.(\d{3}))?)?((Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
var ISO_8601_TIME = /^((\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{3}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function setISOParts(parsed, offset, parts) {
  var part;
  var v;
  var p = {
    y: 1,
    m: 2,
    d: 3,
    h: 4,
    i: 5,
    s: 6,
    u: 7,
    tz: 8
  };
  if (parts) {
    for (var _i = 0, _a = Object.keys(p); _i < _a.length; _i++) {
      part = _a[_i];
      v = parsed[p[part] - offset];
      if (v) {
        parts[part] = part === "tz" ? v : 1;
      }
    }
  }
}
function getISOString(d, parts) {
  var ret = "";
  var time = "";
  if (d) {
    if (parts.h) {
      time += pad(d.getHours()) + ":" + pad(d.getMinutes());
      if (parts.s) {
        time += ":" + pad(d.getSeconds());
      }
      if (parts.u) {
        time += "." + pad(d.getMilliseconds(), 3);
      }
      if (parts.tz) {
        time += parts.tz;
      }
    }
    if (parts.y) {
      ret += d.getFullYear();
      if (parts.m) {
        ret += "-" + pad(d.getMonth() + 1);
        if (parts.d) {
          ret += "-" + pad(d.getDate());
        }
        if (parts.h) {
          ret += "T" + time;
        }
      }
    } else if (parts.h) {
      ret = time;
    }
  }
  return ret;
}
function getDayMilliseconds(d) {
  var dd = new Date(1970, 0, 1, d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds());
  return +dd - +REF_DATE;
}
function checkDateRangeOverlap(start1, end1, start2, end2, adjust) {
  var aStart = +start1;
  var bStart = +start2;
  var aEnd = adjust && aStart === +end1 ? +end1 + 1 : +end1;
  var bEnd = adjust && bStart === +end2 ? +end2 + 1 : +end2;
  return aStart < bEnd && aEnd > bStart;
}
function getDayStart(s, d) {
  var newDate = createDate(s, d);
  newDate.setHours(0, 0, 0, 0);
  return newDate;
}
function getDayEnd(s, d) {
  var newDate = createDate(s, d);
  newDate.setHours(23, 59, 59, 999);
  return newDate;
}
function getEndDate(s, allDay, start, end, isList) {
  var exclusive = allDay || isList ? s.exclusiveEndDates : true;
  var tzOpt = allDay ? UNDEFINED : s;
  return exclusive && start && end && start < end ? createDate(tzOpt, +end - 1) : end;
}
function getDateStr(d) {
  return d.getFullYear() + "-" + pad(d.getMonth() + 1) + "-" + pad(d.getDate());
}
function getDateOnly(d, nativeDate) {
  if (isMBSCDate(d) && !nativeDate) {
    return d.createDate(d.getFullYear(), d.getMonth(), d.getDate());
  } else {
    return adjustedDate(d.getFullYear(), d.getMonth(), d.getDate());
  }
}
function getUTCDateOnly(d) {
  return Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());
}
function getDayDiff(d1, d2) {
  return round((getUTCDateOnly(d2) - getUTCDateOnly(d1)) / ONE_DAY);
}
function getGridDayDiff(from, to, startDay, endDay) {
  var dayIndex = -1;
  for (var d = getDateOnly(from); d <= getDateOnly(to); d.setDate(d.getDate() + 1)) {
    if (isInWeek(d.getDay(), startDay, endDay)) {
      dayIndex++;
    }
  }
  return dayIndex;
}
function getFirstDayOfWeek(d, s, w) {
  var y = d.getFullYear();
  var m = d.getMonth();
  var weekDay = d.getDay();
  var firstWeekDay = w === UNDEFINED ? s.firstDay : w;
  var offset = firstWeekDay - weekDay > 0 ? 7 : 0;
  return new Date(y, m, firstWeekDay - offset - weekDay + d.getDate());
}
function isSameDay(d1, d2) {
  return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
}
function isSameMonth(d1, d2, s) {
  return s.getYear(d1) === s.getYear(d2) && s.getMonth(d1) === s.getMonth(d2);
}
function adjustedDate(y, m, d, h, i, s, u) {
  var date = new Date(y, m, d, h || 0, i || 0, s || 0, u || 0);
  if (date.getHours() === 23 && (h || 0) === 0) {
    date.setHours(date.getHours() + 2);
  }
  return date;
}
function isDate(d) {
  return d.getTime;
}
function isTime(d) {
  return isString(d) && ISO_8601_TIME.test(d);
}
function addTimezone(s, d) {
  return createDate(s, d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds());
}
function removeTimezone(d) {
  if (!d) {
    return d;
  } else {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds());
  }
}
function createDate(s, yearOrStamp, month, date, h, min, sec, ms) {
  if (yearOrStamp === null) {
    return null;
  }
  if (yearOrStamp && (isNumber(yearOrStamp) || isString(yearOrStamp)) && isUndefined(month)) {
    return makeDate(yearOrStamp, s);
  }
  if (s && s.timezonePlugin) {
    return s.timezonePlugin.createDate(s, yearOrStamp, month, date, h, min, sec, ms);
  }
  if (isObject(yearOrStamp)) {
    return new Date(yearOrStamp);
  }
  if (isUndefined(yearOrStamp)) {
    return new Date();
  }
  return new Date(yearOrStamp, month || 0, date || 1, h || 0, min || 0, sec || 0, ms || 0);
}
function makeDate(d, s, format, parts, skipTimezone) {
  var parse;
  if (isString(d)) {
    d = d.trim();
  }
  if (!d) {
    return null;
  }
  var plugin = s && s.timezonePlugin;
  if (plugin && !skipTimezone) {
    var parsedDate = isMBSCDate(d) ? d : plugin.parse(d, s);
    parsedDate.setTimezone(s.displayTimezone);
    return parsedDate;
  }
  if (isDate(d)) {
    return d;
  }
  if (d._isAMomentObject) {
    return d.toDate();
  }
  if (isNumber(d)) {
    return new Date(d);
  }
  parse = ISO_8601_TIME.exec(d);
  var defVal = s && s.defaultValue;
  var def = makeDate((isArray(defVal) ? defVal[0] : defVal) || new Date());
  var defYear = def.getFullYear();
  var defMonth = def.getMonth();
  var defDay = def.getDate();
  if (parse) {
    setISOParts(parse, 2, parts);
    return new Date(defYear, defMonth, defDay, parse[2] ? +parse[2] : 0, parse[3] ? +parse[3] : 0, parse[4] ? +parse[4] : 0, parse[5] ? +parse[5] : 0);
  }
  parse = ISO_8601_FULL.exec(d);
  if (parse) {
    setISOParts(parse, 0, parts);
    return new Date(parse[1] ? +parse[1] : defYear, parse[2] ? parse[2] - 1 : defMonth, parse[3] ? +parse[3] : defDay, parse[4] ? +parse[4] : 0, parse[5] ? +parse[5] : 0, parse[6] ? +parse[6] : 0, parse[7] ? +parse[7] : 0);
  }
  return parseDate(format, d, s);
}
function returnDate(d, s, displayFormat, isoParts, hasTimePart) {
  var moment = isBrowser && window.moment || s.moment;
  var timezone = s.timezonePlugin && (s.dataTimezone || s.displayTimezone);
  var format = timezone ? "iso8601" : s.returnFormat;
  if (timezone && hasTimePart) {
    return convertTimezone(d, s);
  }
  if (d) {
    if (format === "moment" && moment) {
      return moment(d);
    }
    if (format === "locale") {
      return formatDate(displayFormat, d, s);
    }
    if (format === "iso8601") {
      return getISOString(d, isoParts);
    }
  }
  return d;
}
function formatDatePublic(format, date, options$1) {
  var s = __assign(__assign(__assign({}, dateTimeLocale), options.locale), options$1);
  return formatDate(format, date, s);
}
function formatDate(format, date, s) {
  var i;
  var year;
  var output = "";
  var literal = false;
  var c;
  var peekAhead = function (symbol) {
    var nr = 0;
    var j = i;
    while (j + 1 < format.length && format.charAt(j + 1) === symbol) {
      nr++;
      j++;
    }
    return nr;
  };
  var lookAhead = function (symbol) {
    var nr = peekAhead(symbol);
    i += nr;
    return nr;
  };
  var formatNumber = function (symbol, val, len) {
    var ret = "" + val;
    if (lookAhead(symbol)) {
      while (ret.length < len) {
        ret = "0" + ret;
      }
    }
    return ret;
  };
  var formatName = function (symbol, val, short, long) {
    return lookAhead(symbol) === 3 ? long[val] : short[val];
  };
  for (i = 0; i < format.length; i++) {
    if (literal) {
      if (format.charAt(i) === "'" && !lookAhead("'")) {
        literal = false;
      } else {
        output += format.charAt(i);
      }
    } else {
      switch (format.charAt(i)) {
        case "D":
          c = peekAhead("D");
          if (c > 1) {
            output += formatName("D", date.getDay(), s.dayNamesShort, s.dayNames);
          } else {
            output += formatNumber("D", s.getDay(date), 2);
          }
          break;
        case "M":
          c = peekAhead("M");
          if (c > 1) {
            output += formatName("M", s.getMonth(date), s.monthNamesShort, s.monthNames);
          } else {
            output += formatNumber("M", s.getMonth(date) + 1, 2);
          }
          break;
        case "Y":
          year = s.getYear(date);
          output += lookAhead("Y") === 3 ? year : (year % 100 < 10 ? "0" : "") + year % 100;
          break;
        case "h":
          {
            var h = date.getHours();
            output += formatNumber("h", h > 12 ? h - 12 : h === 0 ? 12 : h, 2);
            break;
          }
        case "H":
          output += formatNumber("H", date.getHours(), 2);
          break;
        case "m":
          output += formatNumber("m", date.getMinutes(), 2);
          break;
        case "s":
          output += formatNumber("s", date.getSeconds(), 2);
          break;
        case "a":
          output += date.getHours() > 11 ? s.pmText : s.amText;
          break;
        case "A":
          output += date.getHours() > 11 ? s.pmText.toUpperCase() : s.amText.toUpperCase();
          break;
        case "'":
          if (lookAhead("'")) {
            output += "'";
          } else {
            literal = true;
          }
          break;
        default:
          output += format.charAt(i);
      }
    }
  }
  return output;
}
function parseDate(format, value, options) {
  var s = __assign(__assign({}, dateTimeLocale), options);
  var def = makeDate(s.defaultValue || new Date());
  if (!value) {
    return def;
  }
  if (!format) {
    format = s.dateFormat + s.separator + s.timeFormat;
  }
  var shortYearCutoff = s.shortYearCutoff;
  var year = s.getYear(def);
  var month = s.getMonth(def) + 1;
  var day = s.getDay(def);
  var hours = def.getHours();
  var minutes = def.getMinutes();
  var seconds = 0;
  var ampm = -1;
  var literal = false;
  var iValue = 0;
  var iFormat;
  var peekAhead = function (symbol) {
    var nr = 0;
    var j = iFormat;
    while (j + 1 < format.length && format.charAt(j + 1) === symbol) {
      nr++;
      j++;
    }
    return nr;
  };
  var lookAhead = function (match) {
    var matches = peekAhead(match);
    iFormat += matches;
    return matches;
  };
  var getNumber = function (match) {
    var count = lookAhead(match);
    var size = count >= 2 ? 4 : 2;
    var digits = new RegExp("^\\d{1," + size + "}");
    var num = value.substr(iValue).match(digits);
    if (!num) {
      return 0;
    }
    iValue += num[0].length;
    return parseInt(num[0], 10);
  };
  var getName = function (match, shortNames, longNames) {
    var count = lookAhead(match);
    var names = count === 3 ? longNames : shortNames;
    for (var i = 0; i < names.length; i++) {
      if (value.substr(iValue, names[i].length).toLowerCase() === names[i].toLowerCase()) {
        iValue += names[i].length;
        return i + 1;
      }
    }
    return 0;
  };
  var checkLiteral = function () {
    iValue++;
  };
  for (iFormat = 0; iFormat < format.length; iFormat++) {
    if (literal) {
      if (format.charAt(iFormat) === "'" && !lookAhead("'")) {
        literal = false;
      } else {
        checkLiteral();
      }
    } else {
      switch (format.charAt(iFormat)) {
        case "Y":
          year = getNumber("Y");
          break;
        case "M":
          {
            var p = peekAhead("M");
            if (p < 2) {
              month = getNumber("M");
            } else {
              month = getName("M", s.monthNamesShort, s.monthNames);
            }
            break;
          }
        case "D":
          {
            var p = peekAhead("D");
            if (p < 2) {
              day = getNumber("D");
            } else {
              getName("D", s.dayNamesShort, s.dayNames);
            }
            break;
          }
        case "H":
          hours = getNumber("H");
          break;
        case "h":
          hours = getNumber("h");
          break;
        case "m":
          minutes = getNumber("m");
          break;
        case "s":
          seconds = getNumber("s");
          break;
        case "a":
          ampm = getName("a", [s.amText, s.pmText], [s.amText, s.pmText]) - 1;
          break;
        case "A":
          ampm = getName("A", [s.amText, s.pmText], [s.amText, s.pmText]) - 1;
          break;
        case "'":
          if (lookAhead("'")) {
            checkLiteral();
          } else {
            literal = true;
          }
          break;
        default:
          checkLiteral();
      }
    }
  }
  if (year < 100) {
    var cutoffYear = void 0;
    if (!isString(shortYearCutoff)) {
      cutoffYear = +shortYearCutoff;
    } else {
      cutoffYear = new Date().getFullYear() % 100 + parseInt(shortYearCutoff, 10);
    }
    var addedCentury = void 0;
    if (year <= cutoffYear) {
      addedCentury = 0;
    } else {
      addedCentury = -100;
    }
    year += new Date().getFullYear() - new Date().getFullYear() % 100 + addedCentury;
  }
  hours = ampm === -1 ? hours : ampm && hours < 12 ? hours + 12 : !ampm && hours === 12 ? 0 : hours;
  var date = s.getDate(year, month - 1, day, hours, minutes, seconds);
  if (s.getYear(date) !== year || s.getMonth(date) + 1 !== month || s.getDay(date) !== day) {
    return def;
  }
  return date;
}
function dateValueEquals(v1, v2, s) {
  if (v1 === v2) {
    return true;
  }
  if (isArray(v1) && !v1.length && v2 === null || isArray(v2) && !v2.length && v1 === null) {
    return true;
  }
  if (v1 === null || v2 === null || v1 === UNDEFINED || v2 === UNDEFINED) {
    return false;
  }
  if (isString(v1) && isString(v2)) {
    return v1 === v2;
  }
  var dateFormat = s && s.dateFormat;
  if (isArray(v1) || isArray(v2)) {
    if (v1.length !== v2.length) {
      return false;
    }
    for (var i = 0; i < v1.length; i++) {
      var eq = true;
      var a = v1[i];
      var b = v2[i];
      if (isString(a) && isString(b)) {
        eq = a === b;
      } else {
        eq = +makeDate(a, s, dateFormat) === +makeDate(b, s, dateFormat);
      }
      if (!eq) {
        return false;
      }
    }
    return true;
  }
  return +makeDate(v1, s, dateFormat) === +makeDate(v2, s, dateFormat);
}
function cloneDate(date) {
  return isMBSCDate(date) ? date.clone() : new Date(date);
}
function addDays(date, days) {
  var copy = cloneDate(date);
  copy.setDate(copy.getDate() + days);
  return copy;
}
function addMonths(date, months, s) {
  var year = s.getYear(date);
  var month = s.getMonth(date) + months;
  var maxDays = s.getMaxDayOfMonth(year, month);
  return addTimezone(s, s.getDate(year, month, Math.min(s.getDay(date), maxDays), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
}
function isInWeek(day, startDay, endDay) {
  return startDay > endDay ? day <= endDay || day >= startDay : day >= startDay && day <= endDay;
}
function roundTime(date, step) {
  var ms = ONE_MIN * step;
  var copy = cloneDate(date).setHours(0, 0, 0, 0);
  var rounded = copy + Math.round((+date - +copy) / ms) * ms;
  return isMBSCDate(date) ? date.createDate(rounded) : new Date(rounded);
}
function constrainDate(date, min, max) {
  return min && date < min ? new Date(min) : max && date > max ? new Date(max) : date;
}
if (isBrowser && typeof Symbol === "undefined") {
  window.Symbol = {
    toPrimitive: "toPrimitive"
  };
}
var WEEK_DAYNAMES = {
  0: "SU",
  1: "MO",
  2: "TU",
  3: "WE",
  4: "TH",
  5: "FR",
  6: "SA"
};
var WEEK_DAYS = {
  SU: 0,
  MO: 1,
  TU: 2,
  WE: 3,
  TH: 4,
  FR: 5,
  SA: 6
};
var RULE_KEY_MAP = {
  byday: "weekDays",
  bymonth: "month",
  bymonthday: "day",
  bysetpos: "pos",
  dtstart: "from",
  freq: "repeat",
  wkst: "weekStart"
};
function addMultiDayEvent(obj, item, s, overwrite) {
  var start = makeDate(item.start, item.allDay ? UNDEFINED : s);
  var end = makeDate(item.end, item.allDay ? UNDEFINED : s);
  var duration = end - start;
  if (overwrite) {
    item.start = start;
    item.end = end;
  }
  start = getDateOnly(start);
  end = s.exclusiveEndDates ? end : getDateOnly(addDays(end, 1));
  while (start < end || !duration) {
    addToList(obj, start, item);
    start = addDays(start, 1);
    duration = 1;
  }
}
function addToList(obj, d, data) {
  var key = getDateStr(d);
  if (!obj[key]) {
    obj[key] = [];
    obj[key].date = getDateOnly(d, true);
  }
  obj[key].push(data);
}
function getExceptionDateMap(dtStart, start, end, s, exception, exceptionRule) {
  var map = {};
  if (exception) {
    var exceptionDates = getExceptionList(exception);
    for (var _i = 0, exceptionDates_1 = exceptionDates; _i < exceptionDates_1.length; _i++) {
      var e = exceptionDates_1[_i];
      map[getDateStr(makeDate(e))] = true;
    }
  }
  if (exceptionRule) {
    var exceptionDateList = getOccurrences(exceptionRule, dtStart, dtStart, start, end, s);
    for (var _a = 0, exceptionDateList_1 = exceptionDateList; _a < exceptionDateList_1.length; _a++) {
      var ex = exceptionDateList_1[_a];
      map[getDateStr(ex.d)] = true;
    }
  }
  return map;
}
function getDateFromItem(item) {
  return isString(item) || item.getTime || item.toDate ? item : item.start || item.date;
}
function getTzOpt(s, event, dataAsDisplay) {
  var origStart = event.original ? event.original.start : event.start;
  var allDay = event.allDay || !origStart;
  var tz = s.timezonePlugin;
  var dataTimezone = event.timezone || s.dataTimezone || s.displayTimezone;
  return tz && !allDay ? {
    dataTimezone: dataTimezone,
    displayTimezone: dataAsDisplay ? dataTimezone : s.displayTimezone,
    timezonePlugin: tz
  } : UNDEFINED;
}
function parseRule(ruleStr) {
  var rule = {};
  var pairs = ruleStr.split(";");
  for (var _i = 0, pairs_1 = pairs; _i < pairs_1.length; _i++) {
    var pair = pairs_1[_i];
    var values = pair.split("=");
    var key = values[0].trim().toLowerCase();
    var value = values[1].trim();
    rule[RULE_KEY_MAP[key] || key] = value;
  }
  return rule;
}
function getRule(rule) {
  return isString(rule) ? parseRule(rule) : __assign({}, rule);
}
function updateRecurringRule(recurringRule, newStart, oldStart) {
  var updatedRule = getRule(recurringRule);
  var newStartDate = makeDate(newStart);
  var oldStartDate = makeDate(oldStart);
  var dayDelta = getDayDiff(oldStartDate, newStartDate);
  var repeat = (updatedRule.repeat || "").toLowerCase();
  var updateArray = function (values, oldValue, newValue) {
    var newValues = values.filter(function (value) {
      return value !== oldValue;
    });
    if (newValues.indexOf(newValue) === -1) {
      newValues.push(newValue);
    }
    return newValues;
  };
  var updateNumber = function (values, oldValue, newValue) {
    var oldValues = isArray(values) ? values : ((values || "") + "").split(",").map(function (nr) {
      return +nr;
    });
    var newValues = updateArray(oldValues, oldValue, newValue);
    return newValues.length > 1 ? newValues : newValues[0];
  };
  var updateWeekDays = function () {
    if (updatedRule.weekDays) {
      var oldWeekDays = updatedRule.weekDays.split(",");
      var oldWeekDay = WEEK_DAYNAMES[oldStartDate.getDay()];
      var newWeekDay = WEEK_DAYNAMES[newStartDate.getDay()];
      var newWeekDays = updateArray(oldWeekDays, oldWeekDay, newWeekDay);
      updatedRule.weekDays = newWeekDays.join();
    }
  };
  if (repeat === "weekly") {
    updateWeekDays();
  } else if (repeat === "monthly") {
    if (updatedRule.pos === UNDEFINED) {
      updatedRule.day = updateNumber(updatedRule.day, oldStartDate.getDate(), newStartDate.getDate());
    } else {
      updateWeekDays();
    }
  } else if (repeat === "yearly") {
    if (updatedRule.pos === UNDEFINED) {
      updatedRule.month = updateNumber(updatedRule.month, oldStartDate.getMonth() + 1, newStartDate.getMonth() + 1);
      updatedRule.day = updateNumber(updatedRule.day, oldStartDate.getDate(), newStartDate.getDate());
    } else {
      updateWeekDays();
    }
  }
  if (updatedRule.from) {
    updatedRule.from = addDays(makeDate(updatedRule.from), dayDelta);
  }
  if (updatedRule.until) {
    updatedRule.until = addDays(makeDate(updatedRule.until), dayDelta);
  }
  return updatedRule;
}
function updateRecurringEvent(originalRecurringEvent, oldEventOccurrence, newEvent, updatedEvent, updateMode, timezone, timezonePlugin) {
  var retUpdatedEvent = __assign({}, originalRecurringEvent);
  var retNewEvent = null;
  var newStart = newEvent && newEvent.start;
  var newEnd = newEvent && newEvent.end;
  var newRule;
  var oldStart = oldEventOccurrence && oldEventOccurrence.start;
  var originalRule = getRule(originalRecurringEvent.recurring);
  switch (updateMode) {
    case "following":
      if (updatedEvent) {
        if (updatedEvent.recurring) {
          newRule = getRule(updatedEvent.recurring);
        }
        retNewEvent = __assign({}, updatedEvent);
        delete retNewEvent.id;
      } else if (newStart && oldStart) {
        newRule = updateRecurringRule(originalRule, newStart, oldStart);
        retNewEvent = __assign({}, newEvent);
      }
      originalRule.until = getDateStr(makeDate(oldStart));
      if (originalRule.count) {
        var oldNr = oldEventOccurrence && oldEventOccurrence.nr || 0;
        if (newRule) {
          newRule.count = originalRule.count - oldNr;
        }
        originalRule.count = oldNr;
      }
      if (newStart && newRule) {
        newRule.from = newStart;
      }
      if (retNewEvent && newRule) {
        retNewEvent.recurring = newRule;
      }
      retUpdatedEvent.recurring = originalRule;
      break;
    case "all":
      if (updatedEvent) {
        newStart = updatedEvent.start;
        newEnd = updatedEvent.end;
        retUpdatedEvent = __assign({}, updatedEvent);
      } else if (newEvent && newStart && newEnd && oldStart) {
        retUpdatedEvent.allDay = newEvent.allDay;
        retUpdatedEvent.recurring = updateRecurringRule(originalRule, newStart, oldStart);
      }
      if (newStart && newEnd) {
        var tzOpt = timezone && timezonePlugin ? {
          displayTimezone: timezone,
          timezonePlugin: timezonePlugin
        } : UNDEFINED;
        var tzOpt1 = retUpdatedEvent.allDay ? UNDEFINED : tzOpt;
        var tzOpt2 = originalRecurringEvent.allDay ? UNDEFINED : tzOpt;
        var start = makeDate(newStart, tzOpt1);
        var end = makeDate(newEnd, tzOpt1);
        var origStart = originalRecurringEvent.start;
        var origEnd = originalRecurringEvent.end;
        var allDayChange = originalRecurringEvent.allDay && !retUpdatedEvent.allDay;
        var origStartDate = origStart && makeDate(origStart, tzOpt2);
        var oldStartDate = oldStart && makeDate(oldStart, tzOpt2);
        var duration = end - start;
        var delta = oldStartDate ? start - oldStartDate : 0;
        var updatedStart = origStartDate && oldStartDate ? createDate(tzOpt1, +origStartDate + delta) : start;
        var updatedEnd = createDate(tzOpt1, +updatedStart + duration);
        if (isTime(origStart) || !origStart && allDayChange) {
          retUpdatedEvent.start = formatDatePublic("HH:mm", start);
        } else if (origStart) {
          retUpdatedEvent.start = tzOpt1 ? updatedStart.toISOString() : updatedStart;
        }
        if (isTime(origEnd) || !origEnd && allDayChange) {
          retUpdatedEvent.end = formatDatePublic("HH:mm", end);
        } else if (origEnd) {
          retUpdatedEvent.end = tzOpt1 ? updatedEnd.toISOString() : updatedEnd;
        }
      }
      break;
    default:
      {
        var originalException = originalRecurringEvent.recurringException;
        var exception = isArray(originalException) ? __spreadArray([], originalException, true) : originalException ? [originalException] : [];
        if (oldStart) {
          exception.push(oldStart);
        }
        retUpdatedEvent.recurringException = exception;
        retNewEvent = updatedEvent || newEvent;
        break;
      }
  }
  return {
    updatedEvent: retUpdatedEvent,
    newEvent: retNewEvent
  };
}
function getNextOccurrence(list, from, s, displayFormat) {
  var closest = null;
  for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
    var item = list_1[_i];
    if (item.recurring) {
      var dtStart = makeDate(item.start || item.date);
      var firstOccurrence = getOccurrences(item.recurring, dtStart, dtStart, from, UNDEFINED, s, item.reccurringException, item.recurringExceptionRule, "first");
      if (!closest || firstOccurrence < closest) {
        closest = firstOccurrence;
      }
    } else if (item.start && item.end) {
      var start = makeDate(item.start, s, displayFormat);
      var end = makeDate(item.end, s, displayFormat);
      if (end > from) {
        if (start <= from) {
          closest = from;
        } else {
          closest = closest && closest < start ? closest : start;
        }
      }
    } else {
      var exactDate = makeDate(getDateFromItem(item), s, displayFormat);
      if (exactDate > from && (!closest || exactDate < closest)) {
        closest = exactDate;
      }
    }
  }
  return closest;
}
function getLatestOccurrence(list, from, s, displayFormat) {
  var latest = from;
  list.sort(function (a, b) {
    var d1 = makeDate(getDateFromItem(a), s, displayFormat);
    var d2 = makeDate(getDateFromItem(b), s, displayFormat);
    return d1 - d2;
  });
  for (var _i = 0, list_2 = list; _i < list_2.length; _i++) {
    var item = list_2[_i];
    if (item.recurring) {
      var dtStart = makeDate(item.start || item.date);
      var latestOccurrence = getOccurrences(item.recurring, dtStart, dtStart, from, UNDEFINED, s, item.reccurringException, item.recurringExceptionRule, "last");
      if (latestOccurrence > latest) {
        latest = latestOccurrence;
      }
    } else if (item.start && item.end) {
      var start = makeDate(item.start, s, displayFormat);
      var end = makeDate(item.end, s, displayFormat);
      if (end > latest && getDayDiff(latest, start) <= 1) {
        latest = end;
      }
    } else {
      var exactDate = makeDate(getDateFromItem(item), s, displayFormat);
      if (exactDate > latest && getDayDiff(latest, exactDate) <= 1) {
        latest = exactDate;
      }
    }
  }
  return latest;
}
function getExceptionList(exception) {
  if (exception) {
    if (isArray(exception)) {
      return exception;
    }
    if (isString(exception)) {
      return exception.split(",");
    }
    return [exception];
  }
  return [];
}
function getOccurrences(rule, dtStart, origStart, start, end, s, exception, exceptionRule, returnOccurrence) {
  if (isString(rule)) {
    rule = parseRule(rule);
  }
  var getYear = s.getYear;
  var getMonth = s.getMonth;
  var getDay = s.getDay;
  var getDate = s.getDate;
  var getMaxDays = s.getMaxDayOfMonth;
  var freq = (rule.repeat || "").toLowerCase();
  var interval = rule.interval || 1;
  var count = rule.count;
  var from = rule.from ? makeDate(rule.from) : dtStart || (interval !== 1 || count !== UNDEFINED || freq === "monthly" || freq === "yearly" ? new Date() : start);
  var fromDate = getDateOnly(from);
  var fromYear = getYear(from);
  var fromMonth = getMonth(from);
  var fromDay = getDay(from);
  var origHours = origStart ? origStart.getHours() : 0;
  var origMinutes = origStart ? origStart.getMinutes() : 0;
  var origSeconds = origStart ? origStart.getSeconds() : 0;
  var until = rule.until ? makeDate(rule.until) : Infinity;
  var occurredBefore = from < start;
  var rangeStart = occurredBefore ? start : getDateOnly(from);
  var firstOnly = returnOccurrence === "first";
  var lastOnly = returnOccurrence === "last";
  var rangeEnd = firstOnly || lastOnly || !end ? until : until < end ? until : end;
  var countOrInfinity = count === UNDEFINED ? Infinity : count;
  var weekDays = (rule.weekDays || WEEK_DAYNAMES[from.getDay()]).split(",");
  var weekStart = WEEK_DAYS[(rule.weekStart || "MO").trim().toUpperCase()];
  var rDay = rule.day;
  var rMonth = rule.month;
  var days = isArray(rDay) ? rDay.length ? rDay : [fromDay] : ((rDay || fromDay) + "").split(",");
  var months = isArray(rMonth) ? rMonth.length ? rMonth : [fromMonth] : ((rMonth || fromMonth + 1) + "").split(",");
  var occurrences = [];
  var hasPos = rule.pos !== UNDEFINED;
  var pos = hasPos ? +rule.pos : 1;
  var weekDayValues = [];
  var exceptionDateMap = end ? getExceptionDateMap(dtStart, start, end, s, exception, exceptionRule) : {};
  var first;
  var iterator;
  var repeat = true;
  var i = 0;
  var nr = 0;
  var closest = null;
  var latest = start;
  for (var _i = 0, weekDays_1 = weekDays; _i < weekDays_1.length; _i++) {
    var weekDay = weekDays_1[_i];
    weekDayValues.push(WEEK_DAYS[weekDay.trim().toUpperCase()]);
  }
  var handleOccurrence = function () {
    if (!end) {
      exceptionDateMap = getExceptionDateMap(iterator, iterator, addDays(iterator, 1), s, exception, exceptionRule);
    }
    if (!exceptionDateMap[getDateStr(iterator)] && iterator >= rangeStart) {
      if (firstOnly) {
        closest = !closest || iterator < closest ? iterator : closest;
        repeat = false;
      } else if (lastOnly) {
        var diff = getDayDiff(latest, iterator);
        latest = iterator > latest && diff <= 1 ? iterator : latest;
        repeat = diff <= 1;
      } else {
        occurrences.push({
          d: iterator,
          i: nr
        });
      }
    }
    nr++;
  };
  var handlePos = function (monthFirstDay, monthLastDay) {
    var matches = [];
    for (var _i = 0, weekDayValues_1 = weekDayValues; _i < weekDayValues_1.length; _i++) {
      var weekDay = weekDayValues_1[_i];
      var startWeekDay = getFirstDayOfWeek(monthFirstDay, {
        firstDay: weekDay
      });
      for (var d = startWeekDay; d < monthLastDay; d.setDate(d.getDate() + 7)) {
        if (d.getMonth() === monthFirstDay.getMonth()) {
          matches.push(+d);
        }
      }
    }
    matches.sort();
    var match = matches[pos < 0 ? matches.length + pos : pos - 1];
    iterator = match ? new Date(match) : monthLastDay;
    iterator = getDate(getYear(iterator), getMonth(iterator), getDay(iterator), origHours, origMinutes, origSeconds);
    if (iterator >= from) {
      if (iterator <= rangeEnd && nr < countOrInfinity) {
        if (match) {
          handleOccurrence();
        }
      } else {
        repeat = false;
      }
    }
  };
  switch (freq) {
    case "daily":
      nr = count && occurredBefore ? floor(getDayDiff(from, start) / interval) : 0;
      while (repeat) {
        iterator = getDate(fromYear, fromMonth, fromDay + nr * interval, origHours, origMinutes, origSeconds);
        if (iterator <= rangeEnd && nr < countOrInfinity) {
          handleOccurrence();
        } else {
          repeat = false;
        }
      }
      break;
    case "weekly":
      {
        var sortedDays = weekDayValues;
        var fromFirstWeekDay = getFirstDayOfWeek(from, {
          firstDay: weekStart
        });
        var fromWeekDay_1 = fromFirstWeekDay.getDay();
        sortedDays.sort(function (a, b) {
          a = a - fromWeekDay_1;
          a = a < 0 ? a + 7 : a;
          b = b - fromWeekDay_1;
          b = b < 0 ? b + 7 : b;
          return a - b;
        });
        while (repeat) {
          for (var _a = 0, sortedDays_1 = sortedDays; _a < sortedDays_1.length; _a++) {
            var weekDay = sortedDays_1[_a];
            first = addDays(fromFirstWeekDay, weekDay < weekStart ? weekDay - weekStart + 7 : weekDay - weekStart);
            iterator = getDate(getYear(first), getMonth(first), getDay(first) + i * 7 * interval, origHours, origMinutes, origSeconds);
            if (iterator <= rangeEnd && nr < countOrInfinity) {
              if (iterator >= fromDate) {
                handleOccurrence();
              }
            } else {
              repeat = false;
            }
          }
          i++;
        }
        break;
      }
    case "monthly":
      while (repeat) {
        var maxDays = getMaxDays(fromYear, fromMonth + i * interval);
        if (hasPos) {
          var monthFirstDay = getDate(fromYear, fromMonth + i * interval, 1);
          var monthLastDay = getDate(fromYear, fromMonth + i * interval + 1, 1);
          handlePos(monthFirstDay, monthLastDay);
        } else {
          for (var _b = 0, days_1 = days; _b < days_1.length; _b++) {
            var d = days_1[_b];
            var day = +d;
            iterator = getDate(fromYear, fromMonth + i * interval, day < 0 ? maxDays + day + 1 : day, origHours, origMinutes, origSeconds);
            if (iterator <= rangeEnd && nr < countOrInfinity) {
              if (maxDays >= day && iterator >= fromDate) {
                handleOccurrence();
              }
            } else {
              repeat = false;
            }
          }
        }
        i++;
      }
      break;
    case "yearly":
      while (repeat) {
        for (var _c = 0, months_1 = months; _c < months_1.length; _c++) {
          var m = months_1[_c];
          var month = +m;
          var maxDays = getMaxDays(fromYear + i * interval, month - 1);
          if (hasPos) {
            var monthFirstDay = getDate(fromYear + i * interval, month - 1, 1);
            var monthLastDay = getDate(fromYear + i * interval, month, 1);
            handlePos(monthFirstDay, monthLastDay);
          } else {
            for (var _d = 0, days_2 = days; _d < days_2.length; _d++) {
              var d = days_2[_d];
              var day = +d;
              iterator = getDate(fromYear + i * interval, month - 1, day < 0 ? maxDays + day + 1 : day, origHours, origMinutes, origSeconds);
              if (iterator <= rangeEnd && nr < countOrInfinity) {
                if (maxDays >= day && iterator >= fromDate) {
                  handleOccurrence();
                }
              } else {
                repeat = false;
              }
            }
          }
        }
        i++;
      }
      break;
  }
  return firstOnly ? closest : lastOnly ? latest : occurrences;
}
function getEventMap(list, start, end, s, overwrite) {
  var obj = {};
  if (!list) {
    return UNDEFINED;
  }
  for (var _i = 0, list_3 = list; _i < list_3.length; _i++) {
    var item = list_3[_i];
    var tzOpt = getTzOpt(s, item, true);
    var tzOptDisplay = getTzOpt(s, item);
    var d = getDateFromItem(item);
    var dt = makeDate(d, tzOptDisplay);
    if (item.recurring) {
      var dtStart = ISO_8601_TIME.test(d) ? null : makeDate(d);
      var origStart = createDate(tzOpt, dt);
      var oEnd = item.end ? makeDate(item.end, tzOpt) : origStart;
      var origEnd = item.end === "00:00" ? addDays(oEnd, 1) : oEnd;
      var duration = +origEnd - +origStart;
      var from = addDays(start, -1);
      var until = addDays(end, 1);
      var dates = getOccurrences(item.recurring, dtStart, origStart, from, until, s, item.recurringException, item.recurringExceptionRule);
      for (var _a = 0, dates_1 = dates; _a < dates_1.length; _a++) {
        var occurrence = dates_1[_a];
        var date = occurrence.d;
        var clone = __assign({}, item);
        if (item.start) {
          clone.start = createDate(tzOpt, date.getFullYear(), date.getMonth(), date.getDate(), origStart.getHours(), origStart.getMinutes(), origStart.getSeconds());
        } else {
          clone.allDay = true;
          clone.start = createDate(UNDEFINED, date.getFullYear(), date.getMonth(), date.getDate());
        }
        if (item.end) {
          if (item.allDay) {
            var endDay = addDays(date, getDayDiff(origStart, origEnd));
            clone.end = new Date(endDay.getFullYear(), endDay.getMonth(), endDay.getDate(), origEnd.getHours(), origEnd.getMinutes(), origEnd.getSeconds());
          } else {
            clone.end = createDate(tzOpt, +clone.start + duration);
          }
        }
        clone.nr = occurrence.i;
        clone.occurrenceId = clone.id + "_" + getDateStr(clone.start);
        clone.original = item;
        if (clone.start && clone.end) {
          addMultiDayEvent(obj, clone, s, overwrite);
        } else {
          addToList(obj, date, clone);
        }
      }
    } else if (item.start && item.end) {
      addMultiDayEvent(obj, item, s, overwrite);
    } else if (dt) {
      addToList(obj, dt, item);
    }
  }
  return obj;
}
var labelGuid = 1;
var MULTI_YEAR_VIEW = "multi-year";
var YEAR_VIEW = "year";
var MONTH_VIEW = "month";
var PAGE_VIEW = "page";
var PAGE_WIDTH = 296;
var calendarViewDefaults = /*#__PURE__*/extend(dateTimeLocale, {
  dateText: "Date",
  eventText: "event",
  eventsText: "events",
  moreEventsText: "{count} more",
  nextPageText: "Next page",
  prevPageText: "Previous page",
  showEventTooltip: true,
  showToday: true,
  timeText: "Time"
});
function getFirstPageDay(pageIndex, s) {
  var refDate = s.refDate ? makeDate(s.refDate) : REF_DATE;
  var pageType = s.showCalendar ? s.calendarType : s.eventRange;
  var pageSize = (s.showCalendar ? pageType === "year" ? 1 : pageType === "week" ? s.weeks : s.size : s.eventRangeSize) || 1;
  var getDate = s.getDate;
  var ref = pageType === "week" ? getFirstDayOfWeek(refDate, s) : refDate;
  var year = s.getYear(ref);
  var month = s.getMonth(ref);
  var day = s.getDay(ref);
  switch (pageType) {
    case "year":
      return getDate(year + pageIndex * pageSize, 0, 1);
    case "week":
      return getDate(year, month, day + 7 * pageSize * pageIndex);
    case "day":
      return getDate(year, month, day + pageSize * pageIndex);
    default:
      return getDate(year, month + pageIndex * pageSize, 1);
  }
}
function getPageIndex(d, s) {
  var refDate = s.refDate ? makeDate(s.refDate) : REF_DATE;
  var getYear = s.getYear;
  var getMonth = s.getMonth;
  var pageType = s.showCalendar ? s.calendarType : s.eventRange;
  var pageSize = (s.showCalendar ? pageType === "year" ? 1 : pageType === "week" ? s.weeks : s.size : s.eventRangeSize) || 1;
  var diff;
  switch (pageType) {
    case "year":
      diff = getYear(d) - getYear(refDate);
      break;
    case "week":
      diff = getDayDiff(getFirstDayOfWeek(refDate, s), getFirstDayOfWeek(d, s)) / 7;
      break;
    case "day":
      diff = getDayDiff(refDate, d);
      break;
    case "month":
      diff = getMonth(d) - getMonth(refDate) + (getYear(d) - getYear(refDate)) * 12;
      break;
    default:
      return UNDEFINED;
  }
  return floor(diff / pageSize);
}
function getYearsIndex(d, s) {
  var refDate = s.refDate ? makeDate(s.refDate) : REF_DATE;
  return floor((s.getYear(d) - s.getYear(refDate)) / 12);
}
function getYearIndex(d, s) {
  var refDate = s.refDate ? makeDate(s.refDate) : REF_DATE;
  return s.getYear(d) - s.getYear(refDate);
}
function getMonthIndex(d, s) {
  var refDate = s.refDate ? makeDate(s.refDate) : REF_DATE;
  return s.getMonth(d) - s.getMonth(refDate) + (s.getYear(d) - s.getYear(refDate)) * 12;
}
function compareEvents(a, b) {
  var start1 = makeDate(a.start || a.date);
  var start2 = makeDate(b.start || a.date);
  var text1 = a.title || a.text;
  var text2 = b.title || b.text;
  var weight1 = !start1 ? 0 : +start1 * (a.allDay ? 1 : 10);
  var weight2 = !start2 ? 0 : +start2 * (b.allDay ? 1 : 10);
  if (weight1 === weight2) {
    return text1 > text2 ? 1 : -1;
  }
  return weight1 - weight2;
}
function getPageNr(pages, width) {
  return pages === "auto" ? Math.max(1, Math.min(3, Math.floor(width ? width / PAGE_WIDTH : 1))) : pages ? +pages : 1;
}
function getLabels(s, labelsObj, start, end, maxLabels, days, allDayOnly, firstWeekDay, isMultiRow, eventOrder, noOuterDays, showLabelCount, moreEventsText, moreEventsPluralText) {
  labelsObj = labelsObj || {};
  var dayLabels = {};
  var eventDays = new Map();
  var eventRows = {};
  var day = start;
  var uid = 0;
  var max = maxLabels;
  var rowEnd = end;
  while (day < end) {
    var dateKey = getDateStr(day);
    var weekDay = day.getDay();
    var monthDay = s.getDay(day);
    var lastDayOfMonth = noOuterDays && s.getDate(s.getYear(day), s.getMonth(day) + 1, 0);
    var isRowStart = isMultiRow && (weekDay === firstWeekDay || monthDay === 1 && noOuterDays) || +day === +start;
    var firstDay = getFirstDayOfWeek(day, s);
    var events = sortEvents(labelsObj[dateKey] || [], eventOrder);
    var prevEvent = void 0;
    var prevEventDays = void 0;
    var prevIndex = void 0;
    var row = 0;
    var displayed = 0;
    var i = 0;
    if (isRowStart) {
      eventRows = {};
      rowEnd = isMultiRow ? addDays(firstDay, days) : end;
    }
    if (allDayOnly) {
      events = events.filter(function (ev) {
        return ev.allDay;
      });
    }
    if (maxLabels === -1) {
      max = events.length + 1;
    }
    var eventsNr = events.length;
    var data = [];
    if (showLabelCount) {
      data.push({
        id: "count_" + +day,
        count: eventsNr,
        placeholder: eventsNr === 0
      });
      row = max;
    }
    while (eventsNr && row < max) {
      prevEvent = null;
      for (var j = 0; j < events.length; j++) {
        if (eventRows[row] === events[j]) {
          prevEvent = events[j];
          prevIndex = j;
        }
      }
      prevEventDays = prevEvent ? eventDays.get(prevEvent) || [] : [];
      if (row === max - 1 && (displayed < eventsNr - 1 || i === eventsNr && !prevEvent) && maxLabels !== -1) {
        var nr = eventsNr - displayed;
        var moreText = moreEventsText || "";
        var text = (nr > 1 ? moreEventsPluralText || moreText : moreText).replace(/{count}/, nr);
        if (nr) {
          data.push({
            id: "more_" + ++uid,
            more: text,
            label: text
          });
        }
        if (prevEvent) {
          eventRows[row] = null;
          for (var _i = 0, prevEventDays_1 = prevEventDays; _i < prevEventDays_1.length; _i++) {
            var d = prevEventDays_1[_i];
            var t = moreText.replace(/{count}/, "1");
            dayLabels[getDateStr(d)].data[row] = {
              id: "more_" + ++uid,
              more: t,
              label: t
            };
          }
        }
        displayed++;
        row++;
      } else if (prevEvent) {
        if (prevIndex === i) {
          i++;
        }
        if (isSameDay(day, makeDate(prevEvent.end, getTzOpt(s, prevEvent)))) {
          eventRows[row] = null;
        }
        data.push({
          id: prevEvent.occurrenceId || prevEvent.id,
          event: prevEvent
        });
        row++;
        displayed++;
        prevEventDays.push(day);
      } else if (i < eventsNr) {
        var event_1 = events[i];
        var allDay = event_1.allDay;
        var tzOpt = getTzOpt(s, event_1);
        var startTime = event_1.start && makeDate(event_1.start, tzOpt);
        if (!startTime || isSameDay(day, startTime) || isRowStart) {
          var eventEnd = event_1.end && makeDate(event_1.end, tzOpt);
          var endTime = getEndDate(s, allDay, startTime, eventEnd, true);
          var multiDay = endTime && !isSameDay(startTime, endTime);
          var labelEnd = lastDayOfMonth && lastDayOfMonth < endTime ? lastDayOfMonth : endTime;
          var startStr = startTime ? ", " + s.fromText + ": " + formatDate("DDDD, MMMM D, YYYY", startTime, s) : "";
          var endStr = endTime ? ", " + s.toText + ": " + formatDate("DDDD, MMMM D, YYYY", endTime, s) : "";
          if (event_1.id === UNDEFINED) {
            event_1.id = "mbsc_" + labelGuid++;
          }
          if (multiDay) {
            eventRows[row] = event_1;
          }
          eventDays.set(event_1, [day]);
          data.push({
            event: event_1,
            id: event_1.occurrenceId || event_1.id,
            label: (event_1.title || event_1.text || "") + startStr + endStr,
            lastDay: lastDayOfMonth ? addDays(lastDayOfMonth, 1) : UNDEFINED,
            multiDay: multiDay,
            showText: true,
            width: multiDay ? Math.min(getDayDiff(day, labelEnd) + 1, getDayDiff(day, rowEnd)) * 100 : 100
          });
          row++;
          displayed++;
        }
        i++;
      } else {
        if (displayed < eventsNr) {
          data.push({
            id: "ph_" + ++uid,
            placeholder: true
          });
        }
        row++;
      }
    }
    dayLabels[dateKey] = {
      data: data,
      events: events
    };
    day = getDateOnly(addDays(day, 1));
  }
  return dayLabels;
}
function sortEvents(events, eventOrder) {
  return events && events.slice(0).sort(eventOrder || compareEvents);
}
function computeEventResize(eventResize, calendarResize, resourceResize) {
  if (eventResize === false || resourceResize === false || !calendarResize) {
    return false;
  }
  return true;
}
function computeEventDragInTime(eventDragInTime, resourceDragInTime, calendarDragInTime) {
  if (eventDragInTime === false || resourceDragInTime === false || calendarDragInTime === false) {
    return false;
  }
  return true;
}
function computeEventDragBetweenResources(eventDragBetweenResources, resourceDragBetweenResources, calendarDragBetweenResources) {
  if (eventDragBetweenResources === false || resourceDragBetweenResources === false || calendarDragBetweenResources === false) {
    return false;
  }
  return true;
}
function computeEventDragBetweenSlots(eventDragBetweenSlot, resourceDragBetweenSlots, slotDragBetweenSlot, calendarDragBetweenSlots) {
  if (eventDragBetweenSlot === false || resourceDragBetweenSlots === false || slotDragBetweenSlot === false || calendarDragBetweenSlots === false) {
    return false;
  }
  return true;
}
var MBSC_OPTIONS = new InjectionToken("MbscOptions");
var MbscOptionsService = /*#__PURE__*/function () {
  function MbscOptionsService(_staticOptions, _parentService) {
    this._staticOptions = _staticOptions;
    this._parentService = _parentService;
    this.change = new Observable();
    this._options = {};
  }
  Object.defineProperty(MbscOptionsService.prototype, "options", {
    get: function () {
      return this._options;
    },
    enumerable: false,
    configurable: true
  });
  MbscOptionsService.prototype.setOptions = function (newOptions) {
    this._options = this._parentService ? __assign(__assign(__assign({}, this._staticOptions), this._parentService.options), newOptions) : __assign(__assign({}, this._staticOptions), newOptions);
    this.change.next(this.options);
  };
  MbscOptionsService.ɵfac = function MbscOptionsService_Factory(t) {
    return new (t || MbscOptionsService)(i0.ɵɵinject(MBSC_OPTIONS, 8), i0.ɵɵinject(forwardRef(function () {
      return MbscOptionsService;
    }), 12));
  };
  MbscOptionsService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MbscOptionsService,
    factory: MbscOptionsService.ɵfac
  });
  return MbscOptionsService;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function updateValue(inst, val) {
  inst._val = val;
  if (inst._onValueChange) {
    inst._onValueChange(val);
  }
  inst.setState({
    value: val
  });
}
var Base = /*#__PURE__*/function () {
  function Base(_cdr, _elr, _zone, _sanitizer, _injector, _vcf, _ctrl, _optp, _globals) {
    var _this = this;
    this._cdr = _cdr;
    this._elr = _elr;
    this._zone = _zone;
    this._sanitizer = _sanitizer;
    this._injector = _injector;
    this._vcf = _vcf;
    this._ctrl = _ctrl;
    this._optp = _optp;
    this.state = {};
    this.props = {};
    this.valueChange = new EventEmitter();
    this.onDestroy = new EventEmitter();
    this.onInit = new EventEmitter();
    this._onFormChange = noop;
    this._onFormTouch = noop;
    if (_optp) {
      this._opt = _optp.options;
      this._ctxChange = _optp.change.subscribe(function (nextOptions) {
        _this._opt = nextOptions;
        _this.forceUpdate();
      });
    } else if (_globals) {
      this._opt = _globals;
    }
    if (_ctrl) {
      _ctrl.valueAccessor = this;
    }
    this._ctor();
  }
  Object.defineProperty(Base.prototype, "value", {
    get: function () {
      return this._val;
    },
    set: function (val) {
      if (this._val !== val) {
        updateValue(this, val);
        this._onFormChange(val);
        this.valueChange.emit(val);
      }
    },
    enumerable: false,
    configurable: true
  });
  Base.prototype.ngOnChanges = function (changes) {
    var optionsKey = "options";
    var optionsChange = changes[optionsKey];
    if (optionsChange) {
      var opt = optionsChange.currentValue;
      if (opt) {
        for (var _i = 0, _a = Object.keys(opt); _i < _a.length; _i++) {
          var key = _a[_i];
          this.props[key] = opt[key];
        }
      }
    }
    for (var _b = 0, _c = Object.keys(changes); _b < _c.length; _b++) {
      var key = _c[_b];
      this.props[key] = changes[key].currentValue;
    }
    this._doCheck = true;
  };
  Base.prototype.ngDoCheck = function () {
    if (this._doCheck) {
      this._willUpdate();
    }
  };
  Base.prototype.ngAfterViewChecked = function () {
    if (this._doCheck) {
      this._updated();
    }
    this._doCheck = false;
  };
  Base.prototype.ngOnInit = function () {
    this._doCheck = true;
    this.__init();
    this._init();
  };
  Base.prototype.ngAfterViewInit = function () {
    this._el = this._el || this._elr.nativeElement;
    this._mounted();
  };
  Base.prototype.ngOnDestroy = function () {
    if (this._optp) {
      this._optp.change.unsubscribe(this._ctxChange);
    }
    this._destroy();
    this.__destroy();
  };
  Base.prototype._getKey = function (index) {
    return index;
  };
  Base.prototype.forceUpdate = function () {
    var _this = this;
    if (NgZone.isInAngularZone()) {
      this._doCheck = true;
      this._cdr.markForCheck();
    } else {
      this._zone.run(function () {
        _this._doCheck = true;
        _this._cdr.markForCheck();
      });
    }
  };
  Base.prototype.setState = function (newState) {
    var changed;
    for (var _i = 0, _a = Object.keys(newState); _i < _a.length; _i++) {
      var key = _a[_i];
      if (this.state[key] !== newState[key]) {
        this.state[key] = newState[key];
        changed = true;
      }
    }
    if (changed) {
      this.forceUpdate();
    }
  };
  Base.prototype._emit = function (name, args) {
    var emitter = this[name];
    if (emitter && emitter instanceof EventEmitter) {
      emitter.emit(args);
    }
  };
  Base.prototype._safeHtml = function (html) {
    return this._sanitizer.bypassSecurityTrustHtml(html);
  };
  Base.prototype._ctor = function () {};
  Base.prototype._init = function () {};
  Base.prototype.__init = function () {};
  Base.prototype._mounted = function () {};
  Base.prototype._updated = function () {};
  Base.prototype._destroy = function () {};
  Base.prototype.__destroy = function () {};
  Base.prototype._willUpdate = function () {};
  Base.ɵfac = function Base_Factory(t) {
    return new (t || Base)(i0.ɵɵdirectiveInject(ChangeDetectorRef), i0.ɵɵdirectiveInject(ElementRef), i0.ɵɵdirectiveInject(NgZone), i0.ɵɵdirectiveInject(DomSanitizer), i0.ɵɵdirectiveInject(Injector), i0.ɵɵdirectiveInject(ViewContainerRef), i0.ɵɵdirectiveInject(NgControl, 10), i0.ɵɵdirectiveInject(MbscOptionsService, 8), i0.ɵɵdirectiveInject(MBSC_OPTIONS, 8));
  };
  Base.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: Base,
    selectors: [["", "mbsc-b", ""]],
    inputs: {
      class: "class",
      context: "context",
      locale: "locale",
      modules: "modules",
      options: "options",
      responsive: "responsive",
      rtl: "rtl",
      theme: "theme",
      themeVariant: "themeVariant",
      touchUi: "touchUi",
      value: "value"
    },
    outputs: {
      valueChange: "valueChange",
      onDestroy: "onDestroy",
      onInit: "onInit"
    },
    features: [i0.ɵɵNgOnChangesFeature]
  });
  return Base;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var guid = 0;
var BREAKPOINTS = {
  large: 992,
  medium: 768,
  small: 576,
  xlarge: 1200,
  xsmall: 0
};
var isDark;
if (isDarkQuery) {
  isDark = isDarkQuery.matches;
  isDarkQuery.addListener(function (ev) {
    isDark = ev.matches;
    globalChanges.next();
  });
}
var BaseComponent = /*#__PURE__*/function (_super) {
  __extends(BaseComponent, _super);
  function BaseComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.s = {};
    _this.state = {};
    _this._mbsc = true;
    _this._v = {
      version: "5.29.1"
    };
    _this._uid = ++guid;
    _this._proxyHook = function (args) {
      _this._hook(args.type, args);
    };
    return _this;
  }
  Object.defineProperty(BaseComponent.prototype, "nativeElement", {
    get: function () {
      return this._el;
    },
    enumerable: false,
    configurable: true
  });
  BaseComponent.prototype.destroy = function () {};
  BaseComponent.prototype._hook = function (name, args) {
    var s = this.s;
    args.inst = this;
    args.type = name;
    if (s[name]) {
      return s[name](args, this);
    }
    this._emit(name, args);
  };
  BaseComponent.prototype.__init = function () {
    var _this = this;
    var self = this.constructor;
    if (self.defaults) {
      this._optChange = globalChanges.subscribe(function () {
        _this.forceUpdate();
      });
      var modules = this.props.modules;
      if (modules) {
        for (var _i = 0, modules_1 = modules; _i < modules_1.length; _i++) {
          var module = modules_1[_i];
          if (module.init) {
            module.init(this);
          }
        }
      }
    }
    this._hook("onInit", {});
  };
  BaseComponent.prototype.__destroy = function () {
    if (this._optChange !== UNDEFINED) {
      globalChanges.unsubscribe(this._optChange);
    }
    this._hook("onDestroy", {});
  };
  BaseComponent.prototype._render = function (s, state) {
    return;
  };
  BaseComponent.prototype._willUpdate = function () {
    this._merge();
    this._render(this.s, this.state);
  };
  BaseComponent.prototype._resp = function (s) {
    var resp = s.responsive;
    var ret;
    var br = -1;
    var width = this.state.width;
    if (width === UNDEFINED) {
      width = 375;
    }
    if (resp && width) {
      for (var _i = 0, _a = Object.keys(resp); _i < _a.length; _i++) {
        var key = _a[_i];
        var value = resp[key];
        var breakpoint = value.breakpoint || BREAKPOINTS[key];
        if (width >= breakpoint && breakpoint > br) {
          ret = value;
          br = breakpoint;
        }
      }
    }
    return ret;
  };
  BaseComponent.prototype._merge = function () {
    var self = this.constructor;
    var defaults = self.defaults;
    var context = this._opt || {};
    var props = {};
    var s;
    var themeDef;
    this._prevS = this.s || {};
    if (defaults) {
      for (var prop in this.props) {
        if (this.props[prop] !== UNDEFINED) {
          props[prop] = this.props[prop];
        }
      }
      var locale = props.locale || context.locale || options.locale || {};
      var calendarSystem = props.calendarSystem || locale.calendarSystem || context.calendarSystem || options.calendarSystem;
      var themeName = props.theme || context.theme || options.theme;
      var themeVariant = props.themeVariant || context.themeVariant || options.themeVariant;
      if (themeName === "auto" || !themeName) {
        themeName = autoDetect.theme || "";
      }
      if ((themeVariant === "dark" || isDark && (themeVariant === "auto" || !themeVariant)) && themes[themeName + "-dark"]) {
        themeName += "-dark";
      }
      props.theme = themeName;
      themeDef = themes[themeName];
      var theme = themeDef && themeDef[self._name];
      s = __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, defaults), theme), locale), options), context), calendarSystem), props);
      var resp = this._resp(s);
      this._respProps = resp;
      if (resp) {
        s = __assign(__assign({}, s), resp);
      }
    } else {
      s = __assign({}, this.props);
      themeDef = themes[s.theme];
    }
    var baseTheme = themeDef && themeDef.baseTheme;
    s.baseTheme = baseTheme;
    this.s = s;
    this._className = s.cssClass || s.class || s.className || "";
    this._rtl = " mbsc-" + (s.rtl ? "rtl" : "ltr");
    this._theme = " mbsc-" + s.theme + (baseTheme ? " mbsc-" + baseTheme : "");
    this._touchUi = s.touchUi === "auto" || s.touchUi === UNDEFINED ? touchUi : s.touchUi;
    this._hb = os === "ios" && (s.theme === "ios" || baseTheme === "ios") ? " mbsc-hb" : "";
  };
  BaseComponent.defaults = UNDEFINED;
  BaseComponent._name = "";
  BaseComponent.ɵfac = /* @__PURE__ */(() => {
    let ɵBaseComponent_BaseFactory;
    return function BaseComponent_Factory(t) {
      return (ɵBaseComponent_BaseFactory || (ɵBaseComponent_BaseFactory = i0.ɵɵgetInheritedFactory(BaseComponent)))(t || BaseComponent);
    };
  })();
  BaseComponent.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: BaseComponent,
    selectors: [["", "mbsc-bc", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return BaseComponent;
}(Base);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var doc = isBrowser ? document : UNDEFINED;
var win = isBrowser ? window : UNDEFINED;
var prefixes = ["Webkit", "Moz"];
var elem = doc && doc.createElement("div").style;
var canvas = doc && doc.createElement("canvas");
var ctx = canvas && canvas.getContext && canvas.getContext("2d", {
  willReadFrequently: true
});
var css = win && win.CSS;
var cssSupports = css && css.supports;
var textColors = {};
var raf = win && win.requestAnimationFrame || function (func) {
  return setTimeout(func, 20);
};
var rafc = win && win.cancelAnimationFrame || function (id) {
  clearTimeout(id);
};
var hasAnimation = elem && elem.animationName !== UNDEFINED;
var isWebView = os === "ios" && !isSafari;
var isWkWebView = isWebView && win && win.webkit && win.webkit.messageHandlers;
var hasGhostClick = elem && elem.touchAction === UNDEFINED || isWebView && !isWkWebView;
var jsPrefix = getPrefix();
var cssPrefix = jsPrefix ? "-" + jsPrefix.toLowerCase() + "-" : "";
var has3d = cssSupports && cssSupports("(transform-style: preserve-3d)");
var hasSticky = cssSupports && (cssSupports("position", "sticky") || cssSupports("position", "-webkit-sticky"));
function getPrefix() {
  if (!elem || elem.transform !== UNDEFINED) {
    return "";
  }
  for (var _i = 0, prefixes_1 = prefixes; _i < prefixes_1.length; _i++) {
    var prefix = prefixes_1[_i];
    if (elem[prefix + "Transform"] !== UNDEFINED) {
      return prefix;
    }
  }
  return "";
}
function listen(el, event, handler, opt) {
  if (el) {
    el.addEventListener(event, handler, opt);
  }
}
function unlisten(el, event, handler, opt) {
  if (el) {
    el.removeEventListener(event, handler, opt);
  }
}
function getDocument(el) {
  if (!isBrowser) {
    return UNDEFINED;
  }
  return el && el.ownerDocument ? el.ownerDocument : doc;
}
function getDimension(el, property) {
  return parseFloat(getComputedStyle(el)[property] || "0");
}
function getScrollLeft(el) {
  return el.scrollLeft !== UNDEFINED ? el.scrollLeft : el.pageXOffset;
}
function getScrollTop(el) {
  return el.scrollTop !== UNDEFINED ? el.scrollTop : el.pageYOffset;
}
function setScrollLeft(el, val) {
  if (el.scrollTo) {
    el.scrollTo(val, el.scrollY);
  } else {
    el.scrollLeft = val;
  }
}
function setScrollTop(el, val) {
  if (el.scrollTo) {
    el.scrollTo(el.scrollX, val);
  } else {
    el.scrollTop = val;
  }
}
function getWindow(el) {
  if (!isBrowser) {
    return UNDEFINED;
  }
  return el && el.ownerDocument && el.ownerDocument.defaultView ? el.ownerDocument.defaultView : win;
}
function getPosition(el, vertical) {
  var style = getComputedStyle(el);
  var transform = jsPrefix ? style[jsPrefix + "Transform"] : style.transform;
  var matrix = transform.split(")")[0].split(", ");
  var px = vertical ? matrix[13] || matrix[5] : matrix[12] || matrix[4];
  return +px || 0;
}
function getTextColor(color) {
  if (!ctx || !color) {
    return "#000";
  }
  if (textColors[color]) {
    return textColors[color];
  }
  ctx.fillStyle = color;
  ctx.fillRect(0, 0, 1, 1);
  var img = ctx.getImageData(0, 0, 1, 1);
  var rgb = img ? img.data : [0, 0, 0];
  var delta = +rgb[0] * .299 + +rgb[1] * .587 + +rgb[2] * .114;
  var textColor = delta < 130 ? "#fff" : "#000";
  textColors[color] = textColor;
  return textColor;
}
function scrollStep(elm, startTime, fromX, fromY, toX, toY, callback) {
  var elapsed = Math.min(1, (+new Date() - startTime) / 468);
  var eased = .5 * (1 - Math.cos(Math.PI * elapsed));
  var currentX;
  var currentY;
  if (toX !== UNDEFINED) {
    currentX = round(fromX + (toX - fromX) * eased);
    elm.scrollLeft = currentX;
  }
  if (toY !== UNDEFINED) {
    currentY = round(fromY + (toY - fromY) * eased);
    elm.scrollTop = currentY;
  }
  if (currentX !== toX || currentY !== toY) {
    raf(function () {
      scrollStep(elm, startTime, fromX, fromY, toX, toY, callback);
    });
  } else if (callback) {
    callback();
  }
}
function smoothScroll(elm, toX, toY, animate, rtl, callback) {
  if (toX !== UNDEFINED) {
    toX = Math.max(0, round(toX));
  }
  if (toY !== UNDEFINED) {
    toY = Math.max(0, round(toY));
  }
  if (rtl && toX !== UNDEFINED) {
    toX = -toX;
  }
  if (animate) {
    scrollStep(elm, +new Date(), elm.scrollLeft, elm.scrollTop, toX, toY, callback);
  } else {
    if (toX !== UNDEFINED) {
      elm.scrollLeft = toX;
    }
    if (toY !== UNDEFINED) {
      elm.scrollTop = toY;
    }
    if (callback) {
      callback();
    }
  }
}
function htmlToText(htmlString) {
  if (doc && htmlString) {
    var tempElm = doc.createElement("div");
    tempElm.innerHTML = htmlString;
    return tempElm.textContent.trim();
  }
  return htmlString || "";
}
function getOffset(el) {
  var bRect = el.getBoundingClientRect();
  var ret = {
    left: bRect.left,
    top: bRect.top
  };
  var window = getWindow(el);
  if (window !== UNDEFINED) {
    ret.top += getScrollTop(window);
    ret.left += getScrollLeft(window);
  }
  return ret;
}
function matches(elm, selector) {
  var matchesSelector = elm && (elm.matches || elm.msMatchesSelector);
  return matchesSelector && matchesSelector.call(elm, selector);
}
function closest(elm, selector, context) {
  while (elm && !matches(elm, selector)) {
    if (elm === context || elm.nodeType === elm.DOCUMENT_NODE) {
      return null;
    }
    elm = elm.parentNode;
  }
  return elm;
}
function trigger(elm, name, data) {
  var evt;
  try {
    evt = new CustomEvent(name, {
      bubbles: true,
      cancelable: true,
      detail: data
    });
  } catch (e) {
    evt = document.createEvent("Event");
    evt.initEvent(name, true, true);
    evt.detail = data;
  }
  elm.dispatchEvent(evt);
}
function forEach(items, func) {
  for (var i = 0; i < items.length; i++) {
    func(items[i], i);
  }
}
var ANIMATION_START = "animationstart";
var BLUR = "blur";
var CHANGE = "change";
var CLICK = "click";
var CONTEXTMENU = "contextmenu";
var DOUBLE_CLICK = "dblclick";
var FOCUS = "focus";
var FOCUS_IN = "focusin";
var INPUT = "input";
var KEY_DOWN = "keydown";
var MOUSE_DOWN = "mousedown";
var MOUSE_MOVE = "mousemove";
var MOUSE_UP = "mouseup";
var MOUSE_OVER = "mousedown";
var MOUSE_ENTER = "mouseenter";
var MOUSE_LEAVE = "mouseleave";
var MOUSE_WHEEL = "mousewheel";
var RESIZE = "resize";
var SCROLL = "scroll";
var TOUCH_START = "touchstart";
var TOUCH_MOVE = "touchmove";
var TOUCH_END = "touchend";
var TOUCH_CANCEL = "touchcancel";
var WHEEL = "wheel";
var BACKSPACE = 8;
var TAB = 9;
var ENTER = 13;
var ESC = 27;
var SPACE = 32;
var PAGE_UP = 33;
var PAGE_DOWN = 34;
var END = 35;
var HOME = 36;
var LEFT_ARROW = 37;
var UP_ARROW = 38;
var RIGHT_ARROW = 39;
var DOWN_ARROW = 40;
var DELETE = 46;
var markup = '<div class="mbsc-resize"><div class="mbsc-resize-i mbsc-resize-x"></div></div>' + '<div class="mbsc-resize"><div class="mbsc-resize-i mbsc-resize-y"></div></div>';
var observer;
var count = 0;
function resizeObserver(el, callback, zone) {
  var expand;
  var expandChild;
  var helper;
  var hiddenRafId;
  var rafId;
  var shrink;
  var stopCheck;
  var lastCheck = 0;
  function reset() {
    expandChild.style.width = "100000px";
    expandChild.style.height = "100000px";
    expand.scrollLeft = 1e5;
    expand.scrollTop = 1e5;
    shrink.scrollLeft = 1e5;
    shrink.scrollTop = 1e5;
  }
  function checkHidden() {
    var now = +new Date();
    hiddenRafId = 0;
    if (!stopCheck) {
      if (now - lastCheck > 200 && !expand.scrollTop && !expand.scrollLeft) {
        lastCheck = now;
        reset();
      }
      if (!hiddenRafId) {
        hiddenRafId = raf(checkHidden);
      }
    }
  }
  function onScroll() {
    if (!rafId) {
      rafId = raf(onResize);
    }
  }
  function onResize() {
    rafId = 0;
    reset();
    callback();
  }
  if (win && win.ResizeObserver) {
    if (!observer) {
      observer = new win.ResizeObserver(function (entries) {
        if (!rafId) {
          rafId = raf(function () {
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
              var entry = entries_1[_i];
              if (entry.target.__mbscResize) {
                entry.target.__mbscResize();
              }
            }
            rafId = 0;
          });
        }
      });
    }
    count++;
    el.__mbscResize = function () {
      if (zone) {
        zone.run(callback);
      } else {
        callback();
      }
    };
    observer.observe(el);
  } else {
    helper = doc && doc.createElement("div");
  }
  if (helper) {
    helper.innerHTML = markup;
    helper.dir = "ltr";
    shrink = helper.childNodes[1];
    expand = helper.childNodes[0];
    expandChild = expand.childNodes[0];
    el.appendChild(helper);
    listen(expand, "scroll", onScroll);
    listen(shrink, "scroll", onScroll);
    if (zone) {
      zone.runOutsideAngular(function () {
        raf(checkHidden);
      });
    } else {
      raf(checkHidden);
    }
  }
  return {
    detach: function () {
      if (observer) {
        count--;
        delete el.__mbscResize;
        observer.unobserve(el);
        if (!count) {
          observer = UNDEFINED;
        }
      } else {
        if (helper) {
          unlisten(expand, "scroll", onScroll);
          unlisten(shrink, "scroll", onScroll);
          el.removeChild(helper);
          rafc(rafId);
          helper = UNDEFINED;
        }
        stopCheck = true;
      }
    }
  };
}
var activeModal;
var EDITABLE = "input,select,textarea,button";
var ALLOW_ENTER = 'textarea,button,input[type="button"],input[type="submit"]';
var FOCUSABLE = EDITABLE + ',[tabindex="0"]';
var MAX_WIDTH = 600;
var KEY_CODES = {
  enter: ENTER,
  esc: ESC,
  space: SPACE
};
var needsFixed = isBrowser && /(iphone|ipod)/i.test(userAgent) && majorVersion >= 7 && majorVersion < 15;
function processButtons(inst, buttons) {
  var s = inst.s;
  var processedButtons = [];
  var predefinedButtons = {
    cancel: {
      cssClass: "mbsc-popup-button-close",
      name: "cancel",
      text: s.cancelText
    },
    close: {
      cssClass: "mbsc-popup-button-close",
      name: "close",
      text: s.closeText
    },
    ok: {
      cssClass: "mbsc-popup-button-primary",
      keyCode: ENTER,
      name: "ok",
      text: s.okText
    },
    set: {
      cssClass: "mbsc-popup-button-primary",
      keyCode: ENTER,
      name: "set",
      text: s.setText
    }
  };
  if (buttons && buttons.length) {
    buttons.forEach(function (btn) {
      var button = isString(btn) ? predefinedButtons[btn] || {
        text: btn
      } : btn;
      if (!button.handler || isString(button.handler)) {
        if (isString(button.handler)) {
          button.name = button.handler;
        }
        button.handler = function (domEvent) {
          inst._onButtonClick({
            domEvent: domEvent,
            button: button
          });
        };
      }
      processedButtons.push(button);
    });
    return processedButtons;
  }
  return UNDEFINED;
}
function getPrevActive(modal, i) {
  if (i === void 0) {
    i = 0;
  }
  var prevModal = modal._prevModal;
  if (prevModal && prevModal !== modal && i < 10) {
    if (prevModal.isVisible()) {
      return prevModal;
    }
    return getPrevActive(prevModal, i + 1);
  }
  return UNDEFINED;
}
var PopupBase = /*#__PURE__*/function (_super) {
  __extends(PopupBase, _super);
  function PopupBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._lastFocus = +new Date();
    _this._setActive = function (el) {
      _this._active = el;
    };
    _this._setContent = function (el) {
      _this._content = el;
    };
    _this._setLimitator = function (el) {
      _this._limitator = el;
    };
    _this._setPopup = function (el) {
      _this._popup = el;
    };
    _this._setWrapper = function (el) {
      _this._wrapper = el;
    };
    _this._onOverlayClick = function () {
      if (_this._isOpen && _this.s.closeOnOverlayClick && !_this._preventClose) {
        _this._close("overlay");
      }
      _this._preventClose = false;
    };
    _this._onDocClick = function (ev) {
      if (!_this.s.showOverlay && ev.target !== _this.s.focusElm && activeModal === _this) {
        _this._onOverlayClick();
      }
    };
    _this._onMouseDown = function (ev) {
      if (!_this.s.showOverlay) {
        _this._target = ev.target;
      }
    };
    _this._onMouseUp = function (ev) {
      if (_this._target && _this._popup && _this._popup.contains(_this._target) && !_this._popup.contains(ev.target)) {
        _this._preventClose = true;
      }
      _this._target = false;
    };
    _this._onPopupClick = function () {
      if (!_this.s.showOverlay) {
        _this._preventClose = true;
      }
    };
    _this._onAnimationEnd = function (ev) {
      if (ev.target === _this._popup) {
        if (_this._isClosing) {
          _this._onClosed();
          _this._isClosing = false;
          if (_this.state.isReady) {
            _this.setState({
              isReady: false
            });
          } else {
            _this.forceUpdate();
          }
        }
        if (_this._isOpening) {
          _this._onOpened();
          _this._isOpening = false;
          _this.forceUpdate();
        }
      }
    };
    _this._onButtonClick = function (_a) {
      var domEvent = _a.domEvent,
        button = _a.button;
      _this._hook("onButtonClick", {
        domEvent: domEvent,
        button: button
      });
      if (/cancel|close|ok|set/.test(button.name)) {
        _this._close(button.name);
      }
    };
    _this._onFocus = function (ev) {
      var now = +new Date();
      if (activeModal === _this && ev.target.nodeType && _this._ctx.contains(ev.target) && _this._popup && !_this._popup.contains(ev.target) && now - _this._lastFocus > 100 && ev.target !== _this.s.focusElm) {
        _this._lastFocus = now;
        _this._active.focus();
      }
    };
    _this._onKeyDown = function (ev) {
      var s = _this.s;
      var keyCode = ev.keyCode;
      var focusElm = s.focusElm && !s.focusOnOpen ? s.focusElm : UNDEFINED;
      if (keyCode === SPACE && !matches(ev.target, EDITABLE) || _this._lock && (keyCode === UP_ARROW || keyCode === DOWN_ARROW)) {
        ev.preventDefault();
      }
      if (s.focusTrap && keyCode === TAB) {
        var all = _this._popup.querySelectorAll(FOCUSABLE);
        var focusable_1 = [];
        var end_1 = -1;
        var target = 0;
        var current_1 = -1;
        var targetElm = UNDEFINED;
        forEach(all, function (elm) {
          if (!elm.disabled && (elm.offsetHeight || elm.offsetWidth)) {
            focusable_1.push(elm);
            end_1++;
            if (elm === _this._doc.activeElement) {
              current_1 = end_1;
            }
          }
        });
        if (ev.shiftKey) {
          target = end_1;
          end_1 = 0;
        }
        if (current_1 === end_1) {
          targetElm = focusElm || focusable_1[target];
        } else if (ev.target === focusElm) {
          targetElm = focusable_1[target];
        }
        if (targetElm) {
          targetElm.focus();
          ev.preventDefault();
        }
      }
    };
    _this._onContentScroll = function (ev) {
      if (_this._lock && (ev.type !== TOUCH_MOVE || ev.touches[0].touchType !== "stylus")) {
        ev.preventDefault();
      }
    };
    _this._onScroll = function (ev) {
      var s = _this.s;
      if (s.closeOnScroll) {
        _this._close("scroll");
      } else if (_this._hasContext || s.display === "anchored") {
        _this.position();
      }
    };
    _this._onWndKeyDown = function (ev) {
      var s = _this.s;
      var keyCode = ev.keyCode;
      if (activeModal === _this && keyCode !== UNDEFINED) {
        _this._hook("onKeyDown", {
          keyCode: keyCode
        });
        if (s.closeOnEsc && keyCode === ESC) {
          _this._close("esc");
        }
        if (keyCode === ENTER && matches(ev.target, ALLOW_ENTER) && !ev.shiftKey) {
          return;
        }
        if (_this._buttons) {
          for (var _i = 0, _a = _this._buttons; _i < _a.length; _i++) {
            var button = _a[_i];
            var buttonKeyCodes = isArray(button.keyCode) ? button.keyCode : [button.keyCode];
            for (var _b = 0, buttonKeyCodes_1 = buttonKeyCodes; _b < buttonKeyCodes_1.length; _b++) {
              var key = buttonKeyCodes_1[_b];
              if (!button.disabled && key !== UNDEFINED && (key === keyCode || KEY_CODES[key] === keyCode)) {
                button.handler(ev);
                return;
              }
            }
          }
        }
      }
    };
    _this._onResize = function () {
      var wrapper = _this._wrapper;
      var hasContext = _this._hasContext;
      if (!wrapper) {
        return;
      }
      _this._vpWidth = Math.min(wrapper.clientWidth, hasContext ? Infinity : _this._win.innerWidth);
      _this._vpHeight = Math.min(wrapper.clientHeight, hasContext ? Infinity : _this._win.innerHeight);
      _this._maxWidth = _this._limitator.offsetWidth;
      _this._maxHeight = _this.s.maxHeight !== UNDEFINED || _this._vpWidth < 768 || _this._vpHeight < 650 ? _this._limitator.offsetHeight : 600;
      _this._round = _this.s.touchUi === false || _this._popup.offsetWidth < _this._vpWidth && _this._vpWidth > _this._maxWidth;
      var args = {
        isLarge: _this._round,
        maxPopupHeight: _this._maxHeight,
        maxPopupWidth: _this._maxWidth,
        target: wrapper,
        windowHeight: _this._vpHeight,
        windowWidth: _this._vpWidth
      };
      if (_this._hook("onResize", args) !== false && !args.cancel) {
        _this.position();
      }
    };
    return _this;
  }
  PopupBase.prototype.open = function () {
    if (!this._isOpen) {
      this.setState({
        isOpen: true
      });
    }
  };
  PopupBase.prototype.close = function () {
    this._close();
  };
  PopupBase.prototype.isVisible = function () {
    return !!this._isOpen;
  };
  PopupBase.prototype.position = function () {
    if (!this._isOpen) {
      return;
    }
    var s = this.s;
    var state = this.state;
    var wrapper = this._wrapper;
    var popup = this._popup;
    var hasContext = this._hasContext;
    var anchor = s.anchor;
    var anchorAlign = s.anchorAlign;
    var rtl = s.rtl;
    var scrollTop = getScrollTop(this._scrollCont);
    var scrollLeft = getScrollLeft(this._scrollCont);
    var viewportWidth = this._vpWidth;
    var viewportHeight = this._vpHeight;
    var maxWidth = this._maxWidth;
    var maxHeight = this._maxHeight;
    var popupWidth = Math.min(popup.offsetWidth, maxWidth);
    var popupHeight = Math.min(popup.offsetHeight, maxHeight);
    var showArrow = s.showArrow;
    this._lock = s.scrollLock && this._content.scrollHeight <= this._content.clientHeight;
    if (hasContext) {
      wrapper.style.top = scrollTop + "px";
      wrapper.style.left = scrollLeft + "px";
    }
    var skip = this._hook("onPosition", {
      isLarge: this._round,
      maxPopupHeight: maxHeight,
      maxPopupWidth: maxWidth,
      target: this._wrapper,
      windowHeight: viewportHeight,
      windowWidth: viewportWidth
    }) === false;
    if (s.display === "anchored" && !skip) {
      var ctxLeft = 0;
      var ctxTop = 0;
      var left = constrain(state.modalLeft || 0, 8, viewportWidth - popupWidth - 8);
      var top_1 = state.modalTop || 8;
      var bubblePos = "bottom";
      var arrowPos = {};
      var arrowHeight = showArrow ? 16 : 4;
      var fullWidth = wrapper.offsetWidth;
      var fullHeight = wrapper.offsetHeight;
      var widthOffset = (fullWidth - viewportWidth) / 2;
      var heightOffset = (fullHeight - viewportHeight) / 2;
      if (hasContext) {
        var ctxBox = this._ctx.getBoundingClientRect();
        ctxTop = ctxBox.top;
        ctxLeft = ctxBox.left;
      }
      if (anchor && this._ctx.contains(anchor)) {
        var box = anchor.getBoundingClientRect();
        var anchorTop = box.top - ctxTop;
        var anchorLeft = box.left - ctxLeft;
        var anchorWidth = anchor.offsetWidth;
        var anchorHeight = anchor.offsetHeight;
        if (anchorAlign === "start" && !rtl || anchorAlign === "end" && rtl) {
          left = anchorLeft;
        } else if (anchorAlign === "end" && !rtl || anchorAlign === "start" && rtl) {
          left = anchorLeft + anchorWidth - popupWidth;
        } else {
          left = anchorLeft - (popupWidth - anchorWidth) / 2;
        }
        left = constrain(left, 8, viewportWidth - popupWidth - 8);
        top_1 = anchorTop + anchorHeight + arrowHeight;
        arrowPos = {
          left: constrain(anchorLeft + anchorWidth / 2 - left - widthOffset, 30, popupWidth - 30) + "px"
        };
        if (top_1 + popupHeight + arrowHeight > viewportHeight) {
          if (anchorTop - popupHeight - arrowHeight > 0) {
            bubblePos = "top";
            top_1 = anchorTop - popupHeight - arrowHeight;
          } else if (!s.disableLeftRight) {
            var leftPos = anchorLeft - popupWidth - 8 > 0;
            var rightPos = anchorLeft + anchorWidth + popupWidth + 8 <= viewportWidth;
            if (leftPos || rightPos) {
              top_1 = constrain(anchorTop - (popupHeight - anchorHeight) / 2, 8, viewportHeight - popupHeight - 8);
              if (top_1 + popupHeight + 8 > viewportHeight) {
                top_1 = Math.max(viewportHeight - popupHeight - 8, 0);
              }
              arrowPos = {
                top: constrain(anchorTop + anchorHeight / 2 - top_1 - heightOffset, 30, popupHeight - 30) + "px"
              };
              bubblePos = leftPos ? "left" : "right";
              left = leftPos ? anchorLeft - popupWidth : anchorLeft + anchorWidth;
            }
          }
        }
      }
      if (bubblePos === "top" || bubblePos === "bottom") {
        if (top_1 + popupHeight + arrowHeight > viewportHeight) {
          top_1 = Math.max(viewportHeight - popupHeight - arrowHeight, 0);
          showArrow = false;
        }
      }
      this.setState({
        arrowPos: arrowPos,
        bubblePos: bubblePos,
        height: viewportHeight,
        isReady: true,
        modalLeft: left,
        modalTop: top_1,
        showArrow: showArrow,
        width: viewportWidth
      });
    } else {
      this.setState({
        height: viewportHeight,
        isReady: true,
        showArrow: showArrow,
        width: viewportWidth
      });
    }
  };
  PopupBase.prototype._render = function (s, state) {
    if (s.display === "bubble") {
      s.display = "anchored";
    }
    var animation = s.animation;
    var display = s.display;
    var prevProps = this._prevS;
    var hasPos = display === "anchored";
    var isModal = display !== "inline";
    var isFullScreen = s.fullScreen && isModal;
    var isOpen = isModal ? s.isOpen === UNDEFINED ? state.isOpen : s.isOpen : false;
    if (isOpen && (s.windowWidth !== prevProps.windowWidth || s.display !== prevProps.display || s.showArrow !== prevProps.showArrow || s.anchor !== prevProps.anchor && s.display === "anchored")) {
      this._shouldPosition = true;
    }
    this._limits = {
      maxHeight: addPixel(s.maxHeight),
      maxWidth: addPixel(s.maxWidth)
    };
    this._style = {
      height: isFullScreen ? "100%" : addPixel(s.height),
      left: hasPos && state.modalLeft ? state.modalLeft + "px" : "",
      maxHeight: addPixel(this._maxHeight || s.maxHeight),
      maxWidth: addPixel(this._maxWidth || s.maxWidth),
      top: hasPos && state.modalTop ? state.modalTop + "px" : "",
      width: isFullScreen ? "100%" : addPixel(s.width)
    };
    this._hasContext = s.context !== "body" && s.context !== UNDEFINED;
    this._needsLock = needsFixed && !this._hasContext && display !== "anchored" && s.scrollLock;
    this._isModal = isModal;
    this._flexButtons = display === "center" || !this._touchUi && !isFullScreen && (display === "top" || display === "bottom");
    if (animation !== UNDEFINED && animation !== true) {
      this._animation = isString(animation) ? animation : "";
    } else {
      switch (display) {
        case "bottom":
          this._animation = "slide-up";
          break;
        case "top":
          this._animation = "slide-down";
          break;
        default:
          this._animation = "pop";
      }
    }
    if (s.buttons) {
      if (s.buttons !== prevProps.buttons) {
        this._buttons = processButtons(this, s.buttons);
      }
    } else {
      this._buttons = UNDEFINED;
    }
    if (s.headerText !== prevProps.headerText) {
      this._headerText = s.headerText ? this._safeHtml(s.headerText) : UNDEFINED;
    }
    if (s.context !== prevProps.context) {
      this._contextChanged = true;
    }
    if (isOpen && !this._isOpen) {
      this._onOpen();
    }
    if (!isOpen && this._isOpen) {
      this._onClose();
    }
    this._isOpen = isOpen;
    this._isVisible = isOpen || this._isClosing;
  };
  PopupBase.prototype._updated = function () {
    var _this = this;
    var s = this.s;
    var wrapper = this._wrapper;
    if (doc && (this._contextChanged || !this._ctx)) {
      var ctx = isString(s.context) ? doc.querySelector(s.context) : s.context;
      if (!ctx) {
        ctx = doc.body;
      }
      this._ctx = ctx;
      this._contextChanged = false;
      if (this._justOpened) {
        ngSetTimeout(this, function () {
          _this.forceUpdate();
        });
        return;
      }
    }
    if (!wrapper) {
      return;
    }
    if (this._justOpened) {
      var ctx = this._ctx;
      var hasContext = this._hasContext;
      var doc_1 = this._doc = getDocument(wrapper);
      var win = this._win = getWindow(wrapper);
      var activeElm_1 = doc_1.activeElement;
      if (!this._hasWidth && s.responsive) {
        var viewportWidth_1 = Math.min(wrapper.clientWidth, hasContext ? Infinity : win.innerWidth);
        var viewportHeight_1 = Math.min(wrapper.clientHeight, hasContext ? Infinity : win.innerHeight);
        this._hasWidth = true;
        if (viewportWidth_1 !== this.state.width || viewportHeight_1 !== this.state.height) {
          ngSetTimeout(this, function () {
            _this.setState({
              height: viewportHeight_1,
              width: viewportWidth_1
            });
          });
          return;
        }
      }
      this._scrollCont = hasContext ? ctx : win;
      this._observer = resizeObserver(wrapper, this._onResize, this._zone);
      this._prevFocus = s.focusElm || activeElm_1;
      ctx.__mbscModals = (ctx.__mbscModals || 0) + 1;
      if (this._needsLock) {
        if (!ctx.__mbscIOSLock) {
          var scrollTop = getScrollTop(this._scrollCont);
          var scrollLeft = getScrollLeft(this._scrollCont);
          ctx.style.left = -scrollLeft + "px";
          ctx.style.top = -scrollTop + "px";
          ctx.__mbscScrollLeft = scrollLeft;
          ctx.__mbscScrollTop = scrollTop;
          ctx.classList.add("mbsc-popup-open-ios");
          ctx.parentElement.classList.add("mbsc-popup-open-ios");
        }
        ctx.__mbscIOSLock = (ctx.__mbscIOSLock || 0) + 1;
      }
      if (hasContext) {
        ctx.classList.add("mbsc-popup-ctx");
      }
      if (s.focusTrap) {
        listen(win, FOCUS_IN, this._onFocus);
      }
      if (s.focusElm && !s.focusOnOpen) {
        listen(s.focusElm, KEY_DOWN, this._onKeyDown);
      }
      listen(this._scrollCont, TOUCH_MOVE, this._onContentScroll, {
        passive: false
      });
      listen(this._scrollCont, WHEEL, this._onContentScroll, {
        passive: false
      });
      listen(this._scrollCont, MOUSE_WHEEL, this._onContentScroll, {
        passive: false
      });
      setTimeout(function () {
        if (s.focusOnOpen && activeElm_1) {
          activeElm_1.blur();
        }
        if (!hasAnimation || !_this._animation) {
          _this._onOpened();
        }
        listen(doc_1, MOUSE_DOWN, _this._onMouseDown);
        listen(doc_1, MOUSE_UP, _this._onMouseUp);
        listen(doc_1, CLICK, _this._onDocClick);
      });
      this._hook("onOpen", {
        target: this._wrapper
      });
    }
    if (this._shouldPosition) {
      ngSetTimeout(this, function () {
        _this._onResize();
      });
    }
    this._justOpened = false;
    this._justClosed = false;
    this._shouldPosition = false;
  };
  PopupBase.prototype._destroy = function () {
    if (this._isOpen) {
      this._onClosed();
      this._unlisten();
      if (activeModal === this) {
        activeModal = getPrevActive(this);
      }
    }
  };
  PopupBase.prototype._onOpen = function () {
    var _this = this;
    if (hasAnimation && this._animation) {
      this._isOpening = true;
      this._isClosing = false;
    }
    this._justOpened = true;
    this._preventClose = false;
    if (this.s.setActive && activeModal !== this) {
      setTimeout(function () {
        _this._prevModal = activeModal;
        activeModal = _this;
      });
    }
  };
  PopupBase.prototype._onClose = function () {
    var _this = this;
    if (hasAnimation && this._animation) {
      this._isClosing = true;
      this._isOpening = false;
    } else {
      setTimeout(function () {
        _this._onClosed();
        _this.setState({
          isReady: false
        });
      });
    }
    this._hasWidth = false;
    this._unlisten();
  };
  PopupBase.prototype._onOpened = function () {
    var s = this.s;
    if (s.focusOnOpen) {
      var activeElm = s.activeElm;
      var active = activeElm ? isString(activeElm) ? this._popup.querySelector(activeElm) || this._active : activeElm : this._active;
      if (active && active.focus) {
        active.focus();
      }
    }
    listen(this._win, KEY_DOWN, this._onWndKeyDown);
    listen(this._scrollCont, SCROLL, this._onScroll);
  };
  PopupBase.prototype._onClosed = function () {
    var _this = this;
    var ctx = this._ctx;
    var prevFocus = this._prevFocus;
    var shouldFocus = this.s.focusOnClose && prevFocus && prevFocus.focus && prevFocus !== this._doc.activeElement;
    if (ctx.__mbscModals) {
      ctx.__mbscModals--;
    }
    this._justClosed = true;
    if (this._needsLock) {
      if (ctx.__mbscIOSLock) {
        ctx.__mbscIOSLock--;
      }
      if (!ctx.__mbscIOSLock) {
        ctx.classList.remove("mbsc-popup-open-ios");
        ctx.parentElement.classList.remove("mbsc-popup-open-ios");
        ctx.style.left = "";
        ctx.style.top = "";
        setScrollLeft(this._scrollCont, ctx.__mbscScrollLeft || 0);
        setScrollTop(this._scrollCont, ctx.__mbscScrollTop || 0);
      }
    }
    if (this._hasContext && !ctx.__mbscModals) {
      ctx.classList.remove("mbsc-popup-ctx");
    }
    this._hook("onClosed", {
      focus: shouldFocus
    });
    if (shouldFocus) {
      prevFocus.focus();
    }
    setTimeout(function () {
      if (activeModal === _this) {
        activeModal = getPrevActive(_this);
      }
    });
  };
  PopupBase.prototype._unlisten = function () {
    unlisten(this._win, KEY_DOWN, this._onWndKeyDown);
    unlisten(this._scrollCont, SCROLL, this._onScroll);
    unlisten(this._scrollCont, TOUCH_MOVE, this._onContentScroll, {
      passive: false
    });
    unlisten(this._scrollCont, WHEEL, this._onContentScroll, {
      passive: false
    });
    unlisten(this._scrollCont, MOUSE_WHEEL, this._onContentScroll, {
      passive: false
    });
    unlisten(this._doc, MOUSE_DOWN, this._onMouseDown);
    unlisten(this._doc, MOUSE_UP, this._onMouseUp);
    unlisten(this._doc, CLICK, this._onDocClick);
    if (this.s.focusTrap) {
      unlisten(this._win, FOCUS_IN, this._onFocus);
    }
    if (this.s.focusElm) {
      unlisten(this.s.focusElm, KEY_DOWN, this._onKeyDown);
    }
    if (this._observer) {
      this._observer.detach();
      this._observer = null;
    }
  };
  PopupBase.prototype._close = function (source) {
    if (this._isOpen) {
      if (this.s.isOpen === UNDEFINED) {
        this.setState({
          isOpen: false
        });
      }
      this._hook("onClose", {
        source: source
      });
    }
  };
  PopupBase.defaults = {
    buttonVariant: "flat",
    cancelText: "Cancel",
    closeOnEsc: true,
    closeOnOverlayClick: true,
    closeText: "Close",
    contentPadding: true,
    display: "center",
    focusOnClose: true,
    focusOnOpen: true,
    focusTrap: true,
    maxWidth: MAX_WIDTH,
    okText: "Ok",
    scrollLock: true,
    setActive: true,
    setText: "Set",
    showArrow: true,
    showOverlay: true
  };
  PopupBase.ɵfac = /* @__PURE__ */(() => {
    let ɵPopupBase_BaseFactory;
    return function PopupBase_Factory(t) {
      return (ɵPopupBase_BaseFactory || (ɵPopupBase_BaseFactory = i0.ɵɵgetInheritedFactory(PopupBase)))(t || PopupBase);
    };
  })();
  PopupBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: PopupBase,
    selectors: [["", "mbsc-popup-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return PopupBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function getIonInput(el, cb, nr) {
  if (nr === void 0) {
    nr = 0;
  }
  if (nr > 10) {
    delete el.__mbscTimer;
    cb(el);
  } else {
    clearTimeout(el.__mbscTimer);
    el.__mbscTimer = setTimeout(function () {
      if (el.getInputElement) {
        el.getInputElement().then(function (inp) {
          if (inp) {
            delete el.__mbscTimer;
            cb(inp);
          } else {
            getIonInput(el, cb, nr + 1);
          }
        });
      } else {
        getIonInput(el, cb, nr + 1);
      }
    }, 10);
  }
}
function isIonInput(el) {
  return el.getInputElement || el.tagName && el.tagName.toLowerCase() === "ion-input";
}
function getNativeElement(input, callback) {
  if (input) {
    if (isIonInput(input)) {
      getIonInput(input, callback);
    } else if (input.vInput) {
      callback(input.vInput.nativeElement);
    } else if (input._el) {
      callback(input._el);
    } else if (input.instance && input.instance._el) {
      callback(input.instance._el);
    } else if (input.nodeType === 1) {
      callback(input);
    } else if (isString(input)) {
      var inputElement = doc.querySelector(input);
      if (inputElement) {
        callback(inputElement);
      }
    }
  }
}
function initPickerElement(el, inst, handleChange, handleClick) {
  if (!el || el.nodeType !== 1) {
    return noop;
  }
  var setReadOnly = function () {
    if ((inst.s.showOnClick || inst.s.showOnFocus) && isInput && !inst._allowTyping) {
      input.readOnly = true;
    }
  };
  var onClick = function (ev) {
    var s = inst.s;
    setReadOnly();
    if (handleClick) {
      handleClick(ev);
    }
    if (s.showOnClick && !s.disabled && (!inst._popup._isVisible || el !== inst._popup._prevFocus)) {
      setTimeout(function () {
        inst._focusElm = el;
        inst._anchor = s.anchor || el;
        inst.open();
      });
    }
  };
  var onMouseDown = function (ev) {
    if (inst.s.showOnClick) {
      if (inst.s.showOnFocus) {
        inst._preventShow = true;
      }
      if (!inst._allowTyping) {
        ev.preventDefault();
      }
    }
  };
  var onKeyDown = function (ev) {
    if (inst.s.showOnClick) {
      if (inst._isOpen) {
        if (ev.keyCode === ENTER && inst._allowTyping) {
          ev.stopPropagation();
        }
      } else {
        if (ev.keyCode === SPACE) {
          ev.preventDefault();
        }
        if (ev.keyCode === ENTER || ev.keyCode === SPACE) {
          onClick(ev);
        }
      }
    }
  };
  var onFocus = function (ev) {
    setReadOnly();
    if (inst.s.showOnFocus) {
      if (inst._preventShow) {
        inst._preventShow = false;
      } else {
        onClick(ev);
      }
    }
  };
  var onBlur = function () {
    if (isInput) {
      input.readOnly = readOnly;
    }
  };
  var onChange = function (ev) {
    if (handleChange) {
      handleChange(ev);
    }
  };
  var onWinFocus = function () {
    if (win.document.activeElement === el) {
      setReadOnly();
      inst._preventShow = true;
    }
  };
  var win = getWindow(el);
  var isInput = matches(el, "input,select");
  var input = el;
  var readOnly;
  if (isInput) {
    input.autocomplete = "off";
    readOnly = input.readOnly;
  }
  listen(el, CLICK, onClick);
  listen(el, MOUSE_DOWN, onMouseDown);
  listen(el, KEY_DOWN, onKeyDown);
  listen(el, FOCUS, onFocus);
  listen(el, BLUR, onBlur);
  listen(el, CHANGE, onChange);
  listen(win, FOCUS, onWinFocus);
  return function () {
    if (isInput) {
      input.readOnly = readOnly;
    }
    unlisten(el, CLICK, onClick);
    unlisten(el, MOUSE_DOWN, onMouseDown);
    unlisten(el, KEY_DOWN, onKeyDown);
    unlisten(el, FOCUS, onFocus);
    unlisten(el, BLUR, onBlur);
    unlisten(el, CHANGE, onChange);
    unlisten(win, FOCUS, onWinFocus);
  };
}
var PickerBase = /*#__PURE__*/function (_super) {
  __extends(PickerBase, _super);
  function PickerBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._nullSupport = true;
    _this._onInputChange = function (ev, val) {
      var value = ev.detail || (val !== UNDEFINED ? val : ev.target.value);
      if (value !== _this._tempValueText && !_this._preventChange) {
        _this._readValue(value, true);
        _this._valueTextChange = value !== _this._tempValueText;
        var newValue = isEmpty(value) ? null : _this._get(_this._tempValueRep);
        _this.value = newValue;
        _this._valueChange(newValue);
      }
      _this._preventChange = false;
    };
    _this._onResize = function (args) {
      _this._hook("onResize", args);
    };
    _this._onWrapperResize = function () {
      if (_this._wrapper) {
        _this._onResize({
          windowWidth: _this._wrapper.offsetWidth
        });
      }
    };
    _this._onPopupClose = function (args) {
      if (/cancel|esc|overlay|scroll/.test(args.source)) {
        _this._hook("onCancel", {
          value: _this.value,
          valueText: _this._valueText
        });
      }
      _this.close();
    };
    _this._onPopupClosed = function (args) {
      if (args.focus) {
        _this._preventShow = true;
      }
      _this._hook("onClosed", args);
      _this._onClosed();
    };
    _this._onPopupKey = function (args) {
      if (args.keyCode === 13) {
        _this._onEnterKey(args);
      }
    };
    _this._onPopupOpen = function (args) {
      args.value = _this.value;
      args.valueText = _this._valueText;
      _this._hook("onOpen", args);
    };
    _this._onButtonClick = function (_a) {
      var domEvent = _a.domEvent,
        button = _a.button;
      if (button.name === "set") {
        _this.set();
      }
      if (_this._popup) {
        _this._popup._onButtonClick({
          domEvent: domEvent,
          button: button
        });
      }
    };
    _this._setInput = function (inp) {
      _this._el = inp && inp.nativeElement ? inp.nativeElement : inp;
    };
    _this._setPopup = function (popup) {
      _this._popup = popup;
    };
    _this._setWrapper = function (wrapper) {
      _this._wrapper = wrapper;
    };
    return _this;
  }
  PickerBase.prototype.open = function () {
    if (this._inst) {
      this._inst.open();
      return;
    }
    if (this.s.isOpen === UNDEFINED) {
      this.setState({
        isOpen: true
      });
    }
  };
  PickerBase.prototype.close = function () {
    if (this.s.display === "inline") {
      return;
    }
    if (this._inst) {
      this._inst.close();
      return;
    }
    var args = {
      value: this.value,
      valueText: this._valueText
    };
    if (this.s.isOpen === UNDEFINED) {
      this.setState({
        isOpen: false
      });
    }
    this._hook("onClose", args);
  };
  PickerBase.prototype.set = function () {
    this._valueRep = this._copy(this._tempValueRep);
    this._valueText = this._tempValueText;
    this._value = this.value = this._get(this._valueRep);
    this._valueChange(this.value);
  };
  PickerBase.prototype.position = function () {
    if (this._inst) {
      this._inst.position();
      return;
    }
    if (this._popup) {
      this._popup.position();
    }
  };
  PickerBase.prototype.isVisible = function () {
    if (this._inst) {
      return this._inst.isVisible();
    }
    return !!this._popup && this._popup.isVisible();
  };
  PickerBase.prototype.getVal = function () {
    return this._nullSupport && isEmpty(this._value) ? this.s.selectMultiple ? [] : null : this._get(this._valueRep);
  };
  PickerBase.prototype.setVal = function (value) {
    this.value = value;
    this.setState({
      value: value
    });
  };
  PickerBase.prototype.getTempVal = function () {
    return this._get(this._tempValueRep);
  };
  PickerBase.prototype.setTempVal = function (value) {
    this._tempValueSet = true;
    this._tempValueRep = this._parse(value);
    this._setOrUpdate(true);
  };
  PickerBase.prototype._shouldValidate = function (s, prevS) {
    return false;
  };
  PickerBase.prototype._valueEquals = function (v1, v2) {
    return v1 === v2;
  };
  PickerBase.prototype._change = function (value) {};
  PickerBase.prototype._render = function (s, state) {
    var _this = this;
    var props = this.props || {};
    var resp = this._respProps || {};
    var prevS = this._prevS;
    if (!this._touchUi) {
      s.display = resp.display || props.display || options.display || "anchored";
      s.showArrow = resp.showArrow || props.showArrow || false;
    }
    if (s.display === "bubble") {
      s.display = "anchored";
    }
    this._scrollLock = s.scrollLock;
    var isOpen = s.isOpen !== UNDEFINED ? s.isOpen : state.isOpen;
    var modelValue = s.modelValue !== UNDEFINED ? s.modelValue : s.value;
    var value = modelValue !== UNDEFINED ? modelValue : state.value === UNDEFINED ? s.defaultValue : state.value;
    this._showInput = s.showInput !== UNDEFINED ? s.showInput : s.display !== "inline" && s.element === UNDEFINED;
    if (!this._buttons || s.buttons !== prevS.buttons || s.display !== prevS.display || s.setText !== prevS.setText || s.cancelText !== prevS.cancelText || s.closeText !== prevS.closeText || s.touchUi !== prevS.touchUi) {
      this._buttons = processButtons(this, s.buttons || (s.display !== "inline" && (s.display !== "anchored" || this._touchUi) ? ["cancel", "set"] : []));
      this._live = true;
      if (this._buttons && this._buttons.length) {
        for (var _i = 0, _a = this._buttons; _i < _a.length; _i++) {
          var b = _a[_i];
          if (b.name === "ok" || b.name === "set") {
            this._live = false;
          }
        }
      }
    }
    var valueChange = !this._valueEquals(value, this._value);
    if (valueChange || this._tempValueRep === UNDEFINED || this._shouldValidate(s, prevS) || s.defaultSelection !== prevS.defaultSelection || s.invalid !== prevS.invalid || s.valid !== prevS.valid) {
      this._readValue(value);
      var newValue_1 = this._get(this._tempValueRep);
      var validationChange_1 = !this._valueEquals(value, newValue_1) && (!this._nullSupport || !isEmpty(value));
      this._setHeader();
      clearTimeout(this._handler);
      this._handler = setTimeout(function () {
        _this.value = value;
        if (validationChange_1) {
          _this._valueChange(newValue_1);
        }
        if (!_this._valueEquals(_this._tempValue, newValue_1) && _this._inst === UNDEFINED) {
          _this._hook("onTempChange", {
            value: newValue_1
          });
        }
      });
    }
    if (s.headerText !== prevS.headerText) {
      this._setHeader();
    }
    if (isOpen && !this._isOpen) {
      if (!this._tempValueSet || this._live) {
        var tempValue = this._get(this._tempValueRep);
        var parsedValue_1 = this._get(this._valueRep);
        this._tempValueRep = this._copy(this._valueRep);
        this._tempValueText = this._format(this._tempValueRep);
        this._tempValue = tempValue;
        this._setHeader();
        if (!this._valueEquals(tempValue, parsedValue_1)) {
          setTimeout(function () {
            _this._hook("onTempChange", {
              value: parsedValue_1
            });
          });
        }
      }
      this._onOpen();
    }
    this._allowTyping = s.inputTyping && !touchUi && !this._touchUi;
    this._anchorAlign = s.anchorAlign || (this._touchUi ? "center" : "start");
    this._cssClass = "mbsc-picker " + (s.cssClass || "");
    this._isOpen = isOpen;
    this._maxWidth = s.maxWidth;
    this._valueTextChange = this._valueTextChange || this._oldValueText !== this._valueText;
    this._oldValueText = this._valueText;
    this._value = value;
    this._shouldInitInput = this._shouldInitInput || prevS.display === UNDEFINED || s.display === "inline" && prevS.display !== "inline" || s.display !== "inline" && prevS.display === "inline" || s.element !== prevS.element;
  };
  PickerBase.prototype._updated = function () {
    var _this = this;
    var s = this.s;
    var input = this._input;
    if (this._shouldInitInput && !this._inst) {
      this._unlisten();
      if (this._wrapper && s.display === "inline") {
        this._observer = resizeObserver(this._wrapper, this._onWrapperResize, this._zone);
      }
      getNativeElement(s.element || this._el, function (el) {
        _this._el = el;
        if (s.display !== "inline") {
          _this._resetEl = initPickerElement(el, _this, _this._onInputChange);
        }
        if (matches(el, "input,select")) {
          _this._input = el;
          _this._write(el);
        }
      });
    }
    if (this._valueTextChange && input) {
      this._write(input);
    }
    setTimeout(function () {
      if (s.responsive && s.display !== "inline" && win && _this.state.width === UNDEFINED) {
        _this._onResize({
          windowWidth: win.innerWidth
        });
      }
    });
    this._shouldInitInput = false;
    this._valueTextChange = false;
    this._anchor = s.anchor || this._focusElm || s.element || this._el;
  };
  PickerBase.prototype._writeValue = function (elm, text, value) {
    var oldValue = elm.value;
    elm.value = text;
    return oldValue !== text;
  };
  PickerBase.prototype._destroy = function () {
    this._unlisten();
    this._shouldInitInput = true;
  };
  PickerBase.prototype._setHeader = function () {
    var headerText = this.s.headerText;
    this._headerText = headerText ? headerText.replace(/\{value\}/i, this._tempValueText || "&nbsp;") : UNDEFINED;
  };
  PickerBase.prototype._setOrUpdate = function (preventChange) {
    var value = this._get(this._tempValueRep);
    this._tempValue = value;
    this._tempValueText = this._format(this._tempValueRep);
    this._setHeader();
    if (!preventChange) {
      this._hook("onTempChange", {
        value: value
      });
    }
    if (this._live) {
      this.set();
    } else {
      this.forceUpdate();
    }
  };
  PickerBase.prototype._copy = function (value) {
    return value;
  };
  PickerBase.prototype._format = function (value) {
    return value;
  };
  PickerBase.prototype._get = function (value) {
    return value;
  };
  PickerBase.prototype._parse = function (valueText, fromInput) {
    return valueText;
  };
  PickerBase.prototype._validate = function () {};
  PickerBase.prototype._onClosed = function () {};
  PickerBase.prototype._onOpen = function () {};
  PickerBase.prototype._onParse = function () {};
  PickerBase.prototype._onEnterKey = function (args) {
    this.set();
    this.close();
  };
  PickerBase.prototype._valueChange = function (value) {
    if (this.s.value === UNDEFINED) {
      this.setState({
        value: value
      });
    }
    this._change(value);
    this._hook("onChange", {
      value: value,
      valueText: this._tempValueText
    });
  };
  PickerBase.prototype._readValue = function (value, fromInput) {
    this._tempValueRep = this._parse(value, fromInput);
    this._onParse();
    this._validate();
    this._tempValueText = this._format(this._tempValueRep);
    this._valueRep = this._copy(this._tempValueRep);
    this._valueText = !isEmpty(value) ? this._tempValueText : "";
  };
  PickerBase.prototype._unlisten = function () {
    if (this._resetEl) {
      this._resetEl();
      this._resetEl = UNDEFINED;
    }
    if (this._observer) {
      this._observer.detach();
      this._observer = UNDEFINED;
    }
  };
  PickerBase.prototype._write = function (input) {
    var _this = this;
    var value = this._value;
    var changed = this._writeValue(input, this._valueText || "", value);
    if (changed) {
      setTimeout(function () {
        _this._preventChange = true;
        trigger(input, INPUT);
        trigger(input, CHANGE);
      });
    }
    var mbscInput = input.__mbscFormInst;
    if (mbscInput) {
      mbscInput.setOptions({
        pickerMap: this.s.valueMap,
        pickerValue: value
      });
    }
  };
  PickerBase.defaults = {
    cancelText: "Cancel",
    closeText: "Close",
    focusOnClose: os !== "android",
    okText: "Ok",
    setText: "Set",
    showOnFocus: touchUi
  };
  PickerBase.ɵfac = /* @__PURE__ */(() => {
    let ɵPickerBase_BaseFactory;
    return function PickerBase_Factory(t) {
      return (ɵPickerBase_BaseFactory || (ɵPickerBase_BaseFactory = i0.ɵɵgetInheritedFactory(PickerBase)))(t || PickerBase);
    };
  })();
  PickerBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: PickerBase,
    selectors: [["", "mbsc-p-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return PickerBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function isInvalid(s, d, invalids, valids, min, max) {
  var key = getDateStr(d);
  if (min && +d < min || max && +d > max) {
    return true;
  }
  if (valids && valids[key]) {
    return false;
  }
  var invalidsForDay = invalids && invalids[key];
  if (invalidsForDay) {
    for (var _i = 0, invalidsForDay_1 = invalidsForDay; _i < invalidsForDay_1.length; _i++) {
      var invalid = invalidsForDay_1[_i];
      var start = invalid.start,
        end = invalid.end,
        allDay = invalid.allDay;
      if (start && end && !allDay) {
        var endDate = getEndDate(s, allDay, start, end);
        var dayStart = getDayStart(s, d);
        var dayEnd = getDayEnd(s, endDate);
        if (!isSameDay(start, end) && (+start === +dayStart || +endDate === +dayEnd || !isSameDay(d, start) && !isSameDay(d, end) && d > start && d < end)) {
          return invalid;
        }
      } else {
        return invalid;
      }
    }
  }
  return false;
}
function getClosestValidDate(d, s, min, max, invalids, valids, dir) {
  var next;
  var prev;
  var nextInvalid = true;
  var prevInvalid = true;
  var up = 0;
  var down = 0;
  if (+d < min) {
    d = createDate(s, min);
  }
  if (+d > max) {
    d = createDate(s, max);
  }
  var year = s.getYear(d);
  var month = s.getMonth(d);
  var start = s.getDate(year, month - 1, 1);
  var end = s.getDate(year, month + 2, 1);
  var from = +start > min ? +start : min;
  var until = +end < max ? +end : max;
  if (!invalids) {
    valids = getEventMap(s.valid, start, end, s, true);
    invalids = getEventMap(s.invalid, start, end, s, true);
  }
  if (!isInvalid(s, d, invalids, valids, min, max)) {
    return d;
  }
  next = d;
  prev = d;
  while (nextInvalid && +next < until && up < 100) {
    next = addDays(next, 1);
    nextInvalid = isInvalid(s, next, invalids, valids, min, max);
    up++;
  }
  while (prevInvalid && +prev > from && down < 100) {
    prev = addDays(prev, -1);
    prevInvalid = isInvalid(s, prev, invalids, valids, min, max);
    down++;
  }
  if (nextInvalid && prevInvalid) {
    return d;
  }
  if (dir === 1 && !nextInvalid) {
    return next;
  }
  if (dir === -1 && !prevInvalid) {
    return prev;
  }
  if (isSameMonth(d, next, s) && !nextInvalid) {
    return next;
  }
  if (isSameMonth(d, prev, s) && !prevInvalid) {
    return prev;
  }
  return prevInvalid || down >= up && !nextInvalid ? next : prev;
}
var modules = {};
var RANGE_SEPARATOR = " - ";
var CALENDAR_CTRL = ["calendar"];
var INVALID_ALL = [{
  recurring: {
    repeat: "daily"
  }
}];
function notActive(active) {
  return active === "start" ? "end" : "start";
}
function getPresetRange(timestamp, s) {
  var date = new Date(timestamp);
  var firstSelectDay = s.firstSelectDay !== UNDEFINED ? s.firstSelectDay : s.firstDay;
  var start = getFirstDayOfWeek(date, s, firstSelectDay);
  var end = new Date(start.getFullYear(), start.getMonth(), start.getDate() + s.selectSize - 1);
  return {
    start: start,
    end: end
  };
}
var DatepickerBase = /*#__PURE__*/function (_super) {
  __extends(DatepickerBase, _super);
  function DatepickerBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._iso = {};
    _this._onActiveChange = function (ev) {
      _this._active = ev.date;
      _this.forceUpdate();
    };
    _this._onResize = function (ev) {
      var viewportWidth = ev.windowWidth;
      ev.cancel = _this.state.width !== viewportWidth;
      _this.setState({
        isLarge: ev.isLarge,
        maxPopupWidth: ev.maxPopupWidth,
        width: viewportWidth,
        widthType: viewportWidth > 600 ? "md" : "sm"
      });
    };
    _this._onDayHoverIn = function (_a) {
      var date = _a.date,
        hidden = _a.hidden;
      _this.setState({
        hoverDate: hidden ? UNDEFINED : +date
      });
    };
    _this._onDayHoverOut = function (_a) {
      var date = _a.date;
      if (_this.state.hoverDate === +date) {
        _this.setState({
          hoverDate: UNDEFINED
        });
      }
    };
    _this._onCellClick = function (args) {
      _this._lastSelected = addTimezone(_this.s, args.date);
      args.active = _this._activeSelect;
      _this._hook("onCellClick", args);
    };
    _this._onCalendarChange = function (ev) {
      _this._tempValueSet = false;
      var s = _this.s;
      var tempValueRep = _this._copy(_this._tempValueRep);
      var date = map(ev.value, function (item) {
        return addTimezone(s, item);
      });
      var isPreset = s.select === "preset-range";
      var isRange = s.select === "range";
      var newSelection = isRange && _this._newSelection;
      var slide = (isRange || isPreset) && s.exclusiveEndDates && !_this._hasTime;
      if (slide && tempValueRep.end) {
        tempValueRep.end = +getDayStart(s, createDate(s, tempValueRep.end - 1));
      }
      if (_this._hasTime && _this._selectedTime && !isRange) {
        if (_this.s.selectMultiple) {
          var lastSelection = date[date.length - 1];
          if (lastSelection) {
            lastSelection.setHours(_this._selectedTime.getHours(), _this._selectedTime.getMinutes());
          }
        } else {
          date.setHours(_this._selectedTime.getHours(), _this._selectedTime.getMinutes());
        }
      }
      if (isRange || isPreset) {
        var oldValue = _this._getDate(tempValueRep);
        var oldRangeDate = oldValue.filter(function (v) {
          return v !== null;
        });
        var oldRange = oldRangeDate.map(function (dateValue) {
          return +dateValue;
        });
        var oldRangeCut_1 = oldRangeDate.map(function (v) {
          return +getDateOnly(v);
        });
        var newValue = date.filter(function (v) {
          return oldRangeCut_1.indexOf(+v) < 0;
        })[0];
        if (isPreset) {
          if (newValue) {
            var _a = getPresetRange(+newValue, s),
              start = _a.start,
              end = _a.end;
            tempValueRep.start = +start;
            tempValueRep.end = +end;
          }
        } else {
          var cycle = !_this._hasTime;
          var cycleAndLabels = _this._renderControls;
          var activeSelect = _this._activeSelect;
          var notActiveSelect = notActive(activeSelect);
          if (newValue) {
            if (_this._hasTime && _this._selectedTime) {
              newValue.setHours(_this._selectedTime.getHours(), _this._selectedTime.getMinutes(), _this._selectedTime.getSeconds(), _this._selectedTime.getMilliseconds());
            }
            switch (oldRange.length) {
              case 0:
                {
                  tempValueRep = {};
                  tempValueRep[activeSelect] = +newValue;
                  break;
                }
              case 1:
                {
                  if (cycleAndLabels) {
                    tempValueRep[activeSelect] = +newValue;
                    break;
                  }
                  if (oldRange[0] > +newValue || _this._activeSelect === "start") {
                    if (_this._hasTime) {
                      tempValueRep[activeSelect] = +newValue;
                    } else {
                      tempValueRep = {
                        start: +newValue
                      };
                      cycle = false;
                    }
                  } else {
                    tempValueRep.end = +newValue;
                  }
                  break;
                }
              case 2:
                {
                  if (cycleAndLabels) {
                    tempValueRep[activeSelect] = +newValue;
                    break;
                  }
                  if (oldRange[0] > +newValue || _this._activeSelect === "start") {
                    if (_this._hasTime) {
                      tempValueRep[activeSelect] = +newValue;
                    } else {
                      tempValueRep = {
                        start: +newValue
                      };
                      if (_this._activeSelect === "end") {
                        cycle = false;
                      }
                    }
                  } else if (_this._activeSelect === "end") {
                    tempValueRep.end = +newValue;
                  }
                  break;
                }
            }
            if (cycleAndLabels && tempValueRep.start && tempValueRep.end && tempValueRep.start > tempValueRep.end) {
              tempValueRep = {
                start: +newValue
              };
              _this._setActiveSelect("end");
            }
          } else {
            var newDate = void 0;
            if (oldRange.length === 1) {
              newDate = createDate(s, oldRange[0]);
            } else {
              newDate = _this._lastSelected;
            }
            if (_this._hasTime && _this._selectedTime) {
              newDate.setHours(_this._selectedTime.getHours(), _this._selectedTime.getMinutes(), _this._selectedTime.getSeconds(), _this._selectedTime.getMilliseconds());
            } else if (!s.exclusiveEndDates && !_this._hasTime && _this._activeSelect === "end" && oldValue[0] && isSameDay(newDate, oldValue[0])) {
              newDate.setHours(23, 59, 59, 999);
            }
            if (cycleAndLabels || _this._hasTime) {
              tempValueRep[activeSelect] = +newDate;
            } else if (_this._activeSelect === "start") {
              tempValueRep = {
                start: +newDate
              };
            } else {
              tempValueRep.end = +newDate;
            }
          }
          if (tempValueRep.start && tempValueRep.end) {
            if (tempValueRep.start > tempValueRep.end) {
              var st = createDate(s, tempValueRep.start);
              var ed = createDate(s, tempValueRep.end);
              if (isSameDay(st, ed)) {
                ed.setHours(st.getHours(), st.getMinutes(), st.getSeconds(), st.getMilliseconds());
                tempValueRep.end = +ed;
              } else {
                tempValueRep.end = UNDEFINED;
              }
            }
            if (s.minRange && tempValueRep.end) {
              var newEnd = _this._hasTime ? tempValueRep.start + s.minRange : +addDays(createDate(s, tempValueRep.start), s.minRange - 1);
              if (tempValueRep.end < newEnd && (!_this._hasTime || activeSelect === "start")) {
                tempValueRep.end = UNDEFINED;
              }
            }
            if (s.maxRange && tempValueRep.end) {
              var newEnd = _this._hasTime ? tempValueRep.start + s.maxRange : +addDays(createDate(s, tempValueRep.start), s.maxRange) - 1;
              if (tempValueRep.end > newEnd && (!_this._hasTime || activeSelect === "start")) {
                tempValueRep.end = UNDEFINED;
              }
            }
            if (tempValueRep.end && activeSelect === "start" && !s.inRangeInvalid) {
              var nextInvalid = s.valid ? addDays(getLatestOccurrence(s.valid, createDate(s, tempValueRep.start), s), 1) : getNextOccurrence(s.invalid || [], createDate(s, tempValueRep.start), s);
              if (nextInvalid !== null && +nextInvalid < tempValueRep.end) {
                tempValueRep.end = UNDEFINED;
              }
            }
          }
          if (cycle && (_this._newSelection || !_this._renderControls || _this._newSelection === UNDEFINED && _this.s.display === "inline")) {
            _this._setActiveSelect(notActiveSelect);
            _this._newSelection = false;
          }
        }
      } else {
        tempValueRep = {
          date: {}
        };
        if (_this.s.selectMultiple) {
          for (var _i = 0, date_1 = date; _i < date_1.length; _i++) {
            var dateVal = date_1[_i];
            tempValueRep.date[+dateVal] = dateVal;
          }
        } else {
          if (_this._hasTime) {
            var time = _this._selectedTime || new Date();
            date.setHours(time.getHours(), time.getMinutes(), time.getSeconds(), time.getMilliseconds());
          }
          tempValueRep.date[+date] = date;
        }
      }
      _this._tempValueRep = tempValueRep;
      if (slide && tempValueRep.end) {
        tempValueRep.end = +getDayStart(s, addDays(createDate(s, tempValueRep.end), 1));
      }
      _this._setOrUpdate();
      if (_this._live && (!_this.s.selectMultiple || isRange) && !_this._hasTime && (!isRange || tempValueRep.start && tempValueRep.end && !newSelection)) {
        _this.close();
      }
    };
    _this._onDatetimeChange = function (ev) {
      var s = _this.s;
      var isRange = s.select === "range";
      var value = addTimezone(s, ev.value);
      var date = _this._hasTime ? value : getDateOnly(value);
      var d = +date;
      _this._tempValueSet = false;
      var tempValueRep = _this._copy(_this._tempValueRep);
      var slide = isRange && s.exclusiveEndDates && !_this._hasTime;
      if (slide && tempValueRep.end) {
        tempValueRep.end = +getDayStart(s, createDate(s, tempValueRep.end - 1));
      }
      if (isRange) {
        if (_this._activeSelect === "start") {
          if (_this._hasTime && _this._selectedTime) {
            date.setHours(_this._selectedTime.getHours(), _this._selectedTime.getMinutes(), _this._selectedTime.getSeconds(), _this._selectedTime.getMilliseconds());
          }
          tempValueRep.start = d;
          if (tempValueRep.end) {
            var minRange = s.minRange && !_this._hasTime ? (s.minRange - 1) * 24 * 60 * 60 * 1e3 - 1 : s.minRange || 0;
            var range = tempValueRep.end - tempValueRep.start;
            if (range < minRange) {
              tempValueRep.end = UNDEFINED;
            }
          }
        } else {
          if (_this._hasTime) {
            if (_this._selectedTime) {
              date.setHours(_this._selectedTime.getHours(), _this._selectedTime.getMinutes(), _this._selectedTime.getSeconds(), _this._selectedTime.getMilliseconds());
            }
          } else if (tempValueRep.start === +getDateOnly(date) && !s.exclusiveEndDates) {
            date.setHours(23, 59, 59, 999);
          }
          tempValueRep.end = +date;
        }
      } else {
        if (_this._hasTime && _this._hasDate && s.controls.indexOf("datetime") < 0) {
          var time = _this._selectedTime || new Date();
          date.setHours(time.getHours(), time.getMinutes(), time.getSeconds(), time.getMilliseconds());
        } else {
          _this._selectedTime = createDate(s, date);
        }
        tempValueRep = {
          date: {}
        };
        tempValueRep.date[+date] = date;
      }
      _this._tempValueRep = tempValueRep;
      if (slide && tempValueRep.end) {
        tempValueRep.end = +getDayStart(s, addDays(createDate(s, tempValueRep.end), 1));
      }
      _this._setOrUpdate();
    };
    _this._onTimePartChange = function (ev) {
      _this._tempValueSet = false;
      var s = _this.s;
      var isRange = s.select === "range";
      var date = addTimezone(s, ev.value);
      _this._selectedTime = date;
      if (isRange) {
        var values = _this._getDate(_this._tempValueRep);
        var valueIndex = _this._activeSelect === "start" ? 0 : 1;
        if (values[valueIndex]) {
          var value = createDate(s, values[valueIndex]);
          value.setHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
          values[valueIndex] = value;
          if (_this._activeSelect === "start" && +value > +values[1]) {
            values.length = 1;
          }
          _this._tempValueRep = _this._parse(values);
        } else {
          _this._selectedTime.setHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
        }
      } else if (!s.selectMultiple) {
        var value = _this._getDate(_this._tempValueRep);
        if (value) {
          value.setHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
          _this._tempValueRep = {
            date: {}
          };
          _this._tempValueRep.date[+value] = value;
        } else {
          _this._selectedTime.setHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
          if (_this._live) {
            _this.forceUpdate();
          }
        }
      }
      _this._setOrUpdate();
    };
    _this._changeActiveTab = function (ev) {
      _this.setState({
        activeTab: ev.target.value
      });
    };
    _this._changeActiveSelect = function (ev) {
      var active = ev.target.value;
      _this._setActiveSelect(active);
      _this.setActiveDate(active);
    };
    _this._clearEnd = function () {
      _this._tempValueRep.end = UNDEFINED;
      if (_this._hasTimegrid) {
        _this._selectedTime = UNDEFINED;
      }
      _this._setOrUpdate();
    };
    _this._clearStart = function () {
      _this._tempValueRep = {};
      _this._newSelection = true;
      if (_this._hasTimegrid) {
        _this._selectedTime = UNDEFINED;
      }
      _this._setOrUpdate();
    };
    _this._onInputClickRange = function (ev) {
      var inp = ev.target;
      var activate = inp === _this._startInput || _this._renderControls ? "start" : "end";
      _this._setActiveSelect(activate);
    };
    _this._onInputChangeRange = function (ev) {
      var startInput = _this._startInput;
      var endInput = _this._endInput;
      var value = (startInput ? startInput.value : "") + (endInput && endInput.value ? RANGE_SEPARATOR + endInput.value : "");
      _this._onInputChange(ev, value);
    };
    return _this;
  }
  DatepickerBase.prototype.setActiveDate = function (active) {
    var notActiveSelect = notActive(active);
    this._activeSelect = active;
    var activeValue = this._tempValueRep[active];
    var notActiveValue = this._tempValueRep[notActiveSelect];
    if (this._tempValueRep.start && this._tempValueRep.end || !activeValue && notActiveValue) {
      this._newSelection = false;
    } else if (activeValue && !notActiveValue) {
      this._newSelection = true;
    }
    if (activeValue) {
      this._active = activeValue;
    }
    if (!activeValue && this._hasTimegrid) {
      this._selectedTime = UNDEFINED;
    }
    this.forceUpdate();
  };
  DatepickerBase.prototype.getTempVal = function () {
    return _super.prototype.getTempVal.call(this);
  };
  DatepickerBase.prototype.setTempVal = function (value) {
    _super.prototype.setTempVal.call(this, value);
  };
  DatepickerBase.prototype.navigate = function (date) {
    this._active = +makeDate(date);
    this.forceUpdate();
  };
  DatepickerBase.prototype._shouldValidate = function (s, prevS) {
    return s.controls !== prevS.controls || s.dataTimezone !== prevS.dataTimezone || s.displayTimezone !== prevS.displayTimezone || s.dateFormat !== prevS.dateFormat || s.timeFormat !== prevS.timeFormat || s.locale !== prevS.locale || s.min !== prevS.min || s.max !== prevS.max;
  };
  DatepickerBase.prototype._valueEquals = function (v1, v2) {
    var side1 = isArray(v1) && v1.length === 0 || v1 === UNDEFINED || v1 === null;
    var side2 = isArray(v2) && v2.length === 0 || v2 === UNDEFINED || v2 === null;
    return side1 && side1 === side2 || dateValueEquals(v1, v2, this.s);
  };
  DatepickerBase.prototype.setVal = function (value) {
    if (this.s.select === "range" && value) {
      var start = value[0],
        end = value[1];
      this._savedStartValue = +makeDate(start, this.s, this._valueFormat);
      this._savedEndValue = +makeDate(end, this.s, this._valueFormat);
    }
    _super.prototype.setVal.call(this, value);
  };
  DatepickerBase.prototype._render = function (s, state) {
    var _this = this;
    if (s.inRangeInvalid) {
      s.rangeEndInvalid = false;
    }
    if (s.select === "preset-range") {
      s.controls = CALENDAR_CTRL;
    }
    if (s.exclusiveEndDates === UNDEFINED) {
      s.exclusiveEndDates = !!s.displayTimezone;
    }
    var hadTime = this._hasTime;
    var hasDate = this._hasDate = !!find(s.controls, function (item) {
      return /date|calendar/.test(item);
    });
    var hasTime = this._hasTime = !!find(s.controls, function (item) {
      return /time/.test(item);
    });
    if (!hasTime) {
      s.timezonePlugin = s.dataTimezone = s.displayTimezone = UNDEFINED;
    }
    if (s.valid && (!s.invalid || hasTime)) {
      s.invalid = INVALID_ALL;
    }
    var prevS = this._prevS;
    s.buttons;
    var calendarSize = s.calendarSize;
    s.children;
    s.className;
    var controls = s.controls;
    s.cssClass;
    s.element;
    s.modelValue;
    s.onDestroy;
    s.onInit;
    s.onTempChange;
    s.responsive;
    var select = s.select,
      selectMultiple = s.selectMultiple,
      tabs = s.tabs,
      other = __rest(s, ["buttons", "calendarSize", "children", "className", "controls", "cssClass", "element", "modelValue", "onDestroy", "onInit", "onTempChange", "responsive", "select", "selectMultiple", "tabs"]);
    var widthType = state.widthType || "sm";
    var isRange = select !== "date";
    this._renderTabs = controls.length > 1 && (tabs === "auto" ? widthType === "sm" : tabs);
    if (select !== prevS.select && this._tempValueRep) {
      if (isRange && this._tempValueRep.date) {
        var _a = Object.keys(this._tempValueRep.date).map(function (v) {
            return +v;
          }).sort(),
          start = _a[0],
          end = _a[1];
        this._tempValueRep.start = start;
        this._tempValueRep.end = end;
        this._tempValueRep.date = UNDEFINED;
        this._tempValueText = this._format(this._tempValueRep);
        setTimeout(function () {
          _this.set();
        });
      } else if (!isRange && (this._tempValueRep.start || this._tempValueRep.end)) {
        if (!this._tempValueRep.date) {
          this._tempValueRep.date = {};
        }
        var first = this._tempValueRep.start || this._tempValueRep.end;
        this._tempValueRep.date[first] = new Date(first);
        var second = this._tempValueRep.end || this._tempValueRep.start;
        if (second !== first && s.selectMultiple) {
          this._tempValueRep.date[second] = new Date(second);
        }
        this._tempValueRep.start = UNDEFINED;
        this._tempValueRep.end = UNDEFINED;
        this._tempValueText = this._format(this._tempValueRep);
        setTimeout(function () {
          _this.set();
        });
      }
    }
    if (s.min !== prevS.min) {
      this._min = isEmpty(s.min) ? UNDEFINED : makeDate(s.min, s, s.dateFormat);
    }
    if (s.max !== prevS.max) {
      this._max = isEmpty(s.max) ? UNDEFINED : makeDate(s.max, s, s.dateFormat);
    }
    if (s.minTime !== prevS.minTime) {
      this._minTime = isEmpty(s.minTime) ? UNDEFINED : makeDate(s.minTime, s, s.timeFormat);
    }
    if (s.maxTime !== prevS.maxTime) {
      this._maxTime = isEmpty(s.maxTime) ? UNDEFINED : makeDate(s.maxTime, s, s.timeFormat);
    }
    var tempValueRepEnd = this._tempValueRep && this._tempValueRep.end;
    var tempValueRepStart = this._tempValueRep && this._tempValueRep.start;
    var format = (hasDate ? s.dateFormat : "") + (hasTime ? (hasDate ? s.separator : "") + s.timeFormat : "");
    var controlsChanged = controls !== prevS.controls;
    if (controlsChanged) {
      this._controls = [];
      this._controlsClass = "";
      this._hasCalendar = false;
      this._hasTimegrid = false;
      for (var _i = 0, _b = controls; _i < _b.length; _i++) {
        var control = _b[_i];
        if (control === "timegrid") {
          this._hasTimegrid = true;
        }
        if (control === "calendar") {
          this._hasCalendar = true;
        }
        this._controls.push({
          Component: modules[control === "calendar" ? "Calendar" : control === "timegrid" ? "Timegrid" : "Datetime"],
          name: control,
          title: control === "time" || control === "timegrid" ? s.timeText : s.dateText
        });
        this._controlsClass += " mbsc-datepicker-control-" + control;
      }
      if (!hasTime) {
        this._selectedTime = UNDEFINED;
      }
    }
    this._renderControls = isRange && select !== "preset-range" && (s.showRangeLabels !== UNDEFINED ? s.showRangeLabels : true);
    this._nullSupport = s.display !== "inline" || select !== "date" || s.selectMultiple === true;
    this._valueFormat = format;
    this._activeTab = state.activeTab || controls[0];
    _super.prototype._render.call(this, s, state);
    if (controlsChanged && isRange && s.exclusiveEndDates && hasTime !== hadTime && (tempValueRepEnd || tempValueRepStart)) {
      var savedStart_1 = this._savedStartValue;
      var savedEnd_1 = this._savedEndValue;
      setTimeout(function () {
        if (hasTime) {
          _this._tempValueRep.start = savedStart_1 || tempValueRepStart;
          _this._tempValueRep.end = savedEnd_1 || tempValueRepEnd;
        } else {
          _this._savedStartValue = tempValueRepStart;
          _this._savedEndValue = tempValueRepEnd;
          _this._clearSaved = false;
          var ss = __assign(__assign({}, s), {
            dataTimezone: _this.props.dataTimezone,
            displayTimezone: _this.props.displayTimezone,
            timezonePlugin: _this.props.timezonePlugin
          });
          if (tempValueRepStart) {
            _this._tempValueRep.start = +removeTimezone(getDayStart(ss, createDate(ss, tempValueRepStart)));
          }
          if (tempValueRepEnd) {
            var tzonedEnd = createDate(ss, tempValueRepEnd - 1);
            _this._tempValueRep.end = +removeTimezone(createDate(ss, +getDayEnd(ss, tzonedEnd) + 1));
          }
        }
        _this._valueText = _this._tempValueText = _this._format(_this._tempValueRep);
        _this._valueTextChange = true;
        _this.set();
      });
      this._valueTextChange = false;
    }
    var controlled = s.value !== UNDEFINED;
    var valueChanged = controlled ? s.value !== prevS.value : state.value !== this._prevStateValue;
    if (isRange && this._clearSaved && valueChanged) {
      this._savedEndValue = this._savedStartValue = UNDEFINED;
    }
    this._clearSaved = true;
    if (s.headerText !== prevS.headerText || s.selectCounter !== prevS.selectCounter || s.selectMultiple !== prevS.selectMultiple) {
      this._setHeader();
    }
    this._scrollLock = s.scrollLock !== UNDEFINED ? s.scrollLock : !this._hasTimegrid;
    this._showInput = s.showInput !== UNDEFINED ? s.showInput : this._showInput && (!isRange || !s.startInput && !s.endInput);
    this._shouldInitInputs = this._shouldInitInputs || select !== prevS.select || s.startInput !== prevS.startInput || s.endInput !== prevS.endInput;
    this._shouldInitInput = this._shouldInitInput || this._shouldInitInputs;
    if (controlsChanged || s.dateWheels !== prevS.dateWheels || s.timeWheels !== prevS.timeWheels || s.dateFormat !== prevS.dateFormat || s.timeFormat !== prevS.timeFormat) {
      var dateParts = s.dateWheels || s.dateFormat;
      var timeParts = s.timeWheels || s.timeFormat;
      var isoParts = this._iso = {};
      if (hasDate) {
        if (/y/i.test(dateParts)) {
          isoParts.y = 1;
        }
        if (/M/.test(dateParts)) {
          isoParts.y = 1;
          isoParts.m = 1;
        }
        if (/d/i.test(dateParts)) {
          isoParts.y = 1;
          isoParts.m = 1;
          isoParts.d = 1;
        }
      }
      if (hasTime) {
        if (/h/i.test(timeParts)) {
          isoParts.h = 1;
        }
        if (/m/.test(timeParts)) {
          isoParts.i = 1;
        }
        if (/s/i.test(timeParts)) {
          isoParts.s = 1;
        }
      }
    }
    var setButtonDisabled;
    if (isRange) {
      if (this._activeSelect === UNDEFINED) {
        this._setActiveSelect("start", true);
      }
      setButtonDisabled = this._selectionNotReady();
    } else {
      this._activeSelect = UNDEFINED;
      setButtonDisabled = false;
    }
    if (this._buttons) {
      var setBtn = find(this._buttons, function (btn) {
        return btn.name === "set";
      });
      if (setBtn && setBtn.disabled !== setButtonDisabled) {
        setBtn.disabled = setButtonDisabled;
        this._buttons = __spreadArray([], this._buttons, true);
      }
    }
    var activeSelect = this._activeSelect;
    this._needsWidth = (s.display === "anchored" || s.display === "center" || s.display !== "inline" && state.isLarge || controls.length > 1 && !tabs) && s.width === UNDEFINED;
    var maxDate = s.max !== UNDEFINED ? makeDate(s.max, s, format) : UNDEFINED;
    var minDate = s.min !== UNDEFINED ? makeDate(s.min, s, format) : UNDEFINED;
    this._maxLimited = maxDate;
    this._minLimited = minDate;
    var selectedStart = this._tempValueRep.start;
    if (selectedStart && (this._prevStart !== selectedStart || prevS.valid !== s.valid || prevS.invalid !== s.invalid)) {
      var startDate = createDate(s, selectedStart);
      this._nextInvalid = s.valid ? addDays(getLatestOccurrence(s.valid, startDate, s), 1) : getNextOccurrence(s.invalid || [], startDate, s);
    }
    var endSelection = activeSelect === "end" && selectedStart;
    if (endSelection) {
      if (!s.inRangeInvalid) {
        var nextInvalid = this._nextInvalid;
        if (nextInvalid) {
          if (s.rangeEndInvalid) {
            this._maxLimited = createDate(s, +addDays(nextInvalid, 1) - 1);
          } else {
            this._maxLimited = createDate(s, +nextInvalid - 1);
          }
        }
      }
      if (!this._hasCalendar || hasTime) {
        if (!this._minLimited || makeDate(this._minLimited, s, format) < createDate(s, selectedStart)) {
          this._minLimited = createDate(s, this._tempValueRep.start);
        }
      }
    }
    this._minTimeLimited = this._minLimited;
    if (endSelection) {
      if (s.minRange) {
        var minLimited = hasTime ? this._tempValueRep.start + s.minRange : +addDays(createDate(s, this._tempValueRep.start), s.minRange) - 1;
        if (!this._minLimited || +makeDate(this._minLimited, s, format) < minLimited) {
          this._minLimited = createDate(s, minLimited);
          this._minTimeLimited = this._minLimited;
        }
      }
      if (this._minTimeLimited === UNDEFINED && this._tempValueRep.start && this._tempValueRep.end) {
        this._minTimeLimited = createDate(s, +this._tempValueRep.start);
      }
      if (s.maxRange !== UNDEFINED) {
        var maxLimited = hasTime ? this._tempValueRep.start + s.maxRange : +addDays(createDate(s, this._tempValueRep.start), s.maxRange) - 1;
        if (!this._maxLimited || +makeDate(this._maxLimited, s, format) > maxLimited) {
          this._maxLimited = createDate(s, maxLimited);
        }
      }
    }
    for (var _c = 0, _d = this._controls; _c < _d.length; _c++) {
      var control = _d[_c];
      var options = __assign(__assign({}, other), {
        display: "inline",
        isOpen: s.isOpen || state.isOpen,
        max: this._maxLimited,
        min: this._minLimited
      });
      if (s.rangeEndInvalid && endSelection && this._nextInvalid) {
        options.valid = __spreadArray(__spreadArray([], options.valid || [], true), [this._nextInvalid], false);
      }
      if (control.name === "calendar") {
        options.min = this._minLimited ? getDateOnly(this._minLimited) : UNDEFINED;
        options.max = this._maxLimited ? getDateOnly(this._maxLimited) : UNDEFINED;
        options.selectRange = isRange;
        options.width = this._needsWidth ? PAGE_WIDTH * getPageNr(s.pages, state.maxPopupWidth) : UNDEFINED;
        if (s.calendarType === "week" && calendarSize) {
          options.weeks = calendarSize;
        } else {
          options.size = calendarSize;
        }
        var pages = s.pages === "auto" ? 3 : s.pages || 1;
        this._maxWidth = s.maxWidth || (pages > 2 ? PAGE_WIDTH * pages : UNDEFINED);
        if (isRange) {
          var valueDate = this._getDate(this._tempValueRep);
          var endDate = valueDate[1];
          if (endDate && s.exclusiveEndDates && !hasTime) {
            valueDate[1] = createDate(s, +endDate - 1);
          }
          var values = valueDate.filter(function (v) {
            return v !== null;
          }).map(function (v) {
            return +getDateOnly(v);
          }).filter(function (v, ind, arr) {
            return arr.indexOf(v) === ind;
          }).map(function (v) {
            return new Date(v);
          });
          options.value = values;
          if (s.rangeHighlight) {
            options.rangeStart = valueDate[0] && +getDateOnly(removeTimezone(valueDate[0]));
            options.rangeEnd = valueDate[1] && +getDateOnly(removeTimezone(valueDate[1]));
            options.onDayHoverIn = this._onDayHoverIn;
            options.onDayHoverOut = this._onDayHoverOut;
            if (select === "preset-range") {
              if (state.hoverDate) {
                var _e = getPresetRange(state.hoverDate, s),
                  start = _e.start,
                  end = _e.end;
                options.hoverStart = +start;
                options.hoverEnd = +end;
              }
            } else {
              if (activeSelect === "end" && valueDate[0]) {
                options.hoverStart = options.rangeEnd || options.rangeStart;
                options.hoverEnd = state.hoverDate;
              }
              if (activeSelect === "start" && valueDate[1] && this._renderControls) {
                options.hoverStart = state.hoverDate;
                options.hoverEnd = options.rangeStart || options.rangeEnd;
              }
            }
          }
        } else {
          options.selectMultiple = selectMultiple;
          options.value = this._getDate(this._tempValueRep);
        }
        var vals = isArray(options.value) ? options.value : [options.value];
        var min = options.min ? +options.min : -Infinity;
        var max = options.max ? +options.max : Infinity;
        var selected = void 0;
        for (var _f = 0, vals_1 = vals; _f < vals_1.length; _f++) {
          var val = vals_1[_f];
          if (!selected && val >= min && val <= max) {
            selected = +val;
          }
        }
        if (!selected && isRange && vals.length) {
          selected = +vals[0];
        }
        if (selected !== this._selectedDate || this._active === UNDEFINED || s.min !== prevS.min || s.max !== prevS.max) {
          this._selectedDate = selected;
          this._active = selected ? +getDateOnly(new Date(selected)) : constrain(this._active || +getDateOnly(new Date()), min, max);
        }
        var viewFormat = s.dateWheels || s.dateFormat;
        var selectedView = /d/i.test(viewFormat) ? PAGE_VIEW : /m/i.test(viewFormat) ? YEAR_VIEW : /y/i.test(viewFormat) ? MULTI_YEAR_VIEW : PAGE_VIEW;
        options.active = this._active;
        options.onActiveChange = this._onActiveChange;
        options.onChange = this._onCalendarChange;
        options.onCellClick = this._onCellClick;
        options.onCellHoverIn = this._proxyHook;
        options.onCellHoverOut = this._proxyHook;
        options.onLabelClick = this._proxyHook;
        options.onPageChange = this._proxyHook;
        options.onPageLoaded = this._proxyHook;
        options.onPageLoading = this._proxyHook;
        options.selectView = selectedView;
      } else {
        var tempValueKeys = Object.keys(this._tempValueRep.date || {});
        options.displayStyle = (s.display === "bottom" || s.display === "top") && (this._hasCalendar || this._renderTabs) ? "center" : s.display;
        options.mode = control.name;
        if ((control.name === "time" || control.name === "timegrid") && hasDate) {
          options.onChange = this._onTimePartChange;
          if (isRange) {
            var alreadySelectedOne = this._tempValueRep[activeSelect];
            var selectedTime = void 0;
            if (this._selectedTime) {
              if (!this._minTimeLimited || this._selectedTime > this._minTimeLimited) {
                selectedTime = this._selectedTime;
              } else {
                selectedTime = createDate(s, this._minTimeLimited);
                selectedTime.setHours(this._selectedTime.getHours(), this._selectedTime.getMinutes(), this._selectedTime.getSeconds(), this._selectedTime.getMilliseconds());
              }
            }
            var nowTrimmed = createDate(s);
            nowTrimmed.setSeconds(0, 0);
            this._selectedTime = alreadySelectedOne ? createDate(s, alreadySelectedOne) : selectedTime || (control.name === "time" ? nowTrimmed : UNDEFINED);
            options.value = this._selectedTime;
          } else if (!s.selectMultiple) {
            var alreadyDate = this._tempValueRep.date && this._tempValueRep.date[tempValueKeys[0]] || this._selectedTime;
            this._selectedTime = options.value = alreadyDate;
          }
          options.min = this._minTimeLimited;
          options.max = this._maxLimited;
        } else {
          options.onChange = this._onDatetimeChange;
          if (isRange) {
            var n = this._tempValueRep[activeSelect];
            var m = this._tempValueRep[notActive(activeSelect)];
            options.value = n ? createDate(s, n) : m ? createDate(s, m) : null;
            if (activeSelect === "end" && s.exclusiveEndDates && !hasTime) {
              options.value = createDate(s, +options.value - 1);
            }
          } else {
            var value = this._tempValueRep.date && this._tempValueRep.date[tempValueKeys[0]];
            var passed = value;
            if (value) {
              if (!hasTime) {
                passed = getDateOnly(value);
              }
            }
            options.value = passed || null;
          }
        }
        if (control.name === "time" || control.name === "timegrid") {
          var selectedOrDefault = options.value || constrainDate(new Date(), options.min, options.max);
          if (this._minTime) {
            var minTime = this._minTime;
            var min = new Date(selectedOrDefault.getFullYear(), selectedOrDefault.getMonth(), selectedOrDefault.getDate(), minTime.getHours(), minTime.getMinutes(), minTime.getSeconds(), minTime.getMilliseconds());
            if (!options.min || min > options.min) {
              options.min = min;
            }
          }
          if (this._maxTime) {
            var maxTime = this._maxTime;
            var max = new Date(selectedOrDefault.getFullYear(), selectedOrDefault.getMonth(), selectedOrDefault.getDate(), maxTime.getHours(), maxTime.getMinutes(), maxTime.getSeconds(), maxTime.getMilliseconds());
            if (!options.max || max < options.max) {
              options.max = max;
            }
          }
        }
      }
      control.options = options;
    }
    this._prevStart = this._tempValueRep.start;
    this._prevStateValue = state.value;
  };
  DatepickerBase.prototype._updated = function () {
    var _this = this;
    var s = this.s;
    if (this._shouldInitInputs) {
      this._resetInputs();
      if (s.select === "range") {
        var startInput = s.startInput;
        if (startInput) {
          this._setupInput("start", startInput);
        }
        var endInput = s.endInput;
        if (endInput) {
          this._setupInput("end", endInput);
        }
        if (s.element && (this._startInput === s.element || this._endInput === s.element)) {
          this._shouldInitInput = false;
          clearTimeout(s.element.__mbscTimer);
        }
      }
      this._shouldInitInputs = false;
    }
    var valueTextChange = this._valueTextChange;
    _super.prototype._updated.call(this);
    if (s.select === "range" && valueTextChange) {
      var triggerChange = function (inp, val) {
        inp.value = val;
        setTimeout(function () {
          _this._preventChange = true;
          trigger(inp, INPUT);
          trigger(inp, CHANGE);
        });
      };
      if (this._startInput) {
        triggerChange(this._startInput, this._getValueText("start"));
      }
      if (this._endInput) {
        triggerChange(this._endInput, this._getValueText("end"));
      }
    }
  };
  DatepickerBase.prototype._onEnterKey = function (args) {
    if (!this._selectionNotReady()) {
      _super.prototype._onEnterKey.call(this, args);
    }
  };
  DatepickerBase.prototype._setupInput = function (i, input) {
    var _this = this;
    getNativeElement(input, function (inp) {
      var resetElement = initPickerElement(inp, _this, _this._onInputChangeRange, _this._onInputClickRange);
      if (i === "start") {
        _this._startInput = inp;
        _this._resetStartInput = resetElement;
      } else {
        _this._endInput = inp;
        _this._resetEndInput = resetElement;
      }
      var val = _this._getValueText(i);
      var changed = val !== inp.value;
      inp.value = val;
      if (changed) {
        setTimeout(function () {
          _this._preventChange = true;
          trigger(inp, INPUT);
          trigger(inp, CHANGE);
        });
      }
    });
  };
  DatepickerBase.prototype._destroy = function () {
    this._resetInputs();
    _super.prototype._destroy.call(this);
  };
  DatepickerBase.prototype._setHeader = function () {
    var s = this.s;
    if (s.selectCounter && s.selectMultiple) {
      var count = Object.keys(this._tempValueRep && this._tempValueRep.date || {}).length;
      this._headerText = (count > 1 ? s.selectedPluralText || s.selectedText : s.selectedText).replace(/{count}/, "" + count);
    } else {
      _super.prototype._setHeader.call(this);
    }
  };
  DatepickerBase.prototype._validate = function () {
    if (this._max <= this._min) {
      return;
    }
    var s = this.s;
    var min = this._min ? +this._min : -Infinity;
    var max = this._max ? +this._max : Infinity;
    if (s.select === "date") {
      var values = this._tempValueRep.date;
      if (!s.selectMultiple) {
        for (var _i = 0, _a = Object.keys(values); _i < _a.length; _i++) {
          var key = _a[_i];
          var d = values[key];
          var validated = getClosestValidDate(d, s, min, max);
          if (+validated !== +d) {
            delete values[key];
            values[+getDateOnly(validated)] = validated;
          }
        }
      }
    } else {
      var range = this._getDate(this._tempValueRep);
      var startDate = range[0],
        endDate = range[1];
      if (startDate) {
        startDate = getClosestValidDate(startDate, s, min, max);
        if (!s.inRangeInvalid && (!this._prevStart || this._prevStart !== +startDate)) {
          this._nextInvalid = s.valid ? addDays(getLatestOccurrence(s.valid, startDate, s), 1) : getNextOccurrence(s.invalid || [], startDate, s);
        }
      }
      if (endDate) {
        if (!s.inRangeInvalid && this._nextInvalid && this._nextInvalid <= endDate) {
          endDate = s.rangeEndInvalid ? this._nextInvalid : addDays(this._nextInvalid, -1);
        } else {
          endDate = getClosestValidDate(endDate, s, min, max);
        }
      }
      if (startDate && endDate && startDate > endDate) {
        if (this._activeSelect === "end") {
          startDate = endDate;
        } else {
          endDate = startDate;
        }
      }
      if (startDate) {
        this._prevStart = this._tempValueRep.start = +startDate;
      }
      if (endDate) {
        this._tempValueRep.end = +endDate;
      }
    }
  };
  DatepickerBase.prototype._copy = function (value) {
    var date = value.date ? __assign({}, value.date) : value.date;
    return __assign(__assign({}, value), {
      date: date
    });
  };
  DatepickerBase.prototype._format = function (valueRep) {
    var s = this.s;
    var ret = [];
    if (!s) {
      return "";
    }
    if (s.select === "date") {
      var vRep = valueRep.date;
      for (var i in vRep) {
        if (vRep[i] !== UNDEFINED && vRep[i] !== null) {
          ret.push(formatDate(this._valueFormat, vRep[i], s));
        }
      }
      return s.selectMultiple ? ret.join(", ") : ret[0];
    } else {
      if (valueRep.start) {
        ret.push(formatDate(this._valueFormat, createDate(s, valueRep.start), s));
      }
      if (valueRep.end) {
        if (!ret.length) {
          ret.push("");
        }
        var end = createDate(s, valueRep.end - (s.exclusiveEndDates && !this._hasTime ? 1 : 0));
        ret.push(formatDate(this._valueFormat, end, s));
      }
      this._tempStartText = ret[0] || "";
      this._tempEndText = ret[1] || "";
      return ret.join(RANGE_SEPARATOR);
    }
  };
  DatepickerBase.prototype._parse = function (value, fromInput) {
    var s = this.s;
    var ret = {};
    var isRange = s.select !== "date";
    var isMultiple = s.selectMultiple;
    var values = [];
    if (isEmpty(value)) {
      var def = s.defaultSelection;
      value = isMultiple || isRange ? def : def === null || this._live && s.display !== "inline" ? null : def || new Date();
    }
    if (isString(value) && (isRange || isMultiple)) {
      values = value.split(isRange ? RANGE_SEPARATOR : ",");
    } else if (isArray(value)) {
      values = value;
    } else if (value && !isArray(value)) {
      values = [value];
    }
    if (isRange) {
      var start = values[0],
        end = values[1];
      var startDate = makeDate(start, s, this._valueFormat, this._iso);
      var endDate = makeDate(end, s, this._valueFormat, this._iso);
      ret.start = startDate ? +startDate : UNDEFINED;
      ret.end = endDate ? +endDate : UNDEFINED;
    } else {
      ret.date = {};
      for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
        var val = values_1[_i];
        if (!isEmpty(val)) {
          var date = makeDate(val, s, this._valueFormat, this._iso, fromInput);
          if (date) {
            if (fromInput) {
              date = addTimezone(s, date);
            }
            var key = +getDateOnly(date);
            ret.date[key] = date;
            if (this._hasTime) {
              this._selectedTime = new Date(date);
            }
          }
        }
      }
    }
    return ret;
  };
  DatepickerBase.prototype._getDate = function (value) {
    var s = this.s;
    var isRange = s.select !== "date";
    if (isRange) {
      var start = value.start ? createDate(s, value.start) : null;
      var end = value.end ? createDate(s, value.end) : null;
      if (!start && !end) {
        return [];
      }
      return [start, end];
    }
    if (s.selectMultiple) {
      var valueArray = [];
      var dates = value.date;
      if (dates) {
        for (var _i = 0, _a = Object.keys(dates); _i < _a.length; _i++) {
          var v = _a[_i];
          valueArray.push(createDate(s, +v));
        }
      }
      return valueArray;
    }
    var valueKeys = Object.keys(value.date || {});
    if (!valueKeys.length) {
      return null;
    }
    return createDate(s, value.date[valueKeys[0]]);
  };
  DatepickerBase.prototype._get = function (value) {
    var _this = this;
    var s = this.s;
    var valueFormat = this._valueFormat;
    var isoParts = this._iso;
    var valueDate = this._getDate(value);
    if (isArray(valueDate)) {
      return valueDate.map(function (date) {
        return date ? returnDate(date, s, valueFormat, isoParts, _this._hasTime) : null;
      });
    }
    if (valueDate === null) {
      return null;
    }
    return returnDate(valueDate, s, valueFormat, isoParts, this._hasTime);
  };
  DatepickerBase.prototype._onClosed = function () {
    this._active = this._activeSelect = UNDEFINED;
    if (this._hasTimegrid) {
      this._selectedTime = UNDEFINED;
    }
  };
  DatepickerBase.prototype._onOpen = function () {
    this._newSelection = true;
  };
  DatepickerBase.prototype._resetInputs = function () {
    if (this._resetStartInput) {
      this._resetStartInput();
      this._resetStartInput = UNDEFINED;
    }
    if (this._resetEndInput) {
      this._resetEndInput();
      this._resetEndInput = UNDEFINED;
    }
  };
  DatepickerBase.prototype._getValueText = function (input) {
    return this._valueText.split(RANGE_SEPARATOR)[input === "start" ? 0 : 1] || "";
  };
  DatepickerBase.prototype._selectionNotReady = function () {
    var notReady = false;
    if (this.s.select === "range") {
      var val = (this._get(this._tempValueRep || {}) || []).filter(function (v) {
        return v;
      });
      notReady = !val.length;
      if (!notReady) {
        if (this._hasCalendar && !this._hasTime) {
          notReady = val.length < 2;
        } else {
          if (this._renderControls) {
            notReady = val.length < 2;
          } else {
            notReady = !this._tempValueRep[this._activeSelect];
          }
        }
      }
    }
    return notReady;
  };
  DatepickerBase.prototype._setActiveSelect = function (active, timeout) {
    var _this = this;
    if (this._activeSelect !== active) {
      if (timeout) {
        setTimeout(function () {
          return _this._hook("onActiveDateChange", {
            active: active
          });
        });
      } else {
        this._hook("onActiveDateChange", {
          active: active
        });
      }
    }
    this._activeSelect = active;
  };
  DatepickerBase.defaults = __assign(__assign(__assign({}, dateTimeLocale), PickerBase.defaults), {
    activeElm: '.mbsc-calendar-cell[tabindex="0"]',
    controls: CALENDAR_CTRL,
    dateText: "Date",
    inRangeInvalid: false,
    inputTyping: true,
    rangeEndHelp: "Please select",
    rangeEndLabel: "End",
    rangeHighlight: true,
    rangeStartHelp: "Please select",
    rangeStartLabel: "Start",
    select: "date",
    selectSize: 7,
    selectedText: "{count} selected",
    showOnClick: true,
    timeText: "Time"
  });
  DatepickerBase._name = "Datepicker";
  DatepickerBase.ɵfac = /* @__PURE__ */(() => {
    let ɵDatepickerBase_BaseFactory;
    return function DatepickerBase_Factory(t) {
      return (ɵDatepickerBase_BaseFactory || (ɵDatepickerBase_BaseFactory = i0.ɵɵgetInheritedFactory(DatepickerBase)))(t || DatepickerBase);
    };
  })();
  DatepickerBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DatepickerBase,
    selectors: [["", "mbsc-dp-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return DatepickerBase;
}(PickerBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var tapped = 0;
var allowQuick;
function getCoord(ev, axis, page) {
  var prop = (page ? "page" : "client") + axis;
  if (ev.targetTouches && ev.targetTouches[0]) {
    return ev.targetTouches[0][prop];
  }
  if (ev.changedTouches && ev.changedTouches[0]) {
    return ev.changedTouches[0][prop];
  }
  return ev[prop];
}
function preventClick() {
  tapped++;
  setTimeout(function () {
    tapped--;
  }, 500);
}
function triggerClick(ev, control) {
  if (control.mbscClick) {
    return;
  }
  var touch = (ev.originalEvent || ev).changedTouches[0];
  var evt = document.createEvent("MouseEvents");
  evt.initMouseEvent("click", true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
  evt.isMbscTap = true;
  evt.isIonicTap = true;
  allowQuick = true;
  control.mbscChange = true;
  control.mbscClick = true;
  control.dispatchEvent(evt);
  allowQuick = false;
  preventClick();
  setTimeout(function () {
    delete control.mbscClick;
  });
}
function bustClick(ev) {
  if (tapped && !allowQuick && !ev.isMbscTap && !(ev.target.nodeName === "TEXTAREA" && ev.type === MOUSE_DOWN)) {
    ev.stopPropagation();
    ev.preventDefault();
  }
}
if (isBrowser) {
  [MOUSE_OVER, MOUSE_ENTER, MOUSE_DOWN, MOUSE_UP, CLICK].forEach(function (ev) {
    doc.addEventListener(ev, bustClick, true);
  });
  if (os === "android" && majorVersion < 5) {
    doc.addEventListener(CHANGE, function (ev) {
      var target = ev.target;
      if (tapped && target.type === "checkbox" && !target.mbscChange) {
        ev.stopPropagation();
        ev.preventDefault();
      }
      delete target.mbscChange;
    }, true);
  }
}
var wasTouched;
function setFocusInvisible(ev) {
  var win = getWindow(ev.target);
  win.__mbscFocusVisible = false;
}
function setFocusVisible(ev) {
  var win = getWindow(ev.target);
  win.__mbscFocusVisible = true;
}
function addRipple(elm, x, y) {
  var rect = elm.getBoundingClientRect();
  var left = x - rect.left;
  var top = y - rect.top;
  var width = Math.max(left, elm.offsetWidth - left);
  var height = Math.max(top, elm.offsetHeight - top);
  var size = 2 * Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2));
  var ripple = doc.createElement("span");
  ripple.classList.add("mbsc-ripple");
  var style = ripple.style;
  style.backgroundColor = getComputedStyle(elm).color;
  style.width = size + "px";
  style.height = size + "px";
  style.top = y - rect.top - size / 2 + "px";
  style.left = x - rect.left - size / 2 + "px";
  elm.appendChild(ripple);
  setTimeout(function () {
    style.opacity = ".2";
    style.transform = "scale(1)";
    style.transition = "opacity linear .1s, transform cubic-bezier(0, 0, 0.2, 1) .4s";
  }, 30);
  return ripple;
}
function removeRipple(r) {
  if (r) {
    setTimeout(function () {
      r.style.opacity = "0";
      r.style.transition = "opacity linear .4s";
      setTimeout(function () {
        if (r && r.parentNode) {
          r.parentNode.removeChild(r);
        }
      }, 400);
    }, 200);
  }
}
function gestureListener(elm, options) {
  var args = {};
  var win = getWindow(elm);
  var document = getDocument(elm);
  var active;
  var activeable;
  var activeTimer;
  var ripple;
  var hasFocus;
  var hasHover;
  var hasRipple;
  var moved;
  var startX;
  var startY;
  var endX;
  var endY;
  var deltaX;
  var deltaY;
  var started;
  function skipMouseEvent(ev) {
    if (ev.type === TOUCH_START) {
      wasTouched = true;
    } else if (wasTouched) {
      if (ev.type === MOUSE_DOWN) {
        wasTouched = false;
      }
      return true;
    }
    return false;
  }
  function activate() {
    if (hasRipple) {
      removeRipple(ripple);
      ripple = addRipple(elm, endX, endY);
    }
    options.onPress();
    active = true;
  }
  function deactivate(r, time) {
    activeable = false;
    removeRipple(r);
    clearTimeout(activeTimer);
    activeTimer = setTimeout(function () {
      if (active) {
        options.onRelease();
        active = false;
      }
    }, time);
  }
  function onStart(ev) {
    if (skipMouseEvent(ev)) {
      return;
    }
    if (ev.type === MOUSE_DOWN && (ev.button !== 0 || ev.ctrlKey)) {
      return;
    }
    startX = getCoord(ev, "X");
    startY = getCoord(ev, "Y");
    endX = startX;
    endY = startY;
    active = false;
    activeable = false;
    moved = false;
    started = true;
    args.moved = moved;
    args.startX = startX;
    args.startY = startY;
    args.endX = endX;
    args.endY = endY;
    args.deltaX = 0;
    args.deltaY = 0;
    args.domEvent = ev;
    args.isTouch = wasTouched;
    removeRipple(ripple);
    if (options.onStart) {
      var ret = options.onStart(args);
      hasRipple = ret && ret.ripple;
    }
    if (options.onPress) {
      activeable = true;
      clearTimeout(activeTimer);
      activeTimer = setTimeout(activate, 50);
    }
    if (ev.type === MOUSE_DOWN) {
      listen(document, MOUSE_MOVE, onMove);
      listen(document, MOUSE_UP, onEnd);
    }
    listen(document, CONTEXTMENU, onContextMenu);
  }
  function onMove(ev) {
    if (!started) {
      return;
    }
    endX = getCoord(ev, "X");
    endY = getCoord(ev, "Y");
    deltaX = endX - startX;
    deltaY = endY - startY;
    if (!moved && (Math.abs(deltaX) > 9 || Math.abs(deltaY) > 9)) {
      moved = true;
      deactivate(ripple);
    }
    args.moved = moved;
    args.endX = endX;
    args.endY = endY;
    args.deltaX = deltaX;
    args.deltaY = deltaY;
    args.domEvent = ev;
    args.isTouch = ev.type === TOUCH_MOVE;
    if (options.onMove) {
      options.onMove(args);
    }
  }
  function onEnd(ev) {
    if (!started) {
      return;
    }
    if (activeable && !active) {
      clearTimeout(activeTimer);
      activate();
    }
    args.domEvent = ev;
    args.isTouch = ev.type === TOUCH_END;
    if (options.onEnd) {
      options.onEnd(args);
    }
    deactivate(ripple, 75);
    started = false;
    if (ev.type === TOUCH_END && options.click && hasGhostClick && !moved) {
      triggerClick(ev, ev.target);
    }
    if (ev.type === MOUSE_UP) {
      unlisten(document, MOUSE_MOVE, onMove);
      unlisten(document, MOUSE_UP, onEnd);
    }
    unlisten(document, CONTEXTMENU, onContextMenu);
  }
  function onHoverIn(ev) {
    if (skipMouseEvent(ev)) {
      return;
    }
    hasHover = true;
    options.onHoverIn(ev);
  }
  function onHoverOut(ev) {
    if (hasHover) {
      options.onHoverOut(ev);
    }
    hasHover = false;
  }
  function onKeyDown(ev) {
    options.onKeyDown(ev);
  }
  function onFocus(ev) {
    if (options.keepFocus || win.__mbscFocusVisible) {
      hasFocus = true;
      options.onFocus(ev);
    }
  }
  function onBlur(ev) {
    if (hasFocus) {
      options.onBlur(ev);
    }
    hasFocus = false;
  }
  function onChange(ev) {
    options.onChange(ev);
  }
  function onInput(ev) {
    options.onInput(ev);
  }
  function onDoubleClick(ev) {
    args.domEvent = ev;
    if (!wasTouched) {
      options.onDoubleClick(args);
    }
  }
  function onContextMenu(ev) {
    if (wasTouched) {
      ev.preventDefault();
    }
  }
  listen(elm, MOUSE_DOWN, onStart);
  listen(elm, TOUCH_START, onStart, {
    passive: true
  });
  listen(elm, TOUCH_MOVE, onMove, {
    passive: false
  });
  listen(elm, TOUCH_END, onEnd);
  listen(elm, TOUCH_CANCEL, onEnd);
  if (options.onChange) {
    listen(elm, CHANGE, onChange);
  }
  if (options.onInput) {
    listen(elm, INPUT, onInput);
  }
  if (options.onHoverIn) {
    listen(elm, MOUSE_ENTER, onHoverIn);
  }
  if (options.onHoverOut) {
    listen(elm, MOUSE_LEAVE, onHoverOut);
  }
  if (options.onKeyDown) {
    listen(elm, KEY_DOWN, onKeyDown);
  }
  if (options.onFocus && win) {
    listen(elm, FOCUS, onFocus);
    if (!options.keepFocus) {
      var focusCount = win.__mbscFocusCount || 0;
      if (focusCount === 0) {
        listen(win, MOUSE_DOWN, setFocusInvisible, true);
        listen(win, KEY_DOWN, setFocusVisible, true);
      }
      win.__mbscFocusCount = ++focusCount;
    }
  }
  if (options.onBlur) {
    listen(elm, BLUR, onBlur);
  }
  if (options.onDoubleClick) {
    listen(elm, DOUBLE_CLICK, onDoubleClick);
  }
  return function () {
    clearTimeout(activeTimer);
    if (options.onFocus && win && !options.keepFocus) {
      var focusCount = win.__mbscFocusCount || 0;
      win.__mbscFocusCount = --focusCount;
      if (focusCount <= 0) {
        unlisten(win, MOUSE_DOWN, setFocusInvisible);
        unlisten(win, KEY_DOWN, setFocusVisible);
      }
    }
    unlisten(elm, INPUT, onInput);
    unlisten(elm, MOUSE_DOWN, onStart);
    unlisten(elm, TOUCH_START, onStart, {
      passive: true
    });
    unlisten(elm, TOUCH_MOVE, onMove, {
      passive: false
    });
    unlisten(elm, TOUCH_END, onEnd);
    unlisten(elm, TOUCH_CANCEL, onEnd);
    unlisten(document, MOUSE_MOVE, onMove);
    unlisten(document, MOUSE_UP, onEnd);
    unlisten(document, CONTEXTMENU, onContextMenu);
    unlisten(elm, CHANGE, onChange);
    unlisten(elm, MOUSE_ENTER, onHoverIn);
    unlisten(elm, MOUSE_LEAVE, onHoverOut);
    unlisten(elm, KEY_DOWN, onKeyDown);
    unlisten(elm, FOCUS, onFocus);
    unlisten(elm, BLUR, onBlur);
    unlisten(elm, DOUBLE_CLICK, onDoubleClick);
  };
}
var ButtonBase = /*#__PURE__*/function (_super) {
  __extends(ButtonBase, _super);
  function ButtonBase() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ButtonBase.prototype._mounted = function () {
    var _this = this;
    this._unlisten = gestureListener(this._el, {
      click: true,
      onBlur: function () {
        _this.setState({
          hasFocus: false
        });
      },
      onFocus: function () {
        _this.setState({
          hasFocus: true
        });
      },
      onHoverIn: function () {
        if (!_this.s.disabled) {
          _this.setState({
            hasHover: true
          });
        }
      },
      onHoverOut: function () {
        _this.setState({
          hasHover: false
        });
      },
      onKeyDown: function (ev) {
        switch (ev.keyCode) {
          case ENTER:
          case SPACE:
            _this._el.click();
            ev.preventDefault();
            break;
        }
      },
      onPress: function () {
        _this.setState({
          isActive: true
        });
      },
      onRelease: function () {
        _this.setState({
          isActive: false
        });
      },
      onStart: function () {
        return {
          ripple: _this.s.ripple && !_this.s.disabled
        };
      }
    });
  };
  ButtonBase.prototype._render = function (s, state) {
    var _this = this;
    var disabled = s.disabled;
    this._isIconOnly = !!(s.icon || s.iconSvg);
    this._hasStartIcon = !!(s.startIcon || s.startIconSvg);
    this._hasEndIcon = !!(s.endIcon || s.endIconSvg);
    this._tabIndex = disabled ? UNDEFINED : s.tabIndex || 0;
    this._cssClass = this._className + " mbsc-reset mbsc-font mbsc-button" + this._theme + this._rtl + " mbsc-button-" + s.variant + (this._isIconOnly ? " mbsc-icon-button" : "") + (disabled ? " mbsc-disabled" : "") + (s.color ? " mbsc-button-" + s.color : "") + (state.hasFocus && !disabled ? " mbsc-focus" : "") + (state.isActive && !disabled ? " mbsc-active" : "") + (state.hasHover && !disabled ? " mbsc-hover" : "");
    this._iconClass = "mbsc-button-icon" + this._rtl;
    this._startIconClass = this._iconClass + " mbsc-button-icon-start";
    this._endIconClass = this._iconClass + " mbsc-button-icon-end";
    if (s.disabled && state.hasHover) {
      setTimeout(function () {
        _this.setState({
          hasHover: false
        });
      });
    }
  };
  ButtonBase.prototype._destroy = function () {
    if (this._unlisten) {
      this._unlisten();
    }
  };
  ButtonBase.defaults = {
    ripple: false,
    role: "button",
    tag: "button",
    variant: "standard"
  };
  ButtonBase._name = "Button";
  ButtonBase.ɵfac = /* @__PURE__ */(() => {
    let ɵButtonBase_BaseFactory;
    return function ButtonBase_Factory(t) {
      return (ɵButtonBase_BaseFactory || (ɵButtonBase_BaseFactory = i0.ɵɵgetInheritedFactory(ButtonBase)))(t || ButtonBase);
    };
  })();
  ButtonBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: ButtonBase,
    selectors: [["", "mbsc-btn-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return ButtonBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var IconBase = /*#__PURE__*/function (_super) {
  __extends(IconBase, _super);
  function IconBase() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  IconBase.prototype._render = function (s) {
    this._hasChildren = s.name !== UNDEFINED && !isString(s.name);
    this._cssClass = this._className + " mbsc-icon" + this._theme + (s.name && !this._hasChildren ? s.name.indexOf(" ") !== -1 ? " " + s.name : " mbsc-font-icon mbsc-icon-" + s.name : "");
    this._svg = s.svg ? this._safeHtml(s.svg) : UNDEFINED;
  };
  IconBase.ɵfac = /* @__PURE__ */(() => {
    let ɵIconBase_BaseFactory;
    return function IconBase_Factory(t) {
      return (ɵIconBase_BaseFactory || (ɵIconBase_BaseFactory = i0.ɵɵgetInheritedFactory(IconBase)))(t || IconBase);
    };
  })();
  IconBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: IconBase,
    selectors: [["", "mbsc-i-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return IconBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscCustomIcon = /*#__PURE__*/function () {
  function MbscCustomIcon() {}
  MbscCustomIcon.ɵfac = function MbscCustomIcon_Factory(t) {
    return new (t || MbscCustomIcon)();
  };
  MbscCustomIcon.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: MbscCustomIcon,
    selectors: [["", "mbsc-icon", ""]]
  });
  return MbscCustomIcon;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscCustomStartIcon = /*#__PURE__*/function () {
  function MbscCustomStartIcon() {}
  MbscCustomStartIcon.ɵfac = function MbscCustomStartIcon_Factory(t) {
    return new (t || MbscCustomStartIcon)();
  };
  MbscCustomStartIcon.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: MbscCustomStartIcon,
    selectors: [["", "mbsc-start-icon", ""]]
  });
  return MbscCustomStartIcon;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscCustomEndIcon = /*#__PURE__*/function () {
  function MbscCustomEndIcon() {}
  MbscCustomEndIcon.ɵfac = function MbscCustomEndIcon_Factory(t) {
    return new (t || MbscCustomEndIcon)();
  };
  MbscCustomEndIcon.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: MbscCustomEndIcon,
    selectors: [["", "mbsc-end-icon", ""]]
  });
  return MbscCustomEndIcon;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscIcon = /*#__PURE__*/function (_super) {
  __extends(MbscIcon, _super);
  function MbscIcon() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MbscIcon.prototype._updated = function () {
    if (this.s.svg !== this._prevS.svg) {
      this._el.innerHTML = this.s.svg;
    }
    _super.prototype._updated.call(this);
  };
  MbscIcon.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscIcon_BaseFactory;
    return function MbscIcon_Factory(t) {
      return (ɵMbscIcon_BaseFactory || (ɵMbscIcon_BaseFactory = i0.ɵɵgetInheritedFactory(MbscIcon)))(t || MbscIcon);
    };
  })();
  MbscIcon.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscIcon,
    selectors: [["mbsc-icon"]],
    hostVars: 2,
    hostBindings: function MbscIcon_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx._cssClass);
      }
    },
    inputs: {
      name: "name",
      svg: "svg"
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function MbscIcon_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscIcon;
}(IconBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscButton = /*#__PURE__*/function (_super) {
  __extends(MbscButton, _super);
  function MbscButton() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MbscButton.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscButton_BaseFactory;
    return function MbscButton_Factory(t) {
      return (ɵMbscButton_BaseFactory || (ɵMbscButton_BaseFactory = i0.ɵɵgetInheritedFactory(MbscButton)))(t || MbscButton);
    };
  })();
  MbscButton.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscButton,
    selectors: [["mbsc-button"]],
    contentQueries: function MbscButton_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, MbscCustomIcon, 5);
        i0.ɵɵcontentQuery(dirIndex, MbscCustomStartIcon, 5);
        i0.ɵɵcontentQuery(dirIndex, MbscCustomEndIcon, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._customIcon = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._customStartIcon = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._customEndIcon = _t.first);
      }
    },
    hostVars: 6,
    hostBindings: function MbscButton_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("aria-disabled", ctx.disabled ? "true" : undefined)("aria-label", ctx.ariaLabel)("role", ctx.s.role)("tabindex", ctx._tabIndex);
        i0.ɵɵclassMap(ctx._cssClass);
      }
    },
    inputs: {
      ariaLabel: "ariaLabel",
      color: "color",
      disabled: "disabled",
      endIcon: "endIcon",
      endIconSrc: "endIconSrc",
      endIconSvg: "endIconSvg",
      icon: "icon",
      iconSvg: "iconSvg",
      iconSrc: "iconSrc",
      ripple: "ripple",
      role: "role",
      startIcon: "startIcon",
      startIconSrc: "startIconSrc",
      startIconSvg: "startIconSvg",
      tabIndex: "tabIndex",
      variant: "variant"
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c2,
    decls: 4,
    vars: 3,
    consts: [[3, "class", "name", "svg", "theme", 4, "ngIf"], [3, "name", "svg", "theme"]],
    template: function MbscButton_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef(_c1);
        i0.ɵɵtemplate(0, MbscButton_mbsc_icon_0_Template, 2, 5, "mbsc-icon", 0)(1, MbscButton_mbsc_icon_1_Template, 2, 5, "mbsc-icon", 0);
        i0.ɵɵprojection(2);
        i0.ɵɵtemplate(3, MbscButton_mbsc_icon_3_Template, 2, 5, "mbsc-icon", 0);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx._isIconOnly || ctx._customIcon);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._hasStartIcon || ctx._customStartIcon);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx._hasEndIcon || ctx._customEndIcon);
      }
    },
    dependencies: [MbscIcon, NgIf],
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscButton;
}(ButtonBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscIconModule = /*#__PURE__*/function () {
  function MbscIconModule() {}
  MbscIconModule.ɵfac = function MbscIconModule_Factory(t) {
    return new (t || MbscIconModule)();
  };
  MbscIconModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MbscIconModule
  });
  MbscIconModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule]]
  });
  return MbscIconModule;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscButtonModule = /*#__PURE__*/function () {
  function MbscButtonModule() {}
  MbscButtonModule.ɵfac = function MbscButtonModule_Factory(t) {
    return new (t || MbscButtonModule)();
  };
  MbscButtonModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MbscButtonModule
  });
  MbscButtonModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule, MbscIconModule]]
  });
  return MbscButtonModule;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var InstanceServiceBase = /*#__PURE__*/function () {
  function InstanceServiceBase() {
    this.onInstanceReady = new Observable();
    this.onComponentChange = new Observable();
  }
  Object.defineProperty(InstanceServiceBase.prototype, "instance", {
    get: function () {
      return this.inst;
    },
    set: function (inst) {
      this.inst = inst;
      this.onInstanceReady.next(inst);
    },
    enumerable: false,
    configurable: true
  });
  return InstanceServiceBase;
}();
var MbscInstanceService = /*#__PURE__*/function (_super) {
  __extends(MbscInstanceService, _super);
  function MbscInstanceService() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MbscInstanceService.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscInstanceService_BaseFactory;
    return function MbscInstanceService_Factory(t) {
      return (ɵMbscInstanceService_BaseFactory || (ɵMbscInstanceService_BaseFactory = i0.ɵɵgetInheritedFactory(MbscInstanceService)))(t || MbscInstanceService);
    };
  })();
  MbscInstanceService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MbscInstanceService,
    factory: MbscInstanceService.ɵfac
  });
  return MbscInstanceService;
}(InstanceServiceBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var CalendarSubscriber = /*#__PURE__*/function () {
  function CalendarSubscriber(instanceService, changeDetector) {
    this.changeDetector = changeDetector;
    this._cssClass = "";
    if (instanceService) {
      this.setupServices(instanceService);
    }
  }
  Object.defineProperty(CalendarSubscriber.prototype, "cssClass", {
    get: function () {
      var theme = this._hostInst && this._hostInst._theme || "";
      var newTheme = "" + this._cssClass + theme;
      return newTheme;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CalendarSubscriber.prototype, "calendar", {
    set: function (inst) {
      this.setupServices(inst._instanceService);
    },
    enumerable: false,
    configurable: true
  });
  CalendarSubscriber.prototype.ngOnDestroy = function () {
    this.cleanupService();
  };
  CalendarSubscriber.prototype.setupServices = function (serv) {
    var _this = this;
    if (serv !== this.instanceService) {
      this.cleanupService();
      this.instanceService = serv;
      this._hostInst = serv.instance;
      if (this._hostInst) {
        this.inst = this._hostInst._calendarView;
      }
      this.readyHandler = serv.onInstanceReady.subscribe(function (inst) {
        setTimeout(function () {
          _this._hostInst = inst;
          _this.inst = inst._calendarView;
          _this.changeDetector.markForCheck();
        });
      });
      this.changeHandler = serv.onComponentChange.subscribe(function () {
        setTimeout(function () {
          _this.changeDetector.markForCheck();
        });
      });
    }
  };
  CalendarSubscriber.prototype.cleanupService = function () {
    if (this.instanceService !== UNDEFINED) {
      if (this.changeHandler !== UNDEFINED) {
        this.instanceService.onComponentChange.unsubscribe(this.changeHandler);
      }
      if (this.readyHandler !== UNDEFINED) {
        this.instanceService.onInstanceReady.unsubscribe(this.readyHandler);
      }
    }
  };
  CalendarSubscriber.ɵfac = function CalendarSubscriber_Factory(t) {
    return new (t || CalendarSubscriber)(i0.ɵɵdirectiveInject(MbscInstanceService, 8), i0.ɵɵdirectiveInject(ChangeDetectorRef));
  };
  CalendarSubscriber.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: CalendarSubscriber,
    selectors: [["mbsc-cal-s"]],
    inputs: {
      _cssClass: [i0.ɵɵInputFlags.None, "class", "_cssClass"],
      calendar: "calendar"
    }
  });
  return CalendarSubscriber;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscCalendarPrev = /*#__PURE__*/function (_super) {
  __extends(MbscCalendarPrev, _super);
  function MbscCalendarPrev() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MbscCalendarPrev.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscCalendarPrev_BaseFactory;
    return function MbscCalendarPrev_Factory(t) {
      return (ɵMbscCalendarPrev_BaseFactory || (ɵMbscCalendarPrev_BaseFactory = i0.ɵɵgetInheritedFactory(MbscCalendarPrev)))(t || MbscCalendarPrev);
    };
  })();
  MbscCalendarPrev.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscCalendarPrev,
    selectors: [["mbsc-calendar-prev"]],
    hostVars: 2,
    hostBindings: function MbscCalendarPrev_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.cssClass);
      }
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    decls: 1,
    vars: 1,
    consts: [["class", "mbsc-calendar-button", "variant", "flat", 3, "ariaLabel", "disabled", "iconSvg", "theme", "themeVariant", "click", 4, "ngIf"], ["variant", "flat", 1, "mbsc-calendar-button", 3, "click", "ariaLabel", "disabled", "iconSvg", "theme", "themeVariant"]],
    template: function MbscCalendarPrev_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, MbscCalendarPrev_mbsc_button_0_Template, 1, 5, "mbsc-button", 0);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.inst);
      }
    },
    dependencies: [MbscButton, NgIf],
    encapsulation: 2
  });
  return MbscCalendarPrev;
}(CalendarSubscriber);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscCalendarNext = /*#__PURE__*/function (_super) {
  __extends(MbscCalendarNext, _super);
  function MbscCalendarNext() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MbscCalendarNext.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscCalendarNext_BaseFactory;
    return function MbscCalendarNext_Factory(t) {
      return (ɵMbscCalendarNext_BaseFactory || (ɵMbscCalendarNext_BaseFactory = i0.ɵɵgetInheritedFactory(MbscCalendarNext)))(t || MbscCalendarNext);
    };
  })();
  MbscCalendarNext.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscCalendarNext,
    selectors: [["mbsc-calendar-next"]],
    hostVars: 2,
    hostBindings: function MbscCalendarNext_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.cssClass);
      }
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    decls: 1,
    vars: 1,
    consts: [["class", "mbsc-calendar-button", "variant", "flat", 3, "ariaLabel", "disabled", "iconSvg", "theme", "themeVariant", "click", 4, "ngIf"], ["variant", "flat", 1, "mbsc-calendar-button", 3, "click", "ariaLabel", "disabled", "iconSvg", "theme", "themeVariant"]],
    template: function MbscCalendarNext_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, MbscCalendarNext_mbsc_button_0_Template, 1, 5, "mbsc-button", 0);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.inst);
      }
    },
    dependencies: [MbscButton, NgIf],
    encapsulation: 2
  });
  return MbscCalendarNext;
}(CalendarSubscriber);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscCalendarToday = /*#__PURE__*/function (_super) {
  __extends(MbscCalendarToday, _super);
  function MbscCalendarToday() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MbscCalendarToday.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscCalendarToday_BaseFactory;
    return function MbscCalendarToday_Factory(t) {
      return (ɵMbscCalendarToday_BaseFactory || (ɵMbscCalendarToday_BaseFactory = i0.ɵɵgetInheritedFactory(MbscCalendarToday)))(t || MbscCalendarToday);
    };
  })();
  MbscCalendarToday.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscCalendarToday,
    selectors: [["mbsc-calendar-today"]],
    hostVars: 2,
    hostBindings: function MbscCalendarToday_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.cssClass);
      }
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    decls: 1,
    vars: 1,
    consts: [["class", "mbsc-calendar-button mbsc-calendar-button-today", "variant", "flat", 3, "theme", "themeVariant", "click", 4, "ngIf"], ["variant", "flat", 1, "mbsc-calendar-button", "mbsc-calendar-button-today", 3, "click", "theme", "themeVariant"]],
    template: function MbscCalendarToday_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, MbscCalendarToday_mbsc_button_0_Template, 2, 4, "mbsc-button", 0);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.inst && (ctx.inst.s.showToday || ctx.inst.s.headerTemplate));
      }
    },
    dependencies: [MbscButton, NgIf],
    encapsulation: 2
  });
  return MbscCalendarToday;
}(CalendarSubscriber);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscCalendarNav = /*#__PURE__*/function (_super) {
  __extends(MbscCalendarNav, _super);
  function MbscCalendarNav() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MbscCalendarNav.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscCalendarNav_BaseFactory;
    return function MbscCalendarNav_Factory(t) {
      return (ɵMbscCalendarNav_BaseFactory || (ɵMbscCalendarNav_BaseFactory = i0.ɵɵgetInheritedFactory(MbscCalendarNav)))(t || MbscCalendarNav);
    };
  })();
  MbscCalendarNav.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscCalendarNav,
    selectors: [["mbsc-calendar-nav"]],
    hostAttrs: ["aria-live", "polite"],
    hostVars: 2,
    hostBindings: function MbscCalendarNav_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.cssClass);
      }
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    decls: 1,
    vars: 1,
    consts: [["pickerBtn", ""], [4, "ngIf"], ["variant", "flat", 3, "class", "theme", "themeVariant", "click", 4, "ngFor", "ngForOf"], ["variant", "flat", 3, "click", "theme", "themeVariant"], [3, "class", 4, "ngIf"], [3, "svg", "theme", "themeVariant", 4, "ngIf"], [3, "svg", "theme", "themeVariant"]],
    template: function MbscCalendarNav_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, MbscCalendarNav_ng_container_0_Template, 2, 1, "ng-container", 1);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.inst);
      }
    },
    dependencies: [MbscButton, MbscIcon, NgIf, NgForOf],
    encapsulation: 2
  });
  return MbscCalendarNav;
}(CalendarSubscriber);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscCalendarHeaderModule = /*#__PURE__*/function () {
  function MbscCalendarHeaderModule() {}
  MbscCalendarHeaderModule.ɵfac = function MbscCalendarHeaderModule_Factory(t) {
    return new (t || MbscCalendarHeaderModule)();
  };
  MbscCalendarHeaderModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MbscCalendarHeaderModule
  });
  MbscCalendarHeaderModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule, MbscButtonModule, MbscIconModule]]
  });
  return MbscCalendarHeaderModule;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscPickerModule = /*#__PURE__*/function () {
  function MbscPickerModule() {}
  MbscPickerModule.ɵfac = function MbscPickerModule_Factory(t) {
    return new (t || MbscPickerModule)();
  };
  MbscPickerModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MbscPickerModule
  });
  MbscPickerModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule]]
  });
  return MbscPickerModule;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscCalendarNavService = /*#__PURE__*/function () {
  function MbscCalendarNavService() {
    this.pageSize = 0;
    this._prevS = {};
    this._s = {};
  }
  MbscCalendarNavService.prototype.options = function (news, forcePageLoading) {
    var s = this._s = __assign(__assign({}, this._s), news);
    var prevS = this._prevS;
    var getDate = s.getDate;
    var getYear = s.getYear;
    var getMonth = s.getMonth;
    var showCalendar = s.showCalendar;
    var calendarType = s.calendarType;
    var startDay = s.startDay;
    var endDay = s.endDay;
    var firstWeekDay = s.firstDay;
    var isWeekView = calendarType === "week";
    var weeks = showCalendar ? isWeekView ? s.weeks : 6 : 0;
    var minDate = s.min !== prevS.min || !this.minDate ? !isEmpty(s.min) ? makeDate(s.min) : -Infinity : this.minDate;
    var maxDate = s.max !== prevS.max || !this.maxDate ? !isEmpty(s.max) ? makeDate(s.max) : Infinity : this.maxDate;
    var initialActive = s.activeDate || +new Date();
    var activeDate = constrain(initialActive, +minDate, +maxDate);
    var forcePageChange = this.forcePageChange || activeDate !== initialActive;
    var d = new Date(activeDate);
    var activeChanged = activeDate !== prevS.activeDate;
    var viewChanged = s.calendarType !== prevS.calendarType || s.eventRange !== prevS.eventRange || s.firstDay !== prevS.firstDay || s.eventRangeSize !== prevS.eventRangeSize || s.refDate !== prevS.refDate || showCalendar !== prevS.showCalendar || s.size !== prevS.size || s.weeks !== prevS.weeks;
    var pageIndex = forcePageChange || this.pageIndex === UNDEFINED || viewChanged || !this.preventPageChange && activeChanged && (activeDate < +this.firstDay || activeDate >= +this.lastDay) ? getPageIndex(d, s) : this.pageIndex;
    var size = calendarType === "year" ? 12 : s.size || 1;
    var isGrid = size > 1 && !isWeekView;
    var pageNr = isGrid ? 1 : getPageNr(s.pages, this.pageSize);
    var isVertical = s.calendarScroll === "vertical" && s.pages !== "auto" && (s.pages === UNDEFINED || s.pages === 1);
    var showOuter = s.showOuterDays !== UNDEFINED ? s.showOuterDays : !isVertical && pageNr < 2 && (isWeekView || !size || size < 2);
    var pageBuffer = isGrid ? 0 : 1;
    var firstDay = getFirstPageDay(pageIndex, s);
    var lastDay = getFirstPageDay(pageIndex + pageNr, s);
    if (!showCalendar && s.eventRange === "week" && startDay !== UNDEFINED && endDay !== UNDEFINED) {
      firstDay = addDays(firstDay, startDay - firstWeekDay + (startDay < firstWeekDay ? 7 : 0));
      lastDay = addDays(firstDay, 7 * s.eventRangeSize + endDay - startDay + 1 - (endDay < startDay ? 0 : 7));
    }
    var firstPageDay = showCalendar && showOuter ? getFirstDayOfWeek(firstDay, s) : firstDay;
    var lastPage = isGrid ? getDate(getYear(lastDay), getMonth(lastDay) - 1, 1) : getFirstPageDay(pageIndex + pageNr - 1, s);
    var lastPageDay = showCalendar && showOuter ? addDays(getFirstDayOfWeek(lastPage, s), weeks * 7) : lastDay;
    var start = showCalendar ? getFirstDayOfWeek(getFirstPageDay(pageIndex - pageBuffer, s), s) : firstDay;
    var last = showCalendar ? getFirstDayOfWeek(getFirstPageDay(pageIndex + pageNr + pageBuffer - 1, s), s) : lastDay;
    var end = showCalendar ? addDays(isGrid ? getFirstDayOfWeek(lastPage, s) : last, weeks * 7) : lastDay;
    var initialRun = this.pageIndex === UNDEFINED;
    var viewStart = start;
    var viewEnd = end;
    if (!showCalendar && s.resolution === "week" && (s.eventRange === "year" || s.eventRange === "month")) {
      var length_1 = endDay - startDay + 1 + (endDay < startDay ? 7 : 0);
      if (firstDay.getDay() !== startDay) {
        var weekStart = getFirstDayOfWeek(firstDay, s, startDay);
        var weekEnd = addDays(weekStart, length_1);
        viewStart = weekEnd <= firstDay ? addDays(weekStart, 7) : weekStart;
      }
      if (lastDay.getDay() !== startDay) {
        var weekStart = getFirstDayOfWeek(lastDay, s, startDay);
        var weekEnd = addDays(weekStart, length_1);
        viewEnd = weekStart > lastDay ? addDays(weekEnd, -7) : weekEnd;
      }
    }
    var pageChange = false;
    if (pageIndex !== UNDEFINED) {
      pageChange = +viewStart !== +this.viewStart || +viewEnd !== +this.viewEnd;
      this.pageIndex = pageIndex;
    }
    this.firstDay = firstDay;
    this.lastDay = lastDay;
    this.firstPageDay = firstPageDay;
    this.lastPageDay = lastPageDay;
    this.viewStart = viewStart;
    this.viewEnd = viewEnd;
    this.forcePageChange = false;
    this.preventPageChange = false;
    this.minDate = minDate;
    this.maxDate = maxDate;
    this._prevS = s;
    if (pageIndex !== UNDEFINED && (pageChange || forcePageLoading)) {
      if (pageChange && !initialRun) {
        this.pageChange();
      }
      this.pageLoading(pageChange);
    }
  };
  MbscCalendarNavService.prototype.pageChange = function () {
    if (this._s.onPageChange) {
      this._s.onPageChange({
        firstDay: this.firstPageDay,
        lastDay: this.lastPageDay,
        month: this._s.calendarType === "month" ? this.firstDay : UNDEFINED,
        type: "onPageChange",
        viewEnd: this.viewEnd,
        viewStart: this.viewStart
      });
    }
  };
  MbscCalendarNavService.prototype.pageLoading = function (viewChanged) {
    if (this._s.onPageLoading) {
      this._s.onPageLoading({
        firstDay: this.firstPageDay,
        lastDay: this.lastPageDay,
        month: this._s.calendarType === "month" ? this.firstDay : UNDEFINED,
        type: "onPageLoading",
        viewChanged: viewChanged,
        viewEnd: this.viewEnd,
        viewStart: this.viewStart
      });
    }
  };
  return MbscCalendarNavService;
}();
var CalendarBase = /*#__PURE__*/function (_super) {
  __extends(CalendarBase, _super);
  function CalendarBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._navService = new MbscCalendarNavService();
    _this._update = 0;
    _this._onDayClick = function (args) {
      var s = _this.s;
      var date = addTimezone(s, args.date);
      var d = +date;
      if (args.disabled) {
        return;
      }
      if (s.selectMultiple) {
        var tempValueRep = _this._tempValueRep;
        if (tempValueRep[d]) {
          delete tempValueRep[d];
        } else if (s.selectMax !== UNDEFINED ? Object.keys(tempValueRep).length < s.selectMax : true) {
          tempValueRep[d] = date;
        }
        _this._tempValueRep = __assign({}, tempValueRep);
      } else {
        if (!s.selectRange) {
          _this._tempValueRep = {};
        }
        _this._tempValueRep[d] = date;
      }
      _this._navService.preventPageChange = s.selectRange;
      _this._hook("onCellClick", args);
      _this._setOrUpdate();
    };
    _this._onTodayClick = function () {
      var date = new Date();
      var d = +getDateOnly(date);
      if (!_this.s.selectRange && !_this.s.selectMultiple) {
        _this._tempValueRep = {};
        _this._tempValueRep[d] = date;
        _this._setOrUpdate();
      }
    };
    _this._onActiveChange = function (args) {
      _this._navService.forcePageChange = args.pageChange;
      _this._update++;
      _this._hook("onActiveChange", args);
    };
    _this._setCal = function (cal) {
      _this._calendarView = cal;
    };
    return _this;
  }
  CalendarBase.prototype._valueEquals = function (v1, v2) {
    return dateValueEquals(v1, v2, this.s);
  };
  CalendarBase.prototype._shouldValidate = function (s, prevS) {
    return s.dataTimezone !== prevS.dataTimezone || s.displayTimezone !== prevS.displayTimezone;
  };
  CalendarBase.prototype._render = function (s, state) {
    _super.prototype._render.call(this, s, state);
    this._navService.options({
      activeDate: s.active,
      calendarType: s.calendarType,
      firstDay: s.firstDay,
      getDate: s.getDate,
      getDay: s.getDay,
      getMonth: s.getMonth,
      getYear: s.getYear,
      max: s.max,
      min: s.min,
      onPageChange: s.onPageChange,
      onPageLoading: s.onPageLoading,
      pages: s.pages,
      refDate: s.refDate,
      showCalendar: true,
      showOuterDays: s.showOuterDays,
      size: s.size,
      weeks: s.weeks
    });
  };
  CalendarBase.prototype._copy = function (value) {
    return __assign({}, value);
  };
  CalendarBase.prototype._format = function (value) {
    var s = this.s;
    var ret = [];
    for (var i in value) {
      if (value[i] !== UNDEFINED && value[i] !== null) {
        ret.push(formatDate(s.dateFormat, new Date(+value[i]), s));
      }
    }
    return s.selectMultiple || s.selectRange ? ret.join(", ") : ret[0];
  };
  CalendarBase.prototype._parse = function (value) {
    var s = this.s;
    var isRange = s.selectRange;
    var ret = {};
    var values = [];
    if (isString(value)) {
      values = value.split(",");
    } else if (isArray(value)) {
      values = value;
    } else if (value && !isArray(value)) {
      values = [value];
    }
    for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
      var val = values_1[_i];
      if (val !== null) {
        var date = makeDate(val, s, s.dateFormat);
        var key = isRange ? +date : +getDateOnly(date);
        ret[key] = date;
      }
    }
    return ret;
  };
  CalendarBase.prototype._get = function (value) {
    var s = this.s;
    var isRange = s.selectRange;
    if (this.s.selectMultiple || isRange) {
      var valueArray = [];
      for (var _i = 0, _a = Object.keys(value); _i < _a.length; _i++) {
        var v = _a[_i];
        valueArray.push(createDate(s, +value[v]));
      }
      return valueArray;
    }
    var valueKeys = Object.keys(value || {});
    if (!valueKeys.length) {
      return null;
    }
    return createDate(s, value[valueKeys[0]]);
  };
  CalendarBase.defaults = __assign(__assign({}, calendarViewDefaults), {
    calendarScroll: "horizontal",
    calendarType: "month",
    selectedText: "{count} selected",
    showControls: true,
    showOnClick: true,
    weeks: 1
  });
  CalendarBase._name = "Calendar";
  CalendarBase.ɵfac = /* @__PURE__ */(() => {
    let ɵCalendarBase_BaseFactory;
    return function CalendarBase_Factory(t) {
      return (ɵCalendarBase_BaseFactory || (ɵCalendarBase_BaseFactory = i0.ɵɵgetInheritedFactory(CalendarBase)))(t || CalendarBase);
    };
  })();
  CalendarBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: CalendarBase,
    selectors: [["", "mbsc-sc-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return CalendarBase;
}(PickerBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var CalendarDayBase = /*#__PURE__*/function (_super) {
  __extends(CalendarDayBase, _super);
  function CalendarDayBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._onClick = function (ev) {
      _this._cellClick("onDayClick", ev);
    };
    _this._onRightClick = function (ev) {
      _this._cellClick("onDayRightClick", ev);
    };
    _this._onLabelClick = function (args) {
      _this._labelClick("onLabelClick", args);
    };
    _this._onLabelDoubleClick = function (args) {
      _this._labelClick("onLabelDoubleClick", args);
    };
    _this._onLabelRightClick = function (args) {
      _this._labelClick("onLabelRightClick", args);
    };
    _this._onLabelHoverIn = function (args) {
      _this._labelClick("onLabelHoverIn", args);
    };
    _this._onLabelHoverOut = function (args) {
      _this._labelClick("onLabelHoverOut", args);
    };
    return _this;
  }
  CalendarDayBase.prototype._mounted = function () {
    var _this = this;
    var allowCreate;
    var allowStart;
    var touchTimer;
    this._unlisten = gestureListener(this._el, {
      click: true,
      onBlur: function () {
        _this.setState({
          hasFocus: false
        });
      },
      onDoubleClick: function (args) {
        var s = _this.s;
        if (s.clickToCreate && s.clickToCreate !== "single" && s.labels && !s.disabled && s.display) {
          _this._hook("onLabelUpdateStart", args);
          _this._hook("onLabelUpdateEnd", args);
        }
        _this._cellClick("onDayDoubleClick", args.domEvent);
      },
      onEnd: function (args) {
        if (allowCreate) {
          args.domEvent.preventDefault();
          _this._hook("onLabelUpdateEnd", args);
          allowCreate = false;
        }
        clearTimeout(touchTimer);
        allowCreate = false;
        allowStart = false;
      },
      onFocus: function () {
        _this.setState({
          hasFocus: true
        });
      },
      onHoverIn: function (ev) {
        var s = _this.s;
        if (!s.disabled) {
          _this.setState({
            hasHover: true
          });
        }
        _this._hook("onHoverIn", {
          date: new Date(s.date),
          domEvent: ev,
          hidden: !s.display,
          outer: s.outer,
          target: _this._el
        });
      },
      onHoverOut: function (ev) {
        var s = _this.s;
        _this.setState({
          hasHover: false
        });
        _this._hook("onHoverOut", {
          date: new Date(s.date),
          domEvent: ev,
          hidden: !s.display,
          outer: s.outer,
          target: _this._el
        });
      },
      onKeyDown: function (ev) {
        switch (ev.keyCode) {
          case ENTER:
          case SPACE:
            ev.preventDefault();
            _this._onClick(ev);
            break;
        }
      },
      onMove: function (args) {
        if (allowCreate && _this.s.dragToCreate) {
          args.domEvent.preventDefault();
          _this._hook("onLabelUpdateMove", args);
        } else if (allowStart && _this.s.dragToCreate && (Math.abs(args.deltaX) > 7 || Math.abs(args.deltaY) > 7)) {
          allowCreate = !args.isTouch;
          _this._hook("onLabelUpdateStart", args);
        } else {
          clearTimeout(touchTimer);
        }
      },
      onStart: function (args) {
        var s = _this.s;
        args.create = true;
        if (!s.disabled && (s.dragToCreate || s.clickToCreate) && s.labels && !allowCreate) {
          var label = closest(args.domEvent.target, ".mbsc-calendar-text", _this._el);
          if (!label) {
            if (args.isTouch && s.dragToCreate) {
              touchTimer = setTimeout(function () {
                _this._hook("onLabelUpdateStart", args);
                _this._hook("onLabelUpdateModeOn", args);
                allowCreate = true;
              }, 350);
            } else if (s.clickToCreate === "single") {
              _this._hook("onLabelUpdateStart", args);
              allowCreate = true;
            } else {
              allowStart = !args.isTouch;
            }
          }
        }
      }
    });
  };
  CalendarDayBase.prototype._render = function (s, state) {
    var now = createDate(s);
    var d = s.date;
    var colors = s.colors,
      display = s.display,
      dragData = s.dragData,
      hoverEnd = s.hoverEnd,
      hoverStart = s.hoverStart,
      labels = s.labels,
      rangeEnd = s.rangeEnd,
      rangeStart = s.rangeStart;
    var date = new Date(d);
    var dateKey = getDateStr(date);
    var isToday = isSameDay(now, date);
    var events = labels && labels.events;
    var color = colors && colors[0];
    var background = color && color.background;
    var highlight = color && color.highlight;
    var cellClass = "";
    var highlightClass = "";
    this._draggedLabel = dragData && dragData.draggedDates && dragData.draggedDates[dateKey];
    this._draggedLabelOrig = dragData && dragData.originDates && dragData.originDates[dateKey];
    this._todayClass = isToday ? " mbsc-calendar-today" : "";
    this._cellStyles = background && display ? {
      backgroundColor: background,
      color: getTextColor(background)
    } : UNDEFINED;
    this._circleStyles = highlight ? {
      backgroundColor: highlight,
      color: getTextColor(color.highlight)
    } : UNDEFINED;
    this._ariaLabel = s.type === "day" ? (isToday ? s.todayText + ", " : "") + s.day + ", " + s.month + " " + s.text + ", " + s.year : s.type === "month" ? s.month : "";
    if (display) {
      if (rangeStart && d >= rangeStart && d <= (rangeEnd || rangeStart) || rangeEnd && d <= rangeEnd && d >= (rangeStart || rangeEnd)) {
        highlightClass = " mbsc-range-day" + (d === (rangeStart || rangeEnd) ? " mbsc-range-day-start" : "") + (d === (rangeEnd || rangeStart) ? " mbsc-range-day-end" : "");
      }
      if (hoverStart && hoverEnd && d >= hoverStart && d <= hoverEnd) {
        highlightClass += " mbsc-range-hover" + (d === hoverStart ? " mbsc-range-hover-start mbsc-hover" : "") + (d === hoverEnd ? " mbsc-range-hover-end mbsc-hover" : "");
      }
    }
    if (s.marks) {
      s.marks.forEach(function (e) {
        cellClass += e.cellCssClass ? " " + e.cellCssClass : "";
      });
    }
    if (colors) {
      colors.forEach(function (e) {
        cellClass += e.cellCssClass ? " " + e.cellCssClass : "";
      });
    }
    if (events) {
      events.forEach(function (e) {
        cellClass += e.cellCssClass ? " " + e.cellCssClass : "";
      });
    }
    this._cssClass = "mbsc-calendar-cell mbsc-flex-1-0-0 mbsc-calendar-" + s.type + this._theme + this._rtl + this._hb + cellClass + (labels ? " mbsc-calendar-day-labels" : "") + (colors ? " mbsc-calendar-day-colors" : "") + (s.outer ? " mbsc-calendar-day-outer" : "") + (s.hasMarks ? " mbsc-calendar-day-marked" : "") + (s.disabled ? " mbsc-disabled" : "") + (display ? "" : " mbsc-calendar-day-empty") + (s.selected ? " mbsc-selected" : "") + (state.hasFocus ? " mbsc-focus" : "") + (state.hasHover && (d === hoverStart || d === hoverEnd || !hoverStart && !hoverEnd) ? " mbsc-hover" : "") + (this._draggedLabel ? " mbsc-calendar-day-highlight" : "") + highlightClass;
    this._data = {
      date: date,
      events: s.events || [],
      selected: s.selected
    };
  };
  CalendarDayBase.prototype._destroy = function () {
    if (this._unlisten) {
      this._unlisten();
    }
  };
  CalendarDayBase.prototype._cellClick = function (name, domEvent) {
    var s = this.s;
    if (s.display) {
      this._hook(name, {
        date: new Date(s.date),
        disabled: s.disabled,
        domEvent: domEvent,
        outer: s.outer,
        selected: s.selected,
        source: "calendar",
        target: this._el
      });
    }
  };
  CalendarDayBase.prototype._labelClick = function (name, args) {
    var s = this.s;
    args.date = new Date(s.date);
    args.labels = s.labels.events;
    this._hook(name, args);
  };
  CalendarDayBase.ɵfac = /* @__PURE__ */(() => {
    let ɵCalendarDayBase_BaseFactory;
    return function CalendarDayBase_Factory(t) {
      return (ɵCalendarDayBase_BaseFactory || (ɵCalendarDayBase_BaseFactory = i0.ɵɵgetInheritedFactory(CalendarDayBase)))(t || CalendarDayBase);
    };
  })();
  CalendarDayBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: CalendarDayBase,
    selectors: [["", "mbsc-calday-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return CalendarDayBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var stateObservables = {};
var CalendarLabelBase = /*#__PURE__*/function (_super) {
  __extends(CalendarLabelBase, _super);
  function CalendarLabelBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._onClick = function (ev) {
      if (_this._isDrag) {
        ev.stopPropagation();
      } else {
        _this._triggerEvent("onClick", ev);
        var s = _this.s;
        var observable = stateObservables[s.id];
        if (observable && s.selected) {
          observable.next({
            hasFocus: false
          });
        }
      }
    };
    _this._onRightClick = function (ev) {
      _this._triggerEvent("onRightClick", ev);
    };
    _this._onDocTouch = function (ev) {
      unlisten(_this._doc, TOUCH_START, _this._onDocTouch);
      unlisten(_this._doc, MOUSE_DOWN, _this._onDocTouch);
      _this._isDrag = false;
      _this._hook("onDragModeOff", {
        domEvent: ev,
        event: _this.s.event
      });
    };
    _this._updateState = function (args) {
      if (_this.s.showText) {
        _this.setState(args);
      }
    };
    _this._triggerEvent = function (name, ev) {
      _this._hook(name, {
        domEvent: ev,
        label: _this.s.event,
        target: _this._el
      });
    };
    return _this;
  }
  CalendarLabelBase.prototype._mounted = function () {
    var _this = this;
    var opt = this.s;
    var el = this._el;
    var id = opt.id;
    var isPicker = opt.isPicker;
    var resizeDir;
    var observable = stateObservables[id];
    if (!observable) {
      observable = new Observable();
      stateObservables[id] = observable;
    }
    this._unsubscribe = observable.subscribe(this._updateState);
    this._doc = getDocument(el);
    this._unlisten = gestureListener(el, {
      keepFocus: true,
      onBlur: function () {
        if (!isPicker) {
          observable.next({
            hasFocus: false
          });
        }
      },
      onDoubleClick: function (ev) {
        ev.domEvent.stopPropagation();
        _this._hook("onDoubleClick", {
          domEvent: ev.domEvent,
          label: _this.s.event,
          target: el
        });
      },
      onEnd: function (ev) {
        if (_this._isDrag) {
          var s = _this.s;
          var args = __assign({}, ev);
          args.domEvent.preventDefault();
          args.event = s.event;
          if (s.resize && resizeDir) {
            args.resize = true;
            args.direction = resizeDir;
          } else if (s.drag) {
            args.drag = true;
          }
          _this._hook("onDragEnd", args);
          if (!s.isUpdate) {
            _this._isDrag = false;
          }
          if (el && args.moved) {
            el.blur();
          }
        }
        clearTimeout(_this._touchTimer);
        resizeDir = UNDEFINED;
      },
      onFocus: function () {
        if (!isPicker) {
          observable.next({
            hasFocus: true
          });
        }
      },
      onHoverIn: function (ev) {
        if (_this._isDrag || isPicker) {
          return;
        }
        observable.next({
          hasHover: true
        });
        _this._triggerEvent("onHoverIn", ev);
      },
      onHoverOut: function (ev) {
        observable.next({
          hasHover: false
        });
        _this._triggerEvent("onHoverOut", ev);
      },
      onKeyDown: function (ev) {
        var event = _this.s.event;
        switch (ev.keyCode) {
          case ENTER:
          case SPACE:
            el.click();
            ev.preventDefault();
            break;
          case BACKSPACE:
          case DELETE:
            if (event && event.editable !== false) {
              _this._hook("onDelete", {
                domEvent: ev,
                event: event,
                source: "calendar"
              });
            }
            break;
        }
      },
      onMove: function (ev) {
        var s = _this.s;
        var args = __assign({}, ev);
        args.event = s.event;
        if (resizeDir) {
          args.resize = true;
          args.direction = resizeDir;
        } else if (s.drag) {
          args.drag = true;
        } else {
          return;
        }
        if (!s.event || s.event.editable === false) {
          return;
        }
        if (_this._isDrag) {
          args.domEvent.preventDefault();
          _this._hook("onDragMove", args);
        } else if (Math.abs(args.deltaX) > 7 || Math.abs(args.deltaY) > 7) {
          clearTimeout(_this._touchTimer);
          if (!args.isTouch) {
            _this._isDrag = true;
            _this._hook("onDragStart", args);
          }
        }
      },
      onStart: function (ev) {
        var s = _this.s;
        var args = __assign({}, ev);
        var target = args.domEvent.target;
        args.event = s.event;
        if (s.resize && target.classList.contains("mbsc-calendar-label-resize")) {
          resizeDir = target.classList.contains("mbsc-calendar-label-resize-start") ? "start" : "end";
          args.resize = true;
          args.direction = resizeDir;
        } else if (s.drag) {
          args.drag = true;
        } else {
          return;
        }
        if (!s.event || s.event.editable === false) {
          return;
        }
        if (_this._isDrag || !args.isTouch) {
          args.domEvent.stopPropagation();
        }
        if (_this._isDrag) {
          _this._hook("onDragStart", args);
        } else if (args.isTouch) {
          _this._touchTimer = setTimeout(function () {
            _this._hook("onDragModeOn", args);
            _this._hook("onDragStart", args);
            _this._isDrag = true;
          }, 350);
        }
      }
    });
    if (this._isDrag) {
      listen(this._doc, TOUCH_START, this._onDocTouch);
      listen(this._doc, MOUSE_DOWN, this._onDocTouch);
    }
  };
  CalendarLabelBase.prototype._destroy = function () {
    if (this._el) {
      this._el.blur();
    }
    if (this._unsubscribe) {
      var id = this.s.id;
      var observable = stateObservables[id];
      if (observable) {
        observable.unsubscribe(this._unsubscribe);
        if (!observable.nr) {
          delete stateObservables[id];
        }
      }
    }
    if (this._unlisten) {
      this._unlisten();
    }
    unlisten(this._doc, TOUCH_START, this._onDocTouch);
    unlisten(this._doc, MOUSE_DOWN, this._onDocTouch);
  };
  CalendarLabelBase.prototype._render = function (s, state) {
    var event = s.event;
    var d = new Date(s.date);
    var render = s.render || s.renderContent;
    var start;
    var end;
    var isMultiDay = false;
    var isStart;
    var isEnd;
    var isEndStyle;
    var text;
    this._isDrag = this._isDrag || s.isUpdate;
    this._content = UNDEFINED;
    this._title = s.more || s.count || !s.showEventTooltip ? UNDEFINED : htmlToText(event.tooltip || event.title || event.text);
    this._tabIndex = s.isActiveMonth && s.showText && !s.count && !s.isPicker ? 0 : -1;
    if (event) {
      var allDay = event.allDay;
      var tzOpt = allDay ? UNDEFINED : s;
      start = event.start ? makeDate(event.start, tzOpt) : null;
      end = event.end ? makeDate(event.end, tzOpt) : null;
      var endTime = start && end && getEndDate(s, allDay, start, end, true);
      var firstDayOfWeek = getFirstDayOfWeek(d, s);
      var lastDayOfWeek = addDays(firstDayOfWeek, 7);
      var lastDay = s.lastDay && s.lastDay < lastDayOfWeek ? s.lastDay : lastDayOfWeek;
      isMultiDay = start && endTime && !isSameDay(start, endTime);
      isStart = !isMultiDay || start && isSameDay(start, d);
      isEnd = !isMultiDay || endTime && isSameDay(endTime, d);
      isEndStyle = !isMultiDay || (s.showText ? endTime < lastDay : isEnd);
      this._hasResizeStart = s.resize && isStart;
      this._hasResizeEnd = s.resize && isEndStyle;
      var color = event.color;
      if (!color && event.resource && s.resourcesMap) {
        var resource = s.resourcesMap[isArray(event.resource) ? event.resource[0] : event.resource];
        color = resource && resource.color;
      }
      if (s.showText) {
        this._textColor = color ? getTextColor(color) : UNDEFINED;
      }
      this._color = s.render || s.template ? UNDEFINED : event.textColor && !color ? "transparent" : color;
    }
    if (event && s.showText && (render || s.contentTemplate || s.template)) {
      var fillsAllDay = event.allDay || !start || isMultiDay && !isStart && !isEnd;
      this._data = {
        end: !fillsAllDay && isEnd && end ? formatDate(s.timeFormat, end, s) : "",
        id: event.id,
        isMultiDay: isMultiDay,
        original: event,
        start: !fillsAllDay && isStart && start ? formatDate(s.timeFormat, start, s) : "",
        title: this._title
      };
      if (render) {
        var content = render(this._data);
        if (isString(content)) {
          text = content;
        } else {
          this._content = content;
        }
      }
    } else {
      text = s.more || s.count || (s.showText ? event.title || event.text || "" : "");
    }
    if (text !== this._text) {
      this._text = text;
      this._html = text ? this._safeHtml(text) : UNDEFINED;
      this._shouldEnhance = text && event && s.showText && !!render;
    }
    this._cssClass = "mbsc-calendar-text" + this._theme + this._rtl + (state.hasFocus && !s.inactive && !s.selected || s.selected && s.showText ? " mbsc-calendar-label-active " : "") + (state.hasHover && !s.inactive && !this._isDrag ? " mbsc-calendar-label-hover" : "") + (s.more ? " mbsc-calendar-text-more" : s.render || s.template ? " mbsc-calendar-custom-label" : " mbsc-calendar-label") + (s.inactive ? " mbsc-calendar-label-inactive" : "") + (s.isUpdate ? " mbsc-calendar-label-dragging" : "") + (s.hidden ? " mbsc-calendar-label-hidden" : "") + (isStart ? " mbsc-calendar-label-start" : "") + (isEndStyle ? " mbsc-calendar-label-end" : "") + (event && event.editable === false ? " mbsc-readonly-event" : "") + (event && event.cssClass ? " " + event.cssClass : "");
  };
  CalendarLabelBase.ɵfac = /* @__PURE__ */(() => {
    let ɵCalendarLabelBase_BaseFactory;
    return function CalendarLabelBase_Factory(t) {
      return (ɵCalendarLabelBase_BaseFactory || (ɵCalendarLabelBase_BaseFactory = i0.ɵɵgetInheritedFactory(CalendarLabelBase)))(t || CalendarLabelBase);
    };
  })();
  CalendarLabelBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: CalendarLabelBase,
    selectors: [["", "mbsc-callbl-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return CalendarLabelBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var CalendarViewBase = /*#__PURE__*/function (_super) {
  __extends(CalendarViewBase, _super);
  function CalendarViewBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      height: "sm",
      pageSize: 0,
      pickerSize: 0,
      width: "sm"
    };
    _this._dim = {};
    _this._months = [1, 2, 3];
    _this._title = [];
    _this.PAGE_VIEW = PAGE_VIEW;
    _this.MONTH_VIEW = MONTH_VIEW;
    _this.YEAR_VIEW = YEAR_VIEW;
    _this.MULTI_YEAR_VIEW = MULTI_YEAR_VIEW;
    _this.nextPage = function () {
      _this._prevDocClick();
      switch (_this._view) {
        case MONTH_VIEW:
          _this._activeMonthChange(1);
          break;
        case MULTI_YEAR_VIEW:
          _this._activeYearsChange(1);
          break;
        case YEAR_VIEW:
          _this._activeYearChange(1);
          break;
        default:
          _this._activeChange(1);
      }
    };
    _this.prevPage = function () {
      _this._prevDocClick();
      switch (_this._view) {
        case MONTH_VIEW:
          _this._activeMonthChange(-1);
          break;
        case MULTI_YEAR_VIEW:
          _this._activeYearsChange(-1);
          break;
        case YEAR_VIEW:
          _this._activeYearChange(-1);
          break;
        default:
          _this._activeChange(-1);
      }
    };
    _this._changeView = function (newView) {
      var s = _this.s;
      var view = _this._view;
      var hasPicker = _this._hasPicker;
      var selectView = s.selectView;
      var navView = s.navView;
      var isYearView = s.showCalendar && s.calendarType === "year";
      if (!newView) {
        switch (view) {
          case PAGE_VIEW:
            newView = navView || (isYearView ? MULTI_YEAR_VIEW : YEAR_VIEW);
            break;
          case MONTH_VIEW:
            newView = YEAR_VIEW;
            break;
          case MULTI_YEAR_VIEW:
            newView = isYearView || navView === MULTI_YEAR_VIEW ? PAGE_VIEW : YEAR_VIEW;
            break;
          default:
            newView = hasPicker && navView === YEAR_VIEW || selectView === YEAR_VIEW || _this._prevView !== MULTI_YEAR_VIEW ? MULTI_YEAR_VIEW : navView === MONTH_VIEW ? MONTH_VIEW : PAGE_VIEW;
        }
        if (selectView === MULTI_YEAR_VIEW || navView === MULTI_YEAR_VIEW) {
          newView = MULTI_YEAR_VIEW;
        }
      }
      if (view === PAGE_VIEW) {
        _this._activeMonth = _this._active;
      }
      var skipAnimation = hasPicker && newView === selectView;
      _this._prevView = view;
      _this.setState({
        view: newView,
        viewClosing: skipAnimation ? UNDEFINED : view,
        viewOpening: skipAnimation ? UNDEFINED : newView
      });
    };
    _this._onDayHoverIn = function (ev) {
      if (!_this._disableHover) {
        _this._hook("onDayHoverIn", ev);
        _this._hoverTimer = setTimeout(function () {
          var key = getDateStr(ev.date);
          if (_this._labels) {
            ev.labels = _this._labels[key];
          }
          if (_this._marked) {
            ev.marked = _this._marked[key];
          }
          _this._isHover = true;
          _this._hook("onCellHoverIn", ev);
        }, 150);
      }
    };
    _this._onDayHoverOut = function (ev) {
      if (!_this._disableHover) {
        _this._hook("onDayHoverOut", ev);
        clearTimeout(_this._hoverTimer);
        if (_this._isHover) {
          var key = getDateStr(ev.date);
          if (_this._labels) {
            ev.labels = _this._labels[key];
          }
          if (_this._marked) {
            ev.marked = _this._marked[key];
          }
          _this._isHover = false;
          _this._hook("onCellHoverOut", ev);
        }
      }
    };
    _this._onLabelClick = function (args) {
      _this._isLabelClick = true;
      _this._hook("onLabelClick", args);
    };
    _this._onDayClick = function (args) {
      _this._shouldFocus = !_this._isLabelClick;
      _this._prevAnim = false;
      _this._isLabelClick = false;
      _this._hook("onDayClick", args);
    };
    _this._onTodayClick = function (args) {
      _this._prevAnim = false;
      _this._hook("onActiveChange", {
        date: +removeTimezone(createDate(_this.s)),
        today: true
      });
      _this._hook("onTodayClick", {});
    };
    _this._onNavDayClick = function (args) {
      if (args.disabled) {
        return;
      }
      var d = args.date;
      var s = _this.s;
      var newIndex = getPageIndex(d, s);
      _this._prevDocClick();
      _this._changeView(PAGE_VIEW);
      _this._shouldFocus = true;
      _this._prevAnim = !_this._hasPicker;
      _this._hook("onActiveChange", {
        date: +d,
        nav: true,
        pageChange: newIndex !== _this._pageIndex,
        today: true
      });
    };
    _this._onMonthClick = function (args) {
      if (args.disabled) {
        return;
      }
      var s = _this.s;
      var d = new Date(args.date);
      if (s.selectView === YEAR_VIEW) {
        _this._hook("onDayClick", args);
      } else {
        _this._prevDocClick();
        _this._shouldFocus = true;
        _this._prevAnim = !_this._hasPicker;
        _this._activeMonth = +d;
        if (s.navView === YEAR_VIEW || s.navView === UNDEFINED) {
          var newIndex = getPageIndex(d, s);
          _this._changeView(PAGE_VIEW);
          _this._hook("onActiveChange", {
            date: +d,
            nav: true,
            pageChange: newIndex !== _this._pageIndex,
            today: true
          });
        } else {
          _this._changeView(MONTH_VIEW);
        }
      }
    };
    _this._onYearClick = function (args) {
      if (args.disabled) {
        return;
      }
      var d = args.date;
      var s = _this.s;
      var view = s.selectView;
      if (view === MULTI_YEAR_VIEW) {
        _this._hook("onDayClick", args);
      } else {
        _this._shouldFocus = true;
        _this._prevAnim = view === YEAR_VIEW;
        _this._activeMonth = +d;
        _this._prevDocClick();
        if (s.navView === MULTI_YEAR_VIEW || s.calendarType === "year") {
          var newIndex = getPageIndex(d, s);
          _this._changeView(PAGE_VIEW);
          _this._hook("onActiveChange", {
            date: +d,
            pageChange: newIndex !== _this._pageIndex,
            today: true
          });
        } else {
          _this._changeView(YEAR_VIEW);
        }
      }
    };
    _this._onPageChange = function (args) {
      _this._isSwipeChange = true;
      _this._activeChange(args.diff);
    };
    _this._onMonthPageChange = function (args) {
      _this._activeMonthChange(args.diff);
    };
    _this._onYearPageChange = function (args) {
      _this._activeYearChange(args.diff);
    };
    _this._onYearsPageChange = function (args) {
      _this._activeYearsChange(args.diff);
    };
    _this._onAnimationEnd = function (args) {
      _this._disableHover = false;
      if (_this._isIndexChange) {
        _this._pageLoaded();
        _this._isIndexChange = false;
      }
    };
    _this._onStart = function () {
      clearTimeout(_this._hoverTimer);
    };
    _this._onGestureStart = function (args) {
      _this._disableHover = true;
      _this._hook("onGestureStart", args);
    };
    _this._onGestureEnd = function (args) {
      _this._prevDocClick();
    };
    _this._onPickerClose = function () {
      _this.setState({
        view: PAGE_VIEW
      });
    };
    _this._onPickerOpen = function () {
      var pageHeight = _this._pickerCont.clientHeight;
      var pageWidth = _this._pickerCont.clientWidth;
      _this.setState({
        pickerSize: _this._isVertical ? pageHeight : pageWidth
      });
    };
    _this._onPickerBtnClick = function (ev) {
      if (_this._view === PAGE_VIEW) {
        _this._pickerBtn = ev.currentTarget;
      }
      _this._prevDocClick();
      _this._changeView();
    };
    _this._onDocClick = function () {
      var view = _this.s.selectView;
      if (!_this._prevClick && !_this._hasPicker && _this._view !== view) {
        _this._changeView(view);
      }
    };
    _this._onViewAnimationEnd = function () {
      if (_this.state.viewClosing) {
        _this.setState({
          viewClosing: UNDEFINED
        });
      }
      if (_this.state.viewOpening) {
        _this.setState({
          viewOpening: UNDEFINED
        });
      }
    };
    _this._onResize = function () {
      if (!_this._body || !isBrowser) {
        return;
      }
      var s = _this.s;
      var state = _this.state;
      var showCalendar = s.showCalendar;
      var body = showCalendar ? _this._body.querySelector(".mbsc-calendar-body-inner") : _this._body;
      var totalWidth = _this._el.offsetWidth;
      var totalHeight = _this._el.offsetHeight;
      var pageHeight = body.clientHeight;
      var pageWidth = body.clientWidth;
      var pageSize = _this._isVertical ? pageHeight : pageWidth;
      var pickerSize = _this._hasPicker ? state.pickerSize : pageSize;
      var ready = showCalendar !== UNDEFINED;
      var width = "sm";
      var height = "sm";
      var maxLabels = UNDEFINED;
      var hasScrollY = false;
      var cellTextHeight = 0;
      var labelHeight = 0;
      if (s.responsiveStyle && !_this._isGrid) {
        if (pageHeight > 300) {
          height = "md";
        }
        if (pageWidth > 767) {
          width = "md";
        }
      }
      if (width !== state.width || height !== state.height) {
        _this._shouldCheckSize = true;
        _this.setState({
          width: width,
          height: height
        });
      } else {
        if (_this._labels && showCalendar) {
          var placeholder = body.querySelector(".mbsc-calendar-text");
          var cell = body.querySelector(".mbsc-calendar-day-inner");
          var labelsCont = cell.querySelector(".mbsc-calendar-labels");
          var txtMargin = placeholder ? getDimension(placeholder, "marginBottom") : 2;
          var txtHeight = placeholder ? placeholder.offsetHeight : 18;
          cellTextHeight = labelsCont.offsetTop;
          hasScrollY = body.scrollHeight > body.clientHeight;
          labelHeight = txtHeight + txtMargin;
          maxLabels = Math.max(1, floor((cell.clientHeight - cellTextHeight) / labelHeight));
        }
        _this._hook("onResize", {
          height: totalHeight,
          target: _this._el,
          width: totalWidth
        });
        s.navService.pageSize = pageSize;
        var update = _this._shouldPageLoad ? (state.update || 0) + 1 : state.update;
        _this.setState({
          cellTextHeight: cellTextHeight,
          hasScrollY: hasScrollY,
          labelHeight: labelHeight,
          maxLabels: maxLabels,
          pageSize: pageSize,
          pickerSize: pickerSize,
          ready: ready,
          update: update
        });
      }
    };
    _this._onKeyDown = function (ev) {
      var s = _this.s;
      var view = _this._view;
      var active = view === PAGE_VIEW ? _this._active : _this._activeMonth;
      var activeDate = new Date(active);
      var year = s.getYear(activeDate);
      var month = s.getMonth(activeDate);
      var day = s.getDay(activeDate);
      var getDate = s.getDate;
      var weeks = s.weeks;
      var isMonthView = s.calendarType === "month";
      var newDate;
      if (view === MULTI_YEAR_VIEW) {
        var newYear = void 0;
        switch (ev.keyCode) {
          case LEFT_ARROW:
            newYear = year - 1 * _this._rtlNr;
            break;
          case RIGHT_ARROW:
            newYear = year + 1 * _this._rtlNr;
            break;
          case UP_ARROW:
            newYear = year - 3;
            break;
          case DOWN_ARROW:
            newYear = year + 3;
            break;
          case HOME:
            newYear = _this._getPageYears(_this._yearsIndex);
            break;
          case END:
            newYear = _this._getPageYears(_this._yearsIndex) + 11;
            break;
          case PAGE_UP:
            newYear = year - 12;
            break;
          case PAGE_DOWN:
            newYear = year + 12;
            break;
        }
        if (newYear && _this._minYears <= newYear && _this._maxYears >= newYear) {
          ev.preventDefault();
          _this._shouldFocus = true;
          _this._prevAnim = false;
          _this._activeMonth = +getDate(newYear, 0, 1);
          _this.forceUpdate();
        }
      } else if (view === YEAR_VIEW) {
        switch (ev.keyCode) {
          case LEFT_ARROW:
            newDate = getDate(year, month - 1 * _this._rtlNr, 1);
            break;
          case RIGHT_ARROW:
            newDate = getDate(year, month + 1 * _this._rtlNr, 1);
            break;
          case UP_ARROW:
            newDate = getDate(year, month - 3, 1);
            break;
          case DOWN_ARROW:
            newDate = getDate(year, month + 3, 1);
            break;
          case HOME:
            newDate = getDate(year, 0, 1);
            break;
          case END:
            newDate = getDate(year, 11, 1);
            break;
          case PAGE_UP:
            newDate = getDate(year - 1, month, 1);
            break;
          case PAGE_DOWN:
            newDate = getDate(year + 1, month, 1);
            break;
        }
        if (newDate && _this._minYear <= newDate && _this._maxYear >= newDate) {
          ev.preventDefault();
          _this._shouldFocus = true;
          _this._prevAnim = false;
          _this._activeMonth = +newDate;
          _this.forceUpdate();
        }
      } else {
        switch (ev.keyCode) {
          case LEFT_ARROW:
            newDate = getDate(year, month, day - 1 * _this._rtlNr);
            break;
          case RIGHT_ARROW:
            newDate = getDate(year, month, day + 1 * _this._rtlNr);
            break;
          case UP_ARROW:
            newDate = getDate(year, month, day - 7);
            break;
          case DOWN_ARROW:
            newDate = getDate(year, month, day + 7);
            break;
          case HOME:
            newDate = getDate(year, month, 1);
            break;
          case END:
            newDate = getDate(year, month + 1, 0);
            break;
          case PAGE_UP:
            newDate = ev.altKey ? getDate(year - 1, month, day) : isMonthView ? getDate(year, month - 1, day) : getDate(year, month, day - weeks * 7);
            break;
          case PAGE_DOWN:
            newDate = ev.altKey ? getDate(year + 1, month, day) : isMonthView ? getDate(year, month + 1, day) : getDate(year, month, day + weeks * 7);
            break;
        }
        if (newDate && _this._minDate <= newDate && _this._maxDate >= newDate) {
          ev.preventDefault();
          var newIndex = getPageIndex(newDate, s);
          _this._shouldFocus = true;
          _this._prevAnim = false;
          if (view === MONTH_VIEW) {
            _this._activeMonth = +newDate;
            _this.forceUpdate();
          } else {
            _this._pageChange = s.noOuterChange && newIndex !== _this._pageIndex;
            _this._hook("onActiveChange", {
              date: +newDate,
              pageChange: _this._pageChange
            });
          }
        }
      }
    };
    _this._setHeader = function (el) {
      _this._headerElement = el;
    };
    _this._setBody = function (el) {
      _this._body = el;
    };
    _this._setPickerCont = function (el) {
      _this._pickerCont = el;
    };
    return _this;
  }
  CalendarViewBase.prototype._getPageDay = function (pageIndex) {
    return +getFirstPageDay(pageIndex, this.s);
  };
  CalendarViewBase.prototype._getPageStyle = function (index, offset, pageIndex, pageNr) {
    var _a;
    return _a = {}, _a[(jsPrefix ? jsPrefix + "T" : "t") + "ransform"] = "translate" + this._axis + "(" + (index - offset) * 100 * this._rtlNr + "%)", _a.position = index === pageIndex ? "relative" : "", _a.width = 100 / (pageNr || 1) + "%", _a;
  };
  CalendarViewBase.prototype._getPageMonth = function (pageIndex) {
    var s = this.s;
    var refDate = s.refDate ? makeDate(s.refDate) : REF_DATE;
    var year = s.getYear(refDate);
    var month = s.getMonth(refDate);
    return +s.getDate(year, month + pageIndex, 1);
  };
  CalendarViewBase.prototype._getPageYear = function (pageIndex) {
    var s = this.s;
    var refDate = s.refDate ? makeDate(s.refDate) : REF_DATE;
    var year = s.getYear(refDate);
    return year + pageIndex;
  };
  CalendarViewBase.prototype._getPageYears = function (pageIndex) {
    var s = this.s;
    var refDate = s.refDate ? makeDate(s.refDate) : REF_DATE;
    var year = s.getYear(refDate);
    return year + pageIndex * 12;
  };
  CalendarViewBase.prototype._getPickerClass = function (view) {
    var animName;
    var pickerName = view === this.s.selectView ? " mbsc-calendar-picker-main" : "";
    var baseName = "mbsc-calendar-picker";
    var hasPicker = this._hasPicker;
    var _a = this.state,
      viewClosing = _a.viewClosing,
      viewOpening = _a.viewOpening;
    switch (view) {
      case PAGE_VIEW:
        animName = hasPicker ? "" : (viewOpening === PAGE_VIEW ? "in-down" : "") + (viewClosing === PAGE_VIEW ? "out-down" : "");
        break;
      case MONTH_VIEW:
        animName = hasPicker && viewClosing === PAGE_VIEW ? "" : (viewOpening === MONTH_VIEW ? "in-down" : "") + (viewClosing === MONTH_VIEW ? "out-down" : "");
        break;
      case MULTI_YEAR_VIEW:
        animName = hasPicker && viewClosing === PAGE_VIEW ? "" : (viewOpening === MULTI_YEAR_VIEW ? "in-up" : "") + (viewClosing === MULTI_YEAR_VIEW ? "out-up" : "");
        break;
      default:
        animName = hasPicker && (viewOpening === PAGE_VIEW || viewClosing === PAGE_VIEW) ? "" : (viewOpening === YEAR_VIEW ? viewClosing === MULTI_YEAR_VIEW ? "in-down" : "in-up" : "") + (viewClosing === YEAR_VIEW ? viewOpening === MULTI_YEAR_VIEW ? "out-down" : "out-up" : "");
    }
    return baseName + pickerName + (hasAnimation && animName ? " " + baseName + "-" + animName : "");
  };
  CalendarViewBase.prototype._isNextDisabled = function (isModalPicker) {
    if (!this._hasPicker || isModalPicker) {
      var view = this._view;
      if (view === MULTI_YEAR_VIEW) {
        return this._yearsIndex + 1 > this._maxYearsIndex;
      }
      if (view === YEAR_VIEW) {
        return this._yearIndex + 1 > this._maxYearIndex;
      }
      if (view === MONTH_VIEW) {
        return this._monthIndex + 1 > this._maxMonthIndex;
      }
    }
    return this._pageIndex + 1 > this._maxIndex;
  };
  CalendarViewBase.prototype._isPrevDisabled = function (isModalPicker) {
    if (!this._hasPicker || isModalPicker) {
      var view = this._view;
      if (view === MULTI_YEAR_VIEW) {
        return this._yearsIndex - 1 < this._minYearsIndex;
      }
      if (view === YEAR_VIEW) {
        return this._yearIndex - 1 < this._minYearIndex;
      }
      if (view === MONTH_VIEW) {
        return this._monthIndex - 1 < this._minMonthIndex;
      }
    }
    return this._pageIndex - 1 < this._minIndex;
  };
  CalendarViewBase.prototype._render = function (s, state) {
    var getDate = s.getDate;
    var getYear = s.getYear;
    var getMonth = s.getMonth;
    var showCalendar = s.showCalendar;
    var calendarType = s.calendarType;
    var eventRange = s.eventRange;
    var eventRangeSize = s.eventRangeSize || 1;
    var firstWeekDay = s.firstDay;
    var isWeekView = calendarType === "week";
    var isMonthView = calendarType === "month";
    var isYearView = calendarType === "year";
    var size = isYearView ? 12 : +(s.size || 1);
    var isGrid = size > 1 && !isWeekView;
    var weeks = showCalendar ? isWeekView ? s.weeks : 6 : 0;
    var active = s.activeDate || this._active || +new Date();
    var activeChanged = active !== this._active;
    var d = new Date(active);
    var prevProps = this._prevS;
    var dateFormat = s.dateFormat;
    var monthNames = s.monthNames;
    var yearSuffix = s.yearSuffix;
    var variableRow = isNumeric(s.labelList) ? +s.labelList + 1 : s.labelList === "all" ? -1 : 0;
    var labelListingChanged = s.labelList !== prevProps.labelList;
    var navService = s.navService;
    var pageIndex = navService.pageIndex;
    var firstDay = navService.firstDay;
    var lastDay = navService.lastDay;
    var start = navService.viewStart;
    var end = navService.viewEnd;
    this._minDate = navService.minDate;
    this._maxDate = navService.maxDate;
    if (!isEmpty(s.min)) {
      var min = getDateOnly(this._minDate);
      this._minDate = getDateOnly(min);
      this._minYear = getDate(getYear(min), getMonth(min), 1);
      this._minYears = getYear(min);
      this._minIndex = getPageIndex(min, s);
      this._minYearIndex = getYearIndex(min, s);
      this._minYearsIndex = getYearsIndex(min, s);
      this._minMonthIndex = getMonthIndex(min, s);
    } else {
      this._minIndex = -Infinity;
      this._minYears = -Infinity;
      this._minYearsIndex = -Infinity;
      this._minYear = -Infinity;
      this._minYearIndex = -Infinity;
      this._minMonthIndex = -Infinity;
    }
    if (!isEmpty(s.max)) {
      var max = this._maxDate;
      this._maxYear = getDate(getYear(max), getMonth(max) + 1, 1);
      this._maxYears = getYear(max);
      this._maxIndex = getPageIndex(max, s);
      this._maxYearIndex = getYearIndex(max, s);
      this._maxYearsIndex = getYearsIndex(max, s);
      this._maxMonthIndex = getMonthIndex(max, s);
    } else {
      this._maxIndex = Infinity;
      this._maxYears = Infinity;
      this._maxYearsIndex = Infinity;
      this._maxYear = Infinity;
      this._maxYearIndex = Infinity;
      this._maxMonthIndex = Infinity;
    }
    var viewChanged = calendarType !== prevProps.calendarType || eventRange !== prevProps.eventRange || firstWeekDay !== prevProps.firstDay || s.eventRangeSize !== prevProps.eventRangeSize || s.refDate !== prevProps.refDate || s.showCalendar !== prevProps.showCalendar || s.weeks !== prevProps.weeks;
    if (viewChanged && this._pageIndex !== UNDEFINED) {
      this._prevAnim = true;
    }
    if (activeChanged) {
      this._activeMonth = active;
    }
    this._view = state.view || s.selectView;
    this._yearsIndex = getYearsIndex(new Date(this._activeMonth), s);
    this._yearIndex = getYearIndex(new Date(this._activeMonth), s);
    this._monthIndex = getMonthIndex(new Date(this._activeMonth), s);
    var pageNr = isGrid ? 1 : getPageNr(s.pages, state.pageSize);
    var isVertical = s.calendarScroll === "vertical" && s.pages !== "auto" && (s.pages === UNDEFINED || s.pages === 1);
    var showOuter = s.showOuterDays !== UNDEFINED ? s.showOuterDays : !isVertical && pageNr < 2 && (isWeekView || !size || size < 2);
    var monthIndex = dateFormat.search(/m/i);
    var yearIndex = dateFormat.search(/y/i);
    if (this._view === MONTH_VIEW) {
      var date = new Date(this._getPageMonth(this._monthIndex));
      var month = monthNames[getMonth(date)];
      var year = getYear(date) + yearSuffix;
      this._viewTitle = yearIndex < monthIndex ? year + " " + month : month + " " + year;
    } else if (this._view === YEAR_VIEW) {
      this._viewTitle = this._getPageYear(this._yearIndex) + "";
    } else if (this._view === MULTI_YEAR_VIEW) {
      var startYear = this._getPageYears(this._yearsIndex);
      this._viewTitle = startYear + " - " + (startYear + 11);
    }
    if (isGrid) {
      this._monthsMulti = [];
      if (pageIndex !== UNDEFINED) {
        var columns = floor(state.pageSize * .96 / (PAGE_WIDTH * 1.1)) || 1;
        while (size % columns) {
          columns--;
        }
        for (var i = 0; i < size / columns; ++i) {
          var rowItems = [];
          for (var j = 0; j < columns; ++j) {
            rowItems.push(+getDate(getYear(firstDay), getMonth(firstDay) + i * columns + j, 1));
          }
          this._monthsMulti.push(rowItems);
        }
      }
    }
    if (calendarType !== prevProps.calendarType || s.theme !== prevProps.theme || s.calendarScroll !== prevProps.calendarScroll || s.hasContent !== prevProps.hasContent || s.showCalendar !== prevProps.showCalendar || s.showSchedule !== prevProps.showSchedule || s.showWeekNumbers !== prevProps.showWeekNumbers || s.weeks !== prevProps.weeks || labelListingChanged) {
      this._shouldCheckSize = true;
    }
    if (prevProps.width !== s.width || prevProps.height !== s.height) {
      this._dim = {
        height: addPixel(s.height),
        width: addPixel(s.width)
      };
    }
    this._cssClass = "mbsc-calendar mbsc-font mbsc-flex-col" + this._theme + this._rtl + (state.ready ? "" : " mbsc-hidden") + (isGrid ? " mbsc-calendar-grid-view" : " mbsc-calendar-height-" + state.height + " mbsc-calendar-width-" + state.width) + " " + s.cssClass;
    this._dayNames = state.width === "sm" || isGrid ? s.dayNamesMin : s.dayNamesShort;
    this._isSwipeChange = false;
    this._yearFirst = yearIndex < monthIndex;
    this._pageNr = pageNr;
    this._variableRow = variableRow;
    var forcePageLoad = s.pageLoad !== prevProps.pageLoad;
    var pageChanged = +start !== +this._viewStart || +end !== +this._viewEnd;
    if (this._pageIndex !== UNDEFINED && pageChanged) {
      this._isIndexChange = !this._isSwipeChange && !viewChanged;
    }
    if (pageIndex !== UNDEFINED) {
      this._pageIndex = pageIndex;
    }
    if (pageIndex !== UNDEFINED && (s.marked !== prevProps.marked || s.colors !== prevProps.colors || s.labels !== prevProps.labels || s.invalid !== prevProps.invalid || s.valid !== prevProps.valid || state.maxLabels !== this._maxLabels || pageChanged || labelListingChanged || forcePageLoad)) {
      this._maxLabels = state.maxLabels;
      this._viewStart = start;
      this._viewEnd = end;
      var labelsMap = s.labelsMap || getEventMap(s.labels, start, end, s);
      var labels = labelsMap && getLabels(s, labelsMap, start, end, this._variableRow || this._maxLabels || 1, 7, false, firstWeekDay, true, s.eventOrder, !showOuter, s.showLabelCount, s.moreEventsText, s.moreEventsPluralText);
      if (labels && !this._labels) {
        this._shouldCheckSize = true;
      }
      if (labels && state.maxLabels || !labels) {
        this._shouldPageLoad = !this._isIndexChange || this._prevAnim || !showCalendar || forcePageLoad;
      }
      this._labelsLayout = labels;
      this._labels = labelsMap;
      this._marked = labelsMap ? UNDEFINED : s.marksMap || getEventMap(s.marked, start, end, s);
      this._colors = getEventMap(s.colors, start, end, s);
      this._valid = getEventMap(s.valid, start, end, s, true);
      this._invalid = getEventMap(s.invalid, start, end, s, true);
    }
    if (pageChanged || activeChanged || eventRange !== prevProps.eventRange || eventRangeSize !== prevProps.eventRangeSize || s.monthNames !== prevProps.monthNames) {
      this._title = [];
      var lDay = addDays(lastDay, -1);
      var titleDate = pageIndex === UNDEFINED ? d : firstDay;
      if (isWeekView) {
        titleDate = d;
        for (var _i = 0, _a = Object.keys(s.selectedDates); _i < _a.length; _i++) {
          var key = _a[_i];
          if (+key >= +firstDay && +key < +lastDay) {
            titleDate = new Date(+key);
            break;
          }
        }
      }
      if (this._pageNr > 1) {
        for (var i = 0; i < pageNr; i++) {
          var dt = getDate(getYear(firstDay), getMonth(firstDay) + i, 1);
          var yt = getYear(dt) + yearSuffix;
          var mt = monthNames[getMonth(dt)];
          this._title.push({
            yearTitle: yt,
            monthTitle: mt
          });
        }
      } else {
        var titleObj = {
          yearTitle: getYear(titleDate) + yearSuffix,
          monthTitle: monthNames[getMonth(titleDate)]
        };
        var titleType = s.showSchedule && eventRangeSize === 1 ? eventRange : showCalendar ? calendarType : eventRange;
        var agendaOnly = eventRange && !showCalendar && (!s.showSchedule || eventRangeSize > 1);
        switch (titleType) {
          case "year":
            {
              titleObj.title = getYear(firstDay) + yearSuffix;
              if (eventRangeSize > 1) {
                titleObj.title += " - " + (getYear(lDay) + yearSuffix);
              }
              break;
            }
          case "month":
            {
              if (eventRangeSize > 1 && !showCalendar) {
                var monthStart = monthNames[getMonth(firstDay)];
                var yearStart = getYear(firstDay) + yearSuffix;
                var titleStart = this._yearFirst ? yearStart + " " + monthStart : monthStart + " " + yearStart;
                var monthEnd = monthNames[getMonth(lDay)];
                var yearEnd = getYear(lDay) + yearSuffix;
                var titleEnd = this._yearFirst ? yearEnd + " " + monthEnd : monthEnd + " " + yearEnd;
                titleObj.title = titleStart + " - " + titleEnd;
              } else if (isGrid) {
                titleObj.title = getYear(firstDay) + yearSuffix;
              }
              break;
            }
          case "day":
          case "week":
            {
              if (agendaOnly) {
                var dayIndex = dateFormat.search(/d/i);
                var shortDateFormat = dayIndex < monthIndex ? "D MMM, YYYY" : "MMM D, YYYY";
                titleObj.title = formatDate(shortDateFormat, firstDay, s);
                if (titleType === "week" || eventRangeSize > 1) {
                  titleObj.title += " - " + formatDate(shortDateFormat, lDay, s);
                }
              }
              break;
            }
        }
        this._title.push(titleObj);
      }
    }
    this._active = active;
    this._hasPicker = s.hasPicker || isGrid || !isMonthView || !showCalendar || state.width === "md" && s.hasPicker !== false;
    this._axis = isVertical ? "Y" : "X";
    this._rtlNr = !isVertical && s.rtl ? -1 : 1;
    this._weeks = weeks;
    this._nextIcon = isVertical ? s.nextIconV : s.rtl ? s.prevIconH : s.nextIconH;
    this._prevIcon = isVertical ? s.prevIconV : s.rtl ? s.nextIconH : s.prevIconH;
    this._mousewheel = s.mousewheel === UNDEFINED ? isVertical : s.mousewheel;
    this._isGrid = isGrid;
    this._isVertical = isVertical;
    this._showOuter = showOuter;
    this._showDaysTop = isVertical || !!variableRow && size === 1;
  };
  CalendarViewBase.prototype._mounted = function () {
    this._observer = resizeObserver(this._el, this._onResize, this._zone);
    this._doc = getDocument(this._el);
    listen(this._doc, CLICK, this._onDocClick);
  };
  CalendarViewBase.prototype._updated = function () {
    var _this = this;
    if (this._shouldCheckSize) {
      setTimeout(function () {
        _this._onResize();
      });
      this._shouldCheckSize = false;
    } else if (this._shouldPageLoad) {
      this._pageLoaded();
      this._shouldPageLoad = false;
    }
    if (this._shouldFocus) {
      setTimeout(function () {
        _this._focusActive();
        _this._shouldFocus = false;
      });
    }
    if (this.s.instanceService) {
      this.s.instanceService.onComponentChange.next({});
    }
    this._pageChange = false;
    if (this._variableRow && this.s.showCalendar) {
      var body = this._body.querySelector(".mbsc-calendar-body-inner");
      var hasScrollY = body.scrollHeight > body.clientHeight;
      if (hasScrollY !== this.state.hasScrollY) {
        this._shouldCheckSize = true;
        this.setState({
          hasScrollY: hasScrollY
        });
      }
    }
  };
  CalendarViewBase.prototype._destroy = function () {
    if (this._observer) {
      this._observer.detach();
    }
    unlisten(this._doc, CLICK, this._onDocClick);
    clearTimeout(this._hoverTimer);
  };
  CalendarViewBase.prototype._getActiveCell = function () {
    var view = this._view;
    var cont = view === PAGE_VIEW ? this._body : this._pickerCont;
    var cell = view === MULTI_YEAR_VIEW ? "year" : view === YEAR_VIEW ? "month" : "cell";
    return cont && cont.querySelector(".mbsc-calendar-" + cell + '[tabindex="0"]');
  };
  CalendarViewBase.prototype._focusActive = function () {
    var cell = this._getActiveCell();
    if (cell) {
      cell.focus();
    }
  };
  CalendarViewBase.prototype._pageLoaded = function () {
    var navService = this.s.navService;
    this._hook("onPageLoaded", {
      activeElm: this._getActiveCell(),
      firstDay: navService.firstPageDay,
      lastDay: navService.lastPageDay,
      month: this.s.calendarType === "month" ? navService.firstDay : UNDEFINED,
      viewEnd: navService.viewEnd,
      viewStart: navService.viewStart
    });
  };
  CalendarViewBase.prototype._activeChange = function (diff) {
    var nextIndex = this._pageIndex + diff;
    if (this._minIndex <= nextIndex && this._maxIndex >= nextIndex) {
      this._prevAnim = false;
      this._pageChange = true;
      this._hook("onActiveChange", {
        date: this._getPageDay(nextIndex),
        dir: diff,
        pageChange: true
      });
    }
  };
  CalendarViewBase.prototype._activeMonthChange = function (diff) {
    var nextIndex = this._monthIndex + diff;
    if (this._minMonthIndex <= nextIndex && this._maxMonthIndex >= nextIndex) {
      this._prevAnim = false;
      this._activeMonth = this._getPageMonth(nextIndex);
      this.forceUpdate();
    }
  };
  CalendarViewBase.prototype._activeYearsChange = function (diff) {
    var nextIndex = this._yearsIndex + diff;
    if (this._minYearsIndex <= nextIndex && this._maxYearsIndex >= nextIndex) {
      var newYear = this._getPageYears(nextIndex);
      this._prevAnim = false;
      this._activeMonth = +this.s.getDate(newYear, 0, 1);
      this.forceUpdate();
    }
  };
  CalendarViewBase.prototype._activeYearChange = function (diff) {
    var nextIndex = this._yearIndex + diff;
    if (this._minYearIndex <= nextIndex && this._maxYearIndex >= nextIndex) {
      var newYear = this._getPageYear(nextIndex);
      this._prevAnim = false;
      this._activeMonth = +this.s.getDate(newYear, 0, 1);
      this.forceUpdate();
    }
  };
  CalendarViewBase.prototype._prevDocClick = function () {
    var _this = this;
    this._prevClick = true;
    setTimeout(function () {
      _this._prevClick = false;
    });
  };
  CalendarViewBase.ɵfac = /* @__PURE__ */(() => {
    let ɵCalendarViewBase_BaseFactory;
    return function CalendarViewBase_Factory(t) {
      return (ɵCalendarViewBase_BaseFactory || (ɵCalendarViewBase_BaseFactory = i0.ɵɵgetInheritedFactory(CalendarViewBase)))(t || CalendarViewBase);
    };
  })();
  CalendarViewBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: CalendarViewBase,
    selectors: [["", "mbsc-calview-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return CalendarViewBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MonthViewBase = /*#__PURE__*/function (_super) {
  __extends(MonthViewBase, _super);
  function MonthViewBase() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MonthViewBase.prototype._isActive = function (d) {
    return this.s.isActive && d === this.s.activeDate;
  };
  MonthViewBase.prototype._isInvalid = function (d) {
    var s = this.s;
    var localDate = new Date(d);
    var timezoneDate = addTimezone(s, localDate);
    return isInvalid(s, timezoneDate, s.invalid, s.valid, +s.min, +s.max);
  };
  MonthViewBase.prototype._isSelected = function (d) {
    var localDate = new Date(d);
    var timezoneDate = addTimezone(this.s, localDate);
    return !!this.s.selectedDates[+timezoneDate];
  };
  MonthViewBase.prototype._getWeekNr = function (s, date) {
    var d = new Date(date);
    return "" + s.getWeekNumber(s.getDate(d.getFullYear(), d.getMonth(), d.getDate() + (7 - s.firstDay + 1) % 7));
  };
  MonthViewBase.prototype._render = function (s) {
    var weeks = s.weeks || 6;
    var firstWeekDay = s.firstDay;
    var firstDay = new Date(s.firstPageDay);
    var year = s.getYear(firstDay);
    var month = s.getMonth(firstDay);
    var day = s.getDay(firstDay);
    var weekDay = s.getDate(year, month, day).getDay();
    var offset = firstWeekDay - weekDay > 0 ? 7 : 0;
    var row = [];
    var maxLabels = 0;
    this._rowHeights = [];
    this._rows = [];
    this._days = ARRAY7;
    for (var i = 0; i < 7 * weeks; i++) {
      var curr = s.getDate(year, month, i + firstWeekDay - offset - weekDay + day);
      var key = getDateStr(curr);
      var displayMonth = s.getMonth(curr);
      var outer = displayMonth !== month && s.calendarType !== "week";
      var marked = s.marked && s.marked[key];
      var marks = marked ? s.showSingleMark ? [{}] : marked : null;
      var labels = s.labels && s.labels[key];
      var labelCount = labels ? labels.data.length : 0;
      var isWeekStart = i % 7 === 0;
      if (s.variableRow) {
        if (isWeekStart && outer && i) {
          break;
        }
        if (labelCount > maxLabels) {
          maxLabels = labelCount;
        }
        if (i % 7 === 6) {
          this._rowHeights.push(maxLabels * (s.labelHeight || 20) + (s.cellTextHeight || 0) + 3);
          maxLabels = 0;
        }
      }
      if (isWeekStart) {
        row = [];
        this._rows.push(row);
      }
      row.push({
        colors: s.colors && s.colors[key],
        date: +curr,
        day: s.dayNames[curr.getDay()],
        display: outer ? s.showOuter : true,
        events: s.events && s.events[key],
        labels: labels,
        marks: marks,
        month: s.monthNames[displayMonth],
        monthShort: s.monthNamesShort[displayMonth],
        outer: outer,
        text: s.getDay(curr),
        year: s.getYear(curr)
      });
    }
  };
  MonthViewBase.ɵfac = /* @__PURE__ */(() => {
    let ɵMonthViewBase_BaseFactory;
    return function MonthViewBase_Factory(t) {
      return (ɵMonthViewBase_BaseFactory || (ɵMonthViewBase_BaseFactory = i0.ɵɵgetInheritedFactory(MonthViewBase)))(t || MonthViewBase);
    };
  })();
  MonthViewBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: MonthViewBase,
    selectors: [["", "mbsc-mv-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return MonthViewBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var cloudUpload = '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"/></svg>';
var resizeObservable = new Observable();
var resizeSubscribers = 0;
var resizeTimer;
function onWindowResize() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function () {
    resizeObservable.next();
  }, 100);
}
function subscribeResize(handler) {
  if (!resizeSubscribers) {
    listen(win, RESIZE, onWindowResize);
  }
  resizeSubscribers++;
  return resizeObservable.subscribe(handler);
}
function unsubscribeResize(id) {
  resizeSubscribers--;
  resizeObservable.unsubscribe(id);
  if (!resizeSubscribers) {
    unlisten(win, RESIZE, onWindowResize);
  }
}
function checkAutoFill(el) {
  try {
    return matches(el, "*:-webkit-autofill");
  } catch (ex) {
    return false;
  }
}
var InputBase = /*#__PURE__*/function (_super) {
  __extends(InputBase, _super);
  function InputBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._tag = "input";
    _this._onClick = function () {
      _this._hidePass = !_this._hidePass;
    };
    _this._onMouseDown = function (ev) {
      if (_this.s.tags) {
        _this._preventFocus = true;
      }
    };
    _this._onTagClear = function (ev, index) {
      ev.stopPropagation();
      ev.preventDefault();
      if (!_this.s.disabled) {
        var value = __spreadArray([], _this.s.pickerValue, true);
        value.splice(index, 1);
        trigger(_this._el, CHANGE, value);
      }
    };
    _this._sizeTextArea = function () {
      var input = _this._el;
      var rowNr = _this.s.rows;
      var lineHeight = 24;
      var height;
      var lineNr;
      var line;
      if (input.offsetHeight) {
        input.style.height = "";
        line = input.scrollHeight - input.offsetHeight;
        height = input.offsetHeight + (line > 0 ? line : 0);
        lineNr = Math.round(height / lineHeight);
        if (lineNr > rowNr) {
          height = lineHeight * rowNr + (height - lineNr * lineHeight);
          input.style.overflow = "auto";
        } else {
          input.style.overflow = "";
        }
        if (height) {
          input.style.height = height + "px";
        }
      }
    };
    _this._onAutoFill = function () {
      if (_this.s.labelStyle === "floating" && checkAutoFill(_this._el)) {
        _this.setState({
          isFloatingActive: true
        });
      }
    };
    return _this;
  }
  InputBase.prototype._change = function (val) {};
  InputBase.prototype._checkFloating = function () {
    var _this = this;
    var el = this._el;
    var s = this.s;
    var isAutoFill = checkAutoFill(el);
    var isFloatingActive = this.state.hasFocus || isAutoFill || !isEmpty(this.value);
    if (el && s.labelStyle === "floating") {
      if (this._tag === "select") {
        var select = el;
        var firstOption = select.options[0];
        isFloatingActive = !!(isFloatingActive || select.multiple || select.value || select.selectedIndex > -1 && firstOption && firstOption.label);
      } else if (this.value === UNDEFINED) {
        var input = el;
        isFloatingActive = !!(isFloatingActive || input.value);
      }
      this._valueChecked = true;
      ngSetTimeout(this, function () {
        _this.setState({
          isFloatingActive: isFloatingActive
        });
      });
    }
  };
  InputBase.prototype._mounted = function () {
    var _this = this;
    var s = this.s;
    var input = this._el;
    listen(input, ANIMATION_START, this._onAutoFill);
    if (this._tag === "textarea") {
      listen(input, INPUT, this._sizeTextArea);
      this._unsubscribe = subscribeResize(this._sizeTextArea);
    }
    this._unlisten = gestureListener(input, {
      keepFocus: true,
      onBlur: function () {
        _this.setState({
          hasFocus: false,
          isFloatingActive: !!input.value
        });
      },
      onChange: function (ev) {
        if (s.type === "file") {
          var files = ev.target.files;
          var names = [];
          for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
            var file = files_1[_i];
            names.push(file.name);
          }
          _this.setState({
            files: names.join(", ")
          });
        }
        if (s.tags && s.value === UNDEFINED && s.defaultValue === UNDEFINED) {
          _this.setState({
            value: ev.target.value
          });
        }
        _this._checkFloating();
        _this._change(ev.target.value);
        _this._emit("onChange", ev);
      },
      onFocus: function () {
        if (!_this._preventFocus) {
          _this.setState({
            hasFocus: true,
            isFloatingActive: true
          });
        }
        _this._preventFocus = false;
      },
      onHoverIn: function () {
        if (!_this._disabled) {
          _this.setState({
            hasHover: true
          });
        }
      },
      onHoverOut: function () {
        _this.setState({
          hasHover: false
        });
      },
      onInput: function (ev) {
        _this._change(ev.target.value);
      }
    });
  };
  InputBase.prototype._render = function (s, state) {
    var hasEndIcon = !!(s.endIconSvg || s.endIcon);
    var pickerValue = s.pickerValue;
    var hasStartIcon = !!(s.startIconSvg || s.startIcon);
    var hasLabel = s.label !== UNDEFINED || s.hasChildren;
    var hasError = s.error;
    var iconStartPosition = s.rtl ? "right" : "left";
    var iconEndPosition = s.rtl ? "left" : "right";
    var inputType = s.inputStyle;
    var labelType = s.labelStyle;
    var isFloating = labelType === "floating";
    var isFloatingActive = !!(isFloating && hasLabel && (state.isFloatingActive || !isEmpty(s.value)));
    var disabled = s.disabled === UNDEFINED ? state.disabled : s.disabled;
    var prevS = this._prevS;
    var modelValue = s.modelValue !== UNDEFINED ? s.modelValue : s.value;
    var value = modelValue !== UNDEFINED ? modelValue : state.value !== UNDEFINED ? state.value : s.defaultValue;
    var commonClasses = this._theme + this._rtl + (hasError ? " mbsc-error" : "") + (disabled ? " mbsc-disabled" : "") + (state.hasHover ? " mbsc-hover" : "") + (state.hasFocus && !disabled ? " mbsc-focus" : "");
    if (s.type === "file" && !hasEndIcon) {
      s.endIconSvg = cloudUpload;
      hasEndIcon = true;
    }
    if (s.tags) {
      if (isEmpty(pickerValue)) {
        pickerValue = [];
      }
      if (!isArray(pickerValue)) {
        pickerValue = [pickerValue];
      }
      this._tagsArray = s.pickerMap ? pickerValue.map(function (val) {
        return s.pickerMap.get(val);
      }) : isEmpty(value) ? [] : value.split(", ");
    }
    if (s.passwordToggle) {
      hasEndIcon = true;
      this._passIconClass = commonClasses + " mbsc-toggle-icon" + " mbsc-textfield-icon mbsc-textfield-icon-".concat(inputType, " mbsc-textfield-icon-").concat(iconEndPosition) + " mbsc-textfield-icon-".concat(inputType, "-").concat(iconEndPosition) + (hasLabel ? " mbsc-textfield-icon-".concat(labelType) : "");
      this._hidePass = this._hidePass === UNDEFINED ? s.type === "password" : this._hidePass;
    }
    this._hasStartIcon = hasStartIcon;
    this._hasEndIcon = hasEndIcon;
    this._hasError = hasError;
    this._disabled = disabled;
    this._value = value;
    this._cssClass = this._className + this._hb + commonClasses + " mbsc-form-control-wrapper mbsc-textfield-wrapper mbsc-font" + " mbsc-textfield-wrapper-".concat(inputType) + (disabled ? " mbsc-disabled" : "") + (hasLabel ? " mbsc-textfield-wrapper-".concat(labelType) : "") + (hasStartIcon ? " mbsc-textfield-wrapper-has-icon-".concat(iconStartPosition, " ") : "") + (hasEndIcon ? " mbsc-textfield-wrapper-has-icon-".concat(iconEndPosition, " ") : "");
    if (hasLabel) {
      this._labelClass = commonClasses + " mbsc-label mbsc-label-".concat(labelType, " mbsc-label-").concat(inputType, "-").concat(labelType) + (hasStartIcon ? " mbsc-label-".concat(inputType, "-").concat(labelType, "-has-icon-").concat(iconStartPosition, " ") : "") + (hasEndIcon ? " mbsc-label-".concat(inputType, "-").concat(labelType, "-has-icon-").concat(iconEndPosition, " ") : "") + (isFloating && this._animateFloating ? " mbsc-label-floating-animate" : "") + (isFloatingActive ? " mbsc-label-floating-active" : "");
    }
    this._innerClass = commonClasses + " mbsc-textfield-inner mbsc-textfield-inner-".concat(inputType) + (hasLabel ? " mbsc-textfield-inner-".concat(labelType) : "");
    if (hasStartIcon) {
      this._startIconClass = commonClasses + " mbsc-textfield-icon mbsc-textfield-icon-".concat(inputType, " mbsc-textfield-icon-").concat(iconStartPosition) + " mbsc-textfield-icon-".concat(inputType, "-").concat(iconStartPosition) + (hasLabel ? " mbsc-textfield-icon-".concat(labelType) : "");
    }
    if (hasEndIcon) {
      this._endIconClass = commonClasses + " mbsc-textfield-icon mbsc-textfield-icon-".concat(inputType, " mbsc-textfield-icon-").concat(iconEndPosition) + " mbsc-textfield-icon-".concat(inputType, "-").concat(iconEndPosition) + (hasLabel ? " mbsc-textfield-icon-".concat(labelType) : "");
    }
    this._nativeElmClass = commonClasses + " " + (s.inputClass || "") + " mbsc-textfield mbsc-textfield-".concat(inputType) + (s.dropdown ? " mbsc-select" : "") + (hasLabel ? " mbsc-textfield-".concat(labelType, " mbsc-textfield-").concat(inputType, "-").concat(labelType) : "") + (isFloatingActive ? " mbsc-textfield-floating-active" : "") + (hasStartIcon ? " mbsc-textfield-has-icon-".concat(iconStartPosition, " mbsc-textfield-").concat(inputType, "-has-icon-").concat(iconStartPosition) + (hasLabel ? " mbsc-textfield-".concat(inputType, "-").concat(labelType, "-has-icon-").concat(iconStartPosition) : "") : "") + (hasEndIcon ? " mbsc-textfield-has-icon-".concat(iconEndPosition, " mbsc-textfield-").concat(inputType, "-has-icon-").concat(iconEndPosition) + (hasLabel ? " mbsc-textfield-".concat(inputType, "-").concat(labelType, "-has-icon-").concat(iconEndPosition) : "") : "");
    if (this._tag === "select" || s.dropdown) {
      this._selectIconClass = "mbsc-select-icon mbsc-select-icon-".concat(inputType) + this._rtl + this._theme + (hasLabel ? " mbsc-select-icon-".concat(labelType) : "") + (hasStartIcon ? " mbsc-select-icon-".concat(iconStartPosition) : "") + (hasEndIcon ? " mbsc-select-icon-".concat(iconEndPosition) : "");
    }
    if (this._tag === "textarea" || s.tags) {
      this._cssClass += " mbsc-textarea-wrapper";
      this._innerClass += " mbsc-textarea-inner";
      this._nativeElmClass += " mbsc-textarea";
      if (this._tag === "textarea" && (value !== this._prevValue || s.inputStyle !== prevS.inputStyle || s.labelStyle !== prevS.labelStyle || s.rows !== prevS.rows || s.theme !== prevS.theme)) {
        this._shouldSize = true;
      }
      this._prevValue = value;
    }
    if (s.tags) {
      this._innerClass += " mbsc-textfield-tags-inner";
    }
    if (s.type === "file") {
      this._dummyElmClass = this._nativeElmClass;
      this._nativeElmClass += " mbsc-textfield-file";
    }
    this._errorClass = this._theme + this._rtl + " mbsc-error-message mbsc-error-message-".concat(inputType) + (hasLabel ? " mbsc-error-message-".concat(labelType) : "") + (hasStartIcon ? " mbsc-error-message-has-icon-".concat(iconStartPosition) : "") + (hasEndIcon ? " mbsc-error-message-has-icon-".concat(iconEndPosition) : "");
    if (s.notch && inputType === "outline") {
      this._fieldSetClass = "mbsc-textfield-fieldset" + commonClasses + (hasStartIcon ? " mbsc-textfield-fieldset-has-icon-".concat(iconStartPosition) : "") + (hasEndIcon ? " mbsc-textfield-fieldset-has-icon-".concat(iconEndPosition) : "");
      this._legendClass = "mbsc-textfield-legend" + this._theme + (isFloatingActive || hasLabel && labelType === "stacked" ? " mbsc-textfield-legend-active" : "");
    }
    if (s.ripple && s.inputStyle !== "outline") {
      this._rippleClass = "mbsc-textfield-ripple" + this._theme + (hasError ? " mbsc-error" : "") + (state.hasFocus ? " mbsc-textfield-ripple-active" : "");
    }
    if (this._valueChecked) {
      this._animateFloating = true;
    }
  };
  InputBase.prototype._updated = function () {
    var _this = this;
    if (this._shouldSize) {
      this._shouldSize = false;
      ngSetTimeout(this, function () {
        _this._sizeTextArea();
      });
    }
    this._checkFloating();
  };
  InputBase.prototype._destroy = function () {
    unlisten(this._el, ANIMATION_START, this._onAutoFill);
    unlisten(this._el, INPUT, this._sizeTextArea);
    if (this._unsubscribe) {
      unsubscribeResize(this._unsubscribe);
    }
    if (this._unlisten) {
      this._unlisten();
    }
  };
  InputBase.defaults = {
    dropdown: false,
    dropdownIcon: arrowDown,
    hideIcon: "eye-blocked",
    inputStyle: "underline",
    labelStyle: "stacked",
    placeholder: "",
    ripple: false,
    rows: 6,
    showIcon: "eye",
    type: "text"
  };
  InputBase._name = "Input";
  InputBase.ɵfac = /* @__PURE__ */(() => {
    let ɵInputBase_BaseFactory;
    return function InputBase_Factory(t) {
      return (ɵInputBase_BaseFactory || (ɵInputBase_BaseFactory = i0.ɵɵgetInheritedFactory(InputBase)))(t || InputBase);
    };
  })();
  InputBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: InputBase,
    selectors: [["", "mbsc-inp-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return InputBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function FormControl(constructor) {
  var prototype = constructor.prototype;
  prototype.registerOnChange = function (fn) {
    this._onFormChange = fn;
  };
  prototype.registerOnTouched = function (fn) {
    this._onFormTouch = fn;
  };
  prototype.setDisabledState = function (disabled) {
    this.setState({
      disabled: disabled
    });
  };
  prototype.writeValue = function (val) {
    updateValue(this, val);
  };
}
var guid$1 = 0;
var MbscInput = /*#__PURE__*/function (_super) {
  __extends(MbscInput, _super);
  function MbscInput() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.onChange = new EventEmitter();
    _this._id = "mbsc-textfield-" + guid$1++;
    return _this;
  }
  MbscInput.prototype._onIconClick = function () {
    this.vLbl.nativeElement.click();
  };
  MbscInput.prototype._triggerEvent = function (ev) {
    if (this.s.tags && ev.target !== this._el) {
      trigger(this._el, ev.type);
    }
  };
  MbscInput.prototype._onValueChange = function () {
    this._checkFloating();
  };
  MbscInput.prototype._mounted = function () {
    this._el = this.vInput.nativeElement;
    _super.prototype._mounted.call(this);
  };
  MbscInput.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscInput_BaseFactory;
    return function MbscInput_Factory(t) {
      return (ɵMbscInput_BaseFactory || (ɵMbscInput_BaseFactory = i0.ɵɵgetInheritedFactory(MbscInput)))(t || MbscInput);
    };
  })();
  MbscInput.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscInput,
    selectors: [["mbsc-input"]],
    viewQuery: function MbscInput_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c3, 5);
        i0.ɵɵviewQuery(_c4, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vInput = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vLbl = _t.first);
      }
    },
    hostVars: 2,
    hostBindings: function MbscInput_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx._cssClass);
      }
    },
    inputs: {
      ariaExpanded: "ariaExpanded",
      ariaHaspopup: "ariaHaspopup",
      ariaLabel: "ariaLabel",
      accept: "accept",
      autocapitalize: "autocapitalize",
      autocomplete: "autocomplete",
      autocorrect: "autocorrect",
      autofocus: "autofocus",
      disabled: "disabled",
      dropdown: "dropdown",
      endIcon: "endIcon",
      endIconSrc: "endIconSrc",
      endIconSvg: "endIconSvg",
      error: "error",
      errorMessage: "errorMessage",
      hideIcon: "hideIcon",
      hideIconSvg: "hideIconSvg",
      id: "id",
      inputClass: "inputClass",
      inputStyle: "inputStyle",
      label: "label",
      labelStyle: "labelStyle",
      max: "max",
      maxlength: "maxlength",
      min: "min",
      minlength: "minlength",
      multiple: "multiple",
      name: "name",
      passwordToggle: "passwordToggle",
      pattern: "pattern",
      pickerMap: "pickerMap",
      pickerValue: "pickerValue",
      placeholder: "placeholder",
      readonly: "readonly",
      required: "required",
      ripple: "ripple",
      role: "role",
      rows: "rows",
      showIcon: "showIcon",
      showIconSvg: "showIconSvg",
      spellcheck: "spellcheck",
      startIcon: "startIcon",
      startIconSrc: "startIconSrc",
      startIconSvg: "startIconSvg",
      step: "step",
      tags: "tags",
      type: "type"
    },
    outputs: {
      onChange: "onChange"
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c6,
    decls: 16,
    vars: 42,
    consts: [["lbl", ""], ["input", ""], [3, "for"], [3, "click", "keydown"], [3, "ngModelChange", "blur", "ngModel", "disabled", "id", "placeholder", "readonly", "type"], ["type", "text", 3, "class", "disabled", "placeholder", "readonly", "value", 4, "ngIf"], [3, "class", 4, "ngIf"], [3, "class", "svg", "theme", 4, "ngIf"], [3, "class", "name", "svg", "theme", "click", 4, "ngIf"], ["aria-hidden", "true", 3, "class", 4, "ngIf"], ["type", "text", 3, "disabled", "placeholder", "readonly", "value"], [4, "ngFor", "ngForOf"], [1, "mbsc-textfield-tag-clear", 3, "click", "svg", "theme"], [3, "svg", "theme"], [3, "click", "name", "svg", "theme"], ["aria-hidden", "true"]],
    template: function MbscInput_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵprojectionDef(_c5);
        i0.ɵɵelementStart(0, "label", 2, 0);
        i0.ɵɵtext(2);
        i0.ɵɵprojection(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "span", 3);
        i0.ɵɵlistener("click", function MbscInput_Template_span_click_4_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._triggerEvent($event));
        })("keydown", function MbscInput_Template_span_keydown_4_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._triggerEvent($event));
        });
        i0.ɵɵelementStart(5, "input", 4, 1);
        i0.ɵɵtwoWayListener("ngModelChange", function MbscInput_Template_input_ngModelChange_5_listener($event) {
          i0.ɵɵrestoreView(_r1);
          i0.ɵɵtwoWayBindingSet(ctx.value, $event) || (ctx.value = $event);
          return i0.ɵɵresetView($event);
        });
        i0.ɵɵlistener("blur", function MbscInput_Template_input_blur_5_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onFormTouch($event));
        });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, MbscInput_input_7_Template, 1, 6, "input", 5)(8, MbscInput_span_8_Template, 3, 4, "span", 6)(9, MbscInput_mbsc_icon_9_Template, 1, 4, "mbsc-icon", 7)(10, MbscInput_mbsc_icon_10_Template, 1, 5, "mbsc-icon", 8)(11, MbscInput_mbsc_icon_11_Template, 1, 5, "mbsc-icon", 8)(12, MbscInput_mbsc_icon_12_Template, 1, 5, "mbsc-icon", 8)(13, MbscInput_span_13_Template, 2, 3, "span", 6)(14, MbscInput_fieldset_14_Template, 3, 5, "fieldset", 9)(15, MbscInput_span_15_Template, 1, 2, "span", 6);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵclassMap(ctx._labelClass);
        i0.ɵɵproperty("for", ctx._id);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.s.label, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵclassMap(ctx._innerClass);
        i0.ɵɵadvance();
        i0.ɵɵclassMap(ctx._nativeElmClass + (ctx.s.tags ? " mbsc-textfield-hidden" : ""));
        i0.ɵɵtwoWayProperty("ngModel", ctx.value);
        i0.ɵɵproperty("disabled", ctx._disabled)("id", ctx.id || ctx._id)("placeholder", ctx.s.placeholder)("readonly", ctx.readonly)("type", ctx.s.passwordToggle ? ctx._hidePass ? "password" : "text" : ctx.s.type);
        i0.ɵɵattribute("accept", ctx.accept)("aria-expanded", ctx.ariaExpanded)("aria-haspopup", ctx.ariaHaspopup)("aria-label", ctx.ariaLabel)("autocapitalize", ctx.autocapitalize)("autocomplete", ctx.autocomplete)("autocorrect", ctx.autocorrect)("autofocus", ctx.autofocus)("max", ctx.max)("maxlength", ctx.maxlength)("min", ctx.min)("minlength", ctx.minlength)("multiple", ctx.multiple)("name", ctx.name)("pattern", ctx.pattern)("required", ctx.required)("role", ctx.role)("spellcheck", ctx.spellcheck)("step", ctx.step);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.s.type === "file");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.tags);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.s.dropdown);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._hasStartIcon);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._hasEndIcon && !ctx.s.passwordToggle);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.s.passwordToggle);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._hasError);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.s.notch && ctx.s.inputStyle === "outline");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.s.ripple && ctx.s.inputStyle !== "outline");
      }
    },
    dependencies: [MbscIcon, DefaultValueAccessor, NgControlStatus, NgModel, MaxLengthValidator, MinLengthValidator, PatternValidator, RequiredValidator, NgIf, NgForOf],
    encapsulation: 2,
    changeDetection: 0
  });
  MbscInput = __decorate([FormControl], MbscInput);
  return MbscInput;
}(InputBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscDropdown = /*#__PURE__*/function (_super) {
  __extends(MbscDropdown, _super);
  function MbscDropdown() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._tag = "select";
    return _this;
  }
  MbscDropdown._name = "Dropdown";
  MbscDropdown.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscDropdown_BaseFactory;
    return function MbscDropdown_Factory(t) {
      return (ɵMbscDropdown_BaseFactory || (ɵMbscDropdown_BaseFactory = i0.ɵɵgetInheritedFactory(MbscDropdown)))(t || MbscDropdown);
    };
  })();
  MbscDropdown.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscDropdown,
    selectors: [["mbsc-dropdown"]],
    hostVars: 2,
    hostBindings: function MbscDropdown_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx._cssClass);
      }
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c8,
    decls: 13,
    vars: 24,
    consts: [["input", ""], [3, "for"], [3, "blur", "change", "disabled", "id", "value"], [3, "svg", "theme"], [3, "class", "name", "svg", "theme", "click", 4, "ngIf"], [3, "class", 4, "ngIf"], ["aria-hidden", "true", 3, "class", 4, "ngIf"], [3, "click", "name", "svg", "theme"], ["aria-hidden", "true"]],
    template: function MbscDropdown_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵprojectionDef(_c7);
        i0.ɵɵelementStart(0, "label", 1);
        i0.ɵɵtext(1);
        i0.ɵɵprojection(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "span")(4, "select", 2, 0);
        i0.ɵɵlistener("blur", function MbscDropdown_Template_select_blur_4_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onFormTouch($event));
        })("change", function MbscDropdown_Template_select_change_4_listener() {
          i0.ɵɵrestoreView(_r1);
          const input_r2 = i0.ɵɵreference(5);
          return i0.ɵɵresetView(ctx.value = input_r2.value);
        });
        i0.ɵɵprojection(6, 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(7, "mbsc-icon", 3);
        i0.ɵɵtemplate(8, MbscDropdown_mbsc_icon_8_Template, 1, 5, "mbsc-icon", 4)(9, MbscDropdown_mbsc_icon_9_Template, 1, 5, "mbsc-icon", 4)(10, MbscDropdown_span_10_Template, 2, 3, "span", 5)(11, MbscDropdown_fieldset_11_Template, 3, 5, "fieldset", 6)(12, MbscDropdown_span_12_Template, 1, 2, "span", 5);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵclassMap(ctx._labelClass);
        i0.ɵɵproperty("for", ctx._id);
        i0.ɵɵadvance();
        i0.ɵɵtextInterpolate1(" ", ctx.s.label, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵclassMap(ctx._innerClass);
        i0.ɵɵadvance();
        i0.ɵɵclassMap("mbsc-select " + ctx._nativeElmClass);
        i0.ɵɵproperty("disabled", ctx._disabled)("id", ctx.id || ctx._id)("value", ctx.value);
        i0.ɵɵattribute("autofocus", ctx.autofocus)("multiple", ctx.multiple)("name", ctx.name)("required", ctx.required);
        i0.ɵɵadvance(3);
        i0.ɵɵclassMap(ctx._selectIconClass);
        i0.ɵɵproperty("svg", ctx.s.dropdownIcon)("theme", ctx.s.theme);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._hasStartIcon);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._hasEndIcon);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._hasError);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.s.notch && ctx.s.inputStyle === "outline");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.s.ripple && ctx.s.inputStyle !== "outline");
      }
    },
    dependencies: [MbscIcon, NgIf],
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscDropdown;
}(MbscInput);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscTextarea = /*#__PURE__*/function (_super) {
  __extends(MbscTextarea, _super);
  function MbscTextarea() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._tag = "textarea";
    return _this;
  }
  MbscTextarea._name = "Textarea";
  MbscTextarea.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscTextarea_BaseFactory;
    return function MbscTextarea_Factory(t) {
      return (ɵMbscTextarea_BaseFactory || (ɵMbscTextarea_BaseFactory = i0.ɵɵgetInheritedFactory(MbscTextarea)))(t || MbscTextarea);
    };
  })();
  MbscTextarea.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscTextarea,
    selectors: [["mbsc-textarea"]],
    hostVars: 2,
    hostBindings: function MbscTextarea_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx._cssClass);
      }
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c6,
    decls: 11,
    vars: 30,
    consts: [["input", ""], [3, "for"], [3, "ngModelChange", "blur", "ngModel", "disabled", "id", "readonly", "placeholder"], [3, "class", "name", "svg", "theme", "click", 4, "ngIf"], [3, "class", 4, "ngIf"], ["aria-hidden", "true", 3, "class", 4, "ngIf"], [3, "click", "name", "svg", "theme"], ["aria-hidden", "true"]],
    template: function MbscTextarea_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵprojectionDef(_c5);
        i0.ɵɵelementStart(0, "label", 1);
        i0.ɵɵtext(1);
        i0.ɵɵprojection(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "span")(4, "textarea", 2, 0);
        i0.ɵɵtwoWayListener("ngModelChange", function MbscTextarea_Template_textarea_ngModelChange_4_listener($event) {
          i0.ɵɵrestoreView(_r1);
          i0.ɵɵtwoWayBindingSet(ctx.value, $event) || (ctx.value = $event);
          return i0.ɵɵresetView($event);
        });
        i0.ɵɵlistener("blur", function MbscTextarea_Template_textarea_blur_4_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onFormTouch($event));
        });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, MbscTextarea_mbsc_icon_6_Template, 1, 5, "mbsc-icon", 3)(7, MbscTextarea_mbsc_icon_7_Template, 1, 5, "mbsc-icon", 3)(8, MbscTextarea_span_8_Template, 2, 3, "span", 4)(9, MbscTextarea_fieldset_9_Template, 3, 5, "fieldset", 5)(10, MbscTextarea_span_10_Template, 1, 2, "span", 4);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵclassMap(ctx._labelClass);
        i0.ɵɵproperty("for", ctx._id);
        i0.ɵɵadvance();
        i0.ɵɵtextInterpolate1(" ", ctx.s.label, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵclassMap(ctx._innerClass);
        i0.ɵɵadvance();
        i0.ɵɵclassMap(ctx._nativeElmClass);
        i0.ɵɵtwoWayProperty("ngModel", ctx.value);
        i0.ɵɵproperty("disabled", ctx._disabled)("id", ctx.id || ctx._id)("readonly", ctx.readonly)("placeholder", ctx.placeholder);
        i0.ɵɵattribute("accept", ctx.accept)("autocapitalize", ctx.autocapitalize)("autocomplete", ctx.autocomplete)("autocorrect", ctx.autocorrect)("autofocus", ctx.autofocus)("maxlength", ctx.maxlength)("minlength", ctx.minlength)("name", ctx.name)("pattern", ctx.pattern)("required", ctx.required)("rows", ctx.rows)("spellcheck", ctx.spellcheck);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx._hasStartIcon);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._hasEndIcon);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._hasError);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.s.notch && ctx.s.inputStyle === "outline");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.s.ripple && ctx.s.inputStyle !== "outline");
      }
    },
    dependencies: [MbscIcon, DefaultValueAccessor, NgControlStatus, NgModel, MaxLengthValidator, MinLengthValidator, PatternValidator, RequiredValidator, NgIf],
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscTextarea;
}(MbscInput);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscInputModule = /*#__PURE__*/function () {
  function MbscInputModule() {}
  MbscInputModule.ɵfac = function MbscInputModule_Factory(t) {
    return new (t || MbscInputModule)();
  };
  MbscInputModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MbscInputModule
  });
  MbscInputModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule, FormsModule, MbscIconModule]]
  });
  return MbscInputModule;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscPopup = /*#__PURE__*/function (_super) {
  __extends(MbscPopup, _super);
  function MbscPopup() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.onButtonClick = new EventEmitter();
    _this.onOverlayClick = new EventEmitter();
    _this.onClose = new EventEmitter();
    _this.onClosed = new EventEmitter();
    _this.onKeyDown = new EventEmitter();
    _this.onOpen = new EventEmitter();
    _this.onPosition = new EventEmitter();
    _this.onResize = new EventEmitter();
    return _this;
  }
  MbscPopup.prototype._updated = function () {
    var justOpened = this._justOpened;
    if (justOpened) {
      this._active = this.vActive.nativeElement;
      this._content = this.vContent.nativeElement;
      this._limitator = this.vLimit.nativeElement;
      this._wrapper = this.vWrapper.nativeElement;
      this._popup = this.vPopup.nativeElement;
    }
    _super.prototype._updated.call(this);
    if (justOpened && this._ctx && !this._ph) {
      var wrapper = this._wrapper;
      var doc = getDocument(wrapper);
      this._ph = doc.createComment("mbsc-popup");
      wrapper.parentNode.insertBefore(this._ph, wrapper);
      this._ctx.appendChild(wrapper);
    }
  };
  MbscPopup.prototype._onClosed = function () {
    this._ph.parentNode.replaceChild(this._wrapper, this._ph);
    this._ph = null;
    _super.prototype._onClosed.call(this);
  };
  MbscPopup.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscPopup_BaseFactory;
    return function MbscPopup_Factory(t) {
      return (ɵMbscPopup_BaseFactory || (ɵMbscPopup_BaseFactory = i0.ɵɵgetInheritedFactory(MbscPopup)))(t || MbscPopup);
    };
  })();
  MbscPopup.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscPopup,
    selectors: [["mbsc-popup"]],
    viewQuery: function MbscPopup_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c9, 5);
        i0.ɵɵviewQuery(_c10, 5);
        i0.ɵɵviewQuery(_c11, 5);
        i0.ɵɵviewQuery(_c12, 5);
        i0.ɵɵviewQuery(_c13, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vActive = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vContent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vLimit = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vWrapper = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vPopup = _t.first);
      }
    },
    inputs: {
      activeElm: "activeElm",
      anchor: "anchor",
      anchorAlign: "anchorAlign",
      animation: "animation",
      buttons: "buttons",
      buttonVariant: "buttonVariant",
      closeOnEsc: "closeOnEsc",
      closeOnOverlayClick: "closeOnOverlayClick",
      closeOnScroll: "closeOnScroll",
      contentPadding: "contentPadding",
      cssClass: "cssClass",
      disableLeftRight: "disableLeftRight",
      display: "display",
      focusElm: "focusElm",
      focusOnClose: "focusOnClose",
      focusOnOpen: "focusOnOpen",
      focusTrap: "focusTrap",
      fullScreen: "fullScreen",
      headerText: "headerText",
      height: "height",
      isOpen: "isOpen",
      maxHeight: "maxHeight",
      maxWidth: "maxWidth",
      scrollLock: "scrollLock",
      setActive: "setActive",
      showArrow: "showArrow",
      showOverlay: "showOverlay",
      windowWidth: "windowWidth",
      width: "width",
      cancelText: "cancelText",
      closeText: "closeText",
      okText: "okText",
      setText: "setText"
    },
    outputs: {
      onButtonClick: "onButtonClick",
      onOverlayClick: "onOverlayClick",
      onClose: "onClose",
      onClosed: "onClosed",
      onKeyDown: "onKeyDown",
      onOpen: "onOpen",
      onPosition: "onPosition",
      onResize: "onResize"
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 4,
    vars: 2,
    consts: [["ngcontent", ""], ["wrapper", ""], ["limit", ""], ["popup", ""], ["active", ""], ["content", ""], [4, "ngIf"], [3, "ngTemplateOutlet", 4, "ngIf"], [3, "keydown"], [3, "class", "click", 4, "ngIf"], [3, "ngStyle"], ["role", "dialog", "aria-modal", "true", 3, "animationend", "click", "ngStyle"], [3, "class", 4, "ngIf"], ["tabindex", "-1", 1, "mbsc-popup-focus"], [3, "class", "innerHTML", 4, "ngIf"], [3, "ngTemplateOutlet"], [3, "click"], [3, "innerHTML"], [3, "color", "class", "disabled", "icon", "theme", "themeVariant", "variant", "click", 4, "ngFor", "ngForOf"], [3, "click", "color", "disabled", "icon", "theme", "themeVariant", "variant"]],
    template: function MbscPopup_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, MbscPopup_ng_template_0_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, MbscPopup_ng_container_2_Template, 17, 17, "ng-container", 6)(3, MbscPopup_ng_container_3_Template, 1, 1, "ng-container", 7);
      }
      if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx._isModal && ctx._isVisible);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx._isModal);
      }
    },
    dependencies: [MbscButton, NgIf, NgStyle, NgTemplateOutlet, NgForOf],
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscPopup;
}(PopupBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscPrompt = /*#__PURE__*/function () {
  function MbscPrompt() {
    this.value = "";
  }
  MbscPrompt.ɵfac = function MbscPrompt_Factory(t) {
    return new (t || MbscPrompt)();
  };
  MbscPrompt.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscPrompt,
    selectors: [["mbsc-prompt"]],
    viewQuery: function MbscPrompt_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c13, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.popup = _t.first);
      }
    },
    inputs: {
      inputType: "inputType",
      label: "label",
      message: "message",
      placeholder: "placeholder",
      title: "title",
      props: "props",
      value: "value"
    },
    decls: 7,
    vars: 9,
    consts: [["popup", ""], [3, "options"], [1, "mbsc-alert-content"], ["class", "mbsc-alert-title", 4, "ngIf"], [1, "mbsc-alert-message"], [1, "mbsc-prompt-input", 3, "valueChange", "label", "placeholder", "theme", "themeVariant", "type", "value"], [1, "mbsc-alert-title"]],
    template: function MbscPrompt_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "mbsc-popup", 1, 0)(2, "div", 2);
        i0.ɵɵtemplate(3, MbscPrompt_h2_3_Template, 2, 1, "h2", 3);
        i0.ɵɵelementStart(4, "p", 4);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "mbsc-input", 5);
        i0.ɵɵtwoWayListener("valueChange", function MbscPrompt_Template_mbsc_input_valueChange_6_listener($event) {
          i0.ɵɵrestoreView(_r1);
          i0.ɵɵtwoWayBindingSet(ctx.value, $event) || (ctx.value = $event);
          return i0.ɵɵresetView($event);
        });
        i0.ɵɵelementEnd()()();
      }
      if (rf & 2) {
        i0.ɵɵproperty("options", ctx.props);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.title);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.message || "");
        i0.ɵɵadvance();
        i0.ɵɵproperty("label", ctx.label)("placeholder", ctx.placeholder || "")("theme", ctx.props.theme)("themeVariant", ctx.props.themeVariant)("type", ctx.inputType);
        i0.ɵɵtwoWayProperty("value", ctx.value);
      }
    },
    dependencies: [MbscPopup, MbscInput, NgIf],
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscPrompt;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscSnackbar = /*#__PURE__*/function () {
  function MbscSnackbar() {}
  MbscSnackbar.prototype.onButtonClick = function () {
    this.popup.close();
    if (this.button && this.button.action) {
      this.button.action();
    }
  };
  MbscSnackbar.ɵfac = function MbscSnackbar_Factory(t) {
    return new (t || MbscSnackbar)();
  };
  MbscSnackbar.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscSnackbar,
    selectors: [["mbsc-snackbar"]],
    viewQuery: function MbscSnackbar_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c13, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.popup = _t.first);
      }
    },
    inputs: {
      button: "button",
      message: "message",
      props: "props"
    },
    decls: 6,
    vars: 3,
    consts: [["popup", ""], [3, "options"], [1, "mbsc-snackbar-cont", "mbsc-toast-background", "mbsc-flex"], [1, "mbsc-snackbar-message", "mbsc-flex-1-1"], ["class", "mbsc-snackbar-button", "variant", "flat", 3, "icon", "theme", "themeVariant", "click", 4, "ngIf"], ["variant", "flat", 1, "mbsc-snackbar-button", 3, "click", "icon", "theme", "themeVariant"]],
    template: function MbscSnackbar_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "mbsc-popup", 1, 0)(2, "div", 2)(3, "div", 3);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, MbscSnackbar_mbsc_button_5_Template, 2, 4, "mbsc-button", 4);
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        i0.ɵɵproperty("options", ctx.props);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.message);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.button);
      }
    },
    dependencies: [MbscPopup, MbscButton, NgIf],
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscSnackbar;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscPopupModule = /*#__PURE__*/function () {
  function MbscPopupModule() {}
  MbscPopupModule.ɵfac = function MbscPopupModule_Factory(t) {
    return new (t || MbscPopupModule)();
  };
  MbscPopupModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MbscPopupModule
  });
  MbscPopupModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule, MbscButtonModule, MbscInputModule]]
  });
  return MbscPopupModule;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscCalendarLabel = /*#__PURE__*/function (_super) {
  __extends(MbscCalendarLabel, _super);
  function MbscCalendarLabel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MbscCalendarLabel.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscCalendarLabel_BaseFactory;
    return function MbscCalendarLabel_Factory(t) {
      return (ɵMbscCalendarLabel_BaseFactory || (ɵMbscCalendarLabel_BaseFactory = i0.ɵɵgetInheritedFactory(MbscCalendarLabel)))(t || MbscCalendarLabel);
    };
  })();
  MbscCalendarLabel.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscCalendarLabel,
    selectors: [["mbsc-calendar-label"]],
    hostVars: 9,
    hostBindings: function MbscCalendarLabel_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("click", function MbscCalendarLabel_click_HostBindingHandler($event) {
          return ctx._onClick($event);
        })("contextmenu", function MbscCalendarLabel_contextmenu_HostBindingHandler($event) {
          return ctx._onRightClick($event);
        });
      }
      if (rf & 2) {
        i0.ɵɵattribute("aria-hidden", ctx.showText ? null : "true")("data-id", ctx.showText && ctx.event ? ctx.event.id : null)("role", ctx.showText ? "button" : null)("tabindex", ctx._tabIndex)("title", ctx._title);
        i0.ɵɵclassMap(ctx._cssClass);
        i0.ɵɵstyleProp("color", ctx._color);
      }
    },
    inputs: {
      amText: "amText",
      contentTemplate: "contentTemplate",
      count: "count",
      dataTimezone: "dataTimezone",
      date: "date",
      displayTimezone: "displayTimezone",
      drag: "drag",
      hidden: "hidden",
      firstDay: "firstDay",
      event: "event",
      editMode: "editMode",
      exclusiveEndDates: "exclusiveEndDates",
      inactive: "inactive",
      isActiveMonth: "isActiveMonth",
      label: "label",
      resize: "resize",
      hideLabel: "hideLabel",
      id: "id",
      isPicker: "isPicker",
      isUpdate: "isUpdate",
      lastDay: "lastDay",
      more: "more",
      pmText: "pmText",
      resourcesMap: "resourcesMap",
      selected: "selected",
      showEventTooltip: "showEventTooltip",
      showText: "showText",
      template: "template",
      timeFormat: "timeFormat",
      timezonePlugin: "timezonePlugin",
      onClick: "onClick",
      onDoubleClick: "onDoubleClick",
      onRightClick: "onRightClick",
      onHoverIn: "onHoverIn",
      onHoverOut: "onHoverOut",
      onDelete: "onDelete",
      onDragStart: "onDragStart",
      onDragMove: "onDragMove",
      onDragEnd: "onDragEnd",
      onDragModeOn: "onDragModeOn",
      onDragModeOff: "onDragModeOff"
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    decls: 5,
    vars: 5,
    consts: [[3, "class", 4, "ngIf"], [3, "class", "color", 4, "ngIf"], [4, "ngIf"], ["aria-hidden", "true", 3, "class", "color", "innerHTML", 4, "ngIf"], ["class", "mbsc-hidden-content", 4, "ngIf"], ["aria-hidden", "true", 3, "innerHTML"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "mbsc-hidden-content"]],
    template: function MbscCalendarLabel_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, MbscCalendarLabel_div_0_Template, 1, 2, "div", 0)(1, MbscCalendarLabel_div_1_Template, 1, 2, "div", 0)(2, MbscCalendarLabel_div_2_Template, 1, 2, "div", 0)(3, MbscCalendarLabel_div_3_Template, 4, 7, "div", 1)(4, MbscCalendarLabel_4_Template, 1, 4, null, 2);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx._hasResizeStart && ctx.event && ctx.event.editable !== false);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._hasResizeEnd && ctx.event && ctx.event.editable !== false);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.showText && !ctx.more && !ctx.template);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.template || !!ctx.more);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.showText && !ctx.more && ctx.template);
      }
    },
    dependencies: [NgIf, NgTemplateOutlet],
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscCalendarLabel;
}(CalendarLabelBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscCalendarDay = /*#__PURE__*/function (_super) {
  __extends(MbscCalendarDay, _super);
  function MbscCalendarDay() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._computeEventResize = computeEventResize;
    return _this;
  }
  MbscCalendarDay.prototype._getLabelKey = function (index, label) {
    return label.id;
  };
  MbscCalendarDay.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscCalendarDay_BaseFactory;
    return function MbscCalendarDay_Factory(t) {
      return (ɵMbscCalendarDay_BaseFactory || (ɵMbscCalendarDay_BaseFactory = i0.ɵɵgetInheritedFactory(MbscCalendarDay)))(t || MbscCalendarDay);
    };
  })();
  MbscCalendarDay.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscCalendarDay,
    selectors: [["mbsc-calendar-day"]],
    hostVars: 7,
    hostBindings: function MbscCalendarDay_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("click", function MbscCalendarDay_click_HostBindingHandler($event) {
          return ctx._onClick($event);
        })("contextmenu", function MbscCalendarDay_contextmenu_HostBindingHandler($event) {
          return ctx._onRightClick($event);
        });
      }
      if (rf & 2) {
        i0.ɵɵattribute("tabindex", ctx.s.disabled ? null : ctx.s.active ? 0 : -1);
        i0.ɵɵclassMap(ctx._cssClass);
        i0.ɵɵstyleProp("background-color", ctx._cellStyles ? ctx._cellStyles.backgroundColor : "")("color", ctx._cellStyles ? ctx._cellStyles.color : "");
      }
    },
    inputs: {
      active: "active",
      amText: "amText",
      clickToCreate: "clickToCreate",
      colors: "colors",
      dataTimezone: "dataTimezone",
      date: "date",
      day: "day",
      dayTemplate: "dayTemplate",
      dayContentTemplate: "dayContentTemplate",
      disabled: "disabled",
      display: "display",
      displayTimezone: "displayTimezone",
      dragToCreate: "dragToCreate",
      dragToResize: "dragToResize",
      dragToMove: "dragToMove",
      eventText: "eventText",
      events: "events",
      eventsText: "eventsText",
      exclusiveEndDates: "exclusiveEndDates",
      firstDay: "firstDay",
      hasMarks: "hasMarks",
      hoverEnd: "hoverEnd",
      hoverStart: "hoverStart",
      isActiveMonth: "isActiveMonth",
      isPicker: "isPicker",
      labels: "labels",
      labelTemplate: "labelTemplate",
      labelContentTemplate: "labelContentTemplate",
      dragData: "dragData",
      marks: "marks",
      month: "month",
      monthShort: "monthShort",
      outer: "outer",
      pmText: "pmText",
      rangeEnd: "rangeEnd",
      rangeStart: "rangeStart",
      resourcesMap: "resourcesMap",
      selected: "selected",
      selectedEventsMap: "selectedEventsMap",
      showEventTooltip: "showEventTooltip",
      text: "text",
      timeFormat: "timeFormat",
      timezonePlugin: "timezonePlugin",
      todayText: "todayText",
      type: "type",
      year: "year",
      onDayClick: "onDayClick",
      onDayDoubleClick: "onDayDoubleClick",
      onDayRightClick: "onDayRightClick",
      onHoverIn: "onHoverIn",
      onHoverOut: "onHoverOut",
      onLabelClick: "onLabelClick",
      onLabelDoubleClick: "onLabelDoubleClick",
      onLabelRightClick: "onLabelRightClick",
      onLabelHoverIn: "onLabelHoverIn",
      onLabelHoverOut: "onLabelHoverOut",
      onLabelDelete: "onLabelDelete",
      onLabelUpdateStart: "onLabelUpdateStart",
      onLabelUpdateMove: "onLabelUpdateMove",
      onLabelUpdateEnd: "onLabelUpdateEnd",
      onLabelUpdateModeOn: "onLabelUpdateModeOn",
      onLabelUpdateModeOff: "onLabelUpdateModeOff"
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    decls: 7,
    vars: 8,
    consts: [[4, "ngIf"], ["aria-hidden", "true", 3, "class", 4, "ngIf"], ["role", "button", 3, "class", "ngStyle", 4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["aria-hidden", "true"], ["role", "button", 3, "ngStyle"], [3, "class", "background", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "class", 4, "ngIf"], [1, "mbsc-calendar-labels"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "mbsc-calendar-text", "mbsc-calendar-text-placeholder"], [3, "amText", "date", "dataTimezone", "displayTimezone", "drag", "resize", "event", "exclusiveEndDates", "firstDay", "hidden", "isUpdate", "pmText", "resourcesMap", "rtl", "showEventTooltip", "showText", "theme", "timeFormat", "timezonePlugin", "template", "contentTemplate", "onClick", "onDoubleClick", "onRightClick", "onHoverIn", "onHoverOut", "onDelete", "onDragStart", "onDragMove", "onDragEnd", "onDragModeOn", "onDragModeOff"], [3, "amText", "date", "dataTimezone", "displayTimezone", "drag", "resize", "event", "exclusiveEndDates", "firstDay", "isUpdate", "pmText", "resourcesMap", "rtl", "showEventTooltip", "showText", "theme", "timeFormat", "timezonePlugin", "template", "contentTemplate", "onClick", "onDoubleClick", "onRightClick", "onHoverIn", "onHoverOut", "onDelete", "onDragStart", "onDragMove", "onDragEnd", "onDragModeOn", "onDragModeOff"], ["class", "mbsc-calendar-text mbsc-calendar-text-placeholder", 4, "ngIf"], [3, "count", "id", "isActiveMonth", "label", "more", "rtl", "theme", "onClick", "onDoubleClick", "onRightClick", "onHoverIn", "onHoverOut", "showText", 4, "ngIf"], [3, "amText", "date", "dataTimezone", "displayTimezone", "drag", "resize", "event", "exclusiveEndDates", "firstDay", "id", "inactive", "isActiveMonth", "isPicker", "label", "pmText", "resourcesMap", "rtl", "selected", "showText", "showEventTooltip", "theme", "timeFormat", "timezonePlugin", "template", "contentTemplate", "onClick", "onDoubleClick", "onRightClick", "onHoverIn", "onHoverOut", "onDelete", "onDragStart", "onDragMove", "onDragEnd", "onDragModeOn", "onDragModeOff", 4, "ngIf"], [3, "count", "id", "isActiveMonth", "label", "more", "rtl", "theme", "onClick", "onDoubleClick", "onRightClick", "onHoverIn", "onHoverOut", "showText"], [1, "mbsc-calendar-label-wrapper"], [3, "amText", "date", "dataTimezone", "displayTimezone", "drag", "resize", "event", "exclusiveEndDates", "firstDay", "id", "inactive", "isActiveMonth", "isPicker", "label", "lastDay", "pmText", "resourcesMap", "rtl", "selected", "showEventTooltip", "showText", "theme", "timeFormat", "timezonePlugin", "template", "contentTemplate", "onClick", "onDoubleClick", "onRightClick", "onHoverIn", "onHoverOut", "onDelete", "onDragStart", "onDragMove", "onDragEnd", "onDragModeOn", "onDragModeOff"], [3, "date", "dataTimezone", "displayTimezone", "drag", "resize", "event", "exclusiveEndDates", "firstDay", "id", "inactive", "label", "resourcesMap", "rtl", "showEventTooltip", "theme", "timeFormat", "timezonePlugin", "template", "contentTemplate", "onClick", "onDoubleClick", "onRightClick", "onHoverIn", "onHoverOut", "onDelete", "onDragStart", "onDragMove", "onDragEnd", "onDragModeOn", "onDragModeOff"], [3, "amText", "date", "dataTimezone", "displayTimezone", "drag", "resize", "event", "exclusiveEndDates", "firstDay", "id", "inactive", "isActiveMonth", "isPicker", "label", "pmText", "resourcesMap", "rtl", "selected", "showText", "showEventTooltip", "theme", "timeFormat", "timezonePlugin", "template", "contentTemplate", "onClick", "onDoubleClick", "onRightClick", "onHoverIn", "onHoverOut", "onDelete", "onDragStart", "onDragMove", "onDragEnd", "onDragModeOn", "onDragModeOff"]],
    template: function MbscCalendarDay_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, MbscCalendarDay_1_Template, 1, 4, null, 0)(2, MbscCalendarDay_div_2_Template, 2, 3, "div", 1)(3, MbscCalendarDay_div_3_Template, 2, 6, "div", 2)(4, MbscCalendarDay_div_4_Template, 3, 4, "div", 0)(5, MbscCalendarDay_5_Template, 1, 4, null, 0)(6, MbscCalendarDay_div_6_Template, 6, 4, "div", 0);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵclassMap("mbsc-calendar-cell-inner mbsc-calendar-" + ctx.s.type + "-inner" + ctx._theme + (ctx.s.type === "day" ? "" : ctx._hb) + (ctx.s.display ? "" : " mbsc-calendar-day-hidden"));
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.dayTemplate);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.s.text === 1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.dayTemplate);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.s.marks && !ctx.dayTemplate);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.dayContentTemplate);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.s.labels);
      }
    },
    dependencies: [MbscCalendarLabel, NgIf, NgTemplateOutlet, NgStyle, NgForOf],
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscCalendarDay;
}(CalendarDayBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscCalendarWeekDays = /*#__PURE__*/function () {
  function MbscCalendarWeekDays() {
    this.days = ARRAY7;
  }
  MbscCalendarWeekDays.ɵfac = function MbscCalendarWeekDays_Factory(t) {
    return new (t || MbscCalendarWeekDays)();
  };
  MbscCalendarWeekDays.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscCalendarWeekDays,
    selectors: [["mbsc-calendar-weekdays"]],
    hostAttrs: ["aria-hidden", "true", 1, "mbsc-calendar-week-days", "mbsc-flex"],
    inputs: {
      firstDay: "firstDay",
      hasScroll: "hasScroll",
      dayNamesShort: "dayNamesShort",
      rtl: "rtl",
      showWeekNumbers: "showWeekNumbers",
      theme: "theme"
    },
    decls: 3,
    vars: 3,
    consts: [[3, "ngClass", 4, "ngIf"], [3, "ngClass", 4, "ngFor", "ngForOf"], ["class", "mbsc-schedule-fake-scroll-y", 4, "ngIf"], [3, "ngClass"], [1, "mbsc-schedule-fake-scroll-y"]],
    template: function MbscCalendarWeekDays_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, MbscCalendarWeekDays_div_0_Template, 1, 1, "div", 0)(1, MbscCalendarWeekDays_div_1_Template, 2, 2, "div", 1)(2, MbscCalendarWeekDays_div_2_Template, 1, 0, "div", 2);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.showWeekNumbers);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.days);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.hasScroll);
      }
    },
    dependencies: [NgIf, NgClass, NgForOf],
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscCalendarWeekDays;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscMonthView = /*#__PURE__*/function (_super) {
  __extends(MbscMonthView, _super);
  function MbscMonthView() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MbscMonthView.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscMonthView_BaseFactory;
    return function MbscMonthView_Factory(t) {
      return (ɵMbscMonthView_BaseFactory || (ɵMbscMonthView_BaseFactory = i0.ɵɵgetInheritedFactory(MbscMonthView)))(t || MbscMonthView);
    };
  })();
  MbscMonthView.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscMonthView,
    selectors: [["mbsc-month-view"]],
    inputs: {
      activeDate: "activeDate",
      amText: "amText",
      calendarType: "calendarType",
      cellTextHeight: "cellTextHeight",
      clickToCreate: "clickToCreate",
      colors: "colors",
      dataTimezone: "dataTimezone",
      dayNames: "dayNames",
      dayNamesMin: "dayNamesMin",
      dayNamesShort: "dayNamesShort",
      dayTemplate: "dayTemplate",
      dayContentTemplate: "dayContentTemplate",
      displayTimezone: "displayTimezone",
      dragToCreate: "dragToCreate",
      dragToResize: "dragToResize",
      dragToMove: "dragToMove",
      eventText: "eventText",
      events: "events",
      eventsText: "eventsText",
      exclusiveEndDates: "exclusiveEndDates",
      firstDay: "firstDay",
      firstPageDay: "firstPageDay",
      hasMarks: "hasMarks",
      hoverEnd: "hoverEnd",
      hoverStart: "hoverStart",
      isActive: "isActive",
      isPicker: "isPicker",
      invalid: "invalid",
      labels: "labels",
      labelHeight: "labelHeight",
      labelTemplate: "labelTemplate",
      labelContentTemplate: "labelContentTemplate",
      dragData: "dragData",
      marked: "marked",
      max: "max",
      min: "min",
      monthNames: "monthNames",
      monthNamesShort: "monthNamesShort",
      pmText: "pmText",
      rangeEnd: "rangeEnd",
      rangeStart: "rangeStart",
      selectedDates: "selectedDates",
      selectedEventsMap: "selectedEventsMap",
      showEventTooltip: "showEventTooltip",
      showOuter: "showOuter",
      showWeekDays: "showWeekDays",
      showWeekNumbers: "showWeekNumbers",
      showSingleMark: "showSingleMark",
      resourcesMap: "resourcesMap",
      todayText: "todayText",
      timeFormat: "timeFormat",
      timezonePlugin: "timezonePlugin",
      valid: "valid",
      variableRow: "variableRow",
      weeks: "weeks",
      weekText: "weekText",
      getDate: "getDate",
      getDay: "getDay",
      getMonth: "getMonth",
      getWeekNumber: "getWeekNumber",
      getYear: "getYear",
      onDayClick: "onDayClick",
      onDayDoubleClick: "onDayDoubleClick",
      onDayRightClick: "onDayRightClick",
      onDayHoverIn: "onDayHoverIn",
      onDayHoverOut: "onDayHoverOut",
      onLabelClick: "onLabelClick",
      onLabelDoubleClick: "onLabelDoubleClick",
      onLabelRightClick: "onLabelRightClick",
      onLabelHoverIn: "onLabelHoverIn",
      onLabelHoverOut: "onLabelHoverOut",
      onLabelDelete: "onLabelDelete",
      onLabelUpdateStart: "onLabelUpdateStart",
      onLabelUpdateMove: "onLabelUpdateMove",
      onLabelUpdateEnd: "onLabelUpdateEnd",
      onLabelUpdateModeOn: "onLabelUpdateModeOn",
      onLabelUpdateModeOff: "onLabelUpdateModeOff"
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    decls: 3,
    vars: 6,
    consts: [[3, "rtl", "theme", "firstDay", "dayNamesShort", "showWeekNumbers", 4, "ngIf"], ["class", "mbsc-calendar-row mbsc-flex mbsc-flex-1-0", 3, "minHeight", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "rtl", "theme", "firstDay", "dayNamesShort", "showWeekNumbers"], [1, "mbsc-calendar-row", "mbsc-flex", "mbsc-flex-1-0"], [3, "ngClass", 4, "ngIf"], ["type", "day", 3, "active", "amText", "colors", "clickToCreate", "date", "day", "dayTemplate", "dayContentTemplate", "disabled", "display", "dataTimezone", "displayTimezone", "dragToCreate", "dragToResize", "dragToMove", "eventText", "events", "eventsText", "exclusiveEndDates", "firstDay", "hasMarks", "hoverEnd", "hoverStart", "isActiveMonth", "isPicker", "labels", "labelTemplate", "labelContentTemplate", "dragData", "marks", "month", "monthShort", "outer", "pmText", "rangeEnd", "rangeStart", "resourcesMap", "rtl", "selected", "selectedEventsMap", "showEventTooltip", "text", "timeFormat", "timezonePlugin", "todayText", "theme", "year", "onDayClick", "onDayDoubleClick", "onDayRightClick", "onHoverIn", "onHoverOut", "onLabelClick", "onLabelDoubleClick", "onLabelRightClick", "onLabelHoverIn", "onLabelHoverOut", "onLabelDelete", "onLabelUpdateStart", "onLabelUpdateMove", "onLabelUpdateEnd", "onLabelUpdateModeOn", "onLabelUpdateModeOff", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "ngClass"], ["aria-hidden", "true"], [1, "mbsc-hidden-content"], ["type", "day", 3, "active", "amText", "colors", "clickToCreate", "date", "day", "dayTemplate", "dayContentTemplate", "disabled", "display", "dataTimezone", "displayTimezone", "dragToCreate", "dragToResize", "dragToMove", "eventText", "events", "eventsText", "exclusiveEndDates", "firstDay", "hasMarks", "hoverEnd", "hoverStart", "isActiveMonth", "isPicker", "labels", "labelTemplate", "labelContentTemplate", "dragData", "marks", "month", "monthShort", "outer", "pmText", "rangeEnd", "rangeStart", "resourcesMap", "rtl", "selected", "selectedEventsMap", "showEventTooltip", "text", "timeFormat", "timezonePlugin", "todayText", "theme", "year", "onDayClick", "onDayDoubleClick", "onDayRightClick", "onHoverIn", "onHoverOut", "onLabelClick", "onLabelDoubleClick", "onLabelRightClick", "onLabelHoverIn", "onLabelHoverOut", "onLabelDelete", "onLabelUpdateStart", "onLabelUpdateMove", "onLabelUpdateEnd", "onLabelUpdateModeOn", "onLabelUpdateModeOff"]],
    template: function MbscMonthView_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, MbscMonthView_mbsc_calendar_weekdays_1_Template, 1, 5, "mbsc-calendar-weekdays", 0)(2, MbscMonthView_div_2_Template, 3, 5, "div", 1);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵclassMap("mbsc-calendar-table mbsc-flex-col mbsc-flex-1-1" + (ctx.s.isActive ? " mbsc-calendar-table-active" : ""));
        i0.ɵɵattribute("aria-hidden", ctx.s.isActive ? undefined : "true");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.showWeekDays);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx._rows)("ngForTrackBy", ctx._getKey);
      }
    },
    dependencies: [MbscCalendarWeekDays, MbscCalendarDay, NgIf, NgForOf, NgClass],
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscMonthView;
}(MonthViewBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function getItem(items, i, min, max) {
  var item;
  if (i < min || i > max) {
    return;
  }
  if (isArray(items)) {
    var len = items.length;
    var index = i % len;
    item = items[index >= 0 ? index : index + len];
  } else {
    item = items(i);
  }
  return item;
}
var ScrollviewBase = /*#__PURE__*/function (_super) {
  __extends(ScrollviewBase, _super);
  function ScrollviewBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._currPos = 0;
    _this._delta = 0;
    _this._endPos = 0;
    _this._lastRaf = 0;
    _this._maxSnapScroll = 0;
    _this._margin = 0;
    _this._scrollEnd = debounce(function () {
      rafc(_this._raf);
      _this._raf = false;
      _this._onEnd();
      _this._hasScrolled = false;
    }, 200);
    _this._setInnerEl = function (el) {
      _this._innerEl = el;
    };
    _this._setScrollEl = function (el) {
      _this._scrollEl = el;
    };
    _this._setScrollEl3d = function (el) {
      _this._scrollEl3d = el;
    };
    _this._setScrollbarEl = function (el) {
      _this._scrollbarEl = el;
    };
    _this._setScrollbarContEl = function (el) {
      _this._scrollbarContEl = el;
    };
    _this._onStart = function (args) {
      var s = _this.s;
      _this._hook("onStart", {});
      if (s.changeOnEnd && _this._isScrolling || !s.mouseSwipe && !args.isTouch || !s.swipe) {
        return;
      }
      _this._started = true;
      _this._hasScrolled = _this._isScrolling;
      _this._currX = args.startX;
      _this._currY = args.startY;
      _this._delta = 0;
      _this._velocityX = 0;
      _this._velocityY = 0;
      _this._startPos = getPosition(_this._scrollEl, _this._isVertical);
      _this._timestamp = +new Date();
      if (_this._isScrolling) {
        rafc(_this._raf);
        _this._raf = false;
        _this._scroll(_this._startPos);
      }
    };
    _this._onMove = function (args) {
      var ev = args.domEvent;
      var s = _this.s;
      if (_this._isVertical || s.scrollLock) {
        if (ev.cancelable) {
          ev.preventDefault();
        }
      } else {
        if (_this._hasScrolled) {
          if (ev.cancelable) {
            ev.preventDefault();
          }
        } else if (ev.type === TOUCH_MOVE && (Math.abs(args.deltaY) > 7 || !s.swipe)) {
          _this._started = false;
        }
      }
      if (!_this._started) {
        return;
      }
      _this._delta = _this._isVertical ? args.deltaY : args.deltaX;
      if (_this._hasScrolled || Math.abs(_this._delta) > _this._threshold) {
        if (!_this._hasScrolled) {
          _this._hook("onGestureStart", {});
        }
        _this._hasScrolled = true;
        _this._isScrolling = true;
        if (!_this._raf) {
          _this._raf = raf(function () {
            return _this._move(args);
          });
        }
      }
    };
    _this._onEnd = function () {
      _this._started = false;
      if (_this._hasScrolled) {
        var s = _this.s;
        var v = (_this._isVertical ? _this._velocityY : _this._velocityX) * 17;
        var maxSnapScroll = _this._maxSnapScroll;
        var delta = _this._delta;
        var time = 0;
        delta += v * v * .5 * (v < 0 ? -1 : 1);
        if (maxSnapScroll) {
          delta = constrain(delta, -_this._round * maxSnapScroll, _this._round * maxSnapScroll);
        }
        var pos = constrain(round((_this._startPos + delta) / _this._round) * _this._round, _this._min, _this._max);
        var index = round(-pos * _this._rtlNr / s.itemSize) + _this._offset;
        var direction = delta > 0 ? _this._isVertical ? 270 : 360 : _this._isVertical ? 90 : 180;
        var diff = index - s.selectedIndex;
        time = s.time || Math.max(1e3, Math.abs(pos - _this._currPos) * 3);
        _this._hook("onGestureEnd", {
          direction: direction,
          index: index
        });
        _this._delta = 0;
        _this._scroll(pos, time);
        if (diff && !s.changeOnEnd) {
          _this._hook("onIndexChange", {
            index: index,
            diff: diff
          });
          if (s.selectedIndex === _this._prevIndex && s.selectedIndex !== index) {
            _this.forceUpdate();
          }
        }
      }
    };
    _this._onClick = function (ev) {
      if (_this._hasScrolled) {
        _this._hasScrolled = false;
        ev.stopPropagation();
        ev.preventDefault();
      }
    };
    _this._onScroll = function (ev) {
      ev.target.scrollTop = 0;
      ev.target.scrollLeft = 0;
    };
    _this._onMouseWheel = function (ev) {
      var delta = _this._isVertical ? ev.deltaY === UNDEFINED ? ev.wheelDelta || ev.detail : ev.deltaY : ev.deltaX;
      if (delta && _this.s.mousewheel) {
        ev.preventDefault();
        _this._hook("onStart", {});
        if (!_this._started) {
          _this._delta = 0;
          _this._velocityX = 0;
          _this._velocityY = 0;
          _this._startPos = _this._currPos;
          _this._hook("onGestureStart", {});
        }
        if (ev.deltaMode && ev.deltaMode === 1) {
          delta *= 15;
        }
        delta = constrain(-delta, -_this._scrollSnap, _this._scrollSnap);
        _this._delta += delta;
        if (_this._maxSnapScroll && Math.abs(_this._delta) > _this._round * _this._maxSnapScroll) {
          delta = 0;
        }
        if (_this._startPos + _this._delta < _this._min) {
          _this._startPos = _this._min;
          _this._delta = 0;
          delta = 0;
        }
        if (_this._startPos + _this._delta > _this._max) {
          _this._startPos = _this._max;
          _this._delta = 0;
          delta = 0;
        }
        if (!_this._raf) {
          _this._raf = raf(function () {
            return _this._move();
          });
        }
        if (!delta && _this._started) {
          return;
        }
        _this._hasScrolled = true;
        _this._isScrolling = true;
        _this._started = true;
        _this._scrollEnd();
      }
    };
    _this._onTrackStart = function (ev) {
      ev.stopPropagation();
      var args = {
        domEvent: ev,
        startX: getCoord(ev, "X", true),
        startY: getCoord(ev, "Y", true)
      };
      _this._onStart(args);
      _this._trackStartX = args.startX;
      _this._trackStartY = args.startY;
      if (ev.target === _this._scrollbarEl) {
        listen(_this._doc, MOUSE_UP, _this._onTrackEnd);
        listen(_this._doc, MOUSE_MOVE, _this._onTrackMove);
      } else {
        var top_1 = getOffset(_this._scrollbarContEl).top;
        var percent = (args.startY - top_1) / _this._barContSize;
        _this._startPos = _this._currPos = _this._max + (_this._min - _this._max) * percent;
        _this._hasScrolled = true;
        _this._onEnd();
      }
    };
    _this._onTrackMove = function (ev) {
      var barContSize = _this._barContSize;
      var endX = getCoord(ev, "X", true);
      var endY = getCoord(ev, "Y", true);
      var trackDelta = _this._isVertical ? endY - _this._trackStartY : endX - _this._trackStartX;
      var percent = trackDelta / barContSize;
      if (_this._isInfinite) {
        _this._delta = -(_this._maxSnapScroll * _this._round * 2 + barContSize) * percent;
      } else {
        _this._delta = (_this._min - _this._max - barContSize) * percent;
      }
      if (_this._hasScrolled || Math.abs(_this._delta) > _this._threshold) {
        if (!_this._hasScrolled) {
          _this._hook("onGestureStart", {});
        }
        _this._hasScrolled = true;
        _this._isScrolling = true;
        if (!_this._raf) {
          _this._raf = raf(function () {
            return _this._move({
              endX: endX,
              endY: endY
            }, !_this._isInfinite);
          });
        }
      }
    };
    _this._onTrackEnd = function () {
      _this._delta = 0;
      _this._startPos = _this._currPos;
      _this._onEnd();
      unlisten(_this._doc, MOUSE_UP, _this._onTrackEnd);
      unlisten(_this._doc, MOUSE_MOVE, _this._onTrackMove);
    };
    _this._onTrackClick = function (ev) {
      ev.stopPropagation();
    };
    return _this;
  }
  ScrollviewBase.prototype._render = function (s, state) {
    var prevS = this._prevS;
    var batchSize = s.batchSize;
    var batchSize3d = s.batchSize3d;
    var itemNr = s.itemNr || 1;
    var itemSize = s.itemSize;
    var selectedIndex = s.selectedIndex;
    var prevIndex = prevS.selectedIndex;
    var currIndex = state.index === UNDEFINED ? selectedIndex : state.index;
    var visibleItems = [];
    var visible3dItems = [];
    var diff = selectedIndex - prevIndex;
    var diff2 = currIndex - this._currIndex;
    var minIndex = s.minIndex;
    var maxIndex = s.maxIndex;
    var items = s.items;
    var offset = s.offset;
    this._currIndex = currIndex;
    this._isVertical = s.axis === "Y";
    this._threshold = this._isVertical ? s.thresholdY : s.thresholdX;
    this._rtlNr = !this._isVertical && s.rtl ? -1 : 1;
    this._round = s.snap ? itemSize : 1;
    var scrollSnap = this._round;
    while (scrollSnap > 44) {
      scrollSnap /= 2;
    }
    this._scrollSnap = round(44 / scrollSnap) * scrollSnap;
    if (items) {
      for (var i = currIndex - batchSize; i < currIndex + itemNr + batchSize; i++) {
        visibleItems.push({
          key: i,
          data: getItem(items, i, minIndex, maxIndex)
        });
      }
      if (s.scroll3d) {
        for (var i = currIndex - batchSize3d; i < currIndex + itemNr + batchSize3d; i++) {
          visible3dItems.push({
            key: i,
            data: getItem(items, i, minIndex, maxIndex)
          });
        }
      }
      this.visibleItems = visibleItems;
      this.visible3dItems = visible3dItems;
      this._maxSnapScroll = batchSize;
      this._isInfinite = typeof items === "function";
    }
    if (this._offset === UNDEFINED) {
      this._offset = selectedIndex;
    }
    var nextPos = -(selectedIndex - this._offset) * itemSize * this._rtlNr;
    if (Math.abs(diff) > batchSize && nextPos !== this._endPos) {
      var off = diff + batchSize * (diff > 0 ? -1 : 1);
      this._offset += off;
      this._margin -= off;
    }
    if (offset && offset !== prevS.offset) {
      this._offset += offset;
      this._margin -= offset;
    }
    if (diff2) {
      this._margin += diff2;
    }
    if (minIndex !== UNDEFINED) {
      this._max = -(minIndex - this._offset) * itemSize * this._rtlNr;
    } else {
      this._max = Infinity;
    }
    if (maxIndex !== UNDEFINED) {
      this._min = -(maxIndex - this._offset - (s.spaceAround ? 0 : itemNr - 1)) * itemSize * this._rtlNr;
    } else {
      this._min = -Infinity;
    }
    if (this._rtlNr === -1) {
      var temp = this._min;
      this._min = this._max;
      this._max = temp;
    }
    if (this._min > this._max) {
      this._min = this._max;
    }
    var visibleSize = s.visibleSize;
    var barContSize = visibleSize * itemSize;
    this._barContSize = barContSize;
    this._barSize = Math.max(20, barContSize * barContSize / (this._max - this._min + barContSize));
    this._cssClass = this._className + " mbsc-ltr";
  };
  ScrollviewBase.prototype._mounted = function () {
    var el = this._el;
    var scrollbar = this._scrollbarContEl;
    this._doc = getDocument(el);
    listen(this.s.scroll3d ? this._innerEl : el, SCROLL, this._onScroll);
    listen(el, CLICK, this._onClick, true);
    listen(el, MOUSE_WHEEL, this._onMouseWheel, {
      passive: false
    });
    listen(el, WHEEL, this._onMouseWheel, {
      passive: false
    });
    listen(scrollbar, MOUSE_DOWN, this._onTrackStart);
    listen(scrollbar, CLICK, this._onTrackClick);
    this._unlisten = gestureListener(el, {
      onEnd: this._onEnd,
      onHoverIn: function () {
        scrollbar.classList.add("mbsc-scroller-bar-hover");
      },
      onHoverOut: function () {
        scrollbar.classList.remove("mbsc-scroller-bar-hover");
      },
      onMove: this._onMove,
      onStart: this._onStart,
      prevDef: true
    });
  };
  ScrollviewBase.prototype._updated = function () {
    var s = this.s;
    var batchSize = s.batchSize;
    var itemSize = s.itemSize;
    var selectedIndex = s.selectedIndex;
    var prevIndex = this._prevIndex;
    var shouldAnimate = !s.prevAnim && (prevIndex !== UNDEFINED && prevIndex !== selectedIndex || this._isAnimating);
    var newPos = -(selectedIndex - this._offset) * itemSize * this._rtlNr;
    if (s.margin) {
      this._scrollEl.style.marginTop = this._isVertical ? (this._margin - batchSize) * itemSize + "px" : "";
    }
    if (!this._started) {
      this._scroll(newPos, shouldAnimate ? this._isAnimating || s.time || 1e3 : 0);
    }
    this._prevIndex = selectedIndex;
  };
  ScrollviewBase.prototype._destroy = function () {
    unlisten(this.s.scroll3d ? this._innerEl : this._el, SCROLL, this._onScroll);
    unlisten(this._el, CLICK, this._onClick, true);
    unlisten(this._el, MOUSE_WHEEL, this._onMouseWheel, {
      passive: false
    });
    unlisten(this._el, WHEEL, this._onMouseWheel, {
      passive: false
    });
    unlisten(this._scrollbarContEl, MOUSE_DOWN, this._onTrackStart);
    unlisten(this._scrollbarContEl, CLICK, this._onTrackClick);
    rafc(this._raf);
    this._raf = false;
    this._scroll(0);
    this._unlisten();
  };
  ScrollviewBase.prototype._anim = function (dir) {
    var _this = this;
    return this._raf = raf(function () {
      var s = _this.s;
      var now = +new Date();
      if (!_this._raf) {
        return;
      }
      if ((_this._currPos - _this._endPos) * -dir < 4) {
        _this._currPos = _this._endPos;
        _this._raf = false;
        _this._isAnimating = 0;
        _this._isScrolling = false;
        _this._infinite(_this._currPos);
        _this._hook("onAnimationEnd", {});
        _this._scrollbarContEl.classList.remove("mbsc-scroller-bar-started");
        return;
      }
      if (now - _this._lastRaf > 100) {
        _this._lastRaf = now;
        _this._currPos = getPosition(_this._scrollEl, _this._isVertical);
        if (!s.changeOnEnd) {
          _this._infinite(_this._currPos);
        }
      }
      _this._raf = _this._anim(dir);
    });
  };
  ScrollviewBase.prototype._infinite = function (pos) {
    var s = this.s;
    if (s.itemSize) {
      var index = round(-pos * this._rtlNr / s.itemSize) + this._offset;
      var diff = index - this._currIndex;
      if (diff) {
        if (s.changeOnEnd) {
          this._hook("onIndexChange", {
            index: index,
            diff: diff
          });
        } else {
          this.setState({
            index: index
          });
        }
      }
    }
  };
  ScrollviewBase.prototype._scroll = function (pos, time) {
    var s = this.s;
    var itemSize = s.itemSize;
    var isVertical = this._isVertical;
    var style = this._scrollEl.style;
    var prefix = jsPrefix ? jsPrefix + "T" : "t";
    var timing = time ? cssPrefix + "transform " + round(time) + "ms " + s.easing : "";
    style[prefix + "ransform"] = "translate3d(" + (isVertical ? "0," + pos + "px," : pos + "px,0,") + "0)";
    style[prefix + "ransition"] = timing;
    this._endPos = pos;
    if (s.scroll3d) {
      var style3d = this._scrollEl3d.style;
      var angle = 360 / (s.batchSize3d * 2);
      style3d[prefix + "ransform"] = "translateY(-50%) rotateX(" + -pos / itemSize * angle + "deg)";
      style3d[prefix + "ransition"] = timing;
    }
    if (this._scrollbarEl) {
      var sbStyle = this._scrollbarEl.style;
      var percent = this._isInfinite ? (this._maxSnapScroll * this._round - this._delta) / (this._maxSnapScroll * this._round * 2) : (pos - this._max) / (this._min - this._max);
      var barPos = constrain((this._barContSize - this._barSize) * percent, 0, this._barContSize - this._barSize);
      sbStyle[prefix + "ransform"] = "translate3d(" + (isVertical ? "0," + barPos + "px," : barPos + "px,0,") + "0)";
      sbStyle[prefix + "ransition"] = timing;
    }
    if (time) {
      rafc(this._raf);
      this._isAnimating = time;
      this._scrollbarContEl.classList.add("mbsc-scroller-bar-started");
      this._raf = this._anim(pos > this._currPos ? 1 : -1);
    } else {
      this._currPos = pos;
      if (!s.changeOnEnd) {
        this._infinite(pos);
      }
    }
  };
  ScrollviewBase.prototype._move = function (args, preventMaxSnap) {
    var prevX = this._currX;
    var prevY = this._currY;
    var prevT = this._timestamp;
    var maxSnapScroll = this._maxSnapScroll;
    if (args) {
      this._currX = args.endX;
      this._currY = args.endY;
      this._timestamp = +new Date();
      var timeDelta = this._timestamp - prevT;
      if (timeDelta > 0 && timeDelta < 100) {
        var velocityX = (this._currX - prevX) / timeDelta;
        var velocityY = (this._currY - prevY) / timeDelta;
        this._velocityX = velocityX * .7 + this._velocityX * .3;
        this._velocityY = velocityY * .7 + this._velocityY * .3;
      }
    }
    if (maxSnapScroll && !preventMaxSnap) {
      this._delta = constrain(this._delta, -this._round * maxSnapScroll, this._round * maxSnapScroll);
    }
    this._scroll(constrain(this._startPos + this._delta, this._min - this.s.itemSize, this._max + this.s.itemSize));
    this._raf = false;
  };
  ScrollviewBase.defaults = {
    axis: "Y",
    batchSize: 40,
    easing: "cubic-bezier(0.190, 1.000, 0.220, 1.000)",
    mouseSwipe: true,
    mousewheel: true,
    prevDef: true,
    selectedIndex: 0,
    spaceAround: true,
    stopProp: true,
    swipe: true,
    thresholdX: 10,
    thresholdY: 5
  };
  ScrollviewBase.ɵfac = /* @__PURE__ */(() => {
    let ɵScrollviewBase_BaseFactory;
    return function ScrollviewBase_Factory(t) {
      return (ɵScrollviewBase_BaseFactory || (ɵScrollviewBase_BaseFactory = i0.ɵɵgetInheritedFactory(ScrollviewBase)))(t || ScrollviewBase);
    };
  })();
  ScrollviewBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: ScrollviewBase,
    selectors: [["", "mbsc-sv-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return ScrollviewBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscScrollviewBase = /*#__PURE__*/function (_super) {
  __extends(MbscScrollviewBase, _super);
  function MbscScrollviewBase() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(MbscScrollviewBase.prototype, "vEl3d", {
    set: function (el) {
      this._scrollEl3d = el && el.nativeElement;
    },
    enumerable: false,
    configurable: true
  });
  MbscScrollviewBase.prototype._mounted = function () {
    this._innerEl = this.vInnerEl.nativeElement;
    this._scrollEl = this.vEl.nativeElement;
    this._scrollbarContEl = this.vBarCont.nativeElement;
    this._scrollbarEl = this.vBar.nativeElement;
    _super.prototype._mounted.call(this);
  };
  MbscScrollviewBase.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscScrollviewBase_BaseFactory;
    return function MbscScrollviewBase_Factory(t) {
      return (ɵMbscScrollviewBase_BaseFactory || (ɵMbscScrollviewBase_BaseFactory = i0.ɵɵgetInheritedFactory(MbscScrollviewBase)))(t || MbscScrollviewBase);
    };
  })();
  MbscScrollviewBase.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscScrollviewBase,
    selectors: [["mbsc-scrollview-base"]],
    viewQuery: function MbscScrollviewBase_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c15, 7);
        i0.ɵɵviewQuery(_c16, 5);
        i0.ɵɵviewQuery(_c17, 7);
        i0.ɵɵviewQuery(_c18, 7);
        i0.ɵɵviewQuery(_c19, 7);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vEl = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vEl3d = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vInnerEl = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vBarCont = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vBar = _t.first);
      }
    },
    hostVars: 2,
    hostBindings: function MbscScrollviewBase_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx._cssClass);
      }
    },
    inputs: {
      axis: "axis",
      batchSize: "batchSize",
      batchSize3d: "batchSize3d",
      changeOnEnd: "changeOnEnd",
      easing: "easing",
      innerClass: "innerClass",
      innerStyles: "innerStyles",
      items: "items",
      itemSize: "itemSize",
      itemNr: "itemNr",
      selectedIndex: "selectedIndex",
      margin: "margin",
      maxIndex: "maxIndex",
      minIndex: "minIndex",
      mouseSwipe: "mouseSwipe",
      mousewheel: "mousewheel",
      offset: "offset",
      prevAnim: "prevAnim",
      scroll3d: "scroll3d",
      scrollBar: "scrollBar",
      snap: "snap",
      spaceAround: "spaceAround",
      swipe: "swipe",
      time: "time",
      touchUi: "touchUi",
      visibleSize: "visibleSize",
      onAnimationEnd: "onAnimationEnd",
      onGestureStart: "onGestureStart",
      onGestureEnd: "onGestureEnd",
      onIndexChange: "onIndexChange",
      onStart: "onStart"
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c21,
    decls: 10,
    vars: 12,
    consts: [["innerEl", ""], ["el", ""], ["barCont", ""], ["bar", ""], ["el3d", ""], [3, "ngStyle"], ["class", "mbsc-scroller-items-3d", 3, "height", 4, "ngIf"], [1, "mbsc-scroller-items-3d"]],
    template: function MbscScrollviewBase_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef(_c20);
        i0.ɵɵelementStart(0, "div", 5, 0)(2, "div", null, 1);
        i0.ɵɵprojection(4);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(5, MbscScrollviewBase_div_5_Template, 3, 2, "div", 6);
        i0.ɵɵelementStart(6, "div", null, 2);
        i0.ɵɵelement(8, "div", null, 3);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵclassMap(ctx.s.innerClass || "");
        i0.ɵɵproperty("ngStyle", ctx.s.innerStyles);
        i0.ɵɵadvance(2);
        i0.ɵɵclassMap("mbsc-scrollview-scroll" + ctx._rtl);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.s.scroll3d);
        i0.ɵɵadvance();
        i0.ɵɵclassMap("mbsc-scroller-bar-cont" + ctx._rtl + (!ctx.s.scrollBar || ctx._barSize === ctx._barContSize ? " mbsc-scroller-bar-hidden" : "") + (ctx._started ? " mbsc-scroller-bar-started" : ""));
        i0.ɵɵadvance(2);
        i0.ɵɵclassMap("mbsc-scroller-bar" + ctx._theme);
        i0.ɵɵstyleProp("height", ctx._barSize, "px");
      }
    },
    dependencies: [NgStyle, NgIf],
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscScrollviewBase;
}(ScrollviewBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscMultiYearView = /*#__PURE__*/function () {
  function MbscMultiYearView() {}
  MbscMultiYearView.prototype.ngOnChanges = function () {
    this._rows = [];
    this._selectedYear = this.getYear(new Date(this.active));
    this._activeYear = this.getYear(new Date(this.activeMonth));
    for (var i = 0; i < 4; i++) {
      var row = [];
      for (var j = 0; j < 3; j++) {
        var year = this.firstYear + i * 3 + j;
        var d = +this.getDate(year, 0, 1);
        row.push({
          d: d,
          year: year
        });
      }
      this._rows.push(row);
    }
  };
  MbscMultiYearView.prototype.getKey = function (index, item) {
    return item.key;
  };
  MbscMultiYearView.ɵfac = function MbscMultiYearView_Factory(t) {
    return new (t || MbscMultiYearView)();
  };
  MbscMultiYearView.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscMultiYearView,
    selectors: [["mbsc-multi-year-view"]],
    hostAttrs: [1, "mbsc-calendar-table", "mbsc-flex-col"],
    inputs: {
      active: "active",
      activeMonth: "activeMonth",
      firstYear: "firstYear",
      getDate: "getDate",
      getYear: "getYear",
      max: "max",
      min: "min",
      rtl: "rtl",
      theme: "theme",
      yearSuffix: "yearSuffix",
      onYearClick: "onYearClick"
    },
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 1,
    vars: 2,
    consts: [["class", "mbsc-calendar-row mbsc-flex mbsc-flex-1-0", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "mbsc-calendar-row", "mbsc-flex", "mbsc-flex-1-0"], ["type", "year", 3, "active", "date", "display", "selected", "disabled", "rtl", "text", "theme", "onDayClick", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["type", "year", 3, "active", "date", "display", "selected", "disabled", "rtl", "text", "theme", "onDayClick"]],
    template: function MbscMultiYearView_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, MbscMultiYearView_div_0_Template, 2, 2, "div", 0);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngForOf", ctx._rows)("ngForTrackBy", ctx.getKey);
      }
    },
    dependencies: [MbscCalendarDay, NgForOf],
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscMultiYearView;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscYearView = /*#__PURE__*/function () {
  function MbscYearView() {}
  MbscYearView.prototype.ngOnChanges = function () {
    this._rows = [];
    var active = new Date(this.activeMonth);
    var selected = new Date(this.active);
    this._activeYear = this.getYear(active);
    this._activeMonth = this.getMonth(active);
    this._selectedYear = this.getYear(selected);
    this._selectedMonth = this.getMonth(selected);
    for (var i = 0; i < 4; i++) {
      var row = [];
      for (var j = 0; j < 3; j++) {
        var d = this.getDate(this.year, i * 3 + j, 1);
        var y = this.getYear(d);
        var m = this.getMonth(d);
        row.push({
          d: d,
          y: y,
          m: m
        });
      }
      this._rows.push(row);
    }
  };
  MbscYearView.prototype.getKey = function (index, item) {
    return item.key;
  };
  MbscYearView.ɵfac = function MbscYearView_Factory(t) {
    return new (t || MbscYearView)();
  };
  MbscYearView.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscYearView,
    selectors: [["mbsc-year-view"]],
    hostAttrs: [1, "mbsc-calendar-table", "mbsc-flex-col"],
    inputs: {
      active: "active",
      activeMonth: "activeMonth",
      getDate: "getDate",
      getMonth: "getMonth",
      getYear: "getYear",
      max: "max",
      min: "min",
      monthNames: "monthNames",
      monthNamesShort: "monthNamesShort",
      rtl: "rtl",
      theme: "theme",
      year: "year",
      onMonthClick: "onMonthClick"
    },
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 1,
    vars: 2,
    consts: [["class", "mbsc-calendar-row mbsc-flex mbsc-flex-1-0", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "mbsc-calendar-row", "mbsc-flex", "mbsc-flex-1-0"], ["month", "monthNames[cell.m]", "type", "month", 3, "active", "date", "display", "selected", "disabled", "rtl", "text", "theme", "onDayClick", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["month", "monthNames[cell.m]", "type", "month", 3, "active", "date", "display", "selected", "disabled", "rtl", "text", "theme", "onDayClick"]],
    template: function MbscYearView_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, MbscYearView_div_0_Template, 2, 2, "div", 0);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngForOf", ctx._rows)("ngForTrackBy", ctx.getKey);
      }
    },
    dependencies: [MbscCalendarDay, NgForOf],
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscYearView;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscCalendarView = /*#__PURE__*/function (_super) {
  __extends(MbscCalendarView, _super);
  function MbscCalendarView() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._noop = noop;
    return _this;
  }
  MbscCalendarView.prototype._getFirstDay = function () {
    return +this.s.navService.firstDay;
  };
  MbscCalendarView.prototype._getMonthName = function (item) {
    return this.s.monthNames[new Date(item).getMonth()];
  };
  MbscCalendarView.prototype._mounted = function () {
    this._body = this.vBody.nativeElement;
    _super.prototype._mounted.call(this);
  };
  MbscCalendarView.prototype._updated = function () {
    this._pickerCont = this.vPickerCont && this.vPickerCont.nativeElement;
    _super.prototype._updated.call(this);
  };
  MbscCalendarView.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscCalendarView_BaseFactory;
    return function MbscCalendarView_Factory(t) {
      return (ɵMbscCalendarView_BaseFactory || (ɵMbscCalendarView_BaseFactory = i0.ɵɵgetInheritedFactory(MbscCalendarView)))(t || MbscCalendarView);
    };
  })();
  MbscCalendarView.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscCalendarView,
    selectors: [["mbsc-calendar-view"]],
    viewQuery: function MbscCalendarView_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c22, 5);
        i0.ɵɵviewQuery(_c23, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vBody = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vPickerCont = _t.first);
      }
    },
    hostVars: 6,
    hostBindings: function MbscCalendarView_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("click", function MbscCalendarView_click_HostBindingHandler() {
          return ctx._noop;
        });
      }
      if (rf & 2) {
        i0.ɵɵclassMap(ctx._cssClass);
        i0.ɵɵstyleProp("height", ctx._dim.height)("width", ctx._dim.width);
      }
    },
    inputs: {
      activeDate: "activeDate",
      cssClass: "cssClass",
      clickToCreate: "clickToCreate",
      colors: "colors",
      dataTimezone: "dataTimezone",
      dayTemplate: "dayTemplate",
      dayContentTemplate: "dayContentTemplate",
      displayTimezone: "displayTimezone",
      dragToCreate: "dragToCreate",
      dragToResize: "dragToResize",
      dragToMove: "dragToMove",
      endDay: "endDay",
      eventMap: "eventMap",
      eventOrder: "eventOrder",
      eventRange: "eventRange",
      eventRangeSize: "eventRangeSize",
      exclusiveEndDates: "exclusiveEndDates",
      fromText: "fromText",
      hasContent: "hasContent",
      hasPicker: "hasPicker",
      headerTemplate: "headerTemplate",
      height: "height",
      hoverEnd: "hoverEnd",
      hoverStart: "hoverStart",
      invalid: "invalid",
      instanceService: "instanceService",
      isPicker: "isPicker",
      labels: "labels",
      labelsMap: "labelsMap",
      labelTemplate: "labelTemplate",
      labelContentTemplate: "labelContentTemplate",
      dragData: "dragData",
      max: "max",
      marked: "marked",
      marksMap: "marksMap",
      min: "min",
      mouseSwipe: "mouseSwipe",
      mousewheel: "mousewheel",
      navService: "navService",
      navView: "navView",
      noOuterChange: "noOuterChange",
      downIcon: "downIcon",
      nextIconH: "nextIconH",
      nextIconV: "nextIconV",
      nextPageText: "nextPageText",
      prevIconH: "prevIconH",
      prevIconV: "prevIconV",
      prevPageText: "prevPageText",
      upIcon: "upIcon",
      pages: "pages",
      pageLoad: "pageLoad",
      refDate: "refDate",
      resourcesMap: "resourcesMap",
      rangeEnd: "rangeEnd",
      rangeStart: "rangeStart",
      responsiveStyle: "responsiveStyle",
      selectedDates: "selectedDates",
      selectedEventsMap: "selectedEventsMap",
      selectView: "selectView",
      showCalendar: "showCalendar",
      showControls: "showControls",
      showEventTooltip: "showEventTooltip",
      showLabelCount: "showLabelCount",
      showOuterDays: "showOuterDays",
      showSchedule: "showSchedule",
      showToday: "showToday",
      showWeekNumbers: "showWeekNumbers",
      size: "size",
      startDay: "startDay",
      swipe: "swipe",
      labelList: "labelList",
      timeFormat: "timeFormat",
      timezonePlugin: "timezonePlugin",
      update: "update",
      valid: "valid",
      weeks: "weeks",
      width: "width",
      calendarScroll: "calendarScroll",
      calendarType: "calendarType",
      getDate: "getDate",
      getDay: "getDay",
      getMaxDayOfMonth: "getMaxDayOfMonth",
      getMonth: "getMonth",
      getWeekNumber: "getWeekNumber",
      getYear: "getYear",
      amText: "amText",
      dateFormat: "dateFormat",
      dayNames: "dayNames",
      dayNamesMin: "dayNamesMin",
      dayNamesShort: "dayNamesShort",
      eventText: "eventText",
      eventsText: "eventsText",
      firstDay: "firstDay",
      monthNames: "monthNames",
      monthNamesShort: "monthNamesShort",
      moreEventsPluralText: "moreEventsPluralText",
      moreEventsText: "moreEventsText",
      pmText: "pmText",
      todayText: "todayText",
      toText: "toText",
      weekText: "weekText",
      yearSuffix: "yearSuffix",
      onActiveChange: "onActiveChange",
      onCellHoverIn: "onCellHoverIn",
      onCellHoverOut: "onCellHoverOut",
      onDayClick: "onDayClick",
      onDayDoubleClick: "onDayDoubleClick",
      onDayRightClick: "onDayRightClick",
      onDayHoverIn: "onDayHoverIn",
      onDayHoverOut: "onDayHoverOut",
      onGestureStart: "onGestureStart",
      onLabelClick: "onLabelClick",
      onLabelDoubleClick: "onLabelDoubleClick",
      onLabelRightClick: "onLabelRightClick",
      onLabelHoverIn: "onLabelHoverIn",
      onLabelHoverOut: "onLabelHoverOut",
      onLabelDelete: "onLabelDelete",
      onLabelUpdateStart: "onLabelUpdateStart",
      onLabelUpdateMove: "onLabelUpdateMove",
      onLabelUpdateEnd: "onLabelUpdateEnd",
      onLabelUpdateModeOn: "onLabelUpdateModeOn",
      onLabelUpdateModeOff: "onLabelUpdateModeOff",
      onPageChange: "onPageChange",
      onPageLoaded: "onPageLoaded",
      onPageLoading: "onPageLoading",
      onResize: "onResize",
      onTodayClick: "onTodayClick"
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 13,
    vars: 10,
    consts: [["monthView", ""], ["body", ""], ["picker", ""], ["defaultHeader", ""], ["scrollview", ""], ["pickerCont", ""], ["multiYearView", ""], ["yearView", ""], ["montView", ""], [3, "class", 4, "ngIf"], [3, "dayNamesShort", "firstDay", "hasScroll", "hidden", "showWeekNumbers", "rtl", "theme", 4, "ngIf"], [3, "keydown"], ["class", "mbsc-calendar-popup", "display", "anchored", 3, "anchor", "closeOnScroll", "contentPadding", "context", "isOpen", "locale", "rtl", "scrollLock", "showOverlay", "theme", "themeVariant", "onClose", "onOpen", 4, "ngIf"], [3, "ngTemplateOutlet"], [1, "mbsc-flex", "mbsc-flex-1-1", "mbsc-calendar-title-wrapper"], [1, "mbsc-calendar-header-today"], [3, "dayNamesShort", "firstDay", "hasScroll", "hidden", "showWeekNumbers", "rtl", "theme"], [3, "activeDate", "amText", "calendarType", "cellTextHeight", "clickToCreate", "colors", "dayNames", "dayNamesShort", "dayTemplate", "dayContentTemplate", "dataTimezone", "displayTimezone", "dragData", "dragToCreate", "dragToResize", "dragToMove", "eventText", "events", "eventsText", "exclusiveEndDates", "firstDay", "firstPageDay", "getDate", "getDay", "getMonth", "getYear", "getWeekNumber", "hasMarks", "hoverEnd", "hoverStart", "invalid", "isActive", "isPicker", "labels", "labelHeight", "labelTemplate", "labelContentTemplate", "marked", "max", "min", "monthNames", "monthNamesShort", "onDayClick", "onDayDoubleClick", "onDayRightClick", "onDayHoverIn", "onDayHoverOut", "onLabelClick", "onLabelDoubleClick", "onLabelRightClick", "onLabelHoverIn", "onLabelHoverOut", "onLabelDelete", "onLabelUpdateStart", "onLabelUpdateMove", "onLabelUpdateEnd", "onLabelUpdateModeOn", "onLabelUpdateModeOff", "pmText", "rangeEnd", "rangeStart", "resourcesMap", "rtl", "selectedDates", "selectedEventsMap", "showEventTooltip", "showOuter", "showSingleMark", "showWeekDays", "showWeekNumbers", "theme", "timeFormat", "timezonePlugin", "todayText", "valid", "variableRow", "weeks", "weekText"], [3, "class", "animationend", 4, "ngIf"], [4, "ngIf"], ["class", "mbsc-calendar-grid-row mbsc-flex mbsc-flex-1-1", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "mbsc-calendar-grid-row", "mbsc-flex", "mbsc-flex-1-1"], [3, "class", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "animationend"], ["easing", "ease-out", 1, "mbsc-calendar-scroll-wrapper", 3, "axis", "batchSize", "changeOnEnd", "items", "itemNr", "itemSize", "maxIndex", "minIndex", "mouseSwipe", "mousewheel", "onAnimationEnd", "onGestureStart", "onIndexChange", "onStart", "prevAnim", "rtl", "selectedIndex", "snap", "swipe", "time"], [3, "class", "ngStyle", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "ngStyle"], [4, "ngTemplateOutlet"], ["display", "anchored", 1, "mbsc-calendar-popup", 3, "onClose", "onOpen", "anchor", "closeOnScroll", "contentPadding", "context", "isOpen", "locale", "rtl", "scrollLock", "showOverlay", "theme", "themeVariant"], ["aria-live", "polite"], ["variant", "flat", 1, "mbsc-calendar-button", 3, "click", "theme", "themeVariant"], ["variant", "flat", 1, "mbsc-calendar-button", 3, "click", "disabled", "iconSvg", "theme", "themeVariant"], [1, "mbsc-calendar-picker-wrapper"], ["easing", "ease-out", 3, "axis", "batchSize", "changeOnEnd", "items", "itemSize", "maxIndex", "minIndex", "mousewheel", "onGestureEnd", "onIndexChange", "prevAnim", "rtl", "selectedIndex", "snap", "time"], [3, "active", "activeMonth", "firstYear", "getDate", "getYear", "max", "min", "rtl", "theme", "yearSuffix", "onYearClick"], [3, "active", "activeMonth", "getDate", "getMonth", "getYear", "max", "min", "monthNames", "monthNamesShort", "onMonthClick", "rtl", "theme", "year"], [3, "activeDate", "dataTimezone", "dayNames", "dayNamesShort", "displayTimezone", "firstDay", "firstPageDay", "getDate", "getDay", "getMonth", "getYear", "isActive", "max", "min", "monthNames", "monthNamesShort", "onDayClick", "rtl", "selectedDates", "showOuter", "showWeekDays", "theme", "timezonePlugin", "todayText"]],
    template: function MbscCalendarView_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "div")(1, "div");
        i0.ɵɵtemplate(2, MbscCalendarView_div_2_Template, 4, 3, "div", 9)(3, MbscCalendarView_mbsc_calendar_weekdays_3_Template, 1, 7, "mbsc-calendar-weekdays", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, MbscCalendarView_ng_template_4_Template, 1, 78, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementStart(6, "div", 11, 1);
        i0.ɵɵlistener("keydown", function MbscCalendarView_Template_div_keydown_6_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onKeyDown($event));
        });
        i0.ɵɵtemplate(8, MbscCalendarView_div_8_Template, 5, 6, "div", 9);
        i0.ɵɵelementEnd()();
        i0.ɵɵprojection(9);
        i0.ɵɵtemplate(10, MbscCalendarView_mbsc_popup_10_Template, 11, 29, "mbsc-popup", 12)(11, MbscCalendarView_ng_template_11_Template, 3, 3, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        i0.ɵɵclassMap("mbsc-calendar-wrapper mbsc-flex-col" + ctx._theme + ctx._hb + (ctx.s.hasContent || !ctx.s.showCalendar ? " mbsc-calendar-wrapper-fixed mbsc-flex-none" : " mbsc-flex-1-1"));
        i0.ɵɵadvance();
        i0.ɵɵclassMap("mbsc-calendar-header" + ctx._theme + ctx._hb + (ctx._showDaysTop ? " mbsc-calendar-header-vertical" : ""));
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.s.showControls);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._showDaysTop && ctx.s.showCalendar);
        i0.ɵɵadvance(3);
        i0.ɵɵclassMap("mbsc-calendar-body mbsc-flex-col mbsc-flex-1-1" + ctx._theme);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.s.showCalendar);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx._hasPicker);
      }
    },
    dependencies: [MbscCalendarNav, MbscCalendarPrev, MbscCalendarToday, MbscCalendarNext, MbscCalendarWeekDays, MbscMonthView, MbscScrollviewBase, MbscPopup, MbscButton, MbscMultiYearView, MbscYearView, NgIf, NgTemplateOutlet, NgForOf, NgStyle],
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscCalendarView;
}(CalendarViewBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscScrollviewBaseModule = /*#__PURE__*/function () {
  function MbscScrollviewBaseModule() {}
  MbscScrollviewBaseModule.ɵfac = function MbscScrollviewBaseModule_Factory(t) {
    return new (t || MbscScrollviewBaseModule)();
  };
  MbscScrollviewBaseModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MbscScrollviewBaseModule
  });
  MbscScrollviewBaseModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule]]
  });
  return MbscScrollviewBaseModule;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscCalendarViewModule = /*#__PURE__*/function () {
  function MbscCalendarViewModule() {}
  MbscCalendarViewModule.ɵfac = function MbscCalendarViewModule_Factory(t) {
    return new (t || MbscCalendarViewModule)();
  };
  MbscCalendarViewModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MbscCalendarViewModule
  });
  MbscCalendarViewModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule, MbscButtonModule, MbscCalendarHeaderModule, MbscIconModule, MbscPopupModule, MbscScrollviewBaseModule], MbscCalendarHeaderModule]
  });
  return MbscCalendarViewModule;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscCalendar = /*#__PURE__*/function (_super) {
  __extends(MbscCalendar, _super);
  function MbscCalendar() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._hours = ARRAY24;
    _this.onCancel = new EventEmitter();
    _this.onChange = new EventEmitter();
    _this.onClose = new EventEmitter();
    _this.onOpen = new EventEmitter();
    return _this;
  }
  Object.defineProperty(MbscCalendar.prototype, "vCal", {
    set: function (cal) {
      this._calendarView = cal;
    },
    enumerable: false,
    configurable: true
  });
  MbscCalendar.prototype._ctor = function () {
    this._instanceService = this._injector.get(MbscInstanceService);
  };
  MbscCalendar.prototype._mounted = function () {
    this._instanceService.instance = this;
    _super.prototype._mounted.call(this);
  };
  MbscCalendar.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscCalendar_BaseFactory;
    return function MbscCalendar_Factory(t) {
      return (ɵMbscCalendar_BaseFactory || (ɵMbscCalendar_BaseFactory = i0.ɵɵgetInheritedFactory(MbscCalendar)))(t || MbscCalendar);
    };
  })();
  MbscCalendar.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscCalendar,
    selectors: [["mbsc-calendar"]],
    viewQuery: function MbscCalendar_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c27, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vCal = _t.first);
      }
    },
    hostAttrs: [1, "mbsc-flex-1-1"],
    outputs: {
      onCancel: "onCancel",
      onChange: "onChange",
      onClose: "onClose",
      onOpen: "onOpen"
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    decls: 2,
    vars: 87,
    consts: [["cal", ""], [3, "activeDate", "amText", "cssClass", "calendarScroll", "calendarType", "colors", "context", "dataTimezone", "dayTemplate", "dayContentTemplate", "displayTimezone", "downIcon", "exclusiveEndDates", "fromText", "headerTemplate", "hoverEnd", "hoverStart", "invalid", "instanceService", "isPicker", "labels", "marked", "max", "min", "mousewheel", "navService", "nextIconH", "nextIconV", "nextPageText", "noOuterChange", "onActiveChange", "onCellHoverIn", "onCellHoverOut", "onDayClick", "onDayHoverIn", "onDayHoverOut", "onLabelClick", "onPageChange", "onPageLoaded", "onPageLoading", "onTodayClick", "pmText", "prevIconH", "prevIconV", "prevPageText", "pages", "rangeEnd", "rangeStart", "refDate", "rtl", "selectedDates", "selectView", "showCalendar", "showControls", "showOuterDays", "showToday", "showWeekNumbers", "size", "theme", "themeVariant", "timezonePlugin", "toText", "update", "upIcon", "valid", "weeks", "width", "getDate", "getDay", "getMaxDayOfMonth", "getMonth", "getWeekNumber", "getYear", "dateFormat", "dayNames", "dayNamesMin", "dayNamesShort", "eventText", "eventsText", "firstDay", "monthNames", "monthNamesShort", "moreEventsPluralText", "moreEventsText", "todayText", "weekText", "yearSuffix"]],
    template: function MbscCalendar_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelement(0, "mbsc-calendar-view", 1, 0);
      }
      if (rf & 2) {
        i0.ɵɵproperty("activeDate", ctx.s.active)("amText", ctx.s.amText)("cssClass", ctx._className + " mbsc-flex-1-1 mbsc-calendar-" + ctx.s.display)("calendarScroll", ctx.s.calendarScroll)("calendarType", ctx.s.calendarType)("colors", ctx.s.colors)("context", ctx.s.context)("dataTimezone", ctx.s.dataTimezone)("dayTemplate", ctx.s.dayTemplate)("dayContentTemplate", ctx.s.dayContentTemplate)("displayTimezone", ctx.s.displayTimezone)("downIcon", ctx.s.downIcon)("exclusiveEndDates", ctx.s.exclusiveEndDates)("fromText", ctx.s.fromText)("headerTemplate", ctx.s.calendarHeaderTemplate)("hoverEnd", ctx.s.hoverEnd)("hoverStart", ctx.s.hoverStart)("invalid", ctx.s.invalid)("instanceService", ctx._instanceService)("isPicker", true)("labels", ctx.s.labels)("marked", ctx.s.marked)("max", ctx.s.max)("min", ctx.s.min)("mousewheel", ctx.s.mousewheel)("navService", ctx._navService)("nextIconH", ctx.s.nextIconH)("nextIconV", ctx.s.nextIconV)("nextPageText", ctx.s.nextPageText)("noOuterChange", ctx.s.selectRange)("onActiveChange", ctx._onActiveChange)("onCellHoverIn", ctx.s.onCellHoverIn)("onCellHoverOut", ctx.s.onCellHoverOut)("onDayClick", ctx._onDayClick)("onDayHoverIn", ctx.s.onDayHoverIn)("onDayHoverOut", ctx.s.onDayHoverOut)("onLabelClick", ctx.s.onLabelClick)("onPageChange", ctx.s.onPageChange)("onPageLoaded", ctx.s.onPageLoaded)("onPageLoading", ctx.s.onPageLoading)("onTodayClick", ctx._onTodayClick)("pmText", ctx.s.pmText)("prevIconH", ctx.s.prevIconH)("prevIconV", ctx.s.prevIconV)("prevPageText", ctx.s.prevPageText)("pages", ctx.s.pages)("rangeEnd", ctx.s.rangeEnd)("rangeStart", ctx.s.rangeStart)("refDate", ctx.s.refDate)("rtl", ctx.s.rtl)("selectedDates", ctx._tempValueRep)("selectView", ctx.s.selectView)("showCalendar", true)("showControls", ctx.s.showControls)("showOuterDays", ctx.s.showOuterDays)("showToday", false)("showWeekNumbers", ctx.s.showWeekNumbers)("size", ctx.s.size)("theme", ctx.s.theme)("themeVariant", ctx.s.themeVariant)("timezonePlugin", ctx.s.timezonePlugin)("toText", ctx.s.toText)("update", ctx._update)("upIcon", ctx.s.upIcon)("valid", ctx.s.valid)("weeks", ctx.s.weeks)("width", ctx.s.width)("getDate", ctx.s.getDate)("getDay", ctx.s.getDay)("getMaxDayOfMonth", ctx.s.getMaxDayOfMonth)("getMonth", ctx.s.getMonth)("getWeekNumber", ctx.s.getWeekNumber)("getYear", ctx.s.getYear)("dateFormat", ctx.s.dateFormat)("dayNames", ctx.s.dayNames)("dayNamesMin", ctx.s.dayNamesMin)("dayNamesShort", ctx.s.dayNamesShort)("eventText", ctx.s.eventText)("eventsText", ctx.s.eventsText)("firstDay", ctx.s.firstDay)("monthNames", ctx.s.monthNames)("monthNamesShort", ctx.s.monthNamesShort)("moreEventsPluralText", ctx.s.moreEventsPluralText)("moreEventsText", ctx.s.moreEventsText)("todayText", ctx.s.todayText)("weekText", ctx.s.weekText)("yearSuffix", ctx.s.yearSuffix);
      }
    },
    dependencies: [MbscCalendarView],
    encapsulation: 2,
    changeDetection: 0
  });
  MbscCalendar = __decorate([FormControl], MbscCalendar);
  return MbscCalendar;
}(CalendarBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscCalendarModule = /*#__PURE__*/function () {
  function MbscCalendarModule() {}
  MbscCalendarModule.ɵfac = function MbscCalendarModule_Factory(t) {
    return new (t || MbscCalendarModule)();
  };
  MbscCalendarModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MbscCalendarModule
  });
  MbscCalendarModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule, MbscCalendarViewModule]]
  });
  return MbscCalendarModule;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function getPickerTemplate(content) {
  return '\n    <mbsc-input *ngIf="_showInput" #input\n      [ariaExpanded]="!!_isOpen"\n      [ariaHaspopup]="\'dialog\'"\n      [ariaLabel]="ariaLabel"\n      [dropdown]="dropdown"\n      [disabled]="disabled"\n      [endIcon]="endIcon"\n      [endIconSrc]="endIconSrc"\n      [endIconSvg]="endIconSvg"\n      [error]="error"\n      [errorMessage]="errorMessage"\n      [inputStyle]="s.inputStyle"\n      [label]="label"\n      [labelStyle]="s.labelStyle"\n      [name]="name"\n      [placeholder]="placeholder"\n      [pickerMap]="s.valueMap"\n      [pickerValue]="_value"\n      [role]="\'combobox\'"\n      [rtl]="s.rtl"\n      [startIcon]="startIcon"\n      [startIconSrc]="startIconSrc"\n      [startIconSvg]="startIconSvg"\n      [tags]="s.tagInput === undefined ? s.selectMultiple : s.tagInput"\n      [theme]="s.theme"\n      [themeVariant]="s.themeVariant"\n      [value]="(_value != null && _valueText) || \'\'"\n    >\n      <ng-content></ng-content>\n    </mbsc-input>\n    <mbsc-popup #popup\n      [activeElm]="s.activeElm"\n      [anchor]="_anchor"\n      [anchorAlign]="_anchorAlign"\n      [animation]="s.animation"\n      [buttons]="_buttons"\n      [cancelText]="s.cancelText"\n      [closeOnEsc]="s.closeOnEsc"\n      [closeOnOverlayClick]="s.closeOnOverlayClick"\n      [closeOnScroll]="s.closeOnScroll"\n      [closeText]="s.closeText"\n      [contentPadding]="false"\n      [context]="s.context"\n      [cssClass]="_cssClass"\n      [disableLeftRight]="true"\n      [display]="s.display"\n      [focusElm]="_focusElm"\n      [focusOnClose]="s.focusOnClose"\n      [focusOnOpen]="!_allowTyping"\n      [focusTrap]="s.focusTrap"\n      [fullScreen]="s.fullScreen"\n      [headerText]="_headerText"\n      [height]="s.height"\n      [isOpen]="_isOpen"\n      [maxHeight]="s.maxHeight"\n      [maxWidth]="_maxWidth"\n      [setText]="s.setText"\n      [showArrow]="s.showArrow"\n      [showOverlay]="_allowTyping ? false : s.showOverlay"\n      [rtl]="s.rtl"\n      [scrollLock]="_scrollLock"\n      [theme]="s.theme"\n      [themeVariant]="s.themeVariant"\n      [touchUi]="_touchUi"\n      [windowWidth]="state.width"\n      [width]="s.width"\n      (onClose)="_onPopupClose($event)"\n      (onClosed)="_onPopupClosed($event)"\n      (onKeyDown)="_onPopupKey($event)"\n      (onOpen)="_onPopupOpen($event)"\n      (onResize)="_onResize($event)"\n    >\n      <ng-container *ngIf="(_popup && _popup._isVisible) || s.display === \'inline\'">\n        '.concat(content, "\n      </ng-container>\n    </mbsc-popup>");
}
function getValid(wheel, val, disabled, direction) {
  var min = wheel.min === UNDEFINED ? -Infinity : wheel.min;
  var max = wheel.max === UNDEFINED ? Infinity : wheel.max;
  var index = getIndex(wheel, val);
  var value = getValue(wheel, index);
  var value1 = value;
  var value2 = value;
  var dist1 = 0;
  var dist2 = 0;
  if (disabled && disabled.get(value)) {
    while (index - dist1 >= min && disabled.get(value1) && dist1 < 100) {
      dist1++;
      value1 = getValue(wheel, index - dist1);
    }
    while (index + dist2 < max && disabled.get(value2) && dist2 < 100) {
      dist2++;
      value2 = getValue(wheel, index + dist2);
    }
    if (disabled.get(value1) && disabled.get(value2)) {
      return value;
    }
    if ((dist2 < dist1 && dist2 && direction !== -1 || !dist1 || index - dist1 < 0 || direction === 1) && !disabled.get(value2)) {
      value = value2;
    } else {
      value = value1;
    }
  }
  return value;
}
function getItemValue(item) {
  return item !== UNDEFINED ? item.value !== UNDEFINED ? item.value : item.display !== UNDEFINED ? item.display : item : item;
}
function getItem$1(wheel, index) {
  if (wheel.getItem) {
    return wheel.getItem(index);
  }
  var data = wheel.data || [];
  var len = data.length;
  var i = index % len;
  return wheel._circular ? data[i >= 0 ? i : i + len] : data[constrain(index, 0, len - 1)];
}
function getIndex(wheel, value) {
  var val = wheel.multiple ? value && value.length && value[0] || UNDEFINED : value;
  return (wheel.getIndex ? +wheel.getIndex(value) : wheel._map.get(val)) || 0;
}
function getFirstIndex(wheel, index) {
  if (wheel.getItem && wheel.getIndex) {
    return wheel.getIndex(getItemValue(wheel.getItem(index)));
  }
  var data = wheel.data || [];
  var len = data.length;
  var i = index % len;
  return !len ? 0 : i >= 0 ? i : i + len;
}
function getValue(wheel, index) {
  return getItemValue(getItem$1(wheel, index));
}
var ScrollerBase = /*#__PURE__*/function (_super) {
  __extends(ScrollerBase, _super);
  function ScrollerBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._indexes = [];
    _this._activeIndexes = [];
    _this._wheels = [];
    _this._batches = [];
    _this._lastIndexes = [];
    _this._onSet = function () {
      _this._setOrUpdate();
    };
    _this._onActiveChange = function (_a) {
      var wheel = _a.wheel,
        index = _a.index;
      var wheelIndex = wheel._key;
      _this._activeIndexes[wheelIndex] = index;
      var indexes = _this._indexes;
      var currentIndex = indexes[wheelIndex];
      if (_this._scroll3d) {
        currentIndex = index;
      } else if (index - currentIndex >= _this._rows) {
        currentIndex++;
      } else if (index < currentIndex) {
        currentIndex--;
      }
      indexes[wheelIndex] = currentIndex;
      _this.forceUpdate();
    };
    _this._onWheelIndexChange = function (args) {
      var s = _this.s;
      var wheel = args.wheel;
      var key = wheel._key;
      var isMultiple = wheel.multiple;
      var newValue = getValue(wheel, args.index);
      var disabled = _this._disabled && _this._disabled[key] && _this._disabled[key].get(newValue);
      var lengths = [];
      var selectOnScroll = s.selectOnScroll;
      var updateIndex = selectOnScroll || !args.click;
      if (updateIndex) {
        _this._lastIndexes[key] = _this._indexes[key] = args.index;
        _this._indexes.forEach(function (val, i) {
          var w = _this._wheelMap[i];
          var len = w.data ? w.data.length : 0;
          _this._batches[i] = len ? floor(val / len) : 0;
          lengths[i] = len;
        });
      }
      _this._activeIndexes[key] = args.index;
      var beforeTempValue = _this._get(_this._tempValueRep);
      var itemTap = !!args.click && !disabled;
      var scrollOrTapSelect = selectOnScroll || itemTap;
      if (isMultiple) {
        if (itemTap) {
          var selectionArr = __spreadArray([], _this._tempValueRep[key] || [], true);
          if (args.selected === false) {
            selectionArr.push(newValue);
          } else if (args.selected === true) {
            selectionArr.splice(selectionArr.indexOf(newValue), 1);
          }
          _this._tempValueRep[key] = selectionArr;
        }
      } else if (scrollOrTapSelect) {
        _this._tempValueRep[key] = newValue;
      }
      if (s.onWheelMove && args.index !== UNDEFINED) {
        var wheelRep = s.onWheelMove({
          dataItem: getItem$1(wheel, args.index),
          selection: scrollOrTapSelect,
          wheelIndex: key
        });
        if (wheelRep) {
          wheelRep.forEach(function (v, i) {
            if (v !== UNDEFINED) {
              _this._tempValueRep[i] = v;
            }
            if (!scrollOrTapSelect) {
              var w = _this._wheelMap[i];
              var newIndex = getIndex(w, v);
              _this._constrainIndex(newIndex, w);
            }
          });
        }
      }
      if (scrollOrTapSelect) {
        _this._validate(key, args.diff > 0 ? 1 : -1);
      }
      if (selectOnScroll) {
        _this._tempValueRep.forEach(function (val, i) {
          var w = _this._wheelMap[i];
          var len = w.data ? w.data.length : 0;
          var oldIndex = _this._indexes[i];
          var newIndex = getIndex(w, val) + _this._batches[i] * len;
          _this._activeIndexes[i] = _this._lastIndexes[i] = _this._indexes[i] = newIndex;
          w._offset = len !== lengths[i] ? newIndex - oldIndex : 0;
        });
      }
      var currentTempValue = _this._get(_this._tempValueRep);
      var tempValueChanged = !_this._valueEquals(beforeTempValue, currentTempValue);
      if (tempValueChanged || args.click && _this._live && !_this._valueEquals(_this.value, currentTempValue)) {
        _this._setOrUpdate(!tempValueChanged);
      } else {
        _this.forceUpdate();
      }
      if (_this._live && itemTap && wheel.closeOnTap) {
        _this.close();
      }
    };
    return _this;
  }
  ScrollerBase.prototype._initWheels = function () {
    var _this = this;
    var key = 0;
    var wheels = this.s.wheels || [];
    this._wheelMap = [];
    wheels.forEach(function (wheelGroup) {
      wheelGroup.forEach(function (wheel) {
        _this._initWheel(wheel, key);
        _this._wheelMap[key] = wheel;
        key++;
      });
    });
    this._wheels = wheels;
  };
  ScrollerBase.prototype._shouldValidate = function (s, prevS) {
    return s.shouldValidate ? s.shouldValidate(s, prevS) : false;
  };
  ScrollerBase.prototype._valueEquals = function (v1, v2) {
    if (this.s.valueEquality) {
      return this.s.valueEquality(v1, v2);
    }
    return v1 === v2;
  };
  ScrollerBase.prototype._render = function (s, state) {
    var _this = this;
    var props = this.props || {};
    var resp = this._respProps || {};
    var prevS = this._prevS;
    var circular = this._touchUi ? s.circular : false;
    var rows = this._touchUi ? s.rows : resp.rows || props.rows || 7;
    this._displayStyle = s.displayStyle || s.display;
    this._scroll3d = s.scroll3d && this._touchUi && has3d;
    if (s.itemHeight !== prevS.itemHeight || rows !== this._rows) {
      this._rows = rows;
      this._lineStyle = {
        height: s.itemHeight + "px"
      };
      if (this._scroll3d) {
        var translateZ = "translateZ(" + (s.itemHeight * rows / 2 + 3) + "px";
        this._overlayStyle = {};
        this._overlayStyle[cssPrefix + "transform"] = translateZ;
        this._lineStyle[cssPrefix + "transform"] = "translateY(-50%) " + translateZ;
      }
    }
    if (s.wheels !== prevS.wheels || circular !== this._circular) {
      this._batches = [];
      this._shouldSetIndex = true;
      this._circular = circular;
      this._initWheels();
    }
    _super.prototype._render.call(this, s, state);
    if (this._shouldSetIndex) {
      this._setIndexes();
      this._shouldSetIndex = this._indexFromValue = false;
    }
    if (s.wheels !== prevS.wheels && prevS.wheels !== UNDEFINED) {
      setTimeout(function () {
        for (var _i = 0, _a = _this._wheelMap; _i < _a.length; _i++) {
          var wheel = _a[_i];
          _this._onWheelIndexChange({
            diff: 0,
            index: _this._indexes[wheel._key],
            wheel: wheel
          });
        }
      });
    }
  };
  ScrollerBase.prototype._writeValue = function (elm, text, value) {
    if (this.s.writeValue) {
      return this.s.writeValue(elm, text, value);
    }
    return _super.prototype._writeValue.call(this, elm, text, value);
  };
  ScrollerBase.prototype._copy = function (value) {
    return value.slice(0);
  };
  ScrollerBase.prototype._format = function (value) {
    if (this.s.formatValue) {
      return this.s.formatValue(value);
    }
    return value.join(" ");
  };
  ScrollerBase.prototype._get = function (value) {
    if (this.s.getValue) {
      return this.s.getValue(value);
    }
    return value;
  };
  ScrollerBase.prototype._parse = function (valueStr) {
    if (this.s.parseValue) {
      return this.s.parseValue(valueStr);
    }
    var ret = [];
    var values = [];
    var i = 0;
    if (valueStr !== null && valueStr !== UNDEFINED) {
      values = (valueStr + "").split(" ");
    }
    this._wheels.forEach(function (wheelGroup) {
      wheelGroup.forEach(function (wheel) {
        var data = wheel.data || [];
        var len = data.length;
        var value = getItemValue(data[0]);
        var j = 0;
        /* eslint-disable eqeqeq */
        while (value != values[i] && j < len) {
          value = getItemValue(data[j]);
          j++;
        }
        ret.push(value);
        i++;
      });
    });
    return ret;
  };
  ScrollerBase.prototype._validate = function (index, direction) {
    var _this = this;
    if (this.s.validate) {
      var ret = this.s.validate.call(this._el, {
        direction: direction,
        index: index,
        values: this._tempValueRep.slice(0),
        wheels: this._wheelMap
      });
      this._disabled = ret.disabled;
      if (ret.init) {
        this._initWheels();
      }
      if (ret.indexes) {
        ret.indexes.forEach(function (value, i) {
          if (value !== UNDEFINED) {
            var w = _this._wheelMap[i];
            var newIndex = getIndex(w, value);
            _this._constrainIndex(newIndex, w);
          }
        });
      }
      if (ret.valid) {
        this._tempValueRep = ret.valid.slice(0);
      } else {
        this._wheelMap.forEach(function (wheel, i) {
          _this._tempValueRep[i] = getValid(wheel, _this._tempValueRep[i], _this._disabled && _this._disabled[i], direction);
        });
      }
    }
  };
  ScrollerBase.prototype._onOpen = function () {
    this._batches = [];
    this._shouldSetIndex = true;
    this._indexFromValue = true;
  };
  ScrollerBase.prototype._onParse = function () {
    this._shouldSetIndex = true;
  };
  ScrollerBase.prototype._initWheel = function (wheel, key) {
    var circular = this._circular;
    wheel._key = key;
    wheel._map = new Map();
    wheel._circular = circular === UNDEFINED ? wheel.circular === UNDEFINED ? wheel.data && wheel.data.length > this._rows : wheel.circular : isArray(circular) ? circular[key] : circular;
    if (wheel.data) {
      wheel.min = wheel._circular ? UNDEFINED : 0;
      wheel.max = wheel._circular ? UNDEFINED : wheel.data.length - 1;
      wheel.data.forEach(function (item, i) {
        wheel._map.set(getItemValue(item), i);
      });
    }
  };
  ScrollerBase.prototype._setIndexes = function () {
    var _this = this;
    var currentIndexes = this._indexes || [];
    this._indexes = [];
    this._activeIndexes = [];
    this._tempValueRep.forEach(function (val, i) {
      var w = _this._wheelMap[i];
      var len = w.data ? w.data.length : 0;
      var newIndex = getIndex(w, val);
      if (_this.s.selectOnScroll) {
        _this._activeIndexes[i] = _this._indexes[i] = newIndex + (_this._batches[i] || 0) * len;
      } else {
        var currentIndex = newIndex;
        if (!_this._indexFromValue) {
          currentIndex = _this._prevS.wheels !== _this.s.wheels ? 0 : currentIndexes[i];
          if (currentIndex !== UNDEFINED) {
            currentIndex = getFirstIndex(w, currentIndex) + (_this._batches[i] || 0) * len;
          }
        }
        _this._constrainIndex(currentIndex, w);
      }
    });
  };
  ScrollerBase.prototype._constrainIndex = function (newIndex, wheel) {
    var i = wheel._key;
    if (newIndex !== UNDEFINED && wheel.data) {
      if (!wheel.spaceAround) {
        newIndex = constrain(newIndex, 0, Math.max(wheel.data.length - this._rows, 0));
      }
      this._activeIndexes[i] = this._indexes[i] = newIndex;
    } else {
      this._activeIndexes[i] = this._indexes[i] = this._lastIndexes[i] || 0;
    }
  };
  ScrollerBase.defaults = {
    itemHeight: 40,
    rows: 5,
    selectOnScroll: true,
    showOnClick: true
  };
  ScrollerBase._name = "Scroller";
  ScrollerBase.ɵfac = /* @__PURE__ */(() => {
    let ɵScrollerBase_BaseFactory;
    return function ScrollerBase_Factory(t) {
      return (ɵScrollerBase_BaseFactory || (ɵScrollerBase_BaseFactory = i0.ɵɵgetInheritedFactory(ScrollerBase)))(t || ScrollerBase);
    };
  })();
  ScrollerBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: ScrollerBase,
    selectors: [["", "mbsc-sc-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return ScrollerBase;
}(PickerBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var WHEEL_WIDTHS = {
  ios: 50,
  material: 46,
  windows: 50
};
var TIME_PARTS = ["a", "h", "i", "s", "tt"];
function validateTimes(s, hasAmPm, i, valid, wheelOrder, getDatePart, maxs, steps, key, disabled, order, validDate, startDate, endDate, isValid, exclusiveEndDates) {
  var sameDayInvalid = isSameDay(startDate, endDate);
  var start = sameDayInvalid || !isSameDay(validDate, endDate) ? startDate : getDayStart(s, startDate);
  var end = sameDayInvalid || !isSameDay(validDate, startDate) ? endDate : getDayEnd(s, endDate);
  var startAmPm = getDatePart.a(start);
  var endAmPm = getDatePart.a(end);
  var startProp = true;
  var endProp = true;
  var all = false;
  var add = 0;
  var remove = 0;
  for (var j = 0; j < i; j++) {
    var k = TIME_PARTS[j];
    var validVal = valid[wheelOrder[k]];
    if (validVal !== UNDEFINED) {
      var startVal = startProp ? getDatePart[k](start) : 0;
      var endVal = endProp ? getDatePart[k](end) : maxs[k];
      if (hasAmPm && j === 1) {
        startVal += startAmPm ? 12 : 0;
        endVal += endAmPm ? 12 : 0;
        validVal += valid[wheelOrder.a] ? 12 : 0;
      }
      if ((startProp || endProp) && startVal < validVal && validVal < endVal) {
        all = true;
      }
      if (validVal !== startVal) {
        startProp = false;
      }
      if (validVal !== endVal) {
        endProp = false;
      }
    }
  }
  if (!isValid) {
    for (var j = i + 1; j < 4; j++) {
      var k = TIME_PARTS[j];
      if (wheelOrder[k] !== UNDEFINED) {
        if (getDatePart[k](start) > 0 && startProp) {
          add = steps[key];
        }
        if (getDatePart[k](end) < maxs[k] && endProp) {
          remove = steps[key];
        }
      }
    }
    if (endProp && exclusiveEndDates && !remove) {
      remove = end.getMilliseconds() !== 999 ? steps[key] : 0;
    }
  }
  if (startProp || endProp || all) {
    var startVal = startProp && !all ? getDatePart[key](start) + add : 0;
    var endVal = endProp && !all ? getDatePart[key](end) - remove : maxs[key];
    for (var j = startVal; j <= endVal; j += steps[key]) {
      disabled[order].set(j, !isValid);
    }
  }
}
function getDateIndex(d, hasDay) {
  var dt = new Date(d);
  return hasDay ? floor(+dt / 864e5) : dt.getMonth() + 12 * (dt.getFullYear() - 1970);
}
function getFullDate(d) {
  return d.getFullYear() + "-" + pad(d.getMonth() + 1) + "-" + pad(d.getDate());
}
function getMilliseconds(d) {
  return d.getMilliseconds();
}
function getAmPm(d) {
  return d.getHours() > 11 ? 1 : 0;
}
var DatetimeBase = /*#__PURE__*/function (_super) {
  __extends(DatetimeBase, _super);
  function DatetimeBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._preset = "date";
    _this._innerValues = {};
    _this._onChange = function (args) {
      if (_this.s.value === UNDEFINED) {
        _this.setState({
          value: args.value
        });
      }
      _this._hook("onChange", args);
    };
    _this._parseDate = function (value) {
      var s = _this.s;
      if (!value) {
        _this._innerValues = {};
      }
      return _this._getArray(makeDate(value || s.defaultSelection || new Date(), s, _this._format), !!value);
    };
    _this._formatDate = function (values) {
      var d = _this._getDate(values);
      return d ? formatDate(_this._format, d, _this.s) : "";
    };
    _this._getDate = function (values) {
      var s = _this.s;
      var getArrayPart = _this._getArrayPart;
      var wheelOrder = _this._wheelOrder;
      var today = new Date(new Date().setHours(0, 0, 0, 0));
      var d;
      var t;
      if (values === null || values === UNDEFINED) {
        return null;
      }
      if (wheelOrder.dd !== UNDEFINED) {
        var parts = values[wheelOrder.dd].split("-");
        d = new Date(parts[0], parts[1] - 1, parts[2]);
      }
      if (wheelOrder.tt !== UNDEFINED) {
        t = d || today;
        t = new Date(t.getTime() + values[wheelOrder.tt] % 86400 * 1e3);
      }
      var year = getArrayPart(values, "y", d, today);
      var month = getArrayPart(values, "m", d, today);
      var day = Math.min(getArrayPart(values, "d", d, today), s.getMaxDayOfMonth(year, month));
      var hour = getArrayPart(values, "h", t, today);
      return s.getDate(year, month, day, _this._hasAmPm && getArrayPart(values, "a", t, today) ? hour + 12 : hour, getArrayPart(values, "i", t, today), getArrayPart(values, "s", t, today), getArrayPart(values, "u", t, today));
    };
    _this._validate = function (_a) {
      var direction = _a.direction,
        index = _a.index,
        values = _a.values,
        wheels = _a.wheels;
      var disabled = [];
      var s = _this.s;
      var stepHour = s.stepHour;
      var stepMinute = s.stepMinute;
      var stepSecond = s.stepSecond;
      var preset = s.mode || _this._preset;
      var wheelOrder = _this._wheelOrder;
      var getDatePart = _this._getDatePart;
      var maxDate = _this._max;
      var minDate = _this._min;
      var current = addTimezone(s, _this._getDate(values));
      var currYear = s.getYear(current);
      var currMonth = s.getMonth(current);
      var from = s.getDate(currYear, currMonth - 1, 1);
      var until = s.getDate(currYear, currMonth + 2, 1);
      if (index === wheelOrder.y || index === wheelOrder.m || index === wheelOrder.d || index === wheelOrder.dd || index === UNDEFINED) {
        _this._valids = getEventMap(s.valid, from, until, s, true);
        _this._invalids = getEventMap(s.invalid, from, until, s, true);
      }
      var valids = _this._valids;
      var invalids = _this._invalids;
      var mind = minDate ? +minDate : -Infinity;
      var maxd = maxDate ? +maxDate : Infinity;
      var validated = getClosestValidDate(current, s, mind, maxd, invalids, valids, direction);
      var valid = _this._getArray(validated);
      var dayWheel = _this._wheels && _this._wheels[0][wheelOrder.d];
      var y = getDatePart.y(validated);
      var m = getDatePart.m(validated);
      var maxDays = s.getMaxDayOfMonth(y, m);
      var mins = {
        y: minDate ? minDate.getFullYear() : -Infinity,
        m: 0,
        d: 1,
        h: 0,
        i: 0,
        s: 0,
        a: 0,
        tt: 0
      };
      var maxs = {
        y: maxDate ? maxDate.getFullYear() : Infinity,
        m: 11,
        d: 31,
        h: step(_this._hasAmPm ? 11 : 23, stepHour),
        i: step(59, stepMinute),
        s: step(59, stepSecond),
        a: 1,
        tt: 86400
      };
      var steps = {
        y: 1,
        m: 1,
        d: 1,
        h: stepHour,
        i: stepMinute,
        s: stepSecond,
        a: 1,
        tt: _this._timeStep
      };
      var init = false;
      var minprop = true;
      var maxprop = true;
      ["dd", "y", "m", "d", "tt", "a", "h", "i", "s"].forEach(function (key) {
        var min = mins[key];
        var max = maxs[key];
        var val = getDatePart[key](validated);
        var order = wheelOrder[key];
        if (minprop && minDate) {
          min = getDatePart[key](minDate);
        }
        if (maxprop && maxDate) {
          max = getDatePart[key](maxDate);
        }
        if (val < min) {
          val = min;
        }
        if (val > max) {
          val = max;
        }
        if (key !== "dd" && key !== "tt" && !(key === "a" && order === UNDEFINED)) {
          if (minprop) {
            minprop = val === min;
          }
          if (maxprop) {
            maxprop = val === max;
          }
        }
        if (order !== UNDEFINED) {
          disabled[order] = new Map();
          if (key !== "y" && key !== "dd") {
            for (var i = mins[key]; i <= maxs[key]; i += steps[key]) {
              if (i < min || i > max) {
                disabled[order].set(i, true);
              }
            }
          }
          if (key === "d" && invalids) {
            for (var d in invalids) {
              if (!valids || !valids[d]) {
                var dd = makeDate(d, s);
                var yy = s.getYear(dd);
                var mm = s.getMonth(dd);
                if (yy === y && mm === m && isInvalid(s, dd, invalids, valids)) {
                  disabled[order].set(s.getDay(dd), true);
                }
              }
            }
          }
        }
      });
      if (/time/i.test(preset)) {
        var invalidsForDay_1 = invalids && invalids[getDateStr(validated)];
        var validsForDay_1 = valids && valids[getDateStr(validated)];
        TIME_PARTS.forEach(function (key, i) {
          var order = wheelOrder[key];
          if (order !== UNDEFINED) {
            var entries = s.valid ? validsForDay_1 : invalidsForDay_1;
            if (entries) {
              if (s.valid) {
                for (var j = 0; j <= maxs[key]; j++) {
                  disabled[order].set(j, true);
                }
              }
              for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var entry = entries_1[_i];
                var start = entry.start;
                var end = entry.end;
                if (start && end) {
                  validateTimes(s, _this._hasAmPm, i, valid, wheelOrder, getDatePart, maxs, steps, key, disabled, order, validated, start, end, !!s.valid, s.exclusiveEndDates);
                }
              }
            }
            valid[order] = getValid(wheels[order], getDatePart[key](validated), disabled[order], direction);
          }
        });
      }
      var dateDisplay = _this._dateDisplay;
      if (dayWheel && (dayWheel.data.length !== maxDays || /DDD/.test(dateDisplay))) {
        var data = [];
        var dayDisplay = dateDisplay.replace(/[my|]/gi, "").replace(/DDDD/, "{dddd}").replace(/DDD/, "{ddd}").replace(/DD/, "{dd}").replace(/D/, "{d}");
        for (var j = 1; j <= maxDays; j++) {
          var weekDay = s.getDate(y, m, j).getDay();
          var dayStr = dayDisplay.replace(/{dddd}/, s.dayNames[weekDay]).replace(/{ddd}/, s.dayNamesShort[weekDay]).replace(/{dd}/, pad(j) + s.daySuffix).replace(/{d}/, j + s.daySuffix);
          data.push({
            display: dayStr,
            value: j
          });
        }
        dayWheel.data = data;
        init = true;
      }
      return {
        disabled: disabled,
        init: init,
        valid: valid
      };
    };
    _this._shouldValidate = function (s, prevS) {
      return !!(s.min && +s.min !== +prevS.min || s.max && +s.max !== +prevS.max) || s.wheels !== prevS.wheels || s.dataTimezone !== prevS.dataTimezone || s.displayTimezone !== prevS.displayTimezone;
    };
    _this._setScroller = function (scroller) {
      _this._scroller = scroller;
    };
    _this._getYearValue = function (i) {
      return {
        display: (/yy/i.test(_this._dateDisplay) ? i : (i + "").substr(2, 2)) + _this.s.yearSuffix,
        value: i
      };
    };
    _this._getYearIndex = function (i) {
      return +i;
    };
    _this._getDateIndex = function (i) {
      return getDateIndex(i, _this._hasDay);
    };
    _this._getDateItem = function (i) {
      var s = _this.s;
      var hasDay = _this._hasDay;
      var today = new Date(new Date().setHours(0, 0, 0, 0));
      var d = hasDay ? new Date(i * 864e5) : new Date(1970, i, 1);
      if (hasDay) {
        d = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
      }
      return {
        disabled: hasDay && isInvalid(s, d, _this._invalids, _this._valids),
        display: today.getTime() === d.getTime() ? s.todayText : formatDate(_this._dateTemplate, d, s),
        value: getFullDate(d)
      };
    };
    _this._getArrayPart = function (values, part, d, def) {
      var ret;
      if (_this._wheelOrder[part] !== UNDEFINED) {
        ret = +values[_this._wheelOrder[part]];
        if (!isNaN(ret)) {
          return ret;
        }
      }
      if (d) {
        return _this._getDatePart[part](d);
      }
      if (_this._innerValues[part] !== UNDEFINED) {
        return _this._innerValues[part];
      }
      return _this._getDatePart[part](def);
    };
    _this._getHours = function (d) {
      var hour = d.getHours();
      hour = _this._hasAmPm && hour >= 12 ? hour - 12 : hour;
      return step(hour, _this.s.stepHour);
    };
    _this._getMinutes = function (d) {
      return step(d.getMinutes(), _this.s.stepMinute);
    };
    _this._getSeconds = function (d) {
      return step(d.getSeconds(), _this.s.stepSecond);
    };
    _this._getFullTime = function (d) {
      return step(round((d.getTime() - new Date(d).setHours(0, 0, 0, 0)) / 1e3), _this._timeStep || 1);
    };
    return _this;
  }
  DatetimeBase.prototype.getVal = function () {
    return this._value;
  };
  DatetimeBase.prototype.setVal = function (value) {
    this._value = value;
    this.setState({
      value: value
    });
  };
  DatetimeBase.prototype.position = function () {
    if (this._scroller) {
      this._scroller.position();
    }
  };
  DatetimeBase.prototype.isVisible = function () {
    return this._scroller && this._scroller.isVisible();
  };
  DatetimeBase.prototype._valueEquals = function (v1, v2) {
    return dateValueEquals(v1, v2, this.s);
  };
  DatetimeBase.prototype._render = function (s, state) {
    var genWheels = false;
    var prevProps = this._prevS;
    var dateFormat = s.dateFormat;
    var timeFormat = s.timeFormat;
    var preset = s.mode || this._preset;
    var format = preset === "datetime" ? dateFormat + s.separator + timeFormat : preset === "time" ? timeFormat : dateFormat;
    this._value = s.value === UNDEFINED ? state.value : s.value;
    this._minWheelWidth = s.minWheelWidth || (preset === "datetime" ? WHEEL_WIDTHS[s.baseTheme || s.theme] : UNDEFINED);
    this._dateWheels = s.dateWheels || (preset === "datetime" ? s.dateWheelFormat : dateFormat);
    this._dateDisplay = s.dateWheels || s.dateDisplay;
    this._timeWheels = s.timeWheels || timeFormat;
    this._timeDisplay = this._timeWheels;
    this._format = format;
    this._hasAmPm = /h/.test(this._timeDisplay);
    this._getDatePart = {
      y: s.getYear,
      m: s.getMonth,
      d: s.getDay,
      h: this._getHours,
      i: this._getMinutes,
      s: this._getSeconds,
      u: getMilliseconds,
      a: getAmPm,
      dd: getFullDate,
      tt: this._getFullTime
    };
    if (+makeDate(prevProps.min) !== +makeDate(s.min)) {
      genWheels = true;
      this._min = isEmpty(s.min) ? UNDEFINED : makeDate(s.min, s, format);
    }
    if (+makeDate(prevProps.max) !== +makeDate(s.max)) {
      genWheels = true;
      this._max = isEmpty(s.max) ? UNDEFINED : makeDate(s.max, s, format);
    }
    if (s.theme !== prevProps.theme || s.mode !== prevProps.mode || s.locale !== prevProps.locale || s.dateWheels !== prevProps.dateWheels || s.timeWheels !== prevProps.timeWheels || genWheels) {
      this._wheels = this._getWheels();
    }
  };
  DatetimeBase.prototype._getWheels = function () {
    this._wheelOrder = {};
    var s = this.s;
    var preset = s.mode || this._preset;
    var hasAmPm = this._hasAmPm;
    var dateDisplay = this._dateDisplay;
    var timeDisplay = this._timeDisplay;
    var wheelOrder = this._wheelOrder;
    var wheels = [];
    var dateGroup = [];
    var values;
    var timeGroup = [];
    var nr = 0;
    if (/date/i.test(preset)) {
      var dateParts = this._dateWheels.split(/\|/.test(this._dateWheels) ? "|" : "");
      for (var _i = 0, dateParts_1 = dateParts; _i < dateParts_1.length; _i++) {
        var template = dateParts_1[_i];
        var types = 0;
        if (template.length) {
          if (/y/i.test(template)) {
            types++;
          }
          if (/m/i.test(template)) {
            types++;
          }
          if (/d/i.test(template)) {
            types++;
          }
          if (types > 1 && wheelOrder.dd === UNDEFINED) {
            wheelOrder.dd = nr;
            nr++;
            dateGroup.push(this._getDateWheel(template));
            timeGroup = dateGroup;
          } else if (/y/i.test(template) && wheelOrder.y === UNDEFINED) {
            wheelOrder.y = nr;
            nr++;
            dateGroup.push({
              cssClass: "mbsc-datetime-year-wheel",
              getIndex: this._getYearIndex,
              getItem: this._getYearValue,
              max: this._max ? s.getYear(this._max) : UNDEFINED,
              min: this._min ? s.getYear(this._min) : UNDEFINED,
              spaceAround: true
            });
          } else if (/m/i.test(template) && wheelOrder.m === UNDEFINED) {
            wheelOrder.m = nr;
            values = [];
            nr++;
            var monthDisplay = dateDisplay.replace(/[dy|]/gi, "").replace(/MMMM/, "{mmmm}").replace(/MMM/, "{mmm}").replace(/MM/, "{mm}").replace(/M/, "{m}");
            for (var j = 0; j < 12; j++) {
              var monthStr = monthDisplay.replace(/{mmmm}/, s.monthNames[j]).replace(/{mmm}/, s.monthNamesShort[j]).replace(/{mm}/, pad(j + 1) + (s.monthSuffix || "")).replace(/{m}/, j + 1 + (s.monthSuffix || ""));
              values.push({
                display: monthStr,
                value: j
              });
            }
            dateGroup.push({
              cssClass: "mbsc-datetime-month-wheel",
              data: values,
              spaceAround: true
            });
          } else if (/d/i.test(template) && wheelOrder.d === UNDEFINED) {
            wheelOrder.d = nr;
            values = [];
            nr++;
            for (var j = 1; j < 32; j++) {
              values.push({
                display: (/dd/i.test(dateDisplay) ? pad(j) : j) + s.daySuffix,
                value: j
              });
            }
            dateGroup.push({
              cssClass: "mbsc-datetime-day-wheel",
              data: values,
              spaceAround: true
            });
          }
        }
      }
      wheels.push(dateGroup);
    }
    if (/time/i.test(preset)) {
      var timeParts = this._timeWheels.split(/\|/.test(this._timeWheels) ? "|" : "");
      for (var _a = 0, timeParts_1 = timeParts; _a < timeParts_1.length; _a++) {
        var template = timeParts_1[_a];
        var types = 0;
        if (template.length) {
          if (/h/i.test(template)) {
            types++;
          }
          if (/m/i.test(template)) {
            types++;
          }
          if (/s/i.test(template)) {
            types++;
          }
          if (/a/i.test(template)) {
            types++;
          }
        }
        if (types > 1 && wheelOrder.tt === UNDEFINED) {
          wheelOrder.tt = nr;
          nr++;
          timeGroup.push(this._getTimeWheel(template));
        } else if (/h/i.test(template) && wheelOrder.h === UNDEFINED) {
          values = [];
          wheelOrder.h = nr;
          nr++;
          for (var j = 0; j < (hasAmPm ? 12 : 24); j += s.stepHour) {
            values.push({
              display: hasAmPm && j === 0 ? 12 : /hh/i.test(timeDisplay) ? pad(j) : j,
              value: j
            });
          }
          timeGroup.push({
            cssClass: "mbsc-datetime-hour-wheel",
            data: values,
            spaceAround: true
          });
        } else if (/m/i.test(template) && wheelOrder.i === UNDEFINED) {
          values = [];
          wheelOrder.i = nr;
          nr++;
          for (var j = 0; j < 60; j += s.stepMinute) {
            values.push({
              display: /mm/i.test(timeDisplay) ? pad(j) : j,
              value: j
            });
          }
          timeGroup.push({
            cssClass: "mbsc-datetime-minute-wheel",
            data: values,
            spaceAround: true
          });
        } else if (/s/i.test(template) && wheelOrder.s === UNDEFINED) {
          values = [];
          wheelOrder.s = nr;
          nr++;
          for (var j = 0; j < 60; j += s.stepSecond) {
            values.push({
              display: /ss/i.test(timeDisplay) ? pad(j) : j,
              value: j
            });
          }
          timeGroup.push({
            cssClass: "mbsc-datetime-second-wheel",
            data: values,
            spaceAround: true
          });
        } else if (/a/i.test(template) && wheelOrder.a === UNDEFINED) {
          wheelOrder.a = nr;
          nr++;
          timeGroup.push({
            cssClass: "mbsc-dt-whl-a",
            data: /A/.test(template) ? [{
              display: s.amText.toUpperCase(),
              value: 0
            }, {
              display: s.pmText.toUpperCase(),
              value: 1
            }] : [{
              display: s.amText,
              value: 0
            }, {
              display: s.pmText,
              value: 1
            }],
            spaceAround: true
          });
        }
      }
      if (timeGroup !== dateGroup) {
        wheels.push(timeGroup);
      }
    }
    return wheels;
  };
  DatetimeBase.prototype._getDateWheel = function (template) {
    var hasDay = /d/i.test(template);
    this._hasDay = hasDay;
    this._dateTemplate = template;
    return {
      cssClass: "mbsc-datetime-date-wheel",
      getIndex: this._getDateIndex,
      getItem: this._getDateItem,
      label: "",
      max: this._max ? getDateIndex(getFullDate(this._max), hasDay) : UNDEFINED,
      min: this._min ? getDateIndex(getFullDate(this._min), hasDay) : UNDEFINED,
      spaceAround: true
    };
  };
  DatetimeBase.prototype._getTimeWheel = function (template) {
    var s = this.s;
    var values = [];
    var st = 1;
    if (/s/i.test(template)) {
      st = s.stepSecond;
    } else if (/m/i.test(template)) {
      st = s.stepMinute * 60;
    } else if (/h/i.test(template)) {
      st = s.stepHour * 3600;
    }
    this._timeStep = st;
    for (var i = 0; i < 86400; i += st) {
      var time = new Date(new Date().setHours(0, 0, 0, 0) + i * 1e3);
      values.push({
        display: formatDate(template, time, s),
        value: i
      });
    }
    return {
      data: values,
      label: "",
      spaceAround: true
    };
  };
  DatetimeBase.prototype._getArray = function (d, fillInner) {
    var parts = ["y", "m", "d", "a", "h", "i", "s", "u", "dd", "tt"];
    var ret = [];
    var wheelOrder = this._wheelOrder;
    if (d === null || d === UNDEFINED) {
      return ret;
    }
    for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
      var part = parts_1[_i];
      var v = this._getDatePart[part](d);
      if (wheelOrder[part] !== UNDEFINED) {
        ret[wheelOrder[part]] = v;
      }
      if (fillInner) {
        this._innerValues[part] = v;
      }
    }
    return ret;
  };
  DatetimeBase.defaults = __assign(__assign({}, dateTimeLocale), {
    dateDisplay: "MMMMDDYYYY",
    dateWheelFormat: "|DDD MMM D|",
    stepHour: 1,
    stepMinute: 1,
    stepSecond: 1
  });
  DatetimeBase._name = "Datetime";
  DatetimeBase.ɵfac = /* @__PURE__ */(() => {
    let ɵDatetimeBase_BaseFactory;
    return function DatetimeBase_Factory(t) {
      return (ɵDatetimeBase_BaseFactory || (ɵDatetimeBase_BaseFactory = i0.ɵɵgetInheritedFactory(DatetimeBase)))(t || DatetimeBase);
    };
  })();
  DatetimeBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DatetimeBase,
    selectors: [["", "mbsc-dt-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return DatetimeBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var WheelBase = /*#__PURE__*/function (_super) {
  __extends(WheelBase, _super);
  function WheelBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._onIndexChange = function (args) {
      args.wheel = _this.s.wheel;
      _this._hook("onIndexChange", args);
    };
    _this._onItemClick = function (args) {
      _this._hook("onIndexChange", {
        click: true,
        index: args.index,
        wheel: _this.s.wheel,
        selected: args.selected
      });
    };
    _this._onKeyDown = function (ev) {
      var dir = 0;
      if (ev.keyCode === UP_ARROW) {
        dir = -1;
      } else if (ev.keyCode === DOWN_ARROW) {
        dir = 1;
      }
      var s = _this.s;
      var newIndex = s.activeIndex + dir;
      var change = !(newIndex < s.minIndex) && !(newIndex > s.maxIndex);
      if (dir) {
        ev.preventDefault();
      }
      if (dir && change) {
        var hook = s.selectOnScroll ? "onIndexChange" : "onActiveChange";
        _this._shouldFocus = true;
        _this._hook(hook, {
          diff: dir,
          index: newIndex,
          wheel: s.wheel
        });
      } else if (ev.keyCode === ENTER && s.multiple) {
        _this._hook("onSet", {});
      }
    };
    return _this;
  }
  WheelBase.prototype._getText = function (data) {
    return data !== UNDEFINED ? data.display !== UNDEFINED ? data.display : data : UNDEFINED;
  };
  WheelBase.prototype._getValue = function (data) {
    return data ? data.value !== UNDEFINED ? data.value : data.display !== UNDEFINED ? data.display : data : data;
  };
  WheelBase.prototype._isActive = function (item, text, is3d) {
    var s = this.s;
    var d3 = s.scroll3d && s.multiple ? is3d : !is3d;
    return s.activeIndex === item.key && text && d3;
  };
  WheelBase.prototype._isSelected = function (item) {
    var s = this.s;
    var selectedValues = s.selectedValues;
    var value = this._getValue(item.data);
    return s.multiple ? !!(selectedValues && selectedValues.indexOf) && selectedValues.indexOf(value) >= 0 : s.selectOnScroll ? item.key === s.selectedIndex : value !== UNDEFINED && value === selectedValues;
  };
  WheelBase.prototype._isDisabled = function (data) {
    var disabledMap = this.s.disabled;
    var disabledProp = data && data.disabled;
    var value = this._getValue(data);
    return !!(disabledProp || disabledMap && disabledMap.get(value));
  };
  WheelBase.prototype._render = function (s) {
    var rows = s.rows;
    var itemHeight = s.itemHeight;
    var key = s.wheel._key;
    var itemHeight3d = round((itemHeight - (itemHeight * rows / 2 + 3) * .03) / 2) * 2;
    this._items = s.wheel.getItem || s.wheel.data || [];
    this._batchSize3d = round(rows * 1.8);
    this._angle3d = 360 / (this._batchSize3d * 2);
    this._style = {
      height: round(rows * itemHeight * (s.scroll3d ? 1.1 : 1) / 2) * 2 + "px"
    };
    this._itemNr = s.wheel.spaceAround ? 1 : rows;
    this._innerStyle = {
      height: (s.scroll3d ? itemHeight3d : s.wheel.spaceAround ? itemHeight : itemHeight * rows) + "px"
    };
    this._wheelStyle = s.wheelWidth ? {
      width: (isArray(s.wheelWidth) ? s.wheelWidth[key] : s.wheelWidth) + "px"
    } : {
      maxWidth: (isArray(s.maxWheelWidth) ? s.maxWheelWidth[key] : s.maxWheelWidth) + "px",
      minWidth: (isArray(s.minWheelWidth) ? s.minWheelWidth[key] : s.minWheelWidth) + "px"
    };
    if (s.scroll3d) {
      this._innerStyle[cssPrefix + "transform"] = "translateY(-50%) translateZ(" + (itemHeight * rows / 2 + 3) + "px";
    }
  };
  WheelBase.prototype._updated = function () {
    if (this._shouldFocus) {
      var item_1 = this._el.querySelector('[tabindex="0"]');
      if (item_1) {
        setTimeout(function () {
          item_1.focus();
        });
      }
      this._shouldFocus = false;
    }
  };
  WheelBase.ɵfac = /* @__PURE__ */(() => {
    let ɵWheelBase_BaseFactory;
    return function WheelBase_Factory(t) {
      return (ɵWheelBase_BaseFactory || (ɵWheelBase_BaseFactory = i0.ɵɵgetInheritedFactory(WheelBase)))(t || WheelBase);
    };
  })();
  WheelBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: WheelBase,
    selectors: [["", "mbsc-wh-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return WheelBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var WheelItemBase = /*#__PURE__*/function (_super) {
  __extends(WheelItemBase, _super);
  function WheelItemBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._onClick = function () {
      var s = _this.s;
      if (s.text !== UNDEFINED && !s.isGroup) {
        _this._hook("onClick", {
          index: s.index,
          selected: s.selected,
          disabled: s.disabled
        });
      }
    };
    return _this;
  }
  WheelItemBase.prototype._mounted = function () {
    var _this = this;
    this._unlisten = gestureListener(this._el, {
      click: true,
      keepFocus: false,
      onBlur: function () {
        _this.setState({
          hasFocus: false
        });
      },
      onFocus: function () {
        _this.setState({
          hasFocus: true
        });
      },
      onHoverIn: function () {
        if (_this.s.text !== UNDEFINED) {
          _this.setState({
            hasHover: true
          });
        }
      },
      onHoverOut: function () {
        if (_this.s.text !== UNDEFINED) {
          _this.setState({
            hasHover: false
          });
        }
      },
      onKeyDown: function (ev) {
        if (ev.keyCode === SPACE || !_this.s.multiple && ev.keyCode === ENTER) {
          _this._onClick();
        }
      },
      onPress: function () {
        if (_this.s.text !== UNDEFINED) {
          _this.setState({
            isActive: true
          });
        }
      },
      onRelease: function () {
        if (_this.s.text !== UNDEFINED) {
          _this.setState({
            isActive: false
          });
        }
      }
    });
  };
  WheelItemBase.prototype._destroy = function () {
    this._unlisten();
  };
  WheelItemBase.prototype._render = function (s, state) {
    var height = s.height;
    this._cssClass = "mbsc-scroller-wheel-" + (s.isGroup ? "header" : "item") + this._theme + this._rtl + (s.checkmark && !s.isGroup ? " mbsc-wheel-item-checkmark" : "") + (s.is3d ? " mbsc-scroller-wheel-item-3d" : "") + (s.scroll3d && !s.is3d ? " mbsc-scroller-wheel-item-2d" : "") + (s.selected && !s.is3d ? " mbsc-selected" : "") + (s.selected && s.is3d ? " mbsc-selected-3d" : "") + (s.disabled ? " mbsc-disabled" : "") + (s.multiple && !s.isGroup ? " mbsc-wheel-item-multi" : "") + (state.hasHover ? " mbsc-hover" : "") + (state.hasFocus ? " mbsc-focus" : "") + (state.isActive ? " mbsc-active" : "");
    this._style = {
      height: height + "px",
      lineHeight: height + "px"
    };
    this._checkmarkClass = this._theme + this._rtl + " mbsc-wheel-checkmark" + (s.selected ? " mbsc-selected" : "");
    if (s.is3d) {
      this._transform = "rotateX(" + (s.offset - s.index) * s.angle3d % 360 + "deg) translateZ(" + height * s.rows / 2 + "px)";
      this._style[cssPrefix + "transform"] = this._transform;
    }
  };
  WheelItemBase.ɵfac = /* @__PURE__ */(() => {
    let ɵWheelItemBase_BaseFactory;
    return function WheelItemBase_Factory(t) {
      return (ɵWheelItemBase_BaseFactory || (ɵWheelItemBase_BaseFactory = i0.ɵɵgetInheritedFactory(WheelItemBase)))(t || WheelItemBase);
    };
  })();
  WheelItemBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: WheelItemBase,
    selectors: [["", "mbsc-whi-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return WheelItemBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscWheelItem = /*#__PURE__*/function (_super) {
  __extends(MbscWheelItem, _super);
  function MbscWheelItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MbscWheelItem.prototype._render = function (s, state) {
    _super.prototype._render.call(this, s, state);
    this._transform = this._sanitizer.bypassSecurityTrustStyle(this._transform);
  };
  MbscWheelItem.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscWheelItem_BaseFactory;
    return function MbscWheelItem_Factory(t) {
      return (ɵMbscWheelItem_BaseFactory || (ɵMbscWheelItem_BaseFactory = i0.ɵɵgetInheritedFactory(MbscWheelItem)))(t || MbscWheelItem);
    };
  })();
  MbscWheelItem.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscWheelItem,
    selectors: [["mbsc-wheel-item"]],
    hostAttrs: ["role", "option"],
    hostVars: 12,
    hostBindings: function MbscWheelItem_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("click", function MbscWheelItem_click_HostBindingHandler() {
          return ctx._onClick();
        });
      }
      if (rf & 2) {
        i0.ɵɵattribute("aria-disabled", ctx.disabled ? "true" : undefined)("aria-hidden", ctx.text === undefined || ctx.is3d ? "true" : undefined)("aria-selected", ctx.selected ? "true" : undefined)("tabindex", ctx.active ? 0 : ctx.text === undefined || ctx.is3d ? undefined : -1);
        i0.ɵɵclassMap(ctx._cssClass);
        i0.ɵɵstyleProp("height", ctx.height, "px")("line-height", ctx.height, "px")("transform", ctx._transform);
      }
    },
    inputs: {
      active: "active",
      angle3d: "angle3d",
      data: "data",
      disabled: "disabled",
      height: "height",
      is3d: "is3d",
      isGroup: "isGroup",
      index: "index",
      itemTemplate: "itemTemplate",
      multiple: "multiple",
      offset: "offset",
      rows: "rows",
      scroll3d: "scroll3d",
      selected: "selected",
      text: "text",
      onClick: "onClick",
      checkmark: "checkmark"
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    decls: 3,
    vars: 3,
    consts: [[3, "class", 4, "ngIf"], [4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"]],
    template: function MbscWheelItem_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, MbscWheelItem_span_0_Template, 1, 2, "span", 0)(1, MbscWheelItem_div_1_Template, 2, 4, "div", 1)(2, MbscWheelItem_ng_container_2_Template, 2, 1, "ng-container", 1);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.checkmark);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.itemTemplate && ctx.data);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.itemTemplate || !ctx.data);
      }
    },
    dependencies: [NgIf, NgTemplateOutlet],
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscWheelItem;
}(WheelItemBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscWheel = /*#__PURE__*/function (_super) {
  __extends(MbscWheel, _super);
  function MbscWheel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MbscWheel.prototype._getItemKey = function (index, item) {
    return item.key;
  };
  MbscWheel.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscWheel_BaseFactory;
    return function MbscWheel_Factory(t) {
      return (ɵMbscWheel_BaseFactory || (ɵMbscWheel_BaseFactory = i0.ɵɵgetInheritedFactory(MbscWheel)))(t || MbscWheel);
    };
  })();
  MbscWheel.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscWheel,
    selectors: [["mbsc-wheel"]],
    hostAttrs: ["role", "listbox"],
    hostVars: 9,
    hostBindings: function MbscWheel_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("keydown", function MbscWheel_keydown_HostBindingHandler($event) {
          return ctx._onKeyDown($event);
        });
      }
      if (rf & 2) {
        i0.ɵɵattribute("aria-multiselectable", ctx.multiple ? "true" : undefined);
        i0.ɵɵclassMap("mbsc-scroller-wheel-wrapper mbsc-scroller-wheel-wrapper-" + ctx.wheel._key + " " + (ctx.wheel.cssClass || "") + (ctx.scroll3d ? " mbsc-scroller-wheel-wrapper-3d" : "") + ctx._theme + ctx._rtl);
        i0.ɵɵstyleProp("max-width", ctx._wheelStyle.maxWidth)("min-width", ctx._wheelStyle.minWidth)("width", ctx._wheelStyle.width);
      }
    },
    inputs: {
      activeIndex: "activeIndex",
      disabled: "disabled",
      display: "display",
      itemHeight: "itemHeight",
      itemTemplate: "itemTemplate",
      maxIndex: "maxIndex",
      maxWheelWidth: "maxWheelWidth",
      minIndex: "minIndex",
      minWheelWidth: "minWheelWidth",
      multiple: "multiple",
      rows: "rows",
      scroll3d: "scroll3d",
      selectedIndex: "selectedIndex",
      selectedValues: "selectedValues",
      selectOnScroll: "selectOnScroll",
      touchUi: "touchUi",
      wheel: "wheel",
      wheelWidth: "wheelWidth",
      onGestureEnd: "onGestureEnd",
      onGestureStart: "onGestureStart",
      onIndexChange: "onIndexChange",
      onActiveChange: "onActiveChange",
      onSet: "onSet"
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    decls: 5,
    vars: 26,
    consts: [["scrollview", ""], [3, "batchSize3d", "innerClass", "innerStyles", "items", "itemSize", "itemNr", "margin", "maxIndex", "minIndex", "offset", "onIndexChange", "rtl", "scroll3d", "scrollBar", "selectedIndex", "snap", "spaceAround", "visibleSize"], [3, "active", "angle3d", "data", "disabled", "height", "is3d", "isGroup", "index", "itemTemplate", "multiple", "offset", "checkmark", "rows", "rtl", "scroll3d", "selected", "text", "theme", "onClick", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["content-3d", ""], [3, "active", "angle3d", "data", "disabled", "height", "is3d", "isGroup", "index", "itemTemplate", "multiple", "offset", "checkmark", "rows", "rtl", "scroll3d", "selected", "text", "theme", "onClick"]],
    template: function MbscWheel_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "mbsc-scrollview-base", 1, 0);
        i0.ɵɵtemplate(2, MbscWheel_mbsc_wheel_item_2_Template, 1, 19, "mbsc-wheel-item", 2);
        i0.ɵɵelementContainerStart(3, 3);
        i0.ɵɵtemplate(4, MbscWheel_mbsc_wheel_item_4_Template, 1, 19, "mbsc-wheel-item", 2);
        i0.ɵɵelementContainerEnd();
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        const scrollview_r3 = i0.ɵɵreference(1);
        i0.ɵɵclassMap("mbsc-scroller-wheel" + (ctx.scroll3d ? " mbsc-scroller-wheel-3d" : "") + ctx._theme);
        i0.ɵɵstyleProp("height", ctx._style.height);
        i0.ɵɵproperty("batchSize3d", ctx._batchSize3d)("innerClass", "mbsc-scroller-wheel-cont mbsc-scroller-wheel-cont-" + ctx.display + (ctx.scroll3d ? " mbsc-scroller-wheel-cont-3d" : "") + (ctx.multiple ? " mbsc-scroller-wheel-multi" : "") + ctx._theme)("innerStyles", ctx._innerStyle)("items", ctx._items)("itemSize", ctx.itemHeight)("itemNr", ctx._itemNr)("margin", true)("maxIndex", ctx.maxIndex)("minIndex", ctx.minIndex)("offset", ctx.wheel._offset)("onIndexChange", ctx._onIndexChange)("rtl", ctx.rtl)("scroll3d", ctx.scroll3d)("scrollBar", !ctx._touchUi)("selectedIndex", ctx.selectedIndex)("snap", true)("spaceAround", ctx.wheel.spaceAround)("visibleSize", ctx.rows);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", scrollview_r3.visibleItems)("ngForTrackBy", ctx._getItemKey);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", scrollview_r3.visible3dItems)("ngForTrackBy", ctx._getItemKey);
      }
    },
    dependencies: [MbscScrollviewBase, MbscWheelItem, NgForOf],
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscWheel;
}(WheelBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscScroller = /*#__PURE__*/function (_super) {
  __extends(MbscScroller, _super);
  function MbscScroller() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.onCancel = new EventEmitter();
    _this.onChange = new EventEmitter();
    _this.onClose = new EventEmitter();
    _this.onOpen = new EventEmitter();
    _this.onTempChange = new EventEmitter();
    _this.onResize = new EventEmitter();
    return _this;
  }
  Object.defineProperty(MbscScroller.prototype, "vInput", {
    set: function (inp) {
      if (inp) {
        this._el = inp.nativeElement;
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MbscScroller.prototype, "vPopup", {
    set: function (popup) {
      this._popup = popup;
    },
    enumerable: false,
    configurable: true
  });
  MbscScroller.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscScroller_BaseFactory;
    return function MbscScroller_Factory(t) {
      return (ɵMbscScroller_BaseFactory || (ɵMbscScroller_BaseFactory = i0.ɵɵgetInheritedFactory(MbscScroller)))(t || MbscScroller);
    };
  })();
  MbscScroller.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscScroller,
    selectors: [["mbsc-scroller"]],
    viewQuery: function MbscScroller_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c3, 5);
        i0.ɵɵviewQuery(_c13, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vInput = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vPopup = _t.first);
      }
    },
    inputs: {
      ariaLabel: "ariaLabel",
      element: "element",
      writeValue: "writeValue",
      circular: "circular",
      displayStyle: "displayStyle",
      formatValue: "formatValue",
      getValue: "getValue",
      maxWheelWidth: "maxWheelWidth",
      minWheelWidth: "minWheelWidth",
      inContentTemplate: "inContentTemplate",
      invalid: "invalid",
      itemHeight: "itemHeight",
      itemTemplate: "itemTemplate",
      onWheelMove: "onWheelMove",
      parseValue: "parseValue",
      preContentTemplate: "preContentTemplate",
      preContentData: "preContentData",
      rows: "rows",
      selectMultiple: "selectMultiple",
      selectOnScroll: "selectOnScroll",
      shouldValidate: "shouldValidate",
      showInput: "showInput",
      showOnClick: "showOnClick",
      showOnFocus: "showOnFocus",
      tagInput: "tagInput",
      validate: "validate",
      valueEquality: "valueEquality",
      valueMap: "valueMap",
      wheels: "wheels",
      wheelWidth: "wheelWidth",
      disabled: "disabled",
      dropdown: "dropdown",
      endIcon: "endIcon",
      endIconSrc: "endIconSrc",
      endIconSvg: "endIconSvg",
      error: "error",
      errorMessage: "errorMessage",
      inputStyle: "inputStyle",
      label: "label",
      labelStyle: "labelStyle",
      name: "name",
      placeholder: "placeholder",
      startIcon: "startIcon",
      startIconSrc: "startIconSrc",
      startIconSvg: "startIconSvg",
      activeElm: "activeElm",
      anchor: "anchor",
      animation: "animation",
      buttons: "buttons",
      cancelText: "cancelText",
      closeOnEsc: "closeOnEsc",
      closeOnOverlayClick: "closeOnOverlayClick",
      closeText: "closeText",
      context: "context",
      display: "display",
      focusOnClose: "focusOnClose",
      focusOnOpen: "focusOnOpen",
      focusTrap: "focusTrap",
      headerText: "headerText",
      height: "height",
      maxHeight: "maxHeight",
      maxWidth: "maxWidth",
      setText: "setText",
      showArrow: "showArrow",
      showOverlay: "showOverlay",
      width: "width",
      clearText: "clearText"
    },
    outputs: {
      onCancel: "onCancel",
      onChange: "onChange",
      onClose: "onClose",
      onOpen: "onOpen",
      onTempChange: "onTempChange",
      onResize: "onResize"
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 4,
    vars: 37,
    consts: [["popup", ""], ["input", ""], [3, "ariaExpanded", "ariaHaspopup", "ariaLabel", "dropdown", "disabled", "endIcon", "endIconSrc", "endIconSvg", "error", "errorMessage", "inputStyle", "label", "labelStyle", "name", "placeholder", "pickerMap", "pickerValue", "role", "rtl", "startIcon", "startIconSrc", "startIconSvg", "tags", "theme", "themeVariant", "value", 4, "ngIf"], [3, "onClose", "onClosed", "onKeyDown", "onOpen", "onResize", "activeElm", "anchor", "anchorAlign", "animation", "buttons", "cancelText", "closeOnEsc", "closeOnOverlayClick", "closeOnScroll", "closeText", "contentPadding", "context", "cssClass", "disableLeftRight", "display", "focusElm", "focusOnClose", "focusOnOpen", "focusTrap", "fullScreen", "headerText", "height", "isOpen", "maxHeight", "maxWidth", "setText", "showArrow", "showOverlay", "rtl", "scrollLock", "theme", "themeVariant", "touchUi", "windowWidth", "width"], [4, "ngIf"], [3, "ariaExpanded", "ariaHaspopup", "ariaLabel", "dropdown", "disabled", "endIcon", "endIconSrc", "endIconSvg", "error", "errorMessage", "inputStyle", "label", "labelStyle", "name", "placeholder", "pickerMap", "pickerValue", "role", "rtl", "startIcon", "startIconSrc", "startIconSvg", "tags", "theme", "themeVariant", "value"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "class", 4, "ngFor", "ngForOf"], [3, "class", "ngStyle", 4, "ngIf"], [3, "ngStyle"], [3, "activeIndex", "disabled", "display", "itemHeight", "onActiveChange", "onIndexChange", "onSet", "maxIndex", "maxWheelWidth", "minIndex", "minWheelWidth", "multiple", "rows", "scroll3d", "selectedIndex", "selectedValues", "selectOnScroll", "itemTemplate", "theme", "rtl", "wheel", "wheelWidth", "touchUi", 4, "ngFor", "ngForOf"], [3, "activeIndex", "disabled", "display", "itemHeight", "onActiveChange", "onIndexChange", "onSet", "maxIndex", "maxWheelWidth", "minIndex", "minWheelWidth", "multiple", "rows", "scroll3d", "selectedIndex", "selectedValues", "selectOnScroll", "itemTemplate", "theme", "rtl", "wheel", "wheelWidth", "touchUi"]],
    template: function MbscScroller_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, MbscScroller_mbsc_input_0_Template, 3, 26, "mbsc-input", 2);
        i0.ɵɵelementStart(1, "mbsc-popup", 3, 0);
        i0.ɵɵlistener("onClose", function MbscScroller_Template_mbsc_popup_onClose_1_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onPopupClose($event));
        })("onClosed", function MbscScroller_Template_mbsc_popup_onClosed_1_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onPopupClosed($event));
        })("onKeyDown", function MbscScroller_Template_mbsc_popup_onKeyDown_1_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onPopupKey($event));
        })("onOpen", function MbscScroller_Template_mbsc_popup_onOpen_1_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onPopupOpen($event));
        })("onResize", function MbscScroller_Template_mbsc_popup_onResize_1_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onResize($event));
        });
        i0.ɵɵtemplate(3, MbscScroller_ng_container_3_Template, 5, 11, "ng-container", 4);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx._showInput);
        i0.ɵɵadvance();
        i0.ɵɵproperty("activeElm", ctx.s.activeElm)("anchor", ctx._anchor)("anchorAlign", ctx._anchorAlign)("animation", ctx.s.animation)("buttons", ctx._buttons)("cancelText", ctx.s.cancelText)("closeOnEsc", ctx.s.closeOnEsc)("closeOnOverlayClick", ctx.s.closeOnOverlayClick)("closeOnScroll", ctx.s.closeOnScroll)("closeText", ctx.s.closeText)("contentPadding", false)("context", ctx.s.context)("cssClass", ctx._cssClass)("disableLeftRight", true)("display", ctx.s.display)("focusElm", ctx._focusElm)("focusOnClose", ctx.s.focusOnClose)("focusOnOpen", !ctx._allowTyping)("focusTrap", ctx.s.focusTrap)("fullScreen", ctx.s.fullScreen)("headerText", ctx._headerText)("height", ctx.s.height)("isOpen", ctx._isOpen)("maxHeight", ctx.s.maxHeight)("maxWidth", ctx._maxWidth)("setText", ctx.s.setText)("showArrow", ctx.s.showArrow)("showOverlay", ctx._allowTyping ? false : ctx.s.showOverlay)("rtl", ctx.s.rtl)("scrollLock", ctx._scrollLock)("theme", ctx.s.theme)("themeVariant", ctx.s.themeVariant)("touchUi", ctx._touchUi)("windowWidth", ctx.state.width)("width", ctx.s.width);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx._popup && ctx._popup._isVisible || ctx.s.display === "inline");
      }
    },
    dependencies: [MbscInput, MbscPopup, MbscWheel, NgIf, NgTemplateOutlet, NgForOf, NgStyle],
    encapsulation: 2,
    changeDetection: 0
  });
  MbscScroller = __decorate([FormControl], MbscScroller);
  return MbscScroller;
}(ScrollerBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var TEMPLATE = '\n  <mbsc-scroller #scroller\n    [disabled]="s.disabled"\n    [endIcon]="s.endIcon"\n    [endIconSrc]="s.endIconSrc"\n    [endIconSvg]="s.endIconSvg"\n    [error]="s.error"\n    [errorMessage]="s.errorMessage"\n    [inputStyle]="s.inputStyle"\n    [label]="s.label"\n    [labelStyle]="s.labelStyle"\n    [placeholder]="s.placeholder"\n    [name]="s.name"\n    [startIcon]="s.startIcon"\n    [startIconSrc]="s.startIconSrc"\n    [startIconSvg]="s.startIconSvg"\n\n    [anchor]="s.anchor"\n    [animation]="s.animation"\n    [buttons]="s.buttons"\n    [cancelText]="s.cancelText"\n    [clearText]="s.clearText"\n    [closeOnOverlayClick]="s.closeOnOverlayClick"\n    [context]="s.context"\n    [display]="s.display"\n    [focusOnClose]="s.focusOnClose"\n    [focusTrap]="s.focusTrap"\n    [headerText]="s.headerText"\n    [height]="s.height"\n    [setText]="s.setText"\n    [showArrow]="s.showArrow"\n    [showOverlay]="s.showOverlay"\n    [width]="s.width"\n\n    [circular]="s.circular"\n    [displayStyle]="s.displayStyle"\n    [formatValue]="_formatDate"\n    [getValue]="_getDate"\n    [itemHeight]="s.itemHeight"\n    [maxWheelWidth]="s.maxWheelWidth"\n    [minWheelWidth]="_minWheelWidth"\n    [value]="_value"\n    [parseValue]="_parseDate"\n    [rows]="s.rows"\n    [rtl]="s.rtl"\n    [shouldValidate]="_shouldValidate"\n    [showOnClick]="s.showOnClick"\n    [showOnFocus]="s.showOnFocus"\n    [theme]="s.theme"\n    [themeVariant]="s.themeVariant"\n    [touchUi]="_touchUi"\n    [validate]="_validate"\n    [valueEquality]="_valueEquals"\n    [wheels]="_wheels"\n    [wheelWidth]="s.wheelWidth"\n\n    (onCancel)="_hook(\'onCancel\', $event)"\n    (onChange)="_hook(\'onChange\', $event)"\n    (onClose)="_hook(\'onClose\', $event)"\n    (onOpen)="_hook(\'onOpen\', $event)"\n  ></mbsc-scroller>\n';
var MbscDateBase = /*#__PURE__*/function (_super) {
  __extends(MbscDateBase, _super);
  function MbscDateBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.onCancel = new EventEmitter();
    _this.onChange = new EventEmitter();
    _this.onClose = new EventEmitter();
    _this.onOpen = new EventEmitter();
    return _this;
  }
  Object.defineProperty(MbscDateBase.prototype, "vScroller", {
    set: function (scroller) {
      this._scroller = scroller;
    },
    enumerable: false,
    configurable: true
  });
  MbscDateBase.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscDateBase_BaseFactory;
    return function MbscDateBase_Factory(t) {
      return (ɵMbscDateBase_BaseFactory || (ɵMbscDateBase_BaseFactory = i0.ɵɵgetInheritedFactory(MbscDateBase)))(t || MbscDateBase);
    };
  })();
  MbscDateBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: MbscDateBase,
    selectors: [["", "mbsc-dtb-b", ""]],
    viewQuery: function MbscDateBase_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c29, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vScroller = _t.first);
      }
    },
    outputs: {
      onCancel: "onCancel",
      onChange: "onChange",
      onClose: "onClose",
      onOpen: "onOpen"
    },
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  MbscDateBase = __decorate([FormControl], MbscDateBase);
  return MbscDateBase;
}(DatetimeBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscDate = /*#__PURE__*/function (_super) {
  __extends(MbscDate, _super);
  function MbscDate() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MbscDate.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscDate_BaseFactory;
    return function MbscDate_Factory(t) {
      return (ɵMbscDate_BaseFactory || (ɵMbscDate_BaseFactory = i0.ɵɵgetInheritedFactory(MbscDate)))(t || MbscDate);
    };
  })();
  MbscDate.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscDate,
    selectors: [["mbsc-date"]],
    features: [i0.ɵɵInheritDefinitionFeature],
    decls: 2,
    vars: 51,
    consts: [["scroller", ""], [3, "onCancel", "onChange", "onClose", "onOpen", "disabled", "endIcon", "endIconSrc", "endIconSvg", "error", "errorMessage", "inputStyle", "label", "labelStyle", "placeholder", "name", "startIcon", "startIconSrc", "startIconSvg", "anchor", "animation", "buttons", "cancelText", "clearText", "closeOnOverlayClick", "context", "display", "focusOnClose", "focusTrap", "headerText", "height", "setText", "showArrow", "showOverlay", "width", "circular", "displayStyle", "formatValue", "getValue", "itemHeight", "maxWheelWidth", "minWheelWidth", "value", "parseValue", "rows", "rtl", "shouldValidate", "showOnClick", "showOnFocus", "theme", "themeVariant", "touchUi", "validate", "valueEquality", "wheels", "wheelWidth"]],
    template: function MbscDate_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "mbsc-scroller", 1, 0);
        i0.ɵɵlistener("onCancel", function MbscDate_Template_mbsc_scroller_onCancel_0_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._hook("onCancel", $event));
        })("onChange", function MbscDate_Template_mbsc_scroller_onChange_0_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._hook("onChange", $event));
        })("onClose", function MbscDate_Template_mbsc_scroller_onClose_0_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._hook("onClose", $event));
        })("onOpen", function MbscDate_Template_mbsc_scroller_onOpen_0_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._hook("onOpen", $event));
        });
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵproperty("disabled", ctx.s.disabled)("endIcon", ctx.s.endIcon)("endIconSrc", ctx.s.endIconSrc)("endIconSvg", ctx.s.endIconSvg)("error", ctx.s.error)("errorMessage", ctx.s.errorMessage)("inputStyle", ctx.s.inputStyle)("label", ctx.s.label)("labelStyle", ctx.s.labelStyle)("placeholder", ctx.s.placeholder)("name", ctx.s.name)("startIcon", ctx.s.startIcon)("startIconSrc", ctx.s.startIconSrc)("startIconSvg", ctx.s.startIconSvg)("anchor", ctx.s.anchor)("animation", ctx.s.animation)("buttons", ctx.s.buttons)("cancelText", ctx.s.cancelText)("clearText", ctx.s.clearText)("closeOnOverlayClick", ctx.s.closeOnOverlayClick)("context", ctx.s.context)("display", ctx.s.display)("focusOnClose", ctx.s.focusOnClose)("focusTrap", ctx.s.focusTrap)("headerText", ctx.s.headerText)("height", ctx.s.height)("setText", ctx.s.setText)("showArrow", ctx.s.showArrow)("showOverlay", ctx.s.showOverlay)("width", ctx.s.width)("circular", ctx.s.circular)("displayStyle", ctx.s.displayStyle)("formatValue", ctx._formatDate)("getValue", ctx._getDate)("itemHeight", ctx.s.itemHeight)("maxWheelWidth", ctx.s.maxWheelWidth)("minWheelWidth", ctx._minWheelWidth)("value", ctx._value)("parseValue", ctx._parseDate)("rows", ctx.s.rows)("rtl", ctx.s.rtl)("shouldValidate", ctx._shouldValidate)("showOnClick", ctx.s.showOnClick)("showOnFocus", ctx.s.showOnFocus)("theme", ctx.s.theme)("themeVariant", ctx.s.themeVariant)("touchUi", ctx._touchUi)("validate", ctx._validate)("valueEquality", ctx._valueEquals)("wheels", ctx._wheels)("wheelWidth", ctx.s.wheelWidth);
      }
    },
    dependencies: [MbscScroller],
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscDate;
}(MbscDateBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscDatetime = /*#__PURE__*/function (_super) {
  __extends(MbscDatetime, _super);
  function MbscDatetime() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._preset = "datetime";
    return _this;
  }
  MbscDatetime.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscDatetime_BaseFactory;
    return function MbscDatetime_Factory(t) {
      return (ɵMbscDatetime_BaseFactory || (ɵMbscDatetime_BaseFactory = i0.ɵɵgetInheritedFactory(MbscDatetime)))(t || MbscDatetime);
    };
  })();
  MbscDatetime.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscDatetime,
    selectors: [["mbsc-datetime"]],
    features: [i0.ɵɵInheritDefinitionFeature],
    decls: 2,
    vars: 51,
    consts: [["scroller", ""], [3, "onCancel", "onChange", "onClose", "onOpen", "disabled", "endIcon", "endIconSrc", "endIconSvg", "error", "errorMessage", "inputStyle", "label", "labelStyle", "placeholder", "name", "startIcon", "startIconSrc", "startIconSvg", "anchor", "animation", "buttons", "cancelText", "clearText", "closeOnOverlayClick", "context", "display", "focusOnClose", "focusTrap", "headerText", "height", "setText", "showArrow", "showOverlay", "width", "circular", "displayStyle", "formatValue", "getValue", "itemHeight", "maxWheelWidth", "minWheelWidth", "value", "parseValue", "rows", "rtl", "shouldValidate", "showOnClick", "showOnFocus", "theme", "themeVariant", "touchUi", "validate", "valueEquality", "wheels", "wheelWidth"]],
    template: function MbscDatetime_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "mbsc-scroller", 1, 0);
        i0.ɵɵlistener("onCancel", function MbscDatetime_Template_mbsc_scroller_onCancel_0_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._hook("onCancel", $event));
        })("onChange", function MbscDatetime_Template_mbsc_scroller_onChange_0_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._hook("onChange", $event));
        })("onClose", function MbscDatetime_Template_mbsc_scroller_onClose_0_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._hook("onClose", $event));
        })("onOpen", function MbscDatetime_Template_mbsc_scroller_onOpen_0_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._hook("onOpen", $event));
        });
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵproperty("disabled", ctx.s.disabled)("endIcon", ctx.s.endIcon)("endIconSrc", ctx.s.endIconSrc)("endIconSvg", ctx.s.endIconSvg)("error", ctx.s.error)("errorMessage", ctx.s.errorMessage)("inputStyle", ctx.s.inputStyle)("label", ctx.s.label)("labelStyle", ctx.s.labelStyle)("placeholder", ctx.s.placeholder)("name", ctx.s.name)("startIcon", ctx.s.startIcon)("startIconSrc", ctx.s.startIconSrc)("startIconSvg", ctx.s.startIconSvg)("anchor", ctx.s.anchor)("animation", ctx.s.animation)("buttons", ctx.s.buttons)("cancelText", ctx.s.cancelText)("clearText", ctx.s.clearText)("closeOnOverlayClick", ctx.s.closeOnOverlayClick)("context", ctx.s.context)("display", ctx.s.display)("focusOnClose", ctx.s.focusOnClose)("focusTrap", ctx.s.focusTrap)("headerText", ctx.s.headerText)("height", ctx.s.height)("setText", ctx.s.setText)("showArrow", ctx.s.showArrow)("showOverlay", ctx.s.showOverlay)("width", ctx.s.width)("circular", ctx.s.circular)("displayStyle", ctx.s.displayStyle)("formatValue", ctx._formatDate)("getValue", ctx._getDate)("itemHeight", ctx.s.itemHeight)("maxWheelWidth", ctx.s.maxWheelWidth)("minWheelWidth", ctx._minWheelWidth)("value", ctx._value)("parseValue", ctx._parseDate)("rows", ctx.s.rows)("rtl", ctx.s.rtl)("shouldValidate", ctx._shouldValidate)("showOnClick", ctx.s.showOnClick)("showOnFocus", ctx.s.showOnFocus)("theme", ctx.s.theme)("themeVariant", ctx.s.themeVariant)("touchUi", ctx._touchUi)("validate", ctx._validate)("valueEquality", ctx._valueEquals)("wheels", ctx._wheels)("wheelWidth", ctx.s.wheelWidth);
      }
    },
    dependencies: [MbscScroller],
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscDatetime;
}(MbscDateBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscTime = /*#__PURE__*/function (_super) {
  __extends(MbscTime, _super);
  function MbscTime() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._preset = "time";
    return _this;
  }
  MbscTime.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscTime_BaseFactory;
    return function MbscTime_Factory(t) {
      return (ɵMbscTime_BaseFactory || (ɵMbscTime_BaseFactory = i0.ɵɵgetInheritedFactory(MbscTime)))(t || MbscTime);
    };
  })();
  MbscTime.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscTime,
    selectors: [["mbsc-time"]],
    features: [i0.ɵɵInheritDefinitionFeature],
    decls: 2,
    vars: 51,
    consts: [["scroller", ""], [3, "onCancel", "onChange", "onClose", "onOpen", "disabled", "endIcon", "endIconSrc", "endIconSvg", "error", "errorMessage", "inputStyle", "label", "labelStyle", "placeholder", "name", "startIcon", "startIconSrc", "startIconSvg", "anchor", "animation", "buttons", "cancelText", "clearText", "closeOnOverlayClick", "context", "display", "focusOnClose", "focusTrap", "headerText", "height", "setText", "showArrow", "showOverlay", "width", "circular", "displayStyle", "formatValue", "getValue", "itemHeight", "maxWheelWidth", "minWheelWidth", "value", "parseValue", "rows", "rtl", "shouldValidate", "showOnClick", "showOnFocus", "theme", "themeVariant", "touchUi", "validate", "valueEquality", "wheels", "wheelWidth"]],
    template: function MbscTime_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "mbsc-scroller", 1, 0);
        i0.ɵɵlistener("onCancel", function MbscTime_Template_mbsc_scroller_onCancel_0_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._hook("onCancel", $event));
        })("onChange", function MbscTime_Template_mbsc_scroller_onChange_0_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._hook("onChange", $event));
        })("onClose", function MbscTime_Template_mbsc_scroller_onClose_0_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._hook("onClose", $event));
        })("onOpen", function MbscTime_Template_mbsc_scroller_onOpen_0_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._hook("onOpen", $event));
        });
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵproperty("disabled", ctx.s.disabled)("endIcon", ctx.s.endIcon)("endIconSrc", ctx.s.endIconSrc)("endIconSvg", ctx.s.endIconSvg)("error", ctx.s.error)("errorMessage", ctx.s.errorMessage)("inputStyle", ctx.s.inputStyle)("label", ctx.s.label)("labelStyle", ctx.s.labelStyle)("placeholder", ctx.s.placeholder)("name", ctx.s.name)("startIcon", ctx.s.startIcon)("startIconSrc", ctx.s.startIconSrc)("startIconSvg", ctx.s.startIconSvg)("anchor", ctx.s.anchor)("animation", ctx.s.animation)("buttons", ctx.s.buttons)("cancelText", ctx.s.cancelText)("clearText", ctx.s.clearText)("closeOnOverlayClick", ctx.s.closeOnOverlayClick)("context", ctx.s.context)("display", ctx.s.display)("focusOnClose", ctx.s.focusOnClose)("focusTrap", ctx.s.focusTrap)("headerText", ctx.s.headerText)("height", ctx.s.height)("setText", ctx.s.setText)("showArrow", ctx.s.showArrow)("showOverlay", ctx.s.showOverlay)("width", ctx.s.width)("circular", ctx.s.circular)("displayStyle", ctx.s.displayStyle)("formatValue", ctx._formatDate)("getValue", ctx._getDate)("itemHeight", ctx.s.itemHeight)("maxWheelWidth", ctx.s.maxWheelWidth)("minWheelWidth", ctx._minWheelWidth)("value", ctx._value)("parseValue", ctx._parseDate)("rows", ctx.s.rows)("rtl", ctx.s.rtl)("shouldValidate", ctx._shouldValidate)("showOnClick", ctx.s.showOnClick)("showOnFocus", ctx.s.showOnFocus)("theme", ctx.s.theme)("themeVariant", ctx.s.themeVariant)("touchUi", ctx._touchUi)("validate", ctx._validate)("valueEquality", ctx._valueEquals)("wheels", ctx._wheels)("wheelWidth", ctx.s.wheelWidth);
      }
    },
    dependencies: [MbscScroller],
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscTime;
}(MbscDateBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function getClosestNumber(arr, value) {
  if (value == null || !arr.length) {
    return null;
  }
  var i = 0;
  while (i < arr.length && value >= arr[i]) {
    i++;
  }
  if (i === arr.length) {
    return arr[i - 1];
  } else if (i === 0) {
    return arr[0];
  } else {
    var prev = arr[i - 1];
    var next = arr[i];
    return value - prev < next - value ? prev : next;
  }
}
var TimegridBase = /*#__PURE__*/function (_super) {
  __extends(TimegridBase, _super);
  function TimegridBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._setTime = function (timeSlot) {
      _this._hook("onChange", {
        value: createDate(_this.s, timeSlot.value)
      });
    };
    _this._isDisabled = function (d) {
      if (d) {
        var key = getDateStr(createDate(_this.s, d));
        var invalidsForDay = _this._invalids && _this._invalids[key];
        var validsForDay = _this._valids && _this._valids[key];
        var exclusiveEndDates = _this.s.exclusiveEndDates;
        if (validsForDay) {
          for (var _i = 0, validsForDay_1 = validsForDay; _i < validsForDay_1.length; _i++) {
            var valid = validsForDay_1[_i];
            var lessThanEnd = valid.end && (exclusiveEndDates ? d < +valid.end : d <= +valid.end);
            if (valid.start && d >= +valid.start && lessThanEnd || valid.allDay) {
              return false;
            }
          }
          return true;
        }
        if (invalidsForDay) {
          for (var _a = 0, invalidsForDay_1 = invalidsForDay; _a < invalidsForDay_1.length; _a++) {
            var invalid = invalidsForDay_1[_a];
            var lessThanEnd = invalid.end && (exclusiveEndDates ? d < +invalid.end : d <= +invalid.end);
            if (invalid.start && d >= +invalid.start && lessThanEnd || invalid.allDay) {
              return true;
            }
          }
          return false;
        }
      }
      return false;
    };
    _this._onKeyDown = function (ev) {
      switch (ev.keyCode) {
        case SPACE:
          ev.target.click();
          ev.preventDefault();
          break;
      }
    };
    _this._setCont = function (el) {
      _this._gridContEl = el && el.parentElement;
    };
    return _this;
  }
  TimegridBase.prototype._render = function (s, state) {
    var _this = this;
    var prevS = this._prevS;
    this._cssClass = "mbsc-timegrid-container mbsc-font" + this._theme + this._rtl;
    var minChanged = s.min !== prevS.min;
    var maxChanged = s.max !== prevS.max;
    var timeFormat = s.timeFormat;
    var valueChanged = prevS.value && !s.value || s.value && +s.value !== this._value;
    if (minChanged) {
      this._min = isEmpty(s.min) ? UNDEFINED : makeDate(s.min, s, timeFormat);
    }
    if (maxChanged) {
      this._max = isEmpty(s.max) ? UNDEFINED : makeDate(s.max, s, timeFormat);
    }
    var selected = s.value || createDate(s);
    var dayStart = getDateOnly(selected);
    var dayEnd = addDays(dayStart, 1);
    var currentDateChanged = this._selectedDate !== +dayStart;
    var invChanged = s.invalid !== prevS.invalid;
    var validChanged = s.valid !== prevS.valid;
    if (invChanged || currentDateChanged) {
      this._invalids = getEventMap(s.invalid, dayStart, dayEnd, s, true);
    }
    if (validChanged || currentDateChanged) {
      this._valids = getEventMap(s.valid, dayStart, dayEnd, s, true);
    }
    if (valueChanged) {
      this._value = s.value && +s.value;
    }
    var timeSlotsChange = currentDateChanged || invChanged || minChanged || maxChanged || timeFormat !== prevS.timeFormat;
    if (timeSlotsChange) {
      this._selectedDate = +dayStart;
      var start = Math.max(+dayStart, +(this._min || -Infinity));
      var end = Math.min(+dayEnd, +(this._max || Infinity) + 1);
      var timeInterval = s.stepHour * 36e5 + s.stepMinute * 6e4;
      this._timeSlots = [];
      this._validTimes = [];
      var arr = [];
      var i = 0;
      for (var d = +dayStart; d < +dayEnd; d += timeInterval) {
        if (end >= start ? d >= start && d < end : d >= start || d < end) {
          var timeslot = {
            formattedValue: formatDate(timeFormat, createDate(s, d), s),
            value: d
          };
          arr.push(timeslot);
          if (i === 2) {
            this._timeSlots.push(arr);
            arr = [];
            i = -1;
          }
          if (!this._isDisabled(d)) {
            this._validTimes.push(timeslot);
          }
          i++;
        }
      }
      if (arr.length) {
        this._timeSlots.push(arr);
      }
    }
    if (this._isDisabled(this._value) || (valueChanged || timeSlotsChange) && findIndex(this._validTimes, function (ts) {
      return ts.value === _this._value;
    }) === -1) {
      var validated_1 = getClosestNumber(this._validTimes.map(function (slot) {
        return slot.value;
      }), this._value);
      if (validated_1) {
        clearTimeout(this._validationHandle);
        this._validationHandle = setTimeout(function () {
          var validTimeslot = find(_this._validTimes, function (slot) {
            return slot.value === validated_1;
          });
          _this._setTime(validTimeslot);
        });
      }
    } else if (timeSlotsChange) {
      clearTimeout(this._validationHandle);
    }
    this._valueChanged = this._valueChanged || valueChanged;
  };
  TimegridBase.prototype._updated = function () {
    var isOpen = this.s.isOpen;
    if (isBrowser && this._value !== UNDEFINED && (this._valueChanged || this._isOpen !== isOpen && isOpen)) {
      var animate_1 = this._lastValue !== UNDEFINED;
      var grid_1 = this._gridContEl;
      var timeslot_1 = grid_1.querySelector('[data-timeslot="' + this._value + '"]');
      if (timeslot_1) {
        setTimeout(function () {
          var itemRect = timeslot_1.getBoundingClientRect();
          var itemTop = itemRect.top;
          var itemHeight = itemRect.height;
          var gridRect = grid_1.getBoundingClientRect();
          var gridTop = gridRect.top;
          var gridHeight = gridRect.height;
          var currPos = getScrollTop(grid_1);
          if (itemTop + itemHeight > gridTop + gridHeight || itemTop < gridTop) {
            var scrollPos = itemTop - gridTop + currPos - 5;
            smoothScroll(grid_1, UNDEFINED, scrollPos, animate_1);
          }
        });
      }
      this._valueChanged = false;
      this._lastValue = this._value;
    }
    this._isOpen = isOpen;
  };
  TimegridBase.defaults = __assign(__assign({}, dateTimeLocale), {
    stepHour: 0,
    stepMinute: 30
  });
  TimegridBase._name = "Timegrid";
  TimegridBase.ɵfac = /* @__PURE__ */(() => {
    let ɵTimegridBase_BaseFactory;
    return function TimegridBase_Factory(t) {
      return (ɵTimegridBase_BaseFactory || (ɵTimegridBase_BaseFactory = i0.ɵɵgetInheritedFactory(TimegridBase)))(t || TimegridBase);
    };
  })();
  TimegridBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TimegridBase,
    selectors: [["", "mbsc-tg-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return TimegridBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscTimeBox = /*#__PURE__*/function () {
  function MbscTimeBox() {}
  MbscTimeBox.ɵfac = function MbscTimeBox_Factory(t) {
    return new (t || MbscTimeBox)();
  };
  MbscTimeBox.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscTimeBox,
    selectors: [["mbsc-timebox"]],
    inputs: {
      disabled: "disabled",
      selected: "selected",
      timeSlot: "timeSlot",
      theme: "theme",
      onClick: "onClick",
      onKeyDown: "onKeyDown"
    },
    decls: 2,
    vars: 5,
    consts: [[3, "click", "keydown"]],
    template: function MbscTimeBox_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵlistener("click", function MbscTimeBox_Template_div_click_0_listener() {
          return ctx.onClick(ctx.timeSlot);
        })("keydown", function MbscTimeBox_Template_div_keydown_0_listener($event) {
          return ctx.onKeyDown($event);
        });
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵclassMap("mbsc-timegrid-item" + (ctx.selected ? " mbsc-selected" : "") + (ctx.disabled ? " mbsc-disabled" : "") + ctx.theme);
        i0.ɵɵattribute("data-timeslot", ctx.timeSlot.value)("tabIndex", ctx.disabled ? null : 0);
        i0.ɵɵadvance();
        i0.ɵɵtextInterpolate1(" ", ctx.timeSlot.formattedValue, " ");
      }
    },
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscTimeBox;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscTimegrid = /*#__PURE__*/function (_super) {
  __extends(MbscTimegrid, _super);
  function MbscTimegrid() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MbscTimegrid.prototype._mounted = function () {
    var el = this._elr.nativeElement;
    this._gridContEl = el && el.parentElement;
  };
  MbscTimegrid.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscTimegrid_BaseFactory;
    return function MbscTimegrid_Factory(t) {
      return (ɵMbscTimegrid_BaseFactory || (ɵMbscTimegrid_BaseFactory = i0.ɵɵgetInheritedFactory(MbscTimegrid)))(t || MbscTimegrid);
    };
  })();
  MbscTimegrid.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscTimegrid,
    selectors: [["mbsc-timegrid"]],
    hostVars: 2,
    hostBindings: function MbscTimegrid_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx._cssClass);
      }
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    decls: 1,
    vars: 2,
    consts: [["class", "mbsc-timegrid-row", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "mbsc-timegrid-row"], [3, "class", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "disabled", "selected", "timeSlot", "theme", "onClick", "onKeyDown"]],
    template: function MbscTimegrid_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, MbscTimegrid_div_0_Template, 2, 2, "div", 0);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngForOf", ctx._timeSlots)("ngForTrackBy", ctx._getKey);
      }
    },
    dependencies: [MbscTimeBox, NgForOf],
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscTimegrid;
}(TimegridBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var radios = {};
function subscribeRadio(name, handler) {
  if (!radios[name]) {
    radios[name] = {
      change: new Observable(),
      selectedIndex: -1
    };
  }
  return radios[name].change.subscribe(handler);
}
function unsubscribeRadio(name, key) {
  var data = radios[name];
  if (data) {
    data.change.unsubscribe(key);
    if (!data.change.nr) {
      delete radios[name];
    }
  }
}
function setRadio(name, value, selectedIndex) {
  var data = radios[name];
  if (data) {
    if (selectedIndex !== UNDEFINED) {
      data.selectedIndex = selectedIndex;
    }
    if (value !== UNDEFINED) {
      data.value = value;
    }
    data.change.next(data.value);
  }
}
function getSelectedIndex(name) {
  return radios[name] && radios[name].selectedIndex;
}
function setSelectedIndex(name, selectedIndex) {
  if (radios[name]) {
    radios[name].selectedIndex = selectedIndex;
  }
}
var guid$2 = 1;
var SegmentedGroupBase = /*#__PURE__*/function (_super) {
  __extends(SegmentedGroupBase, _super);
  function SegmentedGroupBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._id = "mbsc-segmented-group" + guid$2++;
    _this._onChange = function (ev, val) {
      var s = _this.s;
      var value = s.modelValue !== UNDEFINED ? s.modelValue : _this.value;
      if (s.select === "multiple") {
        if (value !== UNDEFINED) {
          value = value || [];
          var index = value.indexOf(val);
          if (index !== -1) {
            value.splice(index, 1);
          } else {
            value.push(val);
          }
          _this.value = __spreadArray([], value, true);
        }
      } else {
        _this.value = val;
      }
      _this._change(_this.value);
      if (s.onChange) {
        s.onChange(ev);
      }
    };
    return _this;
  }
  SegmentedGroupBase.prototype._change = function (value) {};
  SegmentedGroupBase.prototype._render = function (s) {
    this._name = s.name === UNDEFINED ? this._id : s.name;
    this._groupClass = "mbsc-segmented mbsc-flex " + this._className + this._theme + this._rtl + (s.color ? " mbsc-segmented-" + s.color : "") + (this.state.dragging ? " mbsc-segmented-dragging" : "");
    this._groupOpt = {
      color: s.color,
      disabled: s.disabled,
      name: this._name,
      onChange: this._onChange,
      select: s.select,
      value: s.modelValue !== UNDEFINED ? s.modelValue : s.value
    };
  };
  SegmentedGroupBase.prototype._updated = function () {
    if (this.s.drag && this.s.select !== "multiple") {
      if (!this._unlisten) {
        this._setupDrag();
      }
    } else {
      this._cleanupDrag();
    }
  };
  SegmentedGroupBase.prototype._destroy = function () {
    this._cleanupDrag();
  };
  SegmentedGroupBase.prototype._setupDrag = function () {
    var _this = this;
    var disabledArray = [];
    var widthArray = [];
    var wrapperWidth;
    var wrapperLeft;
    var isDragging;
    var selectedIndex;
    var oldIndex;
    var name;
    this._unlisten = gestureListener(this._el, {
      onEnd: function () {
        if (isDragging && selectedIndex !== oldIndex && !disabledArray[selectedIndex]) {
          var inputElement = _this._el.querySelectorAll(".mbsc-segmented-input")[selectedIndex];
          inputElement.click();
        }
        isDragging = false;
        _this.setState({
          dragging: false
        });
      },
      onMove: function (ev) {
        if (isDragging) {
          var relativeLeft = Math.min(Math.max(ev.endX - wrapperLeft, 0), wrapperWidth);
          var newIndex = 0;
          var beforeSum = widthArray[0];
          while (relativeLeft > beforeSum && widthArray.length > newIndex + 1) {
            newIndex++;
            beforeSum += widthArray[newIndex];
          }
          newIndex = _this.s.rtl ? widthArray.length - 1 - newIndex : newIndex;
          if (newIndex !== selectedIndex && !disabledArray[newIndex]) {
            selectedIndex = newIndex;
            setRadio(name, UNDEFINED, selectedIndex);
          }
        }
      },
      onStart: function (ev) {
        var item = closest(ev.domEvent.target, ".mbsc-segmented-item", _this._el);
        if (!item) {
          return;
        }
        var input = item.querySelector(".mbsc-segmented-input");
        var classList = input.classList;
        if (classList.contains("mbsc-selected")) {
          disabledArray = [];
          forEach(_this._el.querySelectorAll(".mbsc-segmented-button"), function (button) {
            disabledArray.push(button.classList.contains("mbsc-disabled"));
          });
          widthArray = [];
          forEach(_this._el.querySelectorAll(".mbsc-segmented-item"), function (el) {
            widthArray.push(el.clientWidth);
          });
          var padding = 15;
          wrapperWidth = _this._el.clientWidth - padding * 2;
          wrapperLeft = getOffset(_this._el).left + padding;
          name = input.name;
          selectedIndex = getSelectedIndex(name);
          oldIndex = selectedIndex;
          if (widthArray.length && input.type === "radio") {
            isDragging = true;
            _this.setState({
              dragging: true
            });
          }
        }
      }
    });
  };
  SegmentedGroupBase.prototype._cleanupDrag = function () {
    if (this._unlisten) {
      this._unlisten();
      this._unlisten = null;
    }
  };
  SegmentedGroupBase.defaults = {
    select: "single"
  };
  SegmentedGroupBase._name = "SegmentedGroup";
  SegmentedGroupBase.ɵfac = /* @__PURE__ */(() => {
    let ɵSegmentedGroupBase_BaseFactory;
    return function SegmentedGroupBase_Factory(t) {
      return (ɵSegmentedGroupBase_BaseFactory || (ɵSegmentedGroupBase_BaseFactory = i0.ɵɵgetInheritedFactory(SegmentedGroupBase)))(t || SegmentedGroupBase);
    };
  })();
  SegmentedGroupBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: SegmentedGroupBase,
    selectors: [["", "mbsc-sgr-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return SegmentedGroupBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscRadioService = /*#__PURE__*/function () {
  function MbscRadioService() {}
  MbscRadioService.ɵfac = function MbscRadioService_Factory(t) {
    return new (t || MbscRadioService)();
  };
  MbscRadioService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MbscRadioService,
    factory: MbscRadioService.ɵfac
  });
  return MbscRadioService;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscSegmentedGroup = /*#__PURE__*/function (_super) {
  __extends(MbscSegmentedGroup, _super);
  function MbscSegmentedGroup() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MbscSegmentedGroup.prototype._onValueChange = function (value) {
    this._radioService.value = value;
    setRadio(this._radioService.name, value);
  };
  MbscSegmentedGroup.prototype._ctor = function () {
    this._radioService = this._injector.get(MbscRadioService);
  };
  MbscSegmentedGroup.prototype._render = function (s) {
    _super.prototype._render.call(this, s);
    var rs = this._radioService;
    rs.color = s.color;
    rs.disabled = s.disabled;
    rs.name = this._name;
    rs.select = s.select;
    rs.value = this.value;
    rs.onChange = this._onChange;
  };
  MbscSegmentedGroup.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscSegmentedGroup_BaseFactory;
    return function MbscSegmentedGroup_Factory(t) {
      return (ɵMbscSegmentedGroup_BaseFactory || (ɵMbscSegmentedGroup_BaseFactory = i0.ɵɵgetInheritedFactory(MbscSegmentedGroup)))(t || MbscSegmentedGroup);
    };
  })();
  MbscSegmentedGroup.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscSegmentedGroup,
    selectors: [["mbsc-segmented-group"]],
    hostVars: 2,
    hostBindings: function MbscSegmentedGroup_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx._groupClass);
      }
    },
    inputs: {
      color: "color",
      disabled: "disabled",
      name: "name",
      select: "select"
    },
    features: [i0.ɵɵProvidersFeature([MbscRadioService]), i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function MbscSegmentedGroup_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2,
    changeDetection: 0
  });
  MbscSegmentedGroup = __decorate([FormControl], MbscSegmentedGroup);
  return MbscSegmentedGroup;
}(SegmentedGroupBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var guid$3 = 1;
var SegmentedBase = /*#__PURE__*/function (_super) {
  __extends(SegmentedBase, _super);
  function SegmentedBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._onChange = function (ev) {
      var s = _this.s;
      var checked = ev.target.checked;
      if (checked === _this._checked) {
        return;
      }
      _this._change(checked);
      if (_this._onGroupChange) {
        _this._onGroupChange(ev, _this._value);
      }
      _this._toggle(checked);
      if (s.onChange) {
        s.onChange(ev);
      }
    };
    _this._onValueChange = function (value) {
      var s = _this.s;
      var selected = _this._isMultiple ? isArray(value) && value.indexOf(_this._value) !== -1 : value === _this._value;
      if (s.checked === UNDEFINED && selected !== _this.state.selected) {
        _this.setState({
          selected: selected
        });
      } else {
        _this.forceUpdate();
      }
      _this._change(selected);
    };
    _this._setBox = function (box) {
      _this._box = box;
    };
    return _this;
  }
  SegmentedBase.prototype._change = function (checked) {};
  SegmentedBase.prototype._groupOptions = function (_a) {
    var _this = this;
    var color = _a.color,
      disabled = _a.disabled,
      name = _a.name,
      onChange = _a.onChange,
      select = _a.select,
      value = _a.value;
    var s = this.s;
    var state = this.state;
    var prevChecked = this._checked;
    var modelValue = s.modelValue !== UNDEFINED ? s.modelValue === s.value : s.checked;
    var checked = modelValue !== UNDEFINED ? emptyOrTrue(modelValue) : state.selected === UNDEFINED ? emptyOrTrue(s.defaultChecked) : state.selected;
    this._id = s.id === UNDEFINED ? this._id || "mbsc-segmented-" + guid$3++ : s.id;
    this._value = s.value === UNDEFINED ? this._id : s.value;
    this._onGroupChange = onChange;
    this._isMultiple = (select || s.select) === "multiple";
    this._name = name === UNDEFINED ? s.name : name;
    this._disabled = disabled === UNDEFINED ? s.disabled === UNDEFINED ? state.disabled : emptyOrTrue(s.disabled) : emptyOrTrue(disabled);
    this._color = color === UNDEFINED ? s.color : color;
    this._checked = value === UNDEFINED ? checked : this._isMultiple ? value && value.indexOf(this._value) !== -1 : value === this._value;
    if (!this._isMultiple && !prevChecked && this._checked) {
      setTimeout(function () {
        if (_this._checked) {
          setRadio(_this._name, _this._value, _this._index);
        }
      });
    }
    this._selectedIndex = getSelectedIndex(this._name);
    this._cssClass = "mbsc-segmented-item " + this._className + this._theme + this._rtl + (this._checked ? " mbsc-segmented-item-checked" : "") + (state.hasFocus ? " mbsc-focus" : "") + (this._index === this._selectedIndex || this._index === UNDEFINED && this._checked || this._isMultiple && this._checked ? " mbsc-segmented-item-selected" : "");
  };
  SegmentedBase.prototype._toggle = function (checked) {
    if (this.s.checked === UNDEFINED) {
      this.setState({
        selected: checked
      });
    }
  };
  SegmentedBase.prototype._mounted = function () {
    var _this = this;
    listen(this._el, CLICK, this._onChange);
    this._unlisten = gestureListener(this._el, {
      onBlur: function () {
        _this.setState({
          hasFocus: false
        });
      },
      onFocus: function () {
        _this.setState({
          hasFocus: true
        });
      }
    });
  };
  SegmentedBase.prototype._updated = function () {
    if (this._name && !this._unsubscribe) {
      this._unsubscribe = subscribeRadio(this._name, this._onValueChange);
    }
    if (!this._isMultiple) {
      var cont = closest(this._el, ".mbsc-segmented");
      var index = -1;
      var selectedIndex = -1;
      if (cont) {
        var items = cont.querySelectorAll('.mbsc-segmented-input[name="' + this._name + '"]');
        for (var i = 0; i < items.length; i++) {
          if (items[i] === this._el) {
            index = i;
          }
          if (items[i].checked) {
            selectedIndex = i;
          }
        }
      }
      if (this._index !== index && selectedIndex !== -1) {
        setSelectedIndex(this._name, selectedIndex);
      }
      if (this._selectedIndex !== -1) {
        this._box.style.transform = "translateX(" + (this.s.rtl ? -1 : 1) * (this._selectedIndex - index) * 100 + "%)";
        this._animate = true;
      }
      if (index !== -1) {
        this._index = index;
      }
    }
  };
  SegmentedBase.prototype._destroy = function () {
    unlisten(this._el, CLICK, this._onChange);
    if (this._unsubscribe) {
      unsubscribeRadio(this._name, this._unsubscribe);
      this._unsubscribe = UNDEFINED;
    }
    if (this._unlisten) {
      this._unlisten();
    }
  };
  SegmentedBase.defaults = {
    select: "single"
  };
  SegmentedBase._name = "Segmented";
  SegmentedBase.ɵfac = /* @__PURE__ */(() => {
    let ɵSegmentedBase_BaseFactory;
    return function SegmentedBase_Factory(t) {
      return (ɵSegmentedBase_BaseFactory || (ɵSegmentedBase_BaseFactory = i0.ɵɵgetInheritedFactory(SegmentedBase)))(t || SegmentedBase);
    };
  })();
  SegmentedBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: SegmentedBase,
    selectors: [["", "mbsc-seg-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return SegmentedBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscSegmented = /*#__PURE__*/function (_super) {
  __extends(MbscSegmented, _super);
  function MbscSegmented() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.checkedChange = new EventEmitter();
    return _this;
  }
  Object.defineProperty(MbscSegmented.prototype, "checked", {
    get: function () {
      return this._check;
    },
    set: function (val) {
      var rs = this._radioService;
      if (this._check !== val) {
        if (this._isMultiple) {
          this._onFormChange(val);
        } else if (val) {
          if (rs) {
            rs.value = this.value;
          }
          this._onFormChange(this.value);
        }
        this.props.checked = val;
        this._check = val;
        this.setState({
          selected: val
        });
      }
    },
    enumerable: false,
    configurable: true
  });
  MbscSegmented.prototype.registerOnChange = function (fn) {
    this._onFormChange = fn;
  };
  MbscSegmented.prototype.registerOnTouched = function (fn) {
    this._onFormTouch = fn;
  };
  MbscSegmented.prototype.setDisabledState = function (disabled) {
    this.setState({
      disabled: disabled
    });
  };
  MbscSegmented.prototype.writeValue = function (val) {
    this.checked = this._isMultiple ? val : this.value === val;
  };
  MbscSegmented.prototype._change = function (checked) {
    this.checked = checked;
  };
  MbscSegmented.prototype._ctor = function () {
    var rs;
    this._radioService = rs = this._injector.get(MbscRadioService, null);
    var select = rs && rs.select || this.select;
    this._isMultiple = select === "multiple";
  };
  MbscSegmented.prototype._render = function (s, state) {
    this._groupOptions(this._radioService || {});
    _super.prototype._render.call(this, s, state);
  };
  MbscSegmented.prototype._mounted = function () {
    this._el = this.vInput.nativeElement;
    this._box = this.vBox.nativeElement;
    _super.prototype._mounted.call(this);
  };
  MbscSegmented.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscSegmented_BaseFactory;
    return function MbscSegmented_Factory(t) {
      return (ɵMbscSegmented_BaseFactory || (ɵMbscSegmented_BaseFactory = i0.ɵɵgetInheritedFactory(MbscSegmented)))(t || MbscSegmented);
    };
  })();
  MbscSegmented.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscSegmented,
    selectors: [["mbsc-segmented"]],
    viewQuery: function MbscSegmented_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c3, 5);
        i0.ɵɵviewQuery(_c30, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vInput = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vBox = _t.first);
      }
    },
    hostVars: 2,
    hostBindings: function MbscSegmented_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx._cssClass);
      }
    },
    inputs: {
      ariaLabel: "ariaLabel",
      color: "color",
      checked: "checked",
      disabled: "disabled",
      endIcon: "endIcon",
      endIconSrc: "endIconSrc",
      endIconSvg: "endIconSvg",
      icon: "icon",
      iconSvg: "iconSvg",
      iconSrc: "iconSrc",
      id: "id",
      name: "name",
      ripple: "ripple",
      startIcon: "startIcon",
      startIconSrc: "startIconSrc",
      startIconSvg: "startIconSvg",
      select: "select"
    },
    outputs: {
      checkedChange: "checkedChange"
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 8,
    vars: 32,
    consts: [["box", ""], ["input", ""], [1, "mbsc-segmented-label"], [3, "checked", "disabled", "name", "type", "value"], ["aria-hidden", "true", "role", "none", 3, "ariaLabel", "color", "disabled", "endIcon", "endIconSrc", "endIconSvg", "icon", "iconSrc", "iconSvg", "id", "ripple", "rtl", "startIcon", "startIconSrc", "startIconSvg", "tabIndex", "theme", "themeVariant"]],
    template: function MbscSegmented_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "label", 2)(1, "div", null, 0);
        i0.ɵɵelement(3, "div");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(4, "input", 3, 1);
        i0.ɵɵelementStart(6, "mbsc-button", 4);
        i0.ɵɵprojection(7);
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵclassMap("mbsc-segmented-selectbox" + ctx._theme + (ctx._animate ? " mbsc-segmented-selectbox-animate" : "") + (ctx._checked ? " mbsc-selected" : ""));
        i0.ɵɵadvance(2);
        i0.ɵɵclassMap("mbsc-segmented-selectbox-inner" + (ctx._index === ctx._selectedIndex || ctx._checked ? " mbsc-segmented-selectbox-inner-visible" : "") + (ctx._checked ? " mbsc-selected" : "") + ctx._theme);
        i0.ɵɵadvance();
        i0.ɵɵclassMap("mbsc-segmented-input mbsc-reset" + ctx._theme + (ctx._checked ? " mbsc-selected" : ""));
        i0.ɵɵproperty("checked", ctx._checked)("disabled", ctx._disabled)("name", ctx._isMultiple ? ctx.s.name === undefined ? "" : ctx.s.name : ctx._name)("type", ctx._isMultiple ? "checkbox" : "radio")("value", ctx._value);
        i0.ɵɵattribute("aria-labelledby", ctx._id);
        i0.ɵɵadvance(2);
        i0.ɵɵclassMap("mbsc-segmented-button" + (ctx._checked ? " mbsc-selected" : "") + (ctx.state.hasFocus ? " mbsc-focus" : ""));
        i0.ɵɵproperty("ariaLabel", ctx.s.ariaLabel)("color", ctx._color)("disabled", ctx._disabled)("endIcon", ctx.s.endIcon)("endIconSrc", ctx.s.endIconSrc)("endIconSvg", ctx.s.endIconSvg)("icon", ctx.s.icon)("iconSrc", ctx.s.iconSrc)("iconSvg", ctx.s.iconSvg)("id", ctx._id)("ripple", ctx.s.ripple)("rtl", ctx.s.rtl)("startIcon", ctx.s.startIcon)("startIconSrc", ctx.s.startIconSrc)("startIconSvg", ctx.s.startIconSvg)("tabIndex", -1)("theme", ctx.s.theme)("themeVariant", ctx.s.themeVariant);
      }
    },
    dependencies: [MbscButton],
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscSegmented;
}(SegmentedBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var template = '\n<div [class]="\'mbsc-datepicker mbsc-flex-col mbsc-datepicker-\' + s.display + _theme +\n  (s.display === \'inline\' ? \' \' + _className + _hb : \'\') + _controlsClass"\n>\n  <div *ngIf="_headerText && s.display === \'inline\'" [class]="\'mbsc-picker-header\' + _theme + _hb">\n    {{_headerText}}\n  </div>\n\n  <mbsc-segmented-group *ngIf="_renderTabs"\n    [rtl]="s.rtl"\n    [theme]="s.theme"\n    [themeVariant]="s.themeVariant"\n    [(ngModel)]="_activeTab"\n    (change)="_changeActiveTab($event)"\n  >\n    <mbsc-segmented *ngFor="let control of _controls"\n      [rtl]="s.rtl"\n      [theme]="s.theme"\n      [themeVariant]="s.themeVariant"\n      [value]="control.name"\n    >\n      {{control.title}}\n    </mbsc-segmented>\n  </mbsc-segmented-group>\n  <div *ngIf="_renderControls" [class]="\'mbsc-range-control-wrapper\' + _theme">\n    <mbsc-segmented-group\n      [rtl]="s.rtl"\n      [theme]="s.theme"\n      [themeVariant]="s.themeVariant"\n      [(ngModel)]="_activeSelect"\n      (change)="_changeActiveSelect($event)"\n    >\n      <mbsc-segmented [rtl]="s.rtl" [theme]="s.theme" [themeVariant]="s.themeVariant" value="start" [class]="\'mbsc-range-start\' +\n        (_tempStartText ? \' mbsc-range-value-nonempty\' : \'\')">\n        <div [class]="\'mbsc-range-control-label\' + _theme + _rtl +\n        (_activeSelect === \'start\'? \' active\' : \'\')">{{s.rangeStartLabel}}</div>\n        <div [class]="\'mbsc-range-control-value\' + _theme + _rtl +\n        (_activeSelect === \'start\' ? \' active\' : \'\') +\n        (!_tempStartText ? \' mbsc-range-control-text-empty\' : \'\')">{{_tempStartText || s.rangeStartHelp}}</div>\n        <mbsc-icon *ngIf="_activeSelect === \'start\' && _tempStartText" [class]="\'mbsc-range-label-clear\' + _rtl"\n          (click)="_clearStart()" [svg]="s.clearIcon" [theme]="s.theme"></mbsc-icon>\n      </mbsc-segmented>\n      <mbsc-segmented [rtl]="s.rtl" [theme]="s.theme" [themeVariant]="s.themeVariant" value="end" [class]="\'mbsc-range-end\' +\n        (_tempEndText ? \' mbsc-range-value-nonempty\' : \'\')">\n        <div [class]="\'mbsc-range-control-label\' + _theme + _rtl +\n        (_activeSelect === \'end\'? \' active\' : \'\')">{{s.rangeEndLabel}}</div>\n        <div [class]="\'mbsc-range-control-value\' + _theme + _rtl +\n        (_activeSelect === \'end\' ? \' active\' : \'\') +\n        (!_tempEndText ? \' mbsc-range-control-text-empty\' : \'\')">{{_tempEndText || s.rangeEndHelp}}</div>\n        <mbsc-icon *ngIf="_activeSelect === \'end\' && _tempEndText" [class]="\'mbsc-range-label-clear\' + _rtl"\n          (click)="_clearEnd()" [svg]="s.clearIcon" [theme]="s.theme"></mbsc-icon>\n      </mbsc-segmented>\n    </mbsc-segmented-group>\n  </div>\n  <div [class]="\'mbsc-datepicker-tab-wrapper mbsc-flex mbsc-flex-1-1 \' + _theme" #wrapper>\n    <div *ngFor="let control of _controls"\n      [class]="\'mbsc-flex mbsc-datepicker-tab mbsc-datepicker-tab-\' + control.name + _theme +\n        ((_renderTabs && control.name === _activeTab) || !_renderTabs ? \' mbsc-datepicker-tab-active\' : \'\') +\n        (_renderTabs && control.name === \'time\' ? \' mbsc-datepicker-time-modal\' : \'\') +\n        (_renderTabs || _controls.length === 1 ? \' mbsc-datepicker-tab-expand mbsc-flex-1-1\' : \'\')"\n      >\n      <mbsc-calendar *ngIf="control.name === \'calendar\'" [options]="control.options" #ctrlVar></mbsc-calendar>\n      <mbsc-datetime *ngIf="control.name === \'datetime\'" [options]="control.options" #ctrlVar></mbsc-datetime>\n      <mbsc-date *ngIf="control.name === \'date\'" [options]="control.options" #ctrlVar></mbsc-date>\n      <mbsc-time *ngIf="control.name === \'time\'" [options]="control.options" #ctrlVar></mbsc-time>\n      <mbsc-timegrid *ngIf="control.name === \'timegrid\'" [options]="control.options" #ctrlVar></mbsc-timegrid>\n      \x3c!--<ng-container mbsc-tpl></ng-container>--\x3e\n    </div>\n  </div>\n</div>\n';
var MbscDatepickerBase = /*#__PURE__*/function (_super) {
  __extends(MbscDatepickerBase, _super);
  function MbscDatepickerBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.onCancel = new EventEmitter();
    _this.onCellClick = new EventEmitter();
    _this.onCellHoverIn = new EventEmitter();
    _this.onCellHoverOut = new EventEmitter();
    _this.onChange = new EventEmitter();
    _this.onClose = new EventEmitter();
    _this.onLabelClick = new EventEmitter();
    _this.onPageChange = new EventEmitter(true);
    _this.onPageLoaded = new EventEmitter(true);
    _this.onPageLoading = new EventEmitter(true);
    _this.onOpen = new EventEmitter();
    _this.onPosition = new EventEmitter();
    _this.onTempChange = new EventEmitter();
    _this.onActiveDateChange = new EventEmitter();
    return _this;
  }
  MbscDatepickerBase.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscDatepickerBase_BaseFactory;
    return function MbscDatepickerBase_Factory(t) {
      return (ɵMbscDatepickerBase_BaseFactory || (ɵMbscDatepickerBase_BaseFactory = i0.ɵɵgetInheritedFactory(MbscDatepickerBase)))(t || MbscDatepickerBase);
    };
  })();
  MbscDatepickerBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: MbscDatepickerBase,
    selectors: [["", "mbsc-dp-b", ""]],
    inputs: {
      ariaLabel: "ariaLabel",
      calendarHeaderTemplate: "calendarHeaderTemplate",
      calendarScroll: "calendarScroll",
      calendarSize: "calendarSize",
      calendarSystem: "calendarSystem",
      calendarType: "calendarType",
      colors: "colors",
      controls: "controls",
      dataTimezone: "dataTimezone",
      defaultSelection: "defaultSelection",
      displayTimezone: "displayTimezone",
      element: "element",
      endInput: "endInput",
      exclusiveEndDates: "exclusiveEndDates",
      firstSelectDay: "firstSelectDay",
      inputTyping: "inputTyping",
      invalid: "invalid",
      inRangeInvalid: "inRangeInvalid",
      labels: "labels",
      marked: "marked",
      max: "max",
      maxRange: "maxRange",
      maxTime: "maxTime",
      min: "min",
      minRange: "minRange",
      minTime: "minTime",
      mode: "mode",
      moment: "moment",
      pages: "pages",
      rangeHighlight: "rangeHighlight",
      rangeEndInvalid: "rangeEndInvalid",
      refDate: "refDate",
      returnFormat: "returnFormat",
      showInput: "showInput",
      startInput: "startInput",
      stepHour: "stepHour",
      stepMinute: "stepMinute",
      stepSecond: "stepSecond",
      select: "select",
      selectCounter: "selectCounter",
      selectSize: "selectSize",
      selectMax: "selectMax",
      selectMin: "selectMin",
      selectMultiple: "selectMultiple",
      showOuterDays: "showOuterDays",
      showRangeLabels: "showRangeLabels",
      showWeekNumbers: "showWeekNumbers",
      tabs: "tabs",
      theme: "theme",
      timezonePlugin: "timezonePlugin",
      valid: "valid",
      weeks: "weeks",
      disabled: "disabled",
      dropdown: "dropdown",
      endIcon: "endIcon",
      endIconSrc: "endIconSrc",
      endIconSvg: "endIconSvg",
      error: "error",
      errorMessage: "errorMessage",
      inputStyle: "inputStyle",
      label: "label",
      labelStyle: "labelStyle",
      name: "name",
      placeholder: "placeholder",
      startIcon: "startIcon",
      startIconSrc: "startIconSrc",
      startIconSvg: "startIconSvg",
      tagInput: "tagInput",
      circular: "circular",
      clearText: "clearText",
      itemHeight: "itemHeight",
      maxWheelWidth: "maxWheelWidth",
      minWheelWidth: "minWheelWidth",
      rows: "rows",
      showOnClick: "showOnClick",
      showOnFocus: "showOnFocus",
      wheelWidth: "wheelWidth",
      anchor: "anchor",
      anchorAlign: "anchorAlign",
      animation: "animation",
      buttons: "buttons",
      cancelText: "cancelText",
      closeOnEsc: "closeOnEsc",
      closeOnOverlayClick: "closeOnOverlayClick",
      closeOnScroll: "closeOnScroll",
      closeText: "closeText",
      context: "context",
      display: "display",
      focusOnClose: "focusOnClose",
      focusTrap: "focusTrap",
      fullScreen: "fullScreen",
      headerText: "headerText",
      height: "height",
      isOpen: "isOpen",
      maxHeight: "maxHeight",
      maxWidth: "maxWidth",
      scrollLock: "scrollLock",
      setText: "setText",
      showArrow: "showArrow",
      showOverlay: "showOverlay",
      width: "width",
      amText: "amText",
      dateFormat: "dateFormat",
      dateWheels: "dateWheels",
      dayNames: "dayNames",
      dayNamesMin: "dayNamesMin",
      dayNamesShort: "dayNamesShort",
      daySuffix: "daySuffix",
      dayTemplate: "dayTemplate",
      dayContentTemplate: "dayContentTemplate",
      firstDay: "firstDay",
      monthNames: "monthNames",
      monthNamesShort: "monthNamesShort",
      monthSuffix: "monthSuffix",
      moreEventsPluralText: "moreEventsPluralText",
      moreEventsText: "moreEventsText",
      nextPageText: "nextPageText",
      nowText: "nowText",
      pmText: "pmText",
      prevPageText: "prevPageText",
      rangeEndHelp: "rangeEndHelp",
      rangeEndLabel: "rangeEndLabel",
      rangeStartHelp: "rangeStartHelp",
      rangeStartLabel: "rangeStartLabel",
      selectedPluralText: "selectedPluralText",
      selectedText: "selectedText",
      timeFormat: "timeFormat",
      timeWheels: "timeWheels",
      yearSuffix: "yearSuffix"
    },
    outputs: {
      onCancel: "onCancel",
      onCellClick: "onCellClick",
      onCellHoverIn: "onCellHoverIn",
      onCellHoverOut: "onCellHoverOut",
      onChange: "onChange",
      onClose: "onClose",
      onLabelClick: "onLabelClick",
      onPageChange: "onPageChange",
      onPageLoaded: "onPageLoaded",
      onPageLoading: "onPageLoading",
      onOpen: "onOpen",
      onPosition: "onPosition",
      onTempChange: "onTempChange",
      onActiveDateChange: "onActiveDateChange"
    },
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  MbscDatepickerBase = __decorate([FormControl], MbscDatepickerBase);
  return MbscDatepickerBase;
}(DatepickerBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscDatepicker = /*#__PURE__*/function (_super) {
  __extends(MbscDatepicker, _super);
  function MbscDatepicker() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(MbscDatepicker.prototype, "vInput", {
    set: function (inp) {
      if (inp) {
        this._el = inp.nativeElement;
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MbscDatepicker.prototype, "vPopup", {
    set: function (popup) {
      this._popup = popup;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(MbscDatepicker.prototype, "vWrapper", {
    set: function (wrapper) {
      this._wrapper = wrapper && wrapper.nativeElement;
    },
    enumerable: false,
    configurable: true
  });
  MbscDatepicker.prototype._render = function (s, state) {
    _super.prototype._render.call(this, s, state);
    if (this._controlRefs) {
      this._controlRefs.forEach(function (ctrl) {
        ctrl.props = ctrl.options;
        ctrl.forceUpdate();
      });
    }
  };
  MbscDatepicker.prototype._destroy = function () {
    _super.prototype._destroy.call(this);
  };
  MbscDatepicker.prototype._onClosed = function () {
    _super.prototype._onClosed.call(this);
    this._onFormTouch();
  };
  MbscDatepicker.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscDatepicker_BaseFactory;
    return function MbscDatepicker_Factory(t) {
      return (ɵMbscDatepicker_BaseFactory || (ɵMbscDatepicker_BaseFactory = i0.ɵɵgetInheritedFactory(MbscDatepicker)))(t || MbscDatepicker);
    };
  })();
  MbscDatepicker.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscDatepicker,
    selectors: [["mbsc-datepicker"]],
    viewQuery: function MbscDatepicker_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c3, 5);
        i0.ɵɵviewQuery(_c13, 5);
        i0.ɵɵviewQuery(_c12, 5);
        i0.ɵɵviewQuery(_c31, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vInput = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vPopup = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vWrapper = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._controlRefs = _t);
      }
    },
    features: [i0.ɵɵProvidersFeature([MbscInstanceService]), i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 4,
    vars: 37,
    consts: [["popup", ""], ["input", ""], ["wrapper", ""], ["ctrlVar", ""], [3, "ariaExpanded", "ariaHaspopup", "ariaLabel", "dropdown", "disabled", "endIcon", "endIconSrc", "endIconSvg", "error", "errorMessage", "inputStyle", "label", "labelStyle", "name", "placeholder", "pickerMap", "pickerValue", "role", "rtl", "startIcon", "startIconSrc", "startIconSvg", "tags", "theme", "themeVariant", "value", 4, "ngIf"], [3, "onClose", "onClosed", "onKeyDown", "onOpen", "onResize", "activeElm", "anchor", "anchorAlign", "animation", "buttons", "cancelText", "closeOnEsc", "closeOnOverlayClick", "closeOnScroll", "closeText", "contentPadding", "context", "cssClass", "disableLeftRight", "display", "focusElm", "focusOnClose", "focusOnOpen", "focusTrap", "fullScreen", "headerText", "height", "isOpen", "maxHeight", "maxWidth", "setText", "showArrow", "showOverlay", "rtl", "scrollLock", "theme", "themeVariant", "touchUi", "windowWidth", "width"], [4, "ngIf"], [3, "ariaExpanded", "ariaHaspopup", "ariaLabel", "dropdown", "disabled", "endIcon", "endIconSrc", "endIconSvg", "error", "errorMessage", "inputStyle", "label", "labelStyle", "name", "placeholder", "pickerMap", "pickerValue", "role", "rtl", "startIcon", "startIconSrc", "startIconSvg", "tags", "theme", "themeVariant", "value"], [3, "class", 4, "ngIf"], [3, "rtl", "theme", "themeVariant", "ngModel", "ngModelChange", "change", 4, "ngIf"], [3, "class", 4, "ngFor", "ngForOf"], [3, "ngModelChange", "change", "rtl", "theme", "themeVariant", "ngModel"], [3, "rtl", "theme", "themeVariant", "value", 4, "ngFor", "ngForOf"], [3, "rtl", "theme", "themeVariant", "value"], ["value", "start", 3, "rtl", "theme", "themeVariant"], [3, "class", "svg", "theme", "click", 4, "ngIf"], ["value", "end", 3, "rtl", "theme", "themeVariant"], [3, "click", "svg", "theme"], [3, "options", 4, "ngIf"], [3, "options"]],
    template: function MbscDatepicker_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, MbscDatepicker_mbsc_input_0_Template, 3, 26, "mbsc-input", 4);
        i0.ɵɵelementStart(1, "mbsc-popup", 5, 0);
        i0.ɵɵlistener("onClose", function MbscDatepicker_Template_mbsc_popup_onClose_1_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onPopupClose($event));
        })("onClosed", function MbscDatepicker_Template_mbsc_popup_onClosed_1_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onPopupClosed($event));
        })("onKeyDown", function MbscDatepicker_Template_mbsc_popup_onKeyDown_1_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onPopupKey($event));
        })("onOpen", function MbscDatepicker_Template_mbsc_popup_onOpen_1_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onPopupOpen($event));
        })("onResize", function MbscDatepicker_Template_mbsc_popup_onResize_1_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onResize($event));
        });
        i0.ɵɵtemplate(3, MbscDatepicker_ng_container_3_Template, 8, 8, "ng-container", 6);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx._showInput);
        i0.ɵɵadvance();
        i0.ɵɵproperty("activeElm", ctx.s.activeElm)("anchor", ctx._anchor)("anchorAlign", ctx._anchorAlign)("animation", ctx.s.animation)("buttons", ctx._buttons)("cancelText", ctx.s.cancelText)("closeOnEsc", ctx.s.closeOnEsc)("closeOnOverlayClick", ctx.s.closeOnOverlayClick)("closeOnScroll", ctx.s.closeOnScroll)("closeText", ctx.s.closeText)("contentPadding", false)("context", ctx.s.context)("cssClass", ctx._cssClass)("disableLeftRight", true)("display", ctx.s.display)("focusElm", ctx._focusElm)("focusOnClose", ctx.s.focusOnClose)("focusOnOpen", !ctx._allowTyping)("focusTrap", ctx.s.focusTrap)("fullScreen", ctx.s.fullScreen)("headerText", ctx._headerText)("height", ctx.s.height)("isOpen", ctx._isOpen)("maxHeight", ctx.s.maxHeight)("maxWidth", ctx._maxWidth)("setText", ctx.s.setText)("showArrow", ctx.s.showArrow)("showOverlay", ctx._allowTyping ? false : ctx.s.showOverlay)("rtl", ctx.s.rtl)("scrollLock", ctx._scrollLock)("theme", ctx.s.theme)("themeVariant", ctx.s.themeVariant)("touchUi", ctx._touchUi)("windowWidth", ctx.state.width)("width", ctx.s.width);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx._popup && ctx._popup._isVisible || ctx.s.display === "inline");
      }
    },
    dependencies: [MbscInput, MbscPopup, MbscSegmentedGroup, MbscSegmented, MbscIcon, MbscCalendar, MbscDatetime, MbscDate, MbscTime, MbscTimegrid, NgIf, NgControlStatus, NgModel, NgForOf],
    encapsulation: 2,
    changeDetection: 0
  });
  MbscDatepicker = __decorate([FormControl], MbscDatepicker);
  return MbscDatepicker;
}(MbscDatepickerBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscDatepickerDirective = /*#__PURE__*/function (_super) {
  __extends(MbscDatepickerDirective, _super);
  function MbscDatepickerDirective() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MbscDatepickerDirective.prototype._ctor = function () {
    this._cfr = this._injector.get(ComponentFactoryResolver);
  };
  MbscDatepickerDirective.prototype._init = function () {
    var _this = this;
    var componentFactory = this._cfr.resolveComponentFactory(MbscDatepicker);
    this._ref = this._vcf.createComponent(componentFactory);
    this._inst = this._ref.instance;
    var inst = this._inst;
    var _loop_1 = function (prop) {
      if (prop !== "onInit" && prop !== "onDestroy" && inst[prop] instanceof EventEmitter) {
        inst[prop].subscribe(function (args) {
          if (prop === "onClose") {
            _this._onFormTouch();
          }
          if (prop === "onChange") {
            _this.value = inst.value;
          }
          _this[prop].emit(args);
        });
      }
    };
    for (var prop in inst) {
      _loop_1(prop);
    }
    modules[MbscCalendar._name] = MbscCalendar;
    modules[MbscDatetime._name] = MbscDatetime;
    modules[MbscTimegrid._name] = MbscTimegrid;
    _super.prototype._init.call(this);
  };
  MbscDatepickerDirective.prototype._destroy = function () {
    _super.prototype._destroy.call(this);
    if (this._ref) {
      this._ref.destroy();
    }
  };
  MbscDatepickerDirective.prototype._render = function (s, state) {
    _super.prototype._render.call(this, s, state);
    var inst = this._inst;
    inst.value = this.value;
    inst.props = s;
    inst.props.element = this._elr.nativeElement;
    inst.forceUpdate();
  };
  MbscDatepickerDirective.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscDatepickerDirective_BaseFactory;
    return function MbscDatepickerDirective_Factory(t) {
      return (ɵMbscDatepickerDirective_BaseFactory || (ɵMbscDatepickerDirective_BaseFactory = i0.ɵɵgetInheritedFactory(MbscDatepickerDirective)))(t || MbscDatepickerDirective);
    };
  })();
  MbscDatepickerDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: MbscDatepickerDirective,
    selectors: [["", "mbsc-datepicker", ""]],
    inputs: {
      options: [i0.ɵɵInputFlags.None, "mbscOptions", "options"]
    },
    exportAs: ["mobiscroll"],
    features: [i0.ɵɵProvidersFeature([MbscInstanceService]), i0.ɵɵInheritDefinitionFeature]
  });
  return MbscDatepickerDirective;
}(MbscDatepickerBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscScrollerModule = /*#__PURE__*/function () {
  function MbscScrollerModule() {}
  MbscScrollerModule.ɵfac = function MbscScrollerModule_Factory(t) {
    return new (t || MbscScrollerModule)();
  };
  MbscScrollerModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MbscScrollerModule
  });
  MbscScrollerModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule, MbscInputModule, MbscPickerModule, MbscPopupModule, MbscScrollviewBaseModule]]
  });
  return MbscScrollerModule;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscDatetimeModule = /*#__PURE__*/function () {
  function MbscDatetimeModule() {}
  MbscDatetimeModule.ɵfac = function MbscDatetimeModule_Factory(t) {
    return new (t || MbscDatetimeModule)();
  };
  MbscDatetimeModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MbscDatetimeModule
  });
  MbscDatetimeModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule, FormsModule, MbscScrollerModule]]
  });
  return MbscDatetimeModule;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscSegmentedModule = /*#__PURE__*/function () {
  function MbscSegmentedModule() {}
  MbscSegmentedModule.ɵfac = function MbscSegmentedModule_Factory(t) {
    return new (t || MbscSegmentedModule)();
  };
  MbscSegmentedModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MbscSegmentedModule
  });
  MbscSegmentedModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule, MbscButtonModule]]
  });
  return MbscSegmentedModule;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscTimegridModule = /*#__PURE__*/function () {
  function MbscTimegridModule() {}
  MbscTimegridModule.ɵfac = function MbscTimegridModule_Factory(t) {
    return new (t || MbscTimegridModule)();
  };
  MbscTimegridModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MbscTimegridModule
  });
  MbscTimegridModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule]]
  });
  return MbscTimegridModule;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var id = 0;
function jsonp(url, callback) {
  if (win) {
    var script_1 = doc.createElement("script");
    var unique_1 = "mbscjsonp" + ++id;
    win[unique_1] = function (data) {
      script_1.parentNode.removeChild(script_1);
      delete win[unique_1];
      if (!data) {
        return;
      }
      callback(data);
    };
    script_1.src = url + (url.indexOf("?") >= 0 ? "&" : "?") + "callback=" + unique_1;
    doc.body.appendChild(script_1);
  }
}
function ajaxGet(url, callback) {
  var request = new XMLHttpRequest();
  request.open("GET", url, true);
  request.onload = function () {
    if (request.status >= 200 && request.status < 400) {
      callback(JSON.parse(request.response));
    }
  };
  request.onerror = function () {};
  request.send();
}
function getJson(url, callback, type) {
  if (type === "jsonp") {
    jsonp(url, callback);
  } else {
    ajaxGet(url, callback);
  }
}
var localTimezone;
function normTimezone(timezone) {
  if (!localTimezone) {
    localTimezone = luxonTimezone.luxon.DateTime.local().zoneName;
  }
  return !timezone || timezone === "local" ? localTimezone : timezone;
}
function getVersion(DT) {
  var fn = DT.fromObject.toString().trim();
  return /^(function )?\w*\(\w+\)/.test(fn) ? 1 : 2;
}
var LDate = /*#__PURE__*/function () {
  function LDate(value, timezone) {
    if (timezone === void 0) {
      timezone = "utc";
    }
    this._mbsc = true;
    timezone = normTimezone(timezone);
    var DT = luxonTimezone.luxon.DateTime;
    var zoneOpt = {
      zone: timezone
    };
    this.zone = timezone;
    if (isUndefined(value)) {
      this.dt = DT.utc().setZone(timezone);
    } else if (isDate(value) || isNumber(value)) {
      this.dt = DT.fromMillis(+value, zoneOpt);
    } else if (isString(value)) {
      this.dt = DT.fromISO(value, zoneOpt);
    } else if (isArray(value)) {
      var keys = ["year", "month", "day", "hour", "minute", "second", "millisecond"];
      var valueObj = {};
      for (var i = 0; i < value.length && i < 7; i++) {
        valueObj[keys[i]] = value[i] + (i === 1 ? 1 : 0);
      }
      luxonTimezone.version = luxonTimezone.version || getVersion(DT);
      if (luxonTimezone.version === 1) {
        this.dt = DT.fromObject(__assign(__assign({}, valueObj), zoneOpt));
      } else {
        this.dt = DT.fromObject(valueObj, zoneOpt);
      }
    }
  }
  LDate.prototype.clone = function () {
    return new LDate(this, this.zone);
  };
  LDate.prototype.createDate = function (year, month, date, h, min, sec, ms) {
    return luxonTimezone.createDate({
      displayTimezone: this.zone
    }, year, month, date, h, min, sec, ms);
  };
  LDate.prototype[Symbol.toPrimitive] = function (hint) {
    return this.dt.toJSDate()[Symbol.toPrimitive](hint);
  };
  LDate.prototype.toDateString = function () {
    return this.dt.toFormat("ccc MMM dd yyyy");
  };
  LDate.prototype.toISOString = function () {
    return this.dt.toISO();
  };
  LDate.prototype.toJSON = function () {
    return this.dt.toISO();
  };
  LDate.prototype.valueOf = function () {
    return this.dt.valueOf();
  };
  LDate.prototype.getDate = function () {
    return this.dt.day;
  };
  LDate.prototype.getDay = function () {
    return this.dt.weekday % 7;
  };
  LDate.prototype.getFullYear = function () {
    return this.dt.year;
  };
  LDate.prototype.getHours = function () {
    return this.dt.hour;
  };
  LDate.prototype.getMilliseconds = function () {
    return this.dt.millisecond;
  };
  LDate.prototype.getMinutes = function () {
    return this.dt.minute;
  };
  LDate.prototype.getMonth = function () {
    return this.dt.month - 1;
  };
  LDate.prototype.getSeconds = function () {
    return this.dt.second;
  };
  LDate.prototype.getTime = function () {
    return this.valueOf();
  };
  LDate.prototype.getTimezoneOffset = function () {
    return -this.dt.offset;
  };
  LDate.prototype.getUTCDate = function () {
    return this.dt.toUTC().day;
  };
  LDate.prototype.getUTCDay = function () {
    return this.dt.toUTC().weekday % 7;
  };
  LDate.prototype.getUTCFullYear = function () {
    return this.dt.toUTC().year;
  };
  LDate.prototype.getUTCHours = function () {
    return this.dt.toUTC().hour;
  };
  LDate.prototype.getUTCMilliseconds = function () {
    return this.dt.toUTC().millisecond;
  };
  LDate.prototype.getUTCMinutes = function () {
    return this.dt.toUTC().minute;
  };
  LDate.prototype.getUTCMonth = function () {
    return this.dt.toUTC().month - 1;
  };
  LDate.prototype.getUTCSeconds = function () {
    return this.dt.toUTC().second;
  };
  LDate.prototype.setMilliseconds = function (millisecond) {
    return this.setter({
      millisecond: millisecond
    });
  };
  LDate.prototype.setSeconds = function (second, millisecond) {
    return this.setter({
      second: second,
      millisecond: millisecond
    });
  };
  LDate.prototype.setMinutes = function (minute, second, millisecond) {
    return this.setter({
      minute: minute,
      second: second,
      millisecond: millisecond
    });
  };
  LDate.prototype.setHours = function (hour, minute, second, millisecond) {
    return this.setter({
      hour: hour,
      minute: minute,
      second: second,
      millisecond: millisecond
    });
  };
  LDate.prototype.setDate = function (day) {
    return this.setter({
      day: day
    });
  };
  LDate.prototype.setMonth = function (month, day) {
    month++;
    return this.setter({
      month: month,
      day: day
    });
  };
  LDate.prototype.setFullYear = function (year, month, day) {
    return this.setter({
      year: year,
      month: month,
      day: day
    });
  };
  LDate.prototype.setTime = function (time) {
    this.dt = luxonTimezone.luxon.DateTime.fromMillis(time);
    return this.dt.valueOf();
  };
  LDate.prototype.setTimezone = function (timezone) {
    timezone = normTimezone(timezone);
    this.zone = timezone;
    this.dt = this.dt.setZone(timezone);
  };
  LDate.prototype.setUTCMilliseconds = function (ms) {
    return 0;
  };
  LDate.prototype.setUTCSeconds = function (sec, ms) {
    return 0;
  };
  LDate.prototype.setUTCMinutes = function (min, sec, ms) {
    return 0;
  };
  LDate.prototype.setUTCHours = function (hours, min, sec, ms) {
    return 0;
  };
  LDate.prototype.setUTCDate = function (date) {
    return 0;
  };
  LDate.prototype.setUTCMonth = function (month, date) {
    return 0;
  };
  LDate.prototype.setUTCFullYear = function (year, month, date) {
    return 0;
  };
  LDate.prototype.toUTCString = function () {
    return "";
  };
  LDate.prototype.toTimeString = function () {
    return "";
  };
  LDate.prototype.toLocaleDateString = function () {
    return "";
  };
  LDate.prototype.toLocaleTimeString = function () {
    return "";
  };
  LDate.prototype.setter = function (obj) {
    this.dt = this.dt.set(obj);
    return this.dt.valueOf();
  };
  return LDate;
}();
var luxonTimezone = {
  luxon: UNDEFINED,
  version: UNDEFINED,
  parse: function (date, s) {
    return new LDate(date, s.dataTimezone || s.displayTimezone);
  },
  createDate: function (s, year, month, day, hour, minute, second, millisecond) {
    var displayTimezone = s.displayTimezone;
    if (isObject(year) || isString(year) || isUndefined(month)) {
      return new LDate(year, displayTimezone);
    }
    return new LDate([year || 1970, month || 0, day || 1, hour || 0, minute || 0, second || 0, millisecond || 0], displayTimezone);
  }
};
function normTimezone$1(timezone) {
  return !timezone || timezone === "local" ? momentTimezone.moment.tz.guess() : timezone;
}
var MDate = /*#__PURE__*/function () {
  function MDate(value, timezone) {
    this._mbsc = true;
    this.timezone = normTimezone$1(timezone);
    this.init(value);
  }
  MDate.prototype.clone = function () {
    return new MDate(this, this.timezone);
  };
  MDate.prototype.createDate = function (year, month, date, h, min, sec, ms) {
    return momentTimezone.createDate({
      displayTimezone: this.timezone
    }, year, month, date, h, min, sec, ms);
  };
  MDate.prototype[Symbol.toPrimitive] = function (hint) {
    return this.m.toDate()[Symbol.toPrimitive](hint);
  };
  MDate.prototype.toDateString = function () {
    return this.m.format("ddd MMM DD YYYY");
  };
  MDate.prototype.toISOString = function () {
    return this.m.toISOString(true);
  };
  MDate.prototype.toJSON = function () {
    return this.m.toISOString();
  };
  MDate.prototype.valueOf = function () {
    return this.m.valueOf();
  };
  MDate.prototype.getDate = function () {
    return this.m.date();
  };
  MDate.prototype.getDay = function () {
    return this.m.day();
  };
  MDate.prototype.getFullYear = function () {
    return this.m.year();
  };
  MDate.prototype.getHours = function () {
    return this.m.hours();
  };
  MDate.prototype.getMilliseconds = function () {
    return this.m.milliseconds();
  };
  MDate.prototype.getMinutes = function () {
    return this.m.minutes();
  };
  MDate.prototype.getMonth = function () {
    return this.m.month();
  };
  MDate.prototype.getSeconds = function () {
    return this.m.seconds();
  };
  MDate.prototype.getTime = function () {
    return this.m.valueOf();
  };
  MDate.prototype.getTimezoneOffset = function () {
    return -this.m.utcOffset();
  };
  MDate.prototype.getUTCDate = function () {
    return this.utc().date();
  };
  MDate.prototype.getUTCDay = function () {
    return this.utc().day();
  };
  MDate.prototype.getUTCFullYear = function () {
    return this.utc().year();
  };
  MDate.prototype.getUTCHours = function () {
    return this.utc().hours();
  };
  MDate.prototype.getUTCMilliseconds = function () {
    return this.utc().milliseconds();
  };
  MDate.prototype.getUTCMinutes = function () {
    return this.utc().minutes();
  };
  MDate.prototype.getUTCMonth = function () {
    return this.utc().month();
  };
  MDate.prototype.getUTCSeconds = function () {
    return this.utc().seconds();
  };
  MDate.prototype.setMilliseconds = function (ms) {
    return +this.m.set({
      millisecond: ms
    });
  };
  MDate.prototype.setSeconds = function (sec, ms) {
    return +this.m.set({
      seconds: sec,
      milliseconds: ms
    });
  };
  MDate.prototype.setMinutes = function (min, sec, ms) {
    return +this.m.set({
      minutes: min,
      seconds: sec,
      milliseconds: ms
    });
  };
  MDate.prototype.setHours = function (hours, min, sec, ms) {
    return +this.m.set({
      hours: hours,
      minutes: min,
      seconds: sec,
      milliseconds: ms
    });
  };
  MDate.prototype.setDate = function (date) {
    return +this.m.set({
      date: date
    });
  };
  MDate.prototype.setMonth = function (month, date) {
    return +this.m.set({
      month: month,
      date: date
    });
  };
  MDate.prototype.setFullYear = function (year, month, date) {
    return +this.m.set({
      year: year,
      month: month,
      date: date
    });
  };
  MDate.prototype.setTime = function (time) {
    this.init(time);
    return this.m.valueOf();
  };
  MDate.prototype.setTimezone = function (timezone) {
    this.timezone = normTimezone$1(timezone);
    this.m.tz(this.timezone);
  };
  MDate.prototype.setUTCMilliseconds = function (ms) {
    return 0;
  };
  MDate.prototype.setUTCSeconds = function (sec, ms) {
    return 0;
  };
  MDate.prototype.setUTCMinutes = function (min, sec, ms) {
    return 0;
  };
  MDate.prototype.setUTCHours = function (hours, min, sec, ms) {
    return 0;
  };
  MDate.prototype.setUTCDate = function (date) {
    return 0;
  };
  MDate.prototype.setUTCMonth = function (month, date) {
    return 0;
  };
  MDate.prototype.setUTCFullYear = function (year, month, date) {
    return 0;
  };
  MDate.prototype.toUTCString = function () {
    return "";
  };
  MDate.prototype.toTimeString = function () {
    return "";
  };
  MDate.prototype.toLocaleDateString = function () {
    return "";
  };
  MDate.prototype.toLocaleTimeString = function () {
    return "";
  };
  MDate.prototype.init = function (input) {
    var tz = momentTimezone.moment.tz;
    var normInput = isUndefined(input) || isString(input) || isNumber(input) || isArray(input) ? input : +input;
    var isTime = isString(input) && ISO_8601_TIME.test(input);
    this.m = isTime ? tz(normInput, "HH:mm:ss", this.timezone) : tz(normInput, this.timezone);
  };
  MDate.prototype.utc = function () {
    return this.m.clone().utc();
  };
  return MDate;
}();
var momentTimezone = {
  moment: UNDEFINED,
  parse: function (date, s) {
    return new MDate(date, s.dataTimezone || s.displayTimezone);
  },
  createDate: function (s, year, month, date, h, min, sec, ms) {
    var displayTimezone = s.displayTimezone;
    if (isObject(year) || isString(year) || isUndefined(month)) {
      return new MDate(year, displayTimezone);
    }
    return new MDate([year || 1970, month || 0, date || 1, h || 0, min || 0, sec || 0, ms || 0], displayTimezone);
  }
};
var MbscDatepickerModule = /*#__PURE__*/function () {
  function MbscDatepickerModule() {}
  MbscDatepickerModule.ɵfac = function MbscDatepickerModule_Factory(t) {
    return new (t || MbscDatepickerModule)();
  };
  MbscDatepickerModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MbscDatepickerModule
  });
  MbscDatepickerModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule, FormsModule, MbscCalendarModule, MbscDatetimeModule, MbscIconModule, MbscInputModule, MbscPickerModule, MbscPopupModule, MbscSegmentedModule, MbscTimegridModule], MbscCalendarHeaderModule]
  });
  return MbscDatepickerModule;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var DELIMITER = ", ";
var DEF_GROUP = "group_0";
function createDisabledMap(optionList, invalids) {
  var map = new Map();
  if (optionList) {
    optionList.forEach(function (item) {
      if (item.disabled) {
        map.set(item.value, true);
      }
    });
  }
  if (invalids) {
    invalids.forEach(function (value) {
      map.set(value, true);
    });
  }
  return map;
}
function createDisabledGroupsMap(disabledMap, optionList) {
  var map = new Map();
  if (optionList) {
    optionList.forEach(function (_a) {
      var group = _a.group,
        value = _a.value;
      if (group) {
        if (!map.has(group)) {
          map.set(group, true);
        }
        if (!disabledMap.get(value)) {
          map.set(group, false);
        }
      }
    });
  }
  return map;
}
function filterOptions(optionList, filterText) {
  if (!filterText) {
    return optionList;
  }
  var escapedText = filterText.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
  var filterRegExp = new RegExp(escapedText, "i");
  var filtered = optionList.filter(function (item) {
    return filterRegExp.test(item.text);
  });
  return filtered;
}
var SelectBase = /*#__PURE__*/function (_super) {
  __extends(SelectBase, _super);
  function SelectBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._options = [];
    _this._selectMap = new Map();
    _this._onFilterChange = function (e) {
      var filterText = e.target.value;
      clearTimeout(_this._debounce);
      _this._filterInput.value = filterText;
      _this._debounce = setTimeout(function () {
        _this._filter(filterText);
      }, 300);
    };
    _this._onFilterClear = function () {
      var input = _this._filterInput;
      if (input) {
        input.value = "";
      }
      _this._filter("");
    };
    _this._onResize = function (args) {
      _this.setState({
        width: args.windowWidth
      });
    };
    _this._onChange = function (args) {
      var vals = args.value;
      _this._parsedValue = vals;
      _this._saveSelected(vals);
      _this._change(vals);
      _this._hook("onChange", args);
    };
    _this._onClose = function (args) {
      _this._hook("onClose", args);
      if (_this._filterText) {
        setTimeout(function () {
          return _this._onFilterClear();
        }, 100);
      }
    };
    _this._onWheelMove = function (_a) {
      var wheelIndex = _a.wheelIndex,
        selection = _a.selection,
        dataItem = _a.dataItem;
      if (!_this._selectOnScroll && !selection && wheelIndex === 1) {
        var opt = find(_this._options, function (o) {
          return o.value === dataItem.value;
        });
        var group = dataItem.isGroup ? dataItem.value : opt.group;
        return [group];
      }
      return UNDEFINED;
    };
    _this._shouldValidate = function (s, prevS) {
      var res = s.selectMultiple !== prevS.selectMultiple || !s.filter && s.data !== prevS.data || _this._groupChanged;
      _this._groupChanged = false;
      return res;
    };
    _this._writeValue = function (elm, text, value) {
      var oldValue = elm.value;
      elm.value = text;
      if (_this._isSelect) {
        if (!isArray(value)) {
          value = [value];
        }
        var select = _this.s.selectElement;
        var options = select.options;
        var changed = false;
        for (var i = 0; i < options.length; i++) {
          var opt = options[i];
          var wasSelected = opt.selected;
          opt.selected = value.indexOf(opt.value) > -1;
          if (wasSelected !== opt.selected) {
            changed = true;
          }
        }
        if (changed) {
          trigger(select, CHANGE);
        }
        return changed;
      } else {
        return oldValue !== text;
      }
    };
    _this._format = function (valueRep) {
      var optionWheelIndex = _this.s.showGroupWheel ? 1 : 0;
      var value = valueRep[optionWheelIndex];
      var values = _this.s.selectMultiple ? value : [value];
      var labels = values.map && values.map(function (v) {
        if (_this._map) {
          return _this._map.get(v);
        }
        return UNDEFINED;
      });
      return (labels || []).join(DELIMITER);
    };
    _this._parse = function (value) {
      var map = _this._map;
      var reMap = _this._reMap;
      var isMultiple = _this.s.selectMultiple;
      var defSel = _this.s.defaultSelection;
      var defValue = isMultiple ? defSel ? defSel.length !== UNDEFINED ? defSel : __spreadArray([], defSel, true) : [] : defSel !== UNDEFINED ? defSel : null;
      var parsedValue;
      _this._parsedValue = value;
      if (map) {
        if (isMultiple && !isEmpty(value)) {
          var representation = [];
          if (value.length === UNDEFINED) {
            representation.push(value);
          } else {
            if (isString(value)) {
              var labels = value.split(DELIMITER);
              for (var _i = 0, labels_1 = labels; _i < labels_1.length; _i++) {
                var label = labels_1[_i];
                var valueFromLabel = reMap.get(label);
                if (valueFromLabel !== UNDEFINED) {
                  representation.push(valueFromLabel);
                }
              }
            } else {
              for (var _a = 0, value_1 = value; _a < value_1.length; _a++) {
                var iValue = value_1[_a];
                if (map.has(iValue)) {
                  representation.push(iValue);
                }
              }
            }
          }
          parsedValue = representation;
        } else {
          if (map.has(value)) {
            parsedValue = value;
          } else if (isString(value) && reMap.has(value)) {
            parsedValue = reMap.get(value);
          }
        }
      }
      if (parsedValue === UNDEFINED) {
        parsedValue = defValue;
      }
      if (_this.s.showGroupWheel) {
        var firstValue_1 = isMultiple ? parsedValue[0] : parsedValue;
        var selectedItem = find(_this._options, function (item) {
          return item.value === firstValue_1;
        });
        return [selectedItem && selectedItem.group, parsedValue];
      }
      return [parsedValue];
    };
    _this._get = function (valueRep) {
      var optWheelIndex = _this.s.showGroupWheel ? 1 : 0;
      var values = valueRep[optWheelIndex];
      return _this.s.selectMultiple ? values || [] : values;
    };
    _this._valueEquals = function (v1, v2) {
      if (_this.s.selectMultiple) {
        return arrayContentEquals(v1 || [], v2 || []);
      } else {
        return v1 === v2;
      }
    };
    _this._validate = function (_a) {
      var values = _a.values,
        direction = _a.direction,
        wheels = _a.wheels,
        index = _a.index;
      var disabledMap = _this._disabled;
      var selectOnScroll = _this._selectOnScroll;
      var isMulti = _this.s.selectMultiple;
      var groupWheels = _this.s.showGroupWheel;
      var disabled = groupWheels ? [_this._disabledGroups, disabledMap] : [disabledMap];
      var optWheelIndex = groupWheels ? 1 : 0;
      var val = _this._get(values);
      var ret = {
        disabled: disabled
      };
      if (index === optWheelIndex || index === UNDEFINED) {
        if (isMulti) {
          var valid_1 = [];
          val.forEach(function (selectedValue) {
            if (!disabledMap.get(selectedValue)) {
              valid_1.push(selectedValue);
            }
          });
          ret.valid = _this._parse(valid_1);
          if (index !== UNDEFINED) {
            ret.valid[0] = values[0];
          }
        } else {
          if (isEmpty(val) && !selectOnScroll) {
            ret.valid = groupWheels ? [null, null] : [null];
            return ret;
          }
          var validValue_1 = getValid(wheels[optWheelIndex], values[optWheelIndex], disabledMap, direction);
          if (groupWheels) {
            var item = find(_this._options, function (o) {
              return o.value === validValue_1;
            });
            ret.valid = [item.group, validValue_1];
          } else {
            ret.valid = [validValue_1];
          }
        }
      } else {
        var validGroup_1 = getValid(wheels[0], values[0], disabled[0], direction);
        var firstValidItem = find(_this._options, function (o) {
          return o.group === validGroup_1 && (!selectOnScroll || !disabledMap.get(o.value));
        });
        var itemOrHeaderValue = _this._touchUi || firstValidItem.group === UNDEFINED ? firstValidItem.value : firstValidItem.group;
        if (selectOnScroll) {
          ret.valid = [validGroup_1, itemOrHeaderValue];
        } else {
          ret.valid = [validGroup_1, values[1]];
          var first = isMulti ? [itemOrHeaderValue] : itemOrHeaderValue;
          var group = _this._touchUi ? validGroup_1 : UNDEFINED;
          ret.indexes = [group, first];
        }
      }
      return ret;
    };
    _this._setScroller = function (scroller) {
      _this._scroller = scroller;
    };
    _this._setInput = function (input) {
      _this._filterInput = input && input.nativeElement;
    };
    _this._saveSelected = function (values) {
      if (_this.s.selectMultiple) {
        var selectMap_1 = new Map();
        forEach(values, function (value) {
          var label = _this._map.get(value);
          selectMap_1.set(value, label);
        });
        _this._selectMap = selectMap_1;
      }
    };
    return _this;
  }
  SelectBase.prototype._change = function (value) {};
  SelectBase.prototype.reloadOptionElements = function () {
    var _this = this;
    this._optionsReloaded = true;
    this._setOptionsFromElm();
    setTimeout(function () {
      _this.forceUpdate();
    });
  };
  SelectBase.prototype.setVal = function (value) {
    this._proxy("setVal", [value]);
  };
  SelectBase.prototype.getVal = function () {
    return isEmpty(this._parsedValue) ? this._parsedValue : this._proxy("getVal");
  };
  SelectBase.prototype.setTempVal = function (value) {
    this._proxy("setTempVal", [value]);
  };
  SelectBase.prototype.getTempVal = function () {
    return this._proxy("getTempVal");
  };
  SelectBase.prototype.open = function () {
    this._proxy("open");
  };
  SelectBase.prototype.close = function () {
    this._proxy("close");
  };
  SelectBase.prototype._render = function (s) {
    var prevS = this._prevS;
    var spaceAround = this._touchUi && (!s.selectMultiple || (s.baseTheme || s.theme) === "ios");
    var selectOnScroll = this._touchUi && !s.selectMultiple;
    var elementChanged = s.element !== prevS.element || s.selectElement !== prevS.selectElement;
    var dataChanged = s.data !== prevS.data;
    var dataReloaded = dataChanged || this._optionsReloaded;
    var placeholder = s.placeholder;
    var checkEmptyOption = s.display !== prevS.display || placeholder !== prevS.placeholder || selectOnScroll !== this._selectOnScroll;
    var disabledChanged = dataReloaded || elementChanged || s.invalid !== prevS.invalid || this._selectOnScroll !== selectOnScroll;
    this._selectOnScroll = selectOnScroll;
    if (s.showGroupWheel !== prevS.showGroupWheel) {
      this._groupChanged = true;
    }
    if (elementChanged || checkEmptyOption) {
      this._isSelect = s.selectElement !== UNDEFINED;
      if (this._isSelect) {
        this._setOptionsFromElm();
      } else if (!s.element) {
        this._options = [];
      }
    }
    if ((dataChanged || checkEmptyOption) && s.data) {
      this._createOptionList(s.data);
    }
    if (disabledChanged) {
      this._disabled = createDisabledMap(this._options, s.invalid);
      this._disabledGroups = createDisabledGroupsMap(this._disabled, selectOnScroll ? this._options : UNDEFINED);
    }
    if (disabledChanged || spaceAround !== this._spaceAround || this._groupChanged || s.filter !== prevS.filter || s.selectMultiple !== prevS.selectMultiple) {
      this._createWheels(this._filterText, spaceAround);
    }
    if (dataReloaded || s.filter !== prevS.filter || s.touchUi !== prevS.touchUi || s.rows !== prevS.rows) {
      var dataLength = s.filter ? Infinity : this._wheels[0][s.showGroupWheel ? 1 : 0].data.length;
      var respRows = (this._respProps || {}).rows;
      var propRows = this.props.rows;
      var defRows = this._touchUi ? s.rows : Math.min(respRows || propRows || 7, dataLength);
      this._rows = propRows || defRows;
    }
    if (this._groupChanged || s.wheelWidth !== prevS.wheelWidth || s.filter !== prevS.filter) {
      this._wheelWidth = s.wheelWidth || (s.filter ? s.showGroupWheel ? [150, 250] : 400 : UNDEFINED);
    }
    this._spaceAround = spaceAround;
    this._optionsReloaded = false;
  };
  SelectBase.prototype._createOptionList = function (data) {
    var s = this.s;
    var text = s.placeholder;
    var options = [];
    var map = new Map();
    var reMap = new Map();
    this._selectMap.forEach(function (label, value) {
      map.set(value, label);
    });
    var hasEmpty = false;
    var addOption = function (item, index) {
      if (!item || item.value === UNDEFINED) {
        item = {
          text: item,
          value: item
        };
      }
      if (isEmpty(item.value)) {
        hasEmpty = true;
      }
      if (s.showGroupWheel && item.group === UNDEFINED) {
        item.group = DEF_GROUP;
      }
      map.set(item.value, item.text);
      reMap.set(item.text, item.value);
      options.splice(index, 0, item);
    };
    data.forEach(addOption);
    if (s.display === "inline" && this._selectOnScroll && text && !hasEmpty) {
      addOption({
        value: "",
        text: text
      }, 0);
    }
    this._map = map;
    this._reMap = reMap;
    this._options = options;
  };
  SelectBase.prototype._proxy = function (method, args) {
    var inst = this._inst || this._scroller;
    if (inst) {
      return inst[method].apply(inst, args);
    }
  };
  SelectBase.prototype._createWheels = function (filterText, spaceAround) {
    var _this = this;
    var s = this.s;
    var isMultiple = s.selectMultiple;
    var options = s.filter && filterText ? filterOptions(this._options, filterText) : this._options;
    var data = [];
    var groupData = [];
    var groupMap = new Map();
    options.forEach(function (option) {
      var group = option.group;
      var groupName = !group || group === DEF_GROUP ? "" : group;
      var groupOptions = groupMap.get(groupName);
      var item = {
        display: option.text,
        value: option.value,
        data: option,
        disabled: _this._disabled.get(option.value)
      };
      if (groupOptions) {
        groupOptions.push(item);
      } else {
        groupMap.set(groupName, [item]);
      }
    });
    var ungroupedOptions = groupMap.get("");
    if (ungroupedOptions) {
      data.push.apply(data, ungroupedOptions);
      if (this._selectOnScroll) {
        groupData.push({
          display: "",
          value: DEF_GROUP
        });
      }
    }
    groupMap.forEach(function (groupOptions, key) {
      if (key) {
        data.push({
          display: key,
          isGroup: true,
          value: key
        });
        data.push.apply(data, groupOptions);
        groupData.push({
          display: key,
          value: key
        });
        _this._disabled.set(key, true);
      }
    });
    var optWheel = {
      checkmark: true,
      circular: false,
      closeOnTap: !isMultiple,
      data: data,
      multiple: isMultiple,
      spaceAround: spaceAround
    };
    var groupWheel = {
      checkmark: false,
      circular: false,
      cssClass: "mbsc-select-group-wheel" + (isMultiple ? " mbsc-select-group-wheel-multi" : ""),
      data: groupData,
      multiple: false,
      spaceAround: spaceAround
    };
    this._noResults = s.filter && !options.length;
    this._wheels = s.showGroupWheel ? [[groupWheel, optWheel]] : [[optWheel]];
  };
  SelectBase.prototype._setOptionsFromElm = function () {
    var select = this.s.selectElement;
    var doc = getDocument(select);
    var options = select.options;
    var data = [];
    var hasEmpty = false;
    var hasSelected = false;
    for (var i = 0; i < options.length; i++) {
      var opt = options[i];
      var parent_1 = opt.parentElement;
      var group = parent_1.nodeName.toLowerCase() === "optgroup" ? parent_1.label : UNDEFINED;
      if (opt.value !== "") {
        data.push({
          disabled: opt.disabled,
          group: group,
          text: opt.text,
          value: opt.value
        });
      } else {
        hasEmpty = true;
      }
      if (opt.defaultSelected) {
        hasSelected = true;
      }
    }
    if (!hasEmpty && doc) {
      select.insertBefore(doc.createElement("option"), select.childNodes[0] || null);
      if (!hasSelected) {
        select.value = "";
      }
    }
    this._createOptionList(data);
  };
  SelectBase.prototype._filter = function (filterText) {
    var ret = this._hook("onFilter", {
      filterText: filterText
    });
    if (ret !== false) {
      this._filterText = filterText;
      this._createWheels(filterText, this._spaceAround);
    }
    this.forceUpdate();
  };
  SelectBase.defaults = __assign(__assign({}, PickerBase.defaults), {
    dropdown: true,
    filterEmptyText: "No results",
    filterPlaceholderText: "Search",
    rows: 5
  });
  SelectBase._name = "Select";
  SelectBase.ɵfac = /* @__PURE__ */(() => {
    let ɵSelectBase_BaseFactory;
    return function SelectBase_Factory(t) {
      return (ɵSelectBase_BaseFactory || (ɵSelectBase_BaseFactory = i0.ɵɵgetInheritedFactory(SelectBase)))(t || SelectBase);
    };
  })();
  SelectBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: SelectBase,
    selectors: [["", "mbsc-sel-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return SelectBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscSelectOptionBase = /*#__PURE__*/function () {
  function MbscSelectOptionBase(host, changeService) {
    this.host = host;
    this.changeService = changeService;
    this.component = false;
  }
  MbscSelectOptionBase.prototype.ngAfterViewInit = function () {
    this.text = this.host.nativeElement.textContent || "";
  };
  MbscSelectOptionBase.prototype.ngOnChanges = function (changes) {
    this.text = this.host.nativeElement.textContent || "";
    this.changeService.reloadOptions(this.component);
  };
  MbscSelectOptionBase.ɵfac = function MbscSelectOptionBase_Factory(t) {
    return new (t || MbscSelectOptionBase)(i0.ɵɵdirectiveInject(ElementRef), i0.ɵɵdirectiveInject(MbscSelectOptionChangeService));
  };
  MbscSelectOptionBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: MbscSelectOptionBase,
    selectors: [["", "mbsc-sel-b", ""]],
    inputs: {
      value: "value",
      group: "group",
      disabled: "disabled"
    },
    features: [i0.ɵɵNgOnChangesFeature]
  });
  return MbscSelectOptionBase;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscSelectOptionDirective = /*#__PURE__*/function (_super) {
  __extends(MbscSelectOptionDirective, _super);
  function MbscSelectOptionDirective() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MbscSelectOptionDirective.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscSelectOptionDirective_BaseFactory;
    return function MbscSelectOptionDirective_Factory(t) {
      return (ɵMbscSelectOptionDirective_BaseFactory || (ɵMbscSelectOptionDirective_BaseFactory = i0.ɵɵgetInheritedFactory(MbscSelectOptionDirective)))(t || MbscSelectOptionDirective);
    };
  })();
  MbscSelectOptionDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: MbscSelectOptionDirective,
    selectors: [["", "mbsc-select-option", ""]],
    inputs: {
      value: "value",
      group: "group",
      disabled: "disabled"
    },
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return MbscSelectOptionDirective;
}(MbscSelectOptionBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscSelectOptionComponent = /*#__PURE__*/function (_super) {
  __extends(MbscSelectOptionComponent, _super);
  function MbscSelectOptionComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.component = true;
    return _this;
  }
  MbscSelectOptionComponent.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscSelectOptionComponent_BaseFactory;
    return function MbscSelectOptionComponent_Factory(t) {
      return (ɵMbscSelectOptionComponent_BaseFactory || (ɵMbscSelectOptionComponent_BaseFactory = i0.ɵɵgetInheritedFactory(MbscSelectOptionComponent)))(t || MbscSelectOptionComponent);
    };
  })();
  MbscSelectOptionComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscSelectOptionComponent,
    selectors: [["mbsc-select-option"]],
    inputs: {
      value: "value",
      group: "group",
      disabled: "disabled"
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function MbscSelectOptionComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2
  });
  return MbscSelectOptionComponent;
}(MbscSelectOptionBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscSelectBase = /*#__PURE__*/function (_super) {
  __extends(MbscSelectBase, _super);
  function MbscSelectBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.onCancel = new EventEmitter();
    _this.onChange = new EventEmitter();
    _this.onClose = new EventEmitter();
    _this.onFilter = new EventEmitter();
    _this.onOpen = new EventEmitter();
    _this.onTempChange = new EventEmitter();
    return _this;
  }
  Object.defineProperty(MbscSelectBase.prototype, "vInput", {
    set: function (input) {
      this._filterInput = input && input.nativeElement;
    },
    enumerable: false,
    configurable: true
  });
  MbscSelectBase.prototype._onValueChange = function (value) {
    this.setState({
      value: value
    });
  };
  MbscSelectBase.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscSelectBase_BaseFactory;
    return function MbscSelectBase_Factory(t) {
      return (ɵMbscSelectBase_BaseFactory || (ɵMbscSelectBase_BaseFactory = i0.ɵɵgetInheritedFactory(MbscSelectBase)))(t || MbscSelectBase);
    };
  })();
  MbscSelectBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: MbscSelectBase,
    selectors: [["", "mbsc-sel-b", ""]],
    viewQuery: function MbscSelectBase_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c3, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vInput = _t.first);
      }
    },
    inputs: {
      ariaLabel: "ariaLabel",
      circular: "circular",
      clearIcon: "clearIcon",
      data: "data",
      defaultSelection: "defaultSelection",
      filter: "filter",
      formatValue: "formatValue",
      getValue: "getValue",
      invalid: "invalid",
      itemHeight: "itemHeight",
      itemTemplate: "itemTemplate",
      maxHeight: "maxHeight",
      maxWidth: "maxWidth",
      maxWheelWidth: "maxWheelWidth",
      minWheelWidth: "minWheelWidth",
      parseValue: "parseValue",
      rows: "rows",
      rtl: "rtl",
      selectMultiple: "selectMultiple",
      showGroupWheel: "showGroupWheel",
      showOnClick: "showOnClick",
      showOnFocus: "showOnFocus",
      valueEquality: "valueEquality",
      wheels: "wheels",
      wheelWidth: "wheelWidth",
      disabled: "disabled",
      dropdown: "dropdown",
      endIcon: "endIcon",
      endIconSrc: "endIconSrc",
      endIconSvg: "endIconSvg",
      error: "error",
      errorMessage: "errorMessage",
      inputStyle: "inputStyle",
      label: "label",
      labelStyle: "labelStyle",
      name: "name",
      placeholder: "placeholder",
      startIcon: "startIcon",
      startIconSrc: "startIconSrc",
      startIconSvg: "startIconSvg",
      tagInput: "tagInput",
      anchor: "anchor",
      animation: "animation",
      buttons: "buttons",
      cancelText: "cancelText",
      clearText: "clearText",
      closeOnEsc: "closeOnEsc",
      closeOnOverlayClick: "closeOnOverlayClick",
      closeText: "closeText",
      context: "context",
      display: "display",
      focusOnClose: "focusOnClose",
      focusTrap: "focusTrap",
      headerText: "headerText",
      height: "height",
      setText: "setText",
      showArrow: "showArrow",
      showInput: "showInput",
      showOverlay: "showOverlay",
      width: "width",
      filterEmptyText: "filterEmptyText",
      filterPlaceholderText: "filterPlaceholderText"
    },
    outputs: {
      onCancel: "onCancel",
      onChange: "onChange",
      onClose: "onClose",
      onFilter: "onFilter",
      onOpen: "onOpen",
      onTempChange: "onTempChange"
    },
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  MbscSelectBase = __decorate([FormControl], MbscSelectBase);
  return MbscSelectBase;
}(SelectBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscSelectOptionChangeService = /*#__PURE__*/function () {
  function MbscSelectOptionChangeService() {}
  MbscSelectOptionChangeService.prototype.reloadOptions = function (component) {
    var _this = this;
    clearTimeout(this.handler);
    this.handler = setTimeout(function () {
      if (_this.inst) {
        if (component) {
          _this.inst.updateOptionlist();
        } else {
          _this.inst.reloadOptionElements();
        }
      }
    });
  };
  MbscSelectOptionChangeService.prototype.setInst = function (i) {
    this.inst = i;
  };
  return MbscSelectOptionChangeService;
}();
var MbscSelect = /*#__PURE__*/function (_super) {
  __extends(MbscSelect, _super);
  function MbscSelect() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(MbscSelect.prototype, "vScroller", {
    set: function (scroller) {
      this._scroller = scroller;
    },
    enumerable: false,
    configurable: true
  });
  MbscSelect.prototype.updateOptionlist = function () {
    var _this = this;
    var data = this.optionComponents.map(function (ch) {
      return {
        disabled: ch.disabled,
        group: ch.group,
        text: ch.text,
        value: ch.value
      };
    });
    this._createOptionList(data);
    this._optionsReloaded = true;
    setTimeout(function () {
      _this.forceUpdate();
    });
  };
  MbscSelect.prototype.valueSet = function (event) {
    this.value = event.value;
    this._saveSelected(event.value);
    this._hook("onChange", event);
  };
  MbscSelect.prototype._ctor = function () {
    var s = this._injector.get(MbscSelectOptionChangeService);
    s.setInst(this);
  };
  MbscSelect.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscSelect_BaseFactory;
    return function MbscSelect_Factory(t) {
      return (ɵMbscSelect_BaseFactory || (ɵMbscSelect_BaseFactory = i0.ɵɵgetInheritedFactory(MbscSelect)))(t || MbscSelect);
    };
  })();
  MbscSelect.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscSelect,
    selectors: [["mbsc-select"]],
    contentQueries: function MbscSelect_ContentQueries(rf, ctx, dirIndex) {
      if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, MbscSelectOptionComponent, 4);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.optionComponents = _t);
      }
    },
    viewQuery: function MbscSelect_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c29, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vScroller = _t.first);
      }
    },
    features: [i0.ɵɵProvidersFeature([MbscSelectOptionChangeService]), i0.ɵɵInheritDefinitionFeature],
    decls: 8,
    vars: 74,
    consts: [["defaultInput", ""], ["filterInputTemplate", ""], ["filterEmptyTemplate", ""], ["scroller", ""], ["input", ""], ["type", "text", 3, "hidden"], [3, "onCancel", "onChange", "onClose", "onOpen", "onResize", "onTempChange", "ariaLabel", "activeElm", "anchor", "animation", "buttons", "cancelText", "circular", "clearText", "closeOnEsc", "closeOnOverlayClick", "closeText", "context", "disabled", "display", "dropdown", "element", "endIconSrc", "endIconSvg", "endIcon", "errorMessage", "error", "focusOnClose", "focusOnOpen", "focusTrap", "formatValue", "getValue", "headerText", "height", "inContentTemplate", "inputStyle", "invalid", "itemHeight", "itemTemplate", "labelStyle", "label", "maxHeight", "maxWheelWidth", "maxWidth", "minWheelWidth", "name", "onWheelMove", "parseValue", "placeholder", "preContentData", "preContentTemplate", "rows", "rtl", "selectMultiple", "selectOnScroll", "setText", "shouldValidate", "showArrow", "showInput", "showOnClick", "showOnFocus", "showOverlay", "startIconSrc", "startIconSvg", "startIcon", "tagInput", "themeVariant", "theme", "touchUi", "validate", "valueEquality", "valueMap", "value", "wheelWidth", "wheels", "width", "writeValue"], ["autocomplete", "off", "inputClass", "mbsc-select-filter-input", "inputStyle", "box", 1, "mbsc-select-filter", 3, "input", "placeholder", "rtl", "theme", "themeVariant"], [3, "class", "svg", "theme", "click", 4, "ngIf"], [3, "click", "svg", "theme"], [3, "class", 4, "ngIf"]],
    template: function MbscSelect_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelement(0, "input", 5, 0);
        i0.ɵɵtemplate(2, MbscSelect_ng_template_2_Template, 4, 7, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, MbscSelect_ng_template_4_Template, 1, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementStart(6, "mbsc-scroller", 6, 3);
        i0.ɵɵlistener("onCancel", function MbscSelect_Template_mbsc_scroller_onCancel_6_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._hook("onCancel", $event));
        })("onChange", function MbscSelect_Template_mbsc_scroller_onChange_6_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.valueSet($event));
        })("onClose", function MbscSelect_Template_mbsc_scroller_onClose_6_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onClose($event));
        })("onOpen", function MbscSelect_Template_mbsc_scroller_onOpen_6_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._hook("onOpen", $event));
        })("onResize", function MbscSelect_Template_mbsc_scroller_onResize_6_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onResize($event));
        })("onTempChange", function MbscSelect_Template_mbsc_scroller_onTempChange_6_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._hook("onTempChange", $event));
        });
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        const defaultInput_r6 = i0.ɵɵreference(1);
        const filterInputTemplate_r7 = i0.ɵɵreference(3);
        const filterEmptyTemplate_r8 = i0.ɵɵreference(5);
        i0.ɵɵproperty("hidden", ctx.s.element || !ctx.s.selectElement || ctx.s.display === "inline");
        i0.ɵɵadvance(6);
        i0.ɵɵclassMap((ctx.s.cssClass || ctx.s.class || "") + (ctx._noResults ? " mbsc-select-empty" : "") + " mbsc-select-scroller mbsc-select-scroller-" + ctx.s.display);
        i0.ɵɵproperty("ariaLabel", ctx.s.ariaLabel)("activeElm", ctx.s.filter ? ".mbsc-select-filter-input" : undefined)("anchor", ctx.s.anchor)("animation", ctx.s.animation)("buttons", ctx.s.buttons)("cancelText", ctx.s.cancelText)("circular", ctx.s.circular)("clearText", ctx.s.clearText)("closeOnEsc", ctx.s.closeOnEsc)("closeOnOverlayClick", ctx.s.closeOnOverlayClick)("closeText", ctx.s.closeText)("context", ctx.s.context)("disabled", ctx.s.disabled)("display", ctx.s.display)("dropdown", ctx.s.dropdown)("element", ctx.s.element || (ctx.s.selectElement ? defaultInput_r6 : undefined))("endIconSrc", ctx.s.endIconSrc)("endIconSvg", ctx.s.endIconSvg)("endIcon", ctx.s.endIcon)("errorMessage", ctx.s.errorMessage)("error", ctx.s.error)("focusOnClose", ctx.s.focusOnClose)("focusOnOpen", ctx.s.focusOnOpen)("focusTrap", ctx.s.focusTrap)("formatValue", ctx._format)("getValue", ctx._get)("headerText", ctx.s.headerText)("height", ctx.s.height)("inContentTemplate", filterEmptyTemplate_r8)("inputStyle", ctx.s.inputStyle)("invalid", ctx.s.invalid)("itemHeight", ctx.s.itemHeight)("itemTemplate", ctx.s.itemTemplate)("labelStyle", ctx.s.labelStyle)("label", ctx.s.label)("maxHeight", ctx.s.maxHeight)("maxWheelWidth", ctx.s.maxWheelWidth)("maxWidth", ctx.s.maxWidth)("minWheelWidth", ctx.s.minWheelWidth)("name", ctx.s.name)("onWheelMove", ctx._onWheelMove)("parseValue", ctx._parse)("placeholder", ctx.s.placeholder)("preContentData", ctx)("preContentTemplate", ctx.s.filter && filterInputTemplate_r7)("rows", ctx._rows)("rtl", ctx.s.rtl)("selectMultiple", ctx.s.selectMultiple)("selectOnScroll", ctx._selectOnScroll)("setText", ctx.s.setText)("shouldValidate", ctx._shouldValidate)("showArrow", ctx.s.showArrow)("showInput", ctx.s.showInput)("showOnClick", ctx.s.showOnClick)("showOnFocus", ctx.s.showOnFocus)("showOverlay", ctx.s.showOverlay)("startIconSrc", ctx.s.startIconSrc)("startIconSvg", ctx.s.startIconSvg)("startIcon", ctx.s.startIcon)("tagInput", ctx.s.tagInput)("themeVariant", ctx.s.themeVariant)("theme", ctx.s.theme)("touchUi", ctx._touchUi)("validate", ctx._validate)("valueEquality", ctx._valueEquals)("valueMap", ctx._map)("value", ctx.value)("wheelWidth", ctx._wheelWidth)("wheels", ctx._wheels)("width", ctx.s.width)("writeValue", ctx._writeValue);
      }
    },
    dependencies: [MbscInput, MbscIcon, MbscScroller, NgIf],
    encapsulation: 2,
    changeDetection: 0
  });
  MbscSelect = __decorate([FormControl], MbscSelect);
  return MbscSelect;
}(MbscSelectBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscSelectDirective = /*#__PURE__*/function (_super) {
  __extends(MbscSelectDirective, _super);
  function MbscSelectDirective() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MbscSelectDirective.prototype.reloadOptionElements = function () {
    if (this._inst) {
      this._inst.reloadOptionElements();
    }
  };
  MbscSelectDirective.prototype._ctor = function () {
    this._cfr = this._injector.get(ComponentFactoryResolver);
    var s = this._injector.get(MbscSelectOptionChangeService);
    s.setInst(this);
  };
  MbscSelectDirective.prototype._init = function () {
    var _this = this;
    var componentFactory = this._cfr.resolveComponentFactory(MbscSelect);
    this._ref = this._vcf.createComponent(componentFactory);
    this._inst = this._ref.instance;
    var inst = this._inst;
    var _loop_1 = function (prop) {
      if (prop !== "onInit" && prop !== "onDestroy" && inst[prop] instanceof EventEmitter) {
        inst[prop].subscribe(function (args) {
          if (prop === "onClose") {
            _this._onFormTouch();
          }
          if (prop === "onChange") {
            _this.value = inst.value;
          }
          _this[prop].emit(args);
        });
      }
    };
    for (var prop in inst) {
      _loop_1(prop);
    }
    _super.prototype._init.call(this);
  };
  MbscSelectDirective.prototype._destroy = function () {
    _super.prototype._destroy.call(this);
    if (this._ref) {
      this._ref.destroy();
    }
  };
  MbscSelectDirective.prototype._render = function (s) {
    var inst = this._ref.instance;
    inst.value = this.value;
    inst.props = s;
    inst.props.rows = this.props.rows;
    var el = this._elr.nativeElement;
    if (el.nodeName.toLowerCase() === "select") {
      el.style.display = "none";
      inst.props.selectElement = el;
      if (s.inputElement) {
        inst.props.element = s.inputElement;
      }
    } else {
      inst.props.element = el;
    }
    _super.prototype._render.call(this, s);
    inst.forceUpdate();
  };
  MbscSelectDirective.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscSelectDirective_BaseFactory;
    return function MbscSelectDirective_Factory(t) {
      return (ɵMbscSelectDirective_BaseFactory || (ɵMbscSelectDirective_BaseFactory = i0.ɵɵgetInheritedFactory(MbscSelectDirective)))(t || MbscSelectDirective);
    };
  })();
  MbscSelectDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: MbscSelectDirective,
    selectors: [["", "mbsc-select", ""]],
    inputs: {
      options: [i0.ɵɵInputFlags.None, "mbscOptions", "options"],
      inputElement: "inputElement"
    },
    exportAs: ["mobiscroll"],
    features: [i0.ɵɵProvidersFeature([MbscSelectOptionChangeService]), i0.ɵɵInheritDefinitionFeature]
  });
  return MbscSelectDirective;
}(MbscSelectBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscSelectModule = /*#__PURE__*/function () {
  function MbscSelectModule() {}
  MbscSelectModule.ɵfac = function MbscSelectModule_Factory(t) {
    return new (t || MbscSelectModule)();
  };
  MbscSelectModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MbscSelectModule
  });
  MbscSelectModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule, FormsModule, MbscScrollerModule, MbscIconModule, MbscInputModule]]
  });
  return MbscSelectModule;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var dragObservable = new Observable();
function subscribeExternalDrag(handler) {
  return dragObservable.subscribe(handler);
}
function unsubscribeExternalDrag(key) {
  dragObservable.unsubscribe(key);
}
function moveClone(ev, clone) {
  clone.style.left = ev.endX + "px";
  clone.style.top = ev.endY + "px";
}
var DraggableBase = /*#__PURE__*/function (_super) {
  __extends(DraggableBase, _super);
  function DraggableBase() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  DraggableBase.prototype._render = function (s) {
    if (s.dragData !== this._prevS.dragData) {
      this._dragData = isString(s.dragData) ? JSON.parse(s.dragData.toString()) : s.dragData;
    }
  };
  DraggableBase.prototype._updated = function () {
    var _this = this;
    var el = this.s.element || this._el;
    var doc = getDocument(el);
    if (this._unlisten === UNDEFINED && el && doc) {
      el.classList.add("mbsc-draggable");
      var clone_1;
      var isDrag_1;
      var touchTimer_1;
      var body_1 = doc.body;
      this._unlisten = gestureListener(el, {
        onEnd: function (ev) {
          if (isDrag_1) {
            var args = __assign({}, ev);
            args.domEvent.preventDefault();
            args.action = "externalDrop";
            args.dragData = _this._dragData;
            args.create = true;
            args.external = true;
            args.eventName = "onDragEnd";
            dragObservable.next(args);
            isDrag_1 = false;
            body_1.removeChild(clone_1);
          }
          clearTimeout(touchTimer_1);
        },
        onMove: function (ev) {
          var args = __assign({}, ev);
          args.dragData = _this._dragData;
          args.clone = clone_1;
          args.create = true;
          args.external = true;
          if (isDrag_1 || !args.isTouch) {
            args.domEvent.preventDefault();
          }
          if (isDrag_1) {
            moveClone(ev, clone_1);
            args.eventName = "onDragMove";
            dragObservable.next(args);
          } else if (Math.abs(args.deltaX) > 7 || Math.abs(args.deltaY) > 7) {
            clearTimeout(touchTimer_1);
            if (!args.isTouch) {
              moveClone(ev, clone_1);
              body_1.appendChild(clone_1);
              args.eventName = "onDragStart";
              dragObservable.next(args);
              isDrag_1 = true;
            }
          }
        },
        onStart: function (ev) {
          var args = __assign({}, ev);
          if (!isDrag_1) {
            clone_1 = el.cloneNode(true);
            clone_1.classList.add("mbsc-drag-clone");
            args.dragData = _this._dragData;
            args.create = true;
            args.external = true;
            if (args.isTouch) {
              touchTimer_1 = setTimeout(function () {
                moveClone(ev, clone_1);
                body_1.appendChild(clone_1);
                args.clone = clone_1;
                args.eventName = "onDragModeOn";
                dragObservable.next(args);
                args.eventName = "onDragStart";
                dragObservable.next(args);
                isDrag_1 = true;
              }, 350);
            }
          }
        }
      });
    }
  };
  DraggableBase.prototype._destroy = function () {
    if (this._unlisten) {
      this._unlisten();
      this._unlisten = UNDEFINED;
    }
  };
  DraggableBase._name = "Draggable";
  DraggableBase.ɵfac = /* @__PURE__ */(() => {
    let ɵDraggableBase_BaseFactory;
    return function DraggableBase_Factory(t) {
      return (ɵDraggableBase_BaseFactory || (ɵDraggableBase_BaseFactory = i0.ɵɵgetInheritedFactory(DraggableBase)))(t || DraggableBase);
    };
  })();
  DraggableBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DraggableBase,
    selectors: [["", "mbsc-drag", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return DraggableBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var uid = 1;
function getDataInRange(data, s, firstDay, lastDay, start, end) {
  var startDate = firstDay;
  var endDate = lastDay;
  var map = new Map();
  var dataInRange = [];
  if (start) {
    startDate = makeDate(start, s);
  }
  if (end) {
    endDate = makeDate(end, s);
  } else if (start) {
    endDate = addDays(startDate, 1);
  }
  var events = getEventMap(data, startDate, endDate, s);
  for (var date in events) {
    if (date) {
      for (var _i = 0, _a = events[date]; _i < _a.length; _i++) {
        var event_1 = _a[_i];
        if (!event_1.start) {
          dataInRange.push(event_1);
        } else if (!map.has(event_1)) {
          var eventStart = makeDate(event_1.start, s);
          var eventEnd = makeDate(event_1.end, s) || eventStart;
          if (event_1.allDay) {
            eventStart = createDate(s, eventStart.getFullYear(), eventStart.getMonth(), eventStart.getDate());
            eventEnd = getEndDate(s, true, eventStart, eventEnd);
            eventEnd = createDate(s, eventEnd.getFullYear(), eventEnd.getMonth(), eventEnd.getDate(), 23, 59, 59, 999);
          }
          if (checkDateRangeOverlap(startDate, endDate, eventStart, eventEnd)) {
            var eventCopy = __assign({}, event_1);
            if (s.dataTimezone || s.displayTimezone) {
              eventCopy.start = eventStart.toISOString();
              eventCopy.end = eventEnd.toISOString();
            }
            map.set(event_1, true);
            dataInRange.push(eventCopy);
          }
        }
      }
    }
  }
  return dataInRange;
}
function getEventId() {
  return "mbsc_".concat(uid++);
}
function getEventData(s, event, eventDay, colorEvent, resource, isList, isMultipart, isDailyResolution, skipLabels, fullDates) {
  var color = event.color || resource && resource.color;
  var st = event.start || event.date;
  var origStart = event.recurring ? event.original.start : event.start;
  var allDay = event.allDay || !origStart;
  var tzOpt = getTzOpt(s, event);
  var start = st ? makeDate(st, tzOpt) : null;
  var end = event.end ? makeDate(event.end, tzOpt) : null;
  var endDate = getEndDate(s, event.allDay, start, end, isList);
  var bufferStart = event.bufferBefore ? makeDate(+start - event.bufferBefore * 6e4, tzOpt) : null;
  var bufferEnd = event.bufferAfter ? makeDate(+endDate + event.bufferAfter * 6e4, tzOpt) : null;
  var isMultiDay = start && endDate && !isSameDay(start, endDate);
  var isFirstDay = isMultiDay ? isSameDay(start, eventDay) : true;
  var isLastDay = isMultiDay ? isSameDay(endDate, eventDay) : true;
  var fillsAllDay = !fullDates && (allDay || isMultipart && isMultiDay && !isFirstDay && !isLastDay);
  var startTime = "";
  var endTime = "";
  if (!skipLabels) {
    if (fullDates) {
      var dateTimeFormat = s.dateFormat + (allDay ? "" : s.separator + s.timeFormat);
      startTime = start ? formatDate(dateTimeFormat, start, s) : "";
      endTime = end ? formatDate(dateTimeFormat, allDay ? endDate : end, s) : "";
    } else if (!isMultipart && !isDailyResolution) {
      startTime = start ? formatDate(s.dateFormat, start, s) : "";
      endTime = end ? formatDate(s.dateFormat, endDate, s) : "";
    } else if (!allDay) {
      startTime = start ? formatDate(s.timeFormat, start, s) : "";
      endTime = end ? formatDate(s.timeFormat, end, s) : "";
    }
  }
  var eventStart = !fillsAllDay && (isFirstDay || !isMultipart || fullDates) ? startTime : "";
  var eventEnd = !fillsAllDay && (isLastDay || !isMultipart || fullDates) ? endTime : "";
  var html = event.title || event.text || "";
  var title = html;
  var tooltip = title + (fillsAllDay ? "" : ", " + eventStart + " - " + eventEnd);
  var format = s.dateFormatFull;
  var startStr = !skipLabels && start ? ", " + s.fromText + ": " + formatDate(format, start, s) + (allDay ? "" : ", " + startTime) : "";
  var endStr = !skipLabels && end ? ", " + s.toText + ": " + formatDate(format, end, s) + (allDay ? "" : ", " + endTime) : "";
  var resourceStr = resource && resource.name ? ", " + resource.name : "";
  return {
    allDay: allDay,
    allDayText: fillsAllDay ? s.allDayText : "",
    ariaLabel: title + resourceStr + startStr + endStr,
    bufferEnd: bufferEnd,
    bufferStart: bufferStart,
    color: color,
    currentResource: resource,
    date: +eventDay,
    end: eventEnd,
    endDate: end ? end : start ? new Date(start) : null,
    html: html,
    id: event.id,
    isMultiDay: isMultiDay,
    lastDay: !fillsAllDay && isMultiDay && isLastDay ? s.toText : "",
    original: event,
    position: {},
    resource: event.resource,
    slot: event.slot,
    start: eventStart,
    startDate: start,
    style: {
      background: color,
      color: colorEvent && color ? getTextColor(color) : ""
    },
    title: title,
    tooltip: s.showEventTooltip ? event.tooltip || tooltip : UNDEFINED,
    uid: event.occurrenceId ? event.occurrenceId : event.id
  };
}
function prepareEvents(events) {
  var data = [];
  if (events) {
    for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
      var event_2 = events_1[_i];
      if (event_2.id === UNDEFINED) {
        event_2.id = getEventId();
      }
      data.push(event_2);
    }
  }
  return data;
}
function checkInvalidCollision(s, invalids, valids, start, end, min, max, invalidateEvent, exclusiveEndDates) {
  if (invalidateEvent === "start-end") {
    var invalidStart = isInvalid(s, start, invalids, valids, min, max);
    var invalidEnd = isInvalid(s, end, invalids, valids, min, max);
    if (invalidStart) {
      return invalidStart;
    }
    if (invalidEnd) {
      return invalidEnd;
    }
  } else {
    var until = exclusiveEndDates ? end : getDateOnly(addDays(end, 1));
    for (var d = getDateOnly(start); d < until; d.setDate(d.getDate() + 1)) {
      var invalid = isInvalid(s, d, invalids, valids, min, max);
      if (invalid) {
        return invalid;
      }
    }
  }
  return false;
}
function checkOverlap(event, start, end, eventMap, s) {
  var until = s.exclusiveEndDates ? end : getDateOnly(addDays(end, 1));
  for (var d = getDateOnly(start); d < until; d.setDate(d.getDate() + 1)) {
    var dayEvents = (eventMap[getDateStr(d)] || []).filter(function (e) {
      return e.id !== event.id;
    });
    if (dayEvents.length) {
      if (s.eventOverlap === false || event.overlap === false) {
        return dayEvents[0];
      }
      for (var _i = 0, dayEvents_1 = dayEvents; _i < dayEvents_1.length; _i++) {
        var dayEvent = dayEvents_1[_i];
        if (dayEvent.overlap === false) {
          return dayEvent;
        }
      }
    }
  }
  return false;
}
var EventcalendarBase = /*#__PURE__*/function (_super) {
  __extends(EventcalendarBase, _super);
  function EventcalendarBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.print = noop;
    _this._checkSize = 0;
    _this._navService = new MbscCalendarNavService();
    _this._pageLoad = 0;
    _this._selectedDates = {};
    _this._shouldScrollSchedule = 0;
    _this._update = 0;
    _this._onScroll = throttle(function () {
      if (!_this._isListScrolling && !_this._viewChanged) {
        for (var timestamp in _this._listDays) {
          if (_this._listDays[timestamp]) {
            var day = _this._listDays[timestamp];
            var bottom = day.offsetTop + day.offsetHeight - _this._list.scrollTop;
            if (bottom > 0) {
              if (+timestamp !== _this._selected) {
                _this._shouldSkipScroll = true;
                _this._selectedChange(+timestamp);
              }
              break;
            }
          }
        }
      }
    });
    _this._isListScrolling = 0;
    _this._onWeekDayClick = function (d) {
      if (d !== _this._selected) {
        _this._skipScheduleScroll = true;
        _this._selectedChange(d);
      }
    };
    _this._onDayClick = function (args) {
      var date = args.date;
      var d = +date;
      var key = getDateStr(date);
      var events = sortEvents(_this._eventMap[key], _this.s.eventOrder);
      var showEventPopover = _this._showEventPopover;
      var computed = showEventPopover === UNDEFINED ? !_this._showEventLabels && !_this._showEventList && !_this._showSchedule : showEventPopover;
      var showMore = showEventPopover !== false && _this._moreLabelClicked;
      var showPopover = (computed || showMore) && events && events.length > 0;
      args.events = events;
      if (!_this._isEventClick) {
        _this._resetSelection();
      }
      _this._hook("onCellClick", args);
      _this._moreLabelClicked = false;
      if (!args.disabled && d !== _this._selected) {
        _this._navService.preventPageChange = !_this._showEventList;
        _this._skipScheduleScroll = true;
        _this._selectedChange(d);
      }
      if (showPopover) {
        _this._showPopover(d, d, events.map(function (event) {
          return _this._getEventData(event, date);
        }), args.target);
      }
      _this._isEventClick = false;
    };
    _this._onActiveChange = function (args) {
      if (args.scroll) {
        _this._viewDate = +args.date;
        return;
      }
      var d = _this._getValidDay(args.date, args.dir);
      var newState = {
        activeDate: d
      };
      _this._active = d;
      _this._viewDate = d;
      _this._update++;
      _this._skipScheduleScroll = args.pageChange && !args.nav;
      if (args.pageChange || args.today) {
        newState.selectedDate = d;
        _this._selectedChange(d, true);
        _this._navService.forcePageChange = true;
      }
      _this.setState(newState);
    };
    _this._onGestureStart = function (args) {
      _this._hidePopover();
    };
    _this._onDayDoubleClick = function (args) {
      _this._dayClick("onCellDoubleClick", args);
    };
    _this._onDayRightClick = function (args) {
      _this._dayClick("onCellRightClick", args);
    };
    _this._onCellHoverIn = function (args) {
      args.events = _this._eventMap[getDateStr(args.date)];
      _this._hook("onCellHoverIn", args);
    };
    _this._onCellHoverOut = function (args) {
      args.events = _this._eventMap[getDateStr(args.date)];
      _this._hook("onCellHoverOut", args);
    };
    _this._onEventHoverIn = function (args) {
      _this._hoverTimer = setTimeout(function () {
        _this._isHover = true;
        _this._eventClick("onEventHoverIn", args);
      }, 150);
    };
    _this._onEventHoverOut = function (args) {
      clearTimeout(_this._hoverTimer);
      if (_this._isHover) {
        _this._isHover = false;
        _this._eventClick("onEventHoverOut", args);
      }
    };
    _this._onEventClick = function (args) {
      var s = _this.s;
      _this._handleMultipleSelect(args);
      var close = _this._eventClick("onEventClick", args);
      if (close !== false && !(s.selectMultipleEvents || s.eventDelete || (s.dragToCreate || s.clickToCreate) && s.eventDelete !== false)) {
        _this._hidePopover();
      }
    };
    _this._onEventDoubleClick = function (args) {
      _this._eventClick("onEventDoubleClick", args);
    };
    _this._onEventRightClick = function (args) {
      _this._eventClick("onEventRightClick", args);
    };
    _this._onEventDragEnd = function (args) {
      _this._hook("onEventDragEnd", args);
    };
    _this._onEventDragStart = function (args) {
      _this._hook("onEventDragStart", args);
    };
    _this._onEventDragEnter = function (args) {
      _this._hook("onEventDragEnter", args);
    };
    _this._onEventDragLeave = function (args) {
      _this._hook("onEventDragLeave", args);
    };
    _this._onLabelHoverIn = function (args) {
      _this._hoverTimer = setTimeout(function () {
        _this._isHover = true;
        _this._labelClick("onEventHoverIn", args);
      }, 150);
    };
    _this._onLabelHoverOut = function (args) {
      clearTimeout(_this._hoverTimer);
      if (_this._isHover) {
        _this._isHover = false;
        _this._labelClick("onEventHoverOut", args);
      }
    };
    _this._onLabelClick = function (args) {
      _this._handleMultipleSelect(args);
      _this._hook("onLabelClick", args);
      _this._labelClick("onEventClick", args);
      _this._isEventClick = true;
      if (!args.label) {
        _this._moreLabelClicked = true;
      }
    };
    _this._onLabelDoubleClick = function (args) {
      _this._labelClick("onEventDoubleClick", args);
    };
    _this._onLabelRightClick = function (args) {
      _this._labelClick("onEventRightClick", args);
    };
    _this._onCellClick = function (args) {
      _this._resetSelection();
      _this._cellClick("onCellClick", args);
    };
    _this._onCellDoubleClick = function (args) {
      _this._cellClick("onCellDoubleClick", args);
    };
    _this._onCellRightClick = function (args) {
      _this._cellClick("onCellRightClick", args);
    };
    _this._proxy = function (args) {
      _this._hook(args.type, args);
    };
    _this._onPageChange = function (args) {
      setTimeout(function () {
        _this._hidePopover();
      });
      _this._isPageChange = true;
      _this._hook("onPageChange", args);
    };
    _this._onPageLoading = function (args) {
      var s = _this.s;
      var eventMap = getEventMap(_this._events, args.viewStart, args.viewEnd, s);
      _this._colorsMap = getEventMap(s.colors, args.viewStart, args.viewEnd, s);
      _this._invalidsMap = getEventMap(s.invalid, args.viewStart, args.viewEnd, s, true);
      _this._validsMap = getEventMap(s.valid, args.viewStart, args.viewEnd, s, true);
      _this._eventMap = eventMap;
      _this._firstDay = getFirstDayOfWeek(args.firstDay, s, _this._firstWeekDay);
      _this._lastDay = args.lastDay;
      _this._labelsMap = _this._marksMap = UNDEFINED;
      if (!s.labels && (_this._showEventLabels || _this._showEventCount)) {
        _this._labelsMap = eventMap;
      } else if (!s.marked) {
        _this._marksMap = eventMap;
      }
      if (args.viewChanged) {
        _this._hook("onPageLoading", args);
      }
    };
    _this._onPageLoaded = function (args) {
      _this._shouldAnimateScroll = _this._isPageChange;
      _this._isPageChange = false;
      var viewType = _this._eventListType;
      if (_this._showEventList && !(_this._showCalendar && viewType === "day")) {
        var s = _this.s;
        var month = args.month;
        var isMonthList = _this._showEventList && month && viewType === "month";
        var firstDay = isMonthList ? month : args.firstDay;
        var lastDay = isMonthList ? s.getDate(s.getYear(month), s.getMonth(month) + _this._eventListSize, 1) : args.lastDay;
        _this._setEventList(firstDay, lastDay);
      }
      _this._hook("onPageLoaded", args);
    };
    _this._onMoreClick = function (args) {
      _this._showPopover(args.key, +args.date, args.list.map(function (event) {
        return _this._getEventData(event.original, new Date(args.date), event.currentResource, true);
      }), args.target, args.context, args.inst);
    };
    _this._onPopoverClose = function (args) {
      var state = _this.state;
      if (state.popoverHost && args.source === "dragStart") {
        _this.setState({
          popoverDrag: true,
          popoverHidden: true
        });
      } else if (!state.popoverHost || args.source !== "scroll" || !state.popoverDrag) {
        _this._hidePopover();
      }
    };
    _this._onResize = function (ev) {
      var isListScrollable;
      if (_this._showEventList && isBrowser) {
        var cal = ev.target;
        var height = cal.offsetHeight;
        var calTop = cal.getBoundingClientRect().top;
        var listTop = _this._list.getBoundingClientRect().top;
        isListScrollable = height - listTop + calTop > 170;
      }
      _this.setState({
        height: ev.height,
        isListScrollable: isListScrollable,
        width: ev.width
      });
    };
    _this._onSelectedEventsChange = function (events) {
      _this._emit("selectedEventsChange", events);
      _this._hook("onSelectedEventsChange", {
        events: events
      });
    };
    _this._getDragDates = function (start, end, event) {
      var draggedDates = {};
      var firstWeekDay = _this._firstWeekDay;
      var endDate = getEndDate(_this.s, event.allDay, start, end, true);
      var until = getDateOnly(addDays(endDate, 1));
      for (var d = getDateOnly(start); d < until; d.setDate(d.getDate() + 1)) {
        var weekDay = d.getDay();
        var offset = firstWeekDay - weekDay > 0 ? 7 : 0;
        if (isSameDay(start, d) || weekDay === firstWeekDay) {
          draggedDates[getDateStr(d)] = {
            event: event,
            width: Math.min(getDayDiff(d, endDate) + 1, 7 + firstWeekDay - weekDay - offset) * 100
          };
        } else {
          draggedDates[getDateStr(d)] = {};
        }
      }
      return draggedDates;
    };
    _this._onLabelUpdateModeOn = function (args) {
      var event = args.create ? _this._tempEvent : args.event;
      var start = makeDate(event.start);
      var end = makeDate(event.end || start);
      _this.setState({
        isTouchDrag: true,
        labelDragData: {
          draggedEvent: event,
          originDates: args.external ? UNDEFINED : _this._getDragDates(start, end, event)
        }
      });
    };
    _this._onLabelUpdateModeOff = function (args) {
      _this._hook("onEventDragEnd", {
        domEvent: args.domEvent,
        event: args.create ? _this._tempEvent : args.event,
        source: "calendar"
      });
      _this.setState({
        isTouchDrag: false,
        labelDragData: UNDEFINED
      });
    };
    _this._onLabelUpdateStart = function (args) {
      var s = _this.s;
      var el = _this._el;
      if (s.externalDrag && args.drag && !args.create) {
        var eventEl = el.querySelector(".mbsc-calendar-label[data-id='".concat(args.event.id, "']")) || closest(args.domEvent.target, ".mbsc-list-item");
        if (eventEl) {
          var clone = eventEl.cloneNode(true);
          var cloneClass = clone.classList;
          clone.style.display = "none";
          cloneClass.add("mbsc-drag-clone", "mbsc-schedule-drag-clone", "mbsc-font");
          cloneClass.remove("mbsc-calendar-label-hover", "mbsc-hover", "mbsc-focus", "mbsc-active");
          _this._clone = clone;
          _this._body = getDocument(el).body;
          _this._body.appendChild(clone);
          _this._eventDropped = false;
          dragObservable.next(__assign(__assign({}, args), {
            create: true,
            dragData: args.event,
            eventName: "onDragStart",
            external: true,
            from: _this
          }));
        }
      }
      var weekNumWidth = _this._showWeekNumbers ? el.querySelector(".mbsc-calendar-week-nr").getBoundingClientRect().width : 0;
      var slide = el.querySelectorAll(".mbsc-calendar-slide-active")[0];
      var slideRect = slide.getBoundingClientRect();
      var weeksCont = el.querySelector(".mbsc-calendar-week-days");
      var rows = slide.querySelectorAll(".mbsc-calendar-row");
      var isClick = /click/.test(args.domEvent.type);
      _this._areaTop = 0;
      if (weeksCont) {
        var weeksRect = weeksCont.getBoundingClientRect();
        _this._areaTop = weeksRect.top + weeksRect.height;
      }
      _this._areaLeft = slideRect.left + (s.rtl ? 0 : weekNumWidth);
      _this._areaBottom = slideRect.top + slideRect.height;
      _this._areaRight = _this._areaLeft + slideRect.width - (s.rtl ? weekNumWidth : 0);
      _this._calCellWidth = (_this._areaRight - _this._areaLeft) / 7;
      var newWeek = 0;
      _this._rowTops = [];
      rows.forEach(function (r, i) {
        var rowTop = r.getBoundingClientRect().top - _this._areaTop;
        _this._rowTops.push(rowTop);
        if (args.endY - _this._areaTop > rowTop) {
          newWeek = i;
        }
      });
      if (args.create) {
        var newDay = floor((s.rtl ? _this._areaRight - args.endX : args.endX - _this._areaLeft) / _this._calCellWidth);
        var newStartDay = addDays(_this._firstDay, newWeek * 7 + newDay);
        var newStart = new Date(newStartDay.getFullYear(), newStartDay.getMonth(), newStartDay.getDate());
        var nextDay = addDays(newStart, 1);
        var newEnd = s.exclusiveEndDates ? nextDay : new Date(+nextDay - 1);
        var eventData = s.extendDefaultEvent ? s.extendDefaultEvent({
          start: newStart
        }) : UNDEFINED;
        _this._tempEvent = __assign(__assign({
          allDay: true,
          end: newEnd,
          id: getEventId(),
          start: newStart,
          title: s.newEventText
        }, args.dragData), eventData);
      }
      if (!isClick) {
        _this._hook("onEventDragStart", {
          action: args.create ? "create" : args.resize ? "resize" : "move",
          domEvent: args.domEvent,
          event: args.create ? _this._tempEvent : args.event,
          source: "calendar"
        });
      }
    };
    _this._onLabelUpdateMove = function (args) {
      var s = _this.s;
      var event = args.create ? _this._tempEvent : args.event;
      var draggedEvent = __assign({}, event);
      var labelDragData = _this.state.labelDragData;
      var tzOpt = event.allDay ? UNDEFINED : s;
      if (s.externalDrag && args.drag && !args.create && _this._clone) {
        dragObservable.next(__assign(__assign({}, args), {
          clone: _this._clone,
          create: true,
          dragData: args.event,
          eventName: "onDragMove",
          external: true,
          from: _this
        }));
        if (!_this._onCalendar) {
          moveClone(args, _this._clone);
          if (!labelDragData || !labelDragData.draggedEvent) {
            _this.setState({
              labelDragData: {
                draggedEvent: draggedEvent
              }
            });
          }
          return;
        }
      }
      if (args.endY > _this._areaTop && args.endY < _this._areaBottom && args.endX > _this._areaLeft && args.endX < _this._areaRight) {
        var newDay = floor((s.rtl ? _this._areaRight - args.endX : args.endX - _this._areaLeft) / _this._calCellWidth);
        var oldDay = floor((s.rtl ? _this._areaRight - args.startX : args.startX - _this._areaLeft) / _this._calCellWidth);
        var newWeek_1 = 0;
        var oldWeek_1 = 0;
        _this._rowTops.forEach(function (rowTop, i) {
          if (args.startY - _this._areaTop > rowTop) {
            oldWeek_1 = i;
          }
          if (args.endY - _this._areaTop > rowTop) {
            newWeek_1 = i;
          }
        });
        var dayDelta = (newWeek_1 - oldWeek_1) * 7 + (newDay - oldDay);
        if (newDay !== _this._tempDay || newWeek_1 !== _this._tempWeek) {
          var start = makeDate(event.start, tzOpt);
          var end = makeDate(event.end, tzOpt) || start;
          var isEventDraggableInTime = computeEventDragInTime(event.dragInTime, UNDEFINED, s.dragInTime);
          var newStart = start;
          var newEnd = end;
          if (args.external) {
            var ms = getDayMilliseconds(start);
            var duration = +end - +start;
            if (isEventDraggableInTime) {
              newStart = createDate(s, +addDays(_this._firstDay, newWeek_1 * 7 + newDay) + ms);
              newEnd = createDate(s, +newStart + duration);
            }
          } else if (args.drag) {
            if (!isEventDraggableInTime) {
              return;
            }
            newStart = addDays(start, dayDelta);
            newEnd = addDays(end, dayDelta);
          } else {
            var rtl = s.rtl ? -1 : 1;
            var endResize = args.create ? newWeek_1 === oldWeek_1 ? args.deltaX * rtl > 0 : dayDelta > 0 : args.direction === "end";
            var days = getDayDiff(start, end);
            if (endResize) {
              newEnd = addDays(end, Math.max(-days, dayDelta));
            } else {
              newStart = addDays(start, Math.min(days, dayDelta));
            }
            if (newEnd < newStart) {
              if (endResize) {
                newEnd = createDate(tzOpt, newStart);
              } else {
                newStart = createDate(tzOpt, newEnd);
              }
            }
          }
          draggedEvent.start = newStart;
          draggedEvent.end = newEnd;
          _this.setState({
            labelDragData: {
              draggedDates: _this._getDragDates(newStart, newEnd, draggedEvent),
              draggedEvent: draggedEvent,
              originDates: labelDragData && labelDragData.originDates
            },
            popoverHidden: true
          });
          _this._tempDay = newDay;
          _this._tempWeek = newWeek_1;
        }
      }
    };
    _this._onLabelUpdateEnd = function (args) {
      var s = _this.s;
      var state = _this.state;
      var isCreating = args.create;
      var dragData = state.labelDragData || {};
      var event = isCreating ? _this._tempEvent : args.event;
      var draggedEvent = dragData.draggedEvent || event;
      var origStart = makeDate(event.start);
      var origEnd = makeDate(event.end);
      var newStart = makeDate(draggedEvent.start);
      var newEnd = makeDate(draggedEvent.end);
      var changed = isCreating || +origStart !== +newStart || +origEnd !== +newEnd;
      var draggedEventData = {
        allDay: event.allDay,
        endDate: newEnd,
        original: event,
        startDate: newStart
      };
      var eventLeft = false;
      if (s.externalDrag && args.drag && !args.create && _this._clone) {
        dragObservable.next(__assign(__assign({}, args), {
          action: "externalDrop",
          create: true,
          dragData: args.event,
          eventName: "onDragEnd",
          external: true,
          from: _this
        }));
        _this._body.removeChild(_this._clone);
        _this._clone = UNDEFINED;
        if (!_this._onCalendar) {
          eventLeft = true;
          if (_this._eventDropped) {
            _this._onEventDelete(args);
          }
        }
      }
      var action = args.action || (dragData.draggedEvent ? "drag" : "click");
      var allowUpdate = !eventLeft && (changed ? _this._onEventDragStop({
        action: action,
        collision: checkInvalidCollision(s, _this._invalidsMap, _this._validsMap, newStart, newEnd, _this._minDate, _this._maxDate, s.invalidateEvent, s.exclusiveEndDates),
        create: isCreating,
        domEvent: args.domEvent,
        event: draggedEventData,
        external: args.external,
        from: args.from,
        overlap: checkOverlap(event, newStart, newEnd, _this._eventMap, s),
        source: "calendar"
      }) : true);
      var keepDragMode = state.isTouchDrag && !eventLeft && (!isCreating || allowUpdate);
      if (!keepDragMode && action !== "click") {
        _this._hook("onEventDragEnd", {
          domEvent: args.domEvent,
          event: event,
          source: "calendar"
        });
      }
      _this.setState({
        isTouchDrag: keepDragMode,
        labelDragData: keepDragMode ? {
          draggedEvent: allowUpdate ? draggedEvent : __assign({}, event),
          originDates: allowUpdate ? _this._getDragDates(newStart, newEnd, draggedEventData.original) : dragData.originDates
        } : {}
      });
      if (args.drag) {
        _this._hidePopover();
      }
      _this._tempWeek = -1;
      _this._tempDay = -1;
    };
    _this._onEventDragStop = function (args) {
      var s = _this.s;
      var action = args.action;
      var resource = args.resource;
      var slot = args.slot;
      var invalidCollision = args.collision;
      var overlapCollision = args.overlap;
      var isCreating = args.create;
      var source = args.source;
      var draggedEvent = args.event;
      var event = draggedEvent.original;
      var orig = event.recurring ? event.original : event;
      var originalEvent = s.immutableData ? __assign({}, orig) : orig;
      var oldEvent = __assign({}, originalEvent);
      var eventCopy = __assign({}, originalEvent);
      var eventTz = event.timezone;
      var origStart = convertTimezone(event.start, s, eventTz);
      var start = convertTimezone(draggedEvent.startDate, s, eventTz);
      var end = convertTimezone(draggedEvent.endDate, s, eventTz);
      var allDay = draggedEvent.allDay;
      var isRecurring = eventCopy.recurring;
      if (isRecurring) {
        eventCopy.recurringException = __spreadArray(__spreadArray([], getExceptionList(eventCopy.recurringException), true), [origStart], false);
      } else {
        eventCopy.allDay = allDay;
        eventCopy.start = start;
        eventCopy.end = end;
        if (resource !== UNDEFINED) {
          eventCopy.resource = resource;
        }
        if (slot !== UNDEFINED) {
          eventCopy.slot = slot;
        }
      }
      var allowUpdate = false;
      var newEvent = isRecurring ? __assign({}, originalEvent) : originalEvent;
      if (isCreating || isRecurring) {
        if (isRecurring) {
          delete newEvent.recurring;
        }
        if (isRecurring || newEvent.id === UNDEFINED) {
          newEvent.id = getEventId();
        }
        if (resource !== UNDEFINED) {
          newEvent.resource = resource;
        }
        if (slot !== UNDEFINED) {
          newEvent.slot = slot;
        }
        newEvent.start = start;
        newEvent.end = end;
        newEvent.allDay = allDay;
        allowUpdate = _this._hook("onEventCreate", __assign({
          action: action,
          domEvent: args.domEvent,
          event: newEvent,
          source: source
        }, isRecurring && {
          originEvent: event
        })) !== false;
        if (invalidCollision !== false || overlapCollision !== false) {
          allowUpdate = false;
          _this._hook("onEventCreateFailed", __assign({
            action: action,
            event: newEvent,
            invalid: invalidCollision,
            overlap: overlapCollision,
            source: source
          }, isRecurring && {
            originEvent: event
          }));
        }
      }
      if ((!isCreating || isRecurring) && !args.external) {
        allowUpdate = _this._hook("onEventUpdate", __assign({
          domEvent: args.domEvent,
          event: eventCopy,
          oldEvent: oldEvent,
          oldResource: args.oldResource,
          oldSlot: args.oldSlot,
          resource: args.newResource,
          slot: args.newSlot,
          source: source
        }, isRecurring && {
          newEvent: newEvent,
          oldEventOccurrence: event
        })) !== false;
        if (invalidCollision !== false || overlapCollision !== false) {
          allowUpdate = false;
          _this._hook("onEventUpdateFailed", __assign({
            event: eventCopy,
            invalid: invalidCollision,
            oldEvent: oldEvent,
            overlap: overlapCollision,
            source: source
          }, isRecurring && {
            newEvent: newEvent,
            oldEventOccurrence: event
          }));
        }
      }
      if (allowUpdate) {
        if (args.from) {
          args.from._eventDropped = true;
        }
        if (isCreating || isRecurring) {
          _this._events.push(newEvent);
          _this._triggerCreated = {
            action: action,
            event: newEvent,
            source: source
          };
        }
        if (!isCreating || isRecurring) {
          if (isRecurring) {
            draggedEvent.id = newEvent.id;
            draggedEvent.original = newEvent;
            originalEvent.recurringException = eventCopy.recurringException;
          } else {
            originalEvent.start = start;
            originalEvent.end = end;
            originalEvent.allDay = allDay;
            if (resource !== UNDEFINED) {
              originalEvent.resource = resource;
            }
            if (slot !== UNDEFINED) {
              originalEvent.slot = slot;
            }
          }
          _this._triggerUpdated = {
            event: originalEvent,
            oldEvent: oldEvent,
            source: source
          };
        }
        _this._refresh = true;
        if (source !== "calendar") {
          _this.forceUpdate();
        }
      } else {
        _this._hidePopover();
      }
      return allowUpdate;
    };
    _this._onExternalDrag = function (args) {
      var s = _this.s;
      var clone = args.clone;
      var isSelf = args.from === _this;
      var externalDrop = !isSelf && s.externalDrop;
      var instantDrag = isSelf && s.externalDrag && !s.dragToMove;
      var dragData = _this.state.labelDragData;
      if (_this._showCalendar && (externalDrop || s.externalDrag)) {
        var isInArea = !instantDrag && args.endY > _this._areaTop && args.endY < _this._areaBottom && args.endX > _this._areaLeft && args.endX < _this._areaRight;
        switch (args.eventName) {
          case "onDragModeOff":
            if (externalDrop) {
              _this._onLabelUpdateModeOff(args);
            }
            break;
          case "onDragModeOn":
            if (externalDrop) {
              _this._onLabelUpdateModeOn(args);
            }
            break;
          case "onDragStart":
            if (externalDrop) {
              _this._onLabelUpdateStart(args);
            } else if (isSelf) {
              _this._onCalendar = true;
            }
            break;
          case "onDragMove":
            if (!isSelf && !externalDrop) {
              return;
            }
            if (isInArea) {
              if (!_this._onCalendar) {
                _this._hook("onEventDragEnter", {
                  domEvent: args.domEvent,
                  event: args.dragData,
                  source: "calendar"
                });
              }
              if (isSelf || externalDrop) {
                clone.style.display = "none";
              }
              if (externalDrop) {
                _this._onLabelUpdateMove(args);
              }
              _this._onCalendar = true;
            } else if (_this._onCalendar) {
              _this._hook("onEventDragLeave", {
                domEvent: args.domEvent,
                event: args.dragData,
                source: "calendar"
              });
              clone.style.display = "table";
              if (!isSelf || dragData && dragData.draggedEvent) {
                _this.setState({
                  labelDragData: {
                    draggedDates: {},
                    draggedEvent: isSelf ? dragData && dragData.draggedEvent : UNDEFINED,
                    originDates: isSelf ? dragData && dragData.originDates : UNDEFINED
                  }
                });
              }
              _this._tempWeek = -1;
              _this._tempDay = -1;
              _this._onCalendar = false;
            }
            break;
          case "onDragEnd":
            if (externalDrop) {
              if (!isInArea) {
                _this.setState({
                  labelDragData: UNDEFINED
                });
                _this._hook("onEventDragEnd", {
                  domEvent: args.domEvent,
                  event: args.dragData,
                  source: "calendar"
                });
              } else {
                _this._onLabelUpdateEnd(args);
              }
            }
            break;
        }
      }
    };
    _this._onEventDelete = function (args) {
      var _a;
      var s = _this.s;
      if (s.eventDelete === UNDEFINED && !s.dragToCreate && !s.clickToCreate || s.eventDelete === false) {
        return;
      }
      var changed = false;
      var hasRecurring = false;
      var hasNonRecurring = false;
      var originalEvent;
      var oldEvent;
      var eventCopy;
      var event = args.event;
      var occurrence = event;
      var isMultiple = s.selectMultipleEvents;
      var selectedEventsMap = isMultiple ? _this._selectedEventsMap : (_a = {}, _a[event.id] = event, _a);
      var selectedEvents = toArray(selectedEventsMap);
      var oldEvents = [];
      var recurringEvents = [];
      var updatedEvents = [];
      var updatedEventsMap = {};
      var events = [];
      for (var _i = 0, selectedEvents_1 = selectedEvents; _i < selectedEvents_1.length; _i++) {
        var selectedEvent = selectedEvents_1[_i];
        if (selectedEvent.recurring) {
          occurrence = selectedEvent;
          originalEvent = selectedEvent.original;
          hasRecurring = true;
          var id = originalEvent.id;
          if (updatedEventsMap[id]) {
            eventCopy = updatedEventsMap[id];
          } else {
            oldEvent = __assign({}, originalEvent);
            eventCopy = __assign({}, originalEvent);
            recurringEvents.push(originalEvent);
            oldEvents.push(oldEvent);
            updatedEvents.push(eventCopy);
            updatedEventsMap[id] = eventCopy;
          }
          var origStart = convertTimezone(selectedEvent.start, s);
          eventCopy.recurringException = __spreadArray(__spreadArray([], getExceptionList(eventCopy.recurringException), true), [origStart], false);
        } else {
          hasNonRecurring = true;
          event = selectedEvent;
          events.push(selectedEvent);
        }
      }
      if (hasRecurring) {
        var allowUpdate = _this._hook("onEventUpdate", {
          domEvent: args.domEvent,
          event: eventCopy,
          events: isMultiple ? updatedEvents : UNDEFINED,
          isDelete: true,
          oldEvent: isMultiple ? UNDEFINED : oldEvent,
          oldEventOccurrence: occurrence,
          oldEvents: isMultiple ? oldEvents : UNDEFINED,
          oldResource: args.resource,
          oldSlot: args.slot,
          resource: args.resource,
          slot: args.slot,
          source: args.source
        }) !== false;
        if (allowUpdate) {
          changed = true;
          for (var _b = 0, recurringEvents_1 = recurringEvents; _b < recurringEvents_1.length; _b++) {
            var recurringEvent = recurringEvents_1[_b];
            var updatedEvent = updatedEventsMap[recurringEvent.id];
            recurringEvent.recurringException = updatedEvent.recurringException;
          }
          _this._triggerUpdated = {
            event: originalEvent,
            events: isMultiple ? recurringEvents : UNDEFINED,
            oldEvent: isMultiple ? UNDEFINED : oldEvent,
            oldEvents: isMultiple ? oldEvents : UNDEFINED,
            source: args.source
          };
        }
      }
      if (hasNonRecurring) {
        var allowDelete = _this._hook("onEventDelete", {
          domEvent: args.domEvent,
          event: event,
          events: isMultiple ? events : UNDEFINED,
          source: args.source
        }) !== false;
        if (allowDelete) {
          changed = true;
          _this._events = _this._events.filter(function (e) {
            return !selectedEventsMap[e.id];
          });
          _this._selectedEventsMap = {};
          _this._triggerDeleted = {
            event: event,
            events: isMultiple ? events : UNDEFINED,
            source: args.source
          };
        }
      }
      if (changed) {
        _this._hidePopover();
        _this.refresh();
      }
    };
    _this._setEl = function (el) {
      _this._el = el ? el._el || el : null;
      _this._calendarView = el;
    };
    _this._setList = function (el) {
      _this._list = el;
    };
    _this._setPopoverList = function (list) {
      _this._popoverList = list && list._el;
    };
    _this._onKeyDown = function (ev) {
      if (ev.keyCode === TAB) {
        _this._resetSelection();
      }
    };
    return _this;
  }
  EventcalendarBase.prototype.addEvent = function (events) {
    var eventsToAdd = isArray(events) ? events : [events];
    var ids = [];
    var data = prepareEvents(eventsToAdd);
    for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
      var event_1 = data_1[_i];
      ids.push("" + event_1.id);
      this._events.push(event_1);
    }
    this.refresh();
    return ids;
  };
  EventcalendarBase.prototype.getEvents = function (start, end) {
    return getDataInRange(this._events, this.s, this._firstDay, this._lastDay, start, end);
  };
  EventcalendarBase.prototype.getInvalids = function (start, end) {
    return getDataInRange(this.s.invalid, this.s, this._firstDay, this._lastDay, start, end);
  };
  EventcalendarBase.prototype.getSelectedEvents = function () {
    return toArray(this._selectedEventsMap);
  };
  EventcalendarBase.prototype.setEvents = function (events) {
    var ids = [];
    var data = prepareEvents(events);
    for (var _i = 0, data_2 = data; _i < data_2.length; _i++) {
      var event_2 = data_2[_i];
      ids.push("" + event_2.id);
    }
    this._events = data;
    this.refresh();
    return ids;
  };
  EventcalendarBase.prototype.setSelectedEvents = function (selectedEvents) {
    this._selectedEventsMap = (selectedEvents || []).reduce(function (map, ev) {
      if (ev.occurrenceId) {
        map[ev.occurrenceId] = ev;
      } else {
        map[ev.id] = ev;
      }
      return map;
    }, {});
    this.forceUpdate();
  };
  EventcalendarBase.prototype.removeEvent = function (events) {
    var eventsToRemove = isArray(events) ? events : [events];
    var data = this._events;
    var len = data.length;
    for (var _i = 0, eventsToRemove_1 = eventsToRemove; _i < eventsToRemove_1.length; _i++) {
      var eventToRemove = eventsToRemove_1[_i];
      var found = false;
      var i = 0;
      while (!found && i < len) {
        var event_3 = data[i];
        if (event_3.id === eventToRemove || event_3.id === eventToRemove.id) {
          found = true;
          data.splice(i, 1);
        }
        i++;
      }
    }
    this.refresh();
  };
  EventcalendarBase.prototype.navigateToEvent = function (event) {
    this._navigateToEvent = event;
    this._shouldScrollSchedule++;
    this.navigate(event.start, true);
  };
  EventcalendarBase.prototype.navigate = function (date, animate) {
    var d = +makeDate(date);
    var isNavigate = this._navigateToEvent !== UNDEFINED;
    var changed = d !== this._selectedDateTime;
    if (changed || isNavigate) {
      this._shouldAnimateScroll = !!animate;
    }
    if (this.s.selectedDate === UNDEFINED) {
      if ((this._showSchedule || this._showTimeline) && !changed) {
        this._shouldScrollSchedule++;
        this.forceUpdate();
      } else {
        this.setState({
          selectedDate: d
        });
      }
    } else if (changed || isNavigate) {
      this._selectedChange(d);
    }
  };
  EventcalendarBase.prototype.updateEvent = function (events) {
    var eventsToUpdate = isArray(events) ? events : [events];
    var data = this._events;
    var len = data.length;
    for (var _i = 0, eventsToUpdate_1 = eventsToUpdate; _i < eventsToUpdate_1.length; _i++) {
      var eventToUpdate = eventsToUpdate_1[_i];
      var found = false;
      var i = 0;
      while (!found && i < len) {
        var event_4 = data[i];
        if (event_4.id === eventToUpdate.id) {
          found = true;
          data.splice(i, 1, __assign({}, eventToUpdate));
        }
        i++;
      }
    }
    this.refresh();
  };
  EventcalendarBase.prototype.refresh = function () {
    this._refresh = true;
    this.forceUpdate();
  };
  EventcalendarBase.prototype._render = function (s, state) {
    var _this = this;
    var prevProps = this._prevS;
    var showDate = this._showDate;
    var timezonesChanged = s.displayTimezone !== prevProps.displayTimezone || s.dataTimezone !== prevProps.dataTimezone;
    var renderList = false;
    var selectedChanged = false;
    var selectedDateTime;
    var viewChanged = false;
    this._colorEventList = s.eventTemplate !== UNDEFINED || s.renderEvent !== UNDEFINED ? false : s.colorEventList;
    if (s.exclusiveEndDates === UNDEFINED) {
      s.exclusiveEndDates = !!s.displayTimezone;
    }
    if (!isEmpty(s.min)) {
      if (prevProps.min !== s.min) {
        this._minDate = +makeDate(s.min);
      }
    } else {
      this._minDate = -Infinity;
    }
    if (!isEmpty(s.max)) {
      if (prevProps.max !== s.max) {
        this._maxDate = +makeDate(s.max);
      }
    } else {
      this._maxDate = Infinity;
    }
    if (s.selectedDate !== UNDEFINED) {
      selectedDateTime = +makeDate(s.selectedDate);
    } else {
      if (!this._defaultDate) {
        this._defaultDate = +(s.defaultSelectedDate !== UNDEFINED ? makeDate(s.defaultSelectedDate) : removeTimezone(createDate(s)));
      }
      selectedDateTime = state.selectedDate || this._selectedDateTime || this._defaultDate;
    }
    this.eventList = state.eventList || [];
    if (s.data !== prevProps.data) {
      this._events = s.immutableData ? __spreadArray([], s.data || [], true) : prepareEvents(s.data);
      this._refresh = true;
    }
    if (s.invalid !== prevProps.invalid || s.colors !== prevProps.colors || timezonesChanged) {
      this._refresh = true;
    }
    if (s.view !== prevProps.view || s.firstDay !== prevProps.firstDay) {
      var firstDay = s.firstDay;
      var view = s.view || {};
      var agenda = view.agenda || {};
      var calendar = view.calendar || {};
      var schedule = view.schedule || {};
      var timeline = view.timeline || {};
      var eventListSize = +(agenda.size || 1);
      var eventListType = agenda.type || "month";
      var scheduleSize = +(schedule.size || 1);
      var scheduleType = schedule.type || "week";
      var scheduleStartDay = schedule.startDay !== UNDEFINED ? schedule.startDay : firstDay;
      var scheduleEndDay = schedule.endDay !== UNDEFINED ? schedule.endDay : (firstDay + 6) % 7;
      var scheduleStartTime = schedule.startTime;
      var scheduleEndTime = schedule.endTime;
      var scheduleMaxEventStack = schedule.maxEventStack || "all";
      var scheduleMinEventWidth = schedule.minEventWidth;
      var scheduleTimeCellStep = schedule.timeCellStep || 60;
      var scheduleTimeLabelStep = schedule.timeLabelStep || 60;
      var scheduleTimezones = schedule.timezones;
      var showCalendar = !!view.calendar;
      var showEventCount = calendar.count;
      var showEventList = !!view.agenda;
      var showSchedule = !!view.schedule;
      var showScheduleDays = schedule.days !== UNDEFINED ? schedule.days : !showCalendar && showSchedule && !(scheduleType === "day" && s.resources && s.resources.length > 0 && scheduleSize < 2);
      var showTimeline = !!view.timeline;
      var showTimelineWeekNumbers = timeline.weekNumbers;
      var hasSlots = showTimeline && !!s.slots && s.slots.length > 0;
      var currentTimeIndicator = showTimeline ? timeline.currentTimeIndicator : schedule.currentTimeIndicator;
      var timelineType = timeline.type || "week";
      var resX = timeline.resolutionHorizontal || timeline.resolution;
      var resXDef = resX || "hour";
      var timelineResolutionVertical = timeline.resolutionVertical;
      var timelineResolution = timelineResolutionVertical === "day" && !/hour|day/.test(resXDef) ? "hour" : resXDef;
      var timelineStartDay = timeline.startDay !== UNDEFINED && /hour|day|week/.test(timelineResolution) ? timeline.startDay : firstDay;
      var timelineEndDay = timeline.endDay !== UNDEFINED && /hour|day|week/.test(timelineResolution) ? timeline.endDay : (firstDay + 6) % 7;
      var timelineStartTime = timeline.startTime;
      var timelineEndTime = timeline.endTime;
      var timelineMaxEventStack = timeline.maxEventStack || "all";
      var timelineListing = timeline.eventList || hasSlots;
      var timelineSize = +(timeline.size || 1);
      var timelineStep = /month|year/.test(timelineType) && !resX && timelineResolutionVertical !== "day" || timelineResolution === "day" || timelineListing ? 1440 : 60;
      var timelineTimeCellStep = hasSlots || timelineResolution === "day" ? timelineStep : timeline.timeCellStep || timelineStep;
      var timelineTimeLabelStep = hasSlots || timelineResolution === "day" ? timelineStep : timeline.timeLabelStep || timelineStep;
      var timelineVirtualScroll = timeline.virtualScroll === UNDEFINED ? true : timeline.virtualScroll;
      var calendarType = calendar.type || "month";
      var showEventLabels = calendar.labels !== UNDEFINED ? !!calendar.labels : !showEventList && !showSchedule && !showTimeline && !s.marked && !(calendarType === "year" || calendarType === "month" && calendar.size);
      this._calendarScroll = calendar.scroll;
      this._calendarSize = calendar.size || 1;
      this._calendarLabelList = calendar.labels;
      this._calendarType = calendarType;
      this._dragTimeStep = s.dragTimeStep !== UNDEFINED ? s.dragTimeStep : /hour|day/.test(timelineResolution) ? 15 : 1440;
      this._showEventPopover = calendar.popover;
      this._showOuterDays = calendar.outerDays;
      this._showWeekNumbers = calendar.weekNumbers;
      this._popoverClass = calendar.popoverClass || "";
      this._showScheduleAllDay = schedule.allDay !== UNDEFINED ? schedule.allDay : true;
      this._navView = timelineResolution === "year" || calendarType === "year" ? MULTI_YEAR_VIEW : timelineResolution === "quarter" || timelineResolution === "month" || showCalendar && calendarType === "month" ? YEAR_VIEW : MONTH_VIEW;
      if (eventListSize !== this._eventListSize || eventListType !== this._eventListType || showCalendar !== this._showCalendar || showEventCount !== this._showEventCount || showEventLabels !== this._showEventLabels || showEventList !== this._showEventList || scheduleSize !== this._scheduleSize || scheduleType !== this._scheduleType || showSchedule !== this._showSchedule || showScheduleDays !== this._showScheduleDays || scheduleStartDay !== this._scheduleStartDay || scheduleEndDay !== this._scheduleEndDay || scheduleStartTime !== this._scheduleStartTime || scheduleEndTime !== this._scheduleEndTime || scheduleTimeCellStep !== this._scheduleTimeCellStep || scheduleTimeLabelStep !== this._scheduleTimeLabelStep || showTimeline !== this._showTimeline || timelineStartDay !== this._timelineStartDay || timelineEndDay !== this._timelineEndDay || timelineStartTime !== this._timelineStartTime || timelineEndTime !== this._timelineEndTime || timelineSize !== this._timelineSize || timelineType !== this._timelineType || timelineTimeCellStep !== this._timelineTimeCellStep || timelineTimeLabelStep !== this._timelineTimeLabelStep || timelineListing !== this._timelineListing || timelineResolution !== this._timelineResolution || timelineResolutionVertical !== this._timelineResolutionVertical) {
        this._refresh = true;
        this._viewChanged = viewChanged = true;
      }
      this._currentTimeIndicator = currentTimeIndicator;
      this._eventListSize = eventListSize;
      this._eventListType = eventListType;
      this._scheduleType = scheduleType;
      this._showCalendar = showCalendar;
      this._showEventCount = showEventCount;
      this._showEventLabels = showEventLabels;
      this._showEventList = showEventList;
      this._showSchedule = showSchedule;
      this._showScheduleDays = showScheduleDays;
      this._scheduleStartDay = scheduleStartDay;
      this._scheduleEndDay = scheduleEndDay;
      this._scheduleStartTime = scheduleStartTime;
      this._scheduleEndTime = scheduleEndTime;
      this._scheduleSize = scheduleSize;
      this._scheduleTimeCellStep = scheduleTimeCellStep;
      this._scheduleTimeLabelStep = scheduleTimeLabelStep;
      this._scheduleTimezones = scheduleTimezones;
      this._scheduleMaxEventStack = scheduleMaxEventStack;
      this._scheduleMinEventWidth = scheduleMinEventWidth;
      this._showTimeline = showTimeline;
      this._showTimelineWeekNumbers = showTimelineWeekNumbers;
      this._timelineSize = timelineSize;
      this._timelineType = timelineType;
      this._timelineStartDay = timelineStartDay;
      this._timelineEndDay = timelineEndDay;
      this._timelineListing = timelineListing;
      this._timelineStartTime = timelineStartTime;
      this._timelineEndTime = timelineEndTime;
      this._timelineTimeCellStep = timelineTimeCellStep;
      this._timelineTimeLabelStep = timelineTimeLabelStep;
      this._timelineMaxEventStack = timelineMaxEventStack;
      this._timelineRowHeight = timeline.rowHeight;
      this._timelineResolution = timelineResolution;
      this._timelineResolutionVertical = timelineResolutionVertical;
      this._timelineVirtualScroll = timelineVirtualScroll;
      this._rangeType = showSchedule ? scheduleType : showTimeline ? timelineType : eventListType;
      this._rangeStartDay = showSchedule ? scheduleStartDay : showTimeline ? timelineStartDay : UNDEFINED;
      this._rangeEndDay = showSchedule ? scheduleEndDay : showTimeline ? timelineEndDay : UNDEFINED;
      this._firstWeekDay = showSchedule ? scheduleStartDay : showTimeline ? timelineStartDay : firstDay;
    }
    this._showDate = !this._showScheduleDays && (this._showSchedule && this._scheduleType === "day" || this._showEventList && this._eventListType === "day" && this._eventListSize < 2);
    var lastPageLoad = this._pageLoad;
    if (this._refresh || s.locale !== prevProps.locale || s.theme !== prevProps.theme) {
      renderList = true;
      this._pageLoad++;
    }
    if (s.resources !== prevProps.resources) {
      this._resourcesMap = (s.resources || []).reduce(function (map, res) {
        map[res.id] = res;
        return map;
      }, {});
    }
    if (s.selectMultipleEvents) {
      if (s.selectedEvents !== prevProps.selectedEvents) {
        this._selectedEventsMap = (s.selectedEvents || []).reduce(function (map, ev) {
          if (ev.occurrenceId) {
            map[ev.occurrenceId] = ev;
          } else {
            map[ev.id] = ev;
          }
          return map;
        }, {});
      }
    }
    if (this._selectedEventsMap === UNDEFINED) {
      this._selectedEventsMap = {};
    }
    if (s.refDate !== prevProps.refDate) {
      this._refDate = makeDate(s.refDate);
    }
    if (!this._refDate && !this._showCalendar && (this._showSchedule || this._showTimeline)) {
      this._refDate = getDateOnly(new Date());
    }
    if (selectedDateTime !== this._selectedDateTime) {
      this._viewDate = selectedDateTime;
    }
    if (s.cssClass !== prevProps.cssClass || s.className !== prevProps.className || s.class !== prevProps.class) {
      this._checkSize++;
      this._viewChanged = viewChanged = true;
    }
    if (viewChanged && this._viewDate && selectedDateTime !== this._viewDate) {
      selectedChanged = true;
      selectedDateTime = this._viewDate;
    }
    if (selectedDateTime !== this._selectedDateTime || viewChanged) {
      var validated = this._showCalendar && (this._showSchedule || this._showTimeline || this._showEventList) ? +getClosestValidDate(new Date(selectedDateTime), s, this._minDate, this._maxDate, UNDEFINED, UNDEFINED, 1) : constrain(selectedDateTime, this._minDate, this._maxDate);
      validated = this._getValidDay(validated);
      if (selectedDateTime !== validated || selectedChanged) {
        selectedDateTime = validated;
        setTimeout(function () {
          _this._selectedChange(selectedDateTime);
        });
      }
      if (!this._skipScheduleScroll) {
        this._shouldScrollSchedule++;
      }
      this._selectedDateTime = selectedDateTime;
    }
    var selectedDate = getDateOnly(new Date(selectedDateTime));
    var selected = +selectedDate;
    if (selected !== this._selected || showDate !== this._showDate || s.locale !== prevProps.locale || prevProps.dateFormatLong !== s.dateFormatLong) {
      this._selectedDateHeader = this._showDate ? formatDate(s.dateFormatLong, selectedDate, s) : "";
    }
    if (selected !== this._selected || s.dataTimezone !== prevProps.dataTimezone || s.displayTimezone !== prevProps.displayTimezone) {
      this._shouldAnimateScroll = this._shouldAnimateScroll !== UNDEFINED ? this._shouldAnimateScroll : this._selected !== UNDEFINED;
      this._selected = selected;
      this._selectedDates = {};
      this._selectedDates[+addTimezone(s, new Date(selected))] = true;
      this._active = selected;
      renderList = true;
      selectedChanged = true;
    }
    if (renderList && this._showCalendar && (this._eventListType === "day" || this._scheduleType === "day" || this._timelineType === "day")) {
      this._setEventList(selectedDate, addDays(selectedDate, 1));
    }
    if (this._refresh && state.showPopover) {
      setTimeout(function () {
        _this._hidePopover();
      });
    }
    this._refresh = false;
    this._cssClass = this._className + " mbsc-eventcalendar" + (this._showEventList ? " mbsc-eventcalendar-agenda" : "") + (this._showSchedule ? " mbsc-eventcalendar-schedule" : "") + (this._showTimeline ? " mbsc-eventcalendar-timeline" : "");
    this._navService.options({
      activeDate: this._active,
      calendarType: this._calendarType,
      endDay: this._showSchedule ? this._scheduleEndDay : this._showTimeline ? this._timelineEndDay : this._rangeEndDay,
      eventRange: this._rangeType,
      eventRangeSize: this._showSchedule ? this._scheduleSize : this._showTimeline ? this._timelineSize : this._eventListSize,
      firstDay: s.firstDay,
      getDate: s.getDate,
      getDay: s.getDay,
      getMonth: s.getMonth,
      getYear: s.getYear,
      max: s.max,
      min: s.min,
      onPageChange: this._onPageChange,
      onPageLoading: this._onPageLoading,
      refDate: this._refDate,
      resolution: this._timelineResolution,
      showCalendar: this._showCalendar,
      showOuterDays: this._showOuterDays,
      size: this._calendarSize,
      startDay: this._rangeStartDay,
      weeks: this._calendarSize
    }, this._pageLoad !== lastPageLoad);
    if (selectedChanged) {
      this._shouldScroll = !this._isPageChange && !this._shouldSkipScroll;
    }
  };
  EventcalendarBase.prototype._mounted = function () {
    this._unsubscribe = subscribeExternalDrag(this._onExternalDrag);
    listen(this._el, KEY_DOWN, this._onKeyDown);
  };
  EventcalendarBase.prototype._updated = function () {
    var _this = this;
    if (this._shouldScroll && this.state.eventList && this.state.isListScrollable) {
      ngSetTimeout(this, function () {
        _this._scrollToDay();
        _this._shouldAnimateScroll = UNDEFINED;
      });
      this._shouldScroll = false;
    }
    if (this._shouldLoadDays) {
      this._shouldLoadDays = false;
      forEach(this._list.querySelectorAll("[mbsc-timestamp]"), function (listItem) {
        _this._listDays[listItem.getAttribute("mbsc-timestamp")] = listItem;
      });
    }
    if (this._shouldEnhance) {
      this._shouldEnhance = this._shouldEnhance === "popover" ? this._popoverList : this._list;
    }
    if (this._triggerCreated) {
      var created = this._triggerCreated;
      var target = created.source === "calendar" ? this._calendarView._body.querySelector('.mbsc-calendar-table-active .mbsc-calendar-text[data-id="'.concat(created.event.id, '"]')) : this._el.querySelector('.mbsc-schedule-event[data-id="'.concat(created.event.id, '"]'));
      this._hook("onEventCreated", __assign(__assign({}, this._triggerCreated), {
        target: target
      }));
      this._triggerCreated = null;
    }
    if (this._triggerUpdated) {
      var updated = this._triggerUpdated;
      var target = updated.source === "calendar" ? this._calendarView._body.querySelector('.mbsc-calendar-table-active .mbsc-calendar-text[data-id="'.concat(updated.event.id, '"]')) : this._el.querySelector('.mbsc-schedule-event[data-id="'.concat(updated.event.id, '"]'));
      this._hook("onEventUpdated", __assign(__assign({}, this._triggerUpdated), {
        target: target
      }));
      this._triggerUpdated = null;
    }
    if (this._triggerDeleted) {
      this._hook("onEventDeleted", __assign({}, this._triggerDeleted));
      this._triggerDeleted = null;
    }
    if (this._viewChanged) {
      setTimeout(function () {
        _this._viewChanged = false;
      }, 10);
    }
    if (this._shouldSkipScroll) {
      setTimeout(function () {
        _this._shouldSkipScroll = false;
      });
    }
    if (this._navigateToEvent) {
      setTimeout(function () {
        _this._navigateToEvent = UNDEFINED;
      });
    }
    this._skipScheduleScroll = false;
  };
  EventcalendarBase.prototype._destroy = function () {
    if (this._unsubscribe) {
      unsubscribeExternalDrag(this._unsubscribe);
    }
    unlisten(this._el, KEY_DOWN, this._onKeyDown);
  };
  EventcalendarBase.prototype._resetSelection = function () {
    if (this.s.selectMultipleEvents && Object.keys(this._selectedEventsMap).length > 0) {
      this._selectedEventsMap = {};
      this._onSelectedEventsChange([]);
      this.forceUpdate();
    }
  };
  EventcalendarBase.prototype._getAgendaEvents = function (firstDay, lastDay, eventMap) {
    var _this = this;
    var events = [];
    var s = this.s;
    if (eventMap && this._showEventList) {
      var _loop_1 = function (d) {
        var eventsForDay = eventMap[getDateStr(d)];
        if (eventsForDay && eventsForDay.length) {
          var sorted = sortEvents(eventsForDay, s.eventOrder);
          events.push({
            date: formatDate(s.dateFormatLong, d, s),
            events: sorted.map(function (event) {
              return _this._getEventData(event, d);
            }),
            timestamp: +d
          });
        }
      };
      for (var d = getDateOnly(firstDay); d < lastDay; d.setDate(d.getDate() + 1)) {
        _loop_1(d);
      }
    }
    return events;
  };
  EventcalendarBase.prototype._getEventData = function (event, d, res, fullDates) {
    var s = this.s;
    if (!event.color && event.resource && res === UNDEFINED) {
      res = (this._resourcesMap || {})[isArray(event.resource) ? event.resource[0] : event.resource];
    }
    return getEventData(s, event, d, this._colorEventList, res, true, true, false, false, fullDates);
  };
  EventcalendarBase.prototype._getValidDay = function (timestamp, dir) {
    if (dir === void 0) {
      dir = 1;
    }
    var startDay = this._rangeStartDay;
    var endDay = this._rangeEndDay;
    if (!this._showCalendar && this._rangeType === "day" && startDay !== UNDEFINED && endDay !== UNDEFINED) {
      var date = new Date(timestamp);
      var day = date.getDay();
      var diff = 0;
      if (endDay < startDay ? day > endDay && day < startDay : day > endDay || day < startDay) {
        diff = dir < 0 ? endDay - day : startDay - day;
      }
      if (diff) {
        diff += dir < 0 ? diff > 0 ? -7 : 0 : diff < 0 ? 7 : 0;
        return +addDays(date, diff);
      }
    }
    return timestamp;
  };
  EventcalendarBase.prototype._setEventList = function (firstDay, lastDay) {
    var _this = this;
    setTimeout(function () {
      _this._eventListHTML = UNDEFINED;
      _this._shouldScroll = true;
      _this._listDays = null;
      _this._scrollToDay(0);
      _this.setState({
        eventList: _this._getAgendaEvents(firstDay, lastDay, _this._eventMap)
      });
    });
  };
  EventcalendarBase.prototype._showPopover = function (key, date, list, anchor, context, inst) {
    var _this = this;
    if (!this.state.showPopover || key !== this.state.popoverKey) {
      setTimeout(function () {
        _this._anchor = anchor;
        _this.setState({
          popoverContext: context,
          popoverDate: date,
          popoverHidden: false,
          popoverHost: inst,
          popoverKey: key,
          popoverList: list,
          showPopover: true
        });
      });
    }
  };
  EventcalendarBase.prototype._hidePopover = function () {
    if (this.state.showPopover) {
      this.setState({
        popoverDrag: false,
        showPopover: false
      });
    }
  };
  EventcalendarBase.prototype._scrollToDay = function (pos) {
    var _this = this;
    if (this._list) {
      var to = pos;
      var animate = void 0;
      if (pos === UNDEFINED && this._listDays) {
        var day = this._listDays[this._selected];
        var eventId = this._navigateToEvent && this._navigateToEvent.id;
        if (day) {
          to = day.offsetTop;
          if (eventId !== UNDEFINED) {
            var event_5 = day.querySelector('.mbsc-event[data-id="'.concat(eventId, '"]'));
            var dayHeader = day.querySelector(".mbsc-event-day");
            if (event_5) {
              to = event_5.offsetTop - (dayHeader ? dayHeader.offsetHeight : 0) + 1;
            }
          }
        }
        if (to !== UNDEFINED) {
          animate = this._shouldAnimateScroll;
        }
      }
      if (to !== UNDEFINED) {
        this._isListScrolling++;
        smoothScroll(this._list, UNDEFINED, to, animate, false, function () {
          setTimeout(function () {
            _this._isListScrolling--;
          }, 150);
        });
      }
    }
  };
  EventcalendarBase.prototype._selectedChange = function (d, skipState) {
    var date = new Date(d);
    if (this.s.selectedDate === UNDEFINED && !skipState) {
      this.setState({
        selectedDate: +d
      });
    }
    this._emit("selectedDateChange", date);
    this._hook("onSelectedDateChange", {
      date: date
    });
  };
  EventcalendarBase.prototype._cellClick = function (name, args) {
    this._hook(name, __assign({
      target: args.domEvent.currentTarget
    }, args));
  };
  EventcalendarBase.prototype._dayClick = function (name, args) {
    var d = getDateStr(args.date);
    var events = sortEvents(this._eventMap[d], this.s.eventOrder);
    args.events = events;
    this._hook(name, args);
  };
  EventcalendarBase.prototype._labelClick = function (name, args) {
    if (args.label) {
      this._hook(name, {
        date: args.date,
        domEvent: args.domEvent,
        event: args.label,
        source: "calendar"
      });
    }
  };
  EventcalendarBase.prototype._eventClick = function (name, args) {
    args.date = new Date(args.date);
    return this._hook(name, args);
  };
  EventcalendarBase.prototype._handleMultipleSelect = function (args) {
    var event = args.label || args.event;
    if (event && this.s.selectMultipleEvents) {
      var domEvent = args.domEvent;
      var selectedEvents = !domEvent.shiftKey && !domEvent.ctrlKey && !domEvent.metaKey ? {} : this._selectedEventsMap;
      var eventId = event.occurrenceId || event.id;
      if (selectedEvents[eventId]) {
        delete selectedEvents[eventId];
      } else {
        selectedEvents[eventId] = event;
      }
      this._selectedEventsMap = __assign({}, selectedEvents);
      this._onSelectedEventsChange(toArray(selectedEvents));
      if (this.s.selectedEvents === UNDEFINED) {
        this.forceUpdate();
      }
    }
  };
  EventcalendarBase.defaults = __assign(__assign({}, calendarViewDefaults), {
    actionableEvents: true,
    allDayText: "All-day",
    data: [],
    newEventText: "New event",
    noEventsText: "No events",
    showControls: true,
    showEventTooltip: true,
    view: {
      calendar: {
        type: "month"
      }
    }
  });
  EventcalendarBase._name = "Eventcalendar";
  EventcalendarBase.ɵfac = /* @__PURE__ */(() => {
    let ɵEventcalendarBase_BaseFactory;
    return function EventcalendarBase_Factory(t) {
      return (ɵEventcalendarBase_BaseFactory || (ɵEventcalendarBase_BaseFactory = i0.ɵɵgetInheritedFactory(EventcalendarBase)))(t || EventcalendarBase);
    };
  })();
  EventcalendarBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: EventcalendarBase,
    selectors: [["", "mbsc-ec-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return EventcalendarBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var DEF_ID = "mbsc-def";
function checkCollision(data, start, end, allDay, isTimeline, invalidateEvent, s) {
  var showBuffer = s.showEventBuffer !== false;
  var onlyStartEnd = invalidateEvent === "start-end";
  var until = s.exclusiveEndDates ? end : getDateOnly(addDays(end, 1));
  for (var _i = 0, _a = Object.keys(data); _i < _a.length; _i++) {
    var r = _a[_i];
    var resourceData = data[r];
    for (var d = getDateOnly(start); d < until; d.setDate(d.getDate() + 1)) {
      var dayData = resourceData[getDateStr(d)];
      if (dayData) {
        if ((allDay || isTimeline) && dayData.allDay[0] && (!onlyStartEnd || isSameDay(d, start) || isSameDay(d, end))) {
          return dayData.allDay[0].original;
        }
        if (!allDay) {
          for (var _b = 0, _c = dayData.data; _b < _c.length; _b++) {
            var item = _c[_b];
            var original = item.original;
            var startDate = showBuffer && item.bufferStart ? item.bufferStart : item.startDate;
            var endDate = showBuffer && item.bufferEnd ? item.bufferEnd : item.endDate;
            if (onlyStartEnd) {
              if (checkDateRangeOverlap(startDate, endDate, start, start, true)) {
                return original;
              }
              if (checkDateRangeOverlap(startDate, endDate, end, end)) {
                return original;
              }
            } else if (checkDateRangeOverlap(startDate, endDate, start, end)) {
              return original;
            }
          }
        }
      }
    }
  }
  return false;
}
function getEventLayoutStart(event, s, isListing, isTimeline, isDailyResolution, firstDay, cols, colIndexMap, showBuffer) {
  var eventAllDay = event.allDay || isListing;
  var startDate = showBuffer && event.bufferStart ? event.bufferStart : event.startDate;
  if (isTimeline && isListing && !isDailyResolution) {
    var startCol = colIndexMap[getDateStr(startDate)];
    return startDate < firstDay ? firstDay : cols[startCol + (isInWeek(startDate.getDay(), s.startDay, s.endDay) ? 0 : 1)].date;
  }
  return eventAllDay ? createDate(s, startDate.getFullYear(), startDate.getMonth(), startDate.getDate()) : startDate;
}
function getEventLayoutEnd(event, s, isListing, isTimeline, isDailyResolution, lastDay, cols, colIndexMap, showBuffer) {
  var eventAllDay = event.allDay || isListing;
  var endDate = showBuffer && event.bufferEnd ? event.bufferEnd : event.endDate;
  if (isTimeline && isListing && !isDailyResolution) {
    var endCol = colIndexMap[getDateStr(getEndDate(s, event.allDay, event.startDate, endDate))];
    var endD = endDate >= lastDay || endCol >= cols.length - 1 ? lastDay : cols[endCol + 1].date;
    return getEndDate(s, false, event.startDate, endD);
  }
  var eEnd = eventAllDay ? getEndDate(s, event.allDay, event.startDate, endDate) : endDate;
  return eventAllDay ? createDate(s, eEnd.getFullYear(), eEnd.getMonth(), eEnd.getDate(), 23, 59, 59, 999) : eEnd;
}
function calcLayout(s, groups, event, next, maxEventStack, isListing, isTimeline, isDailyResolution, firstDay, firstDayTz, lastDay, lastDayTz, cols, colIndexMap) {
  var showBuffer = s.showEventBuffer !== false;
  var first = event.allDay ? firstDay : firstDayTz;
  var last = event.allDay ? lastDay : lastDayTz;
  var eventStart = getEventLayoutStart(event, s, isListing, isTimeline, isDailyResolution, first, cols, colIndexMap, showBuffer);
  var eventEnd = getEventLayoutEnd(event, s, isListing, isTimeline, isDailyResolution, last, cols, colIndexMap, showBuffer);
  var pushed = false;
  for (var _i = 0, groups_1 = groups; _i < groups_1.length; _i++) {
    var group = groups_1[_i];
    var i = 0;
    var groupOverlap = false;
    var groupLevel = void 0;
    for (var _a = 0, _b = group.stacks; _a < _b.length; _a++) {
      var level = _b[_a];
      var overlap = false;
      for (var _c = 0, level_1 = level; _c < level_1.length; _c++) {
        var item = level_1[_c];
        var firstD = item.allDay ? firstDay : firstDayTz;
        var lastD = item.allDay ? lastDay : lastDayTz;
        var itemStart = getEventLayoutStart(item, s, isListing, isTimeline, isDailyResolution, firstD, cols, colIndexMap, showBuffer);
        var itemEnd = getEventLayoutEnd(item, s, isListing, isTimeline, isDailyResolution, lastD, cols, colIndexMap, showBuffer);
        if (checkDateRangeOverlap(itemStart, itemEnd, eventStart, eventEnd, true)) {
          overlap = true;
          groupOverlap = true;
          if (groupLevel) {
            next[event.uid] = next[event.uid] || i;
          } else {
            next[item.uid] = i + 1;
          }
        }
      }
      if (!overlap && !groupLevel) {
        groupLevel = level;
      }
      i++;
    }
    if (groupOverlap) {
      if (groupLevel) {
        groupLevel.push(event);
      } else {
        if (maxEventStack === "all" || group.stacks.length < +maxEventStack) {
          group.stacks.push([event]);
        } else {
          event.position = UNDEFINED;
          group.more.push(event);
        }
      }
      pushed = true;
    }
  }
  if (!pushed) {
    next[event.uid] = 0;
    groups.push({
      stacks: [[event]],
      more: []
    });
  }
}
function roundStep(v) {
  v = Math.abs(round(v));
  if (v > 60) {
    return round(v / 60) * 60;
  }
  if (60 % v === 0) {
    return v;
  }
  return [6, 10, 12, 15, 20, 30].reduce(function (a, b) {
    return Math.abs(b - v) < Math.abs(a - v) ? b : a;
  });
}
function calcSchedulerTime(startDate, endDate, startTime, endTime) {
  var start = getDayMilliseconds(startDate);
  var end = getDayMilliseconds(endDate);
  if (startTime > start) {
    start = startTime;
  }
  if (endTime < end) {
    end = endTime;
  }
  return end - start;
}
function calcTimelineTime(startDate, endDate, viewStart, viewEnd, startTime, endTime, startDay, endDay, fullDay) {
  var displayedTime = endTime - startTime + 1;
  var startD = startDate;
  var endD = endDate;
  var until = addDays(getDateOnly(endD), 1);
  if (startD < viewStart) {
    startD = viewStart;
  }
  if (endD > viewEnd) {
    endD = until = viewEnd;
  }
  var start = getDayMilliseconds(startD);
  var end = getDayMilliseconds(endD);
  if (startTime > start) {
    start = startTime;
  }
  if (endTime < end) {
    end = endTime;
  }
  if (!isSameDay(startD, endD)) {
    if (start > endTime) {
      start = endTime;
    }
    if (end < startTime) {
      end = startTime;
    }
  }
  var time = 0;
  if (isSameDay(startD, endD)) {
    time = fullDay ? displayedTime : end - start;
  } else {
    for (var d = getDateOnly(startD); d < until; d.setDate(d.getDate() + 1)) {
      if (isInWeek(d.getDay(), startDay, endDay)) {
        if (!fullDay && isSameDay(d, startD)) {
          time += displayedTime - start + startTime;
        } else if (!fullDay && isSameDay(d, endD)) {
          time += end - startTime;
        } else {
          time += displayedTime;
        }
      }
    }
  }
  return time;
}
function getEventStart(startDate, startTime, displayedTime, viewStart, startDay, endDay) {
  if (viewStart && viewStart > startDate) {
    startDate = viewStart;
  }
  var start = getDayMilliseconds(startDate);
  if (startTime > start || startDay !== UNDEFINED && endDay !== UNDEFINED && !isInWeek(startDate.getDay(), startDay, endDay)) {
    start = startTime;
  }
  return (start - startTime) * 100 / displayedTime;
}
function getResourceMap(eventsMap, resources, slots, hasResources, hasSlots) {
  eventsMap = eventsMap || {};
  var eventKeys = Object.keys(eventsMap);
  var resourceMap = {};
  var resourceIds = resources.map(function (resource) {
    return resource.id;
  });
  var slotIds = slots.map(function (s) {
    return s.id;
  });
  resourceIds.forEach(function (rid) {
    resourceMap[rid] = {};
    slotIds.forEach(function (sid) {
      resourceMap[rid][sid] = {};
    });
  });
  var _loop_1 = function (timestamp) {
    var events = eventsMap[timestamp];
    var _loop_2 = function (event_1) {
      var eventResource = event_1.resource;
      var eventSlot = event_1.slot;
      var res = eventResource === UNDEFINED || !hasResources ? resourceIds : isArray(eventResource) ? eventResource : [eventResource];
      var slot = eventSlot === UNDEFINED || !hasSlots ? slotIds : [eventSlot];
      res.forEach(function (rid) {
        var map = resourceMap[rid];
        if (map) {
          slot.forEach(function (sid) {
            var slotMap = map[sid];
            if (slotMap) {
              if (!slotMap[timestamp]) {
                slotMap[timestamp] = [];
              }
              slotMap[timestamp].push(event_1);
            }
          });
        }
      });
    };
    for (var _a = 0, events_1 = events; _a < events_1.length; _a++) {
      var event_1 = events_1[_a];
      _loop_2(event_1);
    }
  };
  for (var _i = 0, eventKeys_1 = eventKeys; _i < eventKeys_1.length; _i++) {
    var timestamp = eventKeys_1[_i];
    _loop_1(timestamp);
  }
  return resourceMap;
}
function getCellDate(timestamp, ms) {
  var d = new Date(timestamp);
  var time = new Date(+REF_DATE + ms);
  return new Date(d.getFullYear(), d.getMonth(), d.getDate(), time.getHours(), time.getMinutes());
}
var stateObservables$1 = {};
var ScheduleEventBase = /*#__PURE__*/function (_super) {
  __extends(ScheduleEventBase, _super);
  function ScheduleEventBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._onClick = function (ev) {
      _this._triggerClick("onClick", ev);
      var s = _this.s;
      var observable = stateObservables$1[s.event.uid];
      if (observable && s.selected) {
        observable.next({
          hasFocus: false
        });
      }
    };
    _this._onRightClick = function (ev) {
      _this._triggerClick("onRightClick", ev);
    };
    _this._onDocTouch = function (ev) {
      unlisten(_this._doc, TOUCH_START, _this._onDocTouch);
      unlisten(_this._doc, MOUSE_DOWN, _this._onDocTouch);
      _this._isDrag = false;
      _this._hook("onDragModeOff", {
        domEvent: ev,
        event: _this.s.event.original
      });
    };
    _this._updateState = function (args) {
      _this.setState(args);
    };
    return _this;
  }
  ScheduleEventBase.prototype._render = function (s, state) {
    var event = s.event;
    var day = new Date(event.date);
    var pos = event.position;
    var startDate = event.startDate;
    var endDate = getEndDate(s, event.allDay, startDate, event.endDate);
    var isTimeline = s.isTimeline;
    var isTimelineListing = s.isListing;
    var isMore = event.original["more"];
    var isAllDay = isMore && isTimeline || isTimelineListing || event.allDay;
    var isMultiDay = !isSameDay(startDate, endDate);
    var isMultiDayStart = isMultiDay && isSameDay(startDate, day);
    var isMultiDayEnd = isMultiDay && isSameDay(endDate, day);
    var allDayStyle = isAllDay && (!isTimeline || isTimelineListing || isMore);
    var host = isTimeline ? "timeline" : "schedule";
    var gridStartTime = s.gridStartTime;
    var gridEndTime = s.gridEndTime;
    var startTime = getDayMilliseconds(startDate);
    var endTime = getDayMilliseconds(endDate);
    var hasSlots = isTimeline && s.slot !== DEF_ID;
    var isEndInWeek = isInWeek(endDate.getDay(), s.startDay, s.endDay);
    var lastDay = s.singleDay ? addDays(day, 1) : new Date(s.lastDay);
    if (!event.allDay) {
      lastDay = addTimezone(s, lastDay);
    }
    this._isStart = hasSlots || !isMultiDay || isMultiDayStart;
    this._isEnd = hasSlots || !isMultiDay || (isAllDay || isTimeline && !s.hasResY ? endDate < lastDay && isEndInWeek : isMultiDayEnd);
    if (!hasSlots && !isAllDay && (gridStartTime > startTime || gridEndTime < startTime)) {
      this._isStart = false;
    }
    if (!hasSlots && !isAllDay && (gridEndTime < endTime || gridStartTime > endTime)) {
      this._isEnd = false;
    }
    this._isMore = isMore;
    this._isDrag = this._isDrag || s.isDrag;
    this._content = UNDEFINED;
    this._rangeText = event.start + " - " + event.end;
    this._isAllDay = allDayStyle;
    this._host = host;
    if (event.allDay || (!isTimeline || s.hasResY) && isMultiDay && !isMultiDayStart && !isMultiDayEnd) {
      this._rangeText = event.allDayText || " ";
    }
    if (event.bufferBefore) {
      this._bufferStyleStart = isTimeline ? {
        width: event.bufferBefore
      } : {
        height: event.bufferBefore
      };
    }
    if (event.bufferAfter) {
      this._bufferStyleEnd = isTimeline ? {
        width: event.bufferAfter
      } : {
        height: event.bufferAfter
      };
    }
    this._cssClass = "mbsc-schedule-event" + this._theme + this._rtl + (s.render || s.template ? " mbsc-schedule-event-custom" : "") + (isTimeline ? " mbsc-timeline-event" : "") + (isTimelineListing || isMore ? " mbsc-timeline-event-listing" : "") + (this._isStart ? " mbsc-".concat(host, "-event-start") : "") + (this._isEnd ? " mbsc-".concat(host, "-event-end") : "") + (allDayStyle ? " mbsc-schedule-event-all-day" : "") + (hasSlots ? " mbsc-timeline-event-slot" : "") + (state.hasFocus && !s.inactive && !s.selected || s.selected ? " mbsc-schedule-event-active" : "") + (state.hasHover && !s.inactive && !this._isDrag ? " mbsc-schedule-event-hover" : "") + (s.isDrag ? " mbsc-schedule-event-dragging" + (isTimeline ? " mbsc-timeline-event-dragging" : "") : "") + (s.hidden ? " mbsc-schedule-event-hidden" : "") + (s.inactive ? " mbsc-schedule-event-inactive" : "") + (event.original.editable === false ? " mbsc-readonly-event" : "") + (event.original.cssClass ? " " + event.original.cssClass : "");
    this._style = __assign(__assign({}, pos), {
      color: event.color,
      top: s.eventHeight && pos.top !== UNDEFINED ? pos.top * s.eventHeight + "px" : pos.top
    });
    var renderer = s.render || s.renderContent;
    var text;
    if (renderer && !isMore) {
      var content = renderer(event);
      if (isString(content)) {
        text = content;
      } else {
        this._content = content;
      }
    } else if (!s.contentTemplate || isMore) {
      text = event.html;
    }
    if (text !== this._text) {
      this._text = text;
      this._html = text ? this._safeHtml(text) : UNDEFINED;
      this._shouldEnhance = text && !!renderer;
    }
  };
  ScheduleEventBase.prototype._mounted = function () {
    var _this = this;
    var id = this.s.event.uid;
    var el = this._el;
    var resizeDir;
    var observable = stateObservables$1[id];
    var startDomEvent;
    var touchTimer;
    if (!observable) {
      observable = new Observable();
      stateObservables$1[id] = observable;
    }
    this._unsubscribe = observable.subscribe(this._updateState);
    this._doc = getDocument(el);
    this._unlisten = gestureListener(el, {
      keepFocus: true,
      onBlur: function () {
        observable.next({
          hasFocus: false
        });
      },
      onDoubleClick: function (ev) {
        ev.domEvent.stopPropagation();
        _this._triggerClick("onDoubleClick", ev.domEvent);
      },
      onEnd: function (ev) {
        if (_this._isDrag) {
          var s = _this.s;
          var args = __assign({}, ev);
          args.domEvent.preventDefault();
          args.eventData = s.event;
          args.resource = s.resource;
          args.slot = s.slot;
          if (s.resize && resizeDir) {
            args.resize = true;
            args.direction = resizeDir;
          } else if (s.drag) {
            args.drag = true;
          }
          _this._hook("onDragEnd", args);
          if (!s.isDrag) {
            _this._isDrag = false;
          }
          if (el && args.moved) {
            el.blur();
          }
        }
        clearTimeout(touchTimer);
        resizeDir = UNDEFINED;
      },
      onFocus: function () {
        observable.next({
          hasFocus: true
        });
      },
      onHoverIn: function (ev) {
        observable.next({
          hasHover: true
        });
        _this._triggerClick("onHoverIn", ev);
      },
      onHoverOut: function (ev) {
        observable.next({
          hasHover: false
        });
        _this._triggerClick("onHoverOut", ev);
      },
      onKeyDown: function (ev) {
        var event = _this.s.event.original;
        switch (ev.keyCode) {
          case ENTER:
          case SPACE:
            el.click();
            ev.preventDefault();
            break;
          case BACKSPACE:
          case DELETE:
            if (event.editable !== false) {
              _this._hook("onDelete", {
                domEvent: ev,
                event: event,
                resource: _this.s.resource,
                slot: _this.s.slot,
                source: _this._host
              });
            }
            break;
        }
      },
      onMove: function (ev) {
        var s = _this.s;
        var args = __assign({}, ev);
        args.eventData = s.event;
        args.resource = s.resource;
        args.slot = s.slot;
        if (resizeDir) {
          args.resize = true;
          args.direction = resizeDir;
        } else if (s.drag) {
          args.drag = true;
        } else {
          return;
        }
        if (s.event.original.editable === false) {
          return;
        }
        if (_this._isDrag || !args.isTouch) {
          args.domEvent.preventDefault();
        }
        if (_this._isDrag) {
          _this._hook("onDragMove", args);
        } else if (Math.abs(args.deltaX) > 7 || Math.abs(args.deltaY) > 7) {
          clearTimeout(touchTimer);
          if (!args.isTouch) {
            args.domEvent = startDomEvent;
            _this._isDrag = true;
            _this._hook("onDragStart", args);
          }
        }
      },
      onStart: function (ev) {
        startDomEvent = ev.domEvent;
        var s = _this.s;
        var args = __assign({}, ev);
        var target = startDomEvent.target;
        args.eventData = s.event;
        args.resource = s.resource;
        args.slot = s.slot;
        if (s.resize && target.classList.contains("mbsc-schedule-event-resize")) {
          resizeDir = target.classList.contains("mbsc-schedule-event-resize-start") ? "start" : "end";
          args.resize = true;
          args.direction = resizeDir;
        } else if (s.drag) {
          args.drag = true;
        } else {
          return;
        }
        if (s.event.original.editable === false) {
          return;
        }
        if (_this._isDrag) {
          startDomEvent.stopPropagation();
          _this._hook("onDragStart", args);
        } else if (args.isTouch) {
          touchTimer = setTimeout(function () {
            _this._hook("onDragModeOn", args);
            _this._hook("onDragStart", args);
            _this._isDrag = true;
          }, 350);
        }
      }
    });
    if (this._isDrag) {
      listen(this._doc, TOUCH_START, this._onDocTouch);
      listen(this._doc, MOUSE_DOWN, this._onDocTouch);
    }
  };
  ScheduleEventBase.prototype._destroy = function () {
    if (this._el) {
      this._el.blur();
    }
    if (this._unsubscribe) {
      var id = this.s.event.uid;
      var observable = stateObservables$1[id];
      if (observable) {
        observable.unsubscribe(this._unsubscribe);
        if (!observable.nr) {
          delete stateObservables$1[id];
        }
      }
    }
    if (this._unlisten) {
      this._unlisten();
    }
    unlisten(this._doc, TOUCH_START, this._onDocTouch);
    unlisten(this._doc, MOUSE_DOWN, this._onDocTouch);
  };
  ScheduleEventBase.prototype._triggerClick = function (name, domEvent) {
    var s = this.s;
    this._hook(name, {
      date: s.event.date,
      domEvent: domEvent,
      event: s.event.original,
      resource: s.resource,
      slot: s.slot,
      source: this._host
    });
  };
  ScheduleEventBase.ɵfac = /* @__PURE__ */(() => {
    let ɵScheduleEventBase_BaseFactory;
    return function ScheduleEventBase_Factory(t) {
      return (ɵScheduleEventBase_BaseFactory || (ɵScheduleEventBase_BaseFactory = i0.ɵɵgetInheritedFactory(ScheduleEventBase)))(t || ScheduleEventBase);
    };
  })();
  ScheduleEventBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: ScheduleEventBase,
    selectors: [["", "mbsc-sch-ev-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return ScheduleEventBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var STBase = /*#__PURE__*/function (_super) {
  __extends(STBase, _super);
  function STBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._isScrolling = 0;
    _this._onScroll = function () {};
    _this._onMouseLeave = function (ev, force) {
      if (_this._cursorTimeCont && (!_this.state.dragData || force)) {
        _this._cursorTimeCont.style.visibility = "hidden";
        _this._isCursorTimeVisible = false;
      }
    };
    _this._onMouseMove = function (ev) {
      if (_this._showCursorTime) {
        var s = _this.s;
        var rtl = s.rtl;
        var isTimeline = _this._isTimeline;
        var timeCont = _this._cursorTimeCont;
        if (!_this._isTouch || _this._tempStart) {
          if (!_this._isCursorTimeVisible && ev) {
            timeCont.style.visibility = "visible";
            _this._isCursorTimeVisible = true;
          }
        } else {
          timeCont.style.visibility = "hidden";
          _this._isCursorTimeVisible = false;
        }
        if (_this._isCursorTimeVisible && _this._colWidth) {
          var gridCont = _this._gridCont;
          var gridRect = gridCont.getBoundingClientRect();
          var clientX = ev ? ev.clientX : _this._cursorX || 0;
          var clientY = ev ? ev.clientY : _this._cursorY || 0;
          var posX = rtl ? gridRect.right - clientX : clientX - gridRect.left;
          var posY = constrain(clientY - gridRect.top, 8, _this._colHeight);
          var dayIndex = void 0;
          var date = void 0;
          var time = void 0;
          if (_this._dragDelta !== UNDEFINED) {
            date = createDate(s, _this._dragDelta < 0 ? _this._tempStart : _this._tempEnd);
            dayIndex = isTimeline && !_this._hasResY ? _this._dayIndexMap[getDateStr(date)] : 0;
            time = getDayMilliseconds(date);
            time = time === 0 ? _this._dragDelta < 0 ? time : ONE_DAY : time;
          } else {
            dayIndex = isTimeline && !_this._hasResY ? constrain(floor(posX / _this._colWidth), 0, _this._daysNr - 1) : 0;
            time = _this._startTime + step(isTimeline ? floor(_this._time * (posX - dayIndex * _this._colWidth) / _this._colWidth) : floor(_this._time * (posY - 8) / (_this._colHeight - 16)), s.dragTimeStep * ONE_MIN);
            var day = _this._days[dayIndex].date;
            var d = new Date(+REF_DATE + time);
            date = createDate(s, day.getFullYear(), day.getMonth(), day.getDate(), d.getHours(), d.getMinutes());
          }
          var milliSeconds = _this._time * (isTimeline ? _this._daysNr : 1);
          var pos = isTimeline ? rtl ? "right" : "left" : "top";
          var timeContStyle = timeCont.style;
          timeContStyle[pos] = (dayIndex * _this._time + time - _this._startTime) * 100 / milliSeconds + "%";
          timeContStyle[rtl ? "left" : "right"] = "";
          timeCont.textContent = formatDate(s.timeFormat, date, s);
          _this._cursorX = clientX;
          _this._cursorY = clientY;
        }
      }
    };
    _this._onEventClick = function (args) {
      var more = args.event["more"];
      if (more) {
        _this._hook("onMoreClick", {
          context: _this._scrollCont,
          date: args.date,
          key: args.event.id,
          list: more,
          target: args.domEvent.target
        });
      } else {
        _this._hook("onEventClick", args);
      }
    };
    _this._onEventDragModeOn = function (args) {
      if (_this.s.externalDrag && args.drag && !args.create) {
        dragObservable.next(__assign(__assign({}, args), {
          create: true,
          eventName: "onDragModeOn",
          external: true,
          from: _this
        }));
      }
      var event = args.create ? _this._tempEvent : args.eventData;
      var resource = args.create ? _this._tempResource : args.resource;
      var slot = args.create ? _this._tempSlot : args.slot;
      _this.setState({
        dragData: {
          draggedEvent: event,
          originDates: args.external ? UNDEFINED : _this._getDragDates(event, resource, slot),
          resource: resource
        },
        isTouchDrag: true
      });
    };
    _this._onEventDragModeOff = function (args) {
      _this._hook("onEventDragEnd", {
        domEvent: args.domEvent,
        event: args.create ? _this._tempEvent.original : args.event,
        resource: _this._tempResource !== DEF_ID ? _this._tempResource : UNDEFINED,
        slot: _this._tempSlot !== DEF_ID ? _this._tempSlot : UNDEFINED,
        source: _this._isTimeline ? "timeline" : "schedule"
      });
      _this.setState({
        dragData: UNDEFINED,
        isTouchDrag: false
      });
    };
    _this._onEventDragStart = function (args) {
      var s = _this.s;
      var isClick = args.click;
      var isListing = s.eventList;
      var isTimeline = _this._isTimeline;
      var resources = _this._visibleResources;
      var slots = _this._slots;
      var timeStep = s.dragTimeStep;
      var startX = args.startX;
      var startY = args.startY;
      _this._isTouch = args.isTouch;
      _this._scrollY = 0;
      _this._scrollX = 0;
      _this._calcGridSizes();
      var posX = s.rtl ? _this._gridRight - startX : startX - _this._gridLeft;
      var posY = constrain(startY - _this._gridTop, 8, _this._colHeight - 9);
      var cols = isListing ? _this._cols : _this._days;
      var colsNr = cols.length;
      var colWidth = _this._colWidth;
      var colIndex = colWidth ? floor(posX / colWidth) : 1;
      var resourceTops = _this._resourceTops;
      var scrollContTop = _this._scrollCont.scrollTop;
      var resourceIndex = 0;
      var dayIndex = colIndex;
      var slotIndex = 0;
      if (s.externalDrag && args.drag && !args.create) {
        var eventEl = closest(args.domEvent.target, ".mbsc-schedule-event", _this._el);
        var clone = eventEl.cloneNode(true);
        var cloneClass = clone.classList;
        clone.style.display = "none";
        cloneClass.add("mbsc-drag-clone", "mbsc-schedule-drag-clone", "mbsc-font");
        cloneClass.remove("mbsc-schedule-event-hover");
        _this._clone = clone;
        _this._body = getDocument(_this._el).body;
        _this._body.appendChild(clone);
        _this._eventDropped = false;
        dragObservable.next(__assign(__assign({}, args), {
          create: true,
          dragData: args.eventData.original,
          eventName: "onDragStart",
          external: true,
          from: _this
        }));
      }
      if (!isTimeline) {
        var groupByResource = _this._groupByResource;
        var groupCount = groupByResource ? colsNr : _this._hasSlots ? _this._slots.length : resources.length;
        resourceIndex = groupByResource ? floor(colIndex / groupCount) : colIndex % groupCount;
        dayIndex = groupByResource ? colIndex % groupCount : floor(colIndex / groupCount);
      } else {
        slotIndex = colWidth ? floor(posX / (colWidth / slots.length)) % slots.length : 0;
        if (_this._hasResY) {
          cols.forEach(function (d, i) {
            resources.forEach(function (r, j) {
              if (posY > resourceTops[d.dateKey + "-" + r.id]) {
                dayIndex = i;
                resourceIndex = j;
              }
            });
          });
        } else {
          resources.forEach(function (r, i) {
            if (posY > resourceTops[r.id]) {
              resourceIndex = i;
            }
          });
          var fixedY = posY - scrollContTop + _this.state.headerHeight;
          if (scrollContTop && fixedY < _this._fixedHeight && posY - scrollContTop > 0) {
            for (var _i = 0, _a = _this._fixedResources; _i < _a.length; _i++) {
              var r = _a[_i];
              if (fixedY > _this._fixedResourceTops[r.key]) {
                resourceIndex = r.index;
              }
            }
          }
        }
        _this._startSlotIndex = slotIndex;
      }
      var resource = args.external ? UNDEFINED : resources[resourceIndex];
      var resourceId = resource ? resource.id : UNDEFINED;
      var slot = args.external ? UNDEFINED : slots[slotIndex];
      var slotId = slot ? slot.id : UNDEFINED;
      if (resource && resource.eventCreation === false) {
        return false;
      }
      if (args.create) {
        dayIndex = constrain(dayIndex, 0, colsNr - 1);
        var allDay = !isTimeline && s.showAllDay && args.endY < _this._gridContTop;
        var eventDay = s.type === "day" && s.size === 1 ? _this._firstDay : cols[dayIndex].date;
        var eventLength = !isListing && (args.external || isClick) ? _this._stepCell : timeStep * ONE_MIN;
        var gridTime = _this._getGridTime(eventDay, posX, posY, dayIndex, isClick ? _this._stepCell / ONE_MIN : timeStep);
        var newStart = !_this._isDailyResolution || allDay || isListing ? allDay ? eventDay : addTimezone(s, eventDay) : gridTime;
        var nextDay = s.resolution === "year" ? addMonths(newStart, 12, s) : s.resolution === "quarter" ? addMonths(newStart, 3, s) : s.resolution === "month" ? addMonths(newStart, 1, s) : s.resolution === "week" ? addDays(newStart, s.endDay - s.startDay + 1 + (s.endDay < s.startDay ? 7 : 0)) : addDays(newStart, 1);
        var allDayEnd = s.exclusiveEndDates ? nextDay : new Date(+nextDay - 1);
        var newEnd = allDay || isListing ? allDayEnd : roundTime(createDate(s, +newStart + eventLength), isClick ? 1 : timeStep);
        var eventData = s.extendDefaultEvent ? s.extendDefaultEvent({
          resource: resourceId,
          slot: slotId,
          start: newStart
        }) : UNDEFINED;
        var newEvent = __assign(__assign({
          allDay: allDay,
          end: newEnd,
          id: getEventId(),
          resource: resource && resourceId !== DEF_ID ? resourceId : UNDEFINED,
          slot: slot && slotId !== DEF_ID ? slotId : UNDEFINED,
          start: newStart,
          title: s.newEventText
        }, eventData), args.dragData);
        var ev = _this._getEventData(newEvent, eventDay, resource);
        if (isTimeline && resourceId !== UNDEFINED && _this._setRowHeight) {
          ev.position.top = constrain(floor((posY - (_this._fixedResourceTops[resourceId] ? scrollContTop : 0) - resourceTops[resourceId]) / _this._eventHeight), 0, _this._eventRows[resourceId] - 1);
        }
        if (args.dragData) {
          var eventDuration = +ev.endDate - +ev.startDate;
          if (computeEventDragInTime(args.dragData.dragInTime, UNDEFINED, s.dragInTime)) {
            ev.startDate = eventDay;
            ev.endDate = new Date(+eventDay + eventDuration);
          }
        }
        _this._tempEvent = ev;
        _this._tempResource = resourceId;
        _this._tempSlot = slotId;
      }
      _this._hook("onPopoverClose", {
        source: "dragStart"
      });
      if (!isClick) {
        _this._hook("onEventDragStart", {
          action: args.create ? "create" : args.resize ? "resize" : "move",
          domEvent: args.domEvent,
          event: (args.create ? _this._tempEvent : args.eventData).original,
          resource: resourceId !== DEF_ID ? resourceId : UNDEFINED,
          slot: slotId !== DEF_ID ? slotId : UNDEFINED,
          source: isTimeline ? "timeline" : "schedule"
        });
      }
      return true;
    };
    _this._onEventDragMove = function (args) {
      clearTimeout(_this._scrollTimer);
      var s = _this.s;
      var rtl = s.rtl;
      var rtlNr = rtl ? -1 : 1;
      var isTimeline = _this._isTimeline;
      var isListing = s.eventList;
      var isMonthYearResolution = s.resolution === "month" || s.resolution === "year";
      var cols = isListing ? _this._cols : _this._days;
      var colWidth = _this._colWidth;
      var colsNr = cols.length;
      var slots = _this._slots;
      var groupByResource = _this._groupByResource;
      var resources = _this._visibleResources;
      var dragData = _this.state.dragData;
      var timeStep = s.dragTimeStep;
      var timeFormat = s.timeFormat;
      var startX = args.startX;
      var endX = constrain(args.endX, _this._gridContLeft, _this._gridContRight - 1);
      var endY = constrain(args.endY, _this._gridContTop, _this._gridContBottom - 1);
      var deltaY = endY - args.startY + _this._scrollY;
      var deltaX = rtl ? startX - endX + _this._scrollX : endX - startX + _this._scrollX;
      var delta = isTimeline ? deltaX : deltaY;
      var daySize = isTimeline ? colWidth : _this._colHeight - 16;
      var gridWidth = _this._gridRight - _this._gridLeft - 1;
      var startPosY = constrain(args.startY - _this._gridTop, 8, _this._colHeight - 9);
      var posX = constrain(rtl ? _this._gridRight + _this._scrollX - endX : endX - _this._gridLeft + _this._scrollX, 0, gridWidth);
      var posY = constrain(endY - _this._gridTop + _this._scrollY, 8, _this._colHeight - 9);
      var oldIndex = floor((rtl ? _this._gridRight - startX : startX - _this._gridLeft) / colWidth);
      var newIndex = floor(posX / colWidth);
      var inAllDay = s.showAllDay && args.endY < _this._gridContTop;
      var resourceTops = _this._resourceTops;
      var hasResY = _this._hasResY;
      var scrollCont = _this._scrollCont;
      var scrollContTop = scrollCont.scrollTop;
      var event = args.create ? _this._tempEvent : args.eventData;
      var origEvent = event.original;
      var draggedEvent = __assign({}, event);
      var oldDayIndex = oldIndex;
      var newDayIndex = newIndex;
      var resourceIndex = 0;
      var slotIndex = 0;
      var hasScroll = false;
      var distBottom = _this._gridContBottom - args.endY;
      var distTop = args.endY - _this._gridContTop;
      var distLeft = args.endX - _this._gridContLeft;
      var distRight = _this._gridContRight - args.endX;
      var maxScrollH = (scrollCont.scrollWidth - scrollCont.clientWidth) * rtlNr;
      var rightLimit = rtl ? 0 : maxScrollH;
      var leftLimit = rtl ? maxScrollH : 0;
      if (s.externalDrag && args.drag && !args.create) {
        dragObservable.next(__assign(__assign({}, args), {
          clone: _this._clone,
          create: true,
          dragData: origEvent,
          eventName: "onDragMove",
          external: true,
          from: _this
        }));
        if (!_this._onCalendar) {
          moveClone(args, _this._clone);
          if (!dragData) {
            _this.setState({
              dragData: {
                draggedEvent: draggedEvent
              }
            });
          }
          return;
        }
      }
      if (distBottom < 30 && scrollContTop < scrollCont.scrollHeight - scrollCont.clientHeight) {
        scrollCont.scrollTop += 5;
        _this._scrollY += 5;
        hasScroll = true;
      }
      if (distTop < 30 && !inAllDay && scrollContTop > 0) {
        scrollCont.scrollTop -= 5;
        _this._scrollY -= 5;
        hasScroll = true;
      }
      if (distLeft < 30 && scrollCont.scrollLeft > leftLimit) {
        scrollCont.scrollLeft -= 5;
        _this._scrollX -= 5 * rtlNr;
        hasScroll = true;
      }
      if (distRight < 30 && scrollCont.scrollLeft < rightLimit) {
        scrollCont.scrollLeft += 5;
        _this._scrollX += 5 * rtlNr;
        hasScroll = true;
      }
      if (hasScroll) {
        _this._scrollTimer = setTimeout(function () {
          _this._onEventDragMove(args);
        }, 20);
      }
      if (!isTimeline) {
        var groupCount = groupByResource ? colsNr : _this._resources.length;
        oldDayIndex = groupByResource ? oldIndex % groupCount : floor(oldIndex / groupCount);
        newDayIndex = groupByResource ? newIndex % groupCount : floor(newIndex / groupCount);
        resourceIndex = groupByResource ? floor(newIndex / groupCount) : newIndex % groupCount;
      } else {
        slotIndex = floor(posX / (colWidth / slots.length)) % slots.length;
        if (hasResY) {
          cols.forEach(function (d, i) {
            resources.forEach(function (r, j) {
              if (startPosY > resourceTops[d.dateKey + "-" + r.id]) {
                oldDayIndex = i;
              }
              if (posY > resourceTops[d.dateKey + "-" + r.id]) {
                newDayIndex = i;
                resourceIndex = j;
              }
            });
          });
        } else {
          resources.forEach(function (r, i) {
            if (posY > resourceTops[r.id]) {
              resourceIndex = i;
            }
          });
          var fixedY = posY - scrollContTop + _this.state.headerHeight;
          if (scrollContTop && fixedY < _this._fixedHeight && posY - scrollContTop > 0) {
            for (var _i = 0, _a = _this._fixedResources; _i < _a.length; _i++) {
              var r = _a[_i];
              if (fixedY > _this._fixedResourceTops[r.key]) {
                resourceIndex = r.index;
              }
            }
          }
        }
      }
      oldDayIndex = constrain(oldDayIndex, 0, colsNr - 1);
      newDayIndex = constrain(newDayIndex, 0, colsNr - 1);
      var start = event.startDate;
      var end = event.endDate;
      var duration = +end - +start;
      var ms = _this._time;
      var timeDelta = floor(ms * delta / daySize);
      var resource = resources[resourceIndex];
      var startResource = args.create ? _this._tempResource : args.resource;
      var startSlot = args.create ? _this._tempSlot : args.slot;
      if (resource.eventCreation === false && _this._tempResource === UNDEFINED) {
        return false;
      }
      var slotId = slots[slotIndex].id;
      var resourceId = resource.eventCreation !== false ? resource.id : _this._tempResource;
      var allDay = event.allDay;
      var tzOpt = allDay ? UNDEFINED : s;
      var addDayOnly = allDay || isListing;
      var newStart = start;
      var newEnd = end;
      var newDate;
      var isEventDraggableBetweenResources = true;
      var isEventDraggableBetweenSlots = true;
      var isEventDraggableInTime = true;
      var oldDay = cols[oldDayIndex].date;
      var newDay = cols[newDayIndex].date;
      var dayDelta = s.type === "day" && s.size === 1 ? 0 : getDayDiff(oldDay, newDay);
      var colDelta = newDayIndex - oldDayIndex;
      var months = s.resolution === "year" ? 12 : 1;
      var deltaDiff = dayDelta - colDelta;
      if (args.drag && !args.create || args.external) {
        if (!args.external) {
          isEventDraggableBetweenResources = computeEventDragBetweenResources(origEvent.dragBetweenResources, _this._resourcesMap[startResource].eventDragBetweenResources, s.dragBetweenResources);
          isEventDraggableBetweenSlots = computeEventDragBetweenSlots(origEvent.dragBetweenSlots, _this._resourcesMap[startResource].eventDragBetweenSlots, slots[_this._startSlotIndex || 0].eventDragBetweenSlots, s.dragBetweenSlots);
        }
        isEventDraggableInTime = computeEventDragInTime(origEvent.dragInTime, args.external || _this._resourcesMap[startResource].eventDragInTime, s.dragInTime);
      }
      if (args.drag || args.external) {
        if (!isTimeline && !isEventDraggableBetweenResources && startResource !== resourceId) {
          dayDelta = _this._dragDayDelta;
        }
        if (isTimeline && isListing && isMonthYearResolution) {
          newStart = addMonths(start, colDelta * months, s);
          newEnd = addMonths(end, colDelta * months, s);
        } else {
          allDay = inAllDay || isTimeline && event.allDay;
          addDayOnly = allDay || isListing;
          tzOpt = allDay ? UNDEFINED : s;
          if (!isTimeline && !inAllDay && (event.allDay || args.external) || isTimeline && args.external && !event.allDay && !isListing) {
            var day = getDateOnly(addDays(start, dayDelta));
            newStart = _this._getGridTime(day, posX, posY, newDayIndex, timeStep);
          } else {
            if (isTimeline && !addDayOnly && !hasResY) {
              newStart = roundTime(createDate(s, +start + timeDelta + (ONE_DAY - ms) * dayDelta + ms * deltaDiff), timeStep);
            } else {
              newDate = addDays(start, dayDelta);
              newStart = addDayOnly ? newDate : roundTime(createDate(tzOpt, +newDate + timeDelta), timeStep);
            }
          }
          if (resource.eventCreation === false && !isTimeline) {
            newStart = createDate(s, _this._tempStart);
          }
          newEnd = createDate(tzOpt, +newStart + duration);
        }
      } else {
        var gridDelta = isTimeline ? colDelta : newIndex - oldIndex;
        var endResize = args.create ? gridDelta ? gridDelta > 0 : delta > 0 : args.direction === "end";
        var days = getDayDiff(start, end);
        if (!isTimeline && groupByResource && startResource !== resourceId) {
          dayDelta = _this._dragDayDelta;
        }
        if (endResize) {
          if (isTimeline && isListing && isMonthYearResolution) {
            newEnd = addMonths(end, colDelta * months, s);
          } else if (isTimeline && !addDayOnly && !hasResY) {
            newEnd = roundTime(createDate(s, +end + timeDelta + dayDelta * (ONE_DAY - ms) + ms * deltaDiff), timeStep);
          } else {
            newDate = addDays(end, Math.max(-days, dayDelta));
            newEnd = addDayOnly ? newDate : roundTime(createDate(tzOpt, +newDate + timeDelta), timeStep);
            if (!addDayOnly && (getDayMilliseconds(newEnd) > _this._endTime + 1 || newEnd >= addDays(getDateOnly(newDate), 1))) {
              newEnd = createDate(s, +getDateOnly(newDate) + _this._endTime + 1);
            }
          }
        } else {
          if (isTimeline && isListing && isMonthYearResolution) {
            newStart = addMonths(start, colDelta * months, s);
          } else if (isTimeline && !addDayOnly && !hasResY) {
            newStart = roundTime(createDate(s, +start + timeDelta + dayDelta * (ONE_DAY - ms) + ms * deltaDiff), timeStep);
          } else {
            newDate = addDays(start, Math.min(days, dayDelta));
            newStart = addDayOnly ? newDate : roundTime(createDate(tzOpt, +newDate + timeDelta), timeStep);
            if (!addDayOnly && (getDayMilliseconds(newStart) < _this._startTime || newStart < getDateOnly(newDate))) {
              newStart = createDate(s, +getDateOnly(newDate) + _this._startTime);
            }
          }
        }
        resourceId = startResource;
        if (addDayOnly && newEnd < newStart) {
          if (endResize) {
            newEnd = createDate(s, newStart);
          } else {
            newStart = createDate(s, newEnd);
          }
        }
        if (!addDayOnly && (newEnd < newStart || Math.abs(+newEnd - +newStart) < timeStep * ONE_MIN)) {
          if (endResize) {
            newEnd = createDate(s, +newStart + timeStep * ONE_MIN);
          } else {
            newStart = createDate(s, +newEnd - timeStep * ONE_MIN);
          }
        }
      }
      if (args.drag || args.external) {
        if (!isEventDraggableInTime) {
          newStart = start;
          newEnd = end;
          allDay = _this._tempAllDay;
        }
        if (!isEventDraggableBetweenResources) {
          resourceId = startResource;
        }
        if (!isEventDraggableBetweenSlots) {
          slotId = startSlot;
        }
      }
      if (_this._tempStart !== +newStart || _this._tempEnd !== +newEnd || _this._tempAllDay !== allDay || _this._tempResource !== resourceId || _this._tempSlot !== slotId) {
        var startStr = void 0;
        var endStr = void 0;
        if (!_this._isDailyResolution) {
          startStr = formatDate(s.dateFormat, newStart, s);
          endStr = formatDate(s.dateFormat, getEndDate(s, allDay, newStart, newEnd), s);
        } else {
          startStr = formatDate(timeFormat, newStart, s);
          endStr = formatDate(timeFormat, newEnd, s);
        }
        draggedEvent.startDate = newStart;
        draggedEvent.endDate = newEnd;
        draggedEvent.start = startStr;
        draggedEvent.end = endStr;
        draggedEvent.allDay = allDay;
        draggedEvent.date = +newDay;
        if (origEvent.bufferAfter) {
          draggedEvent.bufferEnd = makeDate(+newEnd + origEvent.bufferAfter * 6e4, tzOpt);
        }
        if (origEvent.bufferBefore) {
          draggedEvent.bufferStart = makeDate(+newStart - origEvent.bufferBefore * 6e4, tzOpt);
        }
        _this._tempStart = +newStart;
        _this._tempEnd = +newEnd;
        _this._tempAllDay = allDay;
        _this._tempResource = resourceId;
        _this._tempSlot = slotId;
        _this._dragDelta = args.drag || args.external ? -1 : args.direction ? args.direction === "end" ? 1 : -1 : delta;
        _this._dragDayDelta = dayDelta;
        if (!allDay) {
          _this._onMouseMove(args.domEvent);
        }
        _this.setState({
          dragData: {
            draggedDates: _this._getDragDates(draggedEvent, resourceId, slotId),
            draggedEvent: draggedEvent,
            originDate: event.date,
            originDates: dragData && dragData.originDates,
            originResource: args.external ? UNDEFINED : startResource,
            resource: resourceId,
            slot: slotId
          }
        });
      }
      return true;
    };
    _this._onEventDragEnd = function (args) {
      clearTimeout(_this._scrollTimer);
      var s = _this.s;
      var isCreating = args.create;
      var state = _this.state;
      var dragData = state.dragData;
      var eventLeft = false;
      if (s.externalDrag && args.drag && !args.create) {
        dragObservable.next(__assign(__assign({}, args), {
          action: "externalDrop",
          create: true,
          dragData: args.eventData.original,
          eventName: "onDragEnd",
          external: true,
          from: _this
        }));
        _this._body.removeChild(_this._clone);
        if (!_this._onCalendar) {
          eventLeft = true;
          if (_this._eventDropped) {
            args.event = args.eventData.original;
            s.onEventDelete(args);
          }
        }
      }
      if (isCreating && !dragData) {
        dragData = {};
        dragData.draggedEvent = _this._tempEvent;
      }
      if (dragData && dragData.draggedEvent) {
        var showBuffer = s.showEventBuffer !== false;
        var event_1 = args.eventData;
        var draggedEvent_1 = dragData.draggedEvent;
        var origEvent = draggedEvent_1.original;
        var newStart = draggedEvent_1.startDate;
        var newEnd = draggedEvent_1.endDate;
        var newBufferStart = showBuffer && draggedEvent_1.bufferStart || newStart;
        var newBufferEnd = showBuffer && draggedEvent_1.bufferEnd || newEnd;
        var allDay = draggedEvent_1.allDay;
        var oldResource = isCreating && !args.external ? _this._tempResource : args.resource;
        var newResource = dragData.resource === UNDEFINED ? oldResource : dragData.resource;
        var eventResource = origEvent.resource === UNDEFINED ? newResource : origEvent.resource;
        var oldSlot = isCreating ? _this._tempSlot : args.slot;
        var newSlot = dragData.slot === UNDEFINED ? oldSlot : dragData.slot;
        var invalids = {};
        var events = {};
        var isTimeline = _this._isTimeline;
        var source = isTimeline ? "timeline" : "schedule";
        var changed = isCreating || +newStart !== +event_1.startDate || +newEnd !== +event_1.endDate || allDay !== event_1.allDay || oldResource !== newResource || oldSlot !== newSlot;
        var updatedResource = eventResource;
        var collisionResources = void 0;
        if (oldResource !== newResource && (!isCreating || args.external) && !_this._isSingleResource) {
          if (isArray(eventResource) && eventResource.length && newResource !== UNDEFINED) {
            var indx = eventResource.indexOf(oldResource);
            if (eventResource.indexOf(newResource) === -1) {
              updatedResource = __spreadArray([], eventResource, true);
              updatedResource.splice(indx, 1, newResource);
            }
          } else {
            updatedResource = newResource;
          }
        }
        if (!updatedResource || !s.resources) {
          collisionResources = _this._resources.map(function (r) {
            return r.id;
          });
        } else {
          collisionResources = isArray(updatedResource) ? updatedResource : [updatedResource];
        }
        var newRes = _this._resourcesMap[newResource];
        var allowOverlap_1 = origEvent.overlap !== false && newRes.eventOverlap !== false && s.eventOverlap !== false;
        for (var _i = 0, collisionResources_1 = collisionResources; _i < collisionResources_1.length; _i++) {
          var r = collisionResources_1[_i];
          if (_this._invalids[r]) {
            invalids[r] = _this._invalids[r][newSlot];
          }
          if (_this._events[r]) {
            var possibleOverlaps = {};
            var eventsForResource = _this._events[r][newSlot];
            for (var _a = 0, _b = Object.keys(eventsForResource); _a < _b.length; _a++) {
              var dateKey = _b[_a];
              var eventsForDay = eventsForResource[dateKey];
              possibleOverlaps[dateKey] = {
                allDay: eventsForDay.allDay.filter(function (e) {
                  return e.id !== draggedEvent_1.id && (!allowOverlap_1 || e.original.overlap === false);
                }),
                data: eventsForDay.data.filter(function (e) {
                  return e.id !== draggedEvent_1.id && (!allowOverlap_1 || e.original.overlap === false);
                })
              };
            }
            events[r] = possibleOverlaps;
          }
        }
        var action = args.action || (state.dragData ? "drag" : "click");
        var allowUpdate = !eventLeft && (changed ? s.eventDragEnd({
          action: action,
          collision: checkCollision(invalids, newBufferStart, newBufferEnd, allDay, isTimeline, s.invalidateEvent, s),
          create: isCreating,
          domEvent: args.domEvent,
          event: draggedEvent_1,
          external: args.external,
          from: args.from,
          newResource: newResource,
          newSlot: newSlot,
          oldResource: oldResource,
          oldSlot: oldSlot,
          overlap: checkCollision(events, newBufferStart, newBufferEnd, allDay, isTimeline, "strict", s),
          resource: updatedResource !== DEF_ID ? updatedResource : UNDEFINED,
          slot: newSlot !== DEF_ID ? newSlot : UNDEFINED,
          source: source
        }) : true);
        var keepDragMode = state.isTouchDrag && !eventLeft && (!isCreating || allowUpdate);
        if (allowUpdate && keepDragMode && oldResource !== newResource && !origEvent.color) {
          var resColor = newRes && newRes.color;
          if (resColor) {
            draggedEvent_1.color = resColor;
            draggedEvent_1.style.background = resColor;
            draggedEvent_1.style.color = getTextColor(resColor);
          } else {
            draggedEvent_1.color = UNDEFINED;
            draggedEvent_1.style = {};
          }
        }
        if (!keepDragMode && action !== "click") {
          _this._hook("onEventDragEnd", {
            domEvent: args.domEvent,
            event: (isCreating ? _this._tempEvent : event_1).original,
            resource: newResource !== DEF_ID ? newResource : UNDEFINED,
            slot: newSlot !== DEF_ID ? newSlot : UNDEFINED,
            source: source
          });
        }
        _this.setState({
          dragData: keepDragMode ? {
            draggedEvent: allowUpdate ? draggedEvent_1 : __assign({}, event_1),
            originDate: allowUpdate ? draggedEvent_1.date : event_1.date,
            originDates: allowUpdate ? _this._getDragDates(draggedEvent_1, newResource, newSlot) : dragData.originDates,
            originResource: allowUpdate ? newResource : dragData.originResource
          } : UNDEFINED,
          isTouchDrag: keepDragMode
        });
        _this._tempStart = 0;
        _this._tempEnd = 0;
        _this._tempAllDay = UNDEFINED;
        _this._dragDelta = UNDEFINED;
        _this._onMouseMove(args.domEvent);
        _this._isTouch = false;
      }
    };
    _this._onExternalDrag = function (args) {
      var s = _this.s;
      var clone = args.clone;
      var isSelf = args.from === _this;
      var externalDrop = !isSelf && s.externalDrop;
      var instantDrag = isSelf && s.externalDrag && !s.dragToMove;
      var dragData = _this.state.dragData;
      if (externalDrop || s.externalDrag) {
        var isInArea = !instantDrag && args.endY < _this._gridContBottom && args.endY > _this._allDayTop && args.endX > _this._gridContLeft && args.endX < _this._gridContRight;
        switch (args.eventName) {
          case "onDragModeOff":
            if (externalDrop) {
              _this._onEventDragModeOff(args);
            }
            break;
          case "onDragModeOn":
            if (externalDrop) {
              _this._onEventDragModeOn(args);
            }
            break;
          case "onDragStart":
            if (externalDrop) {
              _this._onEventDragStart(args);
            } else if (isSelf) {
              _this._onCalendar = true;
            }
            break;
          case "onDragMove":
            if (!isSelf && !externalDrop) {
              return;
            }
            if (isInArea) {
              if (!_this._onCalendar) {
                _this._hook("onEventDragEnter", {
                  domEvent: args.domEvent,
                  event: args.dragData,
                  source: _this._isTimeline ? "timeline" : "schedule"
                });
              }
              if (isSelf || externalDrop && _this._onEventDragMove(args) !== false) {
                clone.style.display = "none";
              }
              _this._onCalendar = true;
            } else {
              if (_this._onCalendar) {
                _this._hook("onEventDragLeave", {
                  domEvent: args.domEvent,
                  event: args.dragData,
                  source: _this._isTimeline ? "timeline" : "schedule"
                });
                clearTimeout(_this._scrollTimer);
                clone.style.display = "table";
                if (!isSelf || dragData) {
                  _this.setState({
                    dragData: {
                      draggedDates: {},
                      draggedEvent: isSelf ? dragData && dragData.draggedEvent : UNDEFINED,
                      originDates: isSelf ? dragData && dragData.originDates : UNDEFINED
                    }
                  });
                }
                _this._tempStart = 0;
                _this._tempEnd = 0;
                _this._tempAllDay = UNDEFINED;
                _this._tempResource = UNDEFINED;
                _this._dragDelta = UNDEFINED;
                _this._onCalendar = false;
                _this._onMouseLeave(UNDEFINED, true);
              }
            }
            break;
          case "onDragEnd":
            if (externalDrop) {
              if (isInArea && _this._tempResource !== UNDEFINED) {
                _this._onEventDragEnd(args);
              } else {
                _this.setState({
                  dragData: UNDEFINED,
                  isTouchDrag: false
                });
                _this._hook("onEventDragEnd", {
                  domEvent: args.domEvent,
                  event: args.dragData,
                  resource: args.resource,
                  slot: args.slot,
                  source: args.source
                });
              }
            }
            break;
        }
      }
    };
    return _this;
  }
  STBase.prototype._isToday = function (d) {
    return isSameDay(new Date(d), createDate(this.s));
  };
  STBase.prototype._formatTime = function (v, timezone) {
    var s = this.s;
    var format = s.timeFormat;
    var timeFormat = /a/i.test(format) && this._stepLabel === ONE_HOUR && v % ONE_HOUR === 0 ? format.replace(/.[m]+/i, "") : format;
    var d = new Date(+REF_DATE + v);
    var dd = createDate(s, d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes());
    if (isMBSCDate(dd) && timezone) {
      dd.setTimezone(timezone);
    }
    return formatDate(timeFormat, dd, s);
  };
  STBase.prototype._getEventPos = function (event, day, dateKey, displayedMap) {
    var s = this.s;
    var tzOpt = event.allDay ? UNDEFINED : s;
    var d = createDate(tzOpt, day.getFullYear(), day.getMonth(), day.getDate());
    var nextDay = getDateOnly(addDays(d, 1));
    var firstDay = tzOpt ? this._firstDayTz : this._firstDay;
    var lastDay = tzOpt ? this._lastDayTz : this._lastDay;
    var isTimeline = this._isTimeline;
    var groupByDate = !isTimeline && !this._groupByResource;
    var isAllDay = event.allDay;
    var origEvent = event.original;
    var startTime = this._startTime;
    var endTime = this._endTime + 1;
    var displayedTime = this._time;
    var hasSlots = this._hasSlots;
    var hasResY = this._hasResY;
    var isDailyResolution = this._isDailyResolution;
    var isListing = s.eventList;
    var bufferAfter = "";
    var bufferBefore = "";
    var bufferStart = event.bufferStart;
    var bufferEnd = event.bufferEnd;
    var dayIndex = hasResY ? 0 : this._dayIndexMap[dateKey];
    var start = event.start;
    var end = event.end;
    var startDate = getEventLayoutStart(event, s, isListing, isTimeline, isDailyResolution, firstDay, this._cols, this._colIndexMap);
    var endDate = getEventLayoutEnd(event, s, isListing, isTimeline, isDailyResolution, lastDay, this._cols, this._colIndexMap);
    var adjust = +startDate === +endDate ? 1 : 0;
    var showBuffer = s.showEventBuffer !== false && !isListing && !isAllDay;
    if (!(isAllDay || isTimeline) || hasResY && !hasSlots) {
      if (startDate < d) {
        start = "";
        startDate = createDate(s, d);
      }
      if (endDate >= nextDay) {
        end = "";
        endDate = createDate(s, +nextDay - 1);
      }
      if (endDate >= nextDay) {
        endDate = createDate(s, +nextDay - 1);
      }
    }
    if (isAllDay || isTimeline) {
      if (!displayedMap.get(origEvent) || hasSlots || hasResY || groupByDate) {
        var startDay = s.startDay;
        var endDay = s.endDay;
        var isFullDay = isAllDay || isListing;
        var isMultiDay = !isSameDay(startDate, endDate);
        var daysNr = this._daysNr;
        if (isTimeline && isMultiDay && getDayMilliseconds(startDate) >= endTime) {
          startDate = createDate(s, +getDateOnly(startDate) + endTime);
        }
        var eventTime = calcTimelineTime(startDate, endDate, firstDay, lastDay, startTime, endTime, startDay, endDay, isFullDay);
        var leftPos = getEventStart(startDate, startTime, displayedTime, firstDay, startDay, endDay);
        var width = eventTime * 100 / displayedTime;
        if (showBuffer && bufferStart) {
          var t = calcTimelineTime(bufferStart, startDate, firstDay, lastDay, startTime, endTime, startDay, endDay, isFullDay);
          bufferBefore = Math.max(0, t * 100 / eventTime) + "%";
        }
        if (showBuffer && bufferEnd) {
          var t = calcTimelineTime(endDate, bufferEnd, firstDay, lastDay, startTime, endTime, startDay, endDay, isFullDay);
          bufferAfter = Math.max(0, t * 100 / eventTime) + "%";
        }
        if (isTimeline) {
          var diff = 0;
          if (isListing && !isDailyResolution) {
            dayIndex = this._dayIndexMap[getDateStr(startDate)];
          }
          if (s.resolution === "month" || s.resolution === "quarter") {
            var startDayDiff = this._days[dayIndex].dayDiff;
            var endKey = getDateStr(endDate >= lastDay ? addDays(lastDay, -1) : endDate);
            var endIndex = this._dayIndexMap[endKey];
            var endDayDiff = this._days[endIndex].dayDiff;
            diff = endDayDiff - startDayDiff;
          }
          width = (width + diff * 100) / daysNr;
          leftPos = (leftPos + dayIndex * 100) / daysNr;
        }
        var position = isTimeline ? isFullDay ? {
          left: s.rtl ? "" : (hasSlots ? "" : dayIndex * 100 / daysNr) + "%",
          right: s.rtl ? (hasSlots ? "" : dayIndex * 100 / daysNr) + "%" : "",
          width: (hasSlots ? "" : width) + "%"
        } : {
          height: this._setRowHeight ? "" : "100%",
          left: s.rtl ? "" : leftPos + "%",
          right: s.rtl ? leftPos + "%" : "",
          top: "0",
          width: width + "%"
        } : {
          width: (isMultiDay && !groupByDate ? width : 100) + "%"
        };
        var isStartInView = getDayMilliseconds(startDate) < endTime && endDate > firstDay;
        var isEndInView = getDayMilliseconds(endDate) + adjust > startTime;
        if (isFullDay || isMultiDay && width > 0 || isStartInView && isEndInView) {
          displayedMap.set(origEvent, true);
          return {
            bufferAfter: bufferAfter,
            bufferBefore: bufferBefore,
            end: end,
            endDate: endDate,
            position: position,
            start: start,
            startDate: startDate
          };
        }
      }
    } else {
      if (getDayMilliseconds(startDate) < endTime && getDayMilliseconds(endDate) + adjust > startTime && endDate >= startDate) {
        var eventTime = calcSchedulerTime(startDate, endDate, startTime, endTime);
        var eventHeight = eventTime * 100 / displayedTime;
        if (showBuffer && bufferStart) {
          if (!isSameDay(bufferStart, startDate)) {
            bufferStart = createDate(s, +getDateOnly(startDate) + startTime);
          }
          var bufferTime = calcSchedulerTime(bufferStart, startDate, startTime, endTime);
          bufferBefore = bufferTime * 100 / eventTime + "%";
        }
        if (showBuffer && bufferEnd) {
          if (!isSameDay(bufferEnd, startDate)) {
            bufferEnd = createDate(s, +getDateOnly(startDate) + endTime - 1);
          }
          var bufferTime = calcSchedulerTime(endDate, bufferEnd, startTime, endTime);
          bufferAfter = bufferTime * 100 / eventTime + "%";
        }
        return {
          bufferAfter: bufferAfter,
          bufferBefore: bufferBefore,
          cssClass: eventHeight < 2 ? " mbsc-schedule-event-small-height" : "",
          end: end,
          endDate: endDate,
          position: {
            height: eventHeight + "%",
            top: getEventStart(startDate, startTime, displayedTime) + "%",
            width: "100%"
          },
          start: start,
          startDate: startDate
        };
      }
    }
    return UNDEFINED;
  };
  STBase.prototype._getEventData = function (event, d, resource, skipLabels) {
    var s = this.s;
    var ev = getEventData(s, event, d, true, resource, false, !this._isTimeline || this._hasResY, this._isDailyResolution, skipLabels);
    if (event.allDay && s.exclusiveEndDates && +ev.endDate === +ev.startDate) {
      ev.endDate = getDateOnly(addDays(ev.startDate, 1));
    }
    return ev;
  };
  STBase.prototype._getEvents = function (eventMap) {
    var _this = this;
    var s = this.s;
    var resources = this._resources;
    var slots = this._slots;
    var hasSlots = this._hasSlots;
    var hasResY = this._hasResY;
    var isTimeline = this._isTimeline;
    var isSchedule = !isTimeline;
    var events = {};
    var eventMaps = getResourceMap(eventMap, resources, slots, !!s.resources, !!s.slots);
    var eventLabels = {};
    var firstDay = this._firstDay;
    var lastDay = this._lastDay;
    var variableRow = this._setRowHeight;
    var connectionMap = {};
    var cols = this._cols;
    var allKey = "all";
    var createEventMaps = this._createEventMaps || s.renderHour || s.renderHourFooter || s.renderDay || s.renderDayFooter || s.renderWeek || s.renderWeekFooter || s.renderMonth || s.renderMonthFooter || s.renderQuarter || s.renderQuarterFooter || s.renderYear || s.renderYearFooter;
    if (createEventMaps) {
      cols.forEach(function (c) {
        return c.eventMap = {
          all: []
        };
      });
    }
    if (s.connections) {
      for (var _i = 0, _a = s.connections; _i < _a.length; _i++) {
        var c = _a[_i];
        connectionMap[c.from] = true;
        connectionMap[c.to] = true;
      }
    }
    var _loop_1 = function (resource) {
      var resourceId = resource.id;
      var eventDisplayMap = new Map();
      var eventRows = 0;
      var groups = [];
      var next = {};
      var processGroups = function (slotId, date) {
        for (var n = 0; n < groups.length; n++) {
          var group = groups[n];
          var nr = group.stacks.length;
          var moreNr = group.more.length;
          if (variableRow && nr > eventRows) {
            eventRows = nr;
          }
          if (!hasSlots) {
            for (var i = 0; i < nr; i++) {
              for (var _i = 0, _a = group.stacks[i]; _i < _a.length; _i++) {
                var event_2 = _a[_i];
                var add = isTimeline && moreNr && !variableRow ? 1 : 0;
                var dimension = ((next[event_2.uid] || nr + add) - i) / (nr + add) * 100;
                if (isSchedule) {
                  event_2.position.width = dimension + "%";
                  event_2.position[s.rtl ? "right" : "left"] = i * 100 / nr + "%";
                  event_2.position[s.rtl ? "left" : "right"] = "auto";
                } else {
                  event_2.position.height = variableRow ? "" : dimension + "%";
                  event_2.position.top = variableRow ? i : i * 100 / (nr + add) + "%";
                }
              }
            }
          }
          if (moreNr) {
            var moreStart = void 0;
            var moreEnd = void 0;
            for (var _b = 0, _c = group.more; _b < _c.length; _b++) {
              var event_3 = _c[_b];
              if (!moreStart || event_3.startDate < moreStart) {
                moreStart = event_3.startDate;
              }
              if (!moreEnd || event_3.endDate > moreEnd) {
                moreEnd = event_3.endDate;
              }
            }
            var moreDate = date || new Date(group.more[0].date);
            var moreDateKey = getDateStr(moreDate);
            var key = "more-" + (isSchedule || hasResY ? moreDateKey + "-" : "") + resourceId;
            var mText = s.moreEventsText || "";
            var moreText = (moreNr > 1 ? s.moreEventsPluralText || mText : mText).replace(/{count}/, moreNr);
            var moreData = _this._getEventData({
              color: "#ddd",
              cssClass: "mbsc-schedule-event-more",
              editable: false,
              end: moreEnd,
              id: key + (hasSlots ? (hasResY ? "" : "-" + moreDateKey) + "-" + slotId : "") + "-" + n,
              more: group.more,
              start: moreStart,
              text: (isSchedule ? "+" : "") + (isTimeline ? moreText : moreNr)
            }, moreDate, resource);
            var morePos = _this._getEventPos(moreData, moreDate, moreDateKey, eventDisplayMap);
            if (morePos) {
              moreData.position = morePos.position;
              if (isTimeline) {
                moreData.position.height = variableRow ? "" : 100 / (nr + 1) + "%";
                moreData.position.top = hasSlots ? "" : variableRow ? nr : nr * 100 / (nr + 1) + "%";
                events[resourceId][slotId][hasResY || hasSlots ? moreDateKey : allKey].data.push(moreData);
              } else {
                moreData.showText = true;
                moreData.position.width = "24px";
                moreData.position[s.rtl ? "right" : "left"] = "auto";
                moreData.position[s.rtl ? "left" : "right"] = "-24px";
                events[resourceId][slotId][moreDateKey].hasMore = true;
                events[resourceId][slotId][moreDateKey].data.push(moreData);
              }
            }
            _this._eventRows[key] = 1;
          }
        }
      };
      events[resourceId] = {};
      var _loop_2 = function (slot) {
        var slotId = slot.id;
        var eventsForSlot = eventMaps[resourceId][slotId];
        var eventKeys = Object.keys(eventsForSlot).sort();
        events[resourceId][slotId] = {
          all: {
            allDay: [],
            data: []
          }
        };
        if (isSchedule) {
          eventLabels[slotId] = getLabels(s, eventsForSlot, firstDay, lastDay, -1, this_1._daysNr, true, s.startDay, false, s.eventOrder);
        }
        var _loop_3 = function (dateKey) {
          var d = eventMap[dateKey].date;
          if (this_1._dayIndexMap[dateKey] !== UNDEFINED && isInWeek(d.getDay(), s.startDay, s.endDay)) {
            var eventsForDay = sortEvents(eventsForSlot[dateKey]) || [];
            if (isSchedule || hasResY || hasSlots) {
              groups = [];
              next = {};
            }
            events[resourceId][slotId][dateKey] = {
              allDay: [],
              data: []
            };
            if (hasResY) {
              eventRows = this_1._eventRows[dateKey + "-" + resourceId] || 0;
            }
            for (var _e = 0, eventsForDay_1 = eventsForDay; _e < eventsForDay_1.length; _e++) {
              var ev = eventsForDay_1[_e];
              if (!ev.allDay || isTimeline) {
                var event_4 = this_1._getEventData(ev, d, resource);
                var pos = this_1._getEventPos(event_4, d, dateKey, eventDisplayMap);
                event_4.position = UNDEFINED;
                if (pos) {
                  event_4.cssClass = pos.cssClass;
                  event_4.position = pos.position;
                  event_4.bufferAfter = pos.bufferAfter;
                  event_4.bufferBefore = pos.bufferBefore;
                  if (isSchedule || hasResY) {
                    event_4.showText = true;
                  }
                  calcLayout(s, groups, event_4, next, this_1._maxEventStack || 1, s.eventList, isTimeline, this_1._isDailyResolution, firstDay, this_1._firstDayTz, lastDay, this_1._lastDayTz, this_1._cols, this_1._colIndexMap);
                  events[resourceId][slotId][allKey].data.push(event_4);
                  this_1._eventMap[event_4.id] = event_4;
                  if (createEventMaps) {
                    var timeStep = this_1._stepCell;
                    var isHoursResolution = this_1._isDailyResolution && timeStep < 1440 * ONE_MIN;
                    var firstDayTz = ev.allDay ? firstDay : addTimezone(s, firstDay);
                    var first = event_4.startDate > firstDayTz ? event_4.startDate : firstDayTz;
                    var colIndex = this_1._colIndexMap[getDateStr(first)];
                    var overlap = true;
                    while (overlap && colIndex < cols.length) {
                      var col = cols[colIndex];
                      var dtStart = col.date;
                      var dtEnd = colIndex < cols.length - 1 ? cols[colIndex + 1].date : lastDay;
                      var start = dtStart;
                      var addedToAll = false;
                      while (start < dtEnd) {
                        var ts = +start;
                        var end = isHoursResolution ? new Date(ts + timeStep) : dtEnd;
                        var colStart = ev.allDay ? dtStart : addTimezone(s, start);
                        var colEnd = ev.allDay ? dtEnd : addTimezone(s, end);
                        if (checkDateRangeOverlap(event_4.startDate, event_4.endDate, colStart, colEnd, true)) {
                          if (!col.eventMap[ts]) {
                            col.eventMap[ts] = [];
                          }
                          if (!addedToAll) {
                            col.eventMap.all.push(event_4.original);
                            addedToAll = true;
                          }
                          col.eventMap[ts].push(event_4.original);
                          overlap = true;
                        } else {
                          overlap = false;
                        }
                        start = end;
                      }
                      colIndex++;
                    }
                  }
                }
                events[resourceId][slotId][dateKey].data.push(event_4);
                if (isTimeline && ev.allDay) {
                  events[resourceId][slotId][dateKey].allDay.push(event_4);
                }
              }
            }
            if (isSchedule && eventLabels[slotId][dateKey]) {
              eventLabels[slotId][dateKey].data.forEach(function (_a) {
                var event = _a.event,
                  width = _a.width;
                if (event) {
                  var ev = _this._getEventData(event, d, resource);
                  var pos = _this._getEventPos(ev, d, dateKey, eventDisplayMap);
                  if (pos) {
                    ev.bufferAfter = pos.bufferAfter;
                    ev.bufferBefore = pos.bufferBefore;
                  }
                  ev.position = {
                    width: pos ? pos.position.width : width
                  };
                  ev.showText = !!pos;
                  events[resourceId][slotId][dateKey].allDay.push(ev);
                }
              });
            }
            if (isSchedule || hasResY || hasSlots) {
              processGroups(slotId, d);
            }
            if (hasResY) {
              this_1._eventRows[dateKey + "-" + resourceId] = eventRows || 1;
            }
          } else if (s.connections) {
            var eventsForDay = eventsForSlot[dateKey] || [];
            for (var _f = 0, eventsForDay_2 = eventsForDay; _f < eventsForDay_2.length; _f++) {
              var event_5 = eventsForDay_2[_f];
              var id = event_5.id;
              if (!this_1._eventMap[id] && connectionMap[id]) {
                this_1._eventMap[id] = this_1._getEventData(event_5, d, resource);
              }
            }
          }
        };
        for (var _d = 0, eventKeys_1 = eventKeys; _d < eventKeys_1.length; _d++) {
          var dateKey = eventKeys_1[_d];
          _loop_3(dateKey);
        }
      };
      for (var _c = 0, slots_1 = slots; _c < slots_1.length; _c++) {
        var slot = slots_1[_c];
        _loop_2(slot);
      }
      if (isTimeline && !hasSlots && !hasResY) {
        processGroups(DEF_ID);
      }
      if (!hasResY) {
        this_1._eventRows[resourceId] = eventRows || 1;
      }
    };
    var this_1 = this;
    for (var _b = 0, resources_1 = resources; _b < resources_1.length; _b++) {
      var resource = resources_1[_b];
      _loop_1(resource);
    }
    return events;
  };
  STBase.prototype._getInvalids = function (invalidMap) {
    var _a;
    var s = this.s;
    var isListing = s.eventList;
    var map = invalidMap || {};
    var invalids = {};
    var minDate = isListing ? getDateOnly(new Date(s.minDate)) : new Date(s.minDate);
    var maxDate = isListing ? getDateOnly(addDays(new Date(s.maxDate), 1)) : new Date(s.maxDate);
    var isTimeline = this._isTimeline;
    if (s.minDate) {
      for (var d = getDateOnly(this._firstDay); d < minDate; d.setDate(d.getDate() + 1)) {
        var dateKey = getDateStr(d);
        var invalidsForDay = map[dateKey] || [];
        invalidsForDay.push({
          end: minDate,
          start: new Date(d)
        });
        map[dateKey] = invalidsForDay;
      }
    }
    if (s.maxDate) {
      for (var d = getDateOnly(maxDate); d < this._lastDay; d.setDate(d.getDate() + 1)) {
        var dateKey = getDateStr(d);
        var invalidsForDay = map[dateKey] || [];
        invalidsForDay.push({
          end: new Date(this._lastDay),
          start: maxDate
        });
        map[dateKey] = invalidsForDay;
      }
    }
    var invalidMaps = getResourceMap(map, this._resources, this._slots, !!s.resources, !!s.slots);
    var invalidKeys = Object.keys(map).sort();
    for (var _i = 0, _b = this._resources; _i < _b.length; _i++) {
      var resource = _b[_i];
      var resourceId = resource.id;
      var invalidDisplayedMap = new Map();
      invalids[resourceId] = {};
      for (var _c = 0, _d = this._slots; _c < _d.length; _c++) {
        var slot = _d[_c];
        var slotId = slot.id;
        var allInvalids = {
          allDay: [],
          data: []
        };
        invalids[resourceId][slotId] = {
          all: allInvalids
        };
        for (var _e = 0, invalidKeys_1 = invalidKeys; _e < invalidKeys_1.length; _e++) {
          var dateKey = invalidKeys_1[_e];
          var d = makeDate(dateKey);
          if (this._dayIndexMap[dateKey] !== UNDEFINED && isInWeek(d.getDay(), s.startDay, s.endDay)) {
            var invalidsForDay = invalidMaps[resourceId][slotId][dateKey] || [];
            var allDailyInvalids = {
              allDay: [],
              data: []
            };
            var dailyInvalids = [];
            invalids[resourceId][slotId][dateKey] = allDailyInvalids;
            for (var _f = 0, invalidsForDay_1 = invalidsForDay; _f < invalidsForDay_1.length; _f++) {
              var invalid = invalidsForDay_1[_f];
              if (isString(invalid) || isDate(invalid)) {
                var start = makeDate(invalid);
                var end = new Date(start);
                invalid = {
                  allDay: true,
                  end: end,
                  start: start
                };
              }
              var invalidData = this._getEventData(invalid, d, resource, true);
              invalidData.cssClass = invalid.cssClass ? " " + invalid.cssClass : "";
              invalidData.position = UNDEFINED;
              var pos = this._getEventPos(invalidData, d, dateKey, invalidDisplayedMap);
              if (pos) {
                if (!isTimeline && getDayMilliseconds(pos.startDate) === 0 && new Date(+pos.endDate + 1) >= addDays(d, 1)) {
                  invalidData.allDay = true;
                } else {
                  invalidData.position = pos.position;
                  if (getDayMilliseconds(pos.startDate) <= this._startTime) {
                    invalidData.cssClass += " mbsc-schedule-invalid-start";
                  }
                  if (getDayMilliseconds(pos.endDate) >= this._endTime) {
                    invalidData.cssClass += " mbsc-schedule-invalid-end";
                  }
                }
                dailyInvalids.push(invalidData);
              }
              allDailyInvalids.data.push(invalidData);
              if (invalidData.allDay) {
                if (!isTimeline) {
                  invalidData.position = {};
                  if (pos && +invalidData.startDate === +invalidData.endDate) {
                    invalidData.endDate = pos.endDate;
                  }
                }
                allDailyInvalids.allDay = [invalidData];
                allDailyInvalids.data = [invalidData];
                dailyInvalids = [invalidData];
                break;
              }
            }
            (_a = allInvalids.data).push.apply(_a, dailyInvalids);
          }
        }
      }
    }
    return invalids;
  };
  STBase.prototype._getColors = function (colorMap) {
    var s = this.s;
    var colors = {};
    var colorMaps = getResourceMap(colorMap, this._resources, this._slots, !!s.resources, !!s.slots);
    var colorKeys = Object.keys(colorMap || {}).sort();
    var hasSlots = this._hasSlots;
    var isTimeline = this._isTimeline;
    var hasResY = this._hasResY;
    for (var _i = 0, _a = this._resources; _i < _a.length; _i++) {
      var resource = _a[_i];
      var resourceId = resource.id;
      var colorDisplayedMap = new Map();
      colors[resourceId] = {};
      for (var _b = 0, _c = this._slots; _b < _c.length; _b++) {
        var slot = _c[_b];
        var slotId = slot.id;
        colors[resourceId][slotId] = {
          all: {
            allDay: [],
            data: []
          }
        };
        for (var _d = 0, colorKeys_1 = colorKeys; _d < colorKeys_1.length; _d++) {
          var dateKey = colorKeys_1[_d];
          var d = makeDate(dateKey);
          if (this._dayIndexMap[dateKey] !== UNDEFINED && isInWeek(d.getDay(), s.startDay, s.endDay)) {
            var colorsForDay = colorMaps[resourceId][slotId][dateKey] || [];
            var key = !hasResY && !hasSlots && isTimeline ? "all" : dateKey;
            if (!isTimeline || hasSlots || hasResY) {
              colors[resourceId][slotId][key] = {
                allDay: [],
                data: []
              };
            }
            var dailyColors = colors[resourceId][slotId][key];
            for (var _e = 0, colorsForDay_1 = colorsForDay; _e < colorsForDay_1.length; _e++) {
              var color = colorsForDay_1[_e];
              var colorData = this._getEventData(color, d, resource, true);
              colorData.cssClass = color.cssClass ? " " + color.cssClass : "";
              if (colorData.allDay && !isTimeline) {
                dailyColors.allDay = [colorData];
              } else {
                var pos = this._getEventPos(colorData, d, dateKey, colorDisplayedMap);
                if (pos) {
                  colorData.position = pos.position;
                  if (getDayMilliseconds(pos.startDate) <= this._startTime) {
                    colorData.cssClass += " mbsc-schedule-color-start";
                  }
                  if (getDayMilliseconds(pos.endDate) >= this._endTime) {
                    colorData.cssClass += " mbsc-schedule-color-end";
                  }
                  dailyColors.data.push(colorData);
                }
              }
              colorData.position.background = color.background;
              colorData.position.color = color.textColor ? color.textColor : getTextColor(color.background);
            }
          }
        }
      }
    }
    return colors;
  };
  STBase.prototype._flattenResources = function (resources, flat, depth, copy, fixed) {
    var res = resources && resources.length ? resources : [{
      id: DEF_ID
    }];
    var immutable = this.s.immutableData;
    for (var _i = 0, res_1 = res; _i < res_1.length; _i++) {
      var resource = res_1[_i];
      var r = copy && immutable ? __assign({}, resource) : resource;
      var children = r.children;
      if (immutable) {
        r.original = resource;
      }
      r.depth = depth;
      r.isParent = !!(children && children.length);
      r.fixed = r.fixed || fixed;
      flat.push(r);
      this._resourcesMap[r.id] = r;
      if (copy && (immutable || !depth)) {
        copy.push(r);
      }
      if (r.isParent) {
        this._hasHierarchy = true;
        if (!r.collapsed || copy) {
          if (copy && immutable) {
            r.children = [];
          }
          this._flattenResources(children, flat, depth + 1, copy && r.children, r.fixed);
        }
      }
    }
    return flat;
  };
  STBase.prototype._render = function (s, state) {
    var _this = this;
    var prevS = this._prevS;
    var isTimeline = this._isTimeline;
    var selected = new Date(s.selected);
    var size = +s.size;
    var stepLabel = roundStep(s.timeLabelStep);
    var stepCell = roundStep(s.timeCellStep);
    var firstDay = s.firstDay;
    var startDay = s.startDay;
    var endDay = s.endDay;
    var resources = s.resources;
    var slots = s.slots;
    var disableVirtual = s.virtualScroll === false;
    var resolution = s.resolution;
    var isDailyResolution = resolution === "day" || resolution === "hour" || !isTimeline;
    var hasResY = s.resolutionVertical === "day";
    var calcDays = false;
    var reloadData = false;
    var startTime = this._startTime;
    var endTime = this._endTime;
    if (startDay !== prevS.startDay || endDay !== prevS.endDay || s.checkSize !== prevS.checkSize || s.eventList !== prevS.eventList || s.refDate !== prevS.refDate || s.size !== prevS.size || s.type !== prevS.type || s.resolution !== prevS.resolution || s.resolutionVertical !== prevS.resolutionVertical || s.displayTimezone !== prevS.displayTimezone || s.weekNumbers !== prevS.weekNumbers) {
      calcDays = true;
      this._viewChanged = true;
    }
    if (calcDays || s.rtl !== prevS.rtl || s.dateFormat !== prevS.dateFormat || s.getDay !== prevS.getDay || s.rowHeight !== prevS.rowHeight || s.maxEventStack !== prevS.maxEventStack) {
      reloadData = true;
    }
    if (s.startTime !== prevS.startTime || s.endTime !== prevS.endTime || s.timeLabelStep !== prevS.timeLabelStep || s.timeCellStep !== prevS.timeCellStep || s.timeFormat !== prevS.timeFormat || this._startTime === UNDEFINED || this._endTime === UNDEFINED) {
      var start = makeDate(s.startTime || "00:00");
      var end = new Date(+makeDate(s.endTime || "00:00") - 1);
      this._startTime = startTime = getDayMilliseconds(start);
      this._endTime = endTime = getDayMilliseconds(end);
      this._time = endTime - startTime + 1;
      this._timesBetween = getArray(floor(stepCell / stepLabel) - 1);
      this._times = [];
      this._timeLabels = {};
      this._viewChanged = true;
      var timeStep = stepCell * ONE_MIN;
      var timesFrom = floor(startTime / timeStep) * timeStep;
      var _loop_4 = function (d) {
        this_2._times.push(d);
        if (isTimeline) {
          var first = d === timesFrom;
          this_2._timeLabels[d] = first || d % (stepLabel * ONE_MIN) === 0 ? this_2._formatTime(first ? startTime : d) : "";
          this_2._timesBetween.forEach(function (tb, i) {
            var ms = d + (i + 1) * stepLabel * ONE_MIN;
            _this._timeLabels[ms] = _this._formatTime(ms);
          });
        }
      };
      var this_2 = this;
      for (var d = timesFrom; d <= endTime; d += timeStep) {
        _loop_4(d);
      }
      reloadData = true;
    }
    if (s.slots !== prevS.slots || this._slots === UNDEFINED) {
      this._hasSlots = isTimeline && !!slots && slots.length > 0;
      this._slots = slots && slots.length ? slots : [{
        id: DEF_ID
      }];
      reloadData = true;
    }
    if (resources !== prevS.resources || this._resources === UNDEFINED) {
      this._hasResources = !!resources && resources.length > 0;
      this._hasHierarchy = false;
      this._resourcesMap = {};
      this._resourcesCopy = [];
      this._resources = this._flattenResources(resources, [], 0, this._resourcesCopy);
      this._visibleResources = this._flattenResources(this._resourcesCopy, [], 0);
      this._isSingleResource = this._resources.length === 1;
      reloadData = true;
    }
    if (calcDays || s.selected !== prevS.selected || s.getDay !== prevS.getDay || s.monthNames !== prevS.monthNames || s.dateFormat !== prevS.dateFormat || s.currentTimeIndicator !== prevS.currentTimeIndicator) {
      var now = removeTimezone(createDate(s));
      var isDaily = s.type === "day";
      var isMonthly = s.type === "month";
      var isYearly = s.type === "year";
      var isDayViewOnly = isDaily && size < 2;
      var navService = s.navService;
      var monthPos = s.dateFormat.search(/m/i);
      var yearPos = s.dateFormat.search(/y/i);
      var datePos = s.dateFormat.search(/d/i);
      var yearFirst = yearPos < monthPos;
      var dayFirst = datePos < monthPos;
      var firstGridDay = void 0;
      var lastGridDay = void 0;
      var firstHeaderDay = void 0;
      var lastHeaderDay = void 0;
      if (size > 1 || isYearly || isMonthly) {
        firstHeaderDay = firstGridDay = navService.firstDay;
        lastHeaderDay = lastGridDay = navService.lastDay;
      } else {
        var firstWeekDay = getFirstDayOfWeek(selected, s);
        firstHeaderDay = addDays(firstWeekDay, startDay - firstDay + (startDay < firstDay ? 7 : 0));
        if (isDaily) {
          if (selected < firstHeaderDay) {
            firstHeaderDay = addDays(firstHeaderDay, -7);
          }
          if (selected >= addDays(firstHeaderDay, 7)) {
            firstHeaderDay = addDays(firstHeaderDay, 7);
          }
        }
        lastHeaderDay = addDays(firstHeaderDay, endDay - startDay + 1 + (endDay < startDay ? 7 : 0));
        firstGridDay = isDaily ? getDateOnly(selected) : firstHeaderDay;
        lastGridDay = isDaily ? addDays(firstGridDay, 1) : lastHeaderDay;
      }
      if (isTimeline && resolution === "week" && (isYearly || isMonthly)) {
        firstGridDay = navService.viewStart;
        lastGridDay = navService.viewEnd;
      }
      if (s.selected !== prevS.selected && isDaily && size < 2) {
        reloadData = true;
      }
      this._isMulti = size > 1 || isYearly;
      this._isDailyResolution = isDailyResolution;
      this._hasResY = hasResY;
      this._firstDayTz = createDate(s, firstGridDay.getFullYear(), firstGridDay.getMonth(), firstGridDay.getDate());
      this._lastDayTz = createDate(s, lastGridDay.getFullYear(), lastGridDay.getMonth(), lastGridDay.getDate());
      this._selectedDay = +getDateOnly(selected);
      this._shouldAnimateScroll = prevS.selected !== UNDEFINED && s.selected !== prevS.selected && !this._viewChanged;
      this._showTimeIndicator = !s.eventList && (s.currentTimeIndicator === UNDEFINED ? !isTimeline || isDailyResolution && stepCell < 1440 : s.currentTimeIndicator) && (isDaily && size < 2 ? isSameDay(now, selected) : firstGridDay <= now && lastGridDay >= now);
      if (reloadData || +firstGridDay !== +this._firstDay || +lastGridDay !== +this._lastDay) {
        this._firstDay = firstGridDay;
        this._lastDay = lastGridDay;
        this._colIndexMap = {};
        this._cols = [];
        this._dayIndexMap = {};
        this._days = [];
        this._headerDays = [];
        var i = 0;
        var j = -1;
        var dayDiff = 0;
        var daysInMonth = 0;
        var year = -1;
        var columnTitle = "";
        var month = -1;
        var monthIndex = -1;
        var monthText = "";
        var week = -1;
        var weekIndex = -1;
        var weekText = "";
        var first = firstGridDay;
        var last = lastGridDay;
        var lastColStart = 0;
        var weekEndDay = UNDEFINED;
        var newWeek = 0;
        if (!isTimeline && isDayViewOnly) {
          first = firstHeaderDay;
          last = lastHeaderDay;
        }
        for (var d = getDateOnly(first); d < getDateOnly(last); d.setDate(d.getDate() + 1)) {
          var dateKey = getDateStr(d);
          var weekDay = d.getDay();
          this._dayIndexMap[dateKey] = i;
          if (isInWeek(weekDay, startDay, endDay)) {
            var lastOfMonth = void 0;
            var monthTitle = "";
            var weekTitle = "";
            var columnChange = isDailyResolution;
            if (isTimeline && !hasResY) {
              newWeek = s.getWeekNumber(addDays(d, (7 - firstDay + 1) % 7));
              var newDay = s.getDay(d);
              var newMonth = s.getMonth(d);
              var newYear = s.getYear(d);
              var monthName = s.monthNames[newMonth];
              if (year !== newYear) {
                year = newYear;
                if (resolution === "year") {
                  columnChange = true;
                  columnTitle = "" + year;
                }
              }
              if (month !== newMonth) {
                if (resolution === "month") {
                  columnTitle = isYearly && size < 2 ? monthName : yearFirst ? newYear + " " + monthName : monthName + " " + newYear;
                  columnChange = true;
                } else if (resolution === "quarter" && newMonth % 3 === 0) {
                  var quarterNumber = newMonth / 3 + 1;
                  var quarterText = s.quarterText.replace("{count}", "" + quarterNumber);
                  columnTitle = isYearly && size < 2 ? quarterText : yearFirst ? newYear + " " + quarterText : quarterText + " " + newYear;
                  columnChange = true;
                } else if (isDailyResolution) {
                  monthText = yearFirst ? newYear + " " + monthName : monthName + " " + newYear;
                  monthTitle = monthText;
                }
                monthIndex = i;
                month = newMonth;
                daysInMonth = s.getMaxDayOfMonth(year, month);
              }
              if (week !== newWeek) {
                weekIndex = i;
                week = newWeek;
                weekText = s.weekText.replace(/{count}/, week);
                weekTitle = weekText;
                if (i > 0) {
                  this._days[i - 1].lastOfWeek = true;
                }
              }
              if ((weekDay === startDay || !i) && resolution === "week") {
                var dateFormat = dayFirst ? "D MMM" : "MMM D";
                weekEndDay = addDays(d, endDay - startDay + (endDay < startDay ? 7 : 0));
                columnTitle = formatDate(dateFormat, d, s) + " - " + formatDate(dateFormat, weekEndDay, s);
                columnChange = true;
              }
              var hiddenWeekDays = (startDay - endDay - 1 + 7) % 7;
              lastOfMonth = newDay === daysInMonth || weekDay === endDay && hiddenWeekDays >= daysInMonth - newDay;
              if (lastOfMonth && (resolution === "month" || resolution === "quarter")) {
                dayDiff += 31 - daysInMonth;
              }
            }
            var dayData = {
              columnTitle: columnTitle,
              date: new Date(d),
              dateIndex: i,
              dateKey: dateKey,
              dateText: formatDate(hasResY ? isMonthly && !this._isMulti ? "D DDD" : resources ? s.dateFormatLong : s.dateFormat : isMonthly || this._isMulti ? "D DDD" : s.dateFormatLong, d, s),
              day: s.getDay(d),
              dayDiff: dayDiff,
              endDate: weekEndDay,
              eventMap: {
                all: []
              },
              label: formatDate("DDDD, MMMM D, YYYY", d, s),
              lastOfMonth: lastOfMonth,
              monthIndex: monthIndex,
              monthText: monthText,
              monthTitle: monthTitle,
              timestamp: +getDateOnly(d),
              weekIndex: weekIndex,
              weekNr: newWeek,
              weekText: weekText,
              weekTitle: weekTitle
            };
            if (columnChange) {
              dayData.isActive = d <= now && now < last;
              if (lastColStart) {
                this._cols[j].isActive = lastColStart <= +now && now < d;
              }
              lastColStart = +d;
              this._cols.push(dayData);
              j++;
            }
            if (isDayViewOnly) {
              this._headerDays.push(dayData);
            }
            if (!isDayViewOnly || this._selectedDay === +d) {
              this._days.push(dayData);
            }
            if (lastOfMonth && (resolution === "month" || resolution === "quarter")) {
              for (var k = daysInMonth; k < 31; k++) {
                this._days.push(dayData);
                i++;
              }
            }
            i++;
          }
          this._colIndexMap[dateKey] = j < 0 ? 0 : j;
        }
        this._colsNr = hasResY ? 1 : j + 1;
        this._daysNr = hasResY || isDayViewOnly ? 1 : i;
      }
    }
    this._groupByResource = s.groupBy !== "date" && !(s.type === "day" && size < 2) || this._isSingleResource;
    this._stepCell = stepCell * ONE_MIN;
    this._stepLabel = stepLabel * ONE_MIN;
    this._dayNames = state.dayNameWidth > 49 ? s.dayNamesShort : s.dayNamesMin;
    this._displayTime = stepLabel < 1440 && isDailyResolution;
    this._eventHeight = state.eventHeight || (s.eventList ? 24 : 46);
    this._showCursorTime = this._displayTime && !!(s.dragToCreate || s.dragToMove || s.dragToResize);
    this._setRowHeight = s.eventList || s.rowHeight !== "equal";
    if (s.maxEventStack !== "auto") {
      this._maxEventStack = s.maxEventStack || "all";
    }
    if (s.colorsMap !== prevS.colorsMap || reloadData) {
      this._colors = this._getColors(s.colorsMap);
    }
    if (s.eventMap !== prevS.eventMap || s.showEventBuffer !== prevS.showEventBuffer || reloadData || !this._events || this._reloadEvents) {
      this._eventMap = {};
      this._eventRows = {};
      this._events = this._getEvents(s.eventMap);
      this._reloadEvents = false;
    }
    if (s.invalidsMap !== prevS.invalidsMap || reloadData) {
      this._invalids = this._getInvalids(s.invalidsMap);
    }
    var checkEventHeight = isTimeline && s.eventMap !== prevS.eventMap;
    if (s.height !== prevS.height || s.width !== prevS.width || checkEventHeight || reloadData) {
      this._shouldCheckSize = isBrowser && !!s.height && !!s.width;
    }
    if (s.scroll !== prevS.scroll) {
      this._shouldScroll = true;
    }
    if (s.height !== UNDEFINED) {
      this._hasSideSticky = hasSticky && !s.rtl;
      this._hasSticky = hasSticky;
    }
    if (isTimeline) {
      var cols = this._cols;
      var colsNr = this._colsNr;
      var daysBatch = [];
      var daysBatchNr = this._daysBatchNr === UNDEFINED ? constrain(floor(this._stepCell / (this._time / 30)), 1, 30) : this._daysBatchNr;
      var dayIndex = this._dayIndexMap[getDateStr(selected)] || 0;
      var batchIndexX = state.batchIndexX !== UNDEFINED ? state.batchIndexX : round(dayIndex / daysBatchNr);
      var batchDayIndex = Math.min(batchIndexX * daysBatchNr, colsNr - 1);
      var batchStart = disableVirtual ? 0 : Math.max(0, batchDayIndex - floor(daysBatchNr * 3 / 2));
      var batchEnd = disableVirtual ? colsNr : Math.min(batchStart + 3 * daysBatchNr, colsNr);
      var batchStartDay = cols[batchStart].date;
      var batchEndDay = batchEnd < colsNr ? cols[batchEnd].date : this._lastDay;
      var addedCols = {};
      for (var i = batchStart; i < batchEnd; i++) {
        addedCols[cols[i].dateKey] = true;
        daysBatch.push(cols[i]);
      }
      this._batchStart = createDate(s, batchStartDay.getFullYear(), batchStartDay.getMonth(), batchStartDay.getDate());
      this._batchEnd = createDate(s, batchEndDay.getFullYear(), batchEndDay.getMonth(), batchEndDay.getDate());
      this._daysBatch = daysBatch;
      this._daysBatchNr = daysBatchNr;
      this._placeholderSizeX = disableVirtual ? 0 : state.dayWidth * round(Math.max(0, batchDayIndex - daysBatchNr * 3 / 2)) || 0;
      this._rowHeights = {};
      this._dragCol = "";
      this._dragRow = "";
      this._fixedResources = [];
      this._fixedResourceTops = {};
      this._fixedHeight = state.headerHeight || 0;
      var gridContHeight_1 = (state.scrollContHeight || 0) - (state.headerHeight || 0) - (state.footerHeight || 0);
      var rowHeight_1 = state.rowHeight || 52;
      var parentRowHeight_1 = state.parentRowHeight || 52;
      var gutterHeight_1 = state.gutterHeight !== UNDEFINED ? state.gutterHeight : 16;
      var batchIndexY = state.batchIndexY || 0;
      var visibleResources_1 = this._visibleResources;
      var verticalDays = hasResY ? this._days : [{}];
      var totalRows = visibleResources_1.length * verticalDays.length;
      var rows_1 = [];
      var rowBatch = [];
      var addedGroups = {};
      var addedRows = {};
      var resourceMap_1 = {};
      var virtualPagesY_1 = [];
      var gridHeight_1 = 0;
      var pageHeight_1 = 0;
      if (state.hasScrollY) {
        this._resourceTops = {};
      }
      verticalDays.forEach(function (d, i) {
        visibleResources_1.forEach(function (r, j) {
          var key = (hasResY ? d.dateKey + "-" : "") + r.id;
          resourceMap_1[key] = r;
          if (gridContHeight_1) {
            var currRowHeight = r.children ? parentRowHeight_1 : rowHeight_1;
            var showMoreHeight = _this._eventRows["more-" + key] ? 24 : 0;
            var resHeight = _this._setRowHeight ? r.eventCreation === false ? currRowHeight : Math.max((_this._eventRows[key] || 1) * _this._eventHeight + gutterHeight_1 + showMoreHeight, currRowHeight) : currRowHeight;
            _this._rowHeights[key] = _this._setRowHeight ? resHeight + "px" : UNDEFINED;
            if (!hasResY && r.fixed) {
              _this._fixedResourceTops[key] = _this._fixedHeight;
              _this._fixedHeight += resHeight;
              _this._fixedResources.push({
                height: resHeight,
                index: j,
                key: key,
                resource: r
              });
            }
            if (state.hasScrollY) {
              _this._resourceTops[key] = gridHeight_1;
            }
            if (!pageHeight_1) {
              virtualPagesY_1.push({
                startIndex: i * visibleResources_1.length + j,
                top: gridHeight_1
              });
            }
            gridHeight_1 += resHeight;
            pageHeight_1 += resHeight;
            if (pageHeight_1 > gridContHeight_1) {
              pageHeight_1 = 0;
            }
          }
          rows_1.push({
            dayIndex: i,
            key: key,
            resource: r
          });
        });
      });
      var startPage = virtualPagesY_1[batchIndexY - 1];
      var endPage = virtualPagesY_1[batchIndexY + 2];
      var batchStartY = startPage ? startPage.startIndex : 0;
      var batchEndY = endPage ? endPage.startIndex : gridHeight_1 ? totalRows : 30;
      if (disableVirtual || gridHeight_1 && gridHeight_1 <= gridContHeight_1) {
        batchStartY = 0;
        batchEndY = totalRows;
      }
      var rowGroup = [];
      var lastDayIndex = -1;
      for (var i = batchStartY; i < batchEndY; i++) {
        var row = rows_1[i];
        if (row) {
          var currDayIndex = row.dayIndex;
          if (lastDayIndex !== currDayIndex) {
            rowGroup = [];
            rowBatch.push({
              day: hasResY ? this._days[currDayIndex] : UNDEFINED,
              rows: rowGroup
            });
            lastDayIndex = currDayIndex;
            addedGroups[currDayIndex] = rowBatch[rowBatch.length - 1];
          }
          addedRows[row.key] = true;
          rowGroup.push(row.resource);
        }
      }
      var compensateY = 0;
      for (var _i = 0, _a = this._fixedResources; _i < _a.length; _i++) {
        var r = _a[_i];
        if (!addedRows[r.key]) {
          rowGroup.unshift(r.resource);
          addedRows[r.key] = true;
          compensateY += r.height;
        }
      }
      if (state.dragData && state.dragData.originResource !== UNDEFINED) {
        var resource = state.dragData.originResource;
        var dateKey = getDateStr(new Date(state.dragData.originDate));
        var key = (hasResY ? dateKey + "-" : "") + resource;
        var groupIndex = hasResY ? this._dayIndexMap[dateKey] : 0;
        var colIndex = hasResY ? this._colIndexMap[dateKey] : 0;
        var colKey = cols[colIndex].dateKey;
        if (!addedRows[key]) {
          var group = addedGroups[groupIndex];
          if (!group) {
            group = {
              day: hasResY ? this._days[groupIndex] : UNDEFINED,
              hidden: true,
              rows: []
            };
            rowBatch.push(group);
          }
          group.rows.push(resourceMap_1[key]);
          this._dragRow = key;
        }
        if (!hasResY && !addedCols[colKey]) {
          this._dragCol = colKey;
          daysBatch.push(cols[colIndex]);
        }
      }
      this._gridHeight = gridHeight_1;
      this._virtualPagesY = virtualPagesY_1;
      this._colClass = resources || !hasResY ? "mbsc-timeline-resource-col" : "mbsc-timeline-date-col";
      this._hasRows = this._hasResources || hasResY;
      this._rows = rows_1;
      this._rowBatch = rowBatch;
      this._placeholderSizeY = startPage && !disableVirtual ? startPage.top - compensateY : 0;
    }
  };
  STBase.prototype._mounted = function () {
    var _this = this;
    var allowCreate;
    var allowStart;
    var validTarget;
    this._unlisten = gestureListener(this._el, {
      onDoubleClick: function (args) {
        var s = _this.s;
        if (validTarget && s.clickToCreate && s.clickToCreate !== "single") {
          args.click = true;
          if (_this._onEventDragStart(args)) {
            _this._onEventDragEnd(args);
          }
        }
      },
      onEnd: function (args) {
        if (!allowCreate && allowStart && _this.s.clickToCreate === "single") {
          args.click = true;
          if (_this._onEventDragStart(args)) {
            allowCreate = true;
          }
        }
        if (allowCreate) {
          args.domEvent.preventDefault();
          _this._onEventDragEnd(args);
        }
        clearTimeout(_this._touchTimer);
        allowCreate = false;
        allowStart = false;
      },
      onMove: function (args) {
        var s = _this.s;
        if (allowCreate && s.dragToCreate) {
          args.domEvent.preventDefault();
          _this._onEventDragMove(args);
        } else if (allowStart && s.dragToCreate && (Math.abs(args.deltaX) > 7 || Math.abs(args.deltaY) > 7)) {
          if (_this._onEventDragStart(args)) {
            allowCreate = true;
          } else {
            allowStart = false;
          }
        } else {
          clearTimeout(_this._touchTimer);
        }
      },
      onStart: function (args) {
        var s = _this.s;
        args.create = true;
        args.click = false;
        _this._isTouch = args.isTouch;
        if (!allowCreate && (s.dragToCreate || s.clickToCreate)) {
          var targetClasses = args.domEvent.target && args.domEvent.target.classList;
          validTarget = targetClasses && (targetClasses.contains("mbsc-schedule-item") || targetClasses.contains("mbsc-schedule-all-day-item") || targetClasses.contains("mbsc-timeline-column"));
          if (validTarget) {
            if (args.isTouch && s.dragToCreate) {
              _this._touchTimer = setTimeout(function () {
                if (_this._onEventDragStart(args)) {
                  _this._onEventDragModeOn(args);
                  allowCreate = true;
                }
              }, 350);
            } else {
              allowStart = !args.isTouch;
            }
          }
        }
      }
    });
    this._unsubscribe = subscribeExternalDrag(this._onExternalDrag);
  };
  STBase.prototype._updated = function () {
    var _this = this;
    var s = this.s;
    var state = this.state;
    if (this._scrollAfterResize) {
      this._onScroll();
      this._scrollAfterResize = false;
    }
    if (this._shouldCheckSize) {
      ngSetTimeout(this, function () {
        var resCont = _this._resCont;
        var headerCont = _this._headerCont;
        var footerCont = _this._footerCont;
        var sidebarCont = _this._sidebarCont;
        var stickyFooter = _this._stickyFooter;
        var headerHeight = headerCont.offsetHeight;
        var resContWidth = resCont ? resCont.offsetWidth : 0;
        var sidebarWidth = sidebarCont ? sidebarCont.offsetWidth : 0;
        var footerHeight = footerCont ? footerCont.offsetHeight : 0;
        var scrollCont = _this._scrollCont;
        var scrollContWidth = scrollCont.offsetWidth;
        var scrollContHeight = scrollCont.offsetHeight;
        var scrollClientWidth = scrollCont.clientWidth;
        var scrollClientHeight = scrollCont.clientHeight;
        var gridContWidth = scrollClientWidth - resContWidth - sidebarWidth;
        var gridContHeight = scrollClientHeight - headerHeight - footerHeight;
        var gridHeight = _this._gridHeight;
        var scrollBarSizeY = scrollContWidth - scrollClientWidth;
        var scrollBarSizeX = scrollContHeight - scrollClientHeight;
        var hasScrollY = scrollCont.scrollHeight > scrollClientHeight;
        var hasScrollX = scrollCont.scrollWidth > scrollClientWidth;
        var cellHeight;
        var cellWidth;
        var dayWidth;
        var dayNameWidth;
        var gridWidth;
        var rowHeight;
        var parentRowHeight;
        var gutterHeight;
        var eventHeight = state.eventHeight;
        if (_this._isTimeline) {
          var day = scrollCont.querySelector(".mbsc-timeline-day");
          var gridRow = scrollCont.querySelector(".mbsc-timeline-empty-row");
          var parentRow = scrollCont.querySelector(".mbsc-timeline-empty-parent");
          var gutter = scrollCont.querySelector(".mbsc-timeline-row-gutter");
          var colsNr = _this._colsNr;
          dayWidth = day ? day.offsetWidth : 64;
          rowHeight = gridRow ? gridRow.offsetHeight : 52;
          parentRowHeight = parentRow ? parentRow.offsetHeight : 52;
          gutterHeight = gutter ? gutter.offsetHeight : 16;
          if (dayWidth * colsNr < gridContWidth) {
            hasScrollX = false;
            scrollBarSizeX = 0;
          }
          if (gridHeight && gridHeight < gridContHeight) {
            hasScrollY = false;
            scrollBarSizeY = 0;
          }
          dayWidth = hasScrollX ? dayWidth : round(gridContWidth / colsNr);
          gridWidth = hasScrollX ? dayWidth * colsNr : gridContWidth;
          cellWidth = _this._stepCell * dayWidth / _this._time;
          _this._gridWidth = gridWidth;
          _this._daysBatchNr = Math.max(1, Math.ceil(gridContWidth / (dayWidth || 1)));
          if (!_this._hasSticky) {
            headerCont.style[s.rtl ? "left" : "right"] = scrollBarSizeY + "px";
            if (footerCont) {
              footerCont.style[s.rtl ? "left" : "right"] = scrollBarSizeY + "px";
              footerCont.style.bottom = scrollBarSizeX + "px";
            }
          }
          if (!_this._hasSideSticky) {
            if (resCont) {
              resCont.style.bottom = scrollBarSizeX + "px";
            }
            if (sidebarCont) {
              sidebarCont.style[s.rtl ? "left" : "right"] = scrollBarSizeY + "px";
            }
          }
          if (stickyFooter) {
            stickyFooter.style.bottom = scrollBarSizeX + "px";
          }
          if (_this._setRowHeight) {
            var event_6 = scrollCont.querySelector(".mbsc-schedule-event");
            eventHeight = event_6 ? event_6.clientHeight : eventHeight || (s.eventList ? 24 : 46);
          }
          if (!hasScrollY && state.rowHeight) {
            _this._resourceTops = {};
            var grid = _this._gridCont;
            var gridRect_1 = grid.getBoundingClientRect();
            var rows = grid.querySelectorAll(".mbsc-timeline-row");
            rows.forEach(function (r, i) {
              _this._resourceTops[_this._rows[i].key] = r.getBoundingClientRect().top - gridRect_1.top;
            });
          }
        } else {
          var gridCol = _this._el.querySelector(".mbsc-schedule-column-inner");
          var dayName = _this._el.querySelector(".mbsc-schedule-header-item");
          cellHeight = gridCol ? _this._stepCell * gridCol.offsetHeight / _this._time : 0;
          dayNameWidth = dayName ? dayName.offsetWidth : 0;
          if (s.maxEventStack === "auto") {
            var maxEventStack = floor(gridCol.offsetWidth / (s.minEventWidth || 50));
            _this._reloadEvents = _this._maxEventStack !== maxEventStack;
            _this._maxEventStack = maxEventStack;
          }
        }
        if (scrollCont.scrollTop > gridHeight - gridContHeight) {
          scrollCont.scrollTop = gridHeight - gridContHeight;
        } else {
          _this._onScroll();
        }
        _this._calcConnections = !!s.connections && (_this._isParentClick || _this._calcConnections || !hasScrollY);
        _this._shouldCheckSize = rowHeight !== state.rowHeight || eventHeight !== state.eventHeight || hasScrollY !== state.hasScrollY;
        _this._scrollAfterResize = s.virtualScroll && !_this._shouldCheckSize;
        _this._isCursorTimeVisible = false;
        _this._calcGridSizes();
        _this.setState({
          cellHeight: cellHeight,
          cellWidth: cellWidth,
          dayNameWidth: dayNameWidth,
          dayWidth: dayWidth,
          eventHeight: eventHeight,
          footerHeight: footerHeight,
          gridContWidth: gridContWidth,
          gridWidth: gridWidth,
          gutterHeight: gutterHeight,
          hasScrollX: hasScrollX,
          hasScrollY: hasScrollY,
          headerHeight: headerHeight,
          parentRowHeight: parentRowHeight,
          rowHeight: rowHeight,
          scrollContHeight: hasScrollX ? scrollClientHeight : scrollContHeight,
          update: _this._calcConnections || _this._reloadEvents ? (state.update || 0) + 1 : state.update
        });
      });
    }
    if (this._shouldScroll && (state.dayWidth || !this._isTimeline)) {
      setTimeout(function () {
        _this._scrollToTime(_this._shouldAnimateScroll);
        _this._shouldAnimateScroll = false;
      });
      this._shouldScroll = false;
    }
    if (this._viewChanged) {
      setTimeout(function () {
        _this._viewChanged = false;
      }, 10);
    }
  };
  STBase.prototype._destroy = function () {
    if (this._unlisten) {
      this._unlisten();
    }
    if (this._unsubscribe) {
      unsubscribeExternalDrag(this._unsubscribe);
    }
  };
  STBase.prototype._calcGridSizes = function () {
    var s = this.s;
    var resources = this._resources;
    var isTimeline = this._isTimeline;
    var daysNr = this._daysNr * (isTimeline ? 1 : resources.length);
    var grid = this._gridCont;
    var scrollCont = this._scrollCont;
    var allDayCont = !isTimeline && this._el.querySelector(".mbsc-schedule-all-day-wrapper");
    var allDayRect = allDayCont && allDayCont.getBoundingClientRect();
    var rect = grid.getBoundingClientRect();
    var gridRect = scrollCont.getBoundingClientRect();
    var gridWidth = isTimeline ? this._gridWidth : grid.scrollWidth;
    var resWidth = this._resCont ? this._resCont.offsetWidth : 0;
    this._gridLeft = s.rtl ? rect.right - gridWidth : rect.left;
    this._gridRight = s.rtl ? rect.right : rect.left + gridWidth;
    this._gridTop = rect.top;
    this._gridContTop = gridRect.top;
    this._gridContBottom = gridRect.bottom;
    this._gridContLeft = gridRect.left + (s.rtl ? 0 : resWidth);
    this._gridContRight = gridRect.right - (s.rtl ? resWidth : 0);
    this._allDayTop = allDayRect ? allDayRect.top : this._gridContTop;
    this._colWidth = gridWidth / (s.eventList ? this._colsNr : daysNr);
    this._colHeight = rect.height;
  };
  STBase.prototype._getDragDates = function (event, resourceId, slotId) {
    var s = this.s;
    var dates = {};
    var dragDisplayedMap = new Map();
    var first = event.allDay ? this._firstDay : this._firstDayTz;
    var start = event.startDate;
    var end = event.endDate;
    start = getDateOnly(start);
    start = start < first ? first : start;
    end = getEndDate(s, event.allDay || s.eventList, start, end);
    while (start <= end) {
      var eventForDay = __assign({}, event);
      var dateKey = getDateStr(start);
      var pos = isInWeek(start.getDay(), s.startDay, s.endDay) && this._getEventPos(event, start, dateKey, dragDisplayedMap);
      if (pos) {
        var eventResource = eventForDay.resource;
        if (this._isTimeline && this._setRowHeight && (isArray(eventResource) ? eventResource : [eventResource]).indexOf(this._tempResource) !== -1) {
          pos.position.top = eventForDay.position.top;
        }
        var key = this._isTimeline && !this._hasSlots && !this._hasResY ? "all" : dateKey;
        eventForDay.date = +getDateOnly(start, true);
        eventForDay.cssClass = pos.cssClass;
        eventForDay.start = pos.start;
        eventForDay.end = pos.end;
        eventForDay.position = pos.position;
        eventForDay.bufferAfter = pos.bufferAfter;
        eventForDay.bufferBefore = pos.bufferBefore;
        dates[resourceId + "__" + (this._isTimeline ? slotId + "__" : "") + key] = eventForDay;
      }
      start = addDays(start, 1);
    }
    return dates;
  };
  STBase.prototype._getGridTime = function (day, posX, posY, dayIndex, timeStep) {
    var dayIdx = this._hasResY ? 0 : dayIndex;
    var ms = step(this._isTimeline ? floor(this._time * (posX - dayIdx * this._colWidth) / this._colWidth) : floor(this._time * (posY - 8) / (this._colHeight - 16)), timeStep * ONE_MIN);
    var time = new Date(+REF_DATE + this._startTime + ms);
    return createDate(this.s, day.getFullYear(), day.getMonth(), day.getDate(), time.getHours(), time.getMinutes());
  };
  STBase.prototype._scrollToTime = function (animate) {
    var _this = this;
    var el = this._scrollCont;
    var gridCont = this._gridCont;
    var isTimeline = this._isTimeline;
    if (el) {
      var s = this.s;
      var hasResY = this._hasResY;
      var targetEvent = s.navigateToEvent;
      var targetDate = targetEvent && targetEvent.start ? roundTime(new Date(+makeDate(targetEvent.start, s) - this._stepCell), this._stepCell / ONE_MIN) : new Date(s.selected);
      var colIndex = this._colIndexMap[getDateStr(targetDate)];
      if (colIndex !== UNDEFINED && isTimeline && !hasResY && (s.resolution !== "hour" || this._stepCell === ONE_DAY || s.eventList)) {
        targetDate = this._cols[colIndex].date;
      } else {
        targetDate.setHours(s.eventList ? 0 : targetDate.getHours(), 0);
      }
      var timeStart = getEventStart(targetDate, this._startTime, this._time * (isTimeline ? this._daysNr : 1));
      var dayDiff = hasResY ? 0 : getGridDayDiff(this._firstDay, targetDate, s.startDay, s.endDay);
      var width = isTimeline ? gridCont.offsetWidth : gridCont.scrollWidth;
      var newScrollPosX = width * (dayDiff * 100 / this._daysNr + (isTimeline ? timeStart : 0)) / 100 + 1;
      var newScrollPosY = void 0;
      if (targetEvent || hasResY) {
        var resources = this._visibleResources;
        var resource = targetEvent ? targetEvent.resource : resources[0].id;
        var targetResource_1 = isArray(resource) ? resource[0] : resource;
        if (targetResource_1) {
          if (isTimeline) {
            var key = (hasResY ? getDateStr(targetDate) + "-" : "") + targetResource_1;
            newScrollPosY = this._resourceTops && this._resourceTops[key];
          } else {
            var colWidth = this._colWidth;
            var resourceIndex = findIndex(resources, function (r) {
              return r.id === targetResource_1;
            }) || 0;
            if (this._groupByResource && !this._isSingleResource) {
              newScrollPosX = this._daysNr * colWidth * resourceIndex + colWidth * dayDiff;
            } else {
              newScrollPosX = resources.length * dayDiff * colWidth + resourceIndex * colWidth;
            }
          }
        }
      }
      if (!isTimeline) {
        var gridCol = el.querySelector(".mbsc-schedule-column-inner");
        newScrollPosY = gridCol ? gridCol.offsetHeight * timeStart / 100 : 0;
        if (this._groupByResource && !this._isSingleResource && !targetEvent) {
          newScrollPosX = UNDEFINED;
        }
      }
      this._isScrolling++;
      smoothScroll(el, newScrollPosX, newScrollPosY, animate, s.rtl, function () {
        setTimeout(function () {
          _this._isScrolling--;
        }, 150);
      });
    }
  };
  STBase.ɵfac = /* @__PURE__ */(() => {
    let ɵSTBase_BaseFactory;
    return function STBase_Factory(t) {
      return (ɵSTBase_BaseFactory || (ɵSTBase_BaseFactory = i0.ɵɵgetInheritedFactory(STBase)))(t || STBase);
    };
  })();
  STBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: STBase,
    selectors: [["", "mbsc-st-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return STBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var SchedulerBase = /*#__PURE__*/function (_super) {
  __extends(SchedulerBase, _super);
  function SchedulerBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._onScroll = function () {
      var grid = _this._scrollCont;
      if (grid) {
        var scrollTop = grid.scrollTop;
        var scrollLeft = "translateX(" + -grid.scrollLeft + "px)";
        var timeCont = _this._timeCont;
        var allDay = _this._allDayCont;
        var header = _this._headerCont;
        var transform = (jsPrefix ? jsPrefix + "T" : "t") + "ransform";
        if (allDay) {
          allDay.style[transform] = scrollLeft;
        }
        if (timeCont) {
          timeCont.style.marginTop = -scrollTop + "px";
        }
        if (header) {
          header.style[transform] = scrollLeft;
        }
        if (scrollTop === 0) {
          _this.setState({
            showShadow: false
          });
        } else if (!_this.state.showShadow) {
          _this.setState({
            showShadow: true
          });
        }
        _this._onMouseMove();
      }
    };
    _this._setCont = function (el) {
      _this._scrollCont = el;
    };
    _this._setTimeCont = function (el) {
      _this._timeCont = el;
    };
    _this._setAllDayCont = function (el) {
      _this._allDayCont = el;
    };
    _this._setGridCont = function (el) {
      _this._gridCont = el;
    };
    _this._setHeaderCont = function (el) {
      _this._headerCont = el;
    };
    _this._setCursorTimeCont = function (el) {
      _this._cursorTimeCont = el;
    };
    return _this;
  }
  SchedulerBase.prototype._render = function (s, state) {
    _super.prototype._render.call(this, s, state);
    var prevS = this._prevS;
    var timezones = s.timezones;
    var stepCell = this._stepCell / ONE_MIN;
    var startMinutes = floor(this._startTime / ONE_MIN) % stepCell;
    var endMinutes = floor(this._endTime / ONE_MIN) % stepCell + 1;
    if (timezones !== prevS.timezones) {
      this._timeWidth = timezones ? {
        width: timezones.length * 4.25 + "em"
      } : UNDEFINED;
      this._timezones = UNDEFINED;
      if (timezones) {
        var tz = [];
        for (var _i = 0, timezones_1 = timezones; _i < timezones_1.length; _i++) {
          var t = timezones_1[_i];
          var tzProps = void 0;
          if (isString(t)) {
            var d = createDate(s, 1970, 0, 1);
            if (isMBSCDate(d)) {
              d.setTimezone(t);
            }
            var offset = d.getTimezoneOffset() / 60 * -1;
            tzProps = {
              label: "UTC" + (offset > 0 ? "+" : "") + offset,
              timezone: t
            };
          } else {
            tzProps = t;
          }
          tz.push(tzProps);
        }
        this._timezones = tz;
      }
    }
    this._largeDayNames = state.dayNameWidth > 99;
    this._startCellStyle = startMinutes % stepCell !== 0 ? {
      height: (state.cellHeight || 50) * ((stepCell - startMinutes) % stepCell / stepCell) + "px"
    } : UNDEFINED;
    this._endCellStyle = endMinutes % stepCell !== 0 ? {
      height: (state.cellHeight || 50) * (endMinutes % stepCell) / stepCell + "px"
    } : UNDEFINED;
  };
  SchedulerBase.ɵfac = /* @__PURE__ */(() => {
    let ɵSchedulerBase_BaseFactory;
    return function SchedulerBase_Factory(t) {
      return (ɵSchedulerBase_BaseFactory || (ɵSchedulerBase_BaseFactory = i0.ɵɵgetInheritedFactory(SchedulerBase)))(t || SchedulerBase);
    };
  })();
  SchedulerBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: SchedulerBase,
    selectors: [["", "mbsc-sch-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return SchedulerBase;
}(STBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var TimeIndicatorBase = /*#__PURE__*/function (_super) {
  __extends(TimeIndicatorBase, _super);
  function TimeIndicatorBase() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  TimeIndicatorBase.prototype._mounted = function () {
    var _this = this;
    clearInterval(this._timer);
    this._timer = setInterval(function () {
      if (_this._zone) {
        _this._zone.runOutsideAngular(function () {
          _this.forceUpdate();
        });
      } else {
        _this.forceUpdate();
      }
    }, 1e4);
  };
  TimeIndicatorBase.prototype._destroy = function () {
    clearInterval(this._timer);
  };
  TimeIndicatorBase.prototype._render = function (s) {
    var now = createDate(s);
    var rtl = s.rtl;
    var displayedDays = s.displayedDays;
    var displayedTime = s.displayedTime;
    var startTime = s.startTime;
    var time = floor(getDayMilliseconds(now) / ONE_MIN) * ONE_MIN;
    var timezones = s.timezones;
    var formatOpt = {
      amText: s.amText,
      pmText: s.pmText
    };
    if (timezones && isMBSCDate(now)) {
      this._times = [];
      for (var _i = 0, timezones_1 = timezones; _i < timezones_1.length; _i++) {
        var t = timezones_1[_i];
        var tzNow = now.clone();
        tzNow.setTimezone(t.timezone);
        this._times.push(formatDate(s.timeFormat, tzNow, formatOpt));
      }
    } else {
      this._time = formatDate(s.timeFormat, now, formatOpt);
    }
    this._cssClass = "mbsc-schedule-time-indicator mbsc-schedule-time-indicator-" + s.orientation + this._theme + this._rtl + " " + (time < startTime || time > startTime + displayedTime || !isInWeek(now.getDay(), s.startDay, s.endDay) ? " mbsc-hidden" : "");
    var dayIndex = s.hasResY ? 0 : getGridDayDiff(s.firstDay, now, s.startDay, s.endDay);
    if (s.orientation === "x") {
      var horiz = dayIndex * 100 / displayedDays + "%";
      var multiPos = timezones && 4.25 * timezones.length + "em";
      this._pos = {
        left: timezones && !rtl ? multiPos : UNDEFINED,
        right: timezones && rtl ? multiPos : UNDEFINED,
        top: (time - startTime) * 100 / displayedTime + "%"
      };
      this._dayPos = {
        left: rtl ? "" : horiz,
        right: rtl ? horiz : "",
        width: 100 / displayedDays + "%"
      };
    } else {
      var pos = (dayIndex * displayedTime + time - startTime) * 100 / (displayedDays * displayedTime) + "%";
      this._pos = {
        left: rtl ? "" : pos,
        right: rtl ? pos : ""
      };
    }
  };
  TimeIndicatorBase.ɵfac = /* @__PURE__ */(() => {
    let ɵTimeIndicatorBase_BaseFactory;
    return function TimeIndicatorBase_Factory(t) {
      return (ɵTimeIndicatorBase_BaseFactory || (ɵTimeIndicatorBase_BaseFactory = i0.ɵɵgetInheritedFactory(TimeIndicatorBase)))(t || TimeIndicatorBase);
    };
  })();
  TimeIndicatorBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TimeIndicatorBase,
    selectors: [["", "mbsc-ti-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return TimeIndicatorBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var WeekDayBase = /*#__PURE__*/function (_super) {
  __extends(WeekDayBase, _super);
  function WeekDayBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._onClick = function () {
      var s = _this.s;
      if (s.selectable) {
        s.onClick(s.timestamp);
      }
    };
    return _this;
  }
  WeekDayBase.prototype._render = function (s, state) {
    var date = new Date(s.timestamp);
    this._cssClass = "mbsc-schedule-header-item " + this._className + this._theme + this._rtl + this._hb + (s.largeNames ? " mbsc-schedule-header-item-large" : "") + (s.selected ? " mbsc-selected" : "") + (state.hasHover ? " mbsc-hover" : "");
    this._data = {
      date: date,
      events: s.events || [],
      resource: s.resource,
      selected: s.selected
    };
    this._day = date.getDay();
  };
  WeekDayBase.prototype._mounted = function () {
    var _this = this;
    this._unlisten = gestureListener(this._el, {
      onHoverIn: function () {
        if (_this.s.selectable) {
          _this.setState({
            hasHover: true
          });
        }
      },
      onHoverOut: function () {
        if (_this.s.selectable) {
          _this.setState({
            hasHover: false
          });
        }
      }
    });
  };
  WeekDayBase.prototype._destroy = function () {
    if (this._unlisten) {
      this._unlisten();
    }
  };
  WeekDayBase.ɵfac = /* @__PURE__ */(() => {
    let ɵWeekDayBase_BaseFactory;
    return function WeekDayBase_Factory(t) {
      return (ɵWeekDayBase_BaseFactory || (ɵWeekDayBase_BaseFactory = i0.ɵɵgetInheritedFactory(WeekDayBase)))(t || WeekDayBase);
    };
  })();
  WeekDayBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: WeekDayBase,
    selectors: [["", "mbsc-wd-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return WeekDayBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var TimelineBase = /*#__PURE__*/function (_super) {
  __extends(TimelineBase, _super);
  function TimelineBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._isTimeline = true;
    _this._onScroll = function () {
      var s = _this.s;
      var isRtl = s.rtl;
      var state = _this.state;
      var gridWidth = _this._gridWidth;
      var scrollCont = _this._scrollCont;
      var scrollTop = scrollCont.scrollTop;
      var scrollLeft = scrollCont.scrollLeft;
      var resCont = _this._resCont;
      var sidebarCont = _this._sidebarCont;
      var footer = _this._footerCont;
      var header = _this._headerCont;
      var stickyHeader = _this._stickyHeader;
      var stickyFooter = _this._stickyFooter;
      var days = _this._days;
      var daysNr = _this._daysNr;
      var colsNr = _this._cols.length;
      var rtl = isRtl ? -1 : 1;
      var margin = isRtl ? "marginRight" : "marginLeft";
      var batchIndexX = round(scrollLeft * rtl * (colsNr / _this._daysBatchNr) / gridWidth);
      var dayWidth = gridWidth / daysNr;
      var dayIndex = dayWidth ? constrain(floor(scrollLeft * rtl / dayWidth), 0, daysNr - 1) : 0;
      var virtualPagesY = _this._virtualPagesY || [];
      var batchIndexY = 0;
      var i = 0;
      while (i < virtualPagesY.length && virtualPagesY[i].top - state.scrollContHeight / 2 <= scrollTop) {
        batchIndexY = i;
        i++;
      }
      if (!hasSticky || isRtl) {
        if (resCont) {
          resCont.scrollTop = scrollTop;
        }
        if (sidebarCont) {
          sidebarCont.scrollTop = scrollTop;
        }
      }
      if (stickyHeader && hasSticky) {
        var headerStyle = stickyHeader.style;
        headerStyle.marginTop = scrollTop < 0 ? -scrollTop + "px" : "";
        headerStyle[margin] = scrollLeft * rtl < 0 ? -scrollLeft * rtl + "px" : "";
      }
      if (stickyFooter && hasSticky) {
        var footerStyle = stickyFooter.style;
        footerStyle.marginTop = scrollTop < 0 ? -scrollTop + "px" : "";
        footerStyle[margin] = scrollLeft * rtl < 0 ? -scrollLeft * rtl + "px" : "";
      }
      if (!gridWidth) {
        return;
      }
      if ((header || footer) && _this._isDailyResolution) {
        var updateStickyLabel = function (label, key) {
          if (label && dayWidth) {
            var labelWidth = label.offsetWidth;
            var labelStyle = label.style;
            var nextDayIndex = constrain(floor((scrollLeft * rtl + labelWidth) / dayWidth), 0, daysNr - 1);
            if (days[dayIndex][key + "Index"] !== days[nextDayIndex][key + "Index"]) {
              labelStyle[margin] = -(scrollLeft * rtl + labelWidth - days[nextDayIndex][key + "Index"] * dayWidth + 1) + "px";
            } else {
              labelStyle[margin] = "";
            }
          }
        };
        updateStickyLabel(_this._stickyDate, "date");
        updateStickyLabel(_this._stickyMonth, "month");
        updateStickyLabel(_this._stickyWeek, "week");
        if (!hasSticky) {
          if (footer) {
            footer.scrollLeft = scrollLeft;
          }
          if (header) {
            header.scrollLeft = scrollLeft;
          }
        }
      }
      if (batchIndexX !== state.batchIndexX || batchIndexY !== state.batchIndexY || (_this._stickyDate || _this._stickyMonth || _this._stickyWeek) && dayIndex !== state.dayIndex) {
        _this.setState({
          batchIndexX: batchIndexX,
          batchIndexY: batchIndexY,
          dayIndex: dayIndex
        });
      }
      clearTimeout(_this._scrollDebounce);
      _this._scrollDebounce = setTimeout(function () {
        if (!_this._isScrolling && !_this._viewChanged && !_this._hasResY) {
          var day = days[dayIndex].date;
          var ms = _this._time * (scrollLeft * rtl - dayIndex * dayWidth) / dayWidth;
          _this._hook("onActiveChange", {
            date: new Date(+day + _this._startTime + ms),
            scroll: true
          });
        }
      }, 100);
      _this._onMouseMove();
    };
    _this._setStickyHeader = function (el) {
      _this._stickyHeader = el;
    };
    _this._setStickyFooter = function (el) {
      _this._stickyFooter = el;
    };
    _this._setStickyDay = function (el) {
      _this._stickyDate = el;
    };
    _this._setStickyMonth = function (el) {
      _this._stickyMonth = el;
    };
    _this._setStickyWeek = function (el) {
      _this._stickyWeek = el;
    };
    _this._setCont = function (el) {
      _this._scrollCont = el;
    };
    _this._setResCont = function (el) {
      _this._resCont = el;
    };
    _this._setSidebarCont = function (el) {
      _this._sidebarCont = el;
    };
    _this._setGridCont = function (el) {
      _this._gridCont = el;
    };
    _this._setHeaderCont = function (el) {
      _this._headerCont = el;
    };
    _this._setFooterCont = function (el) {
      _this._footerCont = el;
    };
    _this._setCursorTimeCont = function (el) {
      _this._cursorTimeCont = el;
    };
    return _this;
  }
  TimelineBase.prototype._onParentClick = function (domEvent, resource) {
    resource.collapsed = !resource.collapsed;
    this._hook(resource.collapsed ? "onResourceCollapse" : "onResourceExpand", {
      domEvent: domEvent,
      resource: resource.id
    });
    this._visibleResources = this._flattenResources(this._resourcesCopy, [], 0);
    this._shouldCheckSize = true;
    this._isParentClick = true;
    this.forceUpdate();
  };
  TimelineBase.prototype._render = function (s, state) {
    _super.prototype._render.call(this, s, state);
    clearTimeout(this._scrollDebounce);
    var prevS = this._prevS;
    var eventMap = this._eventMap;
    var resourceTops = this._resourceTops;
    var stepCell = this._stepCell / ONE_MIN;
    var startMinutes = floor(this._startTime / ONE_MIN) % stepCell;
    var endMinutes = floor(this._endTime / ONE_MIN) % stepCell + 1;
    this._stickyDay = this._days[state.dayIndex || 0] || this._days[0];
    this._startCellStyle = startMinutes % stepCell !== 0 ? {
      width: (state.cellWidth || 64) * ((stepCell - startMinutes) % stepCell / stepCell) + "px"
    } : UNDEFINED;
    this._endCellStyle = endMinutes % stepCell !== 0 ? {
      width: (state.cellWidth || 64) * (endMinutes % stepCell) / stepCell + "px"
    } : UNDEFINED;
    if (s.connections !== prevS.connections || s.eventMap !== prevS.eventMap || s.theme !== prevS.theme || s.rtl !== prevS.rtl) {
      this._calcConnections = true;
    }
    if (this._hasSlots) {
      this._connections = UNDEFINED;
    }
    if (this._calcConnections && !this._hasSlots && !this._shouldCheckSize && resourceTops) {
      var connections = [];
      var eventHeight = this._eventHeight;
      var gridWidth = this._gridWidth;
      var gridHeight = state.hasScrollY ? this._gridHeight : state.scrollContHeight - state.headerHeight;
      var constLineH = 1500 / gridWidth;
      var isRtl = s.rtl === true;
      var rtl = isRtl ? -1 : 1;
      var arrowH = 750 / gridWidth * rtl;
      var arrowV = 400 / gridHeight * rtl;
      var eventHeightInPercent = 100 * eventHeight / gridHeight;
      for (var _i = 0, _a = s.connections || []; _i < _a.length; _i++) {
        var connection = _a[_i];
        var fromEvent = eventMap[connection.from];
        var toEvent = eventMap[connection.to];
        var arrow = connection.arrow;
        var color = connection.color;
        var cssClass = connection.cssClass || "";
        var id = connection.from + "__" + connection.to;
        var type = connection.type || "fs";
        if (fromEvent && toEvent) {
          var fromPos = fromEvent.position;
          var toPos = toEvent.position;
          var hasFromPos = fromPos.width !== UNDEFINED;
          var hasToPos = toPos.width !== UNDEFINED;
          var fromResource = fromEvent.resource;
          var toResource = toEvent.resource;
          if ((hasFromPos || hasToPos) && resourceTops[fromResource] >= 0 && resourceTops[toResource] >= 0) {
            var isFirstEnd = type === "fs" || type === "ff";
            var isSecondStart = type === "fs" || type === "ss";
            var from = isFirstEnd ? fromEvent.endDate : fromEvent.startDate;
            var to = isSecondStart ? toEvent.startDate : toEvent.endDate;
            var isToBefore = to < from;
            var startDate = isToBefore ? to : from;
            var endDate = isToBefore ? from : to;
            var fromTop = fromPos.top || 0;
            var toTop = toPos.top || 0;
            var positionProp = isRtl ? "right" : "left";
            var fromLeft = hasFromPos ? +fromPos[positionProp].replace("%", "") : isToBefore ? 100 : 0;
            var toLeft = hasToPos ? +toPos[positionProp].replace("%", "") : isToBefore ? 0 : 100;
            var fromWidth = hasFromPos ? +fromPos.width.replace("%", "") : 0;
            var toWidth = hasFromPos ? +toPos.width.replace("%", "") : 0;
            var resourceTopsDiff = resourceTops[toResource] - resourceTops[fromResource];
            var avoidLinethrough = !resourceTopsDiff && (type === "fs" && isToBefore || type === "sf" && !isToBefore || type === "ff" || type === "ss") && toTop === fromTop;
            var lineWidth = isFirstEnd && isSecondStart ? toLeft - fromLeft - fromWidth - 2 * constLineH : isFirstEnd && !isSecondStart ? toLeft - fromLeft + (toWidth - fromWidth) : !isFirstEnd && isSecondStart ? toLeft - fromLeft : toLeft - fromLeft + toWidth + 2 * constLineH;
            var toUpperResource = resourceTopsDiff < 0 || !resourceTopsDiff && toTop < fromTop ? -1 : 1;
            var lineHeight = 100 * (resourceTopsDiff - fromTop * eventHeight + toTop * eventHeight + (avoidLinethrough ? eventHeight : 0)) / gridHeight;
            var reversedHLine = type === "fs" && lineWidth < 0 || (type === "ff" || type === "ss") && avoidLinethrough || type === "sf";
            var drawHorizontalFirst = type === "ss" && isToBefore && !reversedHLine || type === "ff" && !isToBefore && !reversedHLine || type === "sf" && lineWidth < 0;
            var posX = (isRtl ? 100 - fromLeft : fromLeft) + (isFirstEnd ? fromWidth * rtl : 0);
            var posY = 100 * (resourceTops[fromResource] + fromTop * eventHeight + 3 + eventHeight / 2) / gridHeight;
            if (hasFromPos && (arrow === "from" || arrow === "bidirectional")) {
              var computedArrowH = isFirstEnd ? arrowH : arrowH * -1;
              connections.push({
                color: color,
                cssClass: "mbsc-connection-arrow " + cssClass,
                endDate: endDate,
                fill: color,
                id: id + "__start",
                pathD: "M ".concat(posX, ", ").concat(posY, " L ").concat(posX + computedArrowH, " ").concat(posY - arrowV, " L ").concat(posX + computedArrowH, " ").concat(posY + arrowV, " Z"),
                startDate: startDate
              });
            }
            var pathD = "M ".concat(posX, ", ").concat(posY);
            posX += isFirstEnd ? constLineH * rtl : -constLineH * rtl;
            if (drawHorizontalFirst) {
              posX += lineWidth * rtl;
            }
            if (lineHeight) {
              pathD += " H ".concat(posX);
              if (!drawHorizontalFirst) {
                posY += lineHeight - (reversedHLine ? eventHeightInPercent / 2 : 0) * toUpperResource;
                pathD += " V ".concat(posY);
              }
            }
            if (!drawHorizontalFirst) {
              posX += lineWidth * rtl;
            }
            if (lineHeight) {
              pathD += " H ".concat(posX);
              if (drawHorizontalFirst) {
                posY += lineHeight - (reversedHLine ? eventHeightInPercent / 2 : 0) * toUpperResource;
                pathD += " V ".concat(posY);
              }
            }
            if (lineHeight && reversedHLine) {
              posY += eventHeightInPercent / 2 * toUpperResource * (avoidLinethrough ? -1 : 1);
              pathD += " V ".concat(posY);
            }
            posX += isSecondStart ? constLineH * rtl : -constLineH * rtl;
            pathD += " H ".concat(posX);
            connections.push({
              color: color,
              cssClass: cssClass,
              id: id,
              pathD: pathD,
              startDate: startDate,
              endDate: endDate
            });
            if (hasToPos && (arrow === "to" || arrow === "bidirectional" || arrow === true)) {
              var computedArrowH = isSecondStart ? arrowH * -1 : arrowH;
              connections.push({
                color: color,
                cssClass: "mbsc-connection-arrow " + cssClass,
                endDate: endDate,
                fill: color,
                id: id + "__end",
                pathD: "M ".concat(posX, ", ").concat(posY, " L ").concat(posX + computedArrowH, " ").concat(posY - arrowV, " L ").concat(posX + computedArrowH, " ").concat(posY + arrowV, " Z"),
                startDate: startDate
              });
            }
          }
        }
      }
      this._connections = connections;
      this._calcConnections = false;
    }
  };
  TimelineBase.ɵfac = /* @__PURE__ */(() => {
    let ɵTimelineBase_BaseFactory;
    return function TimelineBase_Factory(t) {
      return (ɵTimelineBase_BaseFactory || (ɵTimelineBase_BaseFactory = i0.ɵɵgetInheritedFactory(TimelineBase)))(t || TimelineBase);
    };
  })();
  TimelineBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TimelineBase,
    selectors: [["", "mbsc-tml-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return TimelineBase;
}(STBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var DraggableDirective = /*#__PURE__*/function (_super) {
  __extends(DraggableDirective, _super);
  function DraggableDirective() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  DraggableDirective.ɵfac = /* @__PURE__ */(() => {
    let ɵDraggableDirective_BaseFactory;
    return function DraggableDirective_Factory(t) {
      return (ɵDraggableDirective_BaseFactory || (ɵDraggableDirective_BaseFactory = i0.ɵɵgetInheritedFactory(DraggableDirective)))(t || DraggableDirective);
    };
  })();
  DraggableDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DraggableDirective,
    selectors: [["", "mbsc-draggable", ""]],
    inputs: {
      dragData: "dragData"
    },
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return DraggableDirective;
}(DraggableBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscDraggableModule = /*#__PURE__*/function () {
  function MbscDraggableModule() {}
  MbscDraggableModule.ɵfac = function MbscDraggableModule_Factory(t) {
    return new (t || MbscDraggableModule)();
  };
  MbscDraggableModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MbscDraggableModule
  });
  MbscDraggableModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule]]
  });
  return MbscDraggableModule;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var DropcontainerBase = /*#__PURE__*/function (_super) {
  __extends(DropcontainerBase, _super);
  function DropcontainerBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._onExternalDrag = function (args) {
      var element = _this.s.element || _this._el;
      var isIn = function () {
        return args.endY < _this._elBottom && args.endY > _this._elTop && args.endX > _this._elLeft && args.endX < _this._elRight;
      };
      var isInArea;
      switch (args.eventName) {
        case "onDragStart":
          if (element) {
            var rect = element.getBoundingClientRect();
            _this._elTop = rect.top;
            _this._elBottom = rect.bottom;
            _this._elLeft = rect.left;
            _this._elRight = rect.right;
            _this._isItemIn = _this._isOwner = isIn();
          }
          break;
        case "onDragMove":
          isInArea = isIn();
          if (isInArea && !_this._isItemIn) {
            _this._hook("onItemDragEnter", {
              clone: args.clone,
              data: args.dragData,
              domEvent: args.domEvent
            });
          } else if (!isInArea && _this._isItemIn) {
            _this._hook("onItemDragLeave", {
              clone: args.clone,
              data: args.dragData,
              domEvent: args.domEvent
            });
          }
          _this._isItemIn = isInArea;
          break;
        case "onDragEnd":
          if (_this._isItemIn && !_this._isOwner) {
            if (args.from) {
              args.from._eventDropped = true;
            }
            _this._hook("onItemDrop", {
              clone: args.clone,
              data: args.dragData,
              domEvent: args.domEvent
            });
          }
          _this._isItemIn = false;
          break;
      }
    };
    return _this;
  }
  DropcontainerBase.prototype._mounted = function () {
    this._unsubscribe = subscribeExternalDrag(this._onExternalDrag);
  };
  DropcontainerBase.prototype._destroy = function () {
    if (this._unsubscribe) {
      unsubscribeExternalDrag(this._unsubscribe);
    }
  };
  DropcontainerBase._name = "Dropcontainer";
  DropcontainerBase.ɵfac = /* @__PURE__ */(() => {
    let ɵDropcontainerBase_BaseFactory;
    return function DropcontainerBase_Factory(t) {
      return (ɵDropcontainerBase_BaseFactory || (ɵDropcontainerBase_BaseFactory = i0.ɵɵgetInheritedFactory(DropcontainerBase)))(t || DropcontainerBase);
    };
  })();
  DropcontainerBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: DropcontainerBase,
    selectors: [["", "mbsc-dropcontainer", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return DropcontainerBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscDropcontainer = /*#__PURE__*/function (_super) {
  __extends(MbscDropcontainer, _super);
  function MbscDropcontainer() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.onItemDragEnter = new EventEmitter();
    _this.onItemDragLeave = new EventEmitter();
    _this.onItemDrop = new EventEmitter();
    return _this;
  }
  MbscDropcontainer.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscDropcontainer_BaseFactory;
    return function MbscDropcontainer_Factory(t) {
      return (ɵMbscDropcontainer_BaseFactory || (ɵMbscDropcontainer_BaseFactory = i0.ɵɵgetInheritedFactory(MbscDropcontainer)))(t || MbscDropcontainer);
    };
  })();
  MbscDropcontainer.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscDropcontainer,
    selectors: [["mbsc-dropcontainer"]],
    outputs: {
      onItemDragEnter: "onItemDragEnter",
      onItemDragLeave: "onItemDragLeave",
      onItemDrop: "onItemDrop"
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function MbscDropcontainer_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscDropcontainer;
}(DropcontainerBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscDropcontainerModule = /*#__PURE__*/function () {
  function MbscDropcontainerModule() {}
  MbscDropcontainerModule.ɵfac = function MbscDropcontainerModule_Factory(t) {
    return new (t || MbscDropcontainerModule)();
  };
  MbscDropcontainerModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MbscDropcontainerModule
  });
  MbscDropcontainerModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule]]
  });
  return MbscDropcontainerModule;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var ListItemBase = /*#__PURE__*/function (_super) {
  __extends(ListItemBase, _super);
  function ListItemBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._onClick = function (ev) {
      _this._hook("onClick", {
        domEvent: ev
      });
      if (_this.s.selected) {
        _this.setState({
          hasFocus: false
        });
      }
    };
    return _this;
  }
  ListItemBase.prototype._mounted = function () {
    var _this = this;
    var isDrag;
    var touchTimer;
    this._unlisten = gestureListener(this._el, {
      click: true,
      keepFocus: true,
      onBlur: function () {
        _this.setState({
          hasFocus: false
        });
      },
      onEnd: function (ev) {
        if (isDrag) {
          var s = _this.s;
          var args = __assign({}, ev);
          var eventData = s.eventData;
          args.domEvent.preventDefault();
          args.drag = true;
          args.event = s.event;
          args.eventData = eventData;
          args.resource = eventData && eventData.currentResource && eventData.currentResource.id;
          _this._hook("onDragEnd", args);
          isDrag = false;
        }
        clearTimeout(touchTimer);
      },
      onFocus: function () {
        _this.setState({
          hasFocus: true
        });
      },
      onHoverIn: function (ev) {
        if (_this.s.actionable) {
          _this.setState({
            hasHover: true
          });
        }
        _this._hook("onHoverIn", {
          domEvent: ev
        });
      },
      onHoverOut: function (ev) {
        _this.setState({
          hasHover: false
        });
        _this._hook("onHoverOut", {
          domEvent: ev
        });
      },
      onKeyDown: function (ev) {
        var event = _this.s.event;
        switch (ev.keyCode) {
          case ENTER:
          case SPACE:
            _this._el.click();
            ev.preventDefault();
            break;
          case BACKSPACE:
          case DELETE:
            if (event && event.editable !== false) {
              _this._hook("onDelete", {
                domEvent: ev,
                event: event,
                source: "agenda"
              });
            }
            break;
        }
      },
      onMove: function (ev) {
        var s = _this.s;
        var args = __assign({}, ev);
        var eventData = s.eventData;
        args.drag = true;
        args.event = s.event;
        args.eventData = eventData;
        args.external = true;
        args.resource = eventData && eventData.currentResource && eventData.currentResource.id;
        if (isDrag || !args.isTouch) {
          args.domEvent.preventDefault();
        }
        if (isDrag) {
          _this._hook("onDragMove", args);
        } else if (Math.abs(args.deltaX) > 7 || Math.abs(args.deltaY) > 7) {
          clearTimeout(touchTimer);
          if (!args.isTouch && s.drag && s.event.editable !== false) {
            isDrag = true;
            _this._hook("onDragStart", args);
          }
        }
      },
      onPress: function () {
        if (_this.s.actionable) {
          _this.setState({
            isActive: true
          });
        }
      },
      onRelease: function () {
        _this.setState({
          isActive: false
        });
      },
      onStart: function (ev) {
        var s = _this.s;
        if (ev.isTouch && s.drag && s.event.editable !== false && !isDrag) {
          touchTimer = setTimeout(function () {
            var args = __assign({}, ev);
            var eventData = s.eventData;
            args.drag = true;
            args.event = s.event;
            args.eventData = eventData;
            args.resource = eventData && eventData.currentResource && eventData.currentResource.id;
            _this._hook("onDragModeOn", args);
            _this._hook("onDragStart", args);
            isDrag = true;
          }, 350);
        }
        return {
          ripple: s.actionable && s.ripple
        };
      }
    });
  };
  ListItemBase.prototype._render = function (s, state) {
    this._cssClass = this._className + " mbsc-list-item" + this._theme + this._hb + this._rtl + (s.actionable ? " mbsc-list-item-actionable" : "") + (state.hasFocus ? " mbsc-focus" : "") + (state.hasHover ? " mbsc-hover" : "") + (state.isActive ? " mbsc-active" : "") + (s.selected ? " mbsc-selected" : "");
  };
  ListItemBase.prototype._destroy = function () {
    if (this._unlisten) {
      this._unlisten();
    }
  };
  ListItemBase.defaults = {
    actionable: true,
    ripple: false
  };
  ListItemBase._name = "ListItem";
  ListItemBase.ɵfac = /* @__PURE__ */(() => {
    let ɵListItemBase_BaseFactory;
    return function ListItemBase_Factory(t) {
      return (ɵListItemBase_BaseFactory || (ɵListItemBase_BaseFactory = i0.ɵɵgetInheritedFactory(ListItemBase)))(t || ListItemBase);
    };
  })();
  ListItemBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: ListItemBase,
    selectors: [["", "mbsc-li-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return ListItemBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscListItem = /*#__PURE__*/function (_super) {
  __extends(MbscListItem, _super);
  function MbscListItem() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.onHoverIn = new EventEmitter();
    _this.onHoverOut = new EventEmitter();
    _this.onDragEnd = new EventEmitter();
    _this.onDragModeOff = new EventEmitter();
    _this.onDragModeOn = new EventEmitter();
    _this.onDragMove = new EventEmitter();
    _this.onDragStart = new EventEmitter();
    return _this;
  }
  MbscListItem.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscListItem_BaseFactory;
    return function MbscListItem_Factory(t) {
      return (ɵMbscListItem_BaseFactory || (ɵMbscListItem_BaseFactory = i0.ɵɵgetInheritedFactory(MbscListItem)))(t || MbscListItem);
    };
  })();
  MbscListItem.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscListItem,
    selectors: [["mbsc-list-item"]],
    hostAttrs: ["tabindex", "0"],
    hostVars: 2,
    hostBindings: function MbscListItem_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx._cssClass);
      }
    },
    inputs: {
      actionable: "actionable",
      cssClass: "cssClass",
      drag: "drag",
      event: "event"
    },
    outputs: {
      onHoverIn: "onHoverIn",
      onHoverOut: "onHoverOut",
      onDragEnd: "onDragEnd",
      onDragModeOff: "onDragModeOff",
      onDragModeOn: "onDragModeOn",
      onDragMove: "onDragMove",
      onDragStart: "onDragStart"
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function MbscListItem_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscListItem;
}(ListItemBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var ListBase = /*#__PURE__*/function (_super) {
  __extends(ListBase, _super);
  function ListBase() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ListBase.prototype._render = function (s) {
    this._cssClass = this._className + this._rtl + " mbsc-font mbsc-list" + this._theme;
  };
  ListBase.ɵfac = /* @__PURE__ */(() => {
    let ɵListBase_BaseFactory;
    return function ListBase_Factory(t) {
      return (ɵListBase_BaseFactory || (ɵListBase_BaseFactory = i0.ɵɵgetInheritedFactory(ListBase)))(t || ListBase);
    };
  })();
  ListBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: ListBase,
    selectors: [["", "mbsc-l-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return ListBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscList = /*#__PURE__*/function (_super) {
  __extends(MbscList, _super);
  function MbscList() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MbscList.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscList_BaseFactory;
    return function MbscList_Factory(t) {
      return (ɵMbscList_BaseFactory || (ɵMbscList_BaseFactory = i0.ɵɵgetInheritedFactory(MbscList)))(t || MbscList);
    };
  })();
  MbscList.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscList,
    selectors: [["mbsc-list"]],
    hostVars: 2,
    hostBindings: function MbscList_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx._cssClass);
      }
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function MbscList_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscList;
}(ListBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var ListHeaderBase = /*#__PURE__*/function (_super) {
  __extends(ListHeaderBase, _super);
  function ListHeaderBase() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ListHeaderBase.prototype._render = function (s) {
    this._cssClass = this._className + " mbsc-list-header" + this._theme + this._hb;
  };
  ListHeaderBase.ɵfac = /* @__PURE__ */(() => {
    let ɵListHeaderBase_BaseFactory;
    return function ListHeaderBase_Factory(t) {
      return (ɵListHeaderBase_BaseFactory || (ɵListHeaderBase_BaseFactory = i0.ɵɵgetInheritedFactory(ListHeaderBase)))(t || ListHeaderBase);
    };
  })();
  ListHeaderBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: ListHeaderBase,
    selectors: [["", "mbsc-lh-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return ListHeaderBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscListHeader = /*#__PURE__*/function (_super) {
  __extends(MbscListHeader, _super);
  function MbscListHeader() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MbscListHeader.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscListHeader_BaseFactory;
    return function MbscListHeader_Factory(t) {
      return (ɵMbscListHeader_BaseFactory || (ɵMbscListHeader_BaseFactory = i0.ɵɵgetInheritedFactory(MbscListHeader)))(t || MbscListHeader);
    };
  })();
  MbscListHeader.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscListHeader,
    selectors: [["mbsc-list-header"]],
    hostVars: 2,
    hostBindings: function MbscListHeader_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx._cssClass);
      }
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function MbscListHeader_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscListHeader;
}(ListHeaderBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscScheduleEvent = /*#__PURE__*/function (_super) {
  __extends(MbscScheduleEvent, _super);
  function MbscScheduleEvent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.onClick = new EventEmitter();
    _this.onDoubleClick = new EventEmitter();
    _this.onRightClick = new EventEmitter();
    _this.onHoverIn = new EventEmitter();
    _this.onHoverOut = new EventEmitter();
    _this.onDelete = new EventEmitter();
    _this.onDragEnd = new EventEmitter();
    _this.onDragModeOff = new EventEmitter();
    _this.onDragModeOn = new EventEmitter();
    _this.onDragMove = new EventEmitter();
    _this.onDragStart = new EventEmitter();
    return _this;
  }
  MbscScheduleEvent.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscScheduleEvent_BaseFactory;
    return function MbscScheduleEvent_Factory(t) {
      return (ɵMbscScheduleEvent_BaseFactory || (ɵMbscScheduleEvent_BaseFactory = i0.ɵɵgetInheritedFactory(MbscScheduleEvent)))(t || MbscScheduleEvent);
    };
  })();
  MbscScheduleEvent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscScheduleEvent,
    selectors: [["mbsc-schedule-event"]],
    hostVars: 17,
    hostBindings: function MbscScheduleEvent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("click", function MbscScheduleEvent_click_HostBindingHandler($event) {
          return ctx._onClick($event);
        })("contextmenu", function MbscScheduleEvent_contextmenu_HostBindingHandler($event) {
          return ctx._onRightClick($event);
        });
      }
      if (rf & 2) {
        i0.ɵɵattribute("data-id", ctx.event.id)("tabindex", 0)("title", ctx.event.tooltip);
        i0.ɵɵclassMap(ctx._cssClass);
        i0.ɵɵstyleProp("color", ctx._style.color)("height", ctx._style.height)("left", ctx._style.left)("right", ctx._style.right)("top", ctx._style.top)("width", ctx._style.width);
      }
    },
    inputs: {
      bufferAfterTemplate: "bufferAfterTemplate",
      bufferBeforeTemplate: "bufferBeforeTemplate",
      contentTemplate: "contentTemplate",
      displayTimezone: "displayTimezone",
      drag: "drag",
      event: "event",
      endDay: "endDay",
      eventHeight: "eventHeight",
      exclusiveEndDates: "exclusiveEndDates",
      gridEndTime: "gridEndTime",
      gridStartTime: "gridStartTime",
      hasResY: "hasResY",
      hidden: "hidden",
      inactive: "inactive",
      isDrag: "isDrag",
      isListing: "isListing",
      isTimeline: "isTimeline",
      lastDay: "lastDay",
      resize: "resize",
      resource: "resource",
      rtl: "rtl",
      selected: "selected",
      singleDay: "singleDay",
      slot: "slot",
      startDay: "startDay",
      template: "template",
      theme: "theme",
      timezonePlugin: "timezonePlugin"
    },
    outputs: {
      onClick: "onClick",
      onDoubleClick: "onDoubleClick",
      onRightClick: "onRightClick",
      onHoverIn: "onHoverIn",
      onHoverOut: "onHoverOut",
      onDelete: "onDelete",
      onDragEnd: "onDragEnd",
      onDragModeOff: "onDragModeOff",
      onDragModeOn: "onDragModeOn",
      onDragMove: "onDragMove",
      onDragStart: "onDragStart"
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    decls: 7,
    vars: 8,
    consts: [["default", ""], [3, "class", "ngStyle", 4, "ngIf"], [3, "class", 4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "ngStyle"], [4, "ngIf"], ["aria-hidden", "true"], [3, "innerHTML", 4, "ngIf"], ["class", "mbsc-hidden-content", 4, "ngIf"], [3, "innerHTML"], [1, "mbsc-hidden-content"]],
    template: function MbscScheduleEvent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, MbscScheduleEvent_div_0_Template, 2, 4, "div", 1)(1, MbscScheduleEvent_div_1_Template, 2, 4, "div", 1)(2, MbscScheduleEvent_div_2_Template, 1, 2, "div", 2)(3, MbscScheduleEvent_div_3_Template, 1, 2, "div", 2)(4, MbscScheduleEvent_ng_template_4_Template, 8, 15, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(6, MbscScheduleEvent_ng_template_6_Template, 0, 0, "ng-template", 3);
      }
      if (rf & 2) {
        const default_r2 = i0.ɵɵreference(5);
        i0.ɵɵproperty("ngIf", ctx._isStart && ctx.event.bufferBefore);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._isEnd && ctx.event.bufferAfter);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._isStart && ctx.resize && ctx.event.original.editable !== false);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._isEnd && ctx.resize && ctx.event.original.editable !== false);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngTemplateOutlet", ctx.template && !ctx._isMore ? ctx.template : default_r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(6, _c14, ctx.event));
      }
    },
    dependencies: [NgIf, NgStyle, NgTemplateOutlet],
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscScheduleEvent;
}(ScheduleEventBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscWeekDay = /*#__PURE__*/function (_super) {
  __extends(MbscWeekDay, _super);
  function MbscWeekDay() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MbscWeekDay.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscWeekDay_BaseFactory;
    return function MbscWeekDay_Factory(t) {
      return (ɵMbscWeekDay_BaseFactory || (ɵMbscWeekDay_BaseFactory = i0.ɵɵgetInheritedFactory(MbscWeekDay)))(t || MbscWeekDay);
    };
  })();
  MbscWeekDay.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscWeekDay,
    selectors: [["mbsc-week-day"]],
    hostVars: 4,
    hostBindings: function MbscWeekDay_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("click", function MbscWeekDay_click_HostBindingHandler() {
          return ctx._onClick();
        });
      }
      if (rf & 2) {
        i0.ɵɵclassMap(ctx._cssClass);
        i0.ɵɵstyleProp("background", ctx.background);
      }
    },
    inputs: {
      background: "background",
      day: "day",
      dayNames: "dayNames",
      dayTemplate: "dayTemplate",
      dayContentTemplate: "dayContentTemplate",
      events: "events",
      isToday: "isToday",
      label: "label",
      largeNames: "largeNames",
      resource: "resource",
      rtl: "rtl",
      selectable: "selectable",
      selected: "selected",
      theme: "theme",
      timestamp: "timestamp",
      onClick: "onClick"
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    decls: 5,
    vars: 5,
    consts: [[4, "ngIf"], ["aria-hidden", "true", 3, "class", 4, "ngIf"], ["class", "mbsc-hidden-content", 4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["aria-hidden", "true"], [1, "mbsc-hidden-content"]],
    template: function MbscWeekDay_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, MbscWeekDay_0_Template, 1, 4, null, 0)(1, MbscWeekDay_div_1_Template, 2, 3, "div", 1)(2, MbscWeekDay_div_2_Template, 2, 3, "div", 1)(3, MbscWeekDay_div_3_Template, 2, 3, "div", 2)(4, MbscWeekDay_4_Template, 1, 4, null, 0);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.dayTemplate);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.dayTemplate);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.dayTemplate);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.label);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.dayContentTemplate);
      }
    },
    dependencies: [NgIf, NgTemplateOutlet],
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscWeekDay;
}(WeekDayBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscTimeIndicator = /*#__PURE__*/function (_super) {
  __extends(MbscTimeIndicator, _super);
  function MbscTimeIndicator() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MbscTimeIndicator.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscTimeIndicator_BaseFactory;
    return function MbscTimeIndicator_Factory(t) {
      return (ɵMbscTimeIndicator_BaseFactory || (ɵMbscTimeIndicator_BaseFactory = i0.ɵɵgetInheritedFactory(MbscTimeIndicator)))(t || MbscTimeIndicator);
    };
  })();
  MbscTimeIndicator.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscTimeIndicator,
    selectors: [["mbsc-time-indicator"]],
    inputs: {
      amText: "amText",
      displayedTime: "displayedTime",
      displayedDays: "displayedDays",
      displayTimezone: "displayTimezone",
      endDay: "endDay",
      firstDay: "firstDay",
      hasResY: "hasResY",
      orientation: "orientation",
      pmText: "pmText",
      rtl: "rtl",
      showDayIndicator: "showDayIndicator",
      startDay: "startDay",
      startTime: "startTime",
      theme: "theme",
      timeFormat: "timeFormat",
      timezones: "timezones",
      timezonePlugin: "timezonePlugin"
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    decls: 5,
    vars: 8,
    consts: [["aria-hidden", "true", 3, "ngStyle"], [4, "ngIf"], [3, "class", "ngStyle", 4, "ngIf"], [3, "class", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "ngStyle"]],
    template: function MbscTimeIndicator_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div");
        i0.ɵɵtemplate(2, MbscTimeIndicator_ng_container_2_Template, 2, 2, "ng-container", 1)(3, MbscTimeIndicator_ng_container_3_Template, 2, 1, "ng-container", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, MbscTimeIndicator_div_4_Template, 1, 3, "div", 2);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵclassMap(ctx._cssClass);
        i0.ɵɵproperty("ngStyle", ctx._pos);
        i0.ɵɵadvance();
        i0.ɵɵclassMap((ctx.timezones ? "mbsc-flex " : "") + "mbsc-schedule-time-indicator-time mbsc-schedule-time-indicator-time-" + ctx.orientation + ctx._theme + ctx._rtl);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.timezones);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.timezones);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.showDayIndicator);
      }
    },
    dependencies: [NgStyle, NgIf, NgForOf],
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscTimeIndicator;
}(TimeIndicatorBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscScheduler = /*#__PURE__*/function (_super) {
  __extends(MbscScheduler, _super);
  function MbscScheduler() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._computeEventResize = computeEventResize;
    _this._defId = DEF_ID;
    return _this;
  }
  Object.defineProperty(MbscScheduler.prototype, "vCursorTimeCont", {
    set: function (el) {
      this._cursorTimeCont = el && el.nativeElement;
    },
    enumerable: false,
    configurable: true
  });
  MbscScheduler.prototype._getEventArgs = function (timestamp, v, event, resource) {
    return {
      date: getCellDate(timestamp, v),
      domEvent: event,
      resource: resource,
      source: "timeline"
    };
  };
  MbscScheduler.prototype._getDayKey = function (index, day) {
    return day.timestamp;
  };
  MbscScheduler.prototype._getEventKey = function (index, event) {
    return event.uid;
  };
  MbscScheduler.prototype._getDragKey = function (resourceId, dateKey) {
    return resourceId + "__" + dateKey;
  };
  MbscScheduler.prototype._getId = function (index, data) {
    return data.id;
  };
  MbscScheduler.prototype._mounted = function () {
    this._scrollCont = this.vScrollCont && this.vScrollCont.nativeElement;
    this._gridCont = this.vGridCont && this.vGridCont.nativeElement;
    this._headerCont = this.vHeaderCont && this.vHeaderCont.nativeElement;
    this._timeCont = this.vTimeCont && this.vTimeCont.nativeElement;
    this._allDayCont = this.vAllDayCont && this.vAllDayCont.nativeElement;
    _super.prototype._mounted.call(this);
  };
  MbscScheduler.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscScheduler_BaseFactory;
    return function MbscScheduler_Factory(t) {
      return (ɵMbscScheduler_BaseFactory || (ɵMbscScheduler_BaseFactory = i0.ɵɵgetInheritedFactory(MbscScheduler)))(t || MbscScheduler);
    };
  })();
  MbscScheduler.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscScheduler,
    selectors: [["mbsc-scheduler"]],
    viewQuery: function MbscScheduler_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c32, 7, ElementRef);
        i0.ɵɵviewQuery(_c33, 7, ElementRef);
        i0.ɵɵviewQuery(_c34, 5, ElementRef);
        i0.ɵɵviewQuery(_c35, 5, ElementRef);
        i0.ɵɵviewQuery(_c36, 7, ElementRef);
        i0.ɵɵviewQuery(_c37, 5, ElementRef);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vScrollCont = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vGridCont = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vHeaderCont = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vAllDayCont = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vTimeCont = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vCursorTimeCont = _t.first);
      }
    },
    hostVars: 2,
    hostBindings: function MbscScheduler_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap("mbsc-flex-col mbsc-flex-1-1 mbsc-schedule-wrapper" + ctx._theme + (ctx._daysNr > 7 ? " mbsc-schedule-wrapper-multi" : ""));
      }
    },
    inputs: {
      allDayText: "allDayText",
      amText: "amText",
      bufferAfterTemplate: "bufferAfterTemplate",
      bufferBeforeTemplate: "bufferBeforeTemplate",
      checkSize: "checkSize",
      clickToCreate: "clickToCreate",
      colorsMap: "colorsMap",
      currentTimeIndicator: "currentTimeIndicator",
      dataTimezone: "dataTimezone",
      dateFormat: "dateFormat",
      dateFormatFull: "dateFormatFull",
      dateFormatLong: "dateFormatLong",
      dayNames: "dayNames",
      dayNamesMin: "dayNamesMin",
      dayNamesShort: "dayNamesShort",
      dayTemplate: "dayTemplate",
      dayContentTemplate: "dayContentTemplate",
      events: "events",
      displayTimezone: "displayTimezone",
      dragBetweenResources: "dragBetweenResources",
      dragInTime: "dragInTime",
      dragTimeStep: "dragTimeStep",
      dragToCreate: "dragToCreate",
      dragToMove: "dragToMove",
      dragToResize: "dragToResize",
      endDay: "endDay",
      endTime: "endTime",
      eventDragEnd: "eventDragEnd",
      eventMap: "eventMap",
      eventContentTemplate: "eventContentTemplate",
      eventOrder: "eventOrder",
      eventOverlap: "eventOverlap",
      eventTemplate: "eventTemplate",
      exclusiveEndDates: "exclusiveEndDates",
      extendDefaultEvent: "extendDefaultEvent",
      externalDrag: "externalDrag",
      externalDrop: "externalDrop",
      firstDay: "firstDay",
      fromText: "fromText",
      getDay: "getDay",
      getDate: "getDate",
      getMaxDayOfMonth: "getMaxDayOfMonth",
      getMonth: "getMonth",
      getWeekNumber: "getWeekNumber",
      getYear: "getYear",
      groupBy: "groupBy",
      height: "height",
      immutableData: "immutableData",
      invalidateEvent: "invalidateEvent",
      invalidsMap: "invalidsMap",
      maxDate: "maxDate",
      navigateToEvent: "navigateToEvent",
      maxEventStack: "maxEventStack",
      minDate: "minDate",
      minEventWidth: "minEventWidth",
      monthNames: "monthNames",
      monthNamesShort: "monthNamesShort",
      moreEventsPluralText: "moreEventsPluralText",
      moreEventsText: "moreEventsText",
      navService: "navService",
      newEventText: "newEventText",
      pmText: "pmText",
      refDate: "refDate",
      resources: "resources",
      resourceTemplate: "resourceTemplate",
      scroll: "scroll",
      selected: "selected",
      selectedEventsMap: "selectedEventsMap",
      showAllDay: "showAllDay",
      showDays: "showDays",
      showEventBuffer: "showEventBuffer",
      showEventTooltip: "showEventTooltip",
      size: "size",
      startDay: "startDay",
      startTime: "startTime",
      timeCellStep: "timeCellStep",
      timeFormat: "timeFormat",
      timeLabelStep: "timeLabelStep",
      timezonePlugin: "timezonePlugin",
      timezones: "timezones",
      toText: "toText",
      type: "type",
      width: "width",
      onCellClick: "onCellClick",
      onCellDoubleClick: "onCellDoubleClick",
      onCellRightClick: "onCellRightClick",
      onEventClick: "onEventClick",
      onEventDoubleClick: "onEventDoubleClick",
      onEventRightClick: "onEventRightClick",
      onEventHoverIn: "onEventHoverIn",
      onEventHoverOut: "onEventHoverOut",
      onEventDelete: "onEventDelete",
      onEventDragEnd: "onEventDragEnd",
      onEventDragStart: "onEventDragStart",
      onEventDragEnter: "onEventDragEnter",
      onEventDragLeave: "onEventDragLeave",
      onMoreClick: "onMoreClick",
      onPopoverClose: "onPopoverClose",
      onWeekDayClick: "onWeekDayClick"
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    decls: 39,
    vars: 29,
    consts: [["tplEvents", ""], ["tplAllDay", ""], ["tplDay", ""], ["tplTimes", ""], ["headerCont", ""], ["timeCont", ""], ["scrollCont", ""], ["gridCont", ""], ["default", ""], ["allDayCont", ""], ["cursorTimeCont", ""], [3, "ngStyle"], [1, "mbsc-flex-1-1", "mbsc-schedule-header-wrapper"], [1, "mbsc-flex"], ["class", "mbsc-flex-1-0 mbsc-schedule-resource-group", 4, "ngIf"], [4, "ngIf"], [1, "mbsc-schedule-fake-scroll-y"], ["class", "mbsc-flex mbsc-schedule-timezone-labels", 3, "ngStyle", 4, "ngIf"], [3, "class", 4, "ngIf"], ["aria-hidden", "true", 3, "ngStyle"], [1, "mbsc-flex", "mbsc-schedule-time-cont-inner"], [1, "mbsc-flex-col", "mbsc-flex-1-1"], [3, "class", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "ngTemplateOutlet", 4, "ngIf"], ["orientation", "x", 3, "amText", "displayedTime", "displayedDays", "displayTimezone", "endDay", "firstDay", "pmText", "rtl", "showDayIndicator", "startDay", "startTime", "theme", "timeFormat", "timezones", "timezonePlugin", 4, "ngIf"], ["class", "mbsc-schedule-fake-scroll-x", 4, "ngIf"], [3, "scroll"], [1, "mbsc-flex", "mbsc-flex-1-1"], [1, "mbsc-flex", "mbsc-flex-1-0", "mbsc-schedule-grid", 3, "mouseleave", "mousemove"], ["class", "mbsc-calendar-dragging", 4, "ngIf"], [3, "bufferAfterTemplate", "bufferBeforeTemplate", "contentTemplate", "displayTimezone", "drag", "event", "endDay", "exclusiveEndDates", "gridEndTime", "gridStartTime", "hidden", "isDrag", "lastDay", "resize", "resource", "rtl", "singleDay", "slot", "startDay", "theme", "template", "timezonePlugin", "onDragStart", "onDragMove", "onDragEnd", "onDragModeOff", 4, "ngIf"], [3, "bufferAfterTemplate", "bufferBeforeTemplate", "contentTemplate", "displayTimezone", "drag", "event", "endDay", "exclusiveEndDates", "gridEndTime", "gridStartTime", "isDrag", "lastDay", "resize", "resource", "rtl", "singleDay", "slot", "startDay", "theme", "template", "timezonePlugin", 4, "ngIf"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "bufferAfterTemplate", "bufferBeforeTemplate", "contentTemplate", "displayTimezone", "drag", "event", "endDay", "exclusiveEndDates", "gridEndTime", "gridStartTime", "inactive", "lastDay", "resize", "resource", "rtl", "singleDay", "selected", "slot", "startDay", "theme", "template", "timezonePlugin", "onClick", "onDoubleClick", "onRightClick", "onHoverIn", "onHoverOut", "onDelete", "onDragStart", "onDragMove", "onDragEnd", "onDragModeOn", "onDragModeOff", 4, "ngIf"], ["class", "mbsc-schedule-event mbsc-schedule-event-all-day mbsc-schedule-event-all-day-placeholder", 4, "ngIf"], [3, "onClick", "onDoubleClick", "onRightClick", "onHoverIn", "onHoverOut", "onDelete", "onDragStart", "onDragMove", "onDragEnd", "onDragModeOn", "onDragModeOff", "bufferAfterTemplate", "bufferBeforeTemplate", "contentTemplate", "displayTimezone", "drag", "event", "endDay", "exclusiveEndDates", "gridEndTime", "gridStartTime", "inactive", "lastDay", "resize", "resource", "rtl", "singleDay", "selected", "slot", "startDay", "theme", "template", "timezonePlugin"], [1, "mbsc-schedule-event", "mbsc-schedule-event-all-day", "mbsc-schedule-event-all-day-placeholder"], [3, "onDragStart", "onDragMove", "onDragEnd", "onDragModeOff", "bufferAfterTemplate", "bufferBeforeTemplate", "contentTemplate", "displayTimezone", "drag", "event", "endDay", "exclusiveEndDates", "gridEndTime", "gridStartTime", "hidden", "isDrag", "lastDay", "resize", "resource", "rtl", "singleDay", "slot", "startDay", "theme", "template", "timezonePlugin"], [3, "bufferAfterTemplate", "bufferBeforeTemplate", "contentTemplate", "displayTimezone", "drag", "event", "endDay", "exclusiveEndDates", "gridEndTime", "gridStartTime", "isDrag", "lastDay", "resize", "resource", "rtl", "singleDay", "slot", "startDay", "theme", "template", "timezonePlugin"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "class", "ngStyle", 4, "ngIf"], [1, "mbsc-schedule-invalid-text"], [1, "mbsc-schedule-color-text"], [3, "class", "ngStyle", "click", "dblclick", "contextmenu", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "class", "ngStyle", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "click", "dblclick", "contextmenu", "ngStyle"], [1, "mbsc-flex-1-0", "mbsc-schedule-resource-group"], ["class", "mbsc-flex", 4, "ngIf"], ["class", "mbsc-flex-1-1", 3, "day", "dayNames", "dayTemplate", "dayContentTemplate", "events", "isToday", "label", "largeNames", "onClick", "rtl", "selectable", "selected", "theme", "timestamp", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "mbsc-flex-1-1", 3, "day", "dayNames", "dayTemplate", "dayContentTemplate", "events", "isToday", "label", "largeNames", "onClick", "rtl", "selectable", "selected", "theme", "timestamp"], [3, "background", "class", 4, "ngIf"], [1, "mbsc-schedule-resource-title"], [3, "class", "background", 4, "ngIf"], [3, "class", "background", "day", "dayNames", "dayTemplate", "dayContentTemplate", "events", "isToday", "label", "largeNames", "onClick", "resource", "rtl", "selectable", "selected", "theme", "timestamp", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "background", "day", "dayNames", "dayTemplate", "dayContentTemplate", "events", "isToday", "label", "largeNames", "onClick", "resource", "rtl", "selectable", "selected", "theme", "timestamp"], [3, "day", "dayNames", "dayTemplate", "dayContentTemplate", "events", "isToday", "label", "largeNames", "onClick", "rtl", "selectable", "selected", "theme", "timestamp", 4, "ngIf"], [3, "day", "dayNames", "dayTemplate", "dayContentTemplate", "events", "isToday", "label", "largeNames", "onClick", "rtl", "selectable", "selected", "theme", "timestamp"], [1, "mbsc-flex", "mbsc-schedule-timezone-labels", 3, "ngStyle"], [1, "mbsc-flex-col", "mbsc-flex-1-1", "mbsc-schedule-all-day-group-wrapper"], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf"], [3, "ngTemplateOutlet"], ["orientation", "x", 3, "amText", "displayedTime", "displayedDays", "displayTimezone", "endDay", "firstDay", "pmText", "rtl", "showDayIndicator", "startDay", "startTime", "theme", "timeFormat", "timezones", "timezonePlugin"], [1, "mbsc-schedule-fake-scroll-x"], [1, "mbsc-calendar-dragging"]],
    template: function MbscScheduler_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵtemplate(0, MbscScheduler_ng_template_0_Template, 3, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, MbscScheduler_ng_template_2_Template, 4, 14, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, MbscScheduler_ng_template_4_Template, 7, 20, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(6, MbscScheduler_ng_template_6_Template, 1, 2, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementStart(8, "div");
        i0.ɵɵelement(9, "div", 11);
        i0.ɵɵelementStart(10, "div", 12)(11, "div", 13, 4);
        i0.ɵɵtemplate(13, MbscScheduler_div_13_Template, 3, 2, "div", 14)(14, MbscScheduler_ng_container_14_Template, 3, 2, "ng-container", 15);
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(15, "div", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div");
        i0.ɵɵtemplate(17, MbscScheduler_div_17_Template, 2, 3, "div", 17)(18, MbscScheduler_div_18_Template, 9, 10, "div", 18);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "div")(20, "div", 19, 5)(22, "div", 20)(23, "div", 21)(24, "div");
        i0.ɵɵtemplate(25, MbscScheduler_div_25_Template, 2, 3, "div", 22)(26, MbscScheduler_ng_container_26_Template, 1, 1, "ng-container", 23)(27, MbscScheduler_mbsc_time_indicator_27_Template, 1, 15, "mbsc-time-indicator", 24)(28, MbscScheduler_div_28_Template, 2, 2, "div", 18);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(29, MbscScheduler_div_29_Template, 1, 0, "div", 25);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(30, "div", 16);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(31, "div", 26, 6);
        i0.ɵɵlistener("scroll", function MbscScheduler_Template_div_scroll_31_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onScroll());
        });
        i0.ɵɵelementStart(33, "div", 27)(34, "div", 28, 7);
        i0.ɵɵlistener("mouseleave", function MbscScheduler_Template_div_mouseleave_34_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onMouseLeave($event));
        })("mousemove", function MbscScheduler_Template_div_mousemove_34_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onMouseMove($event));
        });
        i0.ɵɵtemplate(36, MbscScheduler_ng_container_36_Template, 2, 2, "ng-container", 15)(37, MbscScheduler_ng_container_37_Template, 2, 2, "ng-container", 15);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵtemplate(38, MbscScheduler_div_38_Template, 1, 0, "div", 29);
      }
      if (rf & 2) {
        i0.ɵɵadvance(8);
        i0.ɵɵclassMap("mbsc-schedule-header mbsc-flex mbsc-flex-none" + ctx._theme + ctx._hb);
        i0.ɵɵadvance();
        i0.ɵɵclassMap("mbsc-schedule-time-col mbsc-schedule-time-col-empty" + ctx._theme + ctx._rtl + ctx._hb);
        i0.ɵɵproperty("ngStyle", ctx._timeWidth);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.type === "day" && ctx.size === 1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.type !== "day" || ctx.size !== 1);
        i0.ɵɵadvance(2);
        i0.ɵɵclassMap("mbsc-schedule-all-day-cont" + (ctx.state.showShadow ? " mbsc-schedule-all-day-wrapper-shadow" : "") + ctx._theme);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.timezones);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.showAllDay);
        i0.ɵɵadvance();
        i0.ɵɵclassMap("mbsc-flex mbsc-flex-1-1 mbsc-schedule-grid-wrapper" + ctx._theme);
        i0.ɵɵadvance();
        i0.ɵɵclassMap("mbsc-flex-col mbsc-schedule-time-col mbsc-schedule-time-cont" + ctx._theme + ctx._rtl);
        i0.ɵɵproperty("ngStyle", ctx._timeWidth);
        i0.ɵɵadvance(4);
        i0.ɵɵclassMap("mbsc-flex-1-1 mbsc-schedule-time-cont-pos" + ctx._theme + (ctx.timezones ? " mbsc-flex " : " mbsc-flex-col mbsc-schedule-time-col-last"));
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx._timezones)("ngForTrackBy", ctx._getKey);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.timezones);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._showTimeIndicator);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._showCursorTime);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.state.hasScrollX);
        i0.ɵɵadvance(2);
        i0.ɵɵclassMap("mbsc-flex-col mbsc-flex-1-1 mbsc-schedule-grid-scroll" + ctx._theme);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx._groupByResource);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx._groupByResource);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.state.dragData && !ctx.state.isTouchDrag);
      }
    },
    dependencies: [MbscScheduleEvent, MbscWeekDay, MbscTimeIndicator, NgIf, NgForOf, NgTemplateOutlet, NgStyle],
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscScheduler;
}(SchedulerBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscTimeline = /*#__PURE__*/function (_super) {
  __extends(MbscTimeline, _super);
  function MbscTimeline() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._computeEventResize = computeEventResize;
    _this._defId = DEF_ID;
    _this._oneDay = ONE_DAY;
    return _this;
  }
  Object.defineProperty(MbscTimeline.prototype, "vCursorTimeCont", {
    set: function (el) {
      this._cursorTimeCont = el && el.nativeElement;
    },
    enumerable: false,
    configurable: true
  });
  MbscTimeline.prototype._checkDisplay = function (event, checkDrag) {
    var dragData = this.state.dragData;
    var draggedEventId = dragData && dragData.draggedEvent && dragData.draggedEvent.id;
    return checkDrag && draggedEventId === event.id || this._batchStart <= event.endDate && this._batchEnd > event.startDate;
  };
  MbscTimeline.prototype._getDayKey = function (index, day) {
    return day.timestamp;
  };
  MbscTimeline.prototype._getEventArgs = function (dayEvents, slot, v, event, resource) {
    return {
      date: getCellDate(dayEvents.timestamp, v),
      domEvent: event,
      resource: resource,
      slot: slot.id,
      source: "timeline"
    };
  };
  MbscTimeline.prototype._getEventKey = function (index, data) {
    return data.uid;
  };
  MbscTimeline.prototype._getDragKey = function (resourceId, slotId, dateKey) {
    return resourceId + "__" + slotId + "__" + dateKey;
  };
  MbscTimeline.prototype._getId = function (index, data) {
    return data.id;
  };
  MbscTimeline.prototype._getRowKey = function (index, rowGroup) {
    return rowGroup.day ? rowGroup.day.dateKey : DEF_ID;
  };
  MbscTimeline.prototype._getDate = function (timestamp) {
    return new Date(timestamp);
  };
  MbscTimeline.prototype._render = function (s, state) {
    this._createEventMaps = !!(this.hourTemplate || this.hourFooterTemplate || this.dayTemplate || this.dayFooterTemplate || this.weekTemplate || this.weekFooterTemplate || this.monthTemplate || this.monthFooterTemplate || this.quarterTemplate || this.quarterFooterTemplate || this.yearTemplate || this.yearFooterTemplate);
    _super.prototype._render.call(this, s, state);
  };
  MbscTimeline.prototype._mounted = function () {
    this._footerCont = this.vFooterCont && this.vFooterCont.nativeElement;
    this._headerCont = this.vHeaderCont && this.vHeaderCont.nativeElement;
    this._scrollCont = this.vScrollCont && this.vScrollCont.nativeElement;
    this._gridCont = this.vGridCont && this.vGridCont.nativeElement;
    this._resCont = this.vResCont && this.vResCont.nativeElement;
    this._sidebarCont = this.vSidebarCont && this.vSidebarCont.nativeElement;
    this._stickyDate = this.vStickyDate && this.vStickyDate.nativeElement;
    this._stickyFooter = this.vStickyFooter && this.vStickyFooter.nativeElement;
    this._stickyHeader = this.vStickyHeader && this.vStickyHeader.nativeElement;
    this._stickyMonth = this.vStickyMonth && this.vStickyMonth.nativeElement;
    this._stickyWeek = this.vStickyWeek && this.vStickyWeek.nativeElement;
    _super.prototype._mounted.call(this);
  };
  MbscTimeline.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscTimeline_BaseFactory;
    return function MbscTimeline_Factory(t) {
      return (ɵMbscTimeline_BaseFactory || (ɵMbscTimeline_BaseFactory = i0.ɵɵgetInheritedFactory(MbscTimeline)))(t || MbscTimeline);
    };
  })();
  MbscTimeline.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscTimeline,
    selectors: [["mbsc-timeline"]],
    viewQuery: function MbscTimeline_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c32, 7, ElementRef);
        i0.ɵɵviewQuery(_c33, 7, ElementRef);
        i0.ɵɵviewQuery(_c43, 5, ElementRef);
        i0.ɵɵviewQuery(_c34, 7, ElementRef);
        i0.ɵɵviewQuery(_c44, 5, ElementRef);
        i0.ɵɵviewQuery(_c45, 5, ElementRef);
        i0.ɵɵviewQuery(_c46, 5, ElementRef);
        i0.ɵɵviewQuery(_c47, 5, ElementRef);
        i0.ɵɵviewQuery(_c48, 5, ElementRef);
        i0.ɵɵviewQuery(_c49, 5, ElementRef);
        i0.ɵɵviewQuery(_c50, 5, ElementRef);
        i0.ɵɵviewQuery(_c37, 5, ElementRef);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vScrollCont = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vGridCont = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vFooterCont = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vHeaderCont = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vResCont = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vSidebarCont = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vStickyFooter = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vStickyHeader = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vStickyDate = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vStickyMonth = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vStickyWeek = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vCursorTimeCont = _t.first);
      }
    },
    hostVars: 2,
    hostBindings: function MbscTimeline_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap("mbsc-timeline mbsc-flex-1-1 mbsc-flex-col" + (ctx.state.cellWidth ? "" : " mbsc-hidden") + (ctx._hasSticky ? " mbsc-has-sticky" : "") + (ctx._hasRows ? "" : " mbsc-timeline-no-rows") + (ctx._hasResources ? "" : " mbsc-timeline-no-resource") + ctx._theme + ctx._rtl);
      }
    },
    inputs: {
      allDayText: "allDayText",
      amText: "amText",
      bufferAfterTemplate: "bufferAfterTemplate",
      bufferBeforeTemplate: "bufferBeforeTemplate",
      checkSize: "checkSize",
      clickToCreate: "clickToCreate",
      colorsMap: "colorsMap",
      connections: "connections",
      currentTimeIndicator: "currentTimeIndicator",
      dateFormat: "dateFormat",
      dateFormatFull: "dateFormatFull",
      dateFormatLong: "dateFormatLong",
      dataTimezone: "dataTimezone",
      dayNames: "dayNames",
      dayNamesMin: "dayNamesMin",
      dayNamesShort: "dayNamesShort",
      dayFooterTemplate: "dayFooterTemplate",
      dayTemplate: "dayTemplate",
      monthTemplate: "monthTemplate",
      monthFooterTemplate: "monthFooterTemplate",
      weekTemplate: "weekTemplate",
      weekFooterTemplate: "weekFooterTemplate",
      yearTemplate: "yearTemplate",
      yearFooterTemplate: "yearFooterTemplate",
      hourTemplate: "hourTemplate",
      hourFooterTemplate: "hourFooterTemplate",
      displayTimezone: "displayTimezone",
      dragBetweenResources: "dragBetweenResources",
      dragBetweenSlots: "dragBetweenSlots",
      dragInTime: "dragInTime",
      dragTimeStep: "dragTimeStep",
      dragToCreate: "dragToCreate",
      dragToMove: "dragToMove",
      dragToResize: "dragToResize",
      endDay: "endDay",
      endTime: "endTime",
      eventDragEnd: "eventDragEnd",
      eventMap: "eventMap",
      eventContentTemplate: "eventContentTemplate",
      eventOrder: "eventOrder",
      eventOverlap: "eventOverlap",
      eventTemplate: "eventTemplate",
      exclusiveEndDates: "exclusiveEndDates",
      extendDefaultEvent: "extendDefaultEvent",
      externalDrag: "externalDrag",
      externalDrop: "externalDrop",
      eventList: "eventList",
      firstDay: "firstDay",
      fromText: "fromText",
      getDay: "getDay",
      getDate: "getDate",
      getMaxDayOfMonth: "getMaxDayOfMonth",
      getMonth: "getMonth",
      getWeekNumber: "getWeekNumber",
      getYear: "getYear",
      groupBy: "groupBy",
      height: "height",
      immutableData: "immutableData",
      invalidateEvent: "invalidateEvent",
      invalidsMap: "invalidsMap",
      maxDate: "maxDate",
      maxEventStack: "maxEventStack",
      minDate: "minDate",
      moreEventsPluralText: "moreEventsPluralText",
      moreEventsText: "moreEventsText",
      navigateToEvent: "navigateToEvent",
      monthNames: "monthNames",
      monthNamesShort: "monthNamesShort",
      navService: "navService",
      newEventText: "newEventText",
      nextIcon: "nextIcon",
      nextIconRtl: "nextIconRtl",
      downIcon: "downIcon",
      pmText: "pmText",
      refDate: "refDate",
      resolution: "resolution",
      resolutionVertical: "resolutionVertical",
      resources: "resources",
      resourceFooterTemplate: "resourceFooterTemplate",
      resourceHeaderTemplate: "resourceHeaderTemplate",
      resourceTemplate: "resourceTemplate",
      rowHeight: "rowHeight",
      scroll: "scroll",
      selected: "selected",
      selectedEventsMap: "selectedEventsMap",
      showAllDay: "showAllDay",
      showDays: "showDays",
      showEventBuffer: "showEventBuffer",
      showEventTooltip: "showEventTooltip",
      sidebarFooterTemplate: "sidebarFooterTemplate",
      sidebarHeaderTemplate: "sidebarHeaderTemplate",
      sidebarTemplate: "sidebarTemplate",
      size: "size",
      slots: "slots",
      slotTemplate: "slotTemplate",
      startDay: "startDay",
      startTime: "startTime",
      quarterTemplate: "quarterTemplate",
      quarterFooterTemplate: "quarterFooterTemplate",
      quarterText: "quarterText",
      timeCellStep: "timeCellStep",
      timeFormat: "timeFormat",
      timeLabelStep: "timeLabelStep",
      timezonePlugin: "timezonePlugin",
      toText: "toText",
      type: "type",
      virtualScroll: "virtualScroll",
      weekNumbers: "weekNumbers",
      weekText: "weekText",
      width: "width",
      onActiveChange: "onActiveChange",
      onCellClick: "onCellClick",
      onCellDoubleClick: "onCellDoubleClick",
      onCellRightClick: "onCellRightClick",
      onEventClick: "onEventClick",
      onEventDoubleClick: "onEventDoubleClick",
      onEventDragEnter: "onEventDragEnter",
      onEventDragLeave: "onEventDragLeave",
      onEventRightClick: "onEventRightClick",
      onEventHoverIn: "onEventHoverIn",
      onEventHoverOut: "onEventHoverOut",
      onEventDelete: "onEventDelete",
      onEventDragEnd: "onEventDragEnd",
      onEventDragStart: "onEventDragStart",
      onMoreClick: "onMoreClick",
      onPopoverClose: "onPopoverClose",
      onResourceCollapse: "onResourceCollapse",
      onResourceExpand: "onResourceExpand",
      onWeekDayClick: "onWeekDayClick"
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    decls: 71,
    vars: 54,
    consts: [["tplResource", ""], ["tplSidebar", ""], ["tplRow", ""], ["tplHour", ""], ["tplHourFooter", ""], ["tplDay", ""], ["tplDayFooter", ""], ["tplWeek", ""], ["tplWeekFooter", ""], ["tplMonth", ""], ["tplMonthFooter", ""], ["tplQuarter", ""], ["tplQuarterFooter", ""], ["tplYear", ""], ["tplYearFooter", ""], ["tplDayData", ""], ["stickyHeader", ""], ["scrollCont", ""], ["headerCont", ""], ["gridCont", ""], ["default", ""], ["defaultHour", ""], ["defaultDay", ""], ["defaultWeek", ""], ["defaultMonth", ""], ["defaultQuarter", ""], ["defaultYear", ""], ["stickyMonth", ""], ["defaultTmpl", ""], ["stickyWeek", ""], ["stickyDate", ""], ["stickyFooter", ""], ["cursorTimeCont", ""], ["defaultSlot", ""], ["defaultTitle", ""], ["resCont", ""], ["sidebarCont", ""], ["footerCont", ""], [3, "class", "height", 4, "ngIf"], ["class", "mbsc-flex-1-1", 4, "ngIf"], ["class", "mbsc-schedule-fake-scroll-y", 4, "ngIf"], [3, "class", 4, "ngIf"], [3, "scroll"], [1, "mbsc-timeline-time-indicator-cont"], ["orientation", "y", 3, "amText", "displayedTime", "displayedDays", "displayTimezone", "endDay", "firstDay", "hasResY", "pmText", "rtl", "startDay", "startTime", "theme", "timeFormat", "timezonePlugin", 4, "ngIf"], [1, "mbsc-flex-none"], [4, "ngIf"], ["class", "mbsc-flex", 4, "ngIf"], [1, "mbsc-flex", "mbsc-flex-1-1"], [1, "mbsc-timeline-hidden"], [3, "mouseleave", "mousemove"], [4, "ngFor", "ngForOf", "ngForTrackBy"], ["viewBox", "0 0 100 100", "preserveAspectRatio", "none", 4, "ngIf"], ["class", "mbsc-calendar-dragging", 4, "ngIf"], [3, "class", "background", "minHeight", "paddingLeft", "paddingRight", "top", 4, "ngIf"], [3, "class", "svg", "theme", "click", 4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "click", "svg", "theme"], [3, "class", "background", "minHeight", "top", 4, "ngIf"], [1, "mbsc-timeline-sidebar-resource-title"], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf"], [3, "class", "click", "dblclick", "contextmenu", 4, "ngIf"], [3, "class", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "class", "ngStyle", "click", "dblclick", "contextmenu", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "click", "dblclick", "contextmenu", "ngStyle"], [3, "click", "dblclick", "contextmenu"], ["aria-hidden", "true"], [1, "mbsc-timeline-footer-week-cont"], [1, "mbsc-timeline-footer-month-cont"], [1, "mbsc-timeline-footer-quarter-cont"], [1, "mbsc-timeline-footer-year-cont"], [1, "mbsc-timeline-events"], [3, "bufferAfterTemplate", "bufferBeforeTemplate", "contentTemplate", "displayTimezone", "drag", "endDay", "event", "eventHeight", "exclusiveEndDates", "gridEndTime", "gridStartTime", "hasResY", "hidden", "isDrag", "isTimeline", "isListing", "lastDay", "resize", "resource", "rtl", "slot", "startDay", "theme", "template", "timezonePlugin", "onDragStart", "onDragMove", "onDragEnd", "onDragModeOff", 4, "ngIf"], [3, "bufferAfterTemplate", "bufferBeforeTemplate", "contentTemplate", "displayTimezone", "drag", "endDay", "event", "eventHeight", "exclusiveEndDates", "gridEndTime", "gridStartTime", "hasResY", "isDrag", "isTimeline", "isListing", "lastDay", "resize", "resource", "rtl", "slot", "startDay", "theme", "template", "timezonePlugin", 4, "ngIf"], [3, "bufferAfterTemplate", "bufferBeforeTemplate", "contentTemplate", "displayTimezone", "drag", "endDay", "event", "eventHeight", "exclusiveEndDates", "gridEndTime", "gridStartTime", "hasResY", "inactive", "isTimeline", "isListing", "lastDay", "resize", "resource", "rtl", "selected", "slot", "startDay", "theme", "template", "timezonePlugin", "onClick", "onDoubleClick", "onRightClick", "onHoverIn", "onHoverOut", "onDelete", "onDragStart", "onDragMove", "onDragEnd", "onDragModeOn", "onDragModeOff", 4, "ngIf"], [3, "onClick", "onDoubleClick", "onRightClick", "onHoverIn", "onHoverOut", "onDelete", "onDragStart", "onDragMove", "onDragEnd", "onDragModeOn", "onDragModeOff", "bufferAfterTemplate", "bufferBeforeTemplate", "contentTemplate", "displayTimezone", "drag", "endDay", "event", "eventHeight", "exclusiveEndDates", "gridEndTime", "gridStartTime", "hasResY", "inactive", "isTimeline", "isListing", "lastDay", "resize", "resource", "rtl", "selected", "slot", "startDay", "theme", "template", "timezonePlugin"], [3, "onDragStart", "onDragMove", "onDragEnd", "onDragModeOff", "bufferAfterTemplate", "bufferBeforeTemplate", "contentTemplate", "displayTimezone", "drag", "endDay", "event", "eventHeight", "exclusiveEndDates", "gridEndTime", "gridStartTime", "hasResY", "hidden", "isDrag", "isTimeline", "isListing", "lastDay", "resize", "resource", "rtl", "slot", "startDay", "theme", "template", "timezonePlugin"], [3, "bufferAfterTemplate", "bufferBeforeTemplate", "contentTemplate", "displayTimezone", "drag", "endDay", "event", "eventHeight", "exclusiveEndDates", "gridEndTime", "gridStartTime", "hasResY", "isDrag", "isTimeline", "isListing", "lastDay", "resize", "resource", "rtl", "slot", "startDay", "theme", "template", "timezonePlugin"], [3, "class", "ngStyle", 4, "ngIf"], [3, "ngStyle"], [1, "mbsc-schedule-invalid-text"], [1, "mbsc-schedule-color-text"], [1, "mbsc-timeline-resource-header"], [3, "ngTemplateOutlet"], [1, "mbsc-flex-1-1"], [1, "mbsc-timeline-sidebar-header"], [1, "mbsc-schedule-fake-scroll-y"], [1, "mbsc-timeline-resource-footer"], [1, "mbsc-timeline-sidebar-footer"], ["orientation", "y", 3, "amText", "displayedTime", "displayedDays", "displayTimezone", "endDay", "firstDay", "hasResY", "pmText", "rtl", "startDay", "startTime", "theme", "timeFormat", "timezonePlugin"], [1, "mbsc-flex"], ["aria-hidden", "true", 1, "mbsc-flex"], [3, "ngStyle", "class", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "mbsc-hidden-content", 4, "ngIf"], [1, "mbsc-hidden-content"], [1, "mbsc-timeline-slot-title"], [3, "ngSwitch", 4, "ngIf", "ngIfElse"], [3, "ngSwitch"], [4, "ngSwitchCase"], [3, "class", "minHeight", 4, "ngIf"], [1, "mbsc-timeline-row-resource-col", "mbsc-flex-1-1", "mbsc-flex-col"], ["viewBox", "0 0 100 100", "preserveAspectRatio", "none"], ["vector-effect", "non-scaling-stroke", 3, "stroke", "fill", 4, "ngIf"], ["vector-effect", "non-scaling-stroke"], [3, "ngSwitch", 4, "ngIf"], [1, "mbsc-calendar-dragging"]],
    template: function MbscTimeline_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵtemplate(0, MbscTimeline_ng_template_0_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, MbscTimeline_ng_template_2_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, MbscTimeline_ng_template_4_Template, 4, 13, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(6, MbscTimeline_ng_template_6_Template, 4, 3, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(8, MbscTimeline_ng_template_8_Template, 2, 3, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(10, MbscTimeline_ng_template_10_Template, 4, 10, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor)(12, MbscTimeline_ng_template_12_Template, 2, 9, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor)(14, MbscTimeline_ng_template_14_Template, 3, 12, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor)(16, MbscTimeline_ng_template_16_Template, 2, 12, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor)(18, MbscTimeline_ng_template_18_Template, 3, 9, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor)(20, MbscTimeline_ng_template_20_Template, 2, 8, "ng-template", null, 10, i0.ɵɵtemplateRefExtractor)(22, MbscTimeline_ng_template_22_Template, 3, 9, "ng-template", null, 11, i0.ɵɵtemplateRefExtractor)(24, MbscTimeline_ng_template_24_Template, 2, 9, "ng-template", null, 12, i0.ɵɵtemplateRefExtractor)(26, MbscTimeline_ng_template_26_Template, 3, 9, "ng-template", null, 13, i0.ɵɵtemplateRefExtractor)(28, MbscTimeline_ng_template_28_Template, 2, 9, "ng-template", null, 14, i0.ɵɵtemplateRefExtractor)(30, MbscTimeline_ng_template_30_Template, 6, 5, "ng-template", null, 15, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementStart(32, "div", null, 16);
        i0.ɵɵtemplate(34, MbscTimeline_div_34_Template, 3, 5, "div", 38)(35, MbscTimeline_div_35_Template, 2, 1, "div", 39)(36, MbscTimeline_div_36_Template, 3, 5, "div", 38)(37, MbscTimeline_div_37_Template, 1, 0, "div", 40);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(38, MbscTimeline_div_38_Template, 6, 6, "div", 41);
        i0.ɵɵelementStart(39, "div", 42, 17);
        i0.ɵɵlistener("scroll", function MbscTimeline_Template_div_scroll_39_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onScroll());
        });
        i0.ɵɵelement(41, "div");
        i0.ɵɵelementStart(42, "div", null, 18);
        i0.ɵɵtemplate(44, MbscTimeline_div_44_Template, 1, 2, "div", 41);
        i0.ɵɵelementStart(45, "div")(46, "div", 43);
        i0.ɵɵtemplate(47, MbscTimeline_mbsc_time_indicator_47_Template, 1, 14, "mbsc-time-indicator", 44)(48, MbscTimeline_div_48_Template, 2, 2, "div", 41);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(49, "div", 45);
        i0.ɵɵelementStart(50, "div");
        i0.ɵɵtemplate(51, MbscTimeline_ng_container_51_Template, 5, 4, "ng-container", 46)(52, MbscTimeline_div_52_Template, 2, 2, "div", 47);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(53, MbscTimeline_div_53_Template, 1, 2, "div", 41);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(54, "div", 48)(55, "div", 48);
        i0.ɵɵtemplate(56, MbscTimeline_div_56_Template, 7, 16, "div", 41)(57, MbscTimeline_div_57_Template, 1, 2, "div", 41);
        i0.ɵɵelementStart(58, "div", 49);
        i0.ɵɵelement(59, "div")(60, "div")(61, "div");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(62, "div", 50, 19);
        i0.ɵɵlistener("mouseleave", function MbscTimeline_Template_div_mouseleave_62_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onMouseLeave($event));
        })("mousemove", function MbscTimeline_Template_div_mousemove_62_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onMouseMove($event));
        });
        i0.ɵɵelement(64, "div", 45);
        i0.ɵɵtemplate(65, MbscTimeline_ng_container_65_Template, 3, 2, "ng-container", 51)(66, MbscTimeline__svg_svg_66_Template, 2, 3, "svg", 52);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(67, MbscTimeline_div_67_Template, 7, 16, "div", 41)(68, MbscTimeline_div_68_Template, 1, 2, "div", 41);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(69, MbscTimeline_ng_container_69_Template, 11, 16, "ng-container", 46);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(70, MbscTimeline_div_70_Template, 1, 0, "div", 53);
      }
      if (rf & 2) {
        i0.ɵɵadvance(32);
        i0.ɵɵclassMap("mbsc-timeline-header-sticky mbsc-flex" + ctx._theme);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx._hasRows);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._isDailyResolution);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._hasRows && !!ctx.sidebarTemplate);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.state.hasScrollY);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !!(ctx.hourFooterTemplate || ctx.dayFooterTemplate || ctx.weekFooterTemplate || ctx.monthFooterTemplate || ctx.quarterFooterTemplate || ctx.yearFooterTemplate));
        i0.ɵɵadvance();
        i0.ɵɵclassMap("mbsc-timeline-grid-scroll mbsc-flex-col mbsc-flex-1-1" + ctx._theme + ctx._rtl + ctx._hb);
        i0.ɵɵadvance(2);
        i0.ɵɵclassMap("mbsc-flex-none");
        i0.ɵɵstyleProp("height", ctx._hasSticky ? undefined : ctx.state.headerHeight, "px");
        i0.ɵɵadvance();
        i0.ɵɵclassMap("mbsc-timeline-header mbsc-flex" + ctx._theme + ctx._rtl + ctx._hb);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx._hasRows);
        i0.ɵɵadvance();
        i0.ɵɵclassMap("mbsc-timeline-header-bg mbsc-flex-1-0 mbsc-flex" + ctx._theme);
        i0.ɵɵadvance();
        i0.ɵɵstyleProp("height", (ctx.state.scrollContHeight || 0) - (ctx.state.headerHeight || 0), "px")("width", ctx.state.hasScrollX ? ctx._gridWidth : undefined, "px");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._showTimeIndicator);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._showCursorTime);
        i0.ɵɵadvance();
        i0.ɵɵstyleProp("width", ctx._placeholderSizeX, "px");
        i0.ɵɵadvance();
        i0.ɵɵclassMap(ctx.state.hasScrollX ? "mbsc-flex-none" : "mbsc-flex-1-1");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._isDailyResolution);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx._isDailyResolution);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._hasRows && !!ctx.sidebarTemplate);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx._hasRows);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._hasRows);
        i0.ɵɵadvance(2);
        i0.ɵɵclassMap("mbsc-timeline-row mbsc-timeline-empty-row" + ctx._theme);
        i0.ɵɵadvance();
        i0.ɵɵclassMap("mbsc-timeline-row mbsc-timeline-parent mbsc-timeline-empty-parent" + ctx._theme);
        i0.ɵɵadvance();
        i0.ɵɵclassMap("mbsc-timeline-row-gutter" + ctx._theme);
        i0.ɵɵadvance();
        i0.ɵɵclassMap("mbsc-timeline-grid mbsc-flex-1-0" + (ctx._hasHierarchy || ctx.state.hasScrollY ? "" : " mbsc-flex-col"));
        i0.ɵɵstyleProp("width", ctx.state.hasScrollX ? ctx._gridWidth : undefined, "px")("height", ctx.state.hasScrollY ? ctx._gridHeight : undefined, "px");
        i0.ɵɵadvance(2);
        i0.ɵɵstyleProp("height", ctx._placeholderSizeY, "px");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx._rowBatch)("ngForTrackBy", ctx._getRowKey);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._connections);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._hasRows && !!ctx.sidebarTemplate);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._hasRows && !!ctx.sidebarTemplate);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.hourFooterTemplate || ctx.dayFooterTemplate || ctx.weekFooterTemplate || ctx.monthFooterTemplate || ctx.quarterFooterTemplate || ctx.yearFooterTemplate);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.state.dragData && !ctx.state.isTouchDrag);
      }
    },
    dependencies: [MbscIcon, MbscScheduleEvent, MbscTimeIndicator, NgIf, NgTemplateOutlet, NgForOf, NgStyle, NgSwitch, NgSwitchCase],
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscTimeline;
}(TimelineBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscEventListService = /*#__PURE__*/function () {
  function MbscEventListService() {}
  MbscEventListService.ɵfac = function MbscEventListService_Factory(t) {
    return new (t || MbscEventListService)();
  };
  MbscEventListService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MbscEventListService,
    factory: MbscEventListService.ɵfac
  });
  return MbscEventListService;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscEventListDayDirective = /*#__PURE__*/function () {
  function MbscEventListDayDirective(el, els) {
    this.el = el;
    this.els = els;
  }
  MbscEventListDayDirective.prototype.ngAfterViewChecked = function () {
    if (this.els && this.els.days && !this.els.days[this.timestamp]) {
      this.els.days[this.timestamp] = this.el.nativeElement;
    }
  };
  MbscEventListDayDirective.ɵfac = function MbscEventListDayDirective_Factory(t) {
    return new (t || MbscEventListDayDirective)(i0.ɵɵdirectiveInject(ElementRef), i0.ɵɵdirectiveInject(MbscEventListService, 8));
  };
  MbscEventListDayDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: MbscEventListDayDirective,
    selectors: [["", "mbsc-event-list-day", ""]],
    inputs: {
      timestamp: "timestamp"
    }
  });
  return MbscEventListDayDirective;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscEventListItem = /*#__PURE__*/function (_super) {
  __extends(MbscEventListItem, _super);
  function MbscEventListItem() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MbscEventListItem.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscEventListItem_BaseFactory;
    return function MbscEventListItem_Factory(t) {
      return (ɵMbscEventListItem_BaseFactory || (ɵMbscEventListItem_BaseFactory = i0.ɵɵgetInheritedFactory(MbscEventListItem)))(t || MbscEventListItem);
    };
  })();
  MbscEventListItem.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscEventListItem,
    selectors: [["mbsc-event-list-item"]],
    hostAttrs: ["tabindex", "0"],
    hostVars: 7,
    hostBindings: function MbscEventListItem_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("data-id", ctx.eventData.original.id);
        i0.ɵɵclassMap((ctx.showColor ? "" : "mbsc-colored-event ") + ctx._cssClass);
        i0.ɵɵstyleProp("background", ctx.showColor ? "" : ctx.eventData.style.background)("color", ctx.showColor ? "" : ctx.eventData.style.color);
      }
    },
    inputs: {
      eventData: "eventData",
      hasDate: "hasDate",
      selected: "selected",
      showColor: "showColor",
      template: "template",
      eventContentTemplate: "eventContentTemplate"
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    decls: 6,
    vars: 6,
    consts: [["def", ""], ["defaultEventContent", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "class", "ngStyle", 4, "ngIf"], [3, "class", 4, "ngIf"], [3, "ngStyle"], [3, "innerHTML"]],
    template: function MbscEventListItem_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, MbscEventListItem_ng_template_0_Template, 9, 14, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, MbscEventListItem_ng_template_2_Template, 1, 4, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, MbscEventListItem_ng_template_4_Template, 0, 0, "ng-template", 2);
        i0.ɵɵelement(5, "div");
      }
      if (rf & 2) {
        const def_r3 = i0.ɵɵreference(1);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngTemplateOutlet", ctx.template || def_r3)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c14, ctx.eventData));
        i0.ɵɵadvance();
        i0.ɵɵclassMap("mbsc-list-item-background" + ctx._theme);
      }
    },
    dependencies: [NgIf, NgStyle, NgTemplateOutlet],
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscEventListItem;
}(MbscListItem);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscEventcalendar = /*#__PURE__*/function (_super) {
  __extends(MbscEventcalendar, _super);
  function MbscEventcalendar() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._hours = ARRAY24;
    _this.selectedDateChange = new EventEmitter();
    _this.selectedEventsChange = new EventEmitter();
    _this.onCellClick = new EventEmitter();
    _this.onCellDoubleClick = new EventEmitter();
    _this.onCellRightClick = new EventEmitter();
    _this.onCellHoverIn = new EventEmitter();
    _this.onCellHoverOut = new EventEmitter();
    _this.onEventClick = new EventEmitter();
    _this.onEventDoubleClick = new EventEmitter();
    _this.onEventRightClick = new EventEmitter();
    _this.onEventHoverIn = new EventEmitter();
    _this.onEventHoverOut = new EventEmitter();
    _this.onEventCreate = new EventEmitter();
    _this.onEventCreated = new EventEmitter();
    _this.onEventDelete = new EventEmitter();
    _this.onEventDeleted = new EventEmitter();
    _this.onEventDragEnd = new EventEmitter();
    _this.onEventDragStart = new EventEmitter();
    _this.onEventUpdate = new EventEmitter();
    _this.onEventUpdated = new EventEmitter();
    _this.onEventCreateFailed = new EventEmitter();
    _this.onEventUpdateFailed = new EventEmitter();
    _this.onEventDragEnter = new EventEmitter();
    _this.onEventDragLeave = new EventEmitter();
    _this.onLabelClick = new EventEmitter();
    _this.onSelectedEventsChange = new EventEmitter();
    _this.onPageChange = new EventEmitter();
    _this.onPageLoaded = new EventEmitter();
    _this.onPageLoading = new EventEmitter();
    _this.onResourceCollapse = new EventEmitter();
    _this.onResourceExpand = new EventEmitter();
    _this.onSelectedDateChange = new EventEmitter();
    return _this;
  }
  MbscEventcalendar.prototype._getDayKey = function (index, data) {
    return data.timestamp;
  };
  MbscEventcalendar.prototype._getEventArgs = function (eventList, $event, event) {
    return {
      date: eventList.timestamp,
      domEvent: $event,
      event: event.original,
      source: "agenda"
    };
  };
  MbscEventcalendar.prototype._getEventKey = function (index, data) {
    return data.uid;
  };
  MbscEventcalendar.prototype._getPopoverEventArgs = function (state, $event, event) {
    return {
      date: state.popoverDate,
      domEvent: $event,
      event: event.original,
      source: "popover"
    };
  };
  MbscEventcalendar.prototype._ctor = function () {
    this._els = this._injector.get(MbscEventListService);
    this._instanceService = this._injector.get(MbscInstanceService);
  };
  MbscEventcalendar.prototype._mounted = function () {
    this._instanceService.instance = this;
    _super.prototype._mounted.call(this);
  };
  MbscEventcalendar.prototype._render = function (s, state) {
    if (!this._listDays) {
      this._listDays = {};
      this._els.days = this._listDays;
    }
    _super.prototype._render.call(this, s, state);
  };
  MbscEventcalendar.prototype._updated = function () {
    this._list = this.vList && this.vList.nativeElement;
    _super.prototype._updated.call(this);
  };
  MbscEventcalendar.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscEventcalendar_BaseFactory;
    return function MbscEventcalendar_Factory(t) {
      return (ɵMbscEventcalendar_BaseFactory || (ɵMbscEventcalendar_BaseFactory = i0.ɵɵgetInheritedFactory(MbscEventcalendar)))(t || MbscEventcalendar);
    };
  })();
  MbscEventcalendar.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscEventcalendar,
    selectors: [["mbsc-eventcalendar"]],
    viewQuery: function MbscEventcalendar_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c65, 5, ElementRef);
        i0.ɵɵviewQuery(_c66, 7);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vList = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._calendarView = _t.first);
      }
    },
    inputs: {
      actionableEvents: "actionableEvents",
      agendaEmptyTemplate: "agendaEmptyTemplate",
      agendaTemplate: "agendaTemplate",
      bufferAfterTemplate: "bufferAfterTemplate",
      bufferBeforeTemplate: "bufferBeforeTemplate",
      calendarSystem: "calendarSystem",
      clickToCreate: "clickToCreate",
      colors: "colors",
      connections: "connections",
      data: "data",
      dayTemplate: "dayTemplate",
      dayContentTemplate: "dayContentTemplate",
      dayFooterTemplate: "dayFooterTemplate",
      dataTimezone: "dataTimezone",
      displayTimezone: "displayTimezone",
      dragBetweenResources: "dragBetweenResources",
      dragBetweenSlots: "dragBetweenSlots",
      dragInTime: "dragInTime",
      dragTimeStep: "dragTimeStep",
      dragToCreate: "dragToCreate",
      dragToResize: "dragToResize",
      dragToMove: "dragToMove",
      eventContentTemplate: "eventContentTemplate",
      eventDelete: "eventDelete",
      eventOrder: "eventOrder",
      eventOverlap: "eventOverlap",
      eventTemplate: "eventTemplate",
      exclusiveEndDates: "exclusiveEndDates",
      extendDefaultEvent: "extendDefaultEvent",
      externalDrag: "externalDrag",
      externalDrop: "externalDrop",
      groupBy: "groupBy",
      headerTemplate: "headerTemplate",
      height: "height",
      hourTemplate: "hourTemplate",
      hourFooterTemplate: "hourFooterTemplate",
      immutableData: "immutableData",
      invalid: "invalid",
      invalidateEvent: "invalidateEvent",
      labelContentTemplate: "labelContentTemplate",
      labels: "labels",
      labelTemplate: "labelTemplate",
      marked: "marked",
      max: "max",
      min: "min",
      mousewheel: "mousewheel",
      monthTemplate: "monthTemplate",
      monthFooterTemplate: "monthFooterTemplate",
      refDate: "refDate",
      resources: "resources",
      resourceHeaderTemplate: "resourceHeaderTemplate",
      resourceFooterTemplate: "resourceFooterTemplate",
      resourceTemplate: "resourceTemplate",
      slots: "slots",
      slotTemplate: "slotTemplate",
      scheduleEventContentTemplate: "scheduleEventContentTemplate",
      scheduleEventTemplate: "scheduleEventTemplate",
      selectedDate: "selectedDate",
      selectedEvents: "selectedEvents",
      selectMultipleEvents: "selectMultipleEvents",
      showControls: "showControls",
      showEventBuffer: "showEventBuffer",
      showEventTooltip: "showEventTooltip",
      sidebarFooterTemplate: "sidebarFooterTemplate",
      sidebarHeaderTemplate: "sidebarHeaderTemplate",
      sidebarTemplate: "sidebarTemplate",
      quarterTemplate: "quarterTemplate",
      quarterFooterTemplate: "quarterFooterTemplate",
      quarterText: "quarterText",
      valid: "valid",
      view: "view",
      width: "width",
      weekTemplate: "weekTemplate",
      weekFooterTemplate: "weekFooterTemplate",
      yearTemplate: "yearTemplate",
      yearFooterTemplate: "yearFooterTemplate",
      allDayText: "allDayText",
      amText: "amText",
      dateFormat: "dateFormat",
      dateFormatFull: "dateFormatFull",
      dateFormatLong: "dateFormatLong",
      dayNames: "dayNames",
      dayNamesMin: "dayNamesMin",
      dayNamesShort: "dayNamesShort",
      eventsText: "eventsText",
      eventText: "eventText",
      firstDay: "firstDay",
      monthNames: "monthNames",
      monthNamesShort: "monthNamesShort",
      moreEventsPluralText: "moreEventsPluralText",
      moreEventsText: "moreEventsText",
      newEventText: "newEventText",
      nextPageText: "nextPageText",
      noEventsText: "noEventsText",
      pmText: "pmText",
      prevPageText: "prevPageText",
      timeFormat: "timeFormat",
      timezonePlugin: "timezonePlugin"
    },
    outputs: {
      selectedDateChange: "selectedDateChange",
      selectedEventsChange: "selectedEventsChange",
      onCellClick: "onCellClick",
      onCellDoubleClick: "onCellDoubleClick",
      onCellRightClick: "onCellRightClick",
      onCellHoverIn: "onCellHoverIn",
      onCellHoverOut: "onCellHoverOut",
      onEventClick: "onEventClick",
      onEventDoubleClick: "onEventDoubleClick",
      onEventRightClick: "onEventRightClick",
      onEventHoverIn: "onEventHoverIn",
      onEventHoverOut: "onEventHoverOut",
      onEventCreate: "onEventCreate",
      onEventCreated: "onEventCreated",
      onEventDelete: "onEventDelete",
      onEventDeleted: "onEventDeleted",
      onEventDragEnd: "onEventDragEnd",
      onEventDragStart: "onEventDragStart",
      onEventUpdate: "onEventUpdate",
      onEventUpdated: "onEventUpdated",
      onEventCreateFailed: "onEventCreateFailed",
      onEventUpdateFailed: "onEventUpdateFailed",
      onEventDragEnter: "onEventDragEnter",
      onEventDragLeave: "onEventDragLeave",
      onLabelClick: "onLabelClick",
      onSelectedEventsChange: "onSelectedEventsChange",
      onPageChange: "onPageChange",
      onPageLoaded: "onPageLoaded",
      onPageLoading: "onPageLoading",
      onResourceCollapse: "onResourceCollapse",
      onResourceExpand: "onResourceExpand",
      onSelectedDateChange: "onSelectedDateChange"
    },
    features: [i0.ɵɵProvidersFeature([MbscEventListService, MbscInstanceService]), i0.ɵɵInheritDefinitionFeature],
    decls: 10,
    vars: 143,
    consts: [["calendar", ""], ["list", ""], ["def", ""], ["noEventsText", ""], ["selectView", "page", 3, "activeDate", "amText", "calendarScroll", "calendarType", "clickToCreate", "colors", "context", "cssClass", "dataTimezone", "dayTemplate", "dayContentTemplate", "displayTimezone", "downIcon", "dragData", "dragToCreate", "dragToMove", "dragToResize", "endDay", "eventMap", "eventOrder", "eventRange", "eventRangeSize", "exclusiveEndDates", "hasContent", "hasPicker", "headerTemplate", "height", "invalid", "instanceService", "labels", "labelsMap", "labelList", "labelTemplate", "labelContentTemplate", "marked", "marksMap", "max", "min", "mouseSwipe", "mousewheel", "navService", "navView", "nextIconH", "nextIconV", "nextPageText", "noOuterChange", "onActiveChange", "onCellHoverIn", "onCellHoverOut", "onDayClick", "onDayDoubleClick", "onDayRightClick", "onGestureStart", "onLabelClick", "onLabelDoubleClick", "onLabelRightClick", "onLabelHoverIn", "onLabelHoverOut", "onLabelDelete", "onLabelUpdateStart", "onLabelUpdateMove", "onLabelUpdateEnd", "onLabelUpdateModeOn", "onLabelUpdateModeOff", "onPageChange", "onPageLoaded", "onPageLoading", "onResize", "pageLoad", "pmText", "prevIconH", "prevIconV", "prevPageText", "refDate", "resourcesMap", "responsiveStyle", "rtl", "selectedDates", "selectedEventsMap", "showCalendar", "showControls", "showEventTooltip", "showLabelCount", "showOuterDays", "showSchedule", "showToday", "showWeekNumbers", "size", "startDay", "swipe", "theme", "themeVariant", "timeFormat", "timezonePlugin", "update", "upIcon", "valid", "weeks", "width", "getDate", "getDay", "getMaxDayOfMonth", "getMonth", "getWeekNumber", "getYear", "dateFormat", "dayNames", "dayNamesMin", "dayNamesShort", "eventText", "eventsText", "firstDay", "fromText", "monthNames", "monthNamesShort", "moreEventsPluralText", "moreEventsText", "todayText", "toText", "weekText", "yearSuffix"], [3, "class", 4, "ngIf"], [3, "class", "scroll", 4, "ngIf"], [3, "allDayText", "amText", "bufferAfterTemplate", "bufferBeforeTemplate", "checkSize", "clickToCreate", "colorsMap", "currentTimeIndicator", "dataTimezone", "dateFormat", "dateFormatFull", "dateFormatLong", "dayNames", "dayNamesMin", "dayNamesShort", "dayTemplate", "dayContentTemplate", "displayTimezone", "dragBetweenResources", "dragInTime", "dragTimeStep", "dragToCreate", "dragToMove", "dragToResize", "endDay", "endTime", "eventContentTemplate", "eventDragEnd", "eventMap", "eventOrder", "eventOverlap", "eventTemplate", "exclusiveEndDates", "extendDefaultEvent", "externalDrag", "externalDrop", "firstDay", "fromText", "getDay", "getDate", "getMaxDayOfMonth", "getMonth", "getYear", "getWeekNumber", "groupBy", "height", "immutableData", "invalidateEvent", "invalidsMap", "maxDate", "maxEventStack", "minEventWidth", "moreEventsPluralText", "moreEventsText", "navigateToEvent", "minDate", "monthNames", "monthNamesShort", "navService", "newEventText", "pmText", "refDate", "resources", "resourceTemplate", "rtl", "scroll", "selected", "selectedEventsMap", "showAllDay", "showDays", "showEventBuffer", "showEventTooltip", "size", "startDay", "startTime", "timeCellStep", "timeFormat", "timeLabelStep", "timezonePlugin", "timezones", "theme", "themeVariant", "toText", "type", "width", "onCellClick", "onCellDoubleClick", "onCellRightClick", "onEventClick", "onEventDoubleClick", "onEventRightClick", "onEventHoverIn", "onEventHoverOut", "onEventDelete", "onEventDragEnd", "onEventDragStart", "onEventDragEnter", "onEventDragLeave", "onMoreClick", "onPopoverClose", "onWeekDayClick", 4, "ngIf"], [3, "allDayText", "amText", "bufferAfterTemplate", "bufferBeforeTemplate", "checkSize", "clickToCreate", "colorsMap", "connections", "currentTimeIndicator", "dataTimezone", "dateFormat", "dateFormatFull", "dateFormatLong", "dayNames", "dayNamesMin", "dayNamesShort", "dayFooterTemplate", "dayTemplate", "weekTemplate", "weekFooterTemplate", "yearTemplate", "yearFooterTemplate", "hourTemplate", "hourFooterTemplate", "monthTemplate", "monthFooterTemplate", "displayTimezone", "dragBetweenResources", "dragBetweenSlots", "dragInTime", "dragTimeStep", "dragToCreate", "dragToMove", "dragToResize", "downIcon", "endDay", "endTime", "eventList", "eventDragEnd", "eventContentTemplate", "eventMap", "eventOrder", "eventOverlap", "eventTemplate", "exclusiveEndDates", "extendDefaultEvent", "externalDrag", "externalDrop", "firstDay", "fromText", "getDay", "getDate", "getMaxDayOfMonth", "getMonth", "getWeekNumber", "getYear", "groupBy", "height", "immutableData", "invalidateEvent", "invalidsMap", "maxDate", "maxEventStack", "minDate", "moreEventsPluralText", "moreEventsText", "navigateToEvent", "monthNames", "monthNamesShort", "navService", "newEventText", "nextIcon", "nextIconRtl", "pmText", "refDate", "resolution", "resolutionVertical", "resources", "resourceFooterTemplate", "resourceHeaderTemplate", "resourceTemplate", "rtl", "rowHeight", "scroll", "showEventBuffer", "showEventTooltip", "slots", "slotTemplate", "selected", "selectedEventsMap", "sidebarFooterTemplate", "sidebarHeaderTemplate", "sidebarTemplate", "size", "startDay", "startTime", "quarterFooterTemplate", "quarterTemplate", "quarterText", "timeCellStep", "timeFormat", "timeLabelStep", "timezonePlugin", "theme", "themeVariant", "toText", "type", "virtualScroll", "weekNumbers", "weekText", "width", "onActiveChange", "onCellClick", "onCellDoubleClick", "onCellRightClick", "onEventClick", "onEventDoubleClick", "onEventRightClick", "onEventHoverIn", "onEventHoverOut", "onEventDelete", "onEventDragEnd", "onEventDragStart", "onEventDragEnter", "onEventDragLeave", "onMoreClick", "onPopoverClose", "onResourceCollapse", "onResourceExpand", 4, "ngIf"], ["display", "anchored", "maxHeight", "24em", 3, "onClose", "anchor", "closeOnScroll", "contentPadding", "context", "cssClass", "isOpen", "locale", "rtl", "scrollLock", "showOverlay", "theme", "themeVariant"], [1, "mbsc-popover-list", 3, "rtl", "theme", "themeVariant"], ["class", "mbsc-event", 3, "actionable", "cssClass", "eventContentTemplate", "event", "eventData", "hasDate", "rtl", "selected", "showColor", "template", "theme", "themeVariant", "drag", "onHoverIn", "onHoverOut", "click", "dblclick", "contextmenu", "onDragEnd", "onDragModeOff", "onDragModeOn", "onDragMove", "onDragStart", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "mbsc-calendar-dragging", 4, "ngIf"], ["class", "mbsc-schedule-time-col", 4, "ngIf"], ["class", "mbsc-schedule-fake-scroll-y", 4, "ngIf"], [1, "mbsc-schedule-time-col"], [1, "mbsc-schedule-fake-scroll-y"], [3, "scroll"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "rtl", "theme", "themeVariant"], ["mbsc-event-list-day", "", 3, "class", "timestamp", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "ngTemplateOutlet"], ["mbsc-event-list-day", "", 3, "timestamp"], ["class", "mbsc-event-day", 3, "theme", "themeVariant", 4, "ngIf"], ["class", "mbsc-event", 3, "actionable", "cssClass", "eventContentTemplate", "eventData", "rtl", "selected", "showColor", "template", "theme", "themeVariant", "onHoverIn", "onHoverOut", "click", "dblclick", "contextmenu", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "mbsc-event-day", 3, "theme", "themeVariant"], [1, "mbsc-event", 3, "onHoverIn", "onHoverOut", "click", "dblclick", "contextmenu", "actionable", "cssClass", "eventContentTemplate", "eventData", "rtl", "selected", "showColor", "template", "theme", "themeVariant"], [3, "allDayText", "amText", "bufferAfterTemplate", "bufferBeforeTemplate", "checkSize", "clickToCreate", "colorsMap", "currentTimeIndicator", "dataTimezone", "dateFormat", "dateFormatFull", "dateFormatLong", "dayNames", "dayNamesMin", "dayNamesShort", "dayTemplate", "dayContentTemplate", "displayTimezone", "dragBetweenResources", "dragInTime", "dragTimeStep", "dragToCreate", "dragToMove", "dragToResize", "endDay", "endTime", "eventContentTemplate", "eventDragEnd", "eventMap", "eventOrder", "eventOverlap", "eventTemplate", "exclusiveEndDates", "extendDefaultEvent", "externalDrag", "externalDrop", "firstDay", "fromText", "getDay", "getDate", "getMaxDayOfMonth", "getMonth", "getYear", "getWeekNumber", "groupBy", "height", "immutableData", "invalidateEvent", "invalidsMap", "maxDate", "maxEventStack", "minEventWidth", "moreEventsPluralText", "moreEventsText", "navigateToEvent", "minDate", "monthNames", "monthNamesShort", "navService", "newEventText", "pmText", "refDate", "resources", "resourceTemplate", "rtl", "scroll", "selected", "selectedEventsMap", "showAllDay", "showDays", "showEventBuffer", "showEventTooltip", "size", "startDay", "startTime", "timeCellStep", "timeFormat", "timeLabelStep", "timezonePlugin", "timezones", "theme", "themeVariant", "toText", "type", "width", "onCellClick", "onCellDoubleClick", "onCellRightClick", "onEventClick", "onEventDoubleClick", "onEventRightClick", "onEventHoverIn", "onEventHoverOut", "onEventDelete", "onEventDragEnd", "onEventDragStart", "onEventDragEnter", "onEventDragLeave", "onMoreClick", "onPopoverClose", "onWeekDayClick"], [3, "allDayText", "amText", "bufferAfterTemplate", "bufferBeforeTemplate", "checkSize", "clickToCreate", "colorsMap", "connections", "currentTimeIndicator", "dataTimezone", "dateFormat", "dateFormatFull", "dateFormatLong", "dayNames", "dayNamesMin", "dayNamesShort", "dayFooterTemplate", "dayTemplate", "weekTemplate", "weekFooterTemplate", "yearTemplate", "yearFooterTemplate", "hourTemplate", "hourFooterTemplate", "monthTemplate", "monthFooterTemplate", "displayTimezone", "dragBetweenResources", "dragBetweenSlots", "dragInTime", "dragTimeStep", "dragToCreate", "dragToMove", "dragToResize", "downIcon", "endDay", "endTime", "eventList", "eventDragEnd", "eventContentTemplate", "eventMap", "eventOrder", "eventOverlap", "eventTemplate", "exclusiveEndDates", "extendDefaultEvent", "externalDrag", "externalDrop", "firstDay", "fromText", "getDay", "getDate", "getMaxDayOfMonth", "getMonth", "getWeekNumber", "getYear", "groupBy", "height", "immutableData", "invalidateEvent", "invalidsMap", "maxDate", "maxEventStack", "minDate", "moreEventsPluralText", "moreEventsText", "navigateToEvent", "monthNames", "monthNamesShort", "navService", "newEventText", "nextIcon", "nextIconRtl", "pmText", "refDate", "resolution", "resolutionVertical", "resources", "resourceFooterTemplate", "resourceHeaderTemplate", "resourceTemplate", "rtl", "rowHeight", "scroll", "showEventBuffer", "showEventTooltip", "slots", "slotTemplate", "selected", "selectedEventsMap", "sidebarFooterTemplate", "sidebarHeaderTemplate", "sidebarTemplate", "size", "startDay", "startTime", "quarterFooterTemplate", "quarterTemplate", "quarterText", "timeCellStep", "timeFormat", "timeLabelStep", "timezonePlugin", "theme", "themeVariant", "toText", "type", "virtualScroll", "weekNumbers", "weekText", "width", "onActiveChange", "onCellClick", "onCellDoubleClick", "onCellRightClick", "onEventClick", "onEventDoubleClick", "onEventRightClick", "onEventHoverIn", "onEventHoverOut", "onEventDelete", "onEventDragEnd", "onEventDragStart", "onEventDragEnter", "onEventDragLeave", "onMoreClick", "onPopoverClose", "onResourceCollapse", "onResourceExpand"], [1, "mbsc-event", 3, "onHoverIn", "onHoverOut", "click", "dblclick", "contextmenu", "onDragEnd", "onDragModeOff", "onDragModeOn", "onDragMove", "onDragStart", "actionable", "cssClass", "eventContentTemplate", "event", "eventData", "hasDate", "rtl", "selected", "showColor", "template", "theme", "themeVariant", "drag"], [1, "mbsc-calendar-dragging"]],
    template: function MbscEventcalendar_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "mbsc-calendar-view", 4, 0);
        i0.ɵɵtemplate(2, MbscEventcalendar_div_2_Template, 5, 7, "div", 5)(3, MbscEventcalendar_div_3_Template, 5, 6, "div", 6)(4, MbscEventcalendar_mbsc_scheduler_4_Template, 1, 101, "mbsc-scheduler", 7)(5, MbscEventcalendar_mbsc_timeline_5_Template, 1, 129, "mbsc-timeline", 8);
        i0.ɵɵelementStart(6, "mbsc-popup", 9);
        i0.ɵɵlistener("onClose", function MbscEventcalendar_Template_mbsc_popup_onClose_6_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onPopoverClose($event));
        });
        i0.ɵɵelementStart(7, "mbsc-list", 10);
        i0.ɵɵtemplate(8, MbscEventcalendar_mbsc_event_list_item_8_Template, 1, 13, "mbsc-event-list-item", 11);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(9, MbscEventcalendar_div_9_Template, 1, 0, "div", 12);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵproperty("activeDate", ctx._active)("amText", ctx.s.amText)("calendarScroll", ctx._calendarScroll)("calendarType", ctx._calendarType)("clickToCreate", ctx.s.clickToCreate)("colors", ctx.s.colors)("context", ctx.s.context)("cssClass", ctx._cssClass)("dataTimezone", ctx.s.dataTimezone)("dayTemplate", ctx.dayTemplate)("dayContentTemplate", ctx.dayContentTemplate)("displayTimezone", ctx.s.displayTimezone)("downIcon", ctx.s.downIcon)("dragData", ctx.state.labelDragData)("dragToCreate", ctx.s.dragToCreate)("dragToMove", ctx.s.dragToMove || ctx.s.externalDrag)("dragToResize", ctx.s.dragToResize)("endDay", ctx._rangeEndDay)("eventMap", ctx._eventMap)("eventOrder", ctx.s.eventOrder)("eventRange", ctx._rangeType)("eventRangeSize", ctx._showSchedule ? ctx._scheduleSize : ctx._showTimeline ? ctx._timelineSize : ctx._eventListSize)("exclusiveEndDates", ctx.s.exclusiveEndDates)("hasContent", ctx._showEventList || ctx._showSchedule || ctx._showTimeline)("hasPicker", true)("headerTemplate", ctx.headerTemplate)("height", ctx.s.height)("invalid", ctx.s.invalid)("instanceService", ctx._instanceService)("labels", ctx.s.labels)("labelsMap", ctx._labelsMap)("labelList", ctx._calendarLabelList)("labelTemplate", ctx.labelTemplate)("labelContentTemplate", ctx.labelContentTemplate)("marked", ctx.s.marked)("marksMap", ctx._marksMap)("max", ctx.s.max)("min", ctx.s.min)("mouseSwipe", !ctx.s.dragToCreate && ctx.s.clickToCreate !== "single" || !ctx._showEventLabels && !ctx._showEventCount)("mousewheel", ctx.s.mousewheel)("navService", ctx._navService)("navView", ctx._navView)("nextIconH", ctx.s.nextIconH)("nextIconV", ctx.s.nextIconV)("nextPageText", ctx.s.nextPageText)("noOuterChange", !ctx._showEventList)("onActiveChange", ctx._onActiveChange)("onCellHoverIn", ctx._onCellHoverIn)("onCellHoverOut", ctx._onCellHoverOut)("onDayClick", ctx._onDayClick)("onDayDoubleClick", ctx._onDayDoubleClick)("onDayRightClick", ctx._onDayRightClick)("onGestureStart", ctx._onGestureStart)("onLabelClick", ctx._onLabelClick)("onLabelDoubleClick", ctx._onLabelDoubleClick)("onLabelRightClick", ctx._onLabelRightClick)("onLabelHoverIn", ctx._onLabelHoverIn)("onLabelHoverOut", ctx._onLabelHoverOut)("onLabelDelete", ctx._onEventDelete)("onLabelUpdateStart", ctx._onLabelUpdateStart)("onLabelUpdateMove", ctx._onLabelUpdateMove)("onLabelUpdateEnd", ctx._onLabelUpdateEnd)("onLabelUpdateModeOn", ctx._onLabelUpdateModeOn)("onLabelUpdateModeOff", ctx._onLabelUpdateModeOff)("onPageChange", ctx._onPageChange)("onPageLoaded", ctx._onPageLoaded)("onPageLoading", ctx._onPageLoading)("onResize", ctx._onResize)("pageLoad", ctx._pageLoad)("pmText", ctx.s.pmText)("prevIconH", ctx.s.prevIconH)("prevIconV", ctx.s.prevIconV)("prevPageText", ctx.s.prevPageText)("refDate", ctx._refDate)("resourcesMap", ctx._resourcesMap)("responsiveStyle", true)("rtl", ctx.s.rtl)("selectedDates", ctx._selectedDates)("selectedEventsMap", ctx._selectedEventsMap)("showCalendar", ctx._showCalendar)("showControls", ctx.s.showControls)("showEventTooltip", ctx.s.showEventTooltip)("showLabelCount", ctx._showEventCount)("showOuterDays", ctx._showOuterDays)("showSchedule", ctx._showSchedule || ctx._showTimeline)("showToday", ctx.s.showToday)("showWeekNumbers", ctx._showWeekNumbers)("size", ctx._calendarSize)("startDay", ctx._rangeStartDay)("swipe", !ctx.state.isTouchDrag)("theme", ctx.s.theme)("themeVariant", ctx.s.themeVariant)("timeFormat", ctx.s.timeFormat)("timezonePlugin", ctx.s.timezonePlugin)("update", ctx._update)("upIcon", ctx.s.upIcon)("valid", ctx.s.valid)("weeks", ctx._calendarSize)("width", ctx.s.width)("getDate", ctx.s.getDate)("getDay", ctx.s.getDay)("getMaxDayOfMonth", ctx.s.getMaxDayOfMonth)("getMonth", ctx.s.getMonth)("getWeekNumber", ctx.s.getWeekNumber)("getYear", ctx.s.getYear)("dateFormat", ctx.s.dateFormat)("dayNames", ctx.s.dayNames)("dayNamesMin", ctx.s.dayNamesMin)("dayNamesShort", ctx.s.dayNamesShort)("eventText", ctx.s.eventText)("eventsText", ctx.s.eventsText)("firstDay", ctx.s.firstDay)("fromText", ctx.s.fromText)("monthNames", ctx.s.monthNames)("monthNamesShort", ctx.s.monthNamesShort)("moreEventsPluralText", ctx.s.moreEventsPluralText)("moreEventsText", ctx.s.moreEventsText)("todayText", ctx.s.todayText)("toText", ctx.s.toText)("weekText", ctx.s.weekText)("yearSuffix", ctx.s.yearSuffix);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx._showDate);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._showEventList);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._showSchedule);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx._showTimeline);
        i0.ɵɵadvance();
        i0.ɵɵproperty("anchor", ctx._anchor)("closeOnScroll", true)("contentPadding", false)("context", ctx.state.popoverContext || ctx.s.context)("cssClass", "mbsc-calendar-popup " + (ctx.state.popoverHidden ? "mbsc-popover-hidden " : "") + ctx._popoverClass)("isOpen", ctx.state.showPopover)("locale", ctx.s.locale)("rtl", ctx.s.rtl)("scrollLock", false)("showOverlay", false)("theme", ctx.s.theme)("themeVariant", ctx.s.themeVariant);
        i0.ɵɵadvance();
        i0.ɵɵproperty("rtl", ctx.s.rtl)("theme", ctx.s.theme)("themeVariant", ctx.s.themeVariant);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.state.popoverList)("ngForTrackBy", ctx._getEventKey);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.state.labelDragData && ctx.state.labelDragData.draggedEvent && !ctx.state.isTouchDrag);
      }
    },
    dependencies: [MbscCalendarView, MbscList, MbscListHeader, MbscEventListItem, MbscScheduler, MbscTimeline, MbscPopup, NgIf, NgTemplateOutlet, NgForOf, MbscEventListDayDirective],
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscEventcalendar;
}(EventcalendarBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscListModule = /*#__PURE__*/function () {
  function MbscListModule() {}
  MbscListModule.ɵfac = function MbscListModule_Factory(t) {
    return new (t || MbscListModule)();
  };
  MbscListModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MbscListModule
  });
  MbscListModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule]]
  });
  return MbscListModule;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscEventcalendarModule = /*#__PURE__*/function () {
  function MbscEventcalendarModule() {}
  MbscEventcalendarModule.ɵfac = function MbscEventcalendarModule_Factory(t) {
    return new (t || MbscEventcalendarModule)();
  };
  MbscEventcalendarModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MbscEventcalendarModule
  });
  MbscEventcalendarModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule, MbscCalendarHeaderModule, MbscCalendarViewModule, MbscIconModule, MbscListModule, MbscPopupModule], MbscCalendarHeaderModule, MbscDraggableModule, MbscDropcontainerModule]
  });
  return MbscEventcalendarModule;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var CheckboxBase = /*#__PURE__*/function (_super) {
  __extends(CheckboxBase, _super);
  function CheckboxBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._onChange = function (ev) {
      var s = _this.s;
      var checked = ev.target.checked;
      if (s.checked === UNDEFINED) {
        _this.setState({
          checked: checked
        });
      }
      _this._change(checked);
      if (s.onChange) {
        s.onChange(ev);
      }
    };
    _this._setInput = function (input) {
      _this._input = input;
    };
    return _this;
  }
  CheckboxBase.prototype._change = function (checked) {};
  CheckboxBase.prototype._mounted = function () {
    var _this = this;
    this._unlisten = gestureListener(this._input, {
      click: true,
      onBlur: function () {
        _this.setState({
          hasFocus: false
        });
      },
      onFocus: function () {
        _this.setState({
          hasFocus: true
        });
      },
      onPress: function () {
        _this.setState({
          isActive: true
        });
      },
      onRelease: function () {
        _this.setState({
          isActive: false
        });
      }
    });
  };
  CheckboxBase.prototype._render = function (s, state) {
    var disabled = s.disabled === UNDEFINED ? state.disabled : emptyOrTrue(s.disabled);
    var position = s.position === "start" ? s.rtl ? "right" : "left" : s.rtl ? "left" : "right";
    var modelValue = s.modelValue !== UNDEFINED ? s.modelValue : s.checked;
    this._disabled = disabled;
    this._checked = modelValue !== UNDEFINED ? emptyOrTrue(modelValue) : state.checked === UNDEFINED ? emptyOrTrue(s.defaultChecked) : state.checked;
    this._cssClass = "mbsc-checkbox mbsc-form-control-wrapper mbsc-font " + this._className + this._theme + this._rtl + this._hb + " mbsc-checkbox-" + position + (disabled ? " mbsc-disabled" : "");
    this._boxClass = "mbsc-checkbox-box" + this._theme + " mbsc-checkbox-box-" + position + (state.hasFocus && !disabled ? " mbsc-focus" : "") + (state.isActive && !disabled ? " mbsc-active" : "") + (s.color ? " mbsc-checkbox-box-" + s.color : "") + (disabled ? " mbsc-disabled" : "") + (this._checked ? " mbsc-checked" : "");
  };
  CheckboxBase.prototype._destroy = function () {
    if (this._unlisten) {
      this._unlisten();
    }
  };
  CheckboxBase.defaults = {
    position: "start"
  };
  CheckboxBase._name = "Checkbox";
  CheckboxBase.ɵfac = /* @__PURE__ */(() => {
    let ɵCheckboxBase_BaseFactory;
    return function CheckboxBase_Factory(t) {
      return (ɵCheckboxBase_BaseFactory || (ɵCheckboxBase_BaseFactory = i0.ɵɵgetInheritedFactory(CheckboxBase)))(t || CheckboxBase);
    };
  })();
  CheckboxBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: CheckboxBase,
    selectors: [["", "mbsc-cb-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return CheckboxBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscCheckbox = /*#__PURE__*/function (_super) {
  __extends(MbscCheckbox, _super);
  function MbscCheckbox() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Object.defineProperty(MbscCheckbox.prototype, "checked", {
    get: function () {
      return this._check;
    },
    set: function (val) {
      if (this._check !== val) {
        this.props.checked = val;
        this._onFormChange(val);
        this._check = val;
        this.setState({
          checked: val
        });
      }
    },
    enumerable: false,
    configurable: true
  });
  MbscCheckbox.prototype.registerOnChange = function (fn) {
    this._onFormChange = fn;
  };
  MbscCheckbox.prototype.registerOnTouched = function (fn) {
    this._onFormTouch = fn;
  };
  MbscCheckbox.prototype.setDisabledState = function (disabled) {
    this.setState({
      disabled: disabled
    });
  };
  MbscCheckbox.prototype.writeValue = function (val) {
    this.checked = val;
  };
  MbscCheckbox.prototype._change = function (checked) {
    this.checked = checked;
  };
  MbscCheckbox.prototype._mounted = function () {
    this._input = this.vInput.nativeElement;
    _super.prototype._mounted.call(this);
  };
  MbscCheckbox.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscCheckbox_BaseFactory;
    return function MbscCheckbox_Factory(t) {
      return (ɵMbscCheckbox_BaseFactory || (ɵMbscCheckbox_BaseFactory = i0.ɵɵgetInheritedFactory(MbscCheckbox)))(t || MbscCheckbox);
    };
  })();
  MbscCheckbox.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscCheckbox,
    selectors: [["mbsc-checkbox"]],
    viewQuery: function MbscCheckbox_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c3, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vInput = _t.first);
      }
    },
    hostVars: 2,
    hostBindings: function MbscCheckbox_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx._cssClass);
      }
    },
    inputs: {
      checked: "checked",
      color: "color",
      defaultChecked: "defaultChecked",
      description: "description",
      disabled: "disabled",
      inputStyle: "inputStyle",
      label: "label",
      name: "name",
      position: "position"
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 6,
    vars: 7,
    consts: [["input", ""], ["type", "checkbox", 1, "mbsc-form-control-input", "mbsc-reset", 3, "blur", "change", "checked", "disabled", "name"], [3, "class", 4, "ngIf"]],
    template: function MbscCheckbox_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "input", 1, 0);
        i0.ɵɵlistener("blur", function MbscCheckbox_Template_input_blur_0_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onFormTouch($event));
        })("change", function MbscCheckbox_Template_input_change_0_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onChange($event));
        });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(2, "span");
        i0.ɵɵtemplate(3, MbscCheckbox_span_3_Template, 2, 3, "span", 2)(4, MbscCheckbox_span_4_Template, 2, 3, "span", 2);
        i0.ɵɵprojection(5);
      }
      if (rf & 2) {
        i0.ɵɵproperty("checked", ctx._checked)("disabled", ctx._disabled)("name", ctx.name || "");
        i0.ɵɵadvance(2);
        i0.ɵɵclassMap(ctx._boxClass);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.s.label);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.s.description);
      }
    },
    dependencies: [NgIf],
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscCheckbox;
}(CheckboxBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscCheckboxModule = /*#__PURE__*/function () {
  function MbscCheckboxModule() {}
  MbscCheckboxModule.ɵfac = function MbscCheckboxModule_Factory(t) {
    return new (t || MbscCheckboxModule)();
  };
  MbscCheckboxModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MbscCheckboxModule
  });
  MbscCheckboxModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule]]
  });
  return MbscCheckboxModule;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var popupQueue = [];
var notificationQueue = [];
var hasPromise = isBrowser && !!win.Promise;
function getOptions(queue, options, more, destroy, resolve) {
  return __assign({
    closeOnOverlayClick: false,
    context: options.context,
    cssClass: "mbsc-alert",
    display: options.display || "center",
    onClose: function () {
      queue.shift();
    },
    onClosed: function () {
      handleClose(options, destroy, resolve);
    },
    theme: options.theme,
    themeVariant: options.themeVariant
  }, more);
}
function getToastSnackbarOptions(options, destroy, resolve, isToast) {
  return getOptions(notificationQueue, options, {
    animation: options.animation || (isToast ? "pop" : UNDEFINED),
    buttons: [],
    closeOnOverlayClick: false,
    contentPadding: isToast,
    cssClass: "mbsc-" + (isToast ? "toast" : "snackbar") + " mbsc-" + (options.color ? options.color : "color-none") + " " + (options.cssClass || ""),
    display: options.display || "bottom",
    focusOnClose: false,
    focusOnOpen: false,
    focusTrap: false,
    onOpen: function (ev, inst) {
      handleOpen(options, inst);
    },
    scrollLock: false,
    setActive: false,
    showOverlay: false,
    touchUi: true
  }, destroy, resolve);
}
function handleClose(options, destroy, resolve, result) {
  if (resolve) {
    resolve(result);
  }
  if (options.callback) {
    options.callback(result);
  }
  if (options.onClose) {
    options.onClose(result);
  }
  if (popupQueue.length) {
    popupQueue[0].open();
  } else if (notificationQueue.length) {
    notificationQueue[0].open();
  }
  if (destroy) {
    destroy();
  }
}
function handleOpen(options, inst) {
  if (options.duration !== false) {
    setTimeout(function () {
      inst.close();
    }, options.duration || 3e3);
  }
}
function getToastOptions(options, destroy, resolve) {
  return getToastSnackbarOptions(options, destroy, resolve, true);
}
function getSnackbarOptions(options, destroy, resolve) {
  return getToastSnackbarOptions(options, destroy, resolve, false);
}
function getAlertOptions(options, destroy, resolve) {
  return getOptions(popupQueue, options, {
    buttons: ["ok"],
    cssClass: "mbsc-alert " + (options.cssClass || ""),
    okText: options.okText || "OK"
  }, destroy, resolve);
}
function getConfirmOptions(options, destroy, resolve) {
  var result = false;
  return getOptions(popupQueue, options, {
    buttons: ["cancel", "ok"],
    cancelText: options.cancelText || "Cancel",
    cssClass: "mbsc-confirm " + (options.cssClass || ""),
    okText: options.okText || "OK",
    onButtonClick: function (ev) {
      if (ev.button.name === "ok") {
        result = true;
      }
    },
    onClosed: function () {
      handleClose(options, destroy, resolve, result);
    }
  }, destroy, resolve);
}
function getPromptOptions(options, destroy, resolve, getValue) {
  var okClicked;
  return getOptions(popupQueue, options, {
    activeElm: "input",
    buttons: ["cancel", "ok"],
    cancelText: options.cancelText || "Cancel",
    cssClass: "mbsc-prompt " + (options.cssClass || ""),
    okText: options.okText || "OK",
    onButtonClick: function (ev) {
      if (ev.button.name === "ok") {
        okClicked = true;
      }
    },
    onClosed: function () {
      handleClose(options, destroy, resolve, okClicked && getValue ? getValue() : null);
    }
  }, destroy, resolve);
}
function showModal(popup) {
  if (!popupQueue.length) {
    popup.open();
  }
  popupQueue.push(popup);
}
function showNotification(notification) {
  var activeNotification = notificationQueue[0];
  notificationQueue.push(notification);
  if (!popupQueue.length) {
    if (activeNotification) {
      activeNotification.close();
    } else {
      notification.open();
    }
  }
}
function promise(func, options) {
  var p;
  if (hasPromise) {
    p = new Promise(function (resolve) {
      func(options, resolve);
    });
  } else {
    func(options, noop);
  }
  return p;
}
function getAlertElm(options) {
  var elm = doc.createElement("div");
  elm.className = "mbsc-alert-content";
  elm.innerHTML = '<h2 class="mbsc-alert-title">' + options.title + '</h2><p class="mbsc-alert-message">' + options.message + "</p>";
  return elm;
}
var Notifications = /*#__PURE__*/function () {
  function Notifications(_injector, _cfr, _app) {
    var _this = this;
    this._injector = _injector;
    this._cfr = _cfr;
    this._app = _app;
    this._showToast = function (options, resolve) {
      var elm = doc.createElement("div");
      elm.className = "mbsc-toast-background mbsc-toast-message";
      elm.innerText = options.message;
      var instance = _this._createPopup(MbscPopup, options, getToastOptions, resolve, elm);
      showNotification(instance);
    };
    this._showSnackbar = function (options, resolve) {
      var instance = _this._createPopup(MbscSnackbar, options, getSnackbarOptions, resolve);
      instance.button = options.button;
      instance.message = options.message;
      setTimeout(function () {
        showNotification(instance.popup);
      });
    };
    this._showAlert = function (options, resolve) {
      var elm = getAlertElm(options);
      var instance = _this._createPopup(MbscPopup, options, getAlertOptions, resolve, elm);
      showModal(instance);
    };
    this._showConfirm = function (options, resolve) {
      var elm = getAlertElm(options);
      var instance = _this._createPopup(MbscPopup, options, getConfirmOptions, resolve, elm);
      showModal(instance);
    };
    this._showPrompt = function (options, resolve) {
      var instance = _this._createPopup(MbscPrompt, options, getPromptOptions, resolve, UNDEFINED, function () {
        return instance.value;
      });
      instance.inputType = options.inputType;
      instance.label = options.label;
      instance.message = options.message;
      instance.placeholder = options.placeholder;
      instance.title = options.title;
      setTimeout(function () {
        showModal(instance.popup);
      });
    };
    this._cfr = this._injector.get(ComponentFactoryResolver);
  }
  Notifications.prototype.toast = function (options) {
    return promise(this._showToast, options);
  };
  Notifications.prototype.snackbar = function (options) {
    return promise(this._showSnackbar, options);
  };
  Notifications.prototype.alert = function (options) {
    return promise(this._showAlert, options);
  };
  Notifications.prototype.confirm = function (options) {
    return promise(this._showConfirm, options);
  };
  Notifications.prototype.prompt = function (options) {
    return promise(this._showPrompt, options);
  };
  Notifications.prototype._createPopup = function (Comp, options, getPopupOptions, resolve, body, getValue) {
    var componentFactory = this._cfr.resolveComponentFactory(Comp);
    var host = doc.createElement("div");
    var ref = componentFactory.create(this._injector, [[body]], host);
    var instance = ref.instance;
    var destroy = function () {
      ref.destroy();
    };
    instance.props = getPopupOptions(options, destroy, resolve, getValue);
    this._app.attachView(ref.hostView);
    return instance;
  };
  Notifications.ɵfac = function Notifications_Factory(t) {
    return new (t || Notifications)(i0.ɵɵinject(Injector), i0.ɵɵinject(ComponentFactoryResolver), i0.ɵɵinject(ApplicationRef));
  };
  Notifications.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: Notifications,
    factory: Notifications.ɵfac
  });
  return Notifications;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscNotificationsModule = /*#__PURE__*/function () {
  function MbscNotificationsModule() {}
  MbscNotificationsModule.ɵfac = function MbscNotificationsModule_Factory(t) {
    return new (t || MbscNotificationsModule)();
  };
  MbscNotificationsModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MbscNotificationsModule
  });
  MbscNotificationsModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [Notifications],
    imports: [[MbscInputModule, MbscPopupModule]]
  });
  return MbscNotificationsModule;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var PageBase = /*#__PURE__*/function (_super) {
  __extends(PageBase, _super);
  function PageBase() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PageBase.prototype._render = function (s) {
    this._cssClass = "mbsc-page mbsc-font ".concat(this._className).concat(this._theme).concat(this._rtl);
  };
  PageBase.defaults = {};
  PageBase._name = "Page";
  PageBase.ɵfac = /* @__PURE__ */(() => {
    let ɵPageBase_BaseFactory;
    return function PageBase_Factory(t) {
      return (ɵPageBase_BaseFactory || (ɵPageBase_BaseFactory = i0.ɵɵgetInheritedFactory(PageBase)))(t || PageBase);
    };
  })();
  PageBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: PageBase,
    selectors: [["", "mbsc-page-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return PageBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscPage = /*#__PURE__*/function (_super) {
  __extends(MbscPage, _super);
  function MbscPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MbscPage.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscPage_BaseFactory;
    return function MbscPage_Factory(t) {
      return (ɵMbscPage_BaseFactory || (ɵMbscPage_BaseFactory = i0.ɵɵgetInheritedFactory(MbscPage)))(t || MbscPage);
    };
  })();
  MbscPage.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscPage,
    selectors: [["mbsc-page"]],
    hostVars: 2,
    hostBindings: function MbscPage_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx._cssClass);
      }
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function MbscPage_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscPage;
}(PageBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscPageModule = /*#__PURE__*/function () {
  function MbscPageModule() {}
  MbscPageModule.ɵfac = function MbscPageModule_Factory(t) {
    return new (t || MbscPageModule)();
  };
  MbscPageModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MbscPageModule
  });
  MbscPageModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule]]
  });
  return MbscPageModule;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var guid$4 = 1;
var RadioBase = /*#__PURE__*/function (_super) {
  __extends(RadioBase, _super);
  function RadioBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._setInput = function (inp) {
      _this._input = inp;
    };
    _this._onChange = function (ev) {
      var s = _this.s;
      var checked = ev.target.checked;
      _this._change(checked);
      if (_this._onGroupChange) {
        _this._onGroupChange(ev, _this._value);
      }
      _this._toggle(checked);
      if (s.onChange) {
        s.onChange(ev);
      }
    };
    _this._onValueChange = function (value) {
      var s = _this.s;
      var checked = value === _this._value;
      if (s.checked === UNDEFINED) {
        _this.setState({
          checked: checked
        });
      }
      _this._change(checked);
    };
    return _this;
  }
  RadioBase.prototype._change = function (checked) {};
  RadioBase.prototype._groupOptions = function (_a) {
    var color = _a.color,
      disabled = _a.disabled,
      name = _a.name,
      onChange = _a.onChange,
      position = _a.position,
      rtl = _a.rtl,
      value = _a.value;
    var s = this.s;
    var state = this.state;
    var isRtl = rtl === UNDEFINED ? s.rtl : rtl;
    var col = color === UNDEFINED ? s.color : color;
    var p = position === UNDEFINED ? s.position : position;
    var pos = p === "start" ? s.rtl ? "right" : "left" : s.rtl ? "left" : "right";
    var dis = disabled === UNDEFINED ? s.disabled === UNDEFINED ? state.disabled : emptyOrTrue(s.disabled) : emptyOrTrue(disabled);
    var modelValue = s.modelValue !== UNDEFINED ? s.modelValue === s.value : s.checked;
    var checked = modelValue !== UNDEFINED ? emptyOrTrue(modelValue) : state.checked === UNDEFINED ? emptyOrTrue(s.defaultChecked) : state.checked;
    this._id = s.id === UNDEFINED ? this._id || "mbsc-radio-" + guid$4++ : s.id;
    this._value = s.value === UNDEFINED ? this._id : s.value;
    this._onGroupChange = onChange;
    this._name = name === UNDEFINED ? s.name : name;
    this._rtl = isRtl ? " mbsc-rtl" : " mbsc-ltr";
    this._checked = value === UNDEFINED ? checked : value === this._value;
    this._disabled = dis;
    this._cssClass = "mbsc-radio mbsc-form-control-wrapper mbsc-font " + this._className + this._theme + this._rtl + this._hb + " mbsc-radio-" + pos + (dis ? " mbsc-disabled" : "");
    this._boxClass = "mbsc-radio-box" + this._theme + " mbsc-radio-box-" + pos + (state.hasFocus && !dis ? " mbsc-focus" : "") + (state.isActive && !dis ? " mbsc-active" : "") + (col ? " mbsc-radio-box-" + col : "") + (dis ? " mbsc-disabled" : "") + (this._checked ? " mbsc-checked" : "");
  };
  RadioBase.prototype._toggle = function (checked) {
    if (this.s.checked === UNDEFINED) {
      this.setState({
        checked: checked
      });
    }
    if (checked) {
      setRadio(this._name, this._value);
    }
  };
  RadioBase.prototype._mounted = function () {
    var _this = this;
    this._unlisten = gestureListener(this._input, {
      click: true,
      onBlur: function () {
        _this.setState({
          hasFocus: false
        });
      },
      onFocus: function () {
        _this.setState({
          hasFocus: true
        });
      },
      onPress: function () {
        _this.setState({
          isActive: true
        });
      },
      onRelease: function () {
        _this.setState({
          isActive: false
        });
      }
    });
  };
  RadioBase.prototype._updated = function () {
    if (this._name && !this._unsubscribe) {
      this._unsubscribe = subscribeRadio(this._name, this._onValueChange);
    }
  };
  RadioBase.prototype._destroy = function () {
    if (this._unsubscribe) {
      unsubscribeRadio(this._name, this._unsubscribe);
      this._unsubscribe = UNDEFINED;
    }
    if (this._unlisten) {
      this._unlisten();
    }
  };
  RadioBase.defaults = {
    position: "start"
  };
  RadioBase._name = "Radio";
  RadioBase.ɵfac = /* @__PURE__ */(() => {
    let ɵRadioBase_BaseFactory;
    return function RadioBase_Factory(t) {
      return (ɵRadioBase_BaseFactory || (ɵRadioBase_BaseFactory = i0.ɵɵgetInheritedFactory(RadioBase)))(t || RadioBase);
    };
  })();
  RadioBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: RadioBase,
    selectors: [["", "mbsc-radio-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return RadioBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var guid$5 = 1;
var RadioGroupBase = /*#__PURE__*/function (_super) {
  __extends(RadioGroupBase, _super);
  function RadioGroupBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._id = "mbsc-radio-group" + guid$5++;
    _this._onChange = function (ev, val) {
      var s = _this.s;
      _this.value = val;
      _this._change(val);
      if (s.onChange) {
        s.onChange(ev);
      }
    };
    return _this;
  }
  RadioGroupBase.prototype._change = function (value) {};
  RadioGroupBase.prototype._render = function (s) {
    this._name = s.name === UNDEFINED ? this._id : s.name;
    this._groupClass = "mbsc-radio-group" + this._theme + this._rtl;
    this._groupOpt = {
      color: s.color,
      disabled: s.disabled,
      name: this._name,
      onChange: this._onChange,
      position: s.position,
      rtl: s.rtl,
      value: s.modelValue !== UNDEFINED ? s.modelValue : s.value
    };
  };
  RadioGroupBase.defaults = {};
  RadioGroupBase.ɵfac = /* @__PURE__ */(() => {
    let ɵRadioGroupBase_BaseFactory;
    return function RadioGroupBase_Factory(t) {
      return (ɵRadioGroupBase_BaseFactory || (ɵRadioGroupBase_BaseFactory = i0.ɵɵgetInheritedFactory(RadioGroupBase)))(t || RadioGroupBase);
    };
  })();
  RadioGroupBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: RadioGroupBase,
    selectors: [["", "mbsc-rg-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return RadioGroupBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscRadio = /*#__PURE__*/function (_super) {
  __extends(MbscRadio, _super);
  function MbscRadio() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.checkedChange = new EventEmitter();
    return _this;
  }
  Object.defineProperty(MbscRadio.prototype, "checked", {
    get: function () {
      return this._check;
    },
    set: function (val) {
      var rs = this._radioService;
      if (this._check !== val) {
        if (val) {
          if (rs) {
            rs.value = this.value;
          }
          this._onFormChange(this.value);
        }
        this.props.checked = val;
        this._check = val;
        this.setState({
          checked: val
        });
      }
    },
    enumerable: false,
    configurable: true
  });
  MbscRadio.prototype.registerOnChange = function (fn) {
    this._onFormChange = fn;
  };
  MbscRadio.prototype.registerOnTouched = function (fn) {
    this._onFormTouch = fn;
  };
  MbscRadio.prototype.setDisabledState = function (disabled) {
    this.setState({
      disabled: disabled
    });
  };
  MbscRadio.prototype.writeValue = function (val) {
    this.checked = this.value === val;
  };
  MbscRadio.prototype._change = function (checked) {
    this.checked = checked;
  };
  MbscRadio.prototype._ctor = function () {
    this._radioService = this._injector.get(MbscRadioService, null);
  };
  MbscRadio.prototype._mounted = function () {
    this._input = this.vInput.nativeElement;
    _super.prototype._mounted.call(this);
  };
  MbscRadio.prototype._render = function (s, state) {
    this._groupOptions(this._radioService || {});
    _super.prototype._render.call(this, s, state);
  };
  MbscRadio.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscRadio_BaseFactory;
    return function MbscRadio_Factory(t) {
      return (ɵMbscRadio_BaseFactory || (ɵMbscRadio_BaseFactory = i0.ɵɵgetInheritedFactory(MbscRadio)))(t || MbscRadio);
    };
  })();
  MbscRadio.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscRadio,
    selectors: [["mbsc-radio"]],
    viewQuery: function MbscRadio_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c3, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vInput = _t.first);
      }
    },
    hostVars: 2,
    hostBindings: function MbscRadio_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx._cssClass);
      }
    },
    inputs: {
      color: "color",
      checked: "checked",
      description: "description",
      disabled: "disabled",
      id: "id",
      label: "label",
      name: "name",
      position: "position"
    },
    outputs: {
      checkedChange: "checkedChange"
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 6,
    vars: 8,
    consts: [["input", ""], ["type", "radio", 1, "mbsc-form-control-input", "mbsc-reset", 3, "blur", "change", "checked", "disabled", "name", "value"], [3, "class", 4, "ngIf"]],
    template: function MbscRadio_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "input", 1, 0);
        i0.ɵɵlistener("blur", function MbscRadio_Template_input_blur_0_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onFormTouch($event));
        })("change", function MbscRadio_Template_input_change_0_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onChange($event));
        });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(2, "span");
        i0.ɵɵtemplate(3, MbscRadio_span_3_Template, 2, 3, "span", 2)(4, MbscRadio_span_4_Template, 2, 3, "span", 2);
        i0.ɵɵprojection(5);
      }
      if (rf & 2) {
        i0.ɵɵproperty("checked", ctx._checked)("disabled", ctx._disabled)("name", ctx._name)("value", ctx._value);
        i0.ɵɵadvance(2);
        i0.ɵɵclassMap(ctx._boxClass);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.s.label);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.s.description);
      }
    },
    dependencies: [NgIf],
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscRadio;
}(RadioBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscRadioGroup = /*#__PURE__*/function (_super) {
  __extends(MbscRadioGroup, _super);
  function MbscRadioGroup() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  MbscRadioGroup.prototype._onValueChange = function (value) {
    this._radioService.value = value;
    setRadio(this._radioService.name, value);
  };
  MbscRadioGroup.prototype._ctor = function () {
    this._radioService = this._injector.get(MbscRadioService);
  };
  MbscRadioGroup.prototype._render = function (s) {
    _super.prototype._render.call(this, s);
    var rs = this._radioService;
    rs.color = s.color;
    rs.disabled = s.disabled;
    rs.name = this._name;
    rs.value = this.value;
    rs.onChange = this._onChange;
    rs.position = s.position;
  };
  MbscRadioGroup.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscRadioGroup_BaseFactory;
    return function MbscRadioGroup_Factory(t) {
      return (ɵMbscRadioGroup_BaseFactory || (ɵMbscRadioGroup_BaseFactory = i0.ɵɵgetInheritedFactory(MbscRadioGroup)))(t || MbscRadioGroup);
    };
  })();
  MbscRadioGroup.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscRadioGroup,
    selectors: [["mbsc-radio-group"]],
    hostVars: 2,
    hostBindings: function MbscRadioGroup_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx._groupClass);
      }
    },
    inputs: {
      color: "color",
      disabled: "disabled",
      name: "name",
      position: "position"
    },
    features: [i0.ɵɵProvidersFeature([MbscRadioService]), i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function MbscRadioGroup_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2,
    changeDetection: 0
  });
  MbscRadioGroup = __decorate([FormControl], MbscRadioGroup);
  return MbscRadioGroup;
}(RadioGroupBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscRadioModule = /*#__PURE__*/function () {
  function MbscRadioModule() {}
  MbscRadioModule.ɵfac = function MbscRadioModule_Factory(t) {
    return new (t || MbscRadioModule)();
  };
  MbscRadioModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MbscRadioModule
  });
  MbscRadioModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule]]
  });
  return MbscRadioModule;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var StepperBase = /*#__PURE__*/function (_super) {
  __extends(StepperBase, _super);
  function StepperBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._onChange = function (ev) {
      var s = _this.s;
      var val = _this._round(+ev.target.value);
      ev.target.value = val + "";
      if (s.value === UNDEFINED) {
        _this.setState({
          value: val
        });
      }
      _this._change(val);
      if (s.onChange) {
        s.onChange(ev);
      }
    };
    _this._onMinusClick = function () {
      _this._setValue(_this._value - _this._step);
    };
    _this._onPlusClick = function () {
      _this._setValue(_this._value + _this._step);
    };
    _this._setInput = function (input) {
      _this._input = input;
    };
    _this._onLabelClick = function (ev) {
      ev.preventDefault();
    };
    return _this;
  }
  StepperBase.prototype._change = function (val) {};
  StepperBase.prototype._mounted = function () {
    listen(this._input, CHANGE, this._onChange);
  };
  StepperBase.prototype._render = function (s, state) {
    this._max = isEmpty(s.max) ? 100 : +s.max;
    this._min = isEmpty(s.min) ? 0 : +s.min;
    this._step = isEmpty(s.step) ? 1 : +s.step;
    var disabled = s.disabled === UNDEFINED ? state.disabled : emptyOrTrue(s.disabled);
    var defVal = s.defaultValue !== UNDEFINED ? s.defaultValue : this._min || 0;
    var modelValue = s.modelValue !== UNDEFINED ? s.modelValue : s.value;
    var val = modelValue !== UNDEFINED ? modelValue : state.value !== UNDEFINED ? state.value : defVal;
    this._value = this._round(val);
    this._changed = this._value !== +val;
    this._disabled = disabled;
    this._disabledMinus = this._value === this._min || disabled;
    this._disabledPlus = this._value === this._max || disabled;
    this._cssClass = "mbsc-stepper mbsc-form-control-wrapper mbsc-font mbsc-" + (s.color || "color-none") + this._theme + this._rtl + this._hb + " mbsc-stepper-" + s.inputPosition + (disabled ? " mbsc-disabled" : "");
  };
  StepperBase.prototype._updated = function () {
    this._input.value = this._value + "";
    if (this._changed) {
      trigger(this._input, CHANGE);
      this._changed = false;
    }
  };
  StepperBase.prototype._destroy = function () {
    unlisten(this._input, CHANGE, this._onChange);
  };
  StepperBase.prototype._round = function (v) {
    var step = this._step;
    var scale = Math.abs(step) < 1 ? (step + "").split(".")[1].length : 0;
    return +Math.min(this._max, Math.max(Math.round(v / step) * step, this._min)).toFixed(scale);
  };
  StepperBase.prototype._setValue = function (val) {
    var oldValue = +this._input.value;
    var newValue = this._round(val);
    if (oldValue !== newValue) {
      this._input.value = newValue + "";
      trigger(this._input, CHANGE);
    }
  };
  StepperBase.defaults = {
    inputPosition: "center"
  };
  StepperBase._name = "Stepper";
  StepperBase.ɵfac = /* @__PURE__ */(() => {
    let ɵStepperBase_BaseFactory;
    return function StepperBase_Factory(t) {
      return (ɵStepperBase_BaseFactory || (ɵStepperBase_BaseFactory = i0.ɵɵgetInheritedFactory(StepperBase)))(t || StepperBase);
    };
  })();
  StepperBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: StepperBase,
    selectors: [["", "mbsc-stepper", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return StepperBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var guid$6 = 0;
var MbscStepper = /*#__PURE__*/function (_super) {
  __extends(MbscStepper, _super);
  function MbscStepper() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.onChange = new EventEmitter();
    _this._id = "mbsc-stepper-" + guid$6++;
    return _this;
  }
  MbscStepper.prototype._change = function (value) {
    this.value = value;
  };
  MbscStepper.prototype._mounted = function () {
    this._input = this.vInput.nativeElement;
    _super.prototype._mounted.call(this);
  };
  MbscStepper.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscStepper_BaseFactory;
    return function MbscStepper_Factory(t) {
      return (ɵMbscStepper_BaseFactory || (ɵMbscStepper_BaseFactory = i0.ɵɵgetInheritedFactory(MbscStepper)))(t || MbscStepper);
    };
  })();
  MbscStepper.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscStepper,
    selectors: [["mbsc-stepper"]],
    viewQuery: function MbscStepper_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c3, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vInput = _t.first);
      }
    },
    hostVars: 2,
    hostBindings: function MbscStepper_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx._cssClass);
      }
    },
    inputs: {
      color: "color",
      defaultValue: "defaultValue",
      description: "description",
      disabled: "disabled",
      id: "id",
      inputPosition: "inputPosition",
      label: "label",
      min: "min",
      max: "max",
      name: "name",
      readonly: "readonly",
      step: "step"
    },
    outputs: {
      onChange: "onChange"
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    decls: 12,
    vars: 24,
    consts: [["input", ""], [1, "mbsc-stepper-content", 3, "for"], [3, "class", 4, "ngIf"], [1, "mbsc-stepper-minus", "mbsc-stepper-button", 3, "click", "disabled", "theme", "themeVariant"], ["type", "number", 3, "disabled", "id", "max", "min", "readonly", "step"], [1, "mbsc-stepper-plus", "mbsc-stepper-button", 3, "click", "disabled", "theme", "themeVariant"]],
    template: function MbscStepper_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "label", 1);
        i0.ɵɵtemplate(1, MbscStepper_span_1_Template, 2, 3, "span", 2)(2, MbscStepper_span_2_Template, 2, 3, "span", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div")(4, "mbsc-button", 3);
        i0.ɵɵlistener("click", function MbscStepper_Template_mbsc_button_click_4_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onMinusClick());
        });
        i0.ɵɵelementStart(5, "span");
        i0.ɵɵtext(6, "\u2013");
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(7, "input", 4, 0);
        i0.ɵɵelementStart(9, "mbsc-button", 5);
        i0.ɵɵlistener("click", function MbscStepper_Template_mbsc_button_click_9_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx._onPlusClick());
        });
        i0.ɵɵelementStart(10, "span");
        i0.ɵɵtext(11, "+");
        i0.ɵɵelementEnd()()();
      }
      if (rf & 2) {
        i0.ɵɵproperty("for", ctx.id || ctx._id);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.s.label);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.s.description);
        i0.ɵɵadvance();
        i0.ɵɵclassMap("mbsc-stepper-control mbsc-flex" + ctx._theme + ctx._rtl);
        i0.ɵɵadvance();
        i0.ɵɵproperty("disabled", ctx._disabledMinus)("theme", ctx.s.theme)("themeVariant", ctx.s.themeVariant);
        i0.ɵɵadvance();
        i0.ɵɵclassMap("mbsc-stepper-inner" + ctx._theme);
        i0.ɵɵadvance(2);
        i0.ɵɵclassMap("mbsc-stepper-input" + (ctx._disabled ? " mbsc-disabled" : "") + ctx._theme);
        i0.ɵɵproperty("disabled", ctx._disabled)("id", ctx.id || ctx._id)("max", ctx._max)("min", ctx._min)("readonly", ctx.readonly)("step", ctx._step);
        i0.ɵɵattribute("name", ctx.name);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("disabled", ctx._disabledPlus)("theme", ctx.s.theme)("themeVariant", ctx.s.themeVariant);
        i0.ɵɵadvance();
        i0.ɵɵclassMap("mbsc-stepper-inner" + ctx._theme);
      }
    },
    dependencies: [MbscButton, NgIf],
    encapsulation: 2,
    changeDetection: 0
  });
  MbscStepper = __decorate([FormControl], MbscStepper);
  return MbscStepper;
}(StepperBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscStepperModule = /*#__PURE__*/function () {
  function MbscStepperModule() {}
  MbscStepperModule.ɵfac = function MbscStepperModule_Factory(t) {
    return new (t || MbscStepperModule)();
  };
  MbscStepperModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MbscStepperModule
  });
  MbscStepperModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule, MbscButtonModule]]
  });
  return MbscStepperModule;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var CLICK_MOVE_THRESHOLD = 3;
var CLICK_HOLD_THRESHOLD = 300;
var SwitchBase = /*#__PURE__*/function (_super) {
  __extends(SwitchBase, _super);
  function SwitchBase() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._onChange = function (ev) {
      var s = _this.s;
      var checked = ev.target.checked;
      ev.stopPropagation();
      if (s.checked === UNDEFINED) {
        _this.setState({
          checked: checked
        });
      }
      _this._change(checked);
      if (s.onChange) {
        s.onChange(ev);
      }
    };
    _this._setInput = function (input) {
      _this._input = input;
    };
    _this._setHandleCont = function (span) {
      _this._handleCont = span;
    };
    _this._setHandle = function (span) {
      _this._handle = span;
    };
    _this._onLabelClick = function (ev) {
      ev.preventDefault();
    };
    return _this;
  }
  SwitchBase.prototype._change = function (checked) {};
  SwitchBase.prototype._setHandleLeft = function (left) {
    this._handle.style.left = left + "%";
  };
  SwitchBase.prototype._mounted = function () {
    var _this = this;
    var handleContWidth;
    var handleContLeft;
    var gestureStart;
    var isHandle;
    var isNativeScroll;
    listen(this._input, CLICK, this._onChange);
    this._inputUnlisten = gestureListener(this._input, {
      onBlur: function () {
        _this.setState({
          hasFocus: false
        });
      },
      onFocus: function () {
        if (!_this._disabled) {
          _this.setState({
            hasFocus: true
          });
        }
      }
    });
    this._unlisten = gestureListener(this._el, {
      click: false,
      onEnd: function (ev) {
        if (!_this._disabled && !isNativeScroll) {
          if (isHandle) {
            var noMovement = Math.abs(ev.deltaX) < CLICK_MOVE_THRESHOLD && Math.abs(ev.deltaY) < CLICK_MOVE_THRESHOLD;
            var longHold = +new Date() - gestureStart > CLICK_HOLD_THRESHOLD;
            var newChecked = noMovement && !longHold ? !_this._checked : _this._handleLeft >= 50;
            if (newChecked !== _this._checked) {
              _this._input.click();
              _this._change(newChecked);
            }
            isHandle = false;
          }
          _this.setState({
            dragging: false,
            isActive: false
          });
        }
      },
      onMove: function (ev) {
        var domEvent = ev.domEvent;
        var dragging = _this.state.dragging;
        if (!_this._disabled && !isNativeScroll && isHandle && handleContWidth) {
          if (Math.abs(ev.deltaX) > 5) {
            dragging = true;
            _this.setState({
              dragging: true
            });
          }
          if (dragging) {
            if (domEvent.cancelable) {
              domEvent.preventDefault();
            }
            var offset = (ev.startX - handleContLeft) / handleContWidth * 100;
            var cappedOffset = Math.max(Math.min(offset, 100), 0);
            var left = cappedOffset + ev.deltaX / handleContWidth * 100;
            var capped = Math.max(Math.min(left, 100), 0);
            _this._handleLeft = capped;
            _this._setHandleLeft(capped);
          }
        }
        if (!dragging && !isNativeScroll && Math.abs(ev.deltaY) > 7 && domEvent.type === TOUCH_MOVE) {
          isNativeScroll = true;
          _this.setState({
            isActive: false
          });
        }
      },
      onStart: function (ev) {
        if (!_this._disabled) {
          isNativeScroll = false;
          handleContWidth = _this._handleCont.clientWidth;
          handleContLeft = getOffset(_this._handleCont).left;
          gestureStart = +new Date();
          if (ev.domEvent.target === _this._handleCont || _this._handleCont.contains(ev.domEvent.target)) {
            isHandle = true;
          }
          _this.setState({
            isActive: true
          });
        }
      }
    });
    this._setHandleLeft(this._handleLeft);
  };
  SwitchBase.prototype._render = function (s, state) {
    var disabled = s.disabled === UNDEFINED ? state.disabled : emptyOrTrue(s.disabled);
    var position = s.position === "start" ? s.rtl ? "right" : "left" : s.rtl ? "left" : "right";
    var colorClass = s.color !== UNDEFINED ? " mbsc-switch-" + s.color : "";
    var modelValue = s.modelValue !== UNDEFINED ? s.modelValue : s.checked;
    this._disabled = disabled;
    this._checked = modelValue !== UNDEFINED ? emptyOrTrue(modelValue) : state.checked === UNDEFINED ? emptyOrTrue(s.defaultChecked) : state.checked;
    this._cssClass = "mbsc-switch mbsc-form-control-wrapper mbsc-font " + this._className + this._theme + this._rtl + this._hb + " mbsc-switch-" + position + (disabled ? " mbsc-disabled" : "");
    if (!state.dragging) {
      var hl = this._checked ? 100 : 0;
      if (hl !== this._handleLeft && this._handle) {
        this._setHandleLeft(hl);
      }
      this._handleLeft = hl;
    }
    this._handleContClass = "mbsc-switch-track mbsc-switch-track-" + position + this._theme + colorClass + (this._checked ? " mbsc-checked" : "") + (disabled ? " mbsc-disabled" : "") + (state.hasFocus ? " mbsc-focus" : "") + (state.isActive ? " mbsc-active" : "");
    this._handleClass = "mbsc-switch-handle" + this._theme + colorClass + (state.dragging ? "" : " mbsc-switch-handle-animate") + (this._checked ? " mbsc-checked" : "") + (this.state.isActive ? " mbsc-active" : "") + (disabled ? " mbsc-disabled" : "") + (this.state.hasFocus ? " mbsc-focus" : "");
  };
  SwitchBase.prototype._destroy = function () {
    unlisten(this._input, CLICK, this._onChange);
    if (this._unlisten) {
      this._unlisten();
    }
    if (this._inputUnlisten) {
      this._inputUnlisten();
    }
  };
  SwitchBase.defaults = {
    position: "end"
  };
  SwitchBase._name = "Switch";
  SwitchBase.ɵfac = /* @__PURE__ */(() => {
    let ɵSwitchBase_BaseFactory;
    return function SwitchBase_Factory(t) {
      return (ɵSwitchBase_BaseFactory || (ɵSwitchBase_BaseFactory = i0.ɵɵgetInheritedFactory(SwitchBase)))(t || SwitchBase);
    };
  })();
  SwitchBase.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: SwitchBase,
    selectors: [["", "mbsc-sw-b", ""]],
    features: [i0.ɵɵInheritDefinitionFeature]
  });
  return SwitchBase;
}(BaseComponent);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var guid$7 = 0;
var MbscSwitch = /*#__PURE__*/function (_super) {
  __extends(MbscSwitch, _super);
  function MbscSwitch() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this._id = "mbsc-switch-" + guid$7++;
    return _this;
  }
  Object.defineProperty(MbscSwitch.prototype, "checked", {
    get: function () {
      return this._check;
    },
    set: function (val) {
      if (this._check !== val) {
        this.props.checked = val;
        this._onFormChange(val);
        this._check = val;
        this.setState({
          checked: val
        });
      }
    },
    enumerable: false,
    configurable: true
  });
  MbscSwitch.prototype.registerOnChange = function (fn) {
    this._onFormChange = fn;
  };
  MbscSwitch.prototype.registerOnTouched = function (fn) {
    this._onFormTouch = fn;
  };
  MbscSwitch.prototype.setDisabledState = function (disabled) {
    this.setState({
      disabled: disabled
    });
  };
  MbscSwitch.prototype.writeValue = function (val) {
    this.checked = val;
  };
  MbscSwitch.prototype._change = function (checked) {
    this.checked = checked;
  };
  MbscSwitch.prototype._mounted = function () {
    this._input = this.vInput.nativeElement;
    this._handle = this.vHandle.nativeElement;
    this._handleCont = this.vHandleCont.nativeElement;
    _super.prototype._mounted.call(this);
  };
  MbscSwitch.ɵfac = /* @__PURE__ */(() => {
    let ɵMbscSwitch_BaseFactory;
    return function MbscSwitch_Factory(t) {
      return (ɵMbscSwitch_BaseFactory || (ɵMbscSwitch_BaseFactory = i0.ɵɵgetInheritedFactory(MbscSwitch)))(t || MbscSwitch);
    };
  })();
  MbscSwitch.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscSwitch,
    selectors: [["mbsc-switch"]],
    viewQuery: function MbscSwitch_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c3, 5);
        i0.ɵɵviewQuery(_c67, 5);
        i0.ɵɵviewQuery(_c68, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vInput = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vHandle = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.vHandleCont = _t.first);
      }
    },
    hostVars: 2,
    hostBindings: function MbscSwitch_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassMap(ctx._cssClass);
      }
    },
    inputs: {
      checked: "checked",
      color: "color",
      description: "description",
      disabled: "disabled",
      id: "id",
      label: "label",
      position: "position",
      readonly: "readonly"
    },
    features: [i0.ɵɵInheritDefinitionFeature],
    ngContentSelectors: _c0,
    decls: 8,
    vars: 9,
    consts: [["input", ""], ["handleCont", ""], ["handle", ""], [3, "for", "class", 4, "ngIf"], ["type", "checkbox", 1, "mbsc-form-control-input", "mbsc-reset", 3, "id", "checked", "disabled", "readonly"], [3, "for"], [3, "class", 4, "ngIf"]],
    template: function MbscSwitch_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵtemplate(0, MbscSwitch_label_0_Template, 3, 5, "label", 3);
        i0.ɵɵelement(1, "input", 4, 0);
        i0.ɵɵelementStart(3, "span", null, 1);
        i0.ɵɵelement(5, "span", null, 2);
        i0.ɵɵelementEnd();
        i0.ɵɵprojection(7);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.s.label);
        i0.ɵɵadvance();
        i0.ɵɵproperty("id", ctx.id || ctx._id)("checked", ctx._checked)("disabled", ctx._disabled)("readonly", ctx.readonly);
        i0.ɵɵadvance(2);
        i0.ɵɵclassMap(ctx._handleContClass);
        i0.ɵɵadvance(2);
        i0.ɵɵclassMap(ctx._handleClass);
      }
    },
    dependencies: [NgIf],
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscSwitch;
}(SwitchBase);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscSwitchModule = /*#__PURE__*/function () {
  function MbscSwitchModule() {}
  MbscSwitchModule.ɵfac = function MbscSwitchModule_Factory(t) {
    return new (t || MbscSwitchModule)();
  };
  MbscSwitchModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MbscSwitchModule
  });
  MbscSwitchModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule]]
  });
  return MbscSwitchModule;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscFormsModule = /*#__PURE__*/function () {
  function MbscFormsModule() {}
  MbscFormsModule.ɵfac = function MbscFormsModule_Factory(t) {
    return new (t || MbscFormsModule)();
  };
  MbscFormsModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MbscFormsModule
  });
  MbscFormsModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule, MbscButtonModule, MbscCheckboxModule, MbscInputModule, MbscPageModule, MbscRadioModule, MbscSegmentedModule, MbscStepperModule, MbscSwitchModule], MbscButtonModule, MbscCheckboxModule, MbscInputModule, MbscPageModule, MbscRadioModule, MbscSegmentedModule, MbscStepperModule, MbscSwitchModule, MbscNotificationsModule]
  });
  return MbscFormsModule;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscOptionsProviderComponent = /*#__PURE__*/function () {
  function MbscOptionsProviderComponent(_opt) {
    this._opt = _opt;
  }
  MbscOptionsProviderComponent.prototype.ngOnChanges = function (changes) {
    var key = "options";
    var change = changes[key];
    if (change) {
      this._opt.setOptions(change.currentValue);
    }
  };
  MbscOptionsProviderComponent.ɵfac = function MbscOptionsProviderComponent_Factory(t) {
    return new (t || MbscOptionsProviderComponent)(i0.ɵɵdirectiveInject(MbscOptionsService));
  };
  MbscOptionsProviderComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MbscOptionsProviderComponent,
    selectors: [["mbsc-options-provider"]],
    inputs: {
      options: "options"
    },
    features: [i0.ɵɵProvidersFeature([{
      provide: MbscOptionsService,
      useClass: MbscOptionsService
    }]), i0.ɵɵNgOnChangesFeature],
    ngContentSelectors: _c0,
    decls: 1,
    vars: 0,
    template: function MbscOptionsProviderComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
      }
    },
    encapsulation: 2,
    changeDetection: 0
  });
  return MbscOptionsProviderComponent;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscOptionsModule = /*#__PURE__*/function () {
  function MbscOptionsModule() {}
  MbscOptionsModule.ɵfac = function MbscOptionsModule_Factory(t) {
    return new (t || MbscOptionsModule)();
  };
  MbscOptionsModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MbscOptionsModule
  });
  MbscOptionsModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  return MbscOptionsModule;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscBaseModule = /*#__PURE__*/function () {
  function MbscBaseModule() {}
  MbscBaseModule.ɵfac = function MbscBaseModule_Factory(t) {
    return new (t || MbscBaseModule)();
  };
  MbscBaseModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MbscBaseModule
  });
  MbscBaseModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  return MbscBaseModule;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var MbscModule = /*#__PURE__*/function () {
  function MbscModule() {}
  MbscModule.ɵfac = function MbscModule_Factory(t) {
    return new (t || MbscModule)();
  };
  MbscModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: MbscModule
  });
  MbscModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[MbscCalendarModule, MbscBaseModule, MbscDatepickerModule, MbscDatetimeModule, MbscEventcalendarModule, MbscFormsModule, MbscIconModule, MbscOptionsModule, MbscPopupModule, MbscScrollerModule, MbscSelectModule, MbscTimegridModule], MbscCalendarModule, MbscDatepickerModule, MbscDatetimeModule, MbscEventcalendarModule, MbscFormsModule, MbscIconModule, MbscOptionsModule, MbscPopupModule, MbscScrollerModule, MbscSelectModule, MbscTimegridModule]
  });
  return MbscModule;
}();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
export { DraggableDirective, MBSC_OPTIONS, MbscButton, MbscButtonModule, MbscCalendar, MbscCalendarHeaderModule, MbscCalendarModule, MbscCalendarNav, MbscCalendarNext, MbscCalendarPrev, MbscCalendarToday, MbscCheckbox, MbscCheckboxModule, MbscCustomEndIcon, MbscCustomIcon, MbscCustomStartIcon, MbscDate, MbscDatepicker, MbscDatepickerDirective, MbscDatepickerModule, MbscDatetime, MbscDatetimeModule, MbscDraggableModule, MbscDropcontainer, MbscDropcontainerModule, MbscDropdown, MbscEventListDayDirective, MbscEventListItem, MbscEventcalendar, MbscEventcalendarModule, MbscFormsModule, MbscIcon, MbscIconModule, MbscInput, MbscInputModule, MbscModule, MbscNotificationsModule, MbscOptionsModule, MbscOptionsProviderComponent, MbscOptionsService, MbscPage, MbscPageModule, MbscPopup, MbscPopupModule, MbscPrompt, MbscRadio, MbscRadioGroup, MbscRadioModule, MbscScroller, MbscScrollerModule, MbscSegmented, MbscSegmentedGroup, MbscSegmentedModule, MbscSelect, MbscSelectDirective, MbscSelectModule, MbscSelectOptionComponent, MbscSelectOptionDirective, MbscSnackbar, MbscStepper, MbscStepperModule, MbscSwitch, MbscSwitchModule, MbscTextarea, MbscTime, MbscTimegrid, MbscTimegridModule, Notifications, autoDetect, createCustomTheme, formatDatePublic as formatDate, getAutoTheme, getJson, globalChanges, hijriCalendar, jalaliCalendar, locale, ar as localeAr, bg as localeBg, ca as localeCa, cs as localeCs, da as localeDa, de as localeDe, el as localeEl, localeEn, enGB as localeEnGB, es as localeEs, fa as localeFa, fi as localeFi, fr as localeFr, he as localeHe, hi as localeHi, hr as localeHr, hu as localeHu, it as localeIt, ja as localeJa, ko as localeKo, lt as localeLt, nl as localeNl, no as localeNo, pl as localePl, localePtBR, ptPT as localePtPT, ro as localeRo, ru as localeRu, localeRuUA, sk as localeSk, sr as localeSr, sv as localeSv, th as localeTh, tr as localeTr, ua as localeUa, vi as localeVi, zh as localeZh, luxonTimezone, momentTimezone, options, parseDate, platform$1 as platform, setOptions, themes, updateRecurringEvent, util };